/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/zebulon-grid/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 129);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(135);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export aggregations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_generic__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_accessors__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextualMenu__ = __webpack_require__(54);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__ContextualMenu__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__ContextualMenu__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Input__ = __webpack_require__(107);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Filter__ = __webpack_require__(299);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Filter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ScrollableArea__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ScrollableGrid__ = __webpack_require__(108);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__ScrollableGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConfirmationModal__ = __webpack_require__(301);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__ConfirmationModal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Layout__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__constants__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__utils_generic__; });
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__icons__; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__utils_accessors__["a"]; });













// export utils;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return MEASURE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return TOTAL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return KEY_SEPARATOR; });
/* unused harmony export AXIS_SEPARATOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return ROOT_ID; });
/* unused harmony export EMPTY_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return ScrollbarSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HeaderType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AxisType; });
/* harmony export (immutable) */ __webpack_exports__["F"] = toAxis;
/* harmony export (immutable) */ __webpack_exports__["G"] = toAxisType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SET_DIMENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SET_MEASURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SET_CONFIG_PROPERTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TOGGLE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MOVE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return MOVE_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SET_AXIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FETCH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PUSH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LOADING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_SORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DELETE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_CELL_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return SET_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EXPAND_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EXPAND_COLLAPSE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SET_COLLAPSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SELECT_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return SCROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TOGGLE_SUBTOTAL; });
var MEASURE_ID="__measures__";var TOTAL_ID="__total__";var KEY_SEPARATOR="-/-";var AXIS_SEPARATOR="-//-";var ROOT_ID="__ROOT_ID__";var EMPTY_ID="__EMPTY_ID__";var ScrollbarSize=12;// Headers
var HeaderType={MEASURE:1,// measure header
DIMENSION:2,// dimension value (leaf)
DIMENSION_HEADER:3,// dimension header
GRAND_TOTAL:4,SUB_TOTAL:5};// Axis
var AxisType={COLUMNS:1,ROWS:2,MEASURE:3,DIMENSION:4,DATACELL:5};function toAxis(axisType){switch(axisType){case AxisType.COLUMNS:return"columns";case AxisType.ROWS:return"rows";case AxisType.MEASURES:return"measures";case AxisType.DIMENSION:return"dimensions";default:return"__AXIS_TYPE_UNKNOWN__";}}function toAxisType(axis){return AxisType[axis.toUpperCase()];}// ACTIONS
var SET_DIMENSIONS="PIVOTGRID_SET_DIMENSIONS";var SET_MEASURES="PIVOTGRID_SET_MEASURES";var SET_CONFIG_PROPERTY="PIVOTGRID_SET_CONFIG_PROPERTY";var TOGGLE_MEASURE="PIVOTGRID_TOGGLE_MEASURE";var MOVE_MEASURE="PIVOTGRID_MOVE_MEASURE";var MOVE_DIMENSION="PIVOTGRID_MOVE_DIMENSION";var SET_AXIS="PIVOTGRID_SET_AXIS";var FETCH_DATA="PIVOTGRID_FETCH_DATA";var FETCH_FAILURE="PIVOTGRID_FETCH_FAILURE";var PUSH_DATA="PIVOTGRID_PUSH_DATA";var FETCH_SUCCESS="PIVOTGRID_FETCH_SUCCESS";var LOADING_CONFIG="PIVOTGRID_LOADING_CONFIG";var CHANGE_SORT_ORDER="PIVOTGRID_CHANGE_SORT_ORDER";var ADD_FILTER="PIVOTGRID_ADD_FILTER";var DELETE_FILTER="PIVOTGRID_DELETE_FILTER";var UPDATE_CELL_SIZE="PIVOTGRID_UPDATE_CELL_SIZE";var SET_SIZES="PIVOTGRID_SET_SIZES";var ZOOM="PIVOTGRID_ZOOM";// export const ZOOM_OUT = "PIVOTGRID_ZOOM_OUT";
var EXPAND_COLLAPSE="PIVOTGRID_EXPAND_COLLAPSE";var EXPAND_COLLAPSE_ALL="PIVOTGRID_EXPAND_COLLAPSE_ALL";var SET_COLLAPSES="PIVOTGRID_SET_COLLAPSES";var SELECT_RANGE="PIVOTGRID_SELECT_RANGE";var SCROLL="PIVOTGRID_SCROLL";var TOGGLE_SUBTOTAL="PIVOTGRID_TOGGLE_SUBTOTAL";

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__axis_selector__ = __webpack_require__(23);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__axis_selector__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__axis_selector__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__axis_selector__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__axis_selector__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_0__axis_selector__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cellSizes_selector__ = __webpack_require__(56);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__cellSizes_selector__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__cellSizes_selector__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__ = __webpack_require__(9);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__headers_selector__ = __webpack_require__(304);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_3__headers_selector__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_3__headers_selector__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cell_selector__ = __webpack_require__(111);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__cell_selector__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_4__cell_selector__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_4__cell_selector__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_4__cell_selector__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_4__cell_selector__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_selector__ = __webpack_require__(55);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_5__data_selector__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sizes_selector__ = __webpack_require__(110);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__sizes_selector__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_6__sizes_selector__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selection_selector__ = __webpack_require__(305);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__selection_selector__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__selection_selector__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_7__selection_selector__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_7__selection_selector__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_7__selection_selector__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_7__selection_selector__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_7__selection_selector__["g"]; });


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_action__ = __webpack_require__(306);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchData", function() { return __WEBPACK_IMPORTED_MODULE_0__data_action__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchFailure", function() { return __WEBPACK_IMPORTED_MODULE_0__data_action__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "applyPushedData", function() { return __WEBPACK_IMPORTED_MODULE_0__data_action__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "fetchSuccess", function() { return __WEBPACK_IMPORTED_MODULE_0__data_action__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configuration_action__ = __webpack_require__(307);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "loadingConfig", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setDimensions", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setMeasures", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setProperty", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setConfigurationProperty", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toggleMeasure", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "moveMeasure", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "moveDimension", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setAxis", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "zoom", function() { return __WEBPACK_IMPORTED_MODULE_1__configuration_action__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sizes_action__ = __webpack_require__(308);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "updateCellSize", function() { return __WEBPACK_IMPORTED_MODULE_2__sizes_action__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setSizes", function() { return __WEBPACK_IMPORTED_MODULE_2__sizes_action__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dimension_action__ = __webpack_require__(309);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toggleSortOrder", function() { return __WEBPACK_IMPORTED_MODULE_3__dimension_action__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter_action__ = __webpack_require__(310);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addFilter", function() { return __WEBPACK_IMPORTED_MODULE_4__filter_action__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "deleteFilter", function() { return __WEBPACK_IMPORTED_MODULE_4__filter_action__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collapses_action__ = __webpack_require__(311);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toggleCollapse", function() { return __WEBPACK_IMPORTED_MODULE_5__collapses_action__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "expandCollapseAll", function() { return __WEBPACK_IMPORTED_MODULE_5__collapses_action__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toggleCollapseDimension", function() { return __WEBPACK_IMPORTED_MODULE_5__collapses_action__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setCollapses", function() { return __WEBPACK_IMPORTED_MODULE_5__collapses_action__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selection_action__ = __webpack_require__(312);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectRange", function() { return __WEBPACK_IMPORTED_MODULE_6__selection_action__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "selectCell", function() { return __WEBPACK_IMPORTED_MODULE_6__selection_action__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "scrollToIndex", function() { return __WEBPACK_IMPORTED_MODULE_6__selection_action__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__subtotals_action__ = __webpack_require__(313);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "toggleSubTotal", function() { return __WEBPACK_IMPORTED_MODULE_7__subtotals_action__["a"]; });


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rowDimensionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return columnDimensionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return rowVisibleDimensionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return columnVisibleDimensionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return availableDimensionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return dimensionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return dimensionsWithAxisSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return activatedMeasuresSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return availableMeasuresSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}///////////////////////////////////////////////////////////////////
//  dimensions and measures (+ assignations in rows or columns) selectors
///////////////////////////////////////////////////////////////////
var getAxisDimensions=function getAxisDimensions(axis,axisDimensions,dimensions){var prevDimension={id:__WEBPACK_IMPORTED_MODULE_1__constants__["q" /* ROOT_ID */]};return axisDimensions.map(function(id,index){var dimension=dimensions[id];if(dimension.attributeParents.includes(prevDimension.id)||dimension.attributeParents.includes(prevDimension.isAttributeOf)&&prevDimension.isAttribute){dimension.axis=axis;dimension.depth=index;dimension.isAttribute=true;dimension.isAttributeOf=prevDimension.isAttributeOf||prevDimension.id;prevDimension.hasAttribute=!prevDimension.isAttribute;}else{dimension.isAttribute=false;}prevDimension=dimension;dimension.orderBy=undefined;return dimension;});};var getVisibleDimensions=function getVisibleDimensions(axis,dimensions,collapses,subTotals,hasMeasures){var prevId=void 0;var hasGrandTotal=subTotals[""+Object(__WEBPACK_IMPORTED_MODULE_1__constants__["F" /* toAxis */])(axis)+__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* TOTAL_ID */]]||false;var dims=dimensions.map(function(dimension){if(dimension.isAttribute){dimension.isVisible=!collapses[prevId];dimension.hasSubTotal=null;}else{dimension.isVisible=true;dimension.hasSubTotal=subTotals[dimension.id]||false;dimension.hasGrandTotal=hasGrandTotal;prevId=dimension.id;}return dimension;}).map(function(dimension){if(dimension.id===prevId){dimension.hasSubTotal=null;}return dimension;});if(hasMeasures){dims.push({id:__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* MEASURE_ID */],isVisible:true,sort:{},caption:"Measures",axis:axis});}if(!dims.length){dims.push({id:__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* TOTAL_ID */],isVisible:true,sort:{}});}return dims;};var rowDimensionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.axis.rows;},function(state){return state.dimensions;}],function(axisDimensions,dimensions){return getAxisDimensions(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].ROWS,axisDimensions,dimensions);});var columnDimensionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.axis.columns;},function(state){return state.dimensions;}],function(axisDimensions,dimensions){return getAxisDimensions(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].COLUMNS,axisDimensions,dimensions);});var rowVisibleDimensionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([rowDimensionsSelector,function(state){return state.collapses.dimensions;},function(state){return state.subtotals;},function(state){return state.configuration.measureHeadersAxis==="rows";}],function(dimensions,collapses,subTotals,hasMeasures){return getVisibleDimensions(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].ROWS,dimensions,collapses,subTotals,hasMeasures);});var columnVisibleDimensionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([columnDimensionsSelector,function(state){return state.collapses.dimensions;},function(state){return state.subtotals;},function(state){return state.configuration.measureHeadersAxis==="columns";}],function(dimensions,collapses,subTotals,hasMeasures){return getVisibleDimensions(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].COLUMNS,dimensions,collapses,subTotals,hasMeasures);});var availableDimensionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.axis.dimensions;},function(state){return state.dimensions;}],function(dimensionAxis,dimensions){return dimensionAxis.map(function(id){return dimensions[id];});});var dimensionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.dimensions;}],function(dimensions){return Object.keys(dimensions).map(function(id){return dimensions[id];});});var dimensionsWithAxisSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([rowDimensionsSelector,columnDimensionsSelector,availableDimensionsSelector],function(row,column,available){return row.map(function(dimension,index){dimension.depth=index;dimension.axis=__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].ROWS;return dimension;}).concat(column.map(function(dimension,index){dimension.depth=index;dimension.axis=__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].COLUMNS;return dimension;})).concat(available.map(function(dimension){dimension.depth=null;dimension.axis=null;return dimension;})).filter(function(dimension){return dimension.id!==__WEBPACK_IMPORTED_MODULE_1__constants__["m" /* MEASURE_ID */];});});var measuresSelector=function measuresSelector(state){return state.measures;};var activatedMeasuresSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([measuresSelector,function(state){return state.axis.measures;}],function(measures,activatedMeasures){return activatedMeasures.map(function(id){return measures[id];}).reduce(function(acc,mea){return Object.assign({},acc,_defineProperty({},mea.id,mea));},{});});var availableMeasuresSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([measuresSelector,function(state){return state.axis.measures;}],function(measures,activatedMeasures){return Object.keys(measures).map(function(id){return measures[id];}).filter(function(measure){return!activatedMeasures.includes(measure.id);});});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cellData; });
/* unused harmony export computeRows */
/* unused harmony export computeAnalytics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return computeData; });
/* unused harmony export aggregations */
/* unused harmony export computeAnalytic */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return computeAudit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return computeRowSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return rowSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return cellSearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


// ----------------------------------
// common data access (row or fiels)
// ----------------------------------
var cellData = function cellData(row, column, status, data, params, focused) {
  var editable =
  // focused &&
  !(status || {}).deleted_ && (column.editableFunction ? column.editableFunction({
    column: column,
    row: row,
    status: status || {},
    data: data,
    params: params
  }) : column.editable);
  //  dont use accessor for analytics computed data
  var value = column.aggregation ? row[column.id] : column.accessorFunction ? column.accessorFunction({ column: column, row: row, params: params, status: status, data: data }) : row[column.id];
  if (column.dataType === "date" && typeof value === "string") {
    value = new Date(value);
  }

  var select = column.select && editable && focused ? column.selectItems || column.select : undefined;
  //  map the data
  if (select) {
    if (column.selectFunction && editable && focused && !column.selectItems) {
      select = column.selectFunction({ column: column, row: row, data: data });
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isPromise(select) && !Array.isArray(select) && (typeof select === "undefined" ? "undefined" : _typeof(select)) === "object" && !column.accessorFunction) {
      select = Object.values(select);
    }
  }
  return { editable: editable, select: select, value: value };
};
var computeRows = function computeRows(data, meta, startIndex) {
  var foreignObjects = [];
  foreignObjects = meta.properties.filter(function (column) {
    return column.dataType === "joined object" && column.accessor !== undefined;
  });
  var _meta$table = meta.table,
      pk = _meta$table.pk,
      lk = _meta$table.lk,
      rwd = _meta$table.rwd;


  data.forEach(function (row, index) {
    // if (calcIndex) {
    row.index_ = index + (startIndex || 0);
    // }
    if (pk) {
      meta.indexPk[row[pk.id]] = row.index_;
    }
    if (lk) {
      meta.indexLk[row[lk.id]] = row.index_;
    }
    if (rwd) {
      meta.indexRowId[row[rwd.id]] = row.index_;
    }
    foreignObjects.forEach(function (column) {
      return row[column.id] = column.accessorFunction({ row: row });
    });
    if (meta.table.noDataMutation) {
      data[index] = Object.assign({}, row);
    }
  });
};
var computeAnalytics = function computeAnalytics(data, meta) {
  var columns = meta.properties.filter(function (column) {
    return column.aggregation && typeof column.accessorFunction === "function" && !column.hidden;
  });
  columns.forEach(function (column) {
    computeAnalytic(data, column);
  });
};
var computeData = function computeData(data, meta, startIndex) {
  computeRows(data, meta, startIndex);
  computeAnalytics(data, meta);
};
// ----------------------------
//  aggregations
//  ---------------------------
var aggregations = {
  count: function count(values) {
    return values.length;
  },
  sum: function sum(values) {
    return values.reduce(function (sum, value) {
      return sum += value;
    }, null);
  },
  min: function min(values) {
    return values.reduce(function (min, value) {
      return min = min === null || value < min ? value : min;
    }, null);
  },
  max: function max(values) {
    return values.reduce(function (max, value) {
      return max = max === null || value > max ? value : max;
    }, null);
  },
  avg: function avg(values) {
    return values.length === 0 ? null : aggregations.sum(values) / values.length;
  },
  weighted_avg: function weighted_avg(values) {
    var wavg = values.reduce(function (wavg, value) {
      wavg.v0 += value.v0;
      wavg.v1 += value.v1;
      return wavg;
    }, { v0: null, v1: null });
    return wavg.v0 === 0 && wavg.v1 === 0 ? null : wavg.v0 / wavg.v1;
  },
  delta: function delta(values) {
    var delta = values.reduce(function (delta, value) {
      delta.v0 += value.v0;
      delta.v1 += value.v1;
      return delta;
    }, { v0: null, v1: null });
    return delta.v0 - delta.v1;
  },
  prod: function prod(values) {
    return values.reduce(function (prod, value) {
      return prod *= value;
    }, null);
  }
};
// -------------------------------------
// compute new description
// -------------------------------------
var sortFunction = function sortFunction(accessor) {
  return function (rowA, rowB) {
    var a = accessor(rowA),
        b = accessor(rowB);
    var x = 0,
        i = 0;

    while (!x && i < a.length) {
      x = (a[i] > b[i]) - (b[i] > a[i]);
      i++;
    }

    return x;
  };
};
var computeAnalytic = function computeAnalytic(data, column) {
  var d = data.concat([]);
  var groups = [[]];
  // sort;
  var sortAccessor = column.sortAccessorFunction || function (_ref) {
    var row = _ref.row;
    return row[column.sortAccessor];
  };
  var groupByAccessor = column.groupByAccessorFunction || function (_ref2) {
    var row = _ref2.row;
    return row[column.groupByAccessor];
  };
  var accessor = function accessor(row) {
    var acc = [];
    if (groupByAccessor) {
      acc = acc.concat(groupByAccessor({ row: row }));
    }
    if (sortAccessor) {
      acc = acc.concat(sortAccessor({ row: row }));
    }
    return acc;
  };
  if (sortAccessor || groupByAccessor) {
    d.sort(sortFunction(accessor));
  }
  // group by and window interval
  var values = [];
  d.forEach(function (row, index) {
    row._index = groups[groups.length - 1].length;
    row._window = {
      value: (column.accessorFunction || function (_ref3) {
        var row = _ref3.row;
        return row[column.accessor];
      })({
        row: row
      }),
      groupBy: JSON.stringify(groupByAccessor({ row: row }))
    };
    if (column.comparisonAccessor) {
      row._window.ref = (column.comparisonAccessorFunction || function (row) {
        return row[column.comparisonAccessor];
      })({ row: row });
      if (column.windowStart) {
        row._window.start = column.startFunction(row._window.ref);
      }
      if (column.windowEnd) {
        row._window.end = column.endFunction(row._window.ref);
      }
    }
    if (index > 0 && row._window.groupBy !== d[index - 1]._window.groupBy) {
      if (!column.comparisonAccessor) {
        var value = column.aggregationFunction(values);
        groups[groups.length - 1].forEach(function (row) {
          return row[column.id] = value;
        });
        values = [];
      }
      groups.push([]);
    }
    if (!column.comparisonAccessor) {
      values.push(row._window.value);
    }
    groups[groups.length - 1].push(row);
  });
  // computation
  if (column.comparisonAccessor) {
    groups.forEach(function (group) {
      return group.forEach(function (row, index) {
        var i = index - 1,
            values = [row._window.value];
        while (i >= 0 && (row._window.start === undefined || group[i]._window.ref >= row._window.start)) {
          values.push(group[i]._window.value);
          i--;
        }
        i = index + 1;
        while (i < group.length && (row._window.end === undefined || group[i]._window.ref <= row._window.end)) {
          values.push(group[i]._window.value);
          i++;
        }
        row[column.id] = column.aggregationFunction(values);
      });
    });
  }

  return data;
};
var computeAudit = function computeAudit(rowUpdated, row, meta, audits) {
  var rows = [];
  if (rowUpdated) {
    rows.push(rowUpdated);
  }
  if (audits && audits.length) {
    var audits_ = [].concat(_toConsumableArray(audits)).reverse();
    var nextRow = row;
    audits_.forEach(function (audit) {
      var user_ = audit.user_,
          timestamp_ = audit.timestamp_,
          status_ = audit.status_;

      rows.push(Object.assign({}, nextRow, {
        user_: user_,
        time_: new Date(timestamp_),
        status_: status_
      }));
      nextRow = Object.assign({}, nextRow, audit.row);
    });
    // rows.push(nextRow);
    var foreignObjects = meta.properties.filter(function (column) {
      return column.dataType === "joined object";
    });
    if (foreignObjects.length) {
      rows.forEach(function (row) {
        foreignObjects.forEach(function (column) {
          return row[column.id] = column.accessorFunction({ row: row });
        });
      });
    }
  } else if (!rowUpdated) {
    rows.push(row);
  }
  return rows;
};

var getRegExp = function getRegExp(v) {
  return new RegExp(v.replace(" ", "[" + String.fromCharCode(32, 160) + "]"), "i");
};
var stringValue = function stringValue(property, row) {
  var accessor = property.accessorFunction || function (_ref4) {
    var row = _ref4.row;
    return row[property.id];
  };
  var v = accessor({ row: row });
  if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(v)) {
    if (property.dataType === "string") {
      return v.toUpperCase();
    } else if (property.dataType === "number") {
      return __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].numberToString(v);
    } else if (property.dataType === "date") {
      return __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].dateToString(v);
    } else {
      return null;
    }
  }
};
var computeRowSearch = function computeRowSearch(data, properties, dataStrings) {
  var strings = [];
  // console.log("computeRowSearch", new Date());
  data.forEach(function (row, index) {
    if (!dataStrings[row.index_]) {
      var rowStrings = [];
      properties.forEach(function (property) {
        var v = stringValue(property, row);
        if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(v)) {
          rowStrings.push(v);
        }
      });
      dataStrings[row.index_] = rowStrings.join("~~");
    }
    strings.push(dataStrings[row.index_]);
  });
  // console.log("computeRowSearch2", new Date());
  return strings;
};
var rowSearch = function rowSearch(dataStrings, exp) {
  // const v_ = v.toUpperCase();
  var indexes = [];
  dataStrings.forEach(function (rowString, index) {
    if (exp.test(rowString)) {
      indexes.push(index);
    }
  });
  return indexes;
};
var cellSearch = function cellSearch(row, properties, exp) {
  var propertyStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var direction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

  // const v_ = v.toUpperCase();
  var i = propertyStart;
  while (properties.length > i && i >= 0 && !exp.test(stringValue(properties[i], row) || "")) {
    i += direction;
  }
  // const
  // const v_ = v.toUpperCase();
  // const indexes = [];
  // Object.values(dataStrings).forEach((rowString, index) => {
  //   if (rowString.indexOf(v_) !== -1) {
  //     indexes.push(index);
  //   }
  // });
  return properties.length > i && i >= 0 ? i : null;
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    getPrototype = __webpack_require__(188),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return rollback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return rollbackAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRowStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUpdatedRows; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return setStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return manageRowError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getRowErrors; });
/* unused harmony export getErrors */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return errorHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exportFunctions; });
/* unused harmony export loadFileButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return hasParent; });
/* unused harmony export isEqual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




// -----------------------------------------------------------
// Error management
// -----------------------------------------------------------
var rollback = function rollback(updatedRows, index) {
  var status = updatedRows[index];
  if (!status.new_) {
    Object.keys(status.rowUpdated).forEach(function (key) {
      return status.rowUpdated[key] = null;
    });
    Object.keys(status.row).forEach(function (key) {
      return status.rowUpdated[key] = status.row[key];
    });
  }
  var n = status.errors ? status.errors.n_ || 0 : 0;
  status.deleted_ = false;
  status.updated_ = false;
  // if (!status.new_) {
  status.errors = {};
  if (updatedRows.nErrors) {
    updatedRows.nErrors -= n;
  }
  // }
};
var rollbackAll = function rollbackAll(updatedRows, data) {
  getUpdatedRows(updatedRows).forEach(function (status) {
    if (status.new_) {
      data.splice(status.rowUpdated.index_, 1);
      delete updatedRows[status.rowUpdated.index_];
    } else if (status.updated_) {
      rollback(updatedRows, status.row.index_);
    }
  });
  delete updatedRows.nErrors;
  delete updatedRows.nErrorsServer;
  updatedRows.errors = {};
};

var getRowStatus = function getRowStatus(updatedRows, row) {
  var status = updatedRows[row.index_];
  if (!status) {
    status = {
      // updated_: true,
      rowUpdated: row,
      row: Object.assign({}, row),
      errors: {}
    };
    updatedRows[row.index_] = status;
  }
  return status;
};
var getUpdatedRows = function getUpdatedRows(updatedRows) {
  return Object.keys(updatedRows).filter(function (key) {
    return !Number.isNaN(Number(key)) && (updatedRows[key].deleted_ || updatedRows[key].new_ || updatedRows[key].updated_) && !(updatedRows[key].new_ && updatedRows[key].deleted_);
  }).map(function (key) {
    return updatedRows[key];
  });
};
var setStatus = function setStatus(status, type) {
  status[type] = true;
  status.timeStamp = new Date().getTime();
};
//------------------------------------------------------------
var manageRowError = function manageRowError(updatedRows, index, column, type, error, rowTitle, onServer) {
  var status = updatedRows[index] || {};
  if (rowTitle) {
    status.rowTitle = rowTitle;
  }
  var existsErrors = !__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(onServer ? status.errorsServer : status.errors);
  var errors = (onServer ? status.errorsServer : status.errors) || {};
  var existsObject = !__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(errors[column.id]);
  var objectErrors = errors[column.id] || {};
  var existsType = !__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(objectErrors[type]);
  if (error) {
    objectErrors[type] = error;
    if (!existsType) {
      objectErrors.n_ = (objectErrors.n_ || 0) + 1;
      if (!existsObject) {
        errors[column.id] = objectErrors;
      }
      errors.n_ = (errors.n_ || 0) + 1;
      if (!existsErrors) {
        if (onServer) {
          status.errorsServer = errors;
        } else {
          status.errors = errors;
        }
      }
      if (onServer) {
        updatedRows.nErrorsServer = (updatedRows.nErrorsServer || 0) + 1;
      } else {
        updatedRows.nErrors = (updatedRows.nErrors || 0) + 1;
      }
    }
  } else {
    if (existsType) {
      delete objectErrors[type];
      objectErrors.n_--;
      if (objectErrors.n_ === 0) {
        delete errors[column.id];
      }
      errors.n_--;
      if (onServer) {
        updatedRows.nErrorsServer = (updatedRows.nErrorsServer || 0) - 1;
      } else {
        updatedRows.nErrors = (updatedRows.nErrors || 0) - 1;
      }
    }
  }
};
var getRowErrors = function getRowErrors(status, rowIndex) {
  var errors = [];
  if (!status.deleted_ && status.errors) {
    Object.keys(status.errors).forEach(function (column) {
      if (status.errors[column] || column !== "n_") {
        Object.keys(status.errors[column]).forEach(function (type) {
          if (type !== "n_") {
            errors.push({
              column: column,
              type: type,
              error: status.errors[column][type],
              rowIndex: rowIndex
            });
          }
        });
      }
    });
  }
  if (!status.deleted_ && status.errorsServer) {
    Object.keys(status.errorsServer).forEach(function (column) {
      if (status.errorsServer[column] || column !== "n_") {
        Object.keys(status.errorsServer[column]).forEach(function (type) {
          if (type !== "n_") {
            errors.push({
              column: column,
              type: type,
              error: status.errorsServer[column][type],
              rowIndex: rowIndex
            });
          }
        });
      }
    });
  }
  return errors;
};
var getErrors = function getErrors(updatedRows) {
  var errors = [];
  if (updatedRows.errors) {
    Object.keys(updatedRows.errors).forEach(function (type) {
      if (updatedRows.errors[type].length) {
        errors.push({
          type: type,
          error: updatedRows.errors[type]
        });
      }
    });
  }
  getUpdatedRows(updatedRows).forEach(function (status) {
    if (!status.deleted_ && (status.errors || {}).n_) {
      errors = errors.concat(getRowErrors(status, status.rowUpdated.index_));
    }
  });
  return errors;
};
var errorHandler = {
  onTableChange: function onTableChange(message) {
    if (message.type !== "sort") {
      message.modalBody = "Do you want to save before " + message.type + "?";
    }
    return true;
  },
  onSaveBefore: function onSaveBefore(message) {
    var meta = message.meta,
        updatedRows = message.updatedRows;

    var key = meta.table.lk || meta.table.pk;
    var errors = getErrors(updatedRows).map(function (error) {
      if (error.rowIndex === undefined) {
        return "\n" + (meta.table.caption || meta.table.object) + " : " + error.error;
      } else {
        var rowUpdated = updatedRows[error.rowIndex].rowUpdated;
        var rowTitle = updatedRows[error.rowIndex].rowTitle;
        if (!rowTitle && key) {
          rowTitle = key.caption + " " + rowUpdated[key.id];
        }
        return "\n" + rowTitle + " : " + error.error;
      }
    });
    if (errors.length) {
      message.modalBody = ["Can't save with errors: "].concat(errors);
      return false;
    } else {
      message.modalBody = null;
    }
    return true;
  },
  onSave: function onSave(message) {
    if (message.serverError) {
      message.modalBody = message.serverError;
      return false;
    }
    return true;
  }
};
// -----------------------------------------------------------
// Export configuration
// -----------------------------------------------------------
var excludeProperties = {
  visibleIndexes: true,
  selectItems: true,
  selectFilter: true,
  // accessorFunction: true,
  // formatFunction: true,
  // defaultFunction: true,
  // alignement: true,
  position: true,
  index_: true,
  visibleIndex_: true
};
// const hasFunction = {
//   editable: true,
//   accessor: true,
//   select: true,
//   format: true,
//   disable: true,
//   action: true,
//   onChange: true,
//   onQuit: true,
//   descriptor: true
// };
// const getItem = (key, value, parent, functions) => {
//   let v = value;
//   if (!utils.isNullOrUndefined(v) && !excludes.includes(key)) {
//     if (typeof v === "function") {
//       v: parent;
//       // manage function
//     } else if (typeof v === "function") {
//       v: parent;
//       // manage function
//     } else if (typeof v === "function") {
//       v: parent;
//       // manage function
//     }
//   }
// };
var buildObject = function buildObject(item) {
  var excludes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : excludeProperties;

  if (Array.isArray(item)) {
    return item.map(function (item) {
      return buildObject(item);
    });
  } else if ((typeof item === "undefined" ? "undefined" : _typeof(item)) === "object") {
    return Object.keys(item).reduce(function (acc, key) {
      if (!__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(item[key]) && !excludes[key]) {
        acc[key] = buildObject(item[key]);
      }
      return acc;
    }, {});
  } else {
    return item;
  }
};

var exportFunctions = function exportFunctions(functions) {
  var f = {};
  functions.forEach(function (fct) {
    if (!f[fct.visibility]) f[fct.visibility] = {};
    if (!f[fct.visibility][fct.tp]) f[fct.visibility][fct.tp] = {};
    f[fct.visibility][fct.tp][fct.id] = "~~~" + String(fct.functionJS) + "~~~";
  });
  return JSON.stringify(f).replace(/"~~~/g, "").replace(/~~~"/g, "").replace(/\\n/g, "").replace(/\\t/g, "").replace(/\\"/g, '"');
};
// ----------------------------------
// common data access (row or fiels)
// ----------------------------------
var loadFileButton = function loadFileButton(_ref) {
  var disabled = _ref.disabled,
      index = _ref.index,
      style = _ref.style,
      onClick = _ref.onClick,
      className = _ref.className;

  var onLoad = function onLoad(e) {
    var file = document.getElementById("file-selector").files[0];
    var reader = new FileReader();
    reader.onload = function (ee) {
      onClick(Object.assign({}, ee, { file: file, text: reader.result }));
    };
    reader.readAsText(file);
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    "div",
    { key: index, style: Object.assign({}, style, { display: "inherit" }) },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "file",
      id: "file-selector",
      onChange: onLoad,
      style: { display: "none" }
    }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "button",
      {
        style: { width: "inherit" },
        className: className,
        disabled: disabled,
        onClick: function onClick() {
          return document.getElementById("file-selector").click();
        }
      },
      "Load"
    )
  );
};
// -------------------------------------------
// miscelaneous
// -------------------------------------------
var hasParent = function hasParent(element, id) {
  if (!element.parentElement) {
    return false;
  } else if (element.parentElement.id.slice(0, id.length) === id) {
    return true;
  } else {
    return hasParent(element.parentElement, id);
  }
};
var isEqual = function isEqual(v0, v1) {
  if (v0 === v1 || __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isDate(v0) && __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isDate(v1) && v0.getTime() === v1.getTime() || __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isDate(v0) && typeof v1 === "string" && v0.getTime() === new Date(v1).getTime() || __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isDate(v1) && typeof v0 === "string" && v1.getTime() === new Date(v0).getTime() || (typeof v0 === "undefined" ? "undefined" : _typeof(v0)) === "object" && (typeof v1 === "undefined" ? "undefined" : _typeof(v1)) === "object" && Object.keys(v0).length === Object.keys(v1).length && Object.keys(v0).reduce(function (acc, key) {
    return acc && isEqual(v0[key], v1[key], true);
  })) {
    return true;
  }
  return false;
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(179)();
}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(89),
    overRest = __webpack_require__(222),
    setToString = __webpack_require__(223);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return computeMetaPositions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computeMeta; });
/* unused harmony export getDataType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return computeMetaFromData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__ = __webpack_require__(1);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };


// export const utils.getFunction = (functions, object, type, value, utils_) => {
//   if (typeof value === "function") {
//     return value;
//   } else if (typeof value === "string") {
//     //  accessor
//     const indexDot = value.indexOf(".");
//     if (indexDot !== -1) {
//       let v = value;
//       if (value.slice(0, indexDot) === "row") {
//         v = value.slice(indexDot + 1);
//       }
//       const keys = v.split(".");
//       return ({ row }) => {
//         return keys.reduce(
//           (acc, key, index) =>
//             acc[key] === undefined && index < keys.length - 1 ? {} : acc[key],
//           row
//         );
//       };
//     } else {
//       const v =
//         typeof value === "string"
//           ? functions
//               .filter(
//                 f =>
//                   f.id === value &&
//                   f.tp === type &&
//                   (f.visibility === "global" || f.visibility === object)
//               )
//               .sort(
//                 (f0, f1) =>
//                   (f0.visibility !== object) - (f1.visibility !== object)
//               )
//           : [];
//       return v.length
//         ? message => v[0].functionJS({ ...message, utils: utils_ || utils })
//         : undefined;
//     }
//   }
// };
var getSizes = function getSizes(meta, rowHeight) {
  var headersLength = 1 + !meta.table.noFilter * (1 + (meta.properties.findIndex(function (column) {
    return column.filterType === "between";
  }) !== -1));
  var headersHeight = (meta.table.caption ? 30 : 0) + headersLength * rowHeight * meta.zoom + ((meta.table.actions || []).length ? 30 : 0);

  var lastColumn = meta.properties[meta.properties.length - 1];
  var rowWidth = lastColumn.position + lastColumn.computedWidth;
  var headersWidth = !meta.table.noStatus * rowHeight * meta.zoom;
  return {
    headersHeight: headersHeight,
    headersWidth: headersWidth,
    rowWidth: rowWidth,
    rowHeight: rowHeight * meta.zoom
  };
};
var computeMetaPositions = function computeMetaPositions(meta, zoom) {
  var position = 0;
  meta.visibleIndexes = [];
  meta.lockedIndex = null;
  meta.lockedWidth = null;
  meta.properties.forEach(function (column, index) {
    column.index_ = index;
    column.position = position;
    if (column.dataType === "object" || column.dataType === "joined object") {
      column.hidden = true;
    }
    if (zoom !== undefined) {
      column.computedWidth = zoom * (column.hidden ? 0 : column.width || 0);
    }
    if (column.computedWidth !== 0) {
      column.visibleIndex_ = meta.visibleIndexes.length;
      meta.visibleIndexes.push(column.index_);
    }
    position += column.computedWidth;
    if (column.locked) {
      meta.lockedIndex = column.index_;
      meta.lockedWidth = position;
    }
  });
  return meta.visibleIndexes;
};
var grantPrivilege = function grantPrivilege(object, subObject, target, privileges, type) {
  if (privileges && privileges[object] && privileges[object][type]) {
    var priv = privileges[object][type];
    if (type !== "table") {
      priv = priv[subObject];
    }
    if (priv) {
      if (type === "actions") {
        if (priv === "enable") {
          target.enable = true;
          target.hidden = false;
        } else if (priv === "disable") {
          target.enable = false;
          target.hidden = false;
        } else if (priv === "hidden") {
          target.hidden = true;
          target.enable = false;
        } else {
          target.enable = priv;
        }
      } else if (type === "properties") {
        if (priv === "editable") {
          target.editable = true;
          target.hidden = false;
        } else if (priv === "visible") {
          target.editable = false;
          target.enable = false;
        } else if (priv === "hidden") {
          target.editable = false;
          target.hidden = true;
        } else {
          target.editable = priv;
        }
      }
    }
  }
};
var computeMeta = function computeMeta(meta) {
  var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var functions = arguments[2];
  var utils_ = arguments[3];
  var privileges = arguments[4];

  var position = 0;
  // table
  if (!meta.functions) {
    meta.functions = functions;
  }
  meta.visibleIndexes = [];
  meta.table.editable = meta.table.editable && !meta.table.checkable;
  grantPrivilege(meta.table.object, null, meta.table, privileges, "table");
  meta.zoom = zoom;
  meta.table.selectFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "dml", meta.table.onSave, utils_);
  meta.table.onTableChangeFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "dml", meta.table.onTableChange, utils_);
  meta.table.onSaveFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "dml", meta.table.onSave, utils_);
  meta.table.onSaveBeforeFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "dml", meta.table.onSaveBefore, utils_);
  meta.table.onSaveAfterFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "dml", meta.table.onSaveAfter, utils_);
  if (!meta.indexPk && !__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullValue(meta.table.primaryKey)) {
    meta.indexPk = {};
  }
  if (!meta.indexLk && !__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullValue(meta.table.logicalKey)) {
    meta.indexLk = {};
  }
  if (!meta.indexRowId && !__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullValue(meta.table.rowId)) {
    meta.indexRowId = {};
  }
  meta.row.descriptorFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "accessor", meta.row.descriptor, utils_);
  // row
  meta.row.onQuitFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "validator", meta.row.onQuit, utils_);
  meta.row.auditFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "accessor", meta.row.audit, utils_);
  if (meta.table.actions) {
    meta.table.actions.forEach(function (action) {
      grantPrivilege(action.id || action.caption, action, privileges, "actions");
      if (action.action) {
        action.actionFunction = typeof action.action === "function" ? action.action : __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "action", action.action, utils_);
      }
      action.enableFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "editable", action.enable, utils_);
    });
  }
  if (meta.table.subscription) {
    meta.table.subscription.observableFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "dml", meta.table.subscription.observable, utils_);
    meta.table.subscription.observerFunctions = {
      onNext: __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "observer", (meta.table.subscription.observer || { onNext: "onNext" }).onNext, utils_),
      onCompleted: __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "observer", (meta.table.subscription.observer || { onCompleted: "onCompleted" }).onCompleted, utils_),
      onError: __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "observer", (meta.table.subscription.observer || { onError: "onError" }).onError, utils_)
    };
  }

  // properties
  meta.properties.forEach(function (column, index) {
    if (column.deleted_) {
      column.hidden = true;
      column.mandatory = false;
    }
    grantPrivilege(meta.table.object, column.id, column, privileges, "properties");

    if (column.id === "index_" && column.hidden === undefined) {
      column.hidden = true;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.id) && column.id === meta.table.primaryKey) {
      meta.table.pk = column;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.id) && column.id === meta.table.logicalKey) {
      meta.table.lk = column;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.id) && column.id === meta.table.rowId) {
      column.dataType = "number";
      column.hidden = true;
      meta.table.rwd = column;
    }
    if (column.dataType === "object" || column.dataType === "joined object") {
      column.hidden = true;
    }
    var width = zoom * (column.hidden ? 0 : column.width || 0);
    column.computedWidth = width;
    column.position = position;
    column.index_ = index;

    position += width;
    if (column.locked) {
      meta.lockedIndex = column.index_;
      meta.lockedWidth = position;
    }
    if (width !== 0) {
      column.visibleIndex_ = meta.visibleIndexes.length;
      meta.visibleIndexes.push(column.index_);
    }
    if (!meta.table.editable) {
      column.editable = false;
    } else if (column.editable === undefined) {
      column.editable = true;
    }
    column.editableFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "editable", column.editable, utils_);
    column.formatFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "format", column.format, utils_);
    column.selectFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "select", column.select, utils_);
    column.foreignObjectFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "foreignObject", column.foreignObject, utils_);
    // select items can be defined as
    // - an array
    // - an object {id:caption...}
    // - an object {items:[select items],filter:[function to filter items with parameters as row,data...
    if (Array.isArray(column.select)) {
      column.selectItems = column.select;
    }
    // column.selectItems = select || [""];

    column.accessorFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "accessor", column.accessor, utils_);
    if (column.dataType === "joined object" && column.select) {
      column.primaryKeyAccessorFunction = function (_ref) {
        var row = _ref.row;
        return row.pk_;
      };
      // column.primaryKeyAccessorFunction=({row})=>
      if (column.selectFunction && typeof column.selectFunction === "function") {
        column.selectItems = column.selectFunction();
      } else if (column.selectFunction) {
        column.selectItems = column.selectFunction;
      } else {
        column.selectItems = column.select;
      }
      var f = column.accessorFunction;
      column.setForeignKeyAccessorFunction = function (message) {
        var value = message.value,
            row = message.row;

        row[column.accessor.replace("row.", "")] = value;
      };
      column.accessorFunction = function (_ref2) {
        var row = _ref2.row;

        var v = f({ row: row });
        return column.selectItems[v];
      };
    }
    // reference to an object
    if (column.accessor && typeof column.accessor === "string") {
      var accessor = column.accessor;
      var _index = column.accessor.indexOf(".");
      if (_index !== -1 && accessor.slice(0, _index) === "row") {
        accessor = accessor.slice(_index + 1);
        _index = accessor.indexOf(".");
      }
      if (_index !== -1) {
        column.reference = accessor.slice(0, accessor.indexOf("."));
        var referencedColumn = meta.properties.find(function (col) {
          return col.id === column.reference;
        });
        if (referencedColumn) {
          column.primaryKeyAccessorFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "accessor", referencedColumn.accessor, utils_);
          // referencedColumn.accessorFunction;
          column.setForeignKeyAccessorFunction = function (_ref3) {
            var value = _ref3.value,
                row = _ref3.row;

            row[referencedColumn.accessor.slice(4)] = value;
          };
          if (referencedColumn.dataType === "joined object" && column.editable) {
            column.select = " ";
            column.selectItems = referencedColumn.selectItems;
            column.mandatory = column.mandatory || referencedColumn.mandatory;
          }
        }
      }
    }
    column.sortAccessorFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "accessor", column.sortAccessor || column.accessor, utils_);
    column.defaultFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "default", column.default, utils_);
    column.onChangeFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "validator", column.onChange, utils_);
    column.onQuitFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "validator", column.onQuit, utils_);

    if (!column.defaultFunction && column.default) {
      column.defaultFunction = function () {
        if (typeof column.default === "string" && !(column.dataType === "string" || column.dataType === "text")) {
          if (column.dataType === "boolean") {
            return column.default === "true";
          } else if (column.dataType === "number" && __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNumber(column.default)) {
            return Number(column.default);
          } else if (column.dataType === "date" && __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isDate(column.default)) {
            return new Date(column.default);
          } else {
            return null;
          }
        } else {
          return column.default;
        }
      };
    }
    if (column.aggregation) {
      // a voir
      column.groupByAccessorFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "accessor", column.groupByAccessor, utils_);
      column.comparisonAccessorFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "accessor", column.comparisonAccessor, utils_);
      column.aggregationFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "aggregation", column.aggregation, utils_);
      column.startFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "window", column.windowStart, utils_);
      column.endFunction = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction(functions, "window", column.windowEnd, utils_);
    }
    if (column.accessor && !column.reference && !column.onQuit) {
      column.editable = false;
    }
  });
};
// return meta;
// };
var getDataType = function getDataType(value) {
  var dataType = typeof value === "undefined" ? "undefined" : _typeof(value);
  if (dataType === "object") {
    if (__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isDate(value)) {
      dataType = "date";
    } else if (Array.isArray(value)) {
      dataType = "array";
    } else {
      dataType = "object";
    }
  } else if (dataType === "string" && value === new Date(value).toJSON()) {
    dataType = "date";
  }
  return dataType;
};
var computeMetaFromData = function computeMetaFromData(data, meta, zoom, functions, utils_, privileges) {
  var position = 0;
  if (!meta.properties.length && data && data.length) {
    var row = data[0];
    Object.keys(row).forEach(function (key, index) {
      var dataType = getDataType(row[key]),
          filterType = "";

      var alignement = "unset";
      if (dataType === "string") {
        alignement = "left";
      } else if (dataType === "number") {
        alignement = "right";
        filterType = "between";
      } else if (dataType === "date") {
        alignement = "center";
        filterType = "between";
      }
      var width = 100;
      meta.properties.push({
        id: key,
        caption: key,
        tp: "Dataset",
        width: width,
        dataType: dataType,
        alignement: alignement,
        hidden: dataType === "object" || dataType === "joined object" || dataType === "array" || key === "index_" || key === "timestamp_" || key === "rowId_",
        position: position,
        editable: !!meta.table.editable,
        index_: index,
        formatFunction: function formatFunction(_ref4) {
          var value = _ref4.value;
          return value;
        },
        selectFunction: undefined,
        filterType: filterType,
        v: null,
        vTo: null
      });
      position += width;
    });
  }
  computeMeta(meta, zoom, functions, utils_, privileges);
};
// -----------------------------------------------------------
// build a table of functions from the initial function object
// -----------------------------------------------------------
// const functionsByObject = (object, functions) => {
//   const f = functions[object];
//   // const accessor = accessor => {
//   //   return f.accessors[accessor];
//   // };
//   const f_ = [];
//   Object.keys(f).forEach(type => {
//     const tp = type.slice(0, type.length - 1);
//     Object.keys(f[type]).forEach(code => {
//       const functionJS = f[type][code];
//       if (functionJS) {
//         f_.push({
//           id: code,
//           visibility: object === "globals_" ? "global" : object,
//           caption: code,
//           tp,
//           functionJS
//         });
//       }
//     });
//   });
//   return f_;
// };
// export const functionsTable = functions => {
//   if (functions === undefined) {
//     return [];
//   }
//   return Object.keys(functions).reduce(
//     (acc, object) => acc.concat(functionsByObject(object, functions)),
//     []
//   );
// };

/***/ }),
/* 17 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropContext = __webpack_require__(81);

Object.defineProperty(exports, 'DragDropContext', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContext).default;
  }
});

var _DragDropContextProvider = __webpack_require__(247);

Object.defineProperty(exports, 'DragDropContextProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContextProvider).default;
  }
});

var _DragLayer = __webpack_require__(248);

Object.defineProperty(exports, 'DragLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragLayer).default;
  }
});

var _DragSource = __webpack_require__(249);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(259);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(82);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isNumber"] = isNumber;
/* harmony export (immutable) */ __webpack_exports__["isDate"] = isDate;
/* harmony export (immutable) */ __webpack_exports__["isString"] = isString;
/* harmony export (immutable) */ __webpack_exports__["isStringOrNumber"] = isStringOrNumber;
/* harmony export (immutable) */ __webpack_exports__["isRegExp"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["isFunction"] = isFunction;
/* harmony export (immutable) */ __webpack_exports__["isPromise"] = isPromise;
/* harmony export (immutable) */ __webpack_exports__["isEmpty"] = isEmpty;
/* harmony export (immutable) */ __webpack_exports__["isObservable"] = isObservable;
/* harmony export (immutable) */ __webpack_exports__["escapeRegex"] = escapeRegex;
/* harmony export (immutable) */ __webpack_exports__["findInArray"] = findInArray;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "union", function() { return union; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersection", function() { return intersection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasIntersection", function() { return hasIntersection; });
/* harmony export (immutable) */ __webpack_exports__["isInRange"] = isInRange;
/* harmony export (immutable) */ __webpack_exports__["isNull"] = isNull;
/* harmony export (immutable) */ __webpack_exports__["isUndefined"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["isNullOrUndefined"] = isNullOrUndefined;
/* harmony export (immutable) */ __webpack_exports__["isNullValue"] = isNullValue;
/* harmony export (immutable) */ __webpack_exports__["toAccessorFunction"] = toAccessorFunction;
/* harmony export (immutable) */ __webpack_exports__["nullValue"] = nullValue;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatValue", function() { return formatValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberToString", function() { return numberToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dateToString", function() { return dateToString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stringToDate", function() { return stringToDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyMap", function() { return keyMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNavigationKey", function() { return isNavigationKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isZoom", function() { return isZoom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copy", function() { return copy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeFunctions", function() { return mergeFunctions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "functionsTable", function() { return functionsTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFunction", function() { return getFunction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Returns whether or not obj is a number
 * @param  {object}  obj
 * @return {Boolean}
 */
function isNumber(obj) {
  return Object.prototype.toString.apply(obj) === "[object Number]";
}
/**
 * Returns whether or not obj is a Date object.
 * @param  {object}  obj
 * @return {Boolean}
 */
function isDate(obj) {
  return Object.prototype.toString.apply(obj) === "[object Date]";
}
/**
 * Returns whether or not obj is a string
 * @param  {object}  obj
 * @return {Boolean}
 */
function isString(obj) {
  return typeof obj === "string";
}

function isStringOrNumber(obj) {
  var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
  return type === "string" || type === "number";
}
/**
 * Returns whether or not obj is a regular expression object
 * @param  {object}  obj
 * @return {Boolean}
 */
function isRegExp(obj) {
  return Object.prototype.toString.apply(obj) === "[object RegExp]";
}
/**
 * Returns whether or not obj is a function object
 * @param  {object}  obj
 * @return {Boolean}
 */
function isFunction(obj) {
  return Object.prototype.toString.apply(obj) === "[object Function]";
}

/**
 * Returns whether or not obj is a Promise
 * @param  {object}  obj
 * @return {Boolean}
 */
function isPromise(obj) {
  return Promise.resolve(obj) === obj;
}
/**
 * Returns whether an object is empty
 * @param  {object}  obj
 * @return {Boolean}
 */
function isEmpty(obj) {
  return isNullOrUndefined(obj) || obj.constructor === Object && Object.keys(obj).length === 0;
}

/**
 * Returns whether or not obj is an observable
 * @param  {object}  obj
 * @return {Boolean}
 */
function isObservable(obj) {
  return obj && obj.subscribe !== undefined;
}

/**
 * Escapes all RegExp special characters.
 */
function escapeRegex(re) {
  return re.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
/**
 * Returns the first element in the array that satisfies the given predicate
 * @param  {Array} array     the array to search
 * @param  {function} predicate Function to apply to each element until it returns true
 * @return {Object}           The first object in the array that satisfies the predicate or undefined.
 */
function findInArray(array, predicate) {
  if (this.isArray(array) && predicate) {
    for (var i = 0; i < array.length; i += 1) {
      var item = array[i];
      if (predicate(item)) {
        return item;
      }
    }
  }
  return undefined;
}
var union = function union(arg0, arg1) {
  if (arg1) {
    return [].concat(_toConsumableArray(new Set(arg0.concat(arg1))));
  }
  var res = void 0;
  if (arg1) {
    res = [].concat(_toConsumableArray(arg[0].concat(arg[1])));
  } else {
    res = arg0.reduce(function (acc, array) {
      if (!acc.length) {
        acc = array || [];
      } else {
        acc = acc.concat(array);
      }
      return acc;
    }, []);
  }
  res = [].concat(_toConsumableArray(new Set(res)));
  // res.sort((a,b)=>);
  return res;
};
// calculate the intersection of two arrays (arg1 is the second array) or an array of arrays (arg0)
var intersection = function intersection(arg0, arg1) {
  var intersection_ = function intersection_(arg0, arg1) {
    if (isUndefined(arg0)) {
      return arg1;
    } else if (isUndefined(arg1)) {
      return arg0;
    } else {
      var n = arg0.length;
      var m = arg1.length;
      var i = 0;
      var j = 0;
      var res = [];
      while (i < n && j < m) {
        if (arg0[i] > arg1[j]) {
          j += 1;
        } else if (arg0[i] < arg1[j]) {
          i += 1;
        } else {
          res.push(arg0[i]);
          i += 1;
          j += 1;
        }
      }
      return res;
    }
  };
  if (arg1) {
    return intersection_(arg0, arg1);
  } else if (!arg0.length) {
    return [];
  } else if (arg0.length === 1) {
    return arg0[0];
  } else {
    return arg0.slice(1).reduce(function (acc, array) {
      return intersection_(acc, array);
    }, arg0[0]);
  }
};
var hasIntersection = function hasIntersection(arg0, arg1) {
  if (isUndefined(arg0) || isUndefined(arg1)) {
    return true;
  } else {
    var n = arg0.length;
    var m = arg1.length;
    var i = 0;
    var j = 0;
    // const res = [];
    while (i < n && j < m) {
      if (arg0[i] > arg1[j]) {
        j += 1;
      } else if (arg0[i] < arg1[j]) {
        i += 1;
      } else {
        return true;
      }
    }
    return false;
  }
};

function isInRange(_ref, _ref2, _ref3) {
  var columnIndex = _ref.columns,
      rowIndex = _ref.rows;
  var columnIndexStart = _ref2.columns,
      rowIndexStart = _ref2.rows;
  var columnIndexEnd = _ref3.columns,
      rowIndexEnd = _ref3.rows;

  var inRows = false;
  if (columnIndexStart <= columnIndexEnd) {
    inRows = columnIndexStart <= columnIndex && columnIndex <= columnIndexEnd;
  } else {
    inRows = columnIndexEnd <= columnIndex && columnIndex <= columnIndexStart;
  }
  var inColumns = false;
  if (rowIndexStart <= rowIndexEnd) {
    inColumns = rowIndexStart <= rowIndex && rowIndex <= rowIndexEnd;
  } else {
    inColumns = rowIndexEnd <= rowIndex && rowIndex <= rowIndexStart;
  }
  return inRows && inColumns;
}

function isNull(obj) {
  return obj === null;
}

function isUndefined(obj) {
  return obj === undefined;
}

function isNullOrUndefined(obj) {
  return isUndefined(obj) || isNull(obj);
}
function isNullValue(obj) {
  return isUndefined(obj) || isNull(obj) || obj === "";
}

function toAccessorFunction(accessor) {
  if (typeof accessor === "string") {
    return function (row) {
      return row[accessor];
    };
  }
  return accessor;
}

function nullValue(obj, alternativeValue) {
  return isNullValue(obj) ? alternativeValue : obj;
}

/* eslint-disable no-param-reassign */
var range = function range(a, b) {
  return Array.from( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(x, y) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(x <= y)) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return x;

          case 3:
            x += 1;
            _context.next = 0;
            break;

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  })(a, b));
};
// -----------------------------------
// conversion functions
// -----------------------------------
// date functions
// export const isDate = d => d instanceof Date && !isNaN(d.valueOf());
var formatValue = function formatValue(value, fmt, ndec) {
  // format not managed yet
  if (isNullOrUndefined(value)) {
    return null;
  } else if (isDate(value)) {
    return dateToString(value, fmt);
  } else if (isNumber(value)) {
    return numberToString(value, fmt, ndec);
  } else if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
    return "[object]";
  } else if (typeof value === "function") {
    return "[function]";
  } else {
    return value;
  }
};
var numberToString = function numberToString(n, fmt, ndec) {
  var v = n,
      v2 = "";
  if (!isNullOrUndefined(ndec)) {
    var nf = n.toFixed(ndec);
    v = Number(nf);
    var nn = nf.length - v.toString().length;
    if (nn > 0) {
      v2 = nf.slice(nf.length - nn);
    }
  }
  if (!fmt || fmt === "LocaleString") {
    v = v.toLocaleString();
    if (v2 !== "") {
      var separator = 0.1.toLocaleString().slice(1, 2);
      if (separator !== ".") {
        v2 = v2.replace(".", separator);
      }
    }
  } else if (fmt === "String") {
    v = v.toString();
  }

  return v + v2;
};

var dateToString = function dateToString(d, fmt) {
  // format not managed yet
  if (!isDate(d)) {
    return undefined;
  }
  if (isNullValue(fmt) || fmt === "LocaleDateString") return d.toLocaleDateString();else if (fmt === "LocaleString") return d.toLocaleString();else if (fmt === "LocaleTimeString") return d.toLocaleTimeString();else if (fmt === "ISO") return d.toISOString();else if (fmt === "UTC") return d.toUTCString();
  var date = {
    dd: String(d.getDate()).padStart(2, "0"),
    mm: String(d.getMonth() + 1).padStart(2, "0"),
    yy: String(d.getFullYear()),
    hh: String(d.getHours()).padStart(2, "0"),
    mi: String(d.getMinutes()).padStart(2, "0"),
    ss: String(d.getSeconds()).padStart(2, "0")
  };
  var format = fmt.split(/[/: ]/);
  var index = 0,
      dd = "";
  format.forEach(function (f) {
    var x = date[f.slice(0, 2)];
    if (x) {
      index += f.length + 1;
      dd += x + (fmt[index - 1] || " ");
    }
  });
  return dd.slice(0, dd.length - 1);
};
// export const toMonth = d => {
//   const d_ = new Date(d);
//   d_.setDate(1);
//   return new Date(d_);
// };
// export const toYear = d => {
//   const d_ = new Date(d);
//   d_.setDate(1);
//   d_.setMonth(0);
//   return new Date(d_);
// };
var daysByMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var stringToDate = function stringToDate(s, fmt) {
  // format not managed yet
  //  a voir culture
  if (!s) {
    return null;
  }
  var ds = s.split(/[.:/ ]+/g);
  var d = ds.map(function (v) {
    return parseInt(v, 8);
  });
  if (d.length !== 3) {
    return undefined;
  }
  // a voir 12 mois nb days...
  // months 0..11 ??????
  if (ds[1] > 12) {
    return undefined;
  }
  if (ds[2] < 2000 || ds[2] > 3000) {
    return undefined;
  }
  var nDays = daysByMonth[d[1] - 1] + (d[1] === 2 && !(d[2] % 4));
  if (d[0] > nDays) {
    return undefined;
  }
  return !isNaN(Date.parse(ds[2] + "-" + ds[1] + "-" + ds[0])) ? new Date(ds[2] + "-" + ds[1].padStart(2, 0) + "-" + ds[0].padStart(2, 0)) : undefined;
};
// -------------------------------------------
//  key management
//  ------------------------------------------

var keyMap = {
  9: "Tab",
  13: "Enter",
  27: "Escape",
  32: "Space",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  107: "+",
  109: "-",
  187: "=",
  65: "a",
  70: "f",
  112: "f1",
  113: "f2",
  114: "f3",
  115: "f4",
  119: "f8",
  120: "f9",
  121: "f10",
  122: "f11",
  123: "f12",
  48: "0",
  96: "numpad0"
};

var isNavigationKey = function isNavigationKey(e) {
  var keyCode = e.which || e.keyCode;
  return keyCode >= 32 && keyCode < 41 || // space+arrows...
  keyCode === 9 || // tab
  keyCode === 27 || // escape
  keyCode === 13 || // enter
  keyCode === 65 && (e.metaKey || e.ctrlKey) // ctrl a
  ;
};
var isZoom = function isZoom(e) {
  var keyCode = e.which || e.keyCode;
  return (e.metaKey || e.ctrlKey) * (keyCode === 107 || keyCode === 187 || -(keyCode === 109));
};
//------------------------------------------------
// Copy, ...paste,export
// -----------------------------------------------
var copy = function copy(text) {
  try {
    var bodyElement = document.getElementsByTagName("body")[0];
    var clipboardTextArea = document.createElement("textarea");
    clipboardTextArea.style.position = "absolute";
    clipboardTextArea.style.left = "-10000px";
    bodyElement.appendChild(clipboardTextArea);
    clipboardTextArea.innerHTML = text;
    clipboardTextArea.select();
    window.setTimeout(function () {
      bodyElement.removeChild(clipboardTextArea);
    }, 0);
  } catch (error) {
    /* eslint-disable no-console */
    console.error("error during copy", error);
    /* eslint-enable */
  }
};

var functionsByObject = function functionsByObject(object, functions) {
  var f = functions[object];
  var f_ = [];
  Object.keys(f).forEach(function (type) {
    var tp = type.slice(0, type.length - 1);
    Object.keys(f[type]).forEach(function (code) {
      var functionJS = f[type][code];
      if (functionJS) {
        f_.push({
          id: code,
          visibility: object === "globals_" ? "global" : object,
          caption: code,
          tp: tp,
          functionJS: functionJS
        });
      }
    });
  });
  return f_;
};
var mergeFunctions = function mergeFunctions(functions, object) {
  var fg = {};
  var fl = {};
  (Array.isArray(functions) ? functions.filter(function (f) {
    return f !== undefined;
  }) : [functions || {}]).forEach(function (f) {
    if (f.globals_) {
      Object.keys(f.globals_).forEach(function (type) {
        Object.keys(f.globals_[type]).forEach(function (f_) {
          fg["global" + "--" + type + "--" + f_] = f.globals_[type][f_];
        });
      });
    }
    if (f[object]) {
      Object.keys(f[object]).forEach(function (type) {
        Object.keys(f[object][type]).forEach(function (f_) {
          if (f[object][type][f_]) {
            fl[object + "--" + type + "--" + f_] = f[object][type][f_];
            delete fg["global" + "--" + type + "--" + f_];
          }
        });
      });
    }
  });
  var fs = Object.assign({}, fg, fl);
  var ft = Object.keys(fs).map(function (key) {
    var ks = key.split("--");
    return {
      id: ks[2],
      caption: ks[2],
      visibility: ks[0],
      tp: ks[1].slice(0, ks[1].length - 1),
      functionJS: typeof fs[key] === "string" ? undefined : fs[key],
      functionText: typeof fs[key] === "string" ? fs[key] : undefined,
      isLocal: typeof fs[key] === "string"
    };
  });
  var localFunctions = ft.filter(function (f) {
    return f.isLocal;
  });
  var accessors = ft.reduce(function (acc, f) {
    acc[f.id] = f.functionJS;
    return acc;
  }, {});
  var accessor = function accessor(_accessor) {
    return accessors[_accessor];
  };

  localFunctions.forEach(function (f) {
    try {
      eval("f.functionJS = " + f.functionText);
    } catch (e) {
      f.functionJS = function () {};
    }
    if (f.tp === "accessor") {
      accessors[f.id] = f.functionJS;
    }
  });
  return ft;
  // return ft.reduce((acc, f) => {
  //   acc[f.id] = f;
  //   return acc;
  // }, {});
};
var functionsTable = function functionsTable(functions) {
  if (functions === undefined) {
    return [];
  }
  // if(Array.isArray(functions){functionsTable(mergeFunctions)}
  return Object.keys(functions).reduce(function (acc, object) {
    return acc.concat(functionsByObject(object, functions));
  }, []);
};
var getFunction = function getFunction(functions, type, value, utils) {
  if (typeof value === "function") {
    return value;
  } else if (typeof value === "string") {
    var indexDot = value.indexOf(".");
    if (indexDot !== -1) {
      var v = value;
      if (value.slice(0, indexDot) === "row") {
        v = value.slice(indexDot + 1);
      }
      var keys = v.split(".");
      return function (_ref4) {
        var row = _ref4.row;

        return keys.reduce(function (acc, key, index) {
          return acc[key] === undefined && index < keys.length - 1 ? {} : acc[key];
        }, row);
      };
    } else {
      var _v = typeof value === "string" ? functions.find(function (f) {
        return f.id === value && f.tp === type;
      }) : [];

      if (_v) {
        if (type === "accessor") {
          return function (message) {
            return _v.functionJS(Object.assign({}, message, { utils: utils }));
          };
        } else {
          return _v.functionJS;
        }
      } else if (type === "format") {
        return function (_ref5) {
          var value_ = _ref5.value;
          return formatValue(value_, value);
        };
      } else {
        return function (_ref6) {
          var row = _ref6.row;
          return row[value];
        };
      }
    }
  }
  if (type === "format") {
    return function (_ref7) {
      var value = _ref7.value;
      return formatValue(value);
    };
  }
};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getAxisActivatedMeasuresSelector; });
/* unused harmony export sortFunction */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildAxisTrees;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getAxisTreesSelector; });
/* unused harmony export columnAxisTreeSelector */
/* unused harmony export rowAxisTreeSelector */
/* unused harmony export sort */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAxisLeaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return rowLeavesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return columnLeavesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expandCollapseNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getExpandCollapseKeysSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleSortOrderSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dimensions_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_headers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_selector__ = __webpack_require__(55);
///////////////////////////////////////////////////////////////////
//  compute the axis header trees (rows and columns)
///////////////////////////////////////////////////////////////////
var getAxisActivatedMeasuresSelector=function getAxisActivatedMeasuresSelector(axisType){return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.measures;},function(state){return state.axis.measures;},function(state){return state.configuration.measureHeadersAxis;}],function(measures,axisMeasures,measureHeadersAxis){if(Object(__WEBPACK_IMPORTED_MODULE_4__constants__["G" /* toAxisType */])(measureHeadersAxis)===axisType){return axisMeasures.map(function(measure){return measures[measure];});}return null;});};///////////////////////////////////////////////////////////////////
// Axis trees
//////////////////////////////////////////////////////////////////
var sortFunction=function sortFunction(dimension){if(dimension.sort.custom){return function(a,b){return dimension.sort.custom(a.sortKey,b.sortKey);};}else{return function(a,b){return(a.sortKey>b.sortKey)-(b.sortKey>a.sortKey);};}};// add child node to a node
function buildNode(id,node,index,dimension){if(node.children[id]===undefined){var dimensionValue=dimension.values[id];node.children[id]={id:id,dimensionId:dimension.id,type:__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].DIMENSION,parent:node,children:dimension.last?null:{},dataRowIndexes:dimension.isAttribute?node.dataRowIndexes:[index],sortKey:dimensionValue.sortKey,caption:dimensionValue.caption,key:node.id===__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */]?""+id:node.key+"-/-"+id,depth:dimension.depth,isAttribute:dimension.isAttribute,attributeParentId:dimension.isAttribute?__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].isNullOrUndefined(node.attributeParentId)?node.id:node.attributeParentId:null,isTotal:0};}else if(!dimension.isAttribute){node.children[id].dataRowIndexes.push(index);}return node.children[id];}// build colums and rows trees
function buildAxisTrees(rowRoot,columnRoot,data,dimensions,offset){if(data.length===0){return{columns:null,rows:null};}// Create sorting accessors
var x=Date.now();// console.log("buildAxisTrees0", x, data.length);
var newValue=false,newRows=false,newColumns=false;data.forEach(function(row,index){var columnNode=columnRoot;var rowNode=rowRoot;dimensions.forEach(function(dimension){if(dimension.id!==__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* MEASURE_ID */]){var id=dimension.keyAccessor({row:row});var dimensionValue=dimension.values[id];if(!dimensionValue){dimensionValue={id:id,dimensionId:dimension.id,caption:dimension.labelAccessor({row:row}),sortKey:dimension.sort.keyAccessor({row:row}),rowIndexes:[index+offset],filtered:false};newValue=true;dimension.values[id]=dimensionValue;}else{dimension.values[id].rowIndexes.push(index+offset);}if(dimension.axis===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS){newRows=newRows||newValue;rowNode=buildNode(id,rowNode,index+offset,dimension);}else if(dimension.axis===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].COLUMNS){newColumns=newColumns||newValue;columnNode=buildNode(id,columnNode,index+offset,dimension);}newValue=false;}});});// console.log("buildAxisTrees", data.length, Date.now() - x, rowRoot);
return{columns:columnRoot,rows:rowRoot,dimensions:dimensions,newRows:newRows,newColumns:newColumns};}var getAxisTreesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;},__WEBPACK_IMPORTED_MODULE_1__dimensions_selector__["g" /* dimensionsWithAxisSelector */],function(state){return state.status.loadingConfig;}],function(data,dimensions,loadingConfig){if(!loadingConfig){var rowRoot={id:__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */],children:{},depth:-1,dimensionId:__WEBPACK_IMPORTED_MODULE_4__constants__["C" /* TOTAL_ID */],type:__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].MEASURE,key:__WEBPACK_IMPORTED_MODULE_4__constants__["C" /* TOTAL_ID */],caption:"Total"};var columnRoot=Object.assign({},rowRoot,{children:{}});return buildAxisTrees(rowRoot,columnRoot,data,dimensions.map(function(dimension){dimension.values={};dimension.sortFunction=sortFunction(dimension);return dimension;}),0);}else{return{};}});var columnAxisTreeSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAxisTreesSelector],function(axisTrees){return axisTrees.columns;});var rowAxisTreeSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAxisTreesSelector],function(axisTrees){return axisTrees.rows;});var sort=function sort(children,sortFunction,orderByAttribute){return children.sort(sortFunction).map(function(child){return child.isAttribute&&orderByAttribute?child.attributeParentId:child.id;});};var getFinalLeaves=function getFinalLeaves(node,measures,measuresCount,dimension,filteredIndexes,leaves){node.orderedChildren=[];// node.filteredIndexes = [];
if(node.type===__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].SUB_TOTAL){if(node.id===__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */]){node.depth=0;node.caption="Grand total";node.isTotal=2;}node.isVisible=!node.isParentCollapsed;node.nVisibles=node.isVisible*measuresCount;}// filtering
// when a filter is set on one or several not diplayed dimensions=> filter data indexes
// else filtering is made on leaves
if(!node.isTotal&&node.id!==__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */]&&filteredIndexes){node.filteredIndexes=node.dataRowIndexes.filter(function(index){return filteredIndexes.get(index);});}else{node.filteredIndexes=node.dataRowIndexes;}if(node.filteredIndexes&&!node.filteredIndexes.length){return 0;}if(measures){node.children={};measures.forEach(function(measure,index){node.children[measure.id]={id:measure.id,dimensionId:__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* MEASURE_ID */],type:__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].MEASURE,parent:node,children:{},orderedChildren:[],filteredIndexes:node.filteredIndexes,caption:measure.caption,key:node.key+"-/-"+measure.id,depth:node.depth+1,isAttribute:false,isVisible:node.isVisible,nVisibles:node.isVisible+0,isTotal:node.isTotal,isFiltered:node.isFiltered};node.orderedChildren.push(measure.id);leaves.push(node.children[measure.id]);});}else if(node.id===__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */]&&node.type!==__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].SUB_TOTAL){leaves.push(Object.assign({},node,{depth:0,parent:node}));node.orderedChildren.push(node.id);}else{leaves.push(node);}return node.isVisible*measuresCount;};var getAxisLeaves=function getAxisLeaves(axis,node,dimensions,measures,measuresCount,areCollapsed,subtotals,totalsFirst,filteredIndexes,first){var leaves=arguments.length>10&&arguments[10]!==undefined?arguments[10]:[];if(!node){return 0;}var nVisibles=0,subtotalNode=null;// last dimension
// add measures if needed
var dimension=dimensions[node.depth]||{};var nextDimension=dimensions[node.depth+1]||{};var isAttribute=node.depth!==-1?dimension.isAttribute:false;var parent=node.parent||{isVisible:true};node.isCollapsed=areCollapsed[node.key]||parent.isCollapsed&&isAttribute;node.isParentCollapsed=parent.isParentCollapsed||parent.isCollapsed&&!isAttribute;node.isVisible=parent.isVisible&&first||!node.isParentCollapsed;node.isFiltered=!dimension.filter||dimension.filter[node.id]!==undefined;node.filteredIndexes=[];//  totals
var totalKey=node.id===__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */]?Object(__WEBPACK_IMPORTED_MODULE_4__constants__["F" /* toAxis */])(axis)+__WEBPACK_IMPORTED_MODULE_4__constants__["C" /* TOTAL_ID */]:dimension.id;if(nextDimension.id!==undefined&&subtotals[totalKey]&&!dimension.isAttribute&&node.isFiltered){subtotalNode=Object.assign({},node,{isCollapsed:true,type:__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].SUB_TOTAL,key:__WEBPACK_IMPORTED_MODULE_4__constants__["C" /* TOTAL_ID */]+"-/-"+node.key,caption:"Total "+node.caption,children:[],orderedChildren:[],isTotal:1});if(totalsFirst){// push subtotals or grand total
subtotalNode.nVisibles=getFinalLeaves(subtotalNode,measures,measuresCount,dimension,filteredIndexes,leaves);}}node.subtotal=subtotalNode;if(nextDimension.id!==undefined&&node.isFiltered){var children=Object.values(node.children),sortDimension=nextDimension;if(nextDimension.orderBy!==undefined&&nextDimension.orderBy!==nextDimension.depth){sortDimension=dimensions[nextDimension.orderBy];children=Object(__WEBPACK_IMPORTED_MODULE_3__utils_headers__["a" /* getLeaves */])(node,[],nextDimension.orderBy,true);}children=sort(children,sortDimension.sortFunction,sortDimension!==nextDimension);//  recursive loop on ordered children
var _first=true;children=children.map(function(id,index){var child=node.children[id];var nVisibles=getAxisLeaves(axis,child,dimensions,measures,measuresCount,areCollapsed,subtotals,totalsFirst,filteredIndexes,_first,leaves);if(nVisibles){_first=false;}return{id:id,nVisibles:nVisibles,filteredIndexes:child.filteredIndexes,isFiltered:child.isFiltered};});// ! orders must include collapsed nodes but exclude nodes without child
children=children.filter(function(child){return child.isFiltered&&(!nextDimension.filter||nextDimension.filter[child.id]!==undefined);});children=children.map(function(child){nVisibles+=child.nVisibles;// node.filteredIndexes.push(...child.filteredIndexes);
node.filteredIndexes=node.filteredIndexes.concat(child.filteredIndexes);return child.id;});if(!filteredIndexes&&node.dataRowIndexes&&nVisibles){node.filteredIndexes=node.dataRowIndexes;}node.filteredIndexes.sort(function(a,b){return a-b;});if(!node.orders){node.orders={};}node.orders[sortDimension.id]=children;node.orderedChildren=node.orders[sortDimension.id];}if(nextDimension.id===undefined&&node.isFiltered){// push terminal leaves or, if measures are on the axis,1 leave per measure
nVisibles=getFinalLeaves(node,measures,measuresCount,dimension,filteredIndexes,leaves);}if(node.filteredIndexes&&!node.filteredIndexes.length){node.isVisible=false;node.nVisibles=0;node.isFiltered=false;}if(subtotalNode&&node.isVisible&&!totalsFirst){// push subtotals or grand total
subtotalNode.nVisibles=getFinalLeaves(subtotalNode,measures,measuresCount,dimension,filteredIndexes,leaves);}if(subtotalNode){subtotalNode.filteredIndexes=node.filteredIndexes;subtotalNode.isFiltered=node.isFiltered;if(!node.isFiltered){subtotalNode.isVisible=false;subtotalNode.nVisibles=0;}}node.nVisibles=nVisibles;return nVisibles+(subtotalNode!==null?subtotalNode.nVisibles:0);};var rowLeavesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([rowAxisTreeSelector,__WEBPACK_IMPORTED_MODULE_1__dimensions_selector__["g" /* dimensionsWithAxisSelector */],getAxisActivatedMeasuresSelector(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS),function(state){return state.collapses.configurationRows;},function(state){return state.filters;},function(state){return state.subtotals;},function(state){return state.configuration.totalsFirst;},function(state){return state.status.loadingConfig;},__WEBPACK_IMPORTED_MODULE_5__data_selector__["b" /* filteredIndexesSelector */]],function(node,dimensions,measures,areCollapsed,filters,subtotals,totalsFirst,loadingConfig,filteredIndexes){if(!loadingConfig){// console.log("rowleaves", dimensions);
// no measures on measure axis
if(measures!==null&&measures.length===0){return{nVisibles:0,node:node,leaves:[]};}var x=Date.now();var leaves=[];var nVisibles=void 0;if(node){var axisDimensions=dimensions.filter(function(dimension){return dimension.axis===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS;}).map(function(dimension){dimension.filter=(filters[dimension.id]||{values:null}).values;return dimension;});nVisibles=getAxisLeaves(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS,node,axisDimensions,measures,measures===null?1:measures.length,areCollapsed,subtotals,totalsFirst,filteredIndexes,true,leaves);node.nVisibles=nVisibles;}// console.log("rowleavesend");
return{nVisibles:nVisibles,node:node,leaves:totalsFirst?leaves.filter(function(leaf){return leaf.isFiltered;}):leaves};}else{return{};}});var columnLeavesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([columnAxisTreeSelector,__WEBPACK_IMPORTED_MODULE_1__dimensions_selector__["g" /* dimensionsWithAxisSelector */],getAxisActivatedMeasuresSelector(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].COLUMNS),function(state){return state.collapses.configurationColumns;},function(state){return state.filters;},function(state){return state.subtotals;},function(state){return state.configuration.totalsFirst;},function(state){return state.status.loadingConfig;},__WEBPACK_IMPORTED_MODULE_5__data_selector__["b" /* filteredIndexesSelector */]],function(node,dimensions,measures,areCollapsed,filters,subtotals,totalsFirst,loadingConfig,filteredIndexes){if(!loadingConfig){// console.log("columnleaves", dimensions);
// no measures on measure axis
if(measures!==null&&measures.length===0){return{nVisibles:0,node:node,leaves:[]};}var x=Date.now();var leaves=[];var nVisibles=void 0;if(node){var axisDimensions=dimensions.filter(function(dimension){return dimension.axis===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].COLUMNS;}).map(function(dimension){dimension.filter=(filters[dimension.id]||{values:null}).values;return dimension;});nVisibles=getAxisLeaves(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].COLUMNS,node,axisDimensions,measures,measures===null?1:measures.length,areCollapsed,subtotals,totalsFirst,filteredIndexes,true,leaves);node.nVisibles=nVisibles;}// console.log("columnleavesEnd");
return{nVisibles:nVisibles,node:node,leaves:totalsFirst?leaves.filter(function(leaf){return leaf.isFiltered;}):leaves};}else{return{};}});var parentsVisibles=function parentsVisibles(node,nVisibles){node.nVisibles+=nVisibles;if(node.id!==__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */]){parentsVisibles(node.parent,nVisibles);}};var childrenVisibles=function childrenVisibles(node,measuresCount){var children=Object.values(node.children||{}).filter(function(child){return child.isFiltered;});if(children.length){var index=0;var n=children.reduce(function(n,child){var nCells=child.dimensionId===__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* MEASURE_ID */]?measuresCount:1;var isCollapsed=node.isParentCollapsed||node.isCollapsed&&!child.isAttribute;child.isVisible=node.isVisible&&index<nCells||!isCollapsed;child.isCollapsed=child.isAttribute?node.isCollapsed:child.isCollapsed;child.isParentCollapsed=isCollapsed;var n2=childrenVisibles(child,measuresCount);if(n2){index++;}if(child.subtotal){child.subtotal.isVisible=!child.isParentCollapsed;child.subtotal.nVisibles=child.subtotal.isVisible*measuresCount;n+=child.subtotal.nVisibles;}return n+n2;},0);return n;}else{node.nVisibles=1;return node.isVisible+0;}};var expandCollapseNode=function expandCollapseNode(node,isCollapsed,measuresCount){var nVisibles=node.nVisibles;// mutate the headers
if(isCollapsed!==undefined&&isCollapsed===node.isCollapsed){return 0;}node.isCollapsed=isCollapsed===undefined?!node.isCollapsed:isCollapsed;node.nVisibles=childrenVisibles(node,measuresCount);parentsVisibles(node.parent,node.nVisibles-nVisibles);return node.nVisibles-nVisibles;};var expandCollapseAll=function expandCollapseAll(node,depth,isCollapsed,measuresCount){var leaves=Object(__WEBPACK_IMPORTED_MODULE_3__utils_headers__["a" /* getLeaves */])(node,[],depth);var keys=leaves.reduce(function(acc,leaf){acc.n+=expandCollapseNode(leaf,isCollapsed,measuresCount);acc.keys[leaf.key]=isCollapsed;return acc;},{n:0,keys:{}});return keys;};var getExpandCollapseKeysSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([rowAxisTreeSelector,columnAxisTreeSelector,getAxisActivatedMeasuresSelector(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS),getAxisActivatedMeasuresSelector(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].COLUMNS)],function(rowAxisTree,columnAxisTree,rowMeasures,columnMeasures){return function(axisType,depth,isCollapsed){var measures=axisType===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS?rowMeasures:columnMeasures;return expandCollapseAll(axisType===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS?rowAxisTree:columnAxisTree,depth,isCollapsed,measures===null?1:measures.length);};});var sortNode=function sortNode(node,dimensionId,depth,sortFunction){var orders=node.orders[dimensionId];if(orders){orders.reverse();}else{var orderedChildren=Object(__WEBPACK_IMPORTED_MODULE_3__utils_headers__["a" /* getLeaves */])(node,[],depth,true);orderedChildren.sort(sortFunction);orders=orderedChildren.map(function(child){return child.isAttribute?child.attributeParentId:child.id;});node.orders[dimensionId]=orders;}node.orderedChildren=orders;};var toggleSortOrderSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([rowLeavesSelector,columnLeavesSelector,__WEBPACK_IMPORTED_MODULE_1__dimensions_selector__["i" /* rowVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_1__dimensions_selector__["e" /* columnVisibleDimensionsSelector */],function(state){return state.configuration.totalsFirst;}],function(rowLeaves,columnLeaves,rowDimensions,columnDimensions,totalsFirst){return function(axis,depth){var dimensions=axis===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS?rowDimensions:columnDimensions;var dimension=dimensions[depth];var sortingDepth=depth-1;var sortFct=sortFunction(dimension);if(dimension.isAttribute){while(dimensions[sortingDepth].id!==dimension.isAttributeOf){sortingDepth--;}sortingDepth--;}dimensions[sortingDepth+1].orderBy=dimension.depth;if(dimension.id!==__WEBPACK_IMPORTED_MODULE_4__constants__["C" /* TOTAL_ID */]&&dimension.id!==__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* MEASURE_ID */]){var leaves=axis===__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* AxisType */].ROWS?rowLeaves:columnLeaves;var _sort=dimension.sort;if(_sort.direction==="desc"){_sort.direction="asc";}else{_sort.direction="desc";}var sortedLeaves=Object(__WEBPACK_IMPORTED_MODULE_3__utils_headers__["a" /* getLeaves */])(leaves.node,[],sortingDepth,true);sortedLeaves.map(function(node){return sortNode(node,dimension.id,depth,sortFct);});leaves.leaves=Object(__WEBPACK_IMPORTED_MODULE_3__utils_headers__["a" /* getLeaves */])(leaves.node,[],undefined,false,totalsFirst||false);}};});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export keyToIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLeaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetLeaves; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return resetDimensions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var findHeader=function findHeader(headers,keys){if(keys.length===1){return headers.find(function(header){return header.key===keys[0];});}var parentHeader=headers.find(function(header){return header.key===keys[0];});if(!parentHeader)throw new Error("header not found");return findHeader(parentHeader.children,[[keys[0],keys[1]].join(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* KEY_SEPARATOR */])].concat(_toConsumableArray(keys.slice(2))));};var keyToIndex=function keyToIndex(headers,key){var keys=key.split(__WEBPACK_IMPORTED_MODULE_0__constants__["k" /* KEY_SEPARATOR */]);var depth=headers[0].length;var ancestorHeaders=headers.filter(function(headersRow){return headersRow.length===depth;}).map(function(headersRow){return headersRow[0];});try{return findHeader(ancestorHeaders,keys).x;}catch(e){// console.error(`Header with key ${key} not found in following headers`, headers);
return-1;}};var getLeaves=function getLeaves(node){var acc=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var depth=arguments[2];var notSorted=arguments[3];var totalsFirst=arguments[4];if(// isNullOrUndefined(node.orderedChildren) ||
node.depth===(depth===undefined?10000:depth)||(node.id!==__WEBPACK_IMPORTED_MODULE_0__constants__["q" /* ROOT_ID */]||node.dimensionId===__WEBPACK_IMPORTED_MODULE_0__constants__["C" /* TOTAL_ID */]&&node.isVisible)&&depth===undefined&&node.orderedChildren.length===0){acc.push(node);return acc;}if(notSorted){Object.values(node.children).filter(function(node){return node.isFiltered;}).map(function(node){return getLeaves(node,acc,depth,notSorted);});}else{if(totalsFirst&&node.subtotal){getLeaves(node.subtotal,acc);}node.orderedChildren.map(function(key){return getLeaves(node.children[key],acc,depth,notSorted,totalsFirst);});if(totalsFirst===false&&node.subtotal){getLeaves(node.subtotal,acc);}}return acc;};var resetLeaves=function resetLeaves(node){Object.values(node.children).map(function(child){return resetLeaves(child);});if(node.subtotal){resetLeaves(node.subtotal);}node.children=null;node.subtotal=null;node.dataRowIndexes=null;node.orderedChildren=null;node.filteredIndexes=null;node.dataIndexes=null;if(node.orders){Object.keys(node.orders).map(function(key){return node.orders[key]=null;});}node.orders=null;// node.parent = null;
node.options=null;node.sizes=null;node=undefined;return null;};var resetDimensions=function resetDimensions(dimensions){return Object.values(dimensions).forEach(function(dimension){Object.values(dimension.values).forEach(function(value){value.rowIndexes=null;value=null;});dimension=null;});};// calculate the union of two arrays (arg1 is the second array) or an array of arrays (arg0)
// export const union = (arg0, arg1) => {
//   if (arg1) {
//     return [...new Set(arg[0].concat)];
//   }
//   let res;
//   if (arg1) {
//     res = [...arg[0].concat(arg[1])];
//   } else {
//     res = arg0.reduce((acc, array) => {
//       if (!acc.length) {
//         acc = array || [];
//       } else {
//         acc = acc.concat(array);
//       }
//       return acc;
//     }, []);
//   }
//   res = [...new Set(res)];
//   // res.sort((a,b)=>);
//   return res;
// };
// // calculate the intersection of two arrays (arg1 is the second array) or an array of arrays (arg0)
// export const intersection = (arg0, arg1) => {
//   const intersection_ = (arg0, arg1) => {
//     if (utils.isUndefined(arg0)) {
//       return arg1;
//     } else if (utils.isUndefined(arg1)) {
//       return arg0;
//     } else {
//       const n = arg0.length;
//       const m = arg1.length;
//       let i = 0;
//       let j = 0;
//       const res = [];
//       while (i < n && j < m) {
//         if (arg0[i] > arg1[j]) {
//           j += 1;
//         } else if (arg0[i] < arg1[j]) {
//           i += 1;
//         } else {
//           res.push(arg0[i]);
//           i += 1;
//           j += 1;
//         }
//       }
//       return res;
//     }
//   };
//   if (arg1) {
//     return intersection_(arg0, arg1);
//   } else if (!arg0.length) {
//     return [];
//   } else if (arg0.length === 1) {
//     return arg0[0];
//   } else {
//     return arg0
//       .slice(1)
//       .reduce((acc, array) => intersection_(acc, array), arg0[0]);
//   }
// };
// export const hasIntersection = (arg0, arg1) => {
//   if (utils.isUndefined(arg0) || utils.isUndefined(arg1)) {
//     return true;
//   } else {
//     const n = arg0.length;
//     const m = arg1.length;
//     let i = 0;
//     let j = 0;
//     // const res = [];
//     while (i < n && j < m) {
//       if (arg0[i] > arg1[j]) {
//         j += 1;
//       } else if (arg0[i] < arg1[j]) {
//         i += 1;
//       } else {
//         return true;
//       }
//     }
//     return false;
//   }
// };

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(42),
    getRawTag = __webpack_require__(186),
    objectToString = __webpack_require__(187);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.beginDrag = beginDrag;
exports.publishDragSource = publishDragSource;
exports.hover = hover;
exports.drop = drop;
exports.endDrag = endDrag;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(12);

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = __webpack_require__(21);

var _isObject2 = _interopRequireDefault(_isObject);

var _matchesType = __webpack_require__(84);

var _matchesType2 = _interopRequireDefault(_matchesType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = exports.HOVER = 'dnd-core/HOVER';
var DROP = exports.DROP = 'dnd-core/DROP';
var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';

function beginDrag(sourceIds) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
	var publishSource = options.publishSource,
	    clientOffset = options.clientOffset,
	    getSourceClientOffset = options.getSourceClientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');

	for (var i = 0; i < sourceIds.length; i++) {
		(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	}

	var sourceId = null;
	for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
		if (monitor.canDragSource(sourceIds[_i])) {
			sourceId = sourceIds[_i];
			break;
		}
	}
	if (sourceId === null) {
		return;
	}

	var sourceClientOffset = null;
	if (clientOffset) {
		(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
		sourceClientOffset = getSourceClientOffset(sourceId);
	}

	var source = registry.getSource(sourceId);
	var item = source.beginDrag(monitor, sourceId);
	(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');

	registry.pinSource(sourceId);

	var itemType = registry.getSourceType(sourceId);
	return {
		type: BEGIN_DRAG,
		itemType: itemType,
		item: item,
		sourceId: sourceId,
		clientOffset: clientOffset,
		sourceClientOffset: sourceClientOffset,
		isSourcePublic: publishSource
	};
}

function publishDragSource() {
	var monitor = this.getMonitor();
	if (!monitor.isDragging()) {
		return;
	}

	return { type: PUBLISH_DRAG_SOURCE };
}

function hover(targetIdsArg) {
	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    _ref$clientOffset = _ref.clientOffset,
	    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
	var targetIds = targetIdsArg.slice(0);

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');

	// First check invariants.
	for (var i = 0; i < targetIds.length; i++) {
		var targetId = targetIds[i];
		(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');

		var target = registry.getTarget(targetId);
		(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
	}

	var draggedItemType = monitor.getItemType();

	// Remove those targetIds that don't match the targetType.  This
	// fixes shallow isOver which would only be non-shallow because of
	// non-matching targets.
	for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
		var _targetId = targetIds[_i2];
		var targetType = registry.getTargetType(_targetId);
		if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
			targetIds.splice(_i2, 1);
		}
	}

	// Finally call hover on all matching targets.
	for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
		var _targetId2 = targetIds[_i3];
		var _target = registry.getTarget(_targetId2);
		_target.hover(monitor, _targetId2);
	}

	return {
		type: HOVER,
		targetIds: targetIds,
		clientOffset: clientOffset
	};
}

function drop() {
	var _this = this;

	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');

	var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);

	targetIds.reverse();
	targetIds.forEach(function (targetId, index) {
		var target = registry.getTarget(targetId);

		var dropResult = target.drop(monitor, targetId);
		(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
		if (typeof dropResult === 'undefined') {
			dropResult = index === 0 ? {} : monitor.getDropResult();
		}

		_this.store.dispatch({
			type: DROP,
			dropResult: _extends({}, options, dropResult)
		});
	});
}

function endDrag() {
	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');

	var sourceId = monitor.getSourceId();
	var source = registry.getSource(sourceId, true);
	source.endDrag(monitor, sourceId);

	registry.unpinSource();

	return { type: END_DRAG };
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(29);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(195),
    getValue = __webpack_require__(199);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(31);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(212);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(49),
    isObjectLike = __webpack_require__(20);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addSource = addSource;
exports.addTarget = addTarget;
exports.removeSource = removeSource;
exports.removeTarget = removeTarget;
var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';

function addSource(sourceId) {
	return {
		type: ADD_SOURCE,
		sourceId: sourceId
	};
}

function addTarget(targetId) {
	return {
		type: ADD_TARGET,
		targetId: targetId
	};
}

function removeSource(sourceId) {
	return {
		type: REMOVE_SOURCE,
		sourceId: sourceId
	};
}

function removeTarget(targetId) {
	return {
		type: REMOVE_TARGET,
		targetId: targetId
	};
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = checkDecoratorArguments;
function checkDecoratorArguments(functionName, signature) {
	if (false) {
		for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
			var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
			if (arg && arg.prototype && arg.prototype.render) {
				// eslint-disable-next-line no-console
				console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
				return;
			}
		}
	}
}

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEASURE_ID", function() { return MEASURE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOTAL_ID", function() { return TOTAL_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KEY_SEPARATOR", function() { return KEY_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AXIS_SEPARATOR", function() { return AXIS_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ROOT_ID", function() { return ROOT_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EMPTY_ID", function() { return EMPTY_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollbarSize", function() { return ScrollbarSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderType", function() { return HeaderType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AxisType", function() { return AxisType; });
/* harmony export (immutable) */ __webpack_exports__["toAxis"] = toAxis;
/* harmony export (immutable) */ __webpack_exports__["toAxisType"] = toAxisType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_DIMENSIONS", function() { return SET_DIMENSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_MEASURES", function() { return SET_MEASURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_CONFIG_PROPERTY", function() { return SET_CONFIG_PROPERTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_MEASURE", function() { return TOGGLE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOVE_MEASURE", function() { return MOVE_MEASURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MOVE_DIMENSION", function() { return MOVE_DIMENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_AXIS", function() { return SET_AXIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_DATA", function() { return FETCH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_FAILURE", function() { return FETCH_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PUSH_DATA", function() { return PUSH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FETCH_SUCCESS", function() { return FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOADING_CONFIG", function() { return LOADING_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE_SORT_ORDER", function() { return CHANGE_SORT_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ADD_FILTER", function() { return ADD_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DELETE_FILTER", function() { return DELETE_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_CELL_SIZE", function() { return UPDATE_CELL_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SIZES", function() { return SET_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZOOM_IN", function() { return ZOOM_IN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ZOOM_OUT", function() { return ZOOM_OUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPAND_COLLAPSE", function() { return EXPAND_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXPAND_COLLAPSE_ALL", function() { return EXPAND_COLLAPSE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_COLLAPSES", function() { return SET_COLLAPSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SELECT_RANGE", function() { return SELECT_RANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCROLL", function() { return SCROLL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOGGLE_SUBTOTAL", function() { return TOGGLE_SUBTOTAL; });
var MEASURE_ID = "__measures__";
var TOTAL_ID = "__total__";

var KEY_SEPARATOR = "-/-";
var AXIS_SEPARATOR = "-//-";

var ROOT_ID = "__ROOT_ID__";
var EMPTY_ID = "__EMPTY_ID__";
var ScrollbarSize = 12;
// Headers
var HeaderType = {
  MEASURE: 1, // measure header
  DIMENSION: 2, // dimension value (leaf)
  DIMENSION_HEADER: 3, // dimension header
  GRAND_TOTAL: 4,
  SUB_TOTAL: 5
};

// Axis
var AxisType = {
  COLUMNS: 1,
  ROWS: 2,
  MEASURE: 3,
  DIMENSION: 4,
  DATACELL: 5
};

function toAxis(axisType) {
  switch (axisType) {
    case AxisType.COLUMNS:
      return "columns";
    case AxisType.ROWS:
      return "rows";
    case AxisType.MEASURES:
      return "measures";
    case AxisType.DIMENSION:
      return "dimensions";
    default:
      return "__AXIS_TYPE_UNKNOWN__";
  }
}

function toAxisType(axis) {
  return AxisType[axis.toUpperCase()];
}

// ACTIONS

var SET_DIMENSIONS = "PIVOTGRID_SET_DIMENSIONS";
var SET_MEASURES = "PIVOTGRID_SET_MEASURES";
var SET_CONFIG_PROPERTY = "PIVOTGRID_SET_CONFIG_PROPERTY";
var TOGGLE_MEASURE = "PIVOTGRID_TOGGLE_MEASURE";
var MOVE_MEASURE = "PIVOTGRID_MOVE_MEASURE";
var MOVE_DIMENSION = "PIVOTGRID_MOVE_DIMENSION";
var SET_AXIS = "PIVOTGRID_SET_AXIS";

var FETCH_DATA = "PIVOTGRID_FETCH_DATA";
var FETCH_FAILURE = "PIVOTGRID_FETCH_FAILURE";
var PUSH_DATA = "PIVOTGRID_PUSH_DATA";
var FETCH_SUCCESS = "PIVOTGRID_FETCH_SUCCESS";
var LOADING_CONFIG = "PIVOTGRID_LOADING_CONFIG";

var CHANGE_SORT_ORDER = "PIVOTGRID_CHANGE_SORT_ORDER";

var ADD_FILTER = "PIVOTGRID_ADD_FILTER";
var DELETE_FILTER = "PIVOTGRID_DELETE_FILTER";

var UPDATE_CELL_SIZE = "PIVOTGRID_UPDATE_CELL_SIZE";
var SET_SIZES = "PIVOTGRID_SET_SIZES";

var ZOOM_IN = "PIVOTGRID_ZOOM_IN";
var ZOOM_OUT = "PIVOTGRID_ZOOM_OUT";

var EXPAND_COLLAPSE = "PIVOTGRID_EXPAND_COLLAPSE";
var EXPAND_COLLAPSE_ALL = "PIVOTGRID_EXPAND_COLLAPSE_ALL";
var SET_COLLAPSES = "PIVOTGRID_SET_COLLAPSES";

var SELECT_RANGE = "PIVOTGRID_SELECT_RANGE";
var SCROLL = "PIVOTGRID_SCROLL";
var TOGGLE_SUBTOTAL = "PIVOTGRID_TOGGLE_SUBTOTAL";

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__(60);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* unused harmony reexport applyMiddleware */
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(160);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(87),
    setCacheAdd = __webpack_require__(216),
    setCacheHas = __webpack_require__(217);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(218);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(88),
    isLength = __webpack_require__(92);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = isDisposable;

function isDisposable(obj) {
  return Boolean(obj && typeof obj.dispose === 'function');
}

module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = '__NATIVE_FILE__';
var URL = exports.URL = '__NATIVE_URL__';
var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MenuItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextualMenu; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContextualMenuClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MenuItem = function (_Component) {
	_inherits(MenuItem, _Component);

	function MenuItem() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, MenuItem);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MenuItem.__proto__ || Object.getPrototypeOf(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.handleMenuEvent = function (e) {
			e.preventDefault();
			_this.props.handleMenuEvent(e, _this.props.item);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(MenuItem, [{
		key: "render",
		value: function render() {
			var item = this.props.item;
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
				"zebulon-contextmenu-item": true,
				"zebulon-contextmenu-item-separation": item.separation,
				"zebulon-contextmenu-item-disable": item.disable,
				"zebulon-contextmenu-item-selected": item.opened || item.selected,
				"zebulon-contextmenu-item-checked": item.checked,
				"zebulon-contextmenu-sub-menu ": item.type === "sub-menu"
			});
			var check = item.checked ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				{ style: { marginRight: ".3em" } },
				"\u221A"
			) : null;
			var arrow = item.type === "sub-menu" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				{
					style: {
						marginLeft: ".3em",
						textAlign: "right"
					}
				},
				"\u203A"
			) : null;
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				{
					className: className,
					onClick: this.handleMenuEvent,
					onMouseOver: this.handleMenuEvent
				},
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					{
						style: {
							textAlign: "left",
							marginRight: ".5em",
							display: "flex"
						}
					},
					check,
					item.caption
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					{ style: { textAlign: "right", display: "flex" } },
					item.accelerator,
					arrow
				)
			);
		}
	}]);

	return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var MENU_EVENT = "MENU_EVENT";
var ContextualMenu = function (_Component2) {
	_inherits(ContextualMenu, _Component2);

	function ContextualMenu(props) {
		_classCallCheck(this, ContextualMenu);

		var _this2 = _possibleConstructorReturn(this, (ContextualMenu.__proto__ || Object.getPrototypeOf(ContextualMenu)).call(this, props));

		_this2.buildItems = function (items, style, level, handleMenuEvent, keyEvent) {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				{
					key: "group-" + level,
					className: "zebulon-contextmenu-group",
					style: style
				},
				items.map(function (item, index) {
					item.level = level;
					if (item.type === "jsx") {
						return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(item.content, {
							keyEvent: keyEvent,
							ref: function ref(_ref2) {
								return _this2.element = _ref2;
							}
						});
					} else {
						return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuItem, {
							key: "item-" + item.id,
							item: item,
							handleMenuEvent: handleMenuEvent
						});
					}
				})
			);
		};

		_this2.buildMenu = function (menu, top, left, handleEvent, keyEvent) {
			if (menu && menu.visible) {
				var opened = 0,
				    level = 0,
				    groupTop = 0;
				var item = menu,
				    groups = [];
				var style = {
					position: "absolute",
					top: top,
					left: left,
					display: "flex"
				};
				while (opened >= 0) {
					groupTop += opened * 24;
					var group = _this2.buildItems(item.children, {
						position: "relative",
						top: groupTop // a voir 24 pour prendre en compte le padding 2
					}, level, handleEvent, keyEvent);
					groups.push(group);
					level++;
					opened = item.children.findIndex(function (child) {
						return child.opened;
					});
					if (opened !== -1) {
						item = item.children[opened];
					}
				}
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					{ id: "contextual-menu", style: style },
					groups
				);
			} else {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
					id: "contextual-menu",
					style: { height: 0, width: 0, position: "relative" }
				});
			}
		};

		_this2.close = function () {
			_this2.setState({ menu: null });
		};

		_this2.handleEvent = function (e) {
			var _e$detail = e.detail,
			    position = _e$detail.position,
			    menu = _e$detail.menu,
			    data = _e$detail.data,
			    component = _e$detail.component;

			if (component === _this2.state.component) {
				var rect = _this2.div.getBoundingClientRect();
				position.y -= rect.top;
				position.x -= rect.left;
				var menu_ = _this2.props.getMenu(menu, data);
				if (menu_) {
					menu_.visible = true;
					_this2.setState({ menu: menu_, data: data, position: position });
				}
			}
		};

		_this2.handleMenuEvent = function (e, item, data) {
			if (e.type === "click" && !item.disable) {
				if (item.type === "sub-menu" && item.children && item.children.length) {
					item.opened = !item.opened;
					_this2.navigation = false;
					if (item.opened) {
						if (_this2.openedLevel[item.level] && _this2.openedLevel[item.level].id !== item.id) {
							_this2.openedLevel[item.level].opened = false;
						}
						_this2.openedLevel[item.level] = item;
						if (item.children[0].type === "jsx") {
							_this2.navigation = item.children[0].navigation;
						}
					} else {
						_this2.openedLevel[item.level] = undefined;
					}
					_this2.setState({ menu: _this2.state.menu });
				} else if (item.onClick) {
					var menuItem = item.onClick(_this2.state.data, item);
					if (item.type === "sub-menu" && menuItem && menuItem["$$typeof"].toString() === "Symbol(react.element)") {
						var newItem = {
							type: "jsx",
							level: item.level + 1,
							content: menuItem,
							navigation: true
						};
						item.children.push(newItem);
						_this2.openedLevel[item.level] = newItem;
						item.opened = true;
						_this2.setState({ menu: _this2.state.menu });
					} else {
						_this2.close();
					}
				}

				// console.log("internal menu event", e.target, item);
			} else if (e.type === "mouseover" && _this2.hoveredItem.id !== item.id && !item.disable) {
				_this2.hoveredItem.selected = false;
				_this2.hoveredItem = item;
				item.selected = true;
				_this2.setState({ menu: _this2.state.menu });
			}
		};

		_this2.handleKeyDown = function (e, item) {
			// console.log("keydown menu event", e.key, this.element);
			// if (this.element) {
			// 	console.log("keydown menu event1", e.key, this.element.values);
			// }
			if (_this2.state.menu.visible) {
				// escape
				if (e.which === 27) {
					e.preventDefault();
					_this2.close();
					return true;
				}
				if (_this2.navigation && e.key === "Tab") {
					return true;
				}
				_this2.setState({ keyEvent: e });
			}
		};

		_this2.state = {
			menu: null,
			component: props.component,
			position: { x: 0, y: 0 }
		};
		_this2.openedLevel = {};
		_this2.hoveredItem = {};
		return _this2;
	}

	_createClass(ContextualMenu, [{
		key: "componentDidMount",
		value: function componentDidMount() {
			window.addEventListener("MENU_EVENT", this.handleEvent);
			this.div = document.getElementById(this.state.component);
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			window.removeEventListener("MENU_EVENT", this.handleEvent);
		}
	}, {
		key: "render",
		value: function render() {
			if (this.state.menu) {
				return this.buildMenu(this.state.menu, this.state.position.y, this.state.position.x, this.handleMenuEvent, this.state.keyEvent);
			}
			return null;
		}
	}]);

	return ContextualMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ContextualMenuClient = function (_Component3) {
	_inherits(ContextualMenuClient, _Component3);

	function ContextualMenuClient() {
		var _ref3;

		var _temp2, _this3, _ret2;

		_classCallCheck(this, ContextualMenuClient);

		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = ContextualMenuClient.__proto__ || Object.getPrototypeOf(ContextualMenuClient)).call.apply(_ref3, [this].concat(args))), _this3), _this3.onContextMenu = function (e) {
			if (e.button === 2) {
				e.preventDefault();
				e.persist();
				var event = new CustomEvent(MENU_EVENT, {
					detail: {
						component: _this3.props.component,
						ref: _this3.ref,
						position: { x: e.clientX, y: e.clientY },
						menu: _this3.props.menu,
						data: _this3.props.collect ? _this3.props.collect(_this3.props) : _this3.props
					}
				});
				window.dispatchEvent(event);
				return true;
			}
		}, _temp2), _possibleConstructorReturn(_this3, _ret2);
	}

	_createClass(ContextualMenuClient, [{
		key: "render",
		value: function render() {
			var _this4 = this;

			var props = Object.assign({}, this.props);
			var children = props.children;
			delete props.children;
			delete props.collect;

			return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				{
					onContextMenu: this.props.menu ? this.onContextMenu : undefined,
					ref: function ref(_ref4) {
						return _this4.ref = _ref4;
					}
				},
				children
			), props);
		}
	}]);

	return ContextualMenuClient;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filteredIndexes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataFilteredIndexes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notVisibleFiltersSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filteredIndexesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getDimensionValuesSelector; });
/* unused harmony export dimensionFiltersSelector */
/* unused harmony export indexedRowsSelector */
/* unused harmony export computeData */
/* unused harmony export metaSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dimensions_selector__ = __webpack_require__(9);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};// import { utils.intersection } from "../utils/headers";
var filteredIndexes=function filteredIndexes(dimensions,filters,loading){if(loading){return undefined;}// const y = Date.now();
if(filters.length){var _filteredIndexes=filters.map(function(filter){var dimension=dimensions[filter.dimensionId];var dimensionIndexes=[];if(!dimension.axis){dimensionIndexes=Object.values(dimension.values).reduce(function(indexes,value){if(filter.values[value.id]!==undefined){indexes=indexes.concat(value.rowIndexes);}return indexes;},[]);}return dimensionIndexes.sort(function(a,b){return a-b;});});var x=new Map(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].intersection(_filteredIndexes).map(function(index){return[index,true];}));return x;}else{return undefined;}};var dataFilteredIndexes=function dataFilteredIndexes(data,filters,dimensions,filteredIndexes,offset){data.forEach(function(row,index){if(filters.every(function(filter){return filter.values[dimensions[filter.dimensionId].keyAccessor({row:row})]!==undefined;})){// console.log("new index", index);
filteredIndexes.set(index+offset,true);}});};var notVisibleFiltersSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["b" /* availableDimensionsSelector */],function(state){return state.filters;}],function(dimensions,filters){return dimensions.map(function(dimension){return filters[dimension.id];}).filter(function(filter){return filter;});});var filteredIndexesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.dimensions;},notVisibleFiltersSelector,function(state){return state.status.loading;}],filteredIndexes);var getDimensionValuesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;},function(state){return state.dimensions;}],function(data,dimensions){return function(id){if(id===__WEBPACK_IMPORTED_MODULE_2__constants__["C" /* TOTAL_ID */]||id===__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]){return[];}var dimension=dimensions[id];var values={};// We use data here instead of filteredData
// Otherwise you lose the filtered values the next time you open a Filter Panel
for(var i=0;i<data.length;i+=1){var row=data[i];var key=dimension.keyAccessor({row:row});if(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isUndefined(values[key])){var label=dimension.format({value:dimension.labelAccessor({row:row})});var sortKey=dimension.sort.keyAccessor({row:row});values[key]={id:key,label:label,sortKey:sortKey};}}values=Object.keys(values).map(function(key){return values[key];});var sortFunction=void 0;if(dimension.sort.custom){sortFunction=function sortFunction(a,b){return dimension.sort.custom(a.sortKey,b.sortKey);};}else{sortFunction=function sortFunction(a,b){return(a.sortKey>b.sortKey)-(b.sortKey>a.sortKey);};}values.sort(sortFunction);return values;};});var dimensionFiltersSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.filters;}],function(filters){return function(dimensionId){return filters[dimensionId];};});var indexedRowsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;}],function(data){return data.map(function(row,index){row.index_=index;return row;});});var computeData=function computeData(data,meta){var metaFormula=meta.filter(function(column){return column.tp==="Computed";}).forEach(function(column){return column.f=eval("(row)=>"+column.formula);});data.forEcach(function(row){return metaFormula.forEach(function(column){return row[column.id]=column.f(row);});});};var metaSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;},function(state){return state.data.meta;}],function(data,meta,configurationFunctions){var position=0;if(!meta&&data.length){var row=data[0];return Object.keys(row).map(function(key,index){var dataType=_typeof(row[key]),filterType="";if(dataType==="object"&&__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isDate(row[key])){dataType="date";// format = dateToString;
}var alignement="unset";if(dataType==="string"){alignement="left";}else if(dataType==="number"){alignement="right";filterType="between";}else if(dataType==="date"){alignement="center";filterType="between";}var width=100;var meta={id:key,caption:key,tp:"Initial",width:width,dataType:dataType,alignement:alignement,position:position,index_:index,formatFunction:function formatFunction(_ref){var value=_ref.value;return value;},filterType:filterType,v:null,vTo:null};position+=width;return meta;});}else{return meta;}});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultCellSizesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCellHeightByKeySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCellWidthByKeySelector; });
/* unused harmony export getRowHeightSelector */
/* unused harmony export getColumnWidthSelector */
/* unused harmony export getColumnDimensionHeightSelector */
/* unused harmony export getRowDimensionWidthSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return crossPositionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return crossRowPositionsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return crossColumnPositionsSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axis_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dimensions_selector__ = __webpack_require__(9);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}///////////////////////////////////////////////////////////////////
//  cell sizes by key (or row index or column index) selectors
//  cross dimensions sizes selector
///////////////////////////////////////////////////////////////////
var defaultCellSizesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.configuration.cellHeight;},function(state){return state.configuration.cellWidth;},function(state){return state.configuration.zoom;}],function(cellHeight,cellWidth,zoom){return{height:zoom*(cellHeight||25),width:zoom*(cellWidth||100),zoom:zoom};});var getCellHeightByKeySelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([defaultCellSizesSelector,function(state){return state.sizes.heights;}],function(defaultSizes,heights){return function(key){return defaultSizes.zoom*heights[key]||defaultSizes.height;};});var getCellWidthByKeySelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([defaultCellSizesSelector,function(state){return state.sizes.widths;}],function(defaultSizes,widths){return function(key){return defaultSizes.zoom*widths[key]||defaultSizes.width;};});//-------------------------------------------
var getRowHeightSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCellHeightByKeySelector,__WEBPACK_IMPORTED_MODULE_2__axis_selector__["h" /* rowLeavesSelector */]],function(getCellHeightByKeySelector,rowLeaves){return function(_ref){var index=_ref.index;return getCellHeightByKeySelector(rowLeaves[index].key);};});//-------------------------------------------
var getColumnWidthSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCellWidthByKeySelector,__WEBPACK_IMPORTED_MODULE_2__axis_selector__["b" /* columnLeavesSelector */]],function(getCellWidthByKeySelector,columnLeaves){return function(_ref2){var index=_ref2.index;return getCellWidthByKeySelector(columnLeaves[index].key);};});//-------------------------------------------
var getColumnDimensionHeightSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCellHeightByKeySelector,__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["d" /* columnDimensionsSelector */]],function(getCellHeightByKey,columnDimensions){return function(_ref3){var index=_ref3.index;return getCellHeightByKey(columnDimensions[index].id);};});//-------------------------------------------
var getRowDimensionWidthSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCellWidthByKeySelector,__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["h" /* rowDimensionsSelector */]],function(getCellWidthByKey,rowDimensions){return function(_ref4){var index=_ref4.index;return getCellWidthByKey(rowDimensions[index].id);};});//-------------------------------------------
var calculateCrossPositions=function calculateCrossPositions(dimensions,getCellSizeByKey){var res={};var position=0;// Total header if no dimensions
// if (!dimensions.length) {
//   position += getCrossSize(axisType, TOTAL_ID);
// } else {
// console.log("crosspositions", dimensions);
if(dimensions.length===0){res[__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* TOTAL_ID */]]={position:position,size:getCellSizeByKey(__WEBPACK_IMPORTED_MODULE_1__constants__["C" /* TOTAL_ID */])};}else{dimensions.forEach(function(dimension){var size=dimension.isVisible*getCellSizeByKey(dimension.id);res[dimension.id]={position:position,size:size};position+=dimension.isVisible*size;});}return res;};var crossPositionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getCellWidthByKeySelector,getCellHeightByKeySelector,__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["e" /* columnVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["i" /* rowVisibleDimensionsSelector */]],function(getCellWidthByKey,getCellHeightByKey,columnDimensions,rowDimensions){var _ref5;return _ref5={},_defineProperty(_ref5,__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].COLUMNS,calculateCrossPositions(columnDimensions,getCellHeightByKey)),_defineProperty(_ref5,__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].ROWS,calculateCrossPositions(rowDimensions,getCellWidthByKey)),_ref5;});var crossRowPositionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["e" /* columnVisibleDimensionsSelector */],getCellHeightByKeySelector],calculateCrossPositions);// (columnDimensions,getCellHeightByKey) =>   )
var crossColumnPositionsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["i" /* rowVisibleDimensionsSelector */],getCellWidthByKeySelector],calculateCrossPositions);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getElementsToPaste; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return exportFile; });
/* unused harmony export getFileObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(5);
// import { FileSaver } from "file-saver";
function replaceNullAndUndefined(val){if(val===null||val===undefined){return"";}return JSON.stringify(val);}var getElementsToPaste=function getElementsToPaste(_ref){var rowLeaves=_ref.rowLeaves,columnLeaves=_ref.columnLeaves,measures=_ref.measures,getCellValue=_ref.getCellValue,buidData=_ref.buidData,clipboard=_ref.clipboard,cell=_ref.cell;try{var columnIndex=cell.columnIndex,rowIndex=cell.rowIndex;var lines=clipboard.replace("\r","").split("\n");lines.pop();var cells=lines.map(function(line){return line.split("\t");});var nRows=lines.length,nColumns=cells[0].length;var iRow=0,iColumn=0,measure=void 0,data=[];while(iRow<nRows&&iRow<rowLeaves.leaves.length){var rowLeaf=rowLeaves.leaves[rowIndex];if(rowLeaf.isVisible){if(rowLeaf.dimensionId===__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* MEASURE_ID */]){measure=measures[rowLeaf.id];}while(iColumn<nColumns&&iColumn<columnLeaves.leaves.length){var columnLeaf=columnLeaves.leaves[columnIndex];if(columnLeaf.isVisible){if(columnLeaf.dimensionId===__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* MEASURE_ID */]){measure=measures[columnLeaf.id];}var oldValue=getCellValue(measure.valueAccessor,rowLeaf.dataIndexes,columnLeaf.dataIndexes,measure.aggregation).value,newValue=cells[iRow][iColumn]===""?null:Number(cells[iRow][iColumn]);if(isNaN(newValue)){console.log("not numeric data",cells[iRow][iColumn]);return[];}data.push(buidData(rowLeaf,columnLeaf,oldValue,newValue));iColumn++;}columnIndex++;}iRow++;iColumn=0;columnIndex=cell.columnIndex;}rowIndex++;}return data;}catch(error){/* eslint-disable no-console */console.error("error during copy",error);return[];/* eslint-enable */}};var getSelectedElements=function getSelectedElements(_ref2){var range=_ref2.range,rowLeaves=_ref2.rowLeaves,columnLeaves=_ref2.columnLeaves,rowDimensions=_ref2.rowDimensions,columnDimensions=_ref2.columnDimensions,measures=_ref2.measures,measureHeadersAxis=_ref2.measureHeadersAxis,getCellValue=_ref2.getCellValue,getCellDimensionInfos=_ref2.getCellDimensionInfos;// const mc = measureHeadersAxis === "columns";
// const mr = measureHeadersAxis === "rows";
// Build headers array
var selectedRowLeaves=rowLeaves.leaves,selectedColumnLeaves=columnLeaves.leaves;if(range){var _selectedRowLeaves,_selectedColumnLeaves;var rowsRange=[Math.min(range.start.rows,range.end.rows),Math.max(range.start.rows,range.end.rows)+1];selectedRowLeaves=(_selectedRowLeaves=selectedRowLeaves).slice.apply(_selectedRowLeaves,rowsRange);var columnsRange=[Math.min(range.start.columns,range.end.columns),Math.max(range.start.columns,range.end.columns)+1];selectedColumnLeaves=(_selectedColumnLeaves=selectedColumnLeaves).slice.apply(_selectedColumnLeaves,columnsRange);}selectedRowLeaves=selectedRowLeaves.filter(function(leaf){return leaf.isVisible;});selectedColumnLeaves=selectedColumnLeaves.filter(function(leaf){return leaf.isVisible;});// get rows captions
var rows=selectedRowLeaves.map(function(leaf){leaf.dataIndexes=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["t" /* getFilteredIndex */])(leaf);return getCellDimensionInfos(rowDimensions,"rows",leaf,measures,[]);});// get columns captions
var columns=selectedColumnLeaves.map(function(leaf){leaf.dataIndexes=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["t" /* getFilteredIndex */])(leaf);return getCellDimensionInfos(columnDimensions,"columns",leaf,measures,[]);});// Build data array
var measure=void 0;var cells=selectedRowLeaves.map(function(rowLeaf,index){if(measureHeadersAxis==="rows"){measure=measures[rowLeaf.id];}return selectedColumnLeaves.map(function(columnLeaf){if(measureHeadersAxis==="columns"){measure=measures[columnLeaf.id];}return getCellValue(measure.valueAccessor,rowLeaf.dataIndexes,columnLeaf.dataIndexes,measure.aggregation);});});return{rows:rows,columns:columns,cells:cells,rowDimensions:rowDimensions,columnDimensions:columnDimensions,measureHeadersAxis:measureHeadersAxis};};var getSelectedText=function getSelectedText(elements,type){var columnSeparator=type==="csv"?",":"\t";var rows=elements.rows,columns=elements.columns,cells=elements.cells,rowDimensions=elements.rowDimensions,columnDimensions=elements.columnDimensions,measureHeadersAxis=elements.measureHeadersAxis;var mc=measureHeadersAxis==="columns";var mr=measureHeadersAxis==="rows";var output=[];var caption=void 0,outputHeaders=void 0;// // First rows with only the dimensions (top left area) + columns headers
var depth=columnDimensions.length;var width=rowDimensions.length;for(var y=0;y<depth;y+=1){outputHeaders="";for(var x=0;x<width;x+=1){if(x===width-1&&y<depth-mc){caption=columnDimensions[y].caption;}else if(y===depth-1&&x<width-mr){caption=rowDimensions[x].caption;}else{caption="";}outputHeaders+=""+replaceNullAndUndefined(caption)+columnSeparator;}// column headers
for(var _x=0;_x<columns.length;_x+=1){outputHeaders+=""+replaceNullAndUndefined(columns[_x][y].cell.caption)+columnSeparator;}outputHeaders=outputHeaders.slice(0,-1);output.push(outputHeaders);}// t2 = Date.now();
// console.log("columns headers", t2 - t);
// t = t2;
var outputRow="";for(var _y=0;_y<rows.length;_y+=1){outputRow="";// row headers
for(var _x2=0;_x2<width;_x2+=1){outputRow+=""+replaceNullAndUndefined(rows[_y][_x2].cell.caption)+columnSeparator;}// data cells
for(var _x3=0;_x3<columns.length;_x3+=1){outputRow+=""+replaceNullAndUndefined(cells[_y][_x3].value)+columnSeparator;}outputRow=outputRow.slice(0,-1);output.push(outputRow);}// t2 = Date.now();
// console.log("rows", t2 - t, t2);
// t = t2;
// output = output.slice(0, -1);
return output.join("\n");};var copy=function copy(text){try{var bodyElement=document.getElementsByTagName("body")[0];var clipboardTextArea=document.createElement("textarea");clipboardTextArea.style.position="absolute";clipboardTextArea.style.left="-10000px";bodyElement.appendChild(clipboardTextArea);clipboardTextArea.innerHTML=text;// console.log("rows0", Date.now());
clipboardTextArea.select();// console.log("rows1", Date.now());
window.setTimeout(function(){bodyElement.removeChild(clipboardTextArea);},0);// console.log("rows2", Date.now());
}catch(error){/* eslint-disable no-console */console.error("error during copy",error);/* eslint-enable */}};var exportFile=function exportFile(content,fileName,mime){if(mime==null){mime="text/csv";}var blob=new Blob([content],{type:mime});var a=document.createElement("a");a.download=fileName;a.href=window.URL.createObjectURL(blob);a.dataset.downloadurl=[mime,a.download,a.href].join(":");// const e = document.createEvent("MouseEvents");
// e.initMouseEvent(
//   "click",
//   true,
//   false,
//   window,
//   0,
//   0,
//   0,
//   0,
//   0,
//   false,
//   false,
//   false,
//   false,
//   0,
//   null
// );
// return a.dispatchEvent(e);
};var getFileBlob=function getFileBlob(url,cb){var xhr=new XMLHttpRequest();xhr.onreadystatechange=function(event){// XMLHttpRequest.DONE === 4
if(this.readyState===XMLHttpRequest.DONE){if(this.status===200){console.log("Réponse reçu: %s",this.responseText);}else{console.log("Status de la réponse: %d (%s)",this.status,this.statusText);}}};xhr.open("GET",url,true);// xhr.responseType = "blob";
// xhr.addEventListener("load", () => {
//   cb(xhr.response);
// });
xhr.send(null);};var blobToFile=function blobToFile(blob,name){blob.lastModifiedDate=new Date();blob.name=name;return blob;};var getFileObject=function getFileObject(filePathOrUrl,cb){getFileBlob(filePathOrUrl,function(blob){var file=blobToFile(blob,"toto.json");var reader=new FileReader();reader.onload=function(e){return cb(reader.result);};reader.readAsText(file);// cb(blobToFile(blob, "toto.json"));
});};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultConfigurationFunctions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultMenuFunctions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultSizes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pushData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applySizesToStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyConfigurationToStore; });
/* harmony export (immutable) */ __webpack_exports__["e"] = dimensionFactory;
/* harmony export (immutable) */ __webpack_exports__["f"] = measureFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_headers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aggregation__ = __webpack_require__(112);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var MEASURE_ID=__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["h" /* constants */].MEASURE_ID;var defaultConfigurationFunctions={formats:{},accessors:{},sorts:{},aggregations:{}};var defaultMenuFunctions={dataCellFunctions:{},rangeFunctions:{},gridFunctions:{}};var defaultSizes={height:800,width:1000,cellHeight:25,cellWidth:100,zoom:1};var setData=function setData(store,data,meta){var axisTrees=Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["n" /* getAxisTreesSelector */])(store.getState());if(axisTrees.rows){Object(__WEBPACK_IMPORTED_MODULE_1__utils_headers__["c" /* resetLeaves */])(axisTrees.rows);}if(axisTrees.columns){Object(__WEBPACK_IMPORTED_MODULE_1__utils_headers__["c" /* resetLeaves */])(axisTrees.columns);}Object(__WEBPACK_IMPORTED_MODULE_1__utils_headers__["b" /* resetDimensions */])(store.getState().dimensions);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchData"])());if(Array.isArray(data)){if(data.length===0){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchFailure"])({message:"No rows retrieved"}));}else{store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchSuccess"])(data,meta));}}else if(__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isPromise(data)){data.then(function(data){if(Array.isArray(data)&&data.length!==0){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchSuccess"])(data));}else{store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchFailure"])({message:"No rows retrieved"}));}}).catch(function(error){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchFailure"])(error));});}else if(__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isObservable(data)){data.subscribe(function(data){pushData(store,data);},function(error){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchFailure"])({message:error}));});}else if((typeof data==="undefined"?"undefined":_typeof(data))==="object"){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["fetchFailure"])({type:"Query definition",message:data.error}));}else{throw new Error("datasource type is not supported, datasource must be an array, a promise or an observable, got ",data);}};var pushData=function pushData(store,data){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["applyPushedData"])(data));};var applySizesToStore=function applySizesToStore(store,sizes){var prevSizes=store.getState().configuration;var newSizes=Object.assign({},prevSizes,sizes);store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setConfigurationProperty"])(newSizes,"height",800));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setConfigurationProperty"])(newSizes,"width",1000));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setConfigurationProperty"])(newSizes,"zoom",1));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setConfigurationProperty"])(newSizes,"cellHeight",25));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setConfigurationProperty"])(newSizes,"cellWidth",100));};var applyConfigurationToStore=function applyConfigurationToStore(store,configuration,functions,data,utils_){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["loadingConfig"])(true));if(!__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isNullOrUndefined(data)){setData(store,data);}//  global configuration
var measureHeadersAxis=(configuration.configuration||{}).measureHeadersAxis||configuration.measureHeadersAxis||"columns";store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setProperty"])("measureHeadersAxis",measureHeadersAxis));var totalsFirst=(configuration.configuration||{}).totalsFirst||configuration.totalsFirst||false;store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setProperty"])("totalsFirst",totalsFirst));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setProperty"])("edition",configuration.edition||{}));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setConfigurationProperty"])(configuration,"features",{dimensions:"enabled",measures:"enabled",resize:"enabled",expandCollapse:"enabled",totals:"enabled",filters:"enabled",sorting:"enabled",configuration:"enabled"}));var activeMeasures=configuration.activeMeasures,columns=configuration.columns,rows=configuration.rows;if(configuration.axis){activeMeasures=configuration.axis.measures||activeMeasures;columns=configuration.axis.columns||columns;rows=configuration.axis.rows||rows;}store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setDimensions"])(configuration,functions,utils_));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setMeasures"])(configuration,functions,utils_));var dimensionIdsPositioned=[];rows.forEach(function(dimensionId,index){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["moveDimension"])(dimensionId,"dimensions","rows",index));dimensionIdsPositioned.push(dimensionId);});columns.forEach(function(dimensionId,index){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["moveDimension"])(dimensionId,"dimensions","columns",index));dimensionIdsPositioned.push(dimensionId);});configuration.dimensions.filter(function(dimension){return!dimensionIdsPositioned.includes(dimension.id);}).forEach(function(dimension,index){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["moveDimension"])(dimension.id,"dimensions","dimensions",index));});if(activeMeasures){activeMeasures.forEach(function(measureId){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["moveMeasure"])(measureId));});}if(configuration.collapses){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setCollapses"])(Object.assign({},configuration.collapses,{configurationRows:configuration.collapses.rows,configurationColumns:configuration.collapses.columns})));}if(configuration.sizes){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setSizes"])(configuration.sizes));}if(configuration.filters){Object.values(configuration.filters).forEach(function(_ref){var dimensionId=_ref.dimensionId,operator=_ref.operator,term=_ref.term,exclude=_ref.exclude,values=_ref.values;return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["addFilter"])(dimensionId,operator,term,exclude,values));});}if(configuration.subtotals){Object.keys(configuration.subtotals).forEach(function(dimensionId){return store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["toggleSubTotal"])(dimensionId));});}if(configuration.configuration){if(configuration.configuration.zoom){store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setConfigurationProperty"])(configuration.configuration,"zoom",1));}}// if (configuration.cell) {
//   store.dispatch(scrollToIndex(cell.rows, cell.columns));
// }
// callbacks
store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["setProperty"])("callbacks",configuration.callbacks||{}));store.dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions__["loadingConfig"])(false));};// initialisation of dimensions from configuration
// const utils.getFunction = (functions, object, type, value, utils_) => {
//   if (typeof value === "function") {
//     return value;
//   } else if (typeof value === "string") {
//     const indexDot = value.indexOf(".");
//     if (indexDot !== -1) {
//       let v = value;
//       if (value.slice(0, indexDot) === "row") {
//         v = value.slice(indexDot + 1);
//       }
//       const keys = v.split(".");
//       return ({ row }) => {
//         return keys.reduce(
//           (acc, key, index) =>
//             acc[key] === undefined && index < keys.length - 1 ? {} : acc[key],
//           row
//         );
//       };
//     } else {
//       const v =
//         typeof value === "string"
//           ? functions
//               .filter(
//                 f =>
//                   f.id === value &&
//                   f.tp === type &&
//                   (f.visibility === "global" || f.visibility === object)
//               )
//               .sort(
//                 (f0, f1) =>
//                   (f0.visibility !== object) - (f1.visibility !== object)
//               )
//           : [];
//       if (v.length) {
//         if (type === "accessor") {
//           return message =>
//             v[0].functionJS({ ...message, utils: utils_ || utils });
//         } else {
//           return v[0].functionJS;
//         }
//       } else if (type === "format") {
//         return ({ value: value_ }) => utils.formatValue(value_, value);
//       } else {
//         return ({ row }) => row[value];
//       }
//     }
//   }
//   if (type === "format") {
//     return ({ value }) => utils.formatValue(value);
//   }
// };
function dimensionFactory(dimensionConfiguration,functions,utils_){var id=dimensionConfiguration.id,caption=dimensionConfiguration.caption,keyAccessor=dimensionConfiguration.keyAccessor,labelAccessor=dimensionConfiguration.labelAccessor,sort=dimensionConfiguration.sort,format=dimensionConfiguration.format,subTotal=dimensionConfiguration.subTotal,attributeParents=dimensionConfiguration.attributeParents,isLocal=dimensionConfiguration.isLocal;// const { formats, accessors, sorts } = configurationFunctions;
var _sort=sort||{};// a voir accessor functions
// const datasetProperties = {};
var keyAccessor_=keyAccessor,labelAccessor_=labelAccessor||keyAccessor,keyAccessors_=_sort.keyAccessor||labelAccessor||keyAccessor;var kAccessor=__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"accessor",keyAccessor,utils_),lAccessor=__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"accessor",labelAccessor_,utils_),sAccessor=__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"accessor",keyAccessors_,utils_);var dimSort={direction:_sort.direction||"asc",custom:__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"sort",_sort.custom,utils_),custom_:_sort.custom,keyAccessor:sAccessor,keyAccessor_:keyAccessors_};// console.log("format", utils.format);
return{id:id,caption:id===MEASURE_ID?"Measures":caption||id,keyAccessor:kAccessor,keyAccessor_:keyAccessor_,labelAccessor:lAccessor,labelAccessor_:labelAccessor_,// format: utils.getFunction(functions,  "format", format || id, utils_),
// format_: format || id,
format:__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"format",format,utils_),format_:format,sort:dimSort,subTotal:subTotal,attributeParents:attributeParents||[],isLocal:isLocal};}// initialisation of measures from configuration
function measureFactory(measureConfiguration,functions,utils_){// const {
//   formats,
//   accessors,
//   aggregations: customAggregations
// } = configurationFunctions;
var id=measureConfiguration.id,caption=measureConfiguration.caption,valueAccessor=measureConfiguration.valueAccessor,format=measureConfiguration.format,aggregation=measureConfiguration.aggregation,aggregationCaption=measureConfiguration.aggregationCaption,isLocal=measureConfiguration.isLocal;// const aggs = { ...aggregations, ...customAggregations };
// const datasetProperties = {};
// const accessor = accessors[valueAccessor] || valueAccessor;
// if (typeof accessor === "string") {
//   datasetProperties.value = accessor;
// }
return{id:id,caption:caption||id,valueAccessor:__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"accessor",valueAccessor,utils_),valueAccessor_:valueAccessor,format:__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"format",format||id),format_:format||id,aggregation:__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(functions,"aggregation",aggregation,utils_),aggregation_:aggregation,aggregationCaption:aggregationCaption,isLocal:isLocal};}// export function dimensionFactory(
//   dimensionConfiguration,
//   configurationFunctions
// ) {
//   const {
//     id,
//     caption,
//     keyAccessor,
//     labelAccessor,
//     sort,
//     format,
//     subTotal,
//     attributeParents
//   } = dimensionConfiguration;
//   const { formats, accessors, sorts } = configurationFunctions;
//   const _sort = sort || {};
//   // a voir accessor functions
//   const datasetProperties = {};
//   const kAccessor = accessors[keyAccessor] || keyAccessor,
//     lAccessor =
//       accessors[labelAccessor] ||
//       labelAccessor ||
//       accessors[keyAccessor] ||
//       keyAccessor,
//     sAccessor =
//       accessors[_sort.keyAccessor] ||
//       _sort.keyAccessor ||
//       accessors[labelAccessor] ||
//       labelAccessor ||
//       accessors[keyAccessor] ||
//       keyAccessor;
//   if (typeof kAccessor === "string") {
//     datasetProperties.id = kAccessor;
//   }
//   if (typeof lAccessor === "string") {
//     datasetProperties.label = lAccessor;
//   }
//   if (typeof sAccessor === "string") {
//     datasetProperties.sort = sAccessor;
//   }
//   const dimSort = {
//     direction: _sort.direction || "asc",
//     custom: sorts[_sort.custom] || _sort.custom,
//     keyAccessor: toAccessorFunction(sAccessor)
//   };
//   return {
//     id,
//     caption: id === MEASURE_ID ? "Measures" : caption || id,
//     keyAccessor: toAccessorFunction(kAccessor),
//     labelAccessor: toAccessorFunction(lAccessor),
//     format: formats[format]
//       ? value => formats[format]({ value })
//       : utils.formatValue,
//     sort: dimSort,
//     subTotal,
//     attributeParents: attributeParents || [],
//     datasetProperties
//   };
// }
// // initialisation of measures from configuration
// export function measureFactory(measureConfiguration, configurationFunctions) {
//   const {
//     formats,
//     accessors,
//     aggregations: customAggregations
//   } = configurationFunctions;
//   const {
//     id,
//     caption,
//     valueAccessor,
//     format,
//     aggregation,
//     aggregationCaption
//   } = measureConfiguration;
//   const aggs = { ...aggregations, ...customAggregations };
//   const datasetProperties = {};
//   const accessor = accessors[valueAccessor] || valueAccessor;
//   if (typeof accessor === "string") {
//     datasetProperties.value = accessor;
//   }
//   return {
//     id,
//     caption: caption || id,
//     valueAccessor: toAccessorFunction(
//       accessors[valueAccessor] || valueAccessor
//     ),
//     format: formats[format] || utils.formatValue,
//     aggregation: isStringOrNumber(aggregation)
//       ? aggs[aggregation]
//       : aggregation,
//     aggregationCaption,
//     datasetProperties
//   };
// }

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_polyfill__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__utils_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ZebulonTable__ = __webpack_require__(126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ZebulonTableAndConfiguration__ = __webpack_require__(351);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ZebulonTableAndConfiguration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MetaDescriptions__ = __webpack_require__(63);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__MetaDescriptions__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__MetaDescriptions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_compute_data__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_compute_meta__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_filters_sorts__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zebulon_controls__ = __webpack_require__(1);
/* unused harmony namespace reexport */










/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(333);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export filterFunction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return filtersFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sortsFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSorts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__ = __webpack_require__(1);

// import { utils.getFunction } from "./compute.meta";
// ----------------------------
//  filters
//  ---------------------------
var filterFunction = function filterFunction(column, params, data, updatedRows, utils_) {
  var facc = function facc(row) {
    var f = column.accessorFunction;
    if (column.id === "status_") {
      var status = (updatedRows || {})[row.index_] || {};
      return 1 * (status.updated_ || 0) + 2 * (status.new_ || 0) + 4 * (status.deleted_ || 0) + 8 * ((status.errors || { n_: 0 }).n_ > 0);
    }
    if (!f) {
      if (column.accessor) {
        f = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].getFunction([], "accessor", column.accessor, utils_);
      } else if (column.dataType === "date") {
        f = function f(_ref) {
          var row = _ref.row,
              column = _ref.column;
          return new Date(row[column.id]);
        };
      } else {
        f = function f(_ref2) {
          var row = _ref2.row,
              column = _ref2.column;
          return row[column.id];
        };
      }
    }
    return f({
      row: row,
      column: column,
      params: params,
      status: (updatedRows || {})[row.index_],
      data: data
    });
  };
  if (column.dataType === "date") {
    column.v = new Date(column.v);
    if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.vTo)) {
      column.vTo = new Date(column.vTo);
    }
  }
  if (column.id === "status_") {
    column.f = function (row) {
      var vRow = facc(row);
      return vRow && (vRow & column.v) !== 0;
    };
  } else if (column.filterType === "values") {
    column.f = function (row) {
      return column.v[facc(row)] !== undefined;
    };
  } else if (column.dataType === "boolean") {
    column.f = function (row) {
      return (facc(row) || false) === column.v;
    };
  } else if (column.filterType === "=") {
    column.f = function (row) {
      return facc(row) === column.v;
    };
  } else if (column.filterType === ">=") {
    column.f = function (row) {
      return facc(row) >= column.v;
    };
  } else if (column.filterType === "between") {
    column.f = function (row) {
      return (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.vTo) ? facc(row) <= column.vTo : true) && (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.v) ? facc(row) >= column.v : true);
    };
  } else if (column.filterType === "<=") {
    column.f = function (row) {
      return facc(row) <= column.v;
    };
  } else if (column.filterType === "starts (case sensitive)") {
    column.f = function (row) {
      return String(facc(row) || "").startsWith(String(column.v || ""));
    };
  } else if (column.filterType === "contains") {
    column.f = function (row) {
      return String(facc(row) || "").indexOf(String(column.v || "")) !== -1;
    };
  } else if (column.filterType === "starts") {
    var v = String(column.v).toUpperCase() || "";
    column.f = function (row) {
      return String(facc(row) || "").toUpperCase().startsWith(v);
    };
  }
};
// -----------------------------
var filtersFunction = function filtersFunction(filters, params, data, updatedRows, utils_) {
  if (!filters) {
    return function (x) {
      return x;
    };
  }
  var f = Object.values(filters).concat((params || {}).filter_ || []).filter(function (filter) {
    return !__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(filter.v) || filter.filterType === "between" && !__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(filter.vTo);
  }).map(function (filter) {
    filterFunction(filter, params, data, updatedRows, utils_);
    return filter;
  });
  if (!f.length) {
    return function (x) {
      return x;
    };
  }
  return function (row) {
    return f.reduce(function (acc, filter) {
      return acc && filter.f(row);
    }, true);
  };
};
// -----------------------------
var getFilters = function getFilters(columns, filters) {
  if (!columns.length) {
    return filters;
  }
  return columns.reduce(function (acc, column) {
    var v = column.v,
        vTo = column.vTo,
        filterType = column.filterType;
    if (filters[column.id]) {
      v = filters[column.id].v;
      vTo = filters[column.id].vTo;
      filterType = filters[column.id].filterType;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(v) || column.filterType === "between" && !__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.vTo)) {
      acc[column.id] = {
        id: column.id,
        dataType: column.dataType,
        filterType: filterType,
        v: v,
        vTo: vTo,
        accessor: column.accessor,
        accessorFunction: column.accessorFunction
      };
    }
    return acc;
  }, {});
};
// ----------------------------
//  sorts
//  ---------------------------
var sortsFunction = function sortsFunction(sorts) {
  return function (rowA, rowB) {
    return sorts.reduce(function (acc, sort) {
      var accessor = sort.accessor || function (_ref3) {
        var row = _ref3.row;
        return row[sort.id];
      };
      if (acc === 0) {
        var a = accessor({ row: rowA }),
            b = accessor({ row: rowB });
        // if (sort.id !== "d") {
        //   console.log("sort", a, b);
        // }
        acc = ((a > b) - (b > a)) * (sort.direction === "asc" ? 1 : -1);
      }
      return acc;
    }, 0);
  };
};
// -----------------------------------------
var getSorts = function getSorts(columns) {
  var sorts = columns.filter(function (column) {
    return column.sort !== undefined;
  }).map(function (column) {
    var nullValue = "";
    if (column.dataType === "number" || column.dataType === "boolean") {
      nullValue = null;
    } else if (column.dataType === "date") {
      nullValue = new Date(null);
    }
    return {
      id: column.id,
      sortOrder: column.sortOrder,
      direction: column.sort,
      accessor: column.sortAccessorFunction || column.accessorFunction || function (_ref4) {
        var row = _ref4.row;

        return __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].nullValue(row[column.id], nullValue);
      }
    };
  });
  sorts.sort(function (a, b) {
    return (a.sortOrder > b.sortOrder) - (b.sortOrder > a.sortOrder);
  });
  return sorts;
};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onNext */
/* unused harmony export onCompleted */
/* unused harmony export onError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return functions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return setPropertyAccessors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return metaDescriptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_utils__ = __webpack_require__(13);



// import { getFunction } from "./utils/compute.meta";
// ({row})=>accessor('qty')({row})*3
var functionToString = function functionToString(_ref) {
	var row = _ref.row;

	if (row.functionText) {
		return row.functionText;
	} else if (typeof row.functionJS === "function") {
		return String(row.functionJS);
	}
};
var stringToFunction = function stringToFunction(_ref2) {
	var row = _ref2.row,
	    status = _ref2.status,
	    meta = _ref2.meta,
	    utils_ = _ref2.utils_;

	var f = void 0;
	var accessors = meta.functions.filter(function (f) {
		return f.tp === "accessor";
	}).reduce(function (acc, f) {
		acc[f.id] = f.functionJS;
		return acc;
	}, {});
	var accessor = function accessor(_accessor) {
		return accessors[_accessor];
	};
	try {
		eval("f = " + row.functionText);
	} catch (e) {
		var error = status.errors.functionJS || {};
		error.JS = e.message;
		status.errors.functionJS = error;
	}
	if (typeof f === "function") {
		row.functionJS = f;
		// if (!functions[row.visibility]) {
		// 	functions[row.visibility] = {};
		// }
		// if (!functions[row.visibility][row.tp + "s"]) {
		// 	functions[row.visibility][row.tp + "s"] = {};
		// }
		// functions[row.visibility][row.tp + "s"][row.id] = f;
		if (status.errors.functionJS) {
			delete status.errors.functionJS.JS;
		}
	} else {
		var _error = status.errors.functionJS || {};
		_error.JS = "function not evaluated";
		status.errors.functionJS = _error;
	}
	return true;
};
var onNext = function onNext(data, message) {
	var indexedColumn = message.meta.table.rowId || message.meta.table.primaryKey;
	data.forEach(function (row) {
		//  a voir deleted row on server side + conflict (zebulon table) => recreation of the row (new_=true) index_=...
		if (message.index) {
			var index = message.index[row[indexedColumn]];
			if (index !== undefined) {
				row.index_ = index;
				var status = message.updatedRows[index];
				if (status) {
					status.row = row;
				} else {
					message.data[index] = row;
				}
			} else {
				message.index[row[message.meta.table.primaryKey]] = message.data.length;
				message.data.push(row);
			}
		} else {
			message.data.push(row);
		}
	});
};
var onCompleted = function onCompleted(message) {};
var onError = function onError(e, message) {};
// export const accessor = accessor => {
// 	return () => 4;
// };
var isLocal = function isLocal(_ref3) {
	var row = _ref3.row,
	    status = _ref3.status;
	return (status || {}).new_ || row.isLocal;
};
var functions = {
	properties: {
		accessors: {
			propertyType: function propertyType(_ref4) {
				var row = _ref4.row,
				    status = _ref4.status,
				    meta = _ref4.meta;

				// if (row.tp) {
				// 	return row.tp;
				// } else
				if (row.reference) {
					return row.reference;
					// 	return typeof row.foreignObject === "string"
					// 		? row.foreignObject
					// 		: row.foreignObject.name;
					// } else if (
					// 	row.primaryKeyAccessor &&
					// 	row.setForeignKeyAccessor
					// ) {
					// 	if (!row.reference) {
					// 		return "Joined object";
					// 	} else {
					// 		return `${row.reference} key`;
					// 	}
				} else if (row.aggregation) {
					return "analytic";
				} else if (row.accessor || (status || {}).new_) {
					return "computed";
				} else {
					return "dataset";
				}
			}
		},
		sorts: {},
		formats: {
			isArrayOrFunction: function isArrayOrFunction(_ref5) {
				var value = _ref5.value;

				if (typeof value === "function" || Array.isArray(value)) {
					return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						"div",
						{
							style: {
								backgroundColor: "#f5f7da",
								fontStyle: "italic"
							}
						},
						Array.isArray(value) ? "array[]" : "fct()"
					);
				}
				return value;
			}
		},
		aggregations: {},
		selects: {},
		validators: {
			row: function row(_ref6) {
				var _row = _ref6.row,
				    status = _ref6.status,
				    data = _ref6.data,
				    params = _ref6.params;
			}
		},
		editables: {
			isDataset: function isDataset(_ref7) {
				var row = _ref7.row;
				return row.tp === "Dataset";
			},
			isNotDataset: function isNotDataset(_ref8) {
				var row = _ref8.row;
				return row.tp !== "Dataset";
			},
			isAnalytic: function isAnalytic(_ref9) {
				var row = _ref9.row;
				return row.tp === "Analytic";
			}
		},
		defaults: {},
		row: function row() {},
		table: function table() {},
		actions: {
			exportMeta: function exportMeta(_ref10) {
				var meta = _ref10.meta;
				return "meta = " + JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["a" /* buildObject */])(meta));
			}
		}
	},
	functions: {
		accessors: {
			functionToString: functionToString,
			functionDescriptor: function functionDescriptor(_ref11) {
				var row = _ref11.row;

				var label = void 0;
				if (row.tp === "accessor") {
					label = "Parameters: ({row,status,data,params,utils})";
				} else if (row.tp === "editable") {
					label = "Parameters: ({row,status,data,params})";
				} else if (row.tp === "select") {
					label = "Parameters: ({row,status,data,params})";
				} else if (row.tp === "validator") {
					label = "Parameters: ({row,status,data,params})";
				} else if (row.tp === "format") {
					label = "Parameters: (value,row,status,data,params)";
				} else if (row.tp === "aggregation") {
					label = "Parameters: ([values])";
				} else if (row.tp === "sort") {
					label = "Parameters: (rowA, rowB)";
				} else if (row.tp === "window") {
					label = "Parameters: (value)";
				}
				return (row.caption || row.id) + " : " + label;
			},
			isLocal: isLocal
		},
		validators: {
			stringToFunction: stringToFunction
		},
		actions: {
			exportFunctions: function exportFunctions(_ref12) {
				var data = _ref12.data;
				return "functions = " + Object(__WEBPACK_IMPORTED_MODULE_2__utils_utils__["c" /* exportFunctions */])(data);
			}
		},
		editables: { isLocal: isLocal }
	},
	dimensions: {
		accessors: {
			sortAcc: function sortAcc(_ref13) {
				var row = _ref13.row;
				return (row.sort || {}).keyAccessor;
			},
			sortFct: function sortFct(_ref14) {
				var row = _ref14.row;
				return (row.sort || {}).custom;
			},
			isLocal: isLocal
		},
		validators: {
			sortAcc: function sortAcc(_ref15) {
				var row = _ref15.row;
				return row.sort = Object.assign({}, row.sort || {}, {
					keyAccessor: row.sortAccessor
				});
			},
			sortFct: function sortFct(_ref16) {
				var row = _ref16.row;
				return row.sort = Object.assign({}, row.sort || {}, {
					custom: row.sortFunction
				});
			}
		},
		editables: {
			isLocal: isLocal
		}
	},

	measures: {
		accessors: {
			isLocal: isLocal
		},
		editables: {
			isLocal: isLocal
		}
	},
	globals_: {
		editables: {
			is_selected: function is_selected(_ref17) {
				var row = _ref17.row;
				return row.index_ !== undefined;
			},
			is_new: function is_new(_ref18) {
				var status = _ref18.status;
				return status.new_;
			}
		},
		observers: {
			onNext: onNext,
			onCompleted: onCompleted,
			onError: onError
		}
	}
};


var setPropertyAccessors = function setPropertyAccessors(properties, data) {
	var accessors = {};
	properties.forEach(function (property) {
		accessors[property.id] = {
			id: "row." + property.id,
			caption: "row." + property.id,
			type: "property"
		};
		if (data && (property.dataType === "object" || property.dataType === "joined object")) {
			data.forEach(function (row) {
				if (!__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullValue(row[property.id])) {
					Object.keys(row[property.id]).forEach(function (key) {
						accessors[property.id + "." + key] = {
							id: "row." + property.id + "." + key,
							caption: "row." + property.id + "." + key,
							type: "object property"
						};
					});
				}
			});
		}
	});
	propertyAccessors = accessors;
};
var propertyAccessors = {};

var metaDescriptions = function metaDescriptions(object)
// ,
// properties,
// data_
{
	var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var functions = arguments[2];

	var f = functions;
	var getFunctions = function getFunctions(type) {
		var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object;

		return f.filter(function (f) {
			return f.tp === type;
		}).reduce(function (acc, f) {
			acc[f.id] = {
				id: f.id,
				caption: f.caption || f.id,
				type: "function",
				style: { color: "blue" }
			};
			return acc;
		}, {});
	};
	var getAccessorsAndProperties = function getAccessorsAndProperties(obj) {
		return function () {
			var dataAccessors = propertyAccessors;
			var accessors = getFunctions("accessor", obj);
			// console.log("getAccessorsAndProperties", accessors, dataAccessors);
			return Object.assign({}, dataAccessors, accessors);
		};
	};
	var getAggregations = function getAggregations(obj) {
		return function () {
			return getFunctions("aggregation", obj);
		};
	};
	var getFormats = function getFormats(obj) {
		return function () {
			return getFunctions("format", obj);
		};
	};
	var getSorts = function getSorts(obj) {
		return function () {
			return getFunctions("sort", obj);
		};
	};
	var getWindowFunctions = function getWindowFunctions(obj) {
		return function () {
			return getFunctions("window", obj);
		};
	};
	var getSelects = function getSelects(obj) {
		return function () {
			return getFunctions("select", obj);
		};
	};
	var getValidators = function getValidators(obj) {
		return function () {
			return getFunctions("validator", obj);
		};
	};
	// const getEditables = obj => () => getFunctions("editable", obj);
	var getDefaults = function getDefaults(obj) {
		return function () {
			return getFunctions("default", obj);
		};
	};
	var getForeignObjects = function getForeignObjects(obj) {
		return function () {
			return getFunctions("foreignObject", obj);
		};
	};
	if (object === "dataset") {
		return {
			table: {
				object: "dataset",
				editable: true,
				noFilter: false,
				// caption: "Dataset",
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "is_selected",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Save",
					enable: true,
					key: "f12"
				}, {
					type: "refresh",
					caption: "Refresh",
					enable: true,
					key: "10"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: {},
			properties: []
		};
	} else if (object === "properties") {
		return {
			table: {
				object: object,
				editable: true,
				primaryKey: "id",
				code: "caption",
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isNotDataset",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
					// ,
					// {
					// 	type: "detail",
					// 	caption: "Analytic",
					// 	enable: "isAnalytic",
					// 	content: Property
					// }
					// {
					// 	type: "action",
					// 	caption: "Apply",
					// 	action: callbacks.applyMeta,
					// 	enable: true
					// }
					// ,
					// {
					// 	type: "action",
					// 	caption: "Export configuration",
					// 	action: "exportMeta",
					// 	enable: true
					// }
				}]
			},
			row: {
				// validator: "propertyValidator",
				// detail: "propertyDetail"
			},
			properties: [{
				id: "id",
				caption: "Column",
				width: 100,
				dataType: "string",
				editable: "isNotDataset",
				mandatory: true,
				locked: true
			}, {
				id: "tp",
				caption: "Type",
				width: 150,
				dataType: "string",
				editable: false,
				default: "Computed",
				accessor: "propertyType",
				filterType: "values"
			}, {
				id: "dataType",
				caption: "Data type",
				width: 100,
				dataType: "string",
				editable: "isNotDataset",
				filterType: "values",
				select: ["number", "string", "text", "date", "boolean", "object", "joined object"]
			}, {
				id: "caption",
				caption: "Caption",
				width: 150,
				dataType: "string",
				editable: true
			}, {
				id: "editable",
				caption: "Editable",
				width: 80,
				dataType: "boolean",
				editable: true,
				default: false
			}, {
				id: "mandatory",
				caption: "Mandatory",
				width: 90,
				dataType: "boolean",
				editable: true,
				default: true
			}, {
				id: "hidden",
				caption: "Hidden",
				width: 80,
				dataType: "boolean",
				editable: true,
				default: false
			}, {
				id: "width",
				caption: "Width",
				width: 60,
				dataType: "number",
				editable: true,
				default: 100
			}, {
				id: "format",
				caption: "Format",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getFormats("dataset")
			}, {
				id: "filterType",
				caption: "Filter",
				width: 100,
				dataType: "string",
				editable: true,
				select: ["starts", "starts (case sensitive)", "contains", "=", ">=", "<=", "between", "values"]
			},

			// only for new properties
			{
				id: "accessor",
				caption: "Accessor",
				width: 150,
				dataType: "string",
				editable: "isNotDataset",
				hidden: false,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "select",
				caption: "Select",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getSelects("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "default",
				caption: "Default",
				width: 100,
				dataType: "string",
				editable: true,
				// hidden: true,
				filterType: "values",
				select: getDefaults("dataset")
			}, {
				id: "foreignObject",
				caption: "Foreign object",
				width: 150,
				dataType: "string",
				editable: true,
				// hidden: true,
				// filterType: "values",
				select: getForeignObjects("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "onChange",
				caption: "On change",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getValidators("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "onCellQuit",
				caption: "On cell quit",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getValidators("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "groupByAccessor",
				caption: "Group by accessor",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "sortAccessor",
				caption: "Sort accessor",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "aggregation",
				caption: "Aggregation",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAggregations("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "comparisonAccessor",
				caption: "Comparison accessor",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "startFunction",
				caption: "Start function",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getWindowFunctions("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "endFunction",
				caption: "End function",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getWindowFunctions("dataset"),
				format: "isArrayOrFunction"
			}]
		};
	} else if (object === "functions") {
		return {
			table: {
				object: object,
				editable: true,
				primaryKey: "id",
				code: "caption",
				onSave: callbacks.applyFunctions,
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isLocal",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Apply",
					enable: true,
					hidden: !callbacks.applyFunctions,
					key: "f12"
				},, {
					type: "action",
					caption: "Export functions",
					action: "exportFunctions",
					hidden: true
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: { descriptor: "functionDescriptor" },
			properties: [{
				id: "id",
				caption: "Code",
				width: 100,
				dataType: "string",
				editable: "isLocal",
				mandatory: true,
				locked: true
			}, {
				id: "caption",
				caption: "Caption",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "between"
			}, {
				id: "visibility",
				caption: "Visibility",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				select: ["", "dataset", "properties", "functions", "global"],
				filterType: "values",
				mandatory: true,
				default: "global"
			}, {
				id: "tp",
				caption: "Type",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				filterType: "values",
				select: ["", "action", "accessor", "aggregation", "format", "sort", "window", "select", "validator", "editable", "default", "descriptor", "dml"]
			}, {
				id: "isLocal",
				caption: "Local",
				accessor: "isLocal",
				width: 80,
				dataType: "boolean",
				default: true
			}, {
				id: "functionText",
				caption: "Function",
				accessor: "functionToString",
				onQuit: "stringToFunction",
				width: 500,
				dataType: "text",
				editable: "isLocal"
			}, {
				id: "functionJS",
				caption: "Function",
				// accessor: "functionToString",
				// onQuit: "stringToFunction",
				hidden: true
			}]
		};
	} else if (object === "measures") {
		return {
			table: {
				object: "measures",
				editable: true,
				primaryKey: "id",
				code: "caption",
				onSave: callbacks.applyMeasures,
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isLocal",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Apply",
					// action: callbacks.applyMeasures,
					enable: true,
					key: "f12"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: {},
			properties: [{
				id: "id",
				caption: "id",
				width: 100,
				dataType: "string",
				editable: "isLocal",
				mandatory: true
			}, {
				id: "caption",
				caption: "caption",
				width: 150,
				dataType: "string",
				editable: true
			}, {
				id: "valueAccessor",
				caption: "Value accessor",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				mandatory: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "format",
				caption: "format",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getFormats("dataset")
			}, {
				id: "aggregation",
				caption: "aggregation",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				mandatory: true,
				default: "sum",
				filterType: "values",
				select: getAggregations("dataset")
			}, {
				id: "isLocal",
				caption: "Local",
				accessor: "isLocal",
				width: 80,
				dataType: "boolean",
				default: true
			}]
		};
	} else if (object === "dimensions") {
		return {
			table: {
				object: object,
				editable: true,
				primaryKey: "id",
				code: "caption",
				onSave: callbacks.applyDimensions,
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isLocal",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Apply",
					// action: callbacks.applyDimensions,
					enable: true,
					key: "f12"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: {},
			properties: [{
				id: "id",
				caption: "Dimension",
				width: 100,
				dataType: "string",
				editable: "isLocal"
			}, {
				id: "caption",
				caption: "Caption",
				width: 150,
				dataType: "string",
				editable: true
			}, {
				id: "keyAccessor",
				caption: "Key accessor",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				filterType: "values",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "labelAccessor",
				caption: "Label accessor",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "sort",
				caption: "sort",
				width: 100,
				dataType: "object",
				hidden: true,
				editable: true
			}, {
				id: "sortAccessor",
				accessor: "sortAcc",
				onQuit: "sortAcc",
				caption: "Sort accessor",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "sortFunction",
				accessor: "sortFct",
				onQuit: "sortFct",
				caption: "Sort function",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getSorts("dataset")
			}, {
				id: "format",
				caption: "format",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getFormats("dataset")
			}, {
				id: "isLocal",
				caption: "Local",
				accessor: "isLocal",
				width: 80,
				dataType: "boolean",
				default: true
			}]
		};
	}
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(65);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(139);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(72);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(154);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(162);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17), __webpack_require__(161)(module)))

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(167)();
}


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(76);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(79);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(41);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GridWithoutStoreAndDndContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd_html5_backend__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dnd_html5_backend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dnd_html5_backend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PivotGrid_PivotGrid__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(6);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// const rowAndColumnHeadersSel = () => rowAndColumnHeadersSelector;
var mapStateToProps=function mapStateToProps(){return function(state,ownProps){// const rowAndColumnHeaders = rowAndColumnHeadersSel();
var props={gridId:ownProps.id||"pivotgrid",status:state.status,width:state.configuration.width,height:state.configuration.height,headers:Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["z" /* rowAndColumnHeadersSelector */])(state),sizes:state.sizes,selectedRange:Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["C" /* selectedRangeSelector */])(state),zoomValue:state.configuration.zoom,copy:Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["g" /* copySelector */])(state),paste:Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["x" /* pasteSelector */])(state),export:Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["l" /* exportSelector */])(state),defaultCellSizes:Object(__WEBPACK_IMPORTED_MODULE_4__selectors__["i" /* defaultCellSizesSelector */])(state),pushedData:state.data.pushedData,onEdit:state.configuration.callbacks.onEdit,editable:state.configuration.edition.activated&&state.configuration.edition.editable};// console.log("map", props);
return props;};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updateCellSize:function updateCellSize(_ref){var handle=_ref.handle,offset=_ref.offset,initialOffset=_ref.initialOffset,sizes=_ref.sizes,defaultCellSizes=_ref.defaultCellSizes;dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["updateCellSize"])({handle:handle,offset:offset,initialOffset:initialOffset,sizes:sizes,defaultCellSizes:defaultCellSizes}));},setSizes:function setSizes(_ref2){var height=_ref2.height,width=_ref2.width;if(height)dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["setConfigurationProperty"])({height:height,width:width},"height"));if(width)dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["setConfigurationProperty"])({height:height,width:width},"width"));},selectRange:function selectRange(selectedRange){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["selectRange"])(selectedRange));},selectCell:function selectCell(cell){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["selectCell"])(cell));},zoom:function zoom(value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["zoom"])(value));},// scrollToCell: cell => dispatch(scrollToIndex(cell.rows, cell.columns)),
scrollToRow:function scrollToRow(scroll){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["scrollToIndex"])(scroll,null));},scrollToColumn:function scrollToColumn(scroll){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["scrollToIndex"])(null,scroll));},editData:function editData(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__actions__["applyPushedData"])(data));}};};var mergeProps=function mergeProps(_ref3,_ref4,ownProps){var _updateCellSize2=_ref4.updateCellSize,editData=_ref4.editData,restDispatchProps=_objectWithoutProperties(_ref4,["updateCellSize","editData"]);var sizes=_ref3.sizes,defaultCellSizes=_ref3.defaultCellSizes,_paste=_ref3.paste,onEdit=_ref3.onEdit,restStateProps=_objectWithoutProperties(_ref3,["sizes","defaultCellSizes","paste","onEdit"]);// console.log("merge", restStateProps);
return Object.assign({updateCellSize:function updateCellSize(_ref5){var handle=_ref5.handle,offset=_ref5.offset,initialOffset=_ref5.initialOffset;return _updateCellSize2({handle:handle,offset:offset,initialOffset:initialOffset,sizes:sizes,defaultCellSizes:defaultCellSizes});},paste:function paste(clipboard,cell){var data=_paste(clipboard,cell);editData(data);if(onEdit){data.map(function(row){return onEdit(row);});}}},restStateProps,restDispatchProps,ownProps);};var GridWithoutStoreAndDndContext=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_3__components_PivotGrid_PivotGrid__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["DragDropContext"])(__WEBPACK_IMPORTED_MODULE_2_react_dnd_html5_backend___default.a)(GridWithoutStoreAndDndContext));

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = DragDropContext;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dndCore = __webpack_require__(183);

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(25);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _checkDecoratorArguments = __webpack_require__(35);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
	dragDropManager: _propTypes2.default.object.isRequired
};

var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
	return {
		dragDropManager: new _dndCore.DragDropManager(backend, context)
	};
};

var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
	// Auto-detect ES6 default export for people still using ES5
	var backend = backendOrModule;
	if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
		backend = backend.default;
	}
	(0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
	return backend;
};

function DragDropContext(backendOrModule) {
	_checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params

	var backend = unpackBackendForEs5Users(backendOrModule);
	var childContext = createChildContext(backend);

	return function decorateContext(DecoratedComponent) {
		var _class, _temp;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragDropContextContainer = (_temp = _class = function (_Component) {
			_inherits(DragDropContextContainer, _Component);

			function DragDropContextContainer() {
				_classCallCheck(this, DragDropContextContainer);

				return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
			}

			_createClass(DragDropContextContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'getManager',
				value: function getManager() {
					return childContext.dragDropManager;
				}
			}, {
				key: 'getChildContext',
				value: function getChildContext() {
					return childContext;
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragDropContextContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);


		return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
	};
}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(17)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOffset;
exports.getSourceClientOffset = getSourceClientOffset;
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;

var _dragDrop = __webpack_require__(27);

var initialState = {
	initialSourceClientOffset: null,
	initialClientOffset: null,
	clientOffset: null
};

function areOffsetsEqual(offsetA, offsetB) {
	if (offsetA === offsetB) {
		return true;
	}
	return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}

function dragOffset() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return {
				initialSourceClientOffset: action.sourceClientOffset,
				initialClientOffset: action.clientOffset,
				clientOffset: action.clientOffset
			};
		case _dragDrop.HOVER:
			if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
				return state;
			}
			return _extends({}, state, {
				clientOffset: action.clientOffset
			});
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
			return initialState;
		default:
			return state;
	}
}

function getSourceClientOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset,
	    initialSourceClientOffset = state.initialSourceClientOffset;

	if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
		y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	};
}

function getDifferenceFromInitialOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset;

	if (!clientOffset || !initialClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x - initialClientOffset.x,
		y: clientOffset.y - initialClientOffset.y
	};
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = matchesType;

var _isArray = __webpack_require__(12);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesType(targetType, draggedItemType) {
	if ((0, _isArray2.default)(targetType)) {
		return targetType.some(function (t) {
			return t === draggedItemType;
		});
	} else {
		return targetType === draggedItemType;
	}
}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(86),
    baseRest = __webpack_require__(15),
    isArrayLikeObject = __webpack_require__(33);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(43),
    arrayIncludes = __webpack_require__(44),
    arrayIncludesWith = __webpack_require__(45),
    arrayMap = __webpack_require__(46),
    baseUnary = __webpack_require__(47),
    cacheHas = __webpack_require__(48);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(192),
    mapCacheDelete = __webpack_require__(211),
    mapCacheGet = __webpack_require__(213),
    mapCacheHas = __webpack_require__(214),
    mapCacheSet = __webpack_require__(215);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObject = __webpack_require__(21);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(29);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 92 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dirtyHandlerIds;
exports.areDirty = areDirty;

var _xor = __webpack_require__(228);

var _xor2 = _interopRequireDefault(_xor);

var _intersection = __webpack_require__(236);

var _intersection2 = _interopRequireDefault(_intersection);

var _dragDrop = __webpack_require__(27);

var _registry = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NONE = [];
var ALL = [];

function dirtyHandlerIds() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
	var action = arguments[1];
	var dragOperation = arguments[2];

	switch (action.type) {
		case _dragDrop.HOVER:
			break;
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
		case _registry.REMOVE_TARGET:
		case _registry.REMOVE_SOURCE:
			return NONE;
		case _dragDrop.BEGIN_DRAG:
		case _dragDrop.PUBLISH_DRAG_SOURCE:
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
		default:
			return ALL;
	}

	var targetIds = action.targetIds;
	var prevTargetIds = dragOperation.targetIds;

	var result = (0, _xor2.default)(targetIds, prevTargetIds);

	var didChange = false;
	if (result.length === 0) {
		for (var i = 0; i < targetIds.length; i++) {
			if (targetIds[i] !== prevTargetIds[i]) {
				didChange = true;
				break;
			}
		}
	} else {
		didChange = true;
	}

	if (!didChange) {
		return NONE;
	}

	var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	var innermostTargetId = targetIds[targetIds.length - 1];

	if (prevInnermostTargetId !== innermostTargetId) {
		if (prevInnermostTargetId) {
			result.push(prevInnermostTargetId);
		}
		if (innermostTargetId) {
			result.push(innermostTargetId);
		}
	}

	return result;
}

function areDirty(state, handlerIds) {
	if (state === NONE) {
		return false;
	}

	if (state === ALL || typeof handlerIds === 'undefined') {
		return true;
	}

	return (0, _intersection2.default)(handlerIds, state).length > 0;
}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(231),
    isFlattenable = __webpack_require__(232);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(233),
    isObjectLike = __webpack_require__(20);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(43),
    arrayIncludes = __webpack_require__(44),
    arrayIncludesWith = __webpack_require__(45),
    cacheHas = __webpack_require__(48),
    createSet = __webpack_require__(234),
    setToArray = __webpack_require__(98);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = shallowEqualScalar;
function shallowEqualScalar(objA, objB) {
	if (objA === objB) {
		return true;
	}

	if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
		return false;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i])) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = decorateHandler;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _disposables = __webpack_require__(250);

var _isPlainObject = __webpack_require__(11);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(25);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(99);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isClassComponent = function isClassComponent(Comp) {
	return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
};

function decorateHandler(_ref) {
	var _class, _temp;

	var DecoratedComponent = _ref.DecoratedComponent,
	    createHandler = _ref.createHandler,
	    createMonitor = _ref.createMonitor,
	    createConnector = _ref.createConnector,
	    registerHandler = _ref.registerHandler,
	    containerDisplayName = _ref.containerDisplayName,
	    getType = _ref.getType,
	    collect = _ref.collect,
	    options = _ref.options;
	var _options$arePropsEqua = options.arePropsEqual,
	    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

	var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

	var DragDropContainer = (_temp = _class = function (_Component) {
		_inherits(DragDropContainer, _Component);

		_createClass(DragDropContainer, [{
			key: 'getHandlerId',
			value: function getHandlerId() {
				return this.handlerId;
			}
		}, {
			key: 'getDecoratedComponentInstance',
			value: function getDecoratedComponentInstance() {
				return this.decoratedComponentInstance;
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
			}
		}]);

		function DragDropContainer(props, context) {
			_classCallCheck(this, DragDropContainer);

			var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));

			_this.handleChange = _this.handleChange.bind(_this);
			_this.handleChildRef = _this.handleChildRef.bind(_this);

			(0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

			_this.manager = _this.context.dragDropManager;
			_this.handlerMonitor = createMonitor(_this.manager);
			_this.handlerConnector = createConnector(_this.manager.getBackend());
			_this.handler = createHandler(_this.handlerMonitor);

			_this.disposable = new _disposables.SerialDisposable();
			_this.receiveProps(props);
			_this.state = _this.getCurrentState();
			_this.dispose();
			return _this;
		}

		_createClass(DragDropContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.isCurrentlyMounted = true;
				this.disposable = new _disposables.SerialDisposable();
				this.currentType = null;
				this.receiveProps(this.props);
				this.handleChange();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!arePropsEqual(nextProps, this.props)) {
					this.receiveProps(nextProps);
					this.handleChange();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.dispose();
				this.isCurrentlyMounted = false;
			}
		}, {
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.handler.receiveProps(props);
				this.receiveType(getType(props));
			}
		}, {
			key: 'receiveType',
			value: function receiveType(type) {
				if (type === this.currentType) {
					return;
				}

				this.currentType = type;

				var _registerHandler = registerHandler(type, this.handler, this.manager),
				    handlerId = _registerHandler.handlerId,
				    unregister = _registerHandler.unregister;

				this.handlerId = handlerId;
				this.handlerMonitor.receiveHandlerId(handlerId);
				this.handlerConnector.receiveHandlerId(handlerId);

				var globalMonitor = this.manager.getMonitor();
				var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });

				this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				if (!this.isCurrentlyMounted) {
					return;
				}

				var nextState = this.getCurrentState();
				if (!(0, _shallowEqual2.default)(nextState, this.state)) {
					this.setState(nextState);
				}
			}
		}, {
			key: 'dispose',
			value: function dispose() {
				this.disposable.dispose();
				this.handlerConnector.receiveHandlerId(null);
			}
		}, {
			key: 'handleChildRef',
			value: function handleChildRef(component) {
				this.decoratedComponentInstance = component;
				this.handler.receiveComponent(component);
			}
		}, {
			key: 'getCurrentState',
			value: function getCurrentState() {
				var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);

				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
				}

				return nextState;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
					ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
				}));
			}
		}]);

		return DragDropContainer;
	}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
		dragDropManager: _propTypes2.default.object.isRequired
	}, _temp);


	return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
}

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = wrapConnectorHooks;

var _react = __webpack_require__(0);

var _cloneWithRef = __webpack_require__(258);

var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function throwIfCompositeComponentElement(element) {
	// Custom components can no longer be wrapped directly in React DnD 2.0
	// so that we don't need to depend on findDOMNode() from react-dom.
	if (typeof element.type === 'string') {
		return;
	}

	var displayName = element.type.displayName || element.type.name || 'the component';

	throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
	return function () {
		var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		// When passed a node, call the hook straight away.
		if (!(0, _react.isValidElement)(elementOrNode)) {
			var node = elementOrNode;
			hook(node, options);
			return undefined;
		}

		// If passed a ReactElement, clone it and attach this function as a ref.
		// This helps us achieve a neat API where user doesn't even know that refs
		// are being used under the hood.
		var element = elementOrNode;
		throwIfCompositeComponentElement(element);

		// When no options are passed, use the hook directly
		var ref = options ? function (node) {
			return hook(node, options);
		} : hook;

		return (0, _cloneWithRef2.default)(element, ref);
	};
}

function wrapConnectorHooks(hooks) {
	var wrappedHooks = {};

	Object.keys(hooks).forEach(function (key) {
		var hook = hooks[key];
		var wrappedHook = wrapHookToRecognizeElement(hook);
		wrappedHooks[key] = function () {
			return wrappedHook;
		};
	});

	return wrappedHooks;
}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = areOptionsEqual;

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areOptionsEqual(nextOptions, currentOptions) {
	if (currentOptions === nextOptions) {
		return true;
	}

	return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isValidType;

var _isArray = __webpack_require__(12);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidType(type, allowArray) {
	return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
		return isValidType(t, false);
	});
}

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(91);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = exports.isFirefox = undefined;

var _memoize = __webpack_require__(287);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
  return (/firefox/i.test(navigator.userAgent)
  );
});
var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
  return Boolean(window.safari);
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Input; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_generic__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextualMenu__ = __webpack_require__(54);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import { utils } from "zebulon-controls";



var formatValue = function formatValue(props, value, focused) {
  // console.log(1);
  var row = props.row,
      column = props.column,
      status = props.status,
      params = props.params,
      data = props.data,
      inputType = props.inputType,
      editable = props.editable;

  var _ref = column || { dataType: props.dataType },
      dataType = _ref.dataType,
      formatFunction = _ref.formatFunction;

  var v = Object(__WEBPACK_IMPORTED_MODULE_1__utils_generic__["isNullOrUndefined"])(value) ? "" : value;
  if (formatFunction && inputType !== "filter" && !(focused && editable) && dataType !== "boolean") {
    v = formatFunction({ value: v, row: row, column: column, params: params, status: status, data: data });
  } else if (dataType === "boolean" && value === "") {
    v = null;
  } else if (dataType === "date" && value !== null) {
    v = Object(__WEBPACK_IMPORTED_MODULE_1__utils_generic__["dateToString"])(v, undefined || "dd/mm/yyyy");
  } else if (dataType === "number" && value !== null) {
    v = focused && editable ? v.toString() : Object(__WEBPACK_IMPORTED_MODULE_1__utils_generic__["numberToString"])(v);
  }
  return v;
};
var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _initialiseProps.call(_this);

    _this.column = props.column || {
      dataType: props.dataType,
      id: props.id,
      index_: 0,
      caption: props.label
    };
    var value = props.value;
    _this.state = {
      value: value,
      formatedValue: formatValue(props, value, props.focused),
      loaded: true,
      focused: props.focused
    };
    // this.focused = props.focused;
    if (props.select && props.editable && props.focused) {
      var options = props.select;
      if (typeof options === "function") {
        options = options(props.row);
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_generic__["isPromise"])(options)) {
        _this.state.options = [];
        options.then(function (options) {
          _this.setState({ options: options });
        });
      } else {
        _this.state.options = options;
      }
    }
    return _this;
  }

  _createClass(Input, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      this.column = nextProps.column || {
        dataType: nextProps.dataType,
        id: nextProps.id,
        index_: 0,
        caption: nextProps.label
      };

      if (nextProps.value !== this.state.value || nextProps.focused !== this.state.focused) {
        this.setState({
          value: nextProps.value,
          formatedValue: formatValue(nextProps, nextProps.value, nextProps.focused),
          focused: nextProps.focused
        });
      }
      // this.focused = nextProps.focused;
      var options = nextProps.select;
      if (options) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_generic__["isPromise"])(options)) {
          this.setState.options = [];
          options.then(function (options) {
            _this2.setState({ options: options });
          });
        } else {
          this.setState({ options: options });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          row = _props.row,
          editable = _props.editable,
          inputType = _props.inputType,
          hasFocus = _props.hasFocus,
          select = _props.select,
          label = _props.label,
          className = _props.className,
          style = _props.style,
          onMouseDown = _props.onMouseDown,
          onMouseUp = _props.onMouseUp,
          onDoubleClick = _props.onDoubleClick,
          onMouseOver = _props.onMouseOver,
          tabIndex = _props.tabIndex,
          id = _props.id,
          menu = _props.menu,
          component = _props.component;

      var input = void 0;
      var value = this.state.formatedValue;
      var column = this.column;
      var dataType = column.dataType;

      if (inputType !== "filter" && !((this.state.focused || this.props.column === undefined) && editable) && dataType !== "boolean") {
        input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__ContextualMenu__["b" /* ContextualMenuClient */],
          {
            id: id,
            key: id,
            row: row,
            column: column,
            className: className || "zebulon-input zebulon-input-select",
            style: style,
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseOver: onMouseOver,
            onDoubleClick: onDoubleClick,
            ref: function ref(_ref2) {
              return _this3.input = _ref2;
            },
            menu: menu,
            component: component
          },
          value
        );
      } else {
        var innerStyle = {
          textAlign: style.textAlign,
          width: "100%"
        };
        if (inputType === "filter" && dataType !== "boolean") {
          innerStyle.padding = ".4em";
          innerStyle.height = "inherit";
        }
        // label;
        var disabled = !editable || undefined;
        if (select) {
          var options = this.state.options;
          if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === "object") {
            if (column.reference) {
              value = column.primaryKeyAccessorFunction({ row: row });
              options = Object.keys(options).map(function (key) {
                return {
                  id: key,
                  caption: column.accessorFunction({
                    row: _defineProperty({}, column.reference, options[key])
                  })
                };
              });
            } else {
              options = Object.values(options);
            }
            options = [{ id: undefined, label: "" }].concat(options);
          }
          input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "select",
            {
              id: id,
              key: id,
              className: className || "zebulon-input zebulon-input-select",
              onChange: this.handleChange,
              value: value,
              style: innerStyle,
              autoFocus: hasFocus,
              onFocus: this.handleFocus,
              ref: function ref(_ref3) {
                return _this3.input = _ref3;
              }
            },
            options.map(function (item, index) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                "option",
                {
                  key: index,
                  value: (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item.id : item,
                  style: (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item.style || {} : {}
                },
                (typeof item === "undefined" ? "undefined" : _typeof(item)) === "object" ? item.caption : item
              );
            })
          );
        } else if (dataType === "boolean") {
          innerStyle.width = "100%";
          innerStyle.margin = "unset";
          innerStyle.padding = "unset";
          input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "checkbox",
            id: id,
            key: id,
            autoFocus: hasFocus,
            style: innerStyle,
            checked: this.state.value || false,
            disabled: false,
            onChange: this.handleChange,
            onFocus: onMouseDown,
            onMouseUp: onMouseUp,
            tabIndex: tabIndex,
            ref: function ref(_ref4) {
              return _this3.input = _ref4;
            }
          });
        } else {
          // let value = this.state.formatedValue;
          if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_generic__["isNullOrUndefined"])(value) || value === "") {
            value = "";
          }
          input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "text",
            id: id,
            key: id,
            className: className || "zebulon-table-input",
            autoFocus: hasFocus && inputType !== "filter",
            style: innerStyle,
            value: hasFocus && inputType === "filter" ? this.state.value : value,
            disabled: disabled,
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: tabIndex,
            ref: function ref(_ref5) {
              return _this3.input = _ref5;
            }
          });
        }
        if (dataType === "boolean") {
          input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__ContextualMenu__["b" /* ContextualMenuClient */],
            {
              menu: menu,
              component: component,
              id: id,
              key: id,
              row: row,
              column: column,
              className: className,
              style: Object.assign({}, style),
              onDrop: function onDrop(e) {
                return e.preventDefault();
              },
              onDoubleClick: onDoubleClick
            },
            input
          );
        } else {
          input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2__ContextualMenu__["b" /* ContextualMenuClient */],
            {
              menu: menu,
              component: component,
              id: id,
              key: id,
              row: row,
              column: column,
              style: Object.assign({}, style),
              onDrop: function onDrop(e) {
                return e.preventDefault();
              },
              onDoubleClick: onDoubleClick
            },
            input
          );
        }
      }
      if (inputType === "field") {
        input = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "label",
          {
            id: id,
            key: id,
            style: {
              display: "flex",
              justifyContent: "space-between",
              padding: "0.2em"
            }
            // className={this.props.className}
          },
          column.caption,
          input
        );
      }
      return input;
    }
  }]);

  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.validateInput = function (value) {
    var v = value;
    var dataType = _this4.column.dataType;
    if (_this4.props.validateInput) {
      return _this4.props.validateInput(value);
    } else if (dataType === "number") {
      v = value.slice(value.length - 1, value.length) === "." ? value.slice(0, value.length - 1) : value;
      if (v === "-") {
        v = "";
      }
      return !isNaN(Number(v));
    } else if (dataType === "date") {
      v = value.match(/[0123456789.:/ ]+/g) || [];
      return value === "" || v.length === 1 && v[0] === value;
    }
    return true;
  };

  this.handleChange = function (e) {
    var _props2 = _this4.props,
        row = _props2.row,
        editable = _props2.editable,
        inputType = _props2.inputType,
        onChange = _props2.onChange,
        filterTo = _props2.filterTo,
        onMouseDown = _props2.onMouseDown;

    var column = _this4.column;

    var _ref6 = column || { dataType: _this4.props.dataType },
        dataType = _ref6.dataType,
        format = _ref6.format;

    if (editable) {
      var value = e.target.value,
          validatedValue = void 0;
      if (!_this4.validateInput(value)) return;
      // selection of an object
      if (column.reference && column.selectItems) {
        validatedValue = column.selectItems[e.target.value] || {};
      } else if (dataType === "boolean") {
        if (inputType === "filter" && _this4.state.value === false) validatedValue = null;else {
          validatedValue = !_this4.state.value;
          value = validatedValue;
          if (inputType !== "filter" && !_this4.props.focused) {
            onMouseDown(e);
          }
        }
      } else if (dataType === "date") {
        validatedValue = Object(__WEBPACK_IMPORTED_MODULE_1__utils_generic__["stringToDate"])(value, format);
      } else if (dataType === "number") {
        validatedValue = value === "" ? null : Number(value);
        if (isNaN(validatedValue)) {
          validatedValue = null;
        }
      } else {
        validatedValue = value;
      }
      if (onChange) {
        if (onChange(validatedValue, row, column, filterTo) === false) {
          return false;
        }
      }
      if (row) {
        var columnId = column.reference && column.select ? column.reference : column.id;
        row[columnId] = validatedValue;
        if (column.setForeignKeyAccessorFunction && column.reference && column.selectItems) {
          column.setForeignKeyAccessorFunction({
            value: validatedValue.pk_,
            row: row
          });
        }
      }
      _this4.setState({ formatedValue: value, value: validatedValue });
    }
  };

  this.handleBlur = function () {
    _this4.setState({
      formatedValue: formatValue(_this4.props, _this4.state.value, false)
    });
  };

  this.handleFocus = function (e) {
    var _props3 = _this4.props,
        inputType = _props3.inputType,
        onFocus = _props3.onFocus,
        row = _props3.row;

    var column = _this4.column;
    if (inputType === "filter") {
      onFocus(e, row, column);
      if (column.filterType !== "values") {
        // this.focused = true;
        var formatedValue = formatValue(_this4.props, _this4.state.value, true);
        _this4.setState({
          formatedValue: formatedValue,
          focused: true
        });
      }
    } else if (onFocus) {
      onFocus(e, row, column);
    }
  };
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableGrid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScrollableArea__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_generic__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ScrollableGrid = function (_ScrollableArea) {
  _inherits(ScrollableGrid, _ScrollableArea);

  function ScrollableGrid(props) {
    _classCallCheck(this, ScrollableGrid);

    var _this = _possibleConstructorReturn(this, (ScrollableGrid.__proto__ || Object.getPrototypeOf(ScrollableGrid)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      scroll: {
        rows: { index: 0, direction: 1, startIndex: 0, shift: 0, position: 0 },
        columns: {
          index: 0,
          direction: 1,
          startIndex: 0,
          shift: 0,
          position: 0
        }
      },
      selectedRange: props.selectedRange || {
        start: { rows: 0, columns: 0 },
        end: { rows: 0, columns: 0 }
      },
      meta: props.meta
    };
    if (!props.meta) {
      _this.state.meta = {
        visibleIndexes: [0],
        properties: [{ width: props.rowWidth, position: 0, visibleIndex_: 0 }]
      };
    }
    _this.getRowWidth(props.meta, props.locked);
    _this.stopIndex = { rows: -1, columns: -1 };
    return _this;
  }

  _createClass(ScrollableGrid, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.meta !== nextProps.meta) {
        this.setState({ meta: nextProps.meta });
        this.getRowWidth(nextProps.meta, nextProps.locked);
      }
      if (this.props.scroll !== nextProps.scroll && (nextProps.scroll.rows.index !== this.props.scroll.rows.index || nextProps.scroll.rows.direction !== this.props.scroll.rows.direction || nextProps.scroll.columns.index !== this.props.scroll.columns.index || nextProps.scroll.columns.direction !== this.props.scroll.columns.direction)) {
        this.setState({ scroll: nextProps.scroll });
      } else if (nextProps.height !== this.props.height || nextProps.width !== this.props.width) {
        var ratios = this.getRatios(nextProps);
        if (ratios && nextProps.width !== this.props.width && this.ratios && this.ratios.horizontal.position > 1 - Math.min(ratios.horizontal.display, 1)) {
          this.onScroll(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS, null, null, null, null, 1 - Math.min(ratios.horizontal.display, 1));
        }
        if (ratios && nextProps.height !== this.props.height && this.ratios && this.ratios.vertical.position > 1 - Math.min(ratios.vertical.display, 1)) {
          this.onScroll(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS, null, null, null, null, 1 - Math.min(ratios.vertical.display, 1));
        }
      }
      if (this.props.selectedRange !== nextProps.selectedRange) {
        this.setState({ selectedRange: nextProps.selectedRange });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.props.keyEvent !== nextProps.keyEvent) {
        if (nextProps.isActive === undefined || nextProps.isActive) {
          this.handleNavigationKeys(nextProps.keyEvent);
        }
        return false;
      }
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.selectedRange) {
        this.selectedRange({
          start: { rows: 0, columns: 0 },
          end: { rows: 0, columns: 0 }
        });
      }
    }
    // ------------------------------------------------
    // selected range
    // ------------------------------------------------


    // ------------------------------------------------
    // to be overwritten
    // ------------------------------------------------

    // ------------------------------------------------

    // const keyMap = {
    //   9: "tab",
    //   13: "enter",
    //   27: "escape",
    //   33: "pageUp",
    //   34: "pageDown",
    //   35: "end",
    //   36: "home",
    //   37: "leftArrow",
    //   38: "upArrow",
    //   39: "rightArrow",
    //   40: "downArrow",
    //   107: "+",
    //   109: "-",
    //   187: "=",
    //   65: "a",
    //   112: "f1"
    //   48:"0",
    //   96:"numpad0"
    // };


    // -----------------------------------------------
    // default-> list of items
    // -------------------------------------------------

  }]);

  return ScrollableGrid;
}(__WEBPACK_IMPORTED_MODULE_1__ScrollableArea__["a" /* ScrollableArea */]);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getRowWidth = function (meta, locked) {
    _this2.rowWidth = _this2.props.width;
    _this2.lockedWidth = 0;
    if (meta) {
      if (locked) {
        _this2.rowWidth = meta.lockedWidth;
        _this2.lockedWidth = 0;
      } else {
        _this2.lockedWidth = meta.lockedWidth || 0;
        var lastColumn = meta.properties[meta.properties.length - 1];
        _this2.rowWidth = lastColumn.position + lastColumn.computedWidth - _this2.lockedWidth;
      }
    }
  };

  this.selectedRange = function () {
    return _this2.state.selectedRange;
  };

  this.selectedCell = function () {
    var cell = _this2.state.selectedRange.end;
    return !Object(__WEBPACK_IMPORTED_MODULE_3__utils_generic__["isEmpty"])(cell) ? Object.assign({}, cell) : { columns: 0, rows: 0 };
  };

  this.selectCell = function (cell, extension, fromKey) {
    var range = extension ? Object.assign({}, _this2.selectedRange(), { end: cell }) : { start: cell, end: cell };
    if (range.start.rows === undefined) {
      range.start = range.end;
    }
    var scrollOnClick = !fromKey && _this2.props.locked && (cell.rows === _this2.state.scroll.rows.startIndex || cell.rows === _this2.stopIndex.rows);
    return _this2.selectRange(range, scrollOnClick);
  };

  this.selectRange = function (range, scrollOnClick) {
    if (_this2.props.selectRange) {
      _this2.props.selectRange(range, function (ok) {
        if (ok) {
          _this2.setState({ selectedRange: range });
        }
      }, undefined, undefined, undefined, scrollOnClick);
    } else {
      _this2.setState({ selectedRange: range });
    }
  };

  this.scrollOnKey = function (cell, axis, direction, directionColumn, extension) {
    var dataLength = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : _this2.stopIndex[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS)] + 1;

    var scroll = _this2.state.scroll;
    // console.log("scrollonkey", this.props.scroll, this.stopIndex);
    var axisRow = (axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS || axis === null) && _this2.scrollbars && _this2.scrollbars["vertical"].width && (direction === 1 && cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS)] >= Math.min(dataLength - 1, _this2.stopIndex[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS)]) || direction === -1 && cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS)] <= scroll[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS)].startIndex);
    var directionC = axis === null ? directionColumn : direction;
    var axisColumn = (axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS || axis === null) && _this2.scrollbars && _this2.scrollbars["horizontal"] && _this2.scrollbars["horizontal"].width && (directionC === 1 && cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS)] >= _this2.stopIndex[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS)] || directionC === -1 && cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS)] <= scroll[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS)].startIndex);
    var axis_ = void 0;
    if (axis === null && axisRow && axisColumn) {
      axis_ = null;
    } else if ((axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS || axis === null) && axisRow) {
      axis_ = __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS;
    } else if ((axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS || axis === null) && axisColumn) {
      axis_ = __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS;
    }
    if (axis_ !== undefined) {
      _this2.onScroll(axis_, -(axis === null && axis_ === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS ? directionC : direction), -directionColumn, cell, extension);
    }
    _this2.selectCell(cell, extension, true);
  };

  this.nextIndex = function (axis, direction, index, offset) {
    var _props = _this2.props,
        data = _props.data,
        dataLength = _props.dataLength;

    var meta = _this2.state.meta;
    var nextIndex = index;
    if (axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS) {
      if (direction === 1) {
        nextIndex = meta.visibleIndexes[Math.min(meta.visibleIndexes.length - 1, meta.properties[index].visibleIndex_ + offset)];
      } else {
        nextIndex = meta.visibleIndexes[Math.max(meta.visibleIndexes[0], meta.properties[index].visibleIndex_ - offset)];
      }
    } else if (axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS) {
      nextIndex = Math.max(0, Math.min((dataLength || data.length) - 1, index + offset * direction));
    }
    return nextIndex;
  };

  this.nextPageIndex = function (axis, direction, index) {
    // a voir
    var _props2 = _this2.props,
        data = _props2.data,
        dataLength = _props2.dataLength;

    var meta = _this2.state.meta;
    var last = axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS ? meta.visibleIndexes[meta.visibleIndexes.length - 1] : (dataLength || data.length) - 1;
    var first = axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS ? meta.visibleIndexes[0] : 0;
    var offset = _this2.stopIndex[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(axis)] - _this2.state.scroll[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(axis)].startIndex;
    return Math.max(first, Math.min(last, index + offset * direction));
  };

  this.lastIndex = function (axis, direction) {
    var _props3 = _this2.props,
        data = _props3.data,
        meta = _props3.meta,
        dataLength = _props3.dataLength;

    var last = axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS ? meta.visibleIndexes[meta.visibleIndexes.length - 1] : (dataLength || data.length) - 1;
    var first = axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS ? meta.visibleIndexes[0] : 0;
    return direction === 1 ? last : first;
  };

  this.nextCell = function (axis, direction, offset) {
    var cell = _this2.selectedCell();
    cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(axis)] = _this2.nextIndex(axis, direction, cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(axis)], offset);
    return cell;
  };

  this.nextPageCell = function (axis, direction) {
    var cell = _this2.selectedCell();
    cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(axis)] = _this2.nextPageIndex(axis, direction, cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(axis)]);
    return cell;
  };

  this.endCell = function (axis, direction) {
    var cell = _this2.selectedCell();
    cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(axis)] = _this2.lastIndex(axis, direction);
    return cell;
  };

  this.navigationKeyHandler = function (e) {
    var keyCode = e.which || e.keyCode;
    var key = __WEBPACK_IMPORTED_MODULE_3__utils_generic__["keyMap"][keyCode];
    if (!(keyCode > 32 && keyCode < 41 || keyCode === 9)) {
      return false;
    }
    var element = document.activeElement;
    var tagName = element.tagName;
    // keep default behaviour for editable inputs except when alt key is pressed
    if (key !== "Tab" && !e.altKey && (tagName === "TEXTAREA" || tagName === "SELECT" && ["ArrowDown", "ArrowUp"].includes(key) || tagName === "INPUT" && ["ArrowLeft", "ArrowRight"].includes(key))) {
      return false;
    }
    var direction = void 0,
        cell = void 0,
        axis = void 0;
    if (key === "ArrowDown" || key === "ArrowUp") {
      direction = key === "ArrowDown" ? 1 : -1;
      axis = __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS;
      cell = _this2.nextCell(axis, direction, 1);
    } else if (key === "ArrowRight" || key === "ArrowLeft" || key === "Tab") {
      direction = key === "ArrowRight" || key === "Tab" && !e.shiftKey ? 1 : -1;
      axis = __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS;
      cell = _this2.nextCell(axis, direction, 1);
    } else if (key === "PageUp" || key === "PageDown") {
      direction = key === "PageDown" ? 1 : -1;
      axis = e.altKey ? __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS : __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS;
      cell = _this2.nextPageCell(axis, direction);
    } else if (key === "Home" || key === "End") {
      direction = key === "End" ? 1 : -1;
      axis = e.altKey ? __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS : __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS;
      cell = _this2.endCell(axis, direction);
    }
    // selection
    e.preventDefault();
    return { cell: cell, axis: axis, direction: direction, extension: e.shiftKey && key !== "Tab" };
  };

  this.handleNavigationKeys = function (e) {
    if (e.which === 65 && (e.metaKey || e.ctrlKey)) {
      // ctrl+A
      e.preventDefault();
      if (_this2.selectRange({
        start: {
          columns: _this2.lastIndex(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS, -1),
          rows: _this2.lastIndex(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS, -1)
        },
        end: {
          columns: _this2.lastIndex(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS, 1),
          rows: _this2.lastIndex(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS, 1)
        }
      }) === false) {
        return false;
      }
    } else if (!Object(__WEBPACK_IMPORTED_MODULE_3__utils_generic__["isNullOrUndefined"])(_this2.selectedRange().end.rows)) {
      var navigationKeyHandler = _this2.navigationKeyHandler;
      if (_this2.props.navigationKeyHandler) {
        navigationKeyHandler = function navigationKeyHandler(e) {
          return _this2.props.navigationKeyHandler(e, {
            nextCell: _this2.nextCell,
            nextPageCell: _this2.nextPageCell,
            endCell: _this2.endCell,
            selectCell: _this2.selectCell
          });
        };
      }
      var navigation = navigationKeyHandler(e);
      if (navigation) {
        var cell = navigation.cell,
            axis = navigation.axis,
            direction = navigation.direction,
            extension = navigation.extension;

        _this2.scrollOnKey(cell, axis, direction, undefined, extension);
        return Object.assign({}, cell, { axis: axis, direction: direction });
      }
    }
  };

  this.onScroll = function (axis, dir, dirC, cell, extension, positionRatio) {
    var scroll = Object.assign({}, _this2.state.scroll);
    // console.log("scrollable", scroll, cell);
    var _props4 = _this2.props,
        height = _props4.height,
        width = _props4.width,
        rowHeight = _props4.rowHeight,
        data = _props4.data,
        dataLength = _props4.dataLength;

    var meta = _this2.state.meta;
    var properties = meta.properties;
    var newScroll = {
      rows: Object.assign({}, scroll.rows),
      columns: Object.assign({}, scroll.columns)
    };
    var ix = cell ? cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS)] : null;
    var startIndex = ix,
        index = ix,
        direction = axis === null ? dirC : dir,
        shift = 0,
        position = void 0,
        changed = false;

    // scroll event =>scroll by position
    if (axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS || axis === null) {
      if (ix === null && positionRatio !== null) {
        // const lastColumn = properties[properties.length - 1];
        position = _this2.rowWidth * positionRatio;
        var column = properties.find(function (column) {
          var pos = column.position - _this2.lockedWidth;
          return column.computedWidth !== 0 && position >= pos && position < pos + column.computedWidth - 0.0001;
        });
        shift = column.position - position - _this2.lockedWidth;
        direction = 1;
        index = column.index_;
        startIndex = index;
      } else if (direction === 1) {
        startIndex = index;
        position = properties[index].position - _this2.lockedWidth;
      } else {
        var visibleWidth = width - _this2.scrollbars.vertical.width;
        position = Math.max(0, properties[index].position - _this2.lockedWidth + properties[index].computedWidth - visibleWidth);
        var _column = properties.find(function (column) {
          var pos = column.position - _this2.lockedWidth;
          return column.computedWidth !== 0 && position >= pos && position < pos + column.computedWidth;
        });
        startIndex = _column.index_;
        shift = Math.min(0, _column.position - position - _this2.lockedWidth);
      }
      // console.log("scroll", direction, shift, position);
      changed = direction || changed;
      newScroll.columns = {
        index: index,
        direction: direction,
        startIndex: startIndex,
        shift: shift,
        position: position
      };
      // console.log(column, newScroll);
      // scroll by row step
    }
    if (axis === __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS || axis === null) {
      ix = cell ? cell[Object(__WEBPACK_IMPORTED_MODULE_2__constants__["toAxis"])(__WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS)] : null;
      startIndex = ix;
      index = ix;
      direction = dir;
      shift = 0;
      var visibleHeight = height - _this2.scrollbars.horizontal.width2;
      var nRows = Math.ceil(visibleHeight / rowHeight);
      // scroll event
      if (ix === null && positionRatio !== null) {
        startIndex = Math.round((dataLength || data.length) * positionRatio);
        direction = Object(__WEBPACK_IMPORTED_MODULE_3__utils_generic__["isNullOrUndefined"])(dir) ? Math.sign(scroll.rows.startIndex + (scroll.rows.direction === -1 ? 1 : 0) - startIndex) : dir;
        if (direction === 1) {
          index = startIndex;
        } else {
          index = startIndex + nRows - 1;
          if (index >= (dataLength || data.length)) {
            startIndex = Math.max(0, startIndex - index + (dataLength || data.length) - 1);
            index = (dataLength || data.length) - 1;
          }
        }
      } else {
        if (direction === 1) {
          startIndex = index;
        } else if (index - nRows + 1 <= 0) {
          startIndex = 0;
          direction = 1;
        } else {
          startIndex = index - nRows + 1;
        }
      }
      changed = direction || changed;
      newScroll.rows = {
        index: index,
        direction: direction,
        startIndex: startIndex,
        shift: direction === -1 ? visibleHeight - nRows * rowHeight : 0
      };
    }
    if (changed) {
      _this2.setState({ scroll: newScroll });
      if (_this2.props.onScroll) {
        if (_this2.props.onScroll(newScroll, cell, extension) === false) {
          return false;
        }
      }
      return true;
    }
  };

  this.onScrollEvent = function (e) {
    if (e.type === "scrollbar") {
      _this2.onScroll(e.direction === "horizontal" ? __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].COLUMNS : __WEBPACK_IMPORTED_MODULE_2__constants__["AxisType"].ROWS, e.sense, null, null, null, e.positionRatio);
    }
  };

  this.onWheel = function (e) {
    e.preventDefault();
    e.stopPropagation();
    var sense = e.altKey || e.deltaX !== 0 ? "columns" : "rows";
    var delta = e.deltaX === 0 ? e.deltaY : e.deltaX;
    var _props5 = _this2.props,
        height = _props5.height,
        rowHeight = _props5.rowHeight,
        width = _props5.width,
        data = _props5.data,
        dataLength = _props5.dataLength,
        onScroll = _props5.onScroll;

    var scroll = Object.assign({}, _this2.state.scroll);
    var meta = _this2.state.meta;
    var properties = meta.properties;
    var _scroll$sense = scroll[sense],
        shift = _scroll$sense.shift,
        index = _scroll$sense.index,
        startIndex = _scroll$sense.startIndex,
        position = _scroll$sense.position;

    var direction = -Math.sign(delta);
    var visibleHeight = height - _this2.scrollbars.horizontal.width2;
    var nRows = Math.ceil(visibleHeight / rowHeight);

    if (sense === "rows") {
      if (nRows > (dataLength || data.length)) {
        direction = 1;
      }
      shift = direction === 1 ? 0 : visibleHeight - nRows * rowHeight;
      if (direction === -1) {
        startIndex = Math.max(Math.min(scroll.rows.startIndex + (scroll[sense].direction === direction), (dataLength || data.length) - nRows), 0);
        index = startIndex + nRows - 1;
      } else {
        index = Math.max(scroll.rows.startIndex - (scroll[sense].direction === direction), 0);
        startIndex = index;
      }
    } else {
      direction = 1;
      position = Math.min(Math.max(position + delta, 0), _this2.rowWidth - width);
      var column = properties.find(function (column) {
        var pos = column.position - _this2.lockedWidth;
        return column.computedWidth !== 0 && position >= pos && position < pos + column.computedWidth;
      });
      shift = column.position - position - _this2.lockedWidth;
      index = column.index_;
      startIndex = index;
    }
    scroll[sense] = { index: index, direction: direction, startIndex: startIndex, shift: shift, position: position };
    // console.log("wheel", scroll);
    _this2.setState({ scroll: scroll });
    if (onScroll) {
      onScroll(scroll);
    }
  };

  this._getContent = function () {
    var content = _this2.getContent();
    var rows = content.props.children;
    var rowIndex = 0,
        columnIndex = 0;
    if (Array.isArray(rows) && rows.length) {
      rowIndex = _this2.state.scroll.rows.startIndex + rows.length - 1;
      if (rows[0]) {
        var columns = rows[0].props.children;
        if (Array.isArray(columns) && columns.length) {
          columnIndex = (columns[columns.length - 1].props.column || {
            index_: columns.length - 1
          }).index_;
        }
      }
    }
    _this2.stopIndex = { rows: rowIndex, columns: columnIndex };
    return content;
  };

  this.getRatios = function (props) {
    //  a voir pagination manager: data->rows?
    var height = props.height,
        width = props.width,
        rowHeight = props.rowHeight,
        data = props.data,
        meta = props.meta,
        locked = props.locked,
        dataLength = props.dataLength;

    var scroll = _this2.state.scroll;
    if (data.length === 0) {
      return false;
    }
    _this2.getRowWidth(meta, locked);
    var horizontalDisplay = (width - ((data.length || 1) * rowHeight > height ? __WEBPACK_IMPORTED_MODULE_2__constants__["ScrollbarSize"] * !props.noVerticalScrollbar : 0)) / _this2.rowWidth;
    var verticalDisplay = (height - (_this2.rowWidth > width ? __WEBPACK_IMPORTED_MODULE_2__constants__["ScrollbarSize"] : 0)) / ((dataLength || data.length || 1) * rowHeight);
    return {
      vertical: {
        display: verticalDisplay,
        position: Math.min((scroll.rows.startIndex + (scroll.rows.direction === -1 && scroll.rows.shift ? 1 : 0)) / (data.length || 1), 1 - verticalDisplay)
      },
      horizontal: {
        display: horizontalDisplay,
        position: Math.max(Math.min(scroll.columns.position / _this2.rowWidth, 1 - horizontalDisplay), 0)
      }
    };
  };

  this.getContent = function () {
    var _props6 = _this2.props,
        data = _props6.data,
        height = _props6.height,
        rowHeight = _props6.rowHeight;

    var i = 0,
        index = _this2.state.scroll.rows.startIndex;
    var items = [];
    // const visibleWidth = width - this.scrollbars.vertical.width;

    var _loop = function _loop() {
      var selected = index === _this2.state.selectedRange.end.rows;
      var ix = index;
      var onClick = function onClick(e) {
        e.preventDefault();
        _this2.selectCell({ rows: ix, columns: 0 }, e.shiftKey);
      };
      // const onMouseOver = e => {
      //   e.preventDefault();
      //   if ((e.buttons & 1) === 1) {
      //     this.selectCell({ rows: ix, columns: 0 }, true);
      //   }
      // };
      var className = "zebulon-table-cell" + (selected ? " zebulon-table-cell-selected" : "");
      items.push(Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(data[index], {
        className: className,
        index: ix,
        selected: selected,
        onClick: onClick
        // onMouseOver
      }));
      index++;
      i++;
    };

    while (index < data.length && i < height / rowHeight) {
      _loop();
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          position: "absolute",
          top: _this2.state.scroll.rows.shift,
          width: "inherit",
          height: "inherit"
        },
        onWheel: _this2.onWheel
      },
      items
    );
  };
};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollableArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Scrollbar__ = __webpack_require__(300);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// export const ScrollbarSize = 12;
var ScrollableArea = function (_Component) {
  _inherits(ScrollableArea, _Component);

  function ScrollableArea(props) {
    _classCallCheck(this, ScrollableArea);

    var _this = _possibleConstructorReturn(this, (ScrollableArea.__proto__ || Object.getPrototypeOf(ScrollableArea)).call(this, props));

    _this.getRatios = function () {
      return _this.ratios;
    };

    _this.getScrollbars = function (height, width, ratios) {
      var scrollbars = {};
      if (ratios.vertical.display < 1 && !_this.props.noVerticalScrollbar) {
        scrollbars.vertical = { width: __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"] };
      }
      if (ratios.horizontal.display < 1) {
        scrollbars.horizontal = { width: __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"], width2: __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"] };
      }
      if (scrollbars.vertical && scrollbars.horizontal) {
        scrollbars.horizontal.length = width - __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"];
        scrollbars.vertical.length = height - __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"];
      } else if (scrollbars.vertical) {
        scrollbars.vertical.length = Math.min(height, height / ratios.vertical.display);
        scrollbars.horizontal = {
          length: Math.min(width - __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"], ratios.horizontal.size || (width - __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"]) / ratios.horizontal.display
          // width / ratios.horizontal.display
          ),
          width: 0,
          width2: 0
        };
      } else if (scrollbars.horizontal) {
        scrollbars.horizontal.length = Math.min(width, width / ratios.horizontal.display);
        if (_this.props.locked) {
          scrollbars.horizontal.width = 0;
        }
        scrollbars.vertical = {
          length: Math.min(height - __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"], ratios.vertical.size || (height - __WEBPACK_IMPORTED_MODULE_1__constants__["ScrollbarSize"]) / ratios.vertical.display
          // height / ratios.vertical.display
          ),
          width: 0
        };
      } else {
        scrollbars.horizontal = {
          length: Math.min(width, width / ratios.horizontal.display),
          width: 0,
          width2: 0
        };
        scrollbars.vertical = {
          length: Math.min(height, height / ratios.vertical.display),
          width: 0
        };
      }

      scrollbars.horizontal.innerSize = Math.max(30, width * ratios.horizontal.display);
      scrollbars.vertical.innerSize = Math.max(30, height * ratios.vertical.display);
      _this.scrollbars = scrollbars;
      return scrollbars;
    };

    _this._getContent = function () {
      return _this.getContent();
    };

    _this.getContent = function () {
      return [];
    };

    _this.onScrollEvent = function (e) {
      if (e.type === "scrollbar") {
        if (e.initiator === "bar") {
          if (e.direction === "horizontal") {
            _this.ratios.horizontal.position = e.positionRatio;
          } else {
            _this.ratios.vertical.position = e.positionRatio;
          }
          if (_this.props.onScroll) {
            _this.props.onScroll(e);
          }
        }
        return true;
      }
      return false;
    };

    _this.collect = function (e) {
      var button = e.button,
          shiftKey = e.shiftKey,
          target = e.target,
          clientX = e.clientX,
          clientY = e.clientY;

      var initiator = e.target.id.startsWith("thumb") ? "thumb" : "bar";
      var rect = target.getBoundingClientRect();
      var left = rect.left,
          top = rect.top;

      var x = clientX - left,
          y = clientY - top,
          position = Math.max(0, Math.min((_this.props.direction === "horizontal" ? x : y) - _this.innerSize / 2, _this.props.length - _this.innerSize));
      var event = {
        type: "scrollbar",
        direction: _this.props.direction,
        button: button,
        shiftKey: shiftKey,
        clientX: clientX,
        clientY: clientY,
        x: x,
        y: y,
        positionRatio: position / _this.props.length,
        position: position,
        initiator: initiator
      };
      return event;
    };

    _this._handleDrag = function (type, event) {
      var length = _this.scrollbars[event.direction].length;

      var display = _this.ratios[event.direction].display;
      var size = Math.max(display * length, 30);
      if (type === "startDrag") {
        _this.drag[event.direction] = {
          isDragging: true,
          previousPosition: event.position,
          previousPositionRatio: _this.ratios[event.direction].position
        };
        // this.positionRatio = this.props.positionRatio;
      } else if (type === "endDrag") {
        _this.drag[event.direction] = { isDragging: false };
      } else if (type === "drag" && _this.drag[event.direction].isDragging) {
        var drag = _this.drag[event.direction];
        var delta = event.position - drag.previousPosition;
        if (delta) {
          event.positionRatio = Math.min(Math.max(drag.previousPositionRatio + delta / length, 0), 1 - display);
          event.sense = Math.sign(-delta);
          // event.position = length * event.positionRatio;
          if (_this.onScrollEvent(event)) {
            // console.log(
            //   "drag",
            //   event.position,
            //   event.positionRatio,
            //   this.ratios[event.direction].position
            // );
            drag.previousPosition = event.position;
            drag.previousPositionRatio = event.positionRatio;
          }
        }
      } else if (type === "click") {
        if (event.relativePosition + size / 2 > length) {
          event.positionRatio = 1 - display;
        } else {
          event.positionRatio = Math.max(0, (event.relativePosition - size / 2) / length);
        }
        event.sense = Math.sign(_this.ratios[event.direction].position - event.positionRatio);
        _this.onScrollEvent(event);
        // console.log("click area", length, size, event);
      }
    };

    _this._handleMouseMove = function (e) {
      if ((_this.drag.vertical.isDragging || _this.drag.horizontal.isDragging) && e.buttons) {
        e.preventDefault();
        var direction = _this.drag.vertical.isDragging ? "vertical" : "horizontal";
        _this._handleDrag("drag", {
          type: "scrollbar",
          direction: direction,
          position: direction === "horizontal" ? e.clientX : e.clientY
        });
      }
    };

    _this._handleMouseUp = function (e) {
      _this.drag.vertical.isDragging = false;
      _this.drag.horizontal.isDragging = false;
    };

    _this.ratios = {
      vertical: { display: 1, position: 0 },
      horizontal: { display: 1, position: 0 }
    };
    _this.drag = { vertical: {}, horizontal: {} };
    return _this;
  }

  _createClass(ScrollableArea, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          height = _props.height,
          width = _props.width,
          gridId = _props.gridId;


      this.ratios = this.getRatios(this.props);
      if (!this.ratios) {
        return null;
      }
      var scrollbars = this.getScrollbars(height, width, this.ratios);
      var content = this._getContent(height, width);
      var style = {
        position: "relative",
        overflow: "hidden",
        height: scrollbars.vertical.length,
        width: scrollbars.horizontal.length
      };
      // console.log("ratios", this.ratios.horizontal);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          id: "grid " + gridId
          // style={this.props.style || {}}
          , onMouseMove: this._handleMouseMove,
          onMouseUp: this._handleMouseUp
          // onKeyDown={e => this.console.log("KEYDOWN", e1)}
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            id: "scrollable-area",
            style: Object.assign({
              width: width
            }, this.props.style || {}, {
              display: "flex"
              // overflow: "hidden"
              // width
            })
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { id: "scrollable-area-content", style: style },
            content
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Scrollbar__["a" /* Scrollbar */], {
            direction: "vertical",
            width: scrollbars.vertical.width,
            length: scrollbars.vertical.length,
            positionRatio: this.ratios.vertical.position,
            displayRatio: this.ratios.vertical.display,
            id: "vertical-scrollbar " + gridId,
            onScroll: this.onScrollEvent,
            _handleDrag: this._handleDrag
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Scrollbar__["a" /* Scrollbar */], {
          direction: "horizontal",
          width: scrollbars.horizontal.width,
          length: scrollbars.horizontal.length,
          positionRatio: this.ratios.horizontal.position,
          displayRatio: this.ratios.horizontal.display,
          id: "horizontal-scrollbar " + gridId,
          onScroll: this.onScrollEvent,
          _handleDrag: this._handleDrag
        })
      );
    }
  }]);

  return ScrollableArea;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rowHeadersWidthSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return columnHeadersHeightSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cellSizes_selector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__ = __webpack_require__(9);
// required sizes are (taking account of scrollbars size if needed)
//  data cells available sizes
//    - height
//    - width
//  row headers width
//  column headers height
//  + preview sizes or drag and drop
//-------------------------------------------
var rowHeadersWidthSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["i" /* rowVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_1__cellSizes_selector__["f" /* getCellWidthByKeySelector */]],function(rowDimensions,getCellWidthByKey){var width=rowDimensions.reduce(function(width,dimension){return width+dimension.isVisible*getCellWidthByKey(dimension.id);},0);return width;});//----------------------------------------------
var columnHeadersHeightSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["e" /* columnVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_1__cellSizes_selector__["e" /* getCellHeightByKeySelector */]],function(columnDimensions,getCellHeightByKey){return columnDimensions.reduce(function(height,dimension){return height+dimension.isVisible*getCellHeightByKey(dimension.id);},0);});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFilteredIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCellValueSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getCellDimensionInfosSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCellInfosSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRangeInfosSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildDataSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dimensions_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__axis_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(2);
// import { utils.intersection } from "../utils/headers";
// import { dataSelector } from "./data.selector";
var getFilteredIndex=function getFilteredIndex(leaf){if(leaf.isParentCollapsed){return getFilteredIndex(leaf.parent);}else{return leaf.filteredIndexes;}};var cellValue=function cellValue(data,valueAccessor,rowDataIndexes,columnDataIndexes){var aggregation=arguments.length>4&&arguments[4]!==undefined?arguments[4]:function(){return null;};var measureId=arguments[5];var intersection=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].intersection([rowDataIndexes,columnDataIndexes]);// Root headers have undefined data indexes
var intersectionArray=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isUndefined(intersection)?__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].range(0,data.length-1):intersection;// Remove rows for which the accessor gives a null or undefined value
// This allows better behaviour for cells which have a null value
// for example getting an empty cell instead of zero
var edited=false,row={},comments=[],nullLastNewValue=false;var values=intersectionArray// .map(index => (data[index].isFiltered ? null : valueAccessor(data[index])))
.map(function(index){row=data[index];var comment=row._comment;if(measureId&&row._editedMeasure===measureId){if(row._newValue!==row._oldValue){edited=true;nullLastNewValue=row._newValue===null;// row._edited = true;
comment="Value from "+String(row._oldValue)+" to "+String(row._newValue)+(comment?"\n"+comment:"");}else{nullLastNewValue=false;}if(comment){comments.push(comment);}}return valueAccessor({row:data[index]});}).filter(function(value){return!__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(value);});// If we assume that all our measures are numerical we can be more strict
// and keep only rows where the accessor gives a finite number
// This removes Javascript operators weird behaviour with non finite number values.
// Design decision to be made later.
//  const intersectionWithNumericalValue = intersectionArray.filter(
//   i => Number.isFinite(accessor(data[i]))
// );
var value=aggregation(values,data);if(value===0&&nullLastNewValue){value=null;}return{edited:edited,comments:comments,value:value};};var getCellValueSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;}],function(data){return function(valueAccessor,rowDataIndexes,columnDataIndexes){var aggregation=arguments.length>3&&arguments[3]!==undefined?arguments[3]:function(){return null;};var measureId=arguments[4];return cellValue(data,valueAccessor,rowDataIndexes,columnDataIndexes,aggregation,measureId);};});var cellDimensionInfos=function cellDimensionInfos(data,axisDimensions,axis,leaf,measures){var l=leaf;// const depth = axisDimensions.length;
var axisDepth=axisDimensions.map(function(axis){return axis.depth;});var dimension=void 0,depth=void 0;var dimensions=[];// const row = utils.isNullOrUndefined(leaf.dataIndexes)
// ? null
// : data[leaf.dataIndexes[0]];
for(var index=axisDepth.length-1;index>=0;index-=1){depth=axisDepth[index];dimension=axisDimensions[index];// when a leaf is collapsed its parent  has a depth < leaf.depth -1
// we  have to push an empty cell in this case
// if (index > l.depth) {
//   dimensions.push({
//     axis,
//     dimension: {
//       id: dimension.id,
//       caption: dimension.caption,
//       isCollapsed: leaf.isParentCollapsed
//     },
//     cell: { id: null, caption: null }
//   });
// } else
if(dimension.id===__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* MEASURE_ID */]){dimensions.push({axis:axis,dimension:{id:dimension.id,caption:"measures",isCollapsed:false},cell:{id:l.id,caption:measures[l.id].caption}});l=l.parent;}else{dimensions.push({axis:axis,dimension:{id:dimension.id,caption:dimension.caption,isCollapsed:l.isParentCollapsed},cell:{id:l.isParentCollapsed||l.depth!==depth?null:l.id,caption:l.isParentCollapsed||l.depth!==depth?null:l.caption}});if(index>0&&l.depth===depth){while(l.depth>axisDepth[index-1]){l=l.parent;}}}}return dimensions.reverse();};var getCellDimensionInfosSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;}],function(data){return function(axisDimensions,axis,leaf,measures,dimensions){return cellDimensionInfos(data,axisDimensions,axis,leaf,measures,dimensions);};});var getCellInfosSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;},__WEBPACK_IMPORTED_MODULE_3__axis_selector__["h" /* rowLeavesSelector */],__WEBPACK_IMPORTED_MODULE_3__axis_selector__["b" /* columnLeavesSelector */],__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["a" /* activatedMeasuresSelector */],__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["i" /* rowVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["e" /* columnVisibleDimensionsSelector */]],function(data,rowLeaves,columnLeaves,measures,rowDimensions,columnDimensions){return function(cell){var columns=columnDimensions.filter(function(column){return column.isVisible;});var rows=rowDimensions.filter(function(row){return row.isVisible;});var rowLeaf=rowLeaves.leaves[cell.rows];rowLeaf.dataIndexes=getFilteredIndex(rowLeaf);var columnLeaf=columnLeaves.leaves[cell.columns];columnLeaf.dataIndexes=getFilteredIndex(columnLeaf);var measure=void 0;if(rowLeaf.type===__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].MEASURE){measure=measures[rowLeaf.id];}else{measure=measures[columnLeaf.id];}var value=cellValue(data,measure.valueAccessor,rowLeaf.dataIndexes,columnLeaf.dataIndexes,measure.aggregation);var dimensions=[];dimensions=cellDimensionInfos(data,rows,"rows",rowLeaf,measures);dimensions=dimensions.concat(cellDimensionInfos(data,columns,"columns",columnLeaf,measures));var usedData=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].intersection([rowLeaf.dataIndexes,columnLeaf.dataIndexes]).map(function(x){return data[x];});return{value:value,dimensions:dimensions,data:usedData,cell:cell};};});var getRangeInfosSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data.data;},__WEBPACK_IMPORTED_MODULE_3__axis_selector__["h" /* rowLeavesSelector */],__WEBPACK_IMPORTED_MODULE_3__axis_selector__["b" /* columnLeavesSelector */],__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["a" /* activatedMeasuresSelector */],__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["i" /* rowVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_2__dimensions_selector__["e" /* columnVisibleDimensionsSelector */],function(state){return state.configuration.measureHeadersAxis;}],function(data,rowLeaves,columnLeaves,measures,rowDimensions,columnDimensions,measureHeadersAxis){return function(rg){if(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(rg)||__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(rg.start)||__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(rg.end)){return{};}var columnDims=columnDimensions.filter(function(column){return column.isVisible;});var rowDims=rowDimensions.filter(function(row){return row.isVisible;});var range={start:{rows:Math.min(rg.start.rows,rg.end.rows),columns:Math.min(rg.start.columns,rg.end.columns)},end:{rows:Math.max(rg.start.rows,rg.end.rows),columns:Math.max(rg.start.columns,rg.end.columns)}};var rows=[];// letix = 0;
for(var index=range.start.rows;index<=range.end.rows;index+=1){var rowLeaf=rowLeaves.leaves[index];if(rowLeaf.isVisible){rowLeaf.dataIndexes=getFilteredIndex(rowLeaf);var row=cellDimensionInfos(data,rowDims,"rows",rowLeaf,measures);row.leaf=rowLeaf;rows.push(row);}}var columns=[];for(var _index=range.start.columns;_index<=range.end.columns;_index+=1){var columnLeaf=columnLeaves.leaves[_index];if(columnLeaf.isVisible){columnLeaf.dataIndexes=getFilteredIndex(columnLeaf);var column=cellDimensionInfos(data,columnDims,"columns",columnLeaf,measures);column.leaf=columnLeaf;columns.push(column);}}var values=[];rows.forEach(function(row,index){values.push([]);columns.forEach(function(column){var measure=row.leaf.type===__WEBPACK_IMPORTED_MODULE_4__constants__["j" /* HeaderType */].MEASURE?measures[row.leaf.id]:measures[column.leaf.id];var value=cellValue(data,measure.valueAccessor,row.leaf.dataIndexes,column.leaf.dataIndexes,measure.aggregation);values[index].push(value);});});return{values:values,columns:columns,rows:rows,range:range,measureHeadersAxis:measureHeadersAxis};};});var buildData=function buildData(dimensions,measures,leaf,value,data){if(leaf.dimensionId===__WEBPACK_IMPORTED_MODULE_4__constants__["m" /* MEASURE_ID */]){data[measures[leaf.id].datasetProperties.value]=value;}else{var properties=dimensions[leaf.dimensionId].datasetProperties;data[properties.id]=leaf.id;data[properties.label]=leaf.caption;data[properties.sort]=leaf.sortKey;}var parent=leaf.parent;if(parent&&parent.id!==__WEBPACK_IMPORTED_MODULE_4__constants__["q" /* ROOT_ID */]){buildData(dimensions,measures,parent,value,data);}};var buildDataSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.dimensions;},function(state){return state.measures;},function(state){return state.configuration.measureHeadersAxis;}],function(dimensions,measures,measureHeadersAxis){return function(rowLeaf,columnLeaf,oldValue,newValue,comment){var data={};var value=newValue-oldValue;buildData(dimensions,measures,rowLeaf,value,data);buildData(dimensions,measures,columnLeaf,value,data);data._editedMeasure=measureHeadersAxis==="rows"?rowLeaf.id:columnLeaf.id;if(newValue!==oldValue){data._oldValue=oldValue;data._newValue=newValue;}if(!(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(comment)||comment==="")){data._comment=comment;}return data;};});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "count", function() { return count; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sum", function() { return sum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "min", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "max", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "avg", function() { return avg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "weighted_avg", function() { return weighted_avg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "delta", function() { return delta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prod", function() { return prod; });
var count=function count(values){return values.length;};var sum=function sum(values){return values.reduce(function(sum,value){return sum+=value;},null);};var min=function min(values){return values.reduce(function(min,value){return min=min===null||value<min?value:min;},null);};var max=function max(values){return values.reduce(function(max,value){return max=max===null||value>max?value:max;},null);};var avg=function avg(values){return values.length===0?null:sum(values)/values.length;};var weighted_avg=function weighted_avg(values){var wavg=values.reduce(function(wavg,value){wavg.v0+=value.v0;wavg.v1+=value.v1;return wavg;},{v0:null,v1:null});return wavg.v0===null&&wavg.v1===null?null:wavg.v0/wavg.v1;};var delta=function delta(values){var delta=values.reduce(function(delta,value){delta.v0+=value.v0;delta.v1+=value.v1;return delta;},{v0:null,v1:null});return delta.v0-delta.v1;};var prod=function prod(values){return values.reduce(function(prod,value){return prod*=value;},null);};// function forEachIntersection(accessor, intersection, data, callback) {
//   if (intersection && intersection.length > 0) {
//     // for (let i = 0; i < intersection.length; i += 1) {
//     //   const row=data[intersection[i]];
//     //   callback(accessor(row));
//     // }
//     intersection.map(index=>{const row =data[index];
//       if(!row.isFiltered){callback(accessor(row))};
//   }
// }
// export function calcVariance(accessor, intersection, data, population) {
//   let variance = 0;
//   let avg = null;
//   const len = intersection.length;
//   if (len > 0) {
//     if (population || len > 1) {
//       forEachIntersection(accessor, intersection, data, val => {
//         avg += val;
//       });
//       avg /= len;
//       forEachIntersection(accessor, intersection, data, val => {
//         variance += (val - avg) * (val - avg);
//       });
//       variance /= population ? len : len - 1;
//     } else {
//       variance = NaN;
//     }
//   }
//   return variance;
// }
// export function stdev(accessor, intersection, data) {
//   return Math.sqrt(calcVariance(accessor, intersection, data, false));
// }
// export function stdevp(accessor, intersection, data) {
//   return Math.sqrt(calcVariance(accessor, intersection, data, true));
// }
// /* eslint-disable no-underscore-dangle */
// export function _var(accessor, intersection, data) {
//   return calcVariance(accessor, intersection, data, false);
// }
// /* eslint-enable */
// export function varp(accessor, intersection, data) {
//   return calcVariance(accessor, intersection, data, true);
// }

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__ = __webpack_require__(1);
// import { isNullOrUndefined } from "../../utils/generic";
console.log("icons",__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["i" /* icons */]);// -------------------------------
var headerSpec={drop:function drop(props,monitor,component){var handle=monitor.getItem();if(props.id===__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]&&handle.id===__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]&&props.measureId&&handle.measureId!==props.measureId){props.moveMeasure(handle.measureId,props.measureId);}else if(handle.id!==props.id){var newAxis=void 0,index=void 0;if(props.id===__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]&&handle.id===__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]){if(handle&&handle.measureId){props.moveMeasure(handle.measureId,props.measureId);}}else if((handle.id===__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]||handle.id===__WEBPACK_IMPORTED_MODULE_2__constants__["C" /* TOTAL_ID */])&&props.id!==__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]&&handle.axis!==props.axis){(handle.toggleMeasuresAxis||props.toggleMeasuresAxis)(handle.axis===__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AxisType */].ROWS?"columns":"rows");}else{if(props.id===__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* MEASURE_ID */]||props.id===__WEBPACK_IMPORTED_MODULE_2__constants__["C" /* TOTAL_ID */]){newAxis=Object(__WEBPACK_IMPORTED_MODULE_2__constants__["F" /* toAxis */])(handle.axis===__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AxisType */].ROWS?__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AxisType */].COLUMNS:__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AxisType */].ROWS);index=0;}else{newAxis=Object(__WEBPACK_IMPORTED_MODULE_2__constants__["F" /* toAxis */])(props.axis);index=props.index+1;}if(Object(__WEBPACK_IMPORTED_MODULE_2__constants__["F" /* toAxis */])(handle.axis)!==newAxis||handle.index!==index){props.moveDimension(handle.id,Object(__WEBPACK_IMPORTED_MODULE_2__constants__["F" /* toAxis */])(handle.axis),newAxis,index);}}}}};var InnerHeaderSpec={beginDrag:function beginDrag(props){return props;}};var collectDragSource=function collectDragSource(connect,monitor){return{connectDragSource:connect.dragSource(),connectDragPreview:connect.dragPreview(),isDragging:monitor.isDragging()};};var collectDropTarget=function collectDropTarget(connect){return{connectDropTarget:connect.dropTarget()};};// --------------------------------
var innerHeader=function innerHeader(_ref){var axis=_ref.axis,id=_ref.id,measureId=_ref.measureId,key=_ref.key,index=_ref.index,caption=_ref.caption,isNotCollapsible=_ref.isNotCollapsible,isCollapsed=_ref.isCollapsed,collapseOffset=_ref.collapseOffset,handleClick=_ref.handleClick,handleClickCollapse=_ref.handleClickCollapse,toggleMeasuresAxis=_ref.toggleMeasuresAxis,moveDimension=_ref.moveDimension,moveMeasure=_ref.moveMeasure,connectDragSource=_ref.connectDragSource,connectDropTarget=_ref.connectDropTarget,isDropTarget=_ref.isDropTarget,isDragSource=_ref.isDragSource,gridId=_ref.gridId,zoom=_ref.zoom;var computedStyle={whiteSpace:"nowrap",overflow:"hidden",display:"-webkit-box",width:"inherit"};var collapsedIcon=void 0;if(!isCollapsed&&!isNotCollapsible){collapsedIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{background:__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["i" /* icons */].downArrow,backgroundSize:"cover",height:"1em",width:"1em",marginTop:"0.1em",marginRight:"0.1em"},onClick:handleClickCollapse});}else if(isCollapsed&&!isNotCollapsible){collapsedIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{background:__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["i" /* icons */].rightArrow,backgroundSize:"cover",height:"1em",width:"1em",marginTop:"0.1em",marginRight:"0.1em"},onClick:handleClickCollapse});}else{collapsedIcon=null;// collapsedIcon = (
//   <div
//     style={{
//       height: "1em",
//       width: "1em",
//       marginTop: "0.1em",
//       marginRight: "0.1em"
//     }}
//   />
// );
}var style={width:"-webkit-fill-available"};if(collapseOffset||collapsedIcon){if(axis===__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* AxisType */].ROWS){style.paddingRight=(collapseOffset||0)+(collapsedIcon?18*(zoom||1):0);}else{style.paddingBottom=collapseOffset;style.paddingRight=collapsedIcon?18*(zoom||1):0;}}var header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:style,onClick:handleClick},caption);header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"zebulon-grid-header-inner",style:computedStyle},collapsedIcon,header);if(isDragSource){header=connectDragSource(header);}// dimension header -> drop target
if(isDropTarget){header=connectDropTarget(header);}return header;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["DropTarget"])(function(props){return"cell-inner-header--"+props.gridId;},headerSpec,collectDropTarget)(Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["DragSource"])(function(props){return"cell-inner-header--"+props.gridId;},InnerHeaderSpec,collectDragSource)(innerHeader)));

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd__);
var resizeHandleSpec={beginDrag:function beginDrag(props){return props;}};var sourceCollect=function sourceCollect(connect,monitor){return{connectDragSource:connect.dragSource(),connectDragPreview:connect.dragPreview(),isDragging:monitor.isDragging()};};var ResizeHandle=function ResizeHandle(_ref){var position=_ref.position,size=_ref.size,connectDragSource=_ref.connectDragSource;var handle=void 0;if(position==="right"){handle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"absolute",right:0,width:4,height:size,cursor:"col-resize",opacity:0}});}else if(position==="bottom"){handle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"absolute",bottom:0,height:4,width:size,cursor:"row-resize",opacity:0}});}else{handle=null;}return connectDragSource(handle);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["DragSource"])(function(props){return"cell-resize-handle--"+props.gridId;},resizeHandleSpec,sourceCollect)(ResizeHandle));

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header_Header__ = __webpack_require__(321);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Grid as ReactVirtualizedGrid } from "react-virtualized/dist/commonjs/Grid";
var AxisType=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].AxisType,ROOT_ID=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].ROOT_ID,MEASURE_ID=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].MEASURE_ID;var Headers=function(_PureComponent){_inherits(Headers,_PureComponent);function Headers(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Headers);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Headers.__proto__||Object.getPrototypeOf(Headers)).call.apply(_ref,[this].concat(args))),_this),_this.componentWillReceiveProps=function(nextProps){if(nextProps.headers!==_this.props.headers){_this.cellCache={};}},_this.collectMenu=function(props){return Object.assign({},props,{availableMeasures:_this.props.availableMeasures,measures:_this.props.measures,features:_this.props.features});},_this.affixOffsets=function(firstHeader,offset){var offsets={};var position=firstHeader.sizes.main.position;var header=firstHeader;while(header.parent&&header.parent.id!==ROOT_ID){header=header.parent;offsets[header.depth]=position-header.sizes.main.position;}return offsets;},_this.cellRenderer=function(header,offset,affix,lastSize){var _this$props=_this.props,gridId=_this$props.gridId,selectAxis=_this$props.selectAxis,toggleMeasuresAxis=_this$props.toggleMeasuresAxis,moveDimension=_this$props.moveDimension,toggleMeasure=_this$props.toggleMeasure,moveMeasure=_this$props.moveMeasure,toggleCollapse=_this$props.toggleCollapse,axisType=_this$props.axisType,previewSizes=_this$props.previewSizes,measures=_this$props.measures,features=_this$props.features,status=_this$props.status,zoom=_this$props.zoom;var positionStyle={position:"absolute",left:axisType===AxisType.ROWS?header.sizes.cross.position:header.sizes.main.position-offset,top:axisType===AxisType.COLUMNS?header.sizes.cross.position:header.sizes.main.position-offset,height:axisType===AxisType.ROWS?header.sizes.main.size:header.sizes.cross.size,width:axisType===AxisType.COLUMNS?header.sizes.main.size:header.sizes.cross.size};// affix management to keep labels on screen (except for leaves)
if(header.sizes.affix&&affix){var affixOffset=Math.min(affix+offset,Math.max(header.sizes.main.size-lastSize,0));if(axisType===AxisType.COLUMNS){positionStyle.paddingLeft=affixOffset;}else{positionStyle.paddingTop=affixOffset;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header_Header__["a" /* default */],{key:"header-"+header.key,header:header,axis:axisType,caption:header.format({value:header.caption}),positionStyle:positionStyle,dimensionId:header.dimensionId,isNotCollapsible:header.options.isNotCollapsible||header.isAttribute||header.isTotal,isCollapsed:header.isCollapsed,collapseOffset:header.sizes.cross.collapsed?header.sizes.cross.collapsed:0,isDropTarget:header.options.isDropTarget,isDragSource:header.dimensionId===MEASURE_ID&&Object.keys(_this.props.measures||{}).length>1,gridId:gridId,selectAxis:selectAxis,toggleMeasuresAxis:toggleMeasuresAxis,toggleMeasure:toggleMeasure,moveMeasure:moveMeasure,moveDimension:moveDimension,toggleCollapse:toggleCollapse,collectMenu:_this.collectMenu,previewSizes:previewSizes,measuresCount:measures===null||Object.keys(measures).length,features:features,zoom:zoom});},_this.cellsRenderer=function(){var headers=_this.props.axisType===AxisType.ROWS?_this.props.rows:_this.props.columns;if(headers===undefined||!headers.cells.length){return[];}var cells=[];headers.cells.map(function(header){return header.map(function(cell){return cells.push(_this.cellRenderer(cell,headers.offset,headers.affix,headers.lastSize));});});return cells;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Headers,[{key:"render",value:function render(){var _props=this.props,height=_props.height,width=_props.width,axisType=_props.axisType,gridId=_props.gridId;var cells=this.cellsRenderer();var style={position:"relative",overflow:"hidden",height:height,width:width};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:__WEBPACK_IMPORTED_MODULE_1_classnames___default()({"zebulon-grid-column-headers":axisType===AxisType.COLUMNS,"zebulon-grid-row-headers":axisType===AxisType.ROWS}),id:"headers - "+axisType+" - "+gridId,style:style},cells);}}]);return Headers;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Headers);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(117);

var implementation = __webpack_require__(118);
var getPolyfill = __webpack_require__(125);
var shim = __webpack_require__(341);

var polyfill = getPolyfill();

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(327);
var foreach = __webpack_require__(329);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

var toStr = Object.prototype.toString;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
        /* eslint-disable no-unused-vars, no-restricted-syntax */
        for (var _ in obj) { return false; }
        /* eslint-enable no-unused-vars, no-restricted-syntax */
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = Object.defineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		Object.defineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = props.concat(Object.getOwnPropertySymbols(map));
	}
	foreach(props, function (name) {
		defineProperty(object, name, map[name], predicates[name]);
	});
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(330);
var has = __webpack_require__(37);
var bind = __webpack_require__(60);
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

module.exports = function values(O) {
	var obj = ES.RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 122 */
/***/ (function(module, exports) {

var has = Object.prototype.hasOwnProperty;
module.exports = function assign(target, source) {
	if (Object.assign) {
		return Object.assign(target, source);
	}
	for (var key in source) {
		if (has.call(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(118);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZebulonTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_compute_meta__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MetaDescriptions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_compute_data__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_filters_sorts__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_utils__ = __webpack_require__(13);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var ZebulonTable = function (_Component) {
  _inherits(ZebulonTable, _Component);

  function ZebulonTable(props) {
    _classCallCheck(this, ZebulonTable);

    var _this = _possibleConstructorReturn(this, (ZebulonTable.__proto__ || Object.getPrototypeOf(ZebulonTable)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      meta: props.meta,
      updatedRows: props.updatedRows || {},
      sizes: props.sizes || {},
      keyEvent: props.keyEvent,
      confirmationModal: false,
      params: props.params || {},
      sorts: props.sorts || {}
    };
    props.sizes.zoom = props.sizes.zoom || 1;
    _this.keyEvent = false;
    // functions
    _this.state.functions = _this.initFunctions(props.functions, props.meta.table.object);
    _this.sorts = _this.state.sorts;

    var _this$getData = _this.getData(props),
        data = _this$getData.data,
        status = _this$getData.status,
        filters = _this$getData.filters;

    _this.state.data = data;
    _this.state.status = status;
    _this.state.filters = filters;
    _this.saveConfirmationAnswer = function (ok) {
      return ok;
    };
    return _this;
  }

  _createClass(ZebulonTable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.keyEvent === undefined) {
        document.addEventListener("copy", this.handleCopy);
        document.addEventListener("paste", this.handlePaste);
        document.addEventListener("keydown", this.handleKeyEvent);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.keyEvent === undefined) {
        document.removeEventListener("copy", this.handleCopy);
        document.removeEventListener("paste", this.handlePaste);
        document.removeEventListener("keydown", this.handleKeyEvent);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var data = nextProps.data,
          meta = nextProps.meta,
          sizes = nextProps.sizes,
          keyEvent = nextProps.keyEvent,
          updatedRows = nextProps.updatedRows,
          filters = nextProps.filters,
          status = nextProps.status,
          saveConfirmationRequired = nextProps.saveConfirmationRequired,
          refresh = nextProps.refresh;


      if (this.props.keyEvent !== keyEvent) {
        this.handleKeyEvent(keyEvent);
      } else {
        var _functions = this.state.functions;
        if (nextProps.functions !== this.props.functions) {
          var state = this.state;
          state.functions = this.initFunctions(nextProps.functions, nextProps.meta.table.object);
        }
        if (this.props.sizes !== sizes) {
          this.setState({ sizes: sizes });
        }
        if (updatedRows && this.props.updatedRows !== updatedRows) {
          this.setState({ updatedRows: updatedRows });
        }
        if (this.props.data !== data || this.props.status !== status || this.props.filters !== filters || this.props.refresh !== refresh) {
          var ok = true;
          if (!saveConfirmationRequired && !this.props.saveConfirmationRequired) {
            ok = this.onTableChange("refresh", function (ok) {
              if (ok) {
                _this2.setState(_this2.getData(nextProps));
              }
            });
          }
          if (ok) {
            this.setState(this.getData(nextProps));
          }
        }
      }
      if (saveConfirmationRequired && !this.props.saveConfirmationRequired) {
        this.onTableChange("close", saveConfirmationRequired);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (this.keyEvent && !this.confirmationModal) {
        this.keyEvent = false;
        return false;
      }
      this.keyEvent = false;
      return true;
    }
    // ----------------------------------------
    // comunication with server
    // ----------------------------------------

    // confirmation modal management

    // foreign key modal

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var style = {
        fontSize: (this.props.isModal ? 1 : this.state.sizes.zoom) * 100 + "%",
        position: "relative"
      };
      var div = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: style,
          className: "zebulon-table",
          id: "zebulon-table-" + this.props.id
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Table__["a" /* Table */], {
          id: this.props.id,
          style: this.props.style,
          status: this.state.status,
          data: this.state.data,
          meta: this.state.meta,
          params: this.props.params,
          filters: this.state.filters,
          updatedRows: this.state.updatedRows,
          key: this.props.id,
          visible: this.props.visible === undefined ? true : this.props.visible
          // sizes={this.state.sizes}
          , width: this.state.sizes.width,
          height: this.state.sizes.height,
          zoom: this.state.sizes.zoom,
          rowHeight: (this.state.sizes.rowHeight || 25) * (this.state.sizes.zoom || 1),
          isActive: this.props.isActive,
          onActivation: this.props.onActivation,
          ref: function ref(_ref) {
            return _this3.table = _ref;
          },
          getActions: this.props.getActions,
          onChange: this.props.onChange,
          onDoubleClick: this.props.onDoubleClick,
          onCellEnter: this.props.onCellEnter,
          onCellQuit: this.props.onCellQuit,
          onRowNew: this.props.onRowNew,
          onRowDelete: this.props.onRowDelete,
          onRowEnter: this.props.onRowEnter,
          onRowQuit: this.props.onRowQuit,
          onTableEnter: this.props.onTableEnter,
          onTableChange: this.onTableChange,
          onTableQuit: this.props.onTableQuit,
          onTableClose: this.props.onTableClose,
          onFilter: this.props.onFilter,
          onSort: this.props.onSort,
          select: this.props.select,
          onGetData: this.props.onGetData,
          onGetPage: this.props.onGetPage,
          onSave: this.onSave,
          callbacks: this.props.callbacks,
          errorHandler: this.errorHandler,
          navigationKeyHandler: this.props.navigationKeyHandler,
          contextualMenu: this.props.contextualMenu,
          callbackForeignKey: this.props.callbackForeignKey,
          onForeignKey: this.onForeignKey,
          isModal: this.props.isModal,
          modal: this.state.confirmationModal || this.state.modalCancel,
          utils: this.props.utils
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["a" /* ConfirmationModal */], {
          show: this.state.confirmationModal,
          detail: this.state.modal,
          onConfirm: this.onConfirm,
          keyEvent: this.state.keyEvent,
          ref: function ref(_ref2) {
            return _this3.modal = _ref2;
          }
        })
      );
      return div;
    }
  }]);

  return ZebulonTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.initFunctions = function (functions_, object) {
    if (Array.isArray(functions_)) {
      return functions_;
    } else {
      return __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].mergeFunctions([__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["g" /* accessors */], __WEBPACK_IMPORTED_MODULE_5__MetaDescriptions__["a" /* functions */], functions_ || {}], object || "dataset");
    }
  };

  this.setFilters = function (filters, columns) {
    columns.forEach(function (column) {
      if (filters[column.id]) {
        column.filterType = filters[column.id].filterType;
        column.v = filters[column.id].v;
        column.vTo = filters[column.id].vTo;
        filters[column.id] = column;
      } else if (!__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.v) || column.filterType === "between" && !__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isNullOrUndefined(column.vTo)) {
        filters[column.id] = column;
      }
    });
    return filters;
  };

  this.setSorts = function (sorts, columns) {
    columns.forEach(function (column) {
      if (sorts[column.id]) {
        column.sortOrder = sorts[column.id].sortOrder;
        column.sort = sorts[column.id].direction;
      } else {
        column.sortOrder = undefined;
        column.sort = undefined;
      }
    });
  };

  this.getData = function (props, sorts) {
    _this4.observable = null;
    var data = props.data,
        meta = props.meta,
        params = props.params,
        filters = props.filters,
        filteredData = props.filteredData,
        status = { loaded: false, loading: true };

    var message = {
      dataObject: meta.table.object,
      params: params,
      meta: meta,
      filters: Object(__WEBPACK_IMPORTED_MODULE_7__utils_filters_sorts__["b" /* getFilters */])(meta.properties, filters || {}),
      sorts: _this4.sorts ? Object.values(_this4.sorts) : Object(__WEBPACK_IMPORTED_MODULE_7__utils_filters_sorts__["c" /* getSorts */])(meta.properties)
    };
    if (typeof data === "function") {
      data = data(message);
    } else if (meta && props.select || meta.table.select) {
      data = props.select || __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].getFunction(_this4.state.functions, "dml", meta.table.select, props.utils);
      data = data(message);
    }
    if (Array.isArray(data)) {
      status = { loaded: true, loading: false };
      if (meta.table.noDataMutation) {
        data = [].concat(_toConsumableArray(data));
      }
      _this4.initData(data, meta, _this4.state.zoom, _this4.state.functions, 0, filters, sorts, status);
      _this4.subscribe(message, _this4.state.meta.table.subscription);
    } else if (__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isPromise(data)) {
      _this4.resolvePromise(data, message);
    } else if (__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isObservable(data)) {
      _this4.subscribeObservable(data, message);
      data = [];
    } else {
      data = [];
    }
    // }
    return { data: data, meta: meta, status: status, filters: filters, sorts: sorts };
  };

  this.initData = function (data, meta, zoom, functions, startIndex, filters, status) {
    if (Array.isArray(data)) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_compute_meta__["b" /* computeMetaFromData */])(data, meta, zoom, functions, _this4.props.utils, (_this4.props.params || {}).privileges_);
      Object(__WEBPACK_IMPORTED_MODULE_6__utils_compute_data__["d" /* computeData */])(data, meta, startIndex);
      if (_this4.props.filteredData && meta.indexPk) {
        var updatedRows = _this4.state.updatedRows;
        Object.values(_this4.props.filteredData).forEach(function (data) {
          return updatedRows[meta.indexPk[data.id]] = data;
        });
      }
      if (_this4.props.onGetData) {
        _this4.props.onGetData({ data: data, meta: meta, status: status });
      }
    }
    _this4.initSizes(meta, data);
    if (filters && meta.properties.length !== 0) {
      _this4.setFilters(filters, meta.properties);
    }
    // sorts are applied only the first time
    if (_this4.sorts && meta.properties.length !== 0) {
      _this4.setSorts(_this4.sorts, meta.properties);
      _this4.sorts = null;
    }
  };

  this.resolvePromise = function (data, message) {
    data.then(function (data) {
      var _state = _this4.state,
          meta = _state.meta,
          functions = _state.functions,
          filters = _state.filters,
          sizes = _state.sizes;

      var status = { loaded: true, loading: false };
      if (!meta.serverPagination) {
        _this4.initData(data, meta, sizes.zoom, functions, 0, filters, status);
      } else if (meta.properties.length === 0) {
        data({ startIndex: 0 }).then(function (page) {
          _this4.initData(page.page, meta, sizes.zoom, functions, 0, filters, status);
        });
        _this4.setState({ data: data, status: status });
        return data;
      }
      _this4.setState({ data: data, status: status });
      _this4.subscribe(message, meta.table.subscription);
      return data;
    }).catch(function (error) {
      return _this4.setState({
        data: [],
        status: { loaded: false, loading: false, error: error }
      });
    });
  };

  this.subscribeObservable = function (observable, message) {
    _this4.observable = observable;
    _this4.observable.subscribe(function (x) {
      var status = { loaded: true, loading: false };

      _this4.initData(x, _this4.state.meta, _this4.state.sizes.zoom, _this4.state.functions, _this4.state.data.length, _this4.state.filters, status);
      if (_this4.observable) {
        _this4.setState({
          data: _this4.state.data.concat(x),
          meta: _this4.state.meta,
          status: status
        });
      }
    }, function (e) {
      return _this4.setState({
        data: [],
        status: { loaded: false, loading: false, error: e }
      });
    }, function () {
      _this4.setState({ status: { loaded: true, loading: false } });
      _this4.subscribe(message, _this4.state.meta.table.subscription);
      // console.log("end");
      // this.observable.unsubscribe();
    });
  };

  this.subscribe = function (message, subscription) {
    if (subscription) {
      var _state2 = _this4.state,
          data = _state2.data,
          meta = _state2.meta,
          updatedRows = _state2.updatedRows;

      message.index = meta.indexRowId || meta.indexPk;
      message.data = data;
      message.updatedRows = updatedRows;
      _this4.observable = subscription.observableFunction(message);
      var _subscription$observe = subscription.observerFunctions,
          onNext = _subscription$observe.onNext,
          onError = _subscription$observe.onError,
          onCompleted = _subscription$observe.onCompleted;

      var onNextFunction = function onNextFunction(data) {
        onNext(data, message);
        _this4.setState({ status: { loaded: true, loading: false } });
      };
      var onErrorFunction = function onErrorFunction(error) {
        onError(error, message);
        _this4.setState({ status: { loaded: false, loading: false, error: error } });
      };
      _this4.observable.subscribe(onNextFunction, onErrorFunction, function () {
        return onCompleted(message);
      });
    }
  };

  this.initSizes = function (meta, data) {
    var sizes = _this4.state.sizes;

    if (!sizes.height || !sizes.width) {
      var tableSizes = Object(__WEBPACK_IMPORTED_MODULE_4__utils_compute_meta__["d" /* getSizes */])(meta, sizes.rowHeight || meta.row.height || 25);
      // if (this.props.isModal) {
      //   tableSizes.headersHeight += 30;
      // }
      if (!sizes.height && data) {
        sizes.height = meta.table.height || Math.min(sizes.maxHeight || 1000, Math.max(sizes.minHeight || 100, tableSizes.headersHeight + data.length * tableSizes.rowHeight));
      }
      if (!sizes.width) {
        var scrollbarSize = tableSizes.headersHeight + data.length * tableSizes.rowHeight > (sizes.maxHeight || 1000) ? __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["h" /* constants */].ScrollbarSize : 0;
        sizes.width = meta.row.width || Math.min(sizes.maxWidth || 2000, Math.max(sizes.minWidth || 100, tableSizes.headersWidth + tableSizes.rowWidth + scrollbarSize));
      }
    }
  };

  this.handleKeyEvent = function (e) {
    if (_this4.confirmationModal) {
      _this4.setState({ keyEvent: e });
      return;
    } else if (_this4.state.keyEvent) {
      _this4.setState({ keyEvent: null });
    }
    var zoom = __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["j" /* utils */].isZoom(e);
    if (zoom && (_this4.props.isActive === undefined || _this4.props.isActive)) {
      e.preventDefault();
      var sizes = _this4.state.sizes;
      sizes.zoom *= zoom === 1 ? 1.1 : 1 / 1.1;
      _this4.setState({ sizes: Object.assign({}, sizes) });
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_compute_meta__["a" /* computeMeta */])(_this4.state.meta, sizes.zoom, _this4.state.functions, _this4.props.utils, (_this4.props.params || {}).privileges_);
      return;
    }
    if (_this4.props.keyEvent) {
      _this4.keyEvent = true;
    }
    if (!_this4.table) {
      return;
    } else if (e.type === "copy") {
      _this4.handleCopy(e);
    } else if (e.type === "paste") {
      _this4.handlePaste(e);
    } else if (e.type === "keydown") {
      _this4.handleKeyDown(e);
    }
  };

  this.handleKeyDown = function (e) {
    if (!e.defaultPrevented && _this4.table.handleKeyDown && (_this4.props.isActive === undefined || _this4.props.isActive)) {
      _this4.table.handleKeyDown(e);
    }
  };

  this.handleCopy = function (e) {
    if (!e.defaultPrevented && _this4.table.handleCopy && (_this4.props.isActive === undefined || _this4.props.isActive)) {
      _this4.table.handleCopy(e);
    }
  };

  this.handlePaste = function (e) {
    if (!e.defaultPrevented && _this4.table.handlePaste && (_this4.props.isActive === undefined || _this4.props.isActive)) {
      _this4.table.handlePaste(e);
    }
  };

  this.errorHandler = function (message, action, callback) {
    var handler = (_this4.props.errorHandler || __WEBPACK_IMPORTED_MODULE_8__utils_utils__["b" /* errorHandler */])[action];
    if (action === "onTableQuit" && !(message.updatedRows || {}).nErrors || action === "onSave" && !(message.updatedRows || {}).nErrorsServer) {
      handler = null;
    } else if (action === "onRowQuit" && !((message.status || {}).errors || {}).n_) {
      handler = null;
    }
    if (handler) {
      var ok = handler(message);
      var body = message.modalBody;
      message.modalBody = null;
      var conflicts = message.conflicts;
      message.conflicts = null;
      if (ok === false) {
        if (body) {
          _this4.confirmationModal = true;
          _this4.setState({
            confirmationModal: true,
            modal: { body: body, type: "Ok" }
          });
        }
        return false;
      } else if (body) {
        _this4.confirmationModal = true;
        var type = action === "onTableChange" ? "YesNoCancel" : "YesNo";
        _this4.setState({
          confirmationModal: true,
          modal: { body: body, type: type, callback: callback }
        });
        return;
      } else if (conflicts) {
        var resolveConflicts = function resolveConflicts(ok, data) {
          if (ok) {
            // back to server version
            data.forEach(function (index) {
              var row = conflicts[index].server;
              row.index_ = index;
              message.updatedRows[index].row = row;
              Object(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["i" /* rollback */])(message.updatedRows, index);
            });
            callback(ok);
          }
        };
        _this4.confirmationModal = true;
        _this4.setState({
          confirmationModal: true,
          modal: {
            body: _this4.onConflict(conflicts),
            type: "conflict",
            callback: resolveConflicts
          }
        });
        return;
      }
    }
    return true;
  };

  this.onTableChange = function (type, callback_) {
    var ok = _this4.table.canQuit("rowQuit", function (ok) {
      if (ok) {
        _this4.onTableChange_(type, callback_);
      }
    });
    if (ok) {
      _this4.onTableChange_(type, callback_);
    }
  };

  this.onTableChange_ = function (type, callback_) {
    var callback = !callback_ && type === "refresh" ? function (ok) {
      if (ok) {
        _this4.setState(_this4.getData(_this4.props));
      }
    } : callback_;
    if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* getUpdatedRows */])(_this4.state.updatedRows).length) {
      return callback(true);
    }
    var message = {
      updatedRows: _this4.state.updatedRows,
      meta: _this4.state.meta,
      data: _this4.state.data,
      params: _this4.props.params,
      type: type
    };
    var save = function save(carryOn, ok) {
      if (carryOn && ok) {
        _this4.onSave(callback);
      } else if (carryOn) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["j" /* rollbackAll */])(_this4.state.updatedRows, _this4.state.data);
        _this4.setState({ updatedRows: {} });
        if (_this4.table) {
          _this4.table.updated = false;
          _this4.table.rowUpdated = false;
          _this4.table.tableUpdated = false;
          _this4.table.adjustScrollRows(_this4.table.state.filteredData);
        }
        callback(true);
      } else {
        callback(false);
      }
    };
    var ok = _this4.errorHandler(message, "onTableChange", save);
    if (ok !== undefined) {
      // console.log("errorHandler", ok, this.state);
      callback(ok);
    }
  };

  this.onSave = function (callback) {
    var message = {
      updatedRows: _this4.state.updatedRows,
      meta: _this4.state.meta,
      data: _this4.state.data,
      params: _this4.props.params
    };
    if (_this4.onSave_(message, callback)) {
      return true;
    }
    return false;
  };

  this.onSave_ = function (message, callback) {
    // local checks and process
    // console.log("save", this.state);
    var end = function end(ok_) {
      if (ok_) {
        var data = message.data,
            meta = message.meta,
            serverData = message.serverData;

        var deleteds = [];
        if (serverData) {
          serverData.forEach(function (row) {
            if (row.status_ === "deleted") {
              deleteds.push(row.index_);
            } else {
              delete row.status_;
              data[row.index_] = row;
            }
          });
        } else {
          Object.values(message.updatedRows).filter(function (status) {
            return status.deleted_;
          }).forEach(function (status, index) {
            deleteds.push(status.rowUpdated.index_);
          });
        }
        if (deleteds.length) {
          deleteds.sort(function (x, y) {
            return x > y - y > x;
          });
          deleteds.forEach(function (index_, index) {
            return data.splice(index_ - index, 1);
          });
        }
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_compute_data__["d" /* computeData */])(data, meta, 0);
        // a voir startIndex en mode pagination
        // this.setState({ updatedRows: {} });
        Object.keys(message.updatedRows).forEach(function (key) {
          return delete message.updatedRows[key];
        });
        if (_this4.table) {
          var filteredData = _this4.table.state.filteredData;
          if (deleteds.length) {
            deleteds.forEach(function (index_) {
              var index = filteredData.findIndex(function (row) {
                return row.index_ === index_;
              });
              if (index !== -1) {
                filteredData.splice(index, 1);
              }
            });
            _this4.table.adjustScrollRows(filteredData);
            _this4.table.updated = false;
            _this4.table.rowUpdated = false;
            _this4.table.tableUpdated = false;
          }
          _this4.table.setState({ filteredDataLength: filteredData.length });
        }
      }
      if (callback) {
        callback(ok_);
      }
    };
    var errorAfter = function errorAfter(ok_) {
      var ok = ok_ && _this4.errorHandler(message, "onSaveAfter", end);
      if (ok !== undefined) {
        end(ok);
      }
    };
    var saveAfter = function saveAfter(ok_) {
      var onSaveAfter = _this4.props.onSaveAfter || _this4.state.meta.table.onSaveAfterFunction || function () {
        return true;
      };
      var ok = ok_ && onSaveAfter(message, errorAfter);
      if (ok !== undefined) {
        errorAfter(ok);
      }
    };
    var errorSave = function errorSave(ok_) {
      var ok = ok_ && _this4.errorHandler(message, "onSave", saveAfter);
      if (ok !== undefined) {
        saveAfter(ok);
      }
    };
    var save = function save(ok_) {
      var onSave = _this4.props.onSave || _this4.state.meta.table.onSaveFunction || function () {
        return true;
      };
      var ok = ok_ && onSave(message, errorSave);
      if (ok !== undefined) {
        errorSave(ok);
      }
    };
    var errorBefore = function errorBefore(ok_) {
      var ok = ok_ && _this4.errorHandler(message, "onSaveBefore", save);
      if (ok !== undefined) {
        save(ok);
      }
    };
    var saveBefore = function saveBefore(ok_) {
      var updatedRows = message.updatedRows;
      if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_utils__["f" /* getUpdatedRows */])(updatedRows).length) {
        return end(true);
      }
      var onSaveBefore = _this4.props.onSaveBefore || _this4.state.meta.table.onSaveBeforeFunction || function () {
        return true;
      };
      var ok = ok_ && onSaveBefore(message, errorBefore);
      if (ok !== undefined) {
        errorBefore(ok);
      }
    };
    var canQuit = function canQuit(ok_) {
      var ok = ok_ && _this4.table.canQuit("rowQuit", saveBefore);
      if (ok !== undefined) {
        saveBefore(ok);
      }
    };
    canQuit(true);
  };

  this.onConfirm = function (button, type) {
    _this4.setState({
      modalCancel: false,
      modal: null,
      confirmationModal: false,
      keyEvent: null
    });
    _this4.confirmationModal = false;
  };

  this.onForeignKey = function (ForeignObject, filters, callback) {
    var _state$sizes = _this4.state.sizes,
        rowHeight = _state$sizes.rowHeight,
        zoom = _state$sizes.zoom,
        height = _state$sizes.height,
        width = _state$sizes.width;

    var element = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ForeignObject, {
      sizes: {
        minHeight: 200,
        maxHeight: height,
        minWidth: 300,
        maxWidth: width,
        rowHeight: rowHeight * zoom
      },
      filters: filters,
      keyEvent: _this4.state.keyEvent
    });
    _this4.confirmationModal = true;
    _this4.setState({
      confirmationModal: true,
      modal: { body: element, type: "foreignKey", callback: callback }
    });
    _this4.keyEvent = false;
  };

  this.onConflict = function (conflicts) {
    var properties = [{ id: "From", width: 55 }];
    _this4.state.meta.properties.forEach(function (property) {
      return properties.push(Object.assign({}, property));
    });
    var meta = Object.assign({}, _this4.state.meta, {
      indexPk: {},
      table: Object.assign({}, _this4.state.meta.table, {
        editable: false,
        checkable: 2,
        select: undefined,
        subscription: undefined,
        noFilter: true,
        caption: "Conflicts resolution."
      }),
      properties: properties
    });
    var data = [];
    var index = 0,
        updatedRows = {};

    Object.keys(conflicts).forEach(function (index_) {
      var conflict = conflicts[index_];
      conflict.server.From = conflict.server.deleted_ ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { color: "red" } },
        "Server"
      ) : "Server";
      updatedRows[index] = { checked_: true, index_: index_ };
      var ix = index;
      conflict.server.index_ = ix;
      data.push(conflict.server);
      updatedRows[index + 1] = { checked_: false };
      data.push(Object.assign({}, conflict.client, {
        From: conflict.client.deleted_ ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { color: "red" } },
          "Client"
        ) : "Client",
        index_: ix + 1
      }));
      index += 2;
    });
    var _state$sizes2 = _this4.state.sizes,
        rowHeight = _state$sizes2.rowHeight,
        zoom = _state$sizes2.zoom,
        height = _state$sizes2.height,
        width = _state$sizes2.width;

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ZebulonTable, {
      sizes: {
        minHeight: 200,
        maxHeight: height,
        minWidth: 300,
        maxWidth: width,
        rowHeight: rowHeight * zoom
      },
      meta: meta,
      data: data,
      isModal: true,
      functions: _this4.state.functions,
      updatedRows: updatedRows,
      utils: _this4.props.utils
    });
  };
};

ZebulonTable.prototype["getState"] = function () {
  return this.state;
};

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_reducer__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status_reducer__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configuration_reducer__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dimensions_reducer__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__measures_reducer__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__axis_reducer__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sizes_reducer__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__filters_reducer__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__collapses_reducer__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__selection_reducer__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__subtotals_reducer__ = __webpack_require__(362);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* combineReducers */])({status:__WEBPACK_IMPORTED_MODULE_2__status_reducer__["a" /* default */],data:__WEBPACK_IMPORTED_MODULE_1__data_reducer__["a" /* default */],configuration:__WEBPACK_IMPORTED_MODULE_3__configuration_reducer__["a" /* default */],dimensions:__WEBPACK_IMPORTED_MODULE_4__dimensions_reducer__["a" /* default */],measures:__WEBPACK_IMPORTED_MODULE_5__measures_reducer__["a" /* default */],axis:__WEBPACK_IMPORTED_MODULE_6__axis_reducer__["a" /* default */],sizes:__WEBPACK_IMPORTED_MODULE_7__sizes_reducer__["a" /* default */],filters:__WEBPACK_IMPORTED_MODULE_8__filters_reducer__["a" /* default */],collapses:__WEBPACK_IMPORTED_MODULE_9__collapses_reducer__["a" /* default */],selectedRange:__WEBPACK_IMPORTED_MODULE_10__selection_reducer__["a" /* default */],subtotals:__WEBPACK_IMPORTED_MODULE_11__subtotals_reducer__["a" /* default */]}));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDraggable = __webpack_require__(369);

var _cloneElement = __webpack_require__(370);

var _cloneElement2 = _interopRequireDefault(_cloneElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Resizable = function (_React$Component) {
  _inherits(Resizable, _React$Component);

  function Resizable() {
    var _temp, _this, _ret;

    _classCallCheck(this, Resizable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      resizing: false,
      width: _this.props.width, height: _this.props.height,
      slackW: 0, slackH: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Resizable.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    // If parent changes height/width, set that in our state.
    if (!this.state.resizing && (nextProps.width !== this.props.width || nextProps.height !== this.props.height)) {
      this.setState({
        width: nextProps.width,
        height: nextProps.height
      });
    }
  };

  Resizable.prototype.lockAspectRatio = function lockAspectRatio(width, height, aspectRatio) {
    height = width / aspectRatio;
    width = height * aspectRatio;
    return [width, height];
  };

  // If you do this, be careful of constraints


  Resizable.prototype.runConstraints = function runConstraints(width, height) {
    var _ref = [this.props.minConstraints, this.props.maxConstraints],
        min = _ref[0],
        max = _ref[1];


    if (this.props.lockAspectRatio) {
      var ratio = this.state.width / this.state.height;
      height = width / ratio;
      width = height * ratio;
    }

    if (!min && !max) return [width, height];

    var oldW = width,
        oldH = height;

    // Add slack to the values used to calculate bound position. This will ensure that if
    // we start removing slack, the element won't react to it right away until it's been
    // completely removed.

    var _state = this.state,
        slackW = _state.slackW,
        slackH = _state.slackH;

    width += slackW;
    height += slackH;

    if (min) {
      width = Math.max(min[0], width);
      height = Math.max(min[1], height);
    }
    if (max) {
      width = Math.min(max[0], width);
      height = Math.min(max[1], height);
    }

    // If the numbers changed, we must have introduced some slack. Record it for the next iteration.
    slackW += oldW - width;
    slackH += oldH - height;
    if (slackW !== this.state.slackW || slackH !== this.state.slackH) {
      this.setState({ slackW: slackW, slackH: slackH });
    }

    return [width, height];
  };

  /**
   * Wrapper around drag events to provide more useful data.
   *
   * @param  {String} handlerName Handler name to wrap.
   * @return {Function}           Handler function.
   */


  Resizable.prototype.resizeHandler = function resizeHandler(handlerName) {
    var _this2 = this;

    return function (e, _ref2) {
      var node = _ref2.node,
          deltaX = _ref2.deltaX,
          deltaY = _ref2.deltaY;


      // Axis restrictions
      var canDragX = _this2.props.axis === 'both' || _this2.props.axis === 'x';
      var canDragY = _this2.props.axis === 'both' || _this2.props.axis === 'y';

      // Update w/h
      var width = _this2.state.width + (canDragX ? deltaX : 0);
      var height = _this2.state.height + (canDragY ? deltaY : 0);

      // Early return if no change
      var widthChanged = width !== _this2.state.width,
          heightChanged = height !== _this2.state.height;
      if (handlerName === 'onResize' && !widthChanged && !heightChanged) return;

      // Set the appropriate state for this handler.
      var _runConstraints = _this2.runConstraints(width, height);

      width = _runConstraints[0];
      height = _runConstraints[1];
      var newState = {};
      if (handlerName === 'onResizeStart') {
        newState.resizing = true;
      } else if (handlerName === 'onResizeStop') {
        newState.resizing = false;
        newState.slackW = newState.slackH = 0;
      } else {
        // Early return if no change after constraints
        if (width === _this2.state.width && height === _this2.state.height) return;
        newState.width = width;
        newState.height = height;
      }

      var hasCb = typeof _this2.props[handlerName] === 'function';
      if (hasCb) {
        if (typeof e.persist === 'function') e.persist();
        _this2.setState(newState, function () {
          return _this2.props[handlerName](e, { node: node, size: { width: width, height: height } });
        });
      } else {
        _this2.setState(newState);
      }
    };
  };

  Resizable.prototype.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _props = this.props,
        children = _props.children,
        draggableOpts = _props.draggableOpts,
        width = _props.width,
        height = _props.height,
        handleSize = _props.handleSize,
        lockAspectRatio = _props.lockAspectRatio,
        axis = _props.axis,
        minConstraints = _props.minConstraints,
        maxConstraints = _props.maxConstraints,
        onResize = _props.onResize,
        onResizeStop = _props.onResizeStop,
        onResizeStart = _props.onResizeStart,
        p = _objectWithoutProperties(_props, ['children', 'draggableOpts', 'width', 'height', 'handleSize', 'lockAspectRatio', 'axis', 'minConstraints', 'maxConstraints', 'onResize', 'onResizeStop', 'onResizeStart']);

    var className = p.className ? p.className + ' react-resizable' : 'react-resizable';

    // What we're doing here is getting the child of this element, and cloning it with this element's props.
    // We are then defining its children as:
    // Its original children (resizable's child's children), and
    // A draggable handle.
    return (0, _cloneElement2.default)(children, _extends({}, p, {
      className: className,
      children: [children.props.children, _react2.default.createElement(
        _reactDraggable.DraggableCore,
        _extends({}, draggableOpts, {
          key: 'resizableHandle',
          onStop: this.resizeHandler('onResizeStop'),
          onStart: this.resizeHandler('onResizeStart'),
          onDrag: this.resizeHandler('onResize')
        }),
        _react2.default.createElement('span', { className: 'react-resizable-handle' })
      )]
    }));
  };

  return Resizable;
}(_react2.default.Component);

Resizable.propTypes = {
  //
  // Required Props
  //

  // Require that one and only one child be present.
  children: _propTypes2.default.element.isRequired,

  // Initial w/h
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,

  //
  // Optional props
  //

  // If you change this, be sure to update your css
  handleSize: _propTypes2.default.array,

  // If true, will only allow width/height to move in lockstep
  lockAspectRatio: _propTypes2.default.bool,

  // Restricts resizing to a particular axis (default: 'both')
  // 'both' - allows resizing by width or height
  // 'x' - only allows the width to be changed
  // 'y' - only allows the height to be changed
  // 'none' - disables resizing altogether
  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),

  // Min/max size
  minConstraints: _propTypes2.default.arrayOf(_propTypes2.default.number),
  maxConstraints: _propTypes2.default.arrayOf(_propTypes2.default.number),

  // Callbacks
  onResizeStop: _propTypes2.default.func,
  onResizeStart: _propTypes2.default.func,
  onResize: _propTypes2.default.func,

  // These will be passed wholesale to react-draggable's DraggableCore
  draggableOpts: _propTypes2.default.object
};
Resizable.defaultProps = {
  handleSize: [20, 20],
  lockAspectRatio: false,
  axis: 'both',
  minConstraints: [20, 20],
  maxConstraints: [Infinity, Infinity]
};
exports.default = Resizable;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130);
module.exports = __webpack_require__(134);


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(131).enable();
  window.Promise = __webpack_require__(132);
}

// fetch() polyfill for making API calls.
__webpack_require__(133);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(66);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(64);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(64);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__demo_ZebulonGrid_demo__ = __webpack_require__(150);
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__demo_ZebulonGrid_demo__["a" /* default */],null),document.getElementById("root"));// import React, { Component } from "react";
// import ReactDOM from "react-dom";
// import ZebulonGrid from "./pivotGrid/ZebulonGrid";
// const buildData = (n0, n1, n2) => {
// 	let data = [];
// 	for (let i0 = 0; i0 < n0; i0++) {
// 		for (let i1 = 0; i1 < n1; i1++) {
// 			for (let i2 = 0; i2 < n2; i2++) {
// 				data.push({
// 					totoId: i0,
// 					totoLabel: `toto${i0}`,
// 					titi: i1,
// 					tutu: `tutu${i2}`,
// 					qty: Math.round(100 * Math.random()),
// 					amt: Math.round(1000 * Math.random())
// 				});
// 			}
// 		}
// 	}
// 	return data;
// };
// const buildConfiguration = () => ({
// 	measureHeadersAxis: "columns",
// 	width: 1000,
// 	height: 800,
// 	cellHeight: 30,
// 	cellWidth: 100,
// 	dimensions: [
// 		{
// 			id: "toto",
// 			caption: "Toto",
// 			keyAccessor: "totoId",
// 			labelAccessor: "totoLabel",
// 			sort: {
// 				keyAccessor: "totoLabel"
// 			}
// 		},
// 		{
// 			id: "titi",
// 			caption: "Titi",
// 			keyAccessor: "titi"
// 		},
// 		{
// 			id: "tutu",
// 			caption: "Tutu",
// 			keyAccessor: "tutu"
// 		}
// 	],
// 	measures: [
// 		{
// 			valueAccessor: "qty",
// 			id: "qty",
// 			caption: "Quantity",
// 			aggregation: "sum"
// 		},
// 		{
// 			valueAccessor: "amt",
// 			id: "amt",
// 			caption: "Amount",
// 			aggregation: "sum"
// 		}
// 	],
// 	columns: ["tutu"],
// 	rows: ["toto", "titi"],
// 	activeMeasures: ["qty", "amt"]
// });
// class MyPivotGrid extends Component {
// 	constructor(props) {
// 		super(props);
// 		this.state = {};
// 	}
// 	data = buildData(30, 12, 7);
// 	configuration = buildConfiguration();
// 	render() {
// 		return (
// 			<ZebulonGrid
// 				data={this.data}
// 				configuration={this.configuration}
// 				height={800}
// 				width={1000}
// 			/>
// 		);
// 	}
// }
// ReactDOM.render(<MyPivotGrid />, document.getElementById("root"));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(66),n=__webpack_require__(136),p=__webpack_require__(137),q=__webpack_require__(138),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(140),l=__webpack_require__(142),B=__webpack_require__(68),C=__webpack_require__(38),ba=__webpack_require__(143),da=__webpack_require__(144),ea=__webpack_require__(145),fa=__webpack_require__(146),ia=__webpack_require__(149),D=__webpack_require__(69);
function E(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:E("227");
var oa={children:!0,dangerouslySetInnerHTML:!0,defaultValue:!0,defaultChecked:!0,innerHTML:!0,suppressContentEditableWarning:!0,suppressHydrationWarning:!0,style:!0};function pa(a,b){return(a&b)===b}
var ta={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=ta,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){ua.hasOwnProperty(f)?E("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:pa(h,b.MUST_USE_PROPERTY),
hasBooleanValue:pa(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:pa(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:pa(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:pa(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:pa(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:E("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);ua[f]=g}}},ua={};
function va(a,b){if(oa.hasOwnProperty(a)||2<a.length&&("o"===a[0]||"O"===a[0])&&("n"===a[1]||"N"===a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return oa.hasOwnProperty(a)?a=!0:(b=wa(a))?a=b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue:(a=a.toLowerCase().slice(0,5),a="data-"===a||"aria-"===a),a;case "undefined":case "number":case "string":case "object":return!0;default:return!1}}function wa(a){return ua.hasOwnProperty(a)?ua[a]:null}
var xa=ta,ya=xa.MUST_USE_PROPERTY,K=xa.HAS_BOOLEAN_VALUE,za=xa.HAS_NUMERIC_VALUE,Aa=xa.HAS_POSITIVE_NUMERIC_VALUE,Ba=xa.HAS_OVERLOADED_BOOLEAN_VALUE,Ca=xa.HAS_STRING_BOOLEAN_VALUE,Da={Properties:{allowFullScreen:K,async:K,autoFocus:K,autoPlay:K,capture:Ba,checked:ya|K,cols:Aa,contentEditable:Ca,controls:K,"default":K,defer:K,disabled:K,download:Ba,draggable:Ca,formNoValidate:K,hidden:K,loop:K,multiple:ya|K,muted:ya|K,noValidate:K,open:K,playsInline:K,readOnly:K,required:K,reversed:K,rows:Aa,rowSpan:za,
scoped:K,seamless:K,selected:ya|K,size:Aa,start:za,span:Aa,spellCheck:Ca,style:0,tabIndex:0,itemScope:K,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:Ca},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&a.ownerDocument.activeElement!==a&&
a.setAttribute("value",""+b)}}},Ea=xa.HAS_STRING_BOOLEAN_VALUE,M={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},Ga={Properties:{autoReverse:Ea,externalResourcesRequired:Ea,preserveAlpha:Ea},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:M.xlink,xlinkArcrole:M.xlink,xlinkHref:M.xlink,xlinkRole:M.xlink,xlinkShow:M.xlink,xlinkTitle:M.xlink,xlinkType:M.xlink,
xmlBase:M.xml,xmlLang:M.xml,xmlSpace:M.xml}},Ha=/[\-\:]([a-z])/g;function Ia(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Ha,
Ia);Ga.Properties[b]=0;Ga.DOMAttributeNames[b]=a});xa.injectDOMPropertyConfig(Da);xa.injectDOMPropertyConfig(Ga);
var P={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?E("197"):void 0;Ja=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){Ja.apply(P,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){P.invokeGuardedCallback.apply(this,arguments);if(P.hasCaughtError()){var q=P.clearCaughtError();P._hasRethrowError||(P._hasRethrowError=!0,P._rethrowError=
q)}},rethrowCaughtError:function(){return Ka.apply(P,arguments)},hasCaughtError:function(){return P._hasCaughtError},clearCaughtError:function(){if(P._hasCaughtError){var a=P._caughtError;P._caughtError=null;P._hasCaughtError=!1;return a}E("198")}};function Ja(a,b,c,d,e,f,g,h,k){P._hasCaughtError=!1;P._caughtError=null;var q=Array.prototype.slice.call(arguments,3);try{b.apply(c,q)}catch(v){P._caughtError=v,P._hasCaughtError=!0}}
function Ka(){if(P._hasRethrowError){var a=P._rethrowError;P._rethrowError=null;P._hasRethrowError=!1;throw a;}}var La=null,Ma={};
function Na(){if(La)for(var a in Ma){var b=Ma[a],c=La.indexOf(a);-1<c?void 0:E("96",a);if(!Oa[c]){b.extractEvents?void 0:E("97",a);Oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;Pa.hasOwnProperty(h)?E("99",h):void 0;Pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&Qa(k[e],g,h);e=!0}else f.registrationName?(Qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:E("98",d,a)}}}}
function Qa(a,b,c){Ra[a]?E("100",a):void 0;Ra[a]=b;Sa[a]=b.eventTypes[c].dependencies}var Oa=[],Pa={},Ra={},Sa={};function Ta(a){La?E("101"):void 0;La=Array.prototype.slice.call(a);Na()}function Ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];Ma.hasOwnProperty(c)&&Ma[c]===d||(Ma[c]?E("102",c):void 0,Ma[c]=d,b=!0)}b&&Na()}
var Va=Object.freeze({plugins:Oa,eventNameDispatchConfigs:Pa,registrationNameModules:Ra,registrationNameDependencies:Sa,possibleRegistrationNames:null,injectEventPluginOrder:Ta,injectEventPluginsByName:Ua}),Wa=null,Xa=null,Ya=null;function Za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Ya(d);P.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function $a(a,b){null==b?E("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function ab(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var bb=null;
function cb(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Za(a,b,c[e],d[e]);else c&&Za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function db(a){return cb(a,!0)}function gb(a){return cb(a,!1)}var hb={injectEventPluginOrder:Ta,injectEventPluginsByName:Ua};
function ib(a,b){var c=a.stateNode;if(!c)return null;var d=Wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?E("231",b,typeof c):void 0;
return c}function jb(a,b,c,d){for(var e,f=0;f<Oa.length;f++){var g=Oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=$a(e,g))}return e}function kb(a){a&&(bb=$a(bb,a))}function lb(a){var b=bb;bb=null;b&&(a?ab(b,db):ab(b,gb),bb?E("95"):void 0,P.rethrowCaughtError())}var mb=Object.freeze({injection:hb,getListener:ib,extractEvents:jb,enqueueEvents:kb,processEventQueue:lb}),nb=Math.random().toString(36).slice(2),Q="__reactInternalInstance$"+nb,ob="__reactEventHandlers$"+nb;
function pb(a){if(a[Q])return a[Q];for(var b=[];!a[Q];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=void 0,d=a[Q];if(5===d.tag||6===d.tag)return d;for(;a&&(d=a[Q]);a=b.pop())c=d;return c}function qb(a){if(5===a.tag||6===a.tag)return a.stateNode;E("33")}function rb(a){return a[ob]||null}
var sb=Object.freeze({precacheFiberNode:function(a,b){b[Q]=a},getClosestInstanceFromNode:pb,getInstanceFromNode:function(a){a=a[Q];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:qb,getFiberCurrentPropsFromNode:rb,updateFiberProps:function(a,b){a[ob]=b}});function tb(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function ub(a,b,c){for(var d=[];a;)d.push(a),a=tb(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}
function vb(a,b,c){if(b=ib(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a)}function wb(a){a&&a.dispatchConfig.phasedRegistrationNames&&ub(a._targetInst,vb,a)}function xb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?tb(b):null;ub(b,vb,a)}}
function yb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=ib(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=$a(c._dispatchListeners,b),c._dispatchInstances=$a(c._dispatchInstances,a))}function zb(a){a&&a.dispatchConfig.registrationName&&yb(a._targetInst,null,a)}function Ab(a){ab(a,wb)}
function Bb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=tb(h))g++;h=0;for(var k=f;k;k=tb(k))h++;for(;0<g-h;)e=tb(e),g--;for(;0<h-g;)f=tb(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=tb(e);f=tb(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=tb(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=tb(d)}for(d=0;d<e.length;d++)yb(e[d],"bubbled",a);for(a=c.length;0<a--;)yb(c[a],"captured",b)}
var Cb=Object.freeze({accumulateTwoPhaseDispatches:Ab,accumulateTwoPhaseDispatchesSkipTarget:function(a){ab(a,xb)},accumulateEnterLeaveDispatches:Bb,accumulateDirectDispatches:function(a){ab(a,zb)}}),Db=null;function Eb(){!Db&&l.canUseDOM&&(Db="textContent"in document.documentElement?"textContent":"innerText");return Db}var S={_root:null,_startText:null,_fallbackText:null};
function Fb(){if(S._fallbackText)return S._fallbackText;var a,b=S._startText,c=b.length,d,e=Gb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);S._fallbackText=e.slice(a,1<d?1-d:void 0);return S._fallbackText}function Gb(){return"value"in S._root?S._root.value:S._root[Eb()]}
var Hb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Ib={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function T(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
B(T.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Hb.length;a++)this[Hb[a]]=null}});T.Interface=Ib;T.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;B(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=B({},this.Interface,b);a.augmentClass=this.augmentClass;Jb(a)};Jb(T);function Kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Lb(a){a instanceof this?void 0:E("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Jb(a){a.eventPool=[];a.getPooled=Kb;a.release=Lb}function Mb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Mb,{data:null});function Nb(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Nb,{data:null});var Pb=[9,13,27,32],Vb=l.canUseDOM&&"CompositionEvent"in window,Wb=null;l.canUseDOM&&"documentMode"in document&&(Wb=document.documentMode);var Xb;
if(Xb=l.canUseDOM&&"TextEvent"in window&&!Wb){var Yb=window.opera;Xb=!("object"===typeof Yb&&"function"===typeof Yb.version&&12>=parseInt(Yb.version(),10))}
var Zb=Xb,$b=l.canUseDOM&&(!Vb||Wb&&8<Wb&&11>=Wb),ac=String.fromCharCode(32),bc={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},cc=!1;
function dc(a,b){switch(a){case "topKeyUp":return-1!==Pb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ec(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var fc=!1;function gc(a,b){switch(a){case "topCompositionEnd":return ec(b);case "topKeyPress":if(32!==b.which)return null;cc=!0;return ac;case "topTextInput":return a=b.data,a===ac&&cc?null:a;default:return null}}
function hc(a,b){if(fc)return"topCompositionEnd"===a||!Vb&&dc(a,b)?(a=Fb(),S._root=null,S._startText=null,S._fallbackText=null,fc=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return $b?null:b.data;default:return null}}
var ic={eventTypes:bc,extractEvents:function(a,b,c,d){var e;if(Vb)b:{switch(a){case "topCompositionStart":var f=bc.compositionStart;break b;case "topCompositionEnd":f=bc.compositionEnd;break b;case "topCompositionUpdate":f=bc.compositionUpdate;break b}f=void 0}else fc?dc(a,c)&&(f=bc.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=bc.compositionStart);f?($b&&(fc||f!==bc.compositionStart?f===bc.compositionEnd&&fc&&(e=Fb()):(S._root=d,S._startText=Gb(),fc=!0)),f=Mb.getPooled(f,b,c,d),e?f.data=
e:(e=ec(c),null!==e&&(f.data=e)),Ab(f),e=f):e=null;(a=Zb?gc(a,c):hc(a,c))?(b=Nb.getPooled(bc.beforeInput,b,c,d),b.data=a,Ab(b)):b=null;return[e,b]}},jc=null,kc=null,lc=null;function mc(a){if(a=Xa(a)){jc&&"function"===typeof jc.restoreControlledState?void 0:E("194");var b=Wa(a.stateNode);jc.restoreControlledState(a.stateNode,a.type,b)}}var nc={injectFiberControlledHostComponent:function(a){jc=a}};function oc(a){kc?lc?lc.push(a):lc=[a]:kc=a}
function pc(){if(kc){var a=kc,b=lc;lc=kc=null;mc(a);if(b)for(a=0;a<b.length;a++)mc(b[a])}}var qc=Object.freeze({injection:nc,enqueueStateRestore:oc,restoreStateIfNeeded:pc});function rc(a,b){return a(b)}var sc=!1;function tc(a,b){if(sc)return rc(a,b);sc=!0;try{return rc(a,b)}finally{sc=!1,pc()}}var uc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};
function vc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!uc[a.type]:"textarea"===b?!0:!1}function wc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var xc;l.canUseDOM&&(xc=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function yc(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&xc&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function Bc(a){a._valueTracker||(a._valueTracker=Ac(a))}function Cc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Dc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};
function Ec(a,b,c){a=T.getPooled(Dc.change,a,b,c);a.type="change";oc(c);Ab(a);return a}var Fc=null,Gc=null;function Hc(a){kb(a);lb(!1)}function Ic(a){var b=qb(a);if(Cc(b))return a}function Jc(a,b){if("topChange"===a)return b}var Kc=!1;l.canUseDOM&&(Kc=yc("input")&&(!document.documentMode||9<document.documentMode));function Lc(){Fc&&(Fc.detachEvent("onpropertychange",Mc),Gc=Fc=null)}function Mc(a){"value"===a.propertyName&&Ic(Gc)&&(a=Ec(Gc,a,wc(a)),tc(Hc,a))}
function Nc(a,b,c){"topFocus"===a?(Lc(),Fc=b,Gc=c,Fc.attachEvent("onpropertychange",Mc)):"topBlur"===a&&Lc()}function Oc(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return Ic(Gc)}function Pc(a,b){if("topClick"===a)return Ic(b)}function $c(a,b){if("topInput"===a||"topChange"===a)return Ic(b)}
var ad={eventTypes:Dc,_isInputEventSupported:Kc,extractEvents:function(a,b,c,d){var e=b?qb(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Jc;else if(vc(e))if(Kc)g=$c;else{g=Oc;var h=Nc}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Pc);if(g&&(g=g(a,b)))return Ec(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,e.getAttribute("value")!==
a&&e.setAttribute("value",a))}};function bd(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(bd,{view:null,detail:null});var cd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function dd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=cd[a])?!!b[a]:!1}function ed(){return dd}function fd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(fd,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ed,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var gd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},hd={eventTypes:gd,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?pb(b):null):a=null;if(a===
b)return null;var f=null==a?e:qb(a);e=null==b?e:qb(b);var g=fd.getPooled(gd.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=fd.getPooled(gd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Bb(g,c,a,b);return[g,c]}},id=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner;function jd(a){a=a.type;return"string"===typeof a?a:"function"===typeof a?a.displayName||a.name:null}
function kd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){return(a=a._reactInternalFiber)?2===kd(a):!1}function md(a){2!==kd(a)?E("188"):void 0}
function nd(a){var b=a.alternate;if(!b)return b=kd(a),3===b?E("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return md(e),a;if(g===d)return md(e),b;g=g.sibling}E("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:E("189")}}c.alternate!==d?E("190"):void 0}3!==c.tag?E("188"):void 0;return c.stateNode.current===c?a:b}function od(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function pd(a){a=nd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var qd=[];
function rd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=pb(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],sd(a.topLevelType,b,a.nativeEvent,wc(a.nativeEvent))}var td=!0,sd=void 0;function ud(a){td=!!a}function U(a,b,c){return c?ba.listen(c,b,vd.bind(null,a)):null}function wd(a,b,c){return c?ba.capture(c,b,vd.bind(null,a)):null}
function vd(a,b){if(td){var c=wc(b);c=pb(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(qd.length){var d=qd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{tc(rd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>qd.length&&qd.push(a)}}}
var xd=Object.freeze({get _enabled(){return td},get _handleTopLevel(){return sd},setHandleTopLevel:function(a){sd=a},setEnabled:ud,isEnabled:function(){return td},trapBubbledEvent:U,trapCapturedEvent:wd,dispatchEvent:vd});function yd(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var zd={animationend:yd("Animation","AnimationEnd"),animationiteration:yd("Animation","AnimationIteration"),animationstart:yd("Animation","AnimationStart"),transitionend:yd("Transition","TransitionEnd")},Ad={},Bd={};l.canUseDOM&&(Bd=document.createElement("div").style,"AnimationEvent"in window||(delete zd.animationend.animation,delete zd.animationiteration.animation,delete zd.animationstart.animation),"TransitionEvent"in window||delete zd.transitionend.transition);
function Cd(a){if(Ad[a])return Ad[a];if(!zd[a])return a;var b=zd[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Bd)return Ad[a]=b[c];return""}
var Dd={topAbort:"abort",topAnimationEnd:Cd("animationend")||"animationend",topAnimationIteration:Cd("animationiteration")||"animationiteration",topAnimationStart:Cd("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Cd("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Ed={},Fd=0,Gd="_reactListenersID"+(""+Math.random()).slice(2);function Hd(a){Object.prototype.hasOwnProperty.call(a,Gd)||(a[Gd]=Fd++,Ed[a[Gd]]={});return Ed[a[Gd]]}function Id(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Jd(a,b){var c=Id(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Id(c)}}function Kd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var Ld=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Md={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Nd=null,Od=null,Pd=null,Qd=!1;
function Rd(a,b){if(Qd||null==Nd||Nd!==da())return null;var c=Nd;"selectionStart"in c&&Kd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return Pd&&ea(Pd,c)?null:(Pd=c,a=T.getPooled(Md.select,Od,a,b),a.type="select",a.target=Nd,Ab(a),a)}
var Sd={eventTypes:Md,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Hd(e);f=Sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?qb(b):window;switch(a){case "topFocus":if(vc(e)||"true"===e.contentEditable)Nd=e,Od=b,Pd=null;break;case "topBlur":Pd=Od=Nd=null;break;case "topMouseDown":Qd=!0;break;case "topContextMenu":case "topMouseUp":return Qd=!1,Rd(c,d);case "topSelectionChange":if(Ld)break;
case "topKeyDown":case "topKeyUp":return Rd(c,d)}return null}};function Td(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Td,{animationName:null,elapsedTime:null,pseudoElement:null});function Ud(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(Ud,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function Vd(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(Vd,{relatedTarget:null});
function Wd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var Xd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Yd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function Zd(a,b,c,d){return T.call(this,a,b,c,d)}
bd.augmentClass(Zd,{key:function(a){if(a.key){var b=Xd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Wd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Yd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ed,charCode:function(a){return"keypress"===a.type?Wd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?Wd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function $d(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass($d,{dataTransfer:null});function ae(a,b,c,d){return T.call(this,a,b,c,d)}bd.augmentClass(ae,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ed});function be(a,b,c,d){return T.call(this,a,b,c,d)}T.augmentClass(be,{propertyName:null,elapsedTime:null,pseudoElement:null});
function ce(a,b,c,d){return T.call(this,a,b,c,d)}fd.augmentClass(ce,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var de={},ee={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};de[a]=c;ee[b]=c});
var fe={eventTypes:de,extractEvents:function(a,b,c,d){var e=ee[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Wd(c))return null;case "topKeyDown":case "topKeyUp":a=Zd;break;case "topBlur":case "topFocus":a=Vd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=fd;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=
$d;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=ae;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Td;break;case "topTransitionEnd":a=be;break;case "topScroll":a=bd;break;case "topWheel":a=ce;break;case "topCopy":case "topCut":case "topPaste":a=Ud;break;default:a=T}b=a.getPooled(e,b,c,d);Ab(b);return b}};sd=function(a,b,c,d){a=jb(a,b,c,d);kb(a);lb(!1)};hb.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
Wa=sb.getFiberCurrentPropsFromNode;Xa=sb.getInstanceFromNode;Ya=sb.getNodeFromInstance;hb.injectEventPluginsByName({SimpleEventPlugin:fe,EnterLeaveEventPlugin:hd,ChangeEventPlugin:ad,SelectEventPlugin:Sd,BeforeInputEventPlugin:ic});var ge=[],he=-1;function V(a){0>he||(a.current=ge[he],ge[he]=null,he--)}function W(a,b){he++;ge[he]=a.current;a.current=b}new Set;var ie={current:D},X={current:!1},je=D;function ke(a){return le(a)?je:ie.current}
function me(a,b){var c=a.type.contextTypes;if(!c)return D;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function le(a){return 2===a.tag&&null!=a.type.childContextTypes}function ne(a){le(a)&&(V(X,a),V(ie,a))}
function oe(a,b,c){null!=ie.cursor?E("168"):void 0;W(ie,b,a);W(X,c,a)}function pe(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:E("108",jd(a)||"Unknown",e);return B({},b,c)}function qe(a){if(!le(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||D;je=ie.current;W(ie,b,a);W(X,X.current,a);return!0}
function re(a,b){var c=a.stateNode;c?void 0:E("169");if(b){var d=pe(a,je);c.__reactInternalMemoizedMergedChildContext=d;V(X,a);V(ie,a);W(ie,d,a)}else V(X,a);W(X,b,a)}
function Y(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function se(a,b,c){var d=a.alternate;null===d?(d=new Y(a.tag,a.key,a.internalContextTag),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.pendingProps=b;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function te(a,b,c){var d=void 0,e=a.type,f=a.key;"function"===typeof e?(d=e.prototype&&e.prototype.isReactComponent?new Y(2,f,b):new Y(0,f,b),d.type=e,d.pendingProps=a.props):"string"===typeof e?(d=new Y(5,f,b),d.type=e,d.pendingProps=a.props):"object"===typeof e&&null!==e&&"number"===typeof e.tag?(d=e,d.pendingProps=a.props):E("130",null==e?e:typeof e,"");d.expirationTime=c;return d}function ue(a,b,c,d){b=new Y(10,d,b);b.pendingProps=a;b.expirationTime=c;return b}
function ve(a,b,c){b=new Y(6,null,b);b.pendingProps=a;b.expirationTime=c;return b}function we(a,b,c){b=new Y(7,a.key,b);b.type=a.handler;b.pendingProps=a;b.expirationTime=c;return b}function xe(a,b,c){a=new Y(9,null,b);a.expirationTime=c;return a}function ye(a,b,c){b=new Y(4,a.key,b);b.pendingProps=a.children||[];b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var ze=null,Ae=null;
function Be(a){return function(b){try{return a(b)}catch(c){}}}function Ce(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ze=Be(function(a){return b.onCommitFiberRoot(c,a)});Ae=Be(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function De(a){"function"===typeof ze&&ze(a)}function Ee(a){"function"===typeof Ae&&Ae(a)}
function Fe(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1}}function Ge(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}
function He(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=Fe(null));null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=Fe(null))):a=null;a=a!==d?a:null;null===a?Ge(d,b):null===d.last||null===a.last?(Ge(d,b),Ge(a,b)):(Ge(d,b),a.last=b)}function Ie(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Je(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var g=!0,h=c.first,k=!1;null!==h;){var q=h.expirationTime;if(q>f){var v=c.expirationTime;if(0===v||v>q)c.expirationTime=q;k||(k=!0,c.baseState=a)}else{k||(c.first=h.next,null===
c.first&&(c.last=null));if(h.isReplace)a=Ie(h,d,a,e),g=!0;else if(q=Ie(h,d,a,e))a=g?B({},a,q):B(a,q),g=!1;h.isForced&&(c.hasForceUpdate=!0);null!==h.callback&&(q=c.callbackList,null===q&&(q=c.callbackList=[]),q.push(h))}h=h.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||(b.updateQueue=null);k||(c.baseState=a);return a}
function Ke(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?E("191",e):void 0;e.call(b)}}
function Le(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;b._reactInternalFiber=a}var f={isMounted:ld,enqueueSetState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!1,isForced:!1,nextCallback:null,next:null});a(c,g)},enqueueReplaceState:function(c,d,e){c=c._reactInternalFiber;e=void 0===e?null:e;var g=b(c);He(c,{expirationTime:g,partialState:d,callback:e,isReplace:!0,isForced:!1,nextCallback:null,next:null});
a(c,g)},enqueueForceUpdate:function(c,d){c=c._reactInternalFiber;d=void 0===d?null:d;var e=b(c);He(c,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,nextCallback:null,next:null});a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=ke(a),f=2===a.tag&&null!=a.type.contextTypes,g=f?me(a,d):D;b=new c(b,g);e(a,b);f&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=d,a.__reactInternalMemoizedMaskedChildContext=g);return b},mountClassInstance:function(a,
b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:E("158");var h=ke(a);d.props=g;d.state=a.memoizedState=e;d.refs=D;d.context=me(a,h);null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=1);"function"===typeof d.componentWillMount&&(e=d.state,d.componentWillMount(),e!==d.state&&f.enqueueReplaceState(d,d.state,null),e=a.updateQueue,null!==e&&(d.state=Je(c,a,e,d,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=
4)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?E("159"):void 0);var u=g.context,z=ke(b);z=me(b,z);"function"!==typeof g.componentWillReceiveProps||h===k&&u===z||(u=g.state,g.componentWillReceiveProps(k,z),g.state!==u&&f.enqueueReplaceState(g,g.state,null));u=b.memoizedState;e=null!==b.updateQueue?Je(a,b,b.updateQueue,g,k,e):u;if(!(h!==k||u!==e||X.current||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==
typeof g.componentDidUpdate||h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),!1;var G=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)G=!0;else{var I=b.stateNode,L=b.type;G="function"===typeof I.shouldComponentUpdate?I.shouldComponentUpdate(G,e,z):L.prototype&&L.prototype.isPureReactComponent?!ea(h,G)||!ea(u,e):!0}G?("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(k,e,z),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4)):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&u===a.memoizedState||(b.effectTag|=4),c(b,k),d(b,e));g.props=k;g.state=e;g.context=z;return G}}}var Qe="function"===typeof Symbol&&Symbol["for"],Re=Qe?Symbol["for"]("react.element"):60103,Se=Qe?Symbol["for"]("react.call"):60104,Te=Qe?Symbol["for"]("react.return"):60105,Ue=Qe?Symbol["for"]("react.portal"):60106,Ve=Qe?Symbol["for"]("react.fragment"):60107,We="function"===typeof Symbol&&Symbol.iterator;
function Xe(a){if(null===a||"undefined"===typeof a)return null;a=We&&a[We]||a["@@iterator"];return"function"===typeof a?a:null}var Ye=Array.isArray;
function Ze(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&(2!==b.tag?E("110"):void 0,d=b.stateNode);d?void 0:E("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===D?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?E("148"):void 0;b._owner?void 0:E("149",c)}return c}
function $e(a,b){"textarea"!==a.type&&E("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function af(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=se(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ve(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ze(b,c),d["return"]=a,d;d=te(c,a.internalContextTag,d);d.ref=Ze(b,c);d["return"]=a;return d}function q(a,b,c,d){if(null===b||7!==b.tag)return b=we(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c,d);
b["return"]=a;return b}function v(a,b,c,d){if(null===b||9!==b.tag)return b=xe(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=e(b,null,d);b.type=c.value;b["return"]=a;return b}function y(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=ye(c,a.internalContextTag,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function u(a,b,c,d,f){if(null===b||10!==b.tag)return b=ue(c,a.internalContextTag,
d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ve(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Re:if(b.type===Ve)return b=ue(b.props.children,a.internalContextTag,c,b.key),b["return"]=a,b;c=te(b,a.internalContextTag,c);c.ref=Ze(null,b);c["return"]=a;return c;case Se:return b=we(b,a.internalContextTag,c),b["return"]=a,b;case Te:return c=xe(b,a.internalContextTag,
c),c.type=b.value,c["return"]=a,c;case Ue:return b=ye(b,a.internalContextTag,c),b["return"]=a,b}if(Ye(b)||Xe(b))return b=ue(b,a.internalContextTag,c,null),b["return"]=a,b;$e(a,b)}return null}function G(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Re:return c.key===e?c.type===Ve?u(a,b,c.props.children,d,e):k(a,b,c,d):null;case Se:return c.key===e?q(a,b,c,d):null;case Te:return null===
e?v(a,b,c,d):null;case Ue:return c.key===e?y(a,b,c,d):null}if(Ye(c)||Xe(c))return null!==e?null:u(a,b,c,d,null);$e(a,c)}return null}function I(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Re:return a=a.get(null===d.key?c:d.key)||null,d.type===Ve?u(b,a,d.props.children,e,d.key):k(b,a,d,e);case Se:return a=a.get(null===d.key?c:d.key)||null,q(b,a,d,e);case Te:return a=a.get(c)||null,v(b,a,d,e);case Ue:return a=
a.get(null===d.key?c:d.key)||null,y(b,a,d,e)}if(Ye(d)||Xe(d))return a=a.get(c)||null,u(b,a,d,e,null);$e(b,d)}return null}function L(e,g,m,A){for(var h=null,r=null,n=g,w=g=0,k=null;null!==n&&w<m.length;w++){n.index>w?(k=n,n=null):k=n.sibling;var x=G(e,n,m[w],A);if(null===x){null===n&&(n=k);break}a&&n&&null===x.alternate&&b(e,n);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x;n=k}if(w===m.length)return c(e,n),h;if(null===n){for(;w<m.length;w++)if(n=z(e,m[w],A))g=f(n,g,w),null===r?h=n:r.sibling=n,r=n;return h}for(n=
d(e,n);w<m.length;w++)if(k=I(n,e,w,m[w],A)){if(a&&null!==k.alternate)n["delete"](null===k.key?w:k.key);g=f(k,g,w);null===r?h=k:r.sibling=k;r=k}a&&n.forEach(function(a){return b(e,a)});return h}function N(e,g,m,A){var h=Xe(m);"function"!==typeof h?E("150"):void 0;m=h.call(m);null==m?E("151"):void 0;for(var r=h=null,n=g,w=g=0,k=null,x=m.next();null!==n&&!x.done;w++,x=m.next()){n.index>w?(k=n,n=null):k=n.sibling;var J=G(e,n,x.value,A);if(null===J){n||(n=k);break}a&&n&&null===J.alternate&&b(e,n);g=f(J,
g,w);null===r?h=J:r.sibling=J;r=J;n=k}if(x.done)return c(e,n),h;if(null===n){for(;!x.done;w++,x=m.next())x=z(e,x.value,A),null!==x&&(g=f(x,g,w),null===r?h=x:r.sibling=x,r=x);return h}for(n=d(e,n);!x.done;w++,x=m.next())if(x=I(n,e,w,x.value,A),null!==x){if(a&&null!==x.alternate)n["delete"](null===x.key?w:x.key);g=f(x,g,w);null===r?h=x:r.sibling=x;r=x}a&&n.forEach(function(a){return b(e,a)});return h}return function(a,d,f,h){"object"===typeof f&&null!==f&&f.type===Ve&&null===f.key&&(f=f.props.children);
var m="object"===typeof f&&null!==f;if(m)switch(f.$$typeof){case Re:a:{var r=f.key;for(m=d;null!==m;){if(m.key===r)if(10===m.tag?f.type===Ve:m.type===f.type){c(a,m.sibling);d=e(m,f.type===Ve?f.props.children:f.props,h);d.ref=Ze(m,f);d["return"]=a;a=d;break a}else{c(a,m);break}else b(a,m);m=m.sibling}f.type===Ve?(d=ue(f.props.children,a.internalContextTag,h,f.key),d["return"]=a,a=d):(h=te(f,a.internalContextTag,h),h.ref=Ze(d,f),h["return"]=a,a=h)}return g(a);case Se:a:{for(m=f.key;null!==d;){if(d.key===
m)if(7===d.tag){c(a,d.sibling);d=e(d,f,h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=we(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a);case Te:a:{if(null!==d)if(9===d.tag){c(a,d.sibling);d=e(d,null,h);d.type=f.value;d["return"]=a;a=d;break a}else c(a,d);d=xe(f,a.internalContextTag,h);d.type=f.value;d["return"]=a;a=d}return g(a);case Ue:a:{for(m=f.key;null!==d;){if(d.key===m)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===
f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=ye(f,a.internalContextTag,h);d["return"]=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h)):(c(a,d),d=ve(f,a.internalContextTag,h)),d["return"]=a,a=d,g(a);if(Ye(f))return L(a,d,f,h);if(Xe(f))return N(a,d,f,h);m&&$e(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:h=a.type,E("152",h.displayName||
h.name||"Component")}return c(a,d)}}var bf=af(!0),cf=af(!1);
function df(a,b,c,d,e){function f(a,b,c){var d=b.expirationTime;b.child=null===a?cf(b,null,c,d):bf(b,a.child,c,d)}function g(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=128)}function h(a,b,c,d){g(a,b);if(!c)return d&&re(b,!1),q(a,b);c=b.stateNode;id.current=b;var e=c.render();b.effectTag|=1;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&re(b,!0);return b.child}function k(a){var b=a.stateNode;b.pendingContext?oe(a,b.pendingContext,b.pendingContext!==b.context):b.context&&oe(a,
b.context,!1);I(a,b.containerInfo)}function q(a,b){null!==a&&b.child!==a.child?E("153"):void 0;if(null!==b.child){a=b.child;var c=se(a,a.pendingProps,a.expirationTime);b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=se(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}function v(a,b){switch(b.tag){case 3:k(b);break;case 2:qe(b);break;case 4:I(b,b.stateNode.containerInfo)}return null}var y=a.shouldSetTextContent,u=a.useSyncScheduling,z=a.shouldDeprioritizeSubtree,
G=b.pushHostContext,I=b.pushHostContainer,L=c.enterHydrationState,N=c.resetHydrationState,J=c.tryToClaimNextHydratableInstance;a=Le(d,e,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var w=a.adoptClassInstance,m=a.constructClassInstance,A=a.mountClassInstance,Ob=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c)return v(a,b);switch(b.tag){case 0:null!==a?E("155"):void 0;var d=b.type,e=b.pendingProps,r=ke(b);r=me(b,r);d=d(e,r);b.effectTag|=
1;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=2,e=qe(b),w(b,d),A(b,c),b=h(a,b,!0,e)):(b.tag=1,f(a,b,d),b.memoizedProps=e,b=b.child);return b;case 1:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(X.current)null===c&&(c=d);else if(null===c||d===c){b=q(a,b);break a}d=ke(b);d=me(b,d);e=e(c,d);b.effectTag|=1;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case 2:return e=qe(b),d=void 0,null===a?b.stateNode?E("153"):(m(b,b.pendingProps),A(b,c),d=!0):d=Ob(a,b,c),h(a,b,d,e);case 3:return k(b),
e=b.updateQueue,null!==e?(d=b.memoizedState,e=Je(a,b,e,null,null,c),d===e?(N(),b=q(a,b)):(d=e.element,r=b.stateNode,(null===a||null===a.child)&&r.hydrate&&L(b)?(b.effectTag|=2,b.child=cf(b,null,d,c)):(N(),f(a,b,d)),b.memoizedState=e,b=b.child)):(N(),b=q(a,b)),b;case 5:G(b);null===a&&J(b);e=b.type;var n=b.memoizedProps;d=b.pendingProps;null===d&&(d=n,null===d?E("154"):void 0);r=null!==a?a.memoizedProps:null;X.current||null!==d&&n!==d?(n=d.children,y(e,d)?n=null:r&&y(e,r)&&(b.effectTag|=16),g(a,b),
2147483647!==c&&!u&&z(e,d)?(b.expirationTime=2147483647,b=null):(f(a,b,n),b.memoizedProps=d,b=b.child)):b=q(a,b);return b;case 6:return null===a&&J(b),a=b.pendingProps,null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case 8:b.tag=7;case 7:e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null===e?E("154"):void 0);else if(null===e||b.memoizedProps===e)e=b.memoizedProps;d=e.children;b.stateNode=null===a?cf(b,b.stateNode,d,c):bf(b,b.stateNode,d,c);b.memoizedProps=e;return b.stateNode;
case 9:return null;case 4:a:{I(b,b.stateNode.containerInfo);e=b.pendingProps;if(X.current)null===e&&(e=a&&a.memoizedProps,null==e?E("154"):void 0);else if(null===e||b.memoizedProps===e){b=q(a,b);break a}null===a?b.child=bf(b,null,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case 10:a:{c=b.pendingProps;if(X.current)null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=q(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:E("156")}},beginFailedWork:function(a,b,
c){switch(b.tag){case 2:qe(b);break;case 3:k(b);break;default:E("157")}b.effectTag|=64;null===a?b.child=null:b.child!==a.child&&(b.child=a.child);if(0===b.expirationTime||b.expirationTime>c)return v(a,b);b.firstEffect=null;b.lastEffect=null;b.child=null===a?cf(b,null,null,c):bf(b,a.child,null,c);2===b.tag&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
function ef(a,b,c){function d(a){a.effectTag|=4}var e=a.createInstance,f=a.createTextInstance,g=a.appendInitialChild,h=a.finalizeInitialChildren,k=a.prepareUpdate,q=a.persistence,v=b.getRootHostContainer,y=b.popHostContext,u=b.getHostContext,z=b.popHostContainer,G=c.prepareToHydrateHostInstance,I=c.prepareToHydrateHostTextInstance,L=c.popHydrationState,N=void 0,J=void 0,w=void 0;a.mutation?(N=function(){},J=function(a,b,c){(b.updateQueue=c)&&d(b)},w=function(a,b,c,e){c!==e&&d(b)}):q?E("235"):E("236");
return{completeWork:function(a,b,c){var m=b.pendingProps;if(null===m)m=b.memoizedProps;else if(2147483647!==b.expirationTime||2147483647===c)b.pendingProps=null;switch(b.tag){case 1:return null;case 2:return ne(b),null;case 3:z(b);V(X,b);V(ie,b);m=b.stateNode;m.pendingContext&&(m.context=m.pendingContext,m.pendingContext=null);if(null===a||null===a.child)L(b),b.effectTag&=-3;N(b);return null;case 5:y(b);c=v();var A=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,q=b.stateNode,x=u();q=
k(q,A,p,m,c,x);J(a,b,q,A,p,m,c);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!m)return null===b.stateNode?E("166"):void 0,null;a=u();if(L(b))G(b,c,a)&&d(b);else{a=e(A,m,c,a,b);a:for(p=b.child;null!==p;){if(5===p.tag||6===p.tag)g(a,p.stateNode);else if(4!==p.tag&&null!==p.child){p.child["return"]=p;p=p.child;continue}if(p===b)break;for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}h(a,A,m,c)&&d(b);b.stateNode=a}null!==b.ref&&
(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)w(a,b,a.memoizedProps,m);else{if("string"!==typeof m)return null===b.stateNode?E("166"):void 0,null;a=v();c=u();L(b)?I(b)&&d(b):b.stateNode=f(m,a,c,b)}return null;case 7:(m=b.memoizedProps)?void 0:E("165");b.tag=8;A=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==p;){if(5===p.tag||6===p.tag||4===p.tag)E("247");else if(9===p.tag)A.push(p.type);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===
p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=m.handler;m=p(m.props,A);b.child=bf(b,null!==a?a.child:null,m,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 10:return null;case 4:return z(b),N(b),null;case 0:E("167");default:E("156")}}}}
function ff(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(A){b(a,A)}}function d(a){"function"===typeof Ee&&Ee(a);switch(a.tag){case 2:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(A){b(a,A)}break;case 5:c(a);break;case 7:e(a.stateNode);break;case 4:k&&g(a)}}function e(a){for(var b=a;;)if(d(b),null===b.child||k&&4===b.tag){if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||
b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function f(a){return 5===a.tag||3===a.tag||4===a.tag}function g(a){for(var b=a,c=!1,f=void 0,g=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?E("160"):void 0;switch(c.tag){case 5:f=c.stateNode;g=!1;break a;case 3:f=c.stateNode.containerInfo;g=!0;break a;case 4:f=c.stateNode.containerInfo;g=!0;break a}c=c["return"]}c=!0}if(5===b.tag||6===b.tag)e(b),g?J(f,b.stateNode):N(f,b.stateNode);
else if(4===b.tag?f=b.stateNode.containerInfo:d(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var h=a.getPublicInstance,k=a.mutation;a=a.persistence;k||(a?E("235"):E("236"));var q=k.commitMount,v=k.commitUpdate,y=k.resetTextContent,u=k.commitTextUpdate,z=k.appendChild,G=k.appendChildToContainer,I=k.insertBefore,L=k.insertInContainerBefore,
N=k.removeChild,J=k.removeChildFromContainer;return{commitResetTextContent:function(a){y(a.stateNode)},commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(f(b)){var c=b;break a}b=b["return"]}E("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:E("161")}c.effectTag&16&&(y(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||f(c["return"])){c=
null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?L(b,e.stateNode,c):I(b,e.stateNode,c):d?G(b,e.stateNode):z(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===
a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){g(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&v(c,f,e,a,d,b)}break;case 6:null===b.stateNode?E("162"):void 0;c=b.memoizedProps;u(b.stateNode,null!==a?a.memoizedProps:
c,c);break;case 3:break;default:E("163")}},commitLifeCycles:function(a,b){switch(b.tag){case 2:var c=b.stateNode;if(b.effectTag&4)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b=b.updateQueue;null!==b&&Ke(b,c);break;case 3:c=b.updateQueue;null!==c&&Ke(c,null!==b.child?b.child.stateNode:null);break;case 5:c=b.stateNode;null===a&&b.effectTag&4&&q(c,
b.type,b.memoizedProps,b);break;case 6:break;case 4:break;default:E("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:b(h(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var gf={};
function hf(a){function b(a){a===gf?E("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e={current:gf},f={current:gf},g={current:gf};return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){V(e,a);V(f,a);V(g,a)},popHostContext:function(a){f.current===a&&(V(e,a),V(f,a))},pushHostContainer:function(a,b){W(g,b,a);b=d(b);W(f,a,a);W(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);
d=c(h,a.type,d);h!==d&&(W(f,a,a),W(e,d,a))},resetHostContainer:function(){e.current=gf;g.current=gf}}}
function jf(a){function b(a,b){var c=new Y(5,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=g(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];y=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){E("175")},prepareToHydrateHostTextInstance:function(){E("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,q=a.hydrateInstance,v=a.hydrateTextInstance,y=null,u=null,z=!1;return{enterHydrationState:function(a){u=
k(a.stateNode.containerInfo);y=a;return z=!0},resetHydrationState:function(){u=y=null;z=!1},tryToClaimNextHydratableInstance:function(a){if(z){var d=u;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=2;z=!1;y=a;return}b(y,u)}y=a;u=k(d)}else a.effectTag|=2,z=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=q(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return v(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
y)return!1;if(!z)return d(a),z=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=u;c;)b(a,c),c=h(c);d(a);u=y?h(a.stateNode):null;return!0}}}
function kf(a){function b(a){Qb=ja=!0;var b=a.stateNode;b.current===a?E("177"):void 0;b.isReadyForCommit=!1;id.current=null;if(1<a.effectTag)if(null!==a.lastEffect){a.lastEffect.nextEffect=a;var c=a.firstEffect}else c=a;else c=a.firstEffect;yg();for(t=c;null!==t;){var d=!1,e=void 0;try{for(;null!==t;){var f=t.effectTag;f&16&&zg(t);if(f&128){var g=t.alternate;null!==g&&Ag(g)}switch(f&-242){case 2:Ne(t);t.effectTag&=-3;break;case 6:Ne(t);t.effectTag&=-3;Oe(t.alternate,t);break;case 4:Oe(t.alternate,
t);break;case 8:Sc=!0,Bg(t),Sc=!1}t=t.nextEffect}}catch(Tc){d=!0,e=Tc}d&&(null===t?E("178"):void 0,h(t,e),null!==t&&(t=t.nextEffect))}Cg();b.current=a;for(t=c;null!==t;){c=!1;d=void 0;try{for(;null!==t;){var k=t.effectTag;k&36&&Dg(t.alternate,t);k&128&&Eg(t);if(k&64)switch(e=t,f=void 0,null!==R&&(f=R.get(e),R["delete"](e),null==f&&null!==e.alternate&&(e=e.alternate,f=R.get(e),R["delete"](e))),null==f?E("184"):void 0,e.tag){case 2:e.stateNode.componentDidCatch(f.error,{componentStack:f.componentStack});
break;case 3:null===ca&&(ca=f.error);break;default:E("157")}var Qc=t.nextEffect;t.nextEffect=null;t=Qc}}catch(Tc){c=!0,d=Tc}c&&(null===t?E("178"):void 0,h(t,d),null!==t&&(t=t.nextEffect))}ja=Qb=!1;"function"===typeof De&&De(a.stateNode);ha&&(ha.forEach(G),ha=null);null!==ca&&(a=ca,ca=null,Ob(a));b=b.current.expirationTime;0===b&&(qa=R=null);return b}function c(a){for(;;){var b=Fg(a.alternate,a,H),c=a["return"],d=a.sibling;var e=a;if(2147483647===H||2147483647!==e.expirationTime){if(2!==e.tag&&3!==
e.tag)var f=0;else f=e.updateQueue,f=null===f?0:f.expirationTime;for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;
if(null!==c)a=c;else{a.stateNode.isReadyForCommit=!0;break}}return null}function d(a){var b=rg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function e(a){var b=Gg(a.alternate,a,H);null===b&&(b=c(a));id.current=null;return b}function f(a){if(null!==R){if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=k(F)?e(F):d(F);else for(;null!==F&&!A();)F=k(F)?e(F):d(F)}else if(!(0===H||H>a))if(H<=Uc)for(;null!==F;)F=d(F);else for(;null!==F&&!A();)F=d(F)}function g(a,b){ja?E("243"):void 0;ja=!0;a.isReadyForCommit=
!1;if(a!==ra||b!==H||null===F){for(;-1<he;)ge[he]=null,he--;je=D;ie.current=D;X.current=!1;x();ra=a;H=b;F=se(ra.current,null,b)}var c=!1,d=null;try{f(b)}catch(Rc){c=!0,d=Rc}for(;c;){if(eb){ca=d;break}var g=F;if(null===g)eb=!0;else{var k=h(g,d);null===k?E("183"):void 0;if(!eb){try{c=k;d=b;for(k=c;null!==g;){switch(g.tag){case 2:ne(g);break;case 5:qg(g);break;case 3:p(g);break;case 4:p(g)}if(g===k||g.alternate===k)break;g=g["return"]}F=e(c);f(d)}catch(Rc){c=!0;d=Rc;continue}break}}}b=ca;eb=ja=!1;ca=
null;null!==b&&Ob(b);return a.isReadyForCommit?a.current.alternate:null}function h(a,b){var c=id.current=null,d=!1,e=!1,f=null;if(3===a.tag)c=a,q(a)&&(eb=!0);else for(var g=a["return"];null!==g&&null===c;){2===g.tag?"function"===typeof g.stateNode.componentDidCatch&&(d=!0,f=jd(g),c=g,e=!0):3===g.tag&&(c=g);if(q(g)){if(Sc||null!==ha&&(ha.has(g)||null!==g.alternate&&ha.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===qa&&(qa=new Set);qa.add(c);var h="";g=a;do{a:switch(g.tag){case 0:case 1:case 2:case 5:var k=
g._debugOwner,Qc=g._debugSource;var m=jd(g);var n=null;k&&(n=jd(k));k=Qc;m="\n    in "+(m||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":n?" (created by "+n+")":"");break a;default:m=""}h+=m;g=g["return"]}while(g);g=h;a=jd(a);null===R&&(R=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};R.set(c,b);try{var p=b.error;p&&p.suppressReactErrorLogging||console.error(p)}catch(Vc){Vc&&
Vc.suppressReactErrorLogging||console.error(Vc)}Qb?(null===ha&&(ha=new Set),ha.add(c)):G(c);return c}null===ca&&(ca=b);return null}function k(a){return null!==R&&(R.has(a)||null!==a.alternate&&R.has(a.alternate))}function q(a){return null!==qa&&(qa.has(a)||null!==a.alternate&&qa.has(a.alternate))}function v(){return 20*(((I()+100)/20|0)+1)}function y(a){return 0!==ka?ka:ja?Qb?1:H:!Hg||a.internalContextTag&1?v():1}function u(a,b){return z(a,b,!1)}function z(a,b){for(;null!==a;){if(0===a.expirationTime||
a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a["return"])if(3===a.tag){var c=a.stateNode;!ja&&c===ra&&b<H&&(F=ra=null,H=0);var d=c,e=b;Rb>Ig&&E("185");if(null===d.nextScheduledRoot)d.remainingExpirationTime=e,null===O?(sa=O=d,d.nextScheduledRoot=d):(O=O.nextScheduledRoot=d,O.nextScheduledRoot=sa);else{var f=d.remainingExpirationTime;if(0===f||e<f)d.remainingExpirationTime=e}Fa||(la?
Sb&&(ma=d,na=1,m(ma,na)):1===e?w(1,null):L(e));!ja&&c===ra&&b<H&&(F=ra=null,H=0)}else break;a=a["return"]}}function G(a){z(a,1,!0)}function I(){return Uc=((Wc()-Pe)/10|0)+2}function L(a){if(0!==Tb){if(a>Tb)return;Jg(Xc)}var b=Wc()-Pe;Tb=a;Xc=Kg(J,{timeout:10*(a-2)-b})}function N(){var a=0,b=null;if(null!==O)for(var c=O,d=sa;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===O?E("244"):void 0;if(d===d.nextScheduledRoot){sa=O=d.nextScheduledRoot=null;break}else if(d===sa)sa=e=d.nextScheduledRoot,
O.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===O){O=c;O.nextScheduledRoot=sa;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===O)break;c=d;d=d.nextScheduledRoot}}c=ma;null!==c&&c===b?Rb++:Rb=0;ma=b;na=a}function J(a){w(0,a)}function w(a,b){fb=b;for(N();null!==ma&&0!==na&&(0===a||na<=a)&&!Yc;)m(ma,na),N();null!==fb&&(Tb=0,Xc=-1);0!==na&&L(na);fb=null;Yc=!1;Rb=0;if(Ub)throw a=Zc,Zc=
null,Ub=!1,a;}function m(a,c){Fa?E("245"):void 0;Fa=!0;if(c<=I()){var d=a.finishedWork;null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(a.remainingExpirationTime=b(d)))}else d=a.finishedWork,null!==d?(a.finishedWork=null,a.remainingExpirationTime=b(d)):(a.finishedWork=null,d=g(a,c),null!==d&&(A()?a.finishedWork=d:a.remainingExpirationTime=b(d)));Fa=!1}function A(){return null===fb||fb.timeRemaining()>Lg?!1:Yc=!0}function Ob(a){null===ma?E("246"):
void 0;ma.remainingExpirationTime=0;Ub||(Ub=!0,Zc=a)}var r=hf(a),n=jf(a),p=r.popHostContainer,qg=r.popHostContext,x=r.resetHostContainer,Me=df(a,r,n,u,y),rg=Me.beginWork,Gg=Me.beginFailedWork,Fg=ef(a,r,n).completeWork;r=ff(a,h);var zg=r.commitResetTextContent,Ne=r.commitPlacement,Bg=r.commitDeletion,Oe=r.commitWork,Dg=r.commitLifeCycles,Eg=r.commitAttachRef,Ag=r.commitDetachRef,Wc=a.now,Kg=a.scheduleDeferredCallback,Jg=a.cancelDeferredCallback,Hg=a.useSyncScheduling,yg=a.prepareForCommit,Cg=a.resetAfterCommit,
Pe=Wc(),Uc=2,ka=0,ja=!1,F=null,ra=null,H=0,t=null,R=null,qa=null,ha=null,ca=null,eb=!1,Qb=!1,Sc=!1,sa=null,O=null,Tb=0,Xc=-1,Fa=!1,ma=null,na=0,Yc=!1,Ub=!1,Zc=null,fb=null,la=!1,Sb=!1,Ig=1E3,Rb=0,Lg=1;return{computeAsyncExpiration:v,computeExpirationForFiber:y,scheduleWork:u,batchedUpdates:function(a,b){var c=la;la=!0;try{return a(b)}finally{(la=c)||Fa||w(1,null)}},unbatchedUpdates:function(a){if(la&&!Sb){Sb=!0;try{return a()}finally{Sb=!1}}return a()},flushSync:function(a){var b=la;la=!0;try{a:{var c=
ka;ka=1;try{var d=a();break a}finally{ka=c}d=void 0}return d}finally{la=b,Fa?E("187"):void 0,w(1,null)}},deferredUpdates:function(a){var b=ka;ka=v();try{return a()}finally{ka=b}}}}
function lf(a){function b(a){a=od(a);return null===a?null:a.stateNode}var c=a.getPublicInstance;a=kf(a);var d=a.computeAsyncExpiration,e=a.computeExpirationForFiber,f=a.scheduleWork;return{createContainer:function(a,b){var c=new Y(3,null,0);a={current:c,containerInfo:a,pendingChildren:null,remainingExpirationTime:0,isReadyForCommit:!1,finishedWork:null,context:null,pendingContext:null,hydrate:b,nextScheduledRoot:null};return c.stateNode=a},updateContainer:function(a,b,c,q){var g=b.current;if(c){c=
c._reactInternalFiber;var h;b:{2===kd(c)&&2===c.tag?void 0:E("170");for(h=c;3!==h.tag;){if(le(h)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}(h=h["return"])?void 0:E("171")}h=h.stateNode.context}c=le(c)?pe(c,h):h}else c=D;null===b.context?b.context=c:b.pendingContext=c;b=q;b=void 0===b?null:b;q=null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent?d():e(g);He(g,{expirationTime:q,partialState:{element:a},callback:b,isReplace:!1,isForced:!1,
nextCallback:null,next:null});f(g,q)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:b,findHostInstanceWithNoPortals:function(a){a=pd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var c=a.findFiberByHostInstance;return Ce(B({},
a,{findHostInstanceByFiber:function(a){return b(a)},findFiberByHostInstance:function(a){return c?c(a):null}}))}}}var mf=Object.freeze({default:lf}),nf=mf&&lf||mf,of=nf["default"]?nf["default"]:nf;function pf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ue,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var qf="object"===typeof performance&&"function"===typeof performance.now,rf=void 0;rf=qf?function(){return performance.now()}:function(){return Date.now()};
var sf=void 0,tf=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var uf=null,vf=!1,wf=-1,xf=!1,yf=0,zf=33,Af=33,Bf;Bf=qf?{didTimeout:!1,timeRemaining:function(){var a=yf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=yf-Date.now();return 0<a?a:0}};var Cf="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Cf){vf=!1;a=rf();if(0>=yf-a)if(-1!==wf&&wf<=
a)Bf.didTimeout=!0;else{xf||(xf=!0,requestAnimationFrame(Df));return}else Bf.didTimeout=!1;wf=-1;a=uf;uf=null;null!==a&&a(Bf)}},!1);var Df=function(a){xf=!1;var b=a-yf+Af;b<Af&&zf<Af?(8>b&&(b=8),Af=b<zf?zf:b):zf=b;yf=a+Af;vf||(vf=!0,window.postMessage(Cf,"*"))};sf=function(a,b){uf=a;null!=b&&"number"===typeof b.timeout&&(wf=rf()+b.timeout);xf||(xf=!0,requestAnimationFrame(Df));return 0};tf=function(){uf=null;vf=!1;wf=-1}}else sf=window.requestIdleCallback,tf=window.cancelIdleCallback;else sf=function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity}})})},
tf=function(a){clearTimeout(a)};var Ef=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Ff={},Gf={};
function Hf(a){if(Gf.hasOwnProperty(a))return!0;if(Ff.hasOwnProperty(a))return!1;if(Ef.test(a))return Gf[a]=!0;Ff[a]=!0;return!1}
function If(a,b,c){var d=wa(b);if(d&&va(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?Jf(a,b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else Kf(a,b,va(b,c)?c:null)}
function Kf(a,b,c){Hf(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))}function Jf(a,b){var c=wa(b);c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}
function Lf(a,b){var c=b.value,d=b.checked;return B({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?d:a._wrapperState.initialChecked})}function Mf(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}
function Nf(a,b){b=b.checked;null!=b&&If(a,"checked",b)}function Of(a,b){Nf(a,b);var c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Pf(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function Qf(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}
function Rf(a,b){a=B({children:void 0},b);if(b=Qf(b.children))a.children=b;return a}function Sf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Tf(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Uf(a,b){null!=b.dangerouslySetInnerHTML?E("91"):void 0;return B({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Vf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?E("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:E("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Wf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Xf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Yf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Zf(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function $f(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Zf(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ag=void 0,bg=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Yf.svg||"innerHTML"in a)a.innerHTML=b;else{ag=ag||document.createElement("div");ag.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=ag.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function cg(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var dg={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},eg=["Webkit","ms","Moz","O"];Object.keys(dg).forEach(function(a){eg.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);dg[b]=dg[a]})});
function fg(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||dg.hasOwnProperty(e)&&dg[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var gg=B({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function hg(a,b,c){b&&(gg[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?E("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?E("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:E("61")),null!=b.style&&"object"!==typeof b.style?E("62",c()):void 0)}
function ig(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var jg=Yf.html,kg=C.thatReturns("");
function lg(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Hd(a);b=Sa[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?wd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(wd("topFocus","focus",a),wd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(yc("cancel",!0)&&wd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(yc("close",!0)&&wd("topClose","close",a),c.topClose=!0):Dd.hasOwnProperty(e)&&U(e,Dd[e],a),c[e]=!0)}}
var mg={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"};function ng(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===jg&&(d=Zf(a));d===jg?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function og(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function pg(a,b,c,d){var e=ig(b,c);switch(b){case "iframe":case "object":U("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);f=c;break;case "source":U("topError","error",a);f=c;break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);f=c;break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);f=c;break;case "details":U("topToggle","toggle",a);f=c;break;case "input":Mf(a,c);f=Lf(a,c);U("topInvalid","invalid",a);
lg(d,"onChange");break;case "option":f=Rf(a,c);break;case "select":Tf(a,c);f=B({},c,{value:void 0});U("topInvalid","invalid",a);lg(d,"onChange");break;case "textarea":Vf(a,c);f=Uf(a,c);U("topInvalid","invalid",a);lg(d,"onChange");break;default:f=c}hg(b,f,kg);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?fg(a,k,kg):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&bg(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&cg(a,k):"number"===typeof k&&cg(a,
""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(Ra.hasOwnProperty(h)?null!=k&&lg(d,h):e?Kf(a,h,k):null!=k&&If(a,h,k))}switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Sf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Sf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=
C)}}
function sg(a,b,c,d,e){var f=null;switch(b){case "input":c=Lf(a,c);d=Lf(a,d);f=[];break;case "option":c=Rf(a,c);d=Rf(a,d);f=[];break;case "select":c=B({},c,{value:void 0});d=B({},d,{value:void 0});f=[];break;case "textarea":c=Uf(a,c);d=Uf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}hg(b,d,kg);var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]=
"");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(Ra.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===
g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&(Ra.hasOwnProperty(g)?(null!=k&&lg(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f}
function tg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Nf(a,e);ig(c,d);d=ig(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?fg(a,h,kg):"dangerouslySetInnerHTML"===g?bg(a,h):"children"===g?cg(a,h):d?null!=h?Kf(a,g,h):a.removeAttribute(g):null!=h?If(a,g,h):Jf(a,g)}switch(c){case "input":Of(a,e);break;case "textarea":Wf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Sf(a,
!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?Sf(a,!!e.multiple,e.defaultValue,!0):Sf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function ug(a,b,c,d,e){switch(b){case "iframe":case "object":U("topLoad","load",a);break;case "video":case "audio":for(var f in mg)mg.hasOwnProperty(f)&&U(f,mg[f],a);break;case "source":U("topError","error",a);break;case "img":case "image":U("topError","error",a);U("topLoad","load",a);break;case "form":U("topReset","reset",a);U("topSubmit","submit",a);break;case "details":U("topToggle","toggle",a);break;case "input":Mf(a,c);U("topInvalid","invalid",a);lg(e,"onChange");break;case "select":Tf(a,c);
U("topInvalid","invalid",a);lg(e,"onChange");break;case "textarea":Vf(a,c),U("topInvalid","invalid",a),lg(e,"onChange")}hg(b,c,kg);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Ra.hasOwnProperty(g)&&null!=f&&lg(e,g));switch(b){case "input":Bc(a);Pf(a,c);break;case "textarea":Bc(a);Xf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function vg(a,b){return a.nodeValue!==b}
var wg=Object.freeze({createElement:ng,createTextNode:og,setInitialProperties:pg,diffProperties:sg,updateProperties:tg,diffHydratedProperties:ug,diffHydratedText:vg,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Of(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=rb(d);e?void 0:E("90");Cc(d);Of(d,e)}}}break;case "textarea":Wf(a,c);break;case "select":b=c.value,null!=b&&Sf(a,!!c.multiple,b,!1)}}});nc.injectFiberControlledHostComponent(wg);var xg=null,Mg=null;function Ng(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function Og(a){a=a?9===a.nodeType?a.documentElement:a.firstChild:null;return!(!a||1!==a.nodeType||!a.hasAttribute("data-reactroot"))}
var Z=of({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:$f(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=$f(a,b)}return a},getChildHostContext:function(a,b){return $f(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){xg=td;var a=da();if(Kd(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(z){b=null;break a}var f=0,g=-1,h=-1,k=0,q=0,v=a,y=null;b:for(;;){for(var u;;){v!==b||0!==d&&3!==v.nodeType||(g=f+d);v!==e||0!==c&&3!==v.nodeType||(h=f+c);3===v.nodeType&&(f+=v.nodeValue.length);if(null===(u=v.firstChild))break;y=v;v=u}for(;;){if(v===a)break b;y===b&&++k===d&&(g=f);y===e&&++q===c&&(h=f);if(null!==(u=v.nextSibling))break;v=y;y=v.parentNode}v=u}b=-1===g||-1===h?null:
{start:g,end:h}}else b=null}b=b||{start:0,end:0}}else b=null;Mg={focusedElem:a,selectionRange:b};ud(!1)},resetAfterCommit:function(){var a=Mg,b=da(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){if(Kd(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[Eb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=Jd(c,a);var f=Jd(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var g=document.createRange();g.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(g),b.extend(f.node,f.offset)):(g.setEnd(f.node,f.offset),b.addRange(g))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ia(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=
a.top}Mg=null;ud(xg);xg=null},createInstance:function(a,b,c,d,e){a=ng(a,b,c,d);a[Q]=e;a[ob]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){pg(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return sg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===
typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=og(a,b);a[Q]=d;return a},now:rf,mutation:{commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){a[ob]=e;tg(a,b,c,d,e)},resetTextContent:function(a){a.textContent=""},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,
b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,
b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[Q]=f;a[ob]=c;return ug(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[Q]=c;return vg(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},
didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:sf,cancelDeferredCallback:tf,useSyncScheduling:!0});rc=Z.batchedUpdates;
function Pg(a,b,c,d,e){Ng(c)?void 0:E("200");var f=c._reactRootContainer;if(f)Z.updateContainer(b,f,a,e);else{d=d||Og(c);if(!d)for(f=void 0;f=c.lastChild;)c.removeChild(f);var g=Z.createContainer(c,d);f=c._reactRootContainer=g;Z.unbatchedUpdates(function(){Z.updateContainer(b,g,a,e)})}return Z.getPublicRootInstance(f)}function Qg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ng(b)?void 0:E("200");return pf(a,b,null,c)}
function Rg(a,b){this._reactRootContainer=Z.createContainer(a,b)}Rg.prototype.render=function(a,b){Z.updateContainer(a,this._reactRootContainer,null,b)};Rg.prototype.unmount=function(a){Z.updateContainer(null,this._reactRootContainer,null,a)};
var Sg={createPortal:Qg,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(b)return Z.findHostInstance(b);"function"===typeof a.render?E("188"):E("213",Object.keys(a))},hydrate:function(a,b,c){return Pg(null,a,b,!0,c)},render:function(a,b,c){return Pg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?E("38"):void 0;return Pg(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ng(a)?void 0:
E("40");return a._reactRootContainer?(Z.unbatchedUpdates(function(){Pg(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:Qg,unstable_batchedUpdates:tc,unstable_deferredUpdates:Z.deferredUpdates,flushSync:Z.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:mb,EventPluginRegistry:Va,EventPropagators:Cb,ReactControlledComponent:qc,ReactDOMComponentTree:sb,ReactDOMEventListener:xd}};
Z.injectIntoDevTools({findFiberByHostInstance:pb,bundleType:0,version:"16.2.0",rendererPackageName:"react-dom"});var Tg=Object.freeze({default:Sg}),Ug=Tg&&Sg||Tg;module.exports=Ug["default"]?Ug["default"]:Ug;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(141);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.2.0
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(68),n=__webpack_require__(69),p=__webpack_require__(38),q="function"===typeof Symbol&&Symbol["for"],r=q?Symbol["for"]("react.element"):60103,t=q?Symbol["for"]("react.call"):60104,u=q?Symbol["for"]("react.return"):60105,v=q?Symbol["for"]("react.portal"):60106,w=q?Symbol["for"]("react.fragment"):60107,x="function"===typeof Symbol&&Symbol.iterator;
function y(a){for(var b=arguments.length-1,e="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);b=Error(e+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var z={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function A(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}A.prototype.isReactComponent={};A.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?y("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};A.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function B(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}function C(){}C.prototype=A.prototype;var D=B.prototype=new C;D.constructor=B;m(D,A.prototype);D.isPureReactComponent=!0;function E(a,b,e){this.props=a;this.context=b;this.refs=n;this.updater=e||z}var F=E.prototype=new C;F.constructor=E;m(F,A.prototype);F.unstable_isAsyncReactComponent=!0;F.render=function(){return this.props.children};var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,e){var c,d={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)H.call(b,c)&&!I.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var h=Array(f),l=0;l<f;l++)h[l]=arguments[l+2];d.children=h}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:r,type:a,key:g,ref:k,props:d,_owner:G.current}}function K(a){return"object"===typeof a&&null!==a&&a.$$typeof===r}
function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var L=/\/+/g,M=[];function N(a,b,e,c){if(M.length){var d=M.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function O(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>M.length&&M.push(a)}
function P(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case r:case t:case u:case v:g=!0}}if(g)return e(c,a,""===b?"."+Q(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+Q(d,k);g+=P(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=x&&a[x]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=
f.call(a),k=0;!(d=a.next()).done;)d=d.value,f=b+Q(d,k++),g+=P(d,f,e,c);else"object"===d&&(e=""+a,y("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function Q(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function R(a,b){a.func.call(a.context,b,a.count++)}
function S(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?T(a,c,e,p.thatReturnsArgument):null!=a&&(K(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(L,"$\x26/")+"/")+e,a={$$typeof:r,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function T(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(L,"$\x26/")+"/");b=N(b,g,c,d);null==a||P(a,"",S,b);O(b)}
var U={Children:{map:function(a,b,e){if(null==a)return a;var c=[];T(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=N(null,null,b,e);null==a||P(a,"",R,b);O(b)},count:function(a){return null==a?0:P(a,"",p.thatReturnsNull,null)},toArray:function(a){var b=[];T(a,b,null,p.thatReturnsArgument);return b},only:function(a){K(a)?void 0:y("143");return a}},Component:A,PureComponent:B,unstable_AsyncComponent:E,Fragment:w,createElement:J,cloneElement:function(a,b,e){var c=m({},a.props),
d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)H.call(b,h)&&!I.hasOwnProperty(h)&&(c[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)c.children=e;else if(1<h){f=Array(h);for(var l=0;l<h;l++)f[l]=arguments[l+2];c.children=f}return{$$typeof:r,type:a.type,key:d,ref:g,props:c,_owner:k}},createFactory:function(a){var b=J.bind(null,a);b.type=a;return b},
isValidElement:K,version:"16.2.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:G,assign:m}},V=Object.freeze({default:U}),W=V&&U||V;module.exports=W["default"]?W["default"]:W;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(38);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(147);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(148);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pivotGrid__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_resizable_css_styles_css__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_resizable_css_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_resizable_css_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zebulon_controls_lib_index_css__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zebulon_controls_lib_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_zebulon_controls_lib_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resizable__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resizable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_resizable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mock__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__configurationFunctions__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__menuFunctions__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__demo__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pivotGrid_services_copyService__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_zebulon_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_zebulon_controls__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ReactDOM from "react-dom";
// import "zebulon-table/lib/index.css";
// console.log("zebulon-table", metaDescriptions, functions, functionsTable);
// import { functionsTable } from "../table/utils";
var ZebulonGridDemo=function(_Component){_inherits(ZebulonGridDemo,_Component);function ZebulonGridDemo(props){_classCallCheck(this,ZebulonGridDemo);var _this=_possibleConstructorReturn(this,(ZebulonGridDemo.__proto__||Object.getPrototypeOf(ZebulonGridDemo)).call(this,props));_this.handleDataSetOption=function(){_this.bigDataSet=!_this.bigDataSet;_this.options=_this.bigDataSet?[500,400,5]:[200,40,3];// const node = document.getElementById("toto");
_this.setState({data:__WEBPACK_IMPORTED_MODULE_5__mock__["b" /* getPromiseMockDatasource */].apply(undefined,[1].concat(_toConsumableArray(_this.options))),actionContent:_this.bigDataSet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Reload a 1 million rows dataset :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"500 Totos * 400 Titis * 5 Tutus"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"N.B. Performances are linked to the length in axis, so if you set Toto, Titi and Tutu in rows, you'll get 1M available rows in the grid and it may be a little slow; just try to set Tutu in columns (row / 5)")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Reload a 24000 rows dataset :"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"200 Totos * 40 Titis * 3 Tutus"))});};_this.pushData=function(){_this.setState({pushedData:__WEBPACK_IMPORTED_MODULE_5__mock__["c" /* getRandomMockDatasource */].apply(undefined,[20].concat(_toConsumableArray(_this.options))),// selectedCell: { rows: 12, columns: 0 },
actionContent:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Push randomly new rows in the dataset. "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"N.B. Only changes diplayed in the grid will be visible, so it may be prefereable to remove (using the contextual menu on the dimension header) the dimension Titi by example (or collapse all dimension Toto)."))});};_this.setCustomConfigurationFunctions=function(){if(_this.state.configurationFunctions===__WEBPACK_IMPORTED_MODULE_6__configurationFunctions__["a" /* configurationFunctions */]){_this.setState(Object(__WEBPACK_IMPORTED_MODULE_8__demo__["a" /* customConfigurationFunctions */])(_this.state.configurationFunctions,_this.state.configuration));}else{_this.setState({configurationFunctions:__WEBPACK_IMPORTED_MODULE_6__configurationFunctions__["a" /* configurationFunctions */],configuration:Object(__WEBPACK_IMPORTED_MODULE_5__mock__["a" /* basicConfig */])({onEdit:_this.onEdit}),actionContent:null});}};_this.setCustomFunctions=function(){if(_this.state.menuFunctions===__WEBPACK_IMPORTED_MODULE_7__menuFunctions__["a" /* menuFunctions */]){_this.setState(Object(__WEBPACK_IMPORTED_MODULE_8__demo__["b" /* customMenuFunctions */])(_this.state.menuFunctions,function(type,action){return _this.setState({actionContent:action});}));}else{_this.setState({menuFunctions:__WEBPACK_IMPORTED_MODULE_7__menuFunctions__["a" /* menuFunctions */],actionContent:null});}};_this.onResize=function(e,data){_this.setState({sizes:Object.assign({},_this.state.sizes,{height:data.size.height,width:data.size.width})});};_this.handleKeyEvent=function(e){_this.setState({keyEvent:e});return true;};_this.onEdit=function(data){_this.setState({actionContent:"Old value: "+data._oldValue+" - New value:"+data._newValue});_this.data.push(data);};_this.onSave=function(){Object(__WEBPACK_IMPORTED_MODULE_9__pivotGrid_services_copyService__["b" /* exportFile */])(JSON.stringify(_this.data),"toto.json");};_this.onClickMenu=function(e,id){if(e.button===2){e.preventDefault();e.persist();e.stopPropagation();// e.button = 0;
_this.setState({menuVisible:!_this.state.menuVisible,menuParent:{top:e.target.offsetTop,left:e.target.offsetLeft}});// console.log("click menu", e.target, id);
}return false;};_this.options=[200,40,3];// this.options = [2, 5, 2];
_this.state={// focusCell: [],
data:__WEBPACK_IMPORTED_MODULE_5__mock__["b" /* getPromiseMockDatasource */].apply(undefined,[1].concat(_toConsumableArray(_this.options))),pushedData:[],configuration:Object(__WEBPACK_IMPORTED_MODULE_5__mock__["a" /* basicConfig */])({onEdit:_this.onEdit}),configurationFunctions:__WEBPACK_IMPORTED_MODULE_6__configurationFunctions__["a" /* configurationFunctions */],menuFunctions:__WEBPACK_IMPORTED_MODULE_7__menuFunctions__["a" /* menuFunctions */],sizes:{height:600,width:1000,rowHeight:25},actionContent:null,keyEvent:null,selectedCell:{rows:0,columns:0}};_this.bigDataSet=false;_this.data=[];// configuration
// this.functions = utils.mergeFunctions([accessors, functions], "dataset");
_this.meta=Object(__WEBPACK_IMPORTED_MODULE_10_zebulon_table__["c" /* metaDescriptions */])("dataset");// configuration
_this.params={};return _this;}_createClass(ZebulonGridDemo,[{key:"componentDidMount",value:function componentDidMount(){document.addEventListener("copy",this.handleKeyEvent);document.addEventListener("paste",this.handleKeyEvent);document.addEventListener("keydown",this.handleKeyEvent);window.addEventListener("beforeunload",this.handleKeyEvent);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("copy",this.handleKeyEvent);document.removeEventListener("paste",this.handleKeyEvent);document.removeEventListener("keydown",this.handleKeyEvent);window.removeEventListener("beforeunload",this.handleKeyEvent);}// onLoad = e => {
//   // getFileObject("file:///c:/Users/thomas/Downloads/toto.json", fileObject => {
//   //   console.log(fileObject);
//   // });
//   const file = document.getElementById("file-selector").files[0];
//   const reader = new FileReader();
//   reader.onload = e => {
//     console.log("toto", reader.result);
//     reader.result;
//   };
//   reader.readAsText(file);
//   // console.log(reader.result);
// };
},{key:"render",value:function render(){var _this2=this;var _state=this.state,sizes=_state.sizes,keyEvent=_state.keyEvent,configuration=_state.configuration,data=_state.data,pushedData=_state.pushedData,actionContent=_state.actionContent,display=_state.display;var sizes2=Object.assign({},this.state.sizes);sizes2.height=sizes2.height-30;// - (display ? 20 : 0);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"zebulon",style:{fontFamily:"sans-serif"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_resizable__["ResizableBox"],{height:sizes.height,width:sizes.width,onResize:this.onResize},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{height:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"checkbox",id:"configuration",onChange:function onChange(){return _this2.setState({display:!display});},checked:display}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"configuration"},"Configuration")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__pivotGrid__["a" /* default */],{configuration:configuration,data:data,pushedData:pushedData,menuFunctions:this.state.menuFunctions,configurationFunctions:this.state.configurationFunctions,sizes:sizes2,ref:function ref(_ref){return _this2.zebulon=_ref;},display:display?"configuration":"pivotgrid",meta:this.meta// functions={this.functions}
,params:this.params,keyEvent:keyEvent,selectedCell:this.state.selectedCell})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex",marginTop:".5em",width:sizes.width}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{style:{marginRight:".5em"},onClick:this.pushData},"Push data"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{style:{marginRight:".5em"},onClick:this.setCustomConfigurationFunctions},(this.state.configurationFunctions===__WEBPACK_IMPORTED_MODULE_6__configurationFunctions__["a" /* configurationFunctions */]?"Add":"Remove")+" custom configuration functions"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{style:{marginRight:".5em"},onClick:this.setCustomFunctions},(this.state.menuFunctions===__WEBPACK_IMPORTED_MODULE_7__menuFunctions__["a" /* menuFunctions */]?"Add":"Remove")+" custom menu functions"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{marginRight:".5em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"option",checked:this.bigDataSet,type:"checkbox",onChange:this.handleDataSetOption}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"option"},"Try a 1M rows dataset"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{minHeight:100,height:"fitContent",width:sizes.width,fontSize:"smaller",marginTop:".5em",border:"solid .05em"}},actionContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontFamily:"sans-serif",fontSize:"smaller",marginTop:"1em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontWeight:"bold"}}," Key board and mouse: "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"2em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Ctrl+A : select all, Ctrl + : zoom in, Ctrl - : zoom out."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Up, Down, Right, Left, PageDown, PageUp, Home, End to move selection."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"+Shift to extend selection, +Alt to move in column axis for PageDown, PageUp, Home, End."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Mouse down and move over to select a range."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Mouse wheel to scroll. +Alt to scroll in column")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontWeight:"bold"}}," Dimension headers: "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"2em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," Click: toggle sort direction."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Drag and drop on an other dimension header to reorder or change dimension axis."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Collapse or expand button to hide or show attribute dimensions (in Italic)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Right and bottom handle: drag and drop to resize rows or columns headers."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Right click context menu to reverse order, filter, expand and collapse all, remove or add dimension, subtotals or grand total.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontWeight:"bold"}},"Measure, column and row headers:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"2em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," Click: select children headers columns or rows."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Collapse or expand button to hide or show children headers and recompute measures."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Right and bottom handle: drag and drop to resize rows or columns."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Drag and drop measure on an other measure to reorder them, on a dimension header to change measure axis."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Right click context menu on measures to remove, add a measure or change the axis.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{fontWeight:"bold"}},"Cells and ranges:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"2em"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," Ctrl+C to copy selected range"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," Double click for drilldown main custom function"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Right click context menu to call cell, range or general custom functions,to filter any dimension or to modify some configuration parameters (as changing subtotals position).")))));}}]);return ZebulonGridDemo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ZebulonGridDemo);// (<button
//   style={{ marginRight: ".5em" }}
//   type="button"
//   onClick={this.onSave}
// >
//   Save
// </button>

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ZebulonGrid__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_PivotGrid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_configuration__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_polyfill__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__utils_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zebulon_table__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* unused harmony reexport GridWithoutStoreAndDndContext */
/* unused harmony reexport GridWithoutStore */
/* unused harmony reexport reducer */
/* unused harmony reexport actions */
/* unused harmony reexport applyConfigToStore */
// Import polyfills for IE11 compatibility
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__ZebulonGrid__["a" /* default */]);

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_PivotGrid__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Chart__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zebulon_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reducers__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_aggregation__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_configurationMenus__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_configuration__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(6);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// configuration
// configuration
var ZebulonGrid=function(_Component){_inherits(ZebulonGrid,_Component);function ZebulonGrid(props){_classCallCheck(this,ZebulonGrid);// configuration
var _this=_possibleConstructorReturn(this,(ZebulonGrid.__proto__||Object.getPrototypeOf(ZebulonGrid)).call(this,props));_initialiseProps.call(_this);_this.buildFunctionsTable(props);if(props.display==="configuration"||props.display==="error")_this.buildDimensionsAndMesures(props.configuration,props.tabs);// configuration
_this.state={sizes:Object.assign({},props.sizes,{height:props.sizes.height-30}),display:props.display};_this.zoomValue=props.sizes.zoom||1;return _this;}// configuration
_createClass(ZebulonGrid,[{key:"componentWillReceiveProps",// configuration
value:function componentWillReceiveProps(nextProps){var data=nextProps.data,meta=nextProps.meta,configuration=nextProps.configuration,configurationFunctions=nextProps.configurationFunctions,pushedData=nextProps.pushedData,sizes=nextProps.sizes,keyEvent=nextProps.keyEvent,display=nextProps.display,tabs=nextProps.tabs;// this.sizes = { ...defaultSizes, ...sizes };
if(sizes!==this.props.sizes){Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["b" /* applySizesToStore */])(this.store,sizes);if(sizes.zoom){this.zoomValue=sizes.zoom;}this.setState({sizes:Object.assign({},sizes,{height:sizes.height-30,zoom:this.zoomValue})});}if(display==="configuration"&&(this.props.display!==display||this.props.configuration!==configuration||this.props.tabs!==tabs)){this.buildDimensionsAndMesures(configuration,tabs);}// configuration
if(nextProps.configurationFunctions!==this.props.configurationFunctions||nextProps.functions!==this.props.functions||!this.functions){this.buildFunctionsTable(nextProps);}// configuration
if(this.props.configuration!==configuration){Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["a" /* applyConfigurationToStore */])(this.store,configuration,this.functions,data===this.props.data?null:data,this.props.utils||__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */]);}else if(this.props.data!==data){Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["h" /* setData */])(this.store,data,meta);}else if(this.props.pushedData!==pushedData&&pushedData.length){Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["g" /* pushData */])(this.store,pushedData);}if(this.props.display!==display){this.setState({display:display});}else if(this.props.keyEvent!==keyEvent){this.handleKeyEvent(keyEvent);}}},{key:"componentWillMount",value:function componentWillMount(){var _props=this.props,data=_props.data,configuration=_props.configuration,configurationFunctions=_props.configurationFunctions,sizes=_props.sizes,functions=_props.functions;this.store=Object(__WEBPACK_IMPORTED_MODULE_1_redux__["c" /* createStore */])(__WEBPACK_IMPORTED_MODULE_7__reducers__["a" /* default */],window.__REDUX_DEVTOOLS_EXTENSION__&&window.__REDUX_DEVTOOLS_EXTENSION__());Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["b" /* applySizesToStore */])(this.store,Object.assign({},__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["d" /* defaultSizes */],sizes));Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["a" /* applyConfigurationToStore */])(this.store,configuration,this.functions,data,this.props.utils||__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */]);}},{key:"componentDidMount",value:function componentDidMount(){if(!this.props.keyEvent===undefined){document.addEventListener("copy",this.handleCopy);document.addEventListener("paste",this.handlePaste);document.addEventListener("keydown",this.handleKeyDown);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(!this.props.keyEvent===undefined){document.removeEventListener("copy",this.handleCopy);document.removeEventListener("paste",this.handlePaste);document.removeEventListener("keydown",this.handleKeyDown);}}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){if(this.updateKey){this.updateKey=false;return false;}return true;}// configuration
},{key:"render",value:function render(){var _this2=this;// pivot grid
var div=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:this.store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_PivotGrid__["a" /* default */],{id:this.props.id,menuFunctions:this.props.menuFunctions||__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["c" /* defaultMenuFunctions */],selectedCell:this.props.selectedCell,getRef:function getRef(ref){return _this2.display=ref;}})));if(this.state.display==="configuration"||this.state.display==="error"){var _store$getState=this.store.getState(),data=_store$getState.data,status=_store$getState.status;this.meta=data.meta||this.props.meta||{};this.data=data.data;// configuration
div=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:this.store},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_zebulon_table__["a" /* ZebulonTableAndConfiguration */],{id:this.props.id,sizes:this.state.sizes,data:this.data,meta:this.meta,functions:this.functions,params:this.props.params||{},status:status,tabs:this.tabs,ref:function ref(_ref){return _this2.display=_ref;},callbacks:Object.assign({applyDimensions:this.applyDimensions,applyMeasures:this.applyMeasures,applyFunctions:this.applyFunctions},this.props.callbacks),utils:this.props.utils,configurationMenus:Object.assign({},__WEBPACK_IMPORTED_MODULE_9__utils_configurationMenus__["a" /* configurationMenus */],this.props.configurationMenus||{})})));}// configuration
// else
//
// if (this.props.display === "chart") {
//   this.displayId = `chart-${this.props.id || 0}`;
//   div = (
//     <div>
//       <Provider store={this.store}>
//         <Chart
//           id={this.displayId}
//           menuFunctions={this.props.menuFunctions || defaultMenuFunctions}
//           key={this.displayId}
//           configurationId={this.displayId}
//           // isActive={this.props.isActive}
//           getRef={ref => (this.display = ref)}
//           callbacks={this.props.callbacks}
//         />
//       </Provider>
//     </div>
//   );
// }
return div;}}]);return ZebulonGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);// expose all actions
var _initialiseProps=function _initialiseProps(){var _this3=this;this.buildDimensionsAndMesures=function(configuration,tabs){_this3.measures=configuration.measures.map(function(measure,index){measure.index_=index;return measure;});_this3.dimensions=configuration.dimensions.map(function(dimension,index){dimension.index_=index;return dimension;});_this3.tabs=[{id:"measures",caption:"Measures",data:_this3.measures,updatedRows:{}},{id:"dimensions",caption:"Dimensions",data:_this3.dimensions,updatedRows:{}}];if(tabs){_this3.tabs=_this3.tabs.concat(tabs);}};this.buildFunctionsTable=function(props){if(!Array.isArray(props.functions)){_this3.functions=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].mergeFunctions([__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["g" /* accessors */],__WEBPACK_IMPORTED_MODULE_5_zebulon_table__["b" /* functions */],props.configurationFunctions||{},props.configuration.functions||{}],"dataset");}else{_this3.functions=props.functions;}};this.handleKeyEvent=function(e){if(_this3.display&&_this3.display.handleKeyEvent){return _this3.display.handleKeyEvent(e);}var zoom=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].isZoom(e);if(zoom){e.preventDefault();_this3.zoomValue*=zoom===1?1.1:1/1.1;_this3.store.dispatch(__WEBPACK_IMPORTED_MODULE_12__actions__["zoom"](_this3.zoomValue));_this3.setState({sizes:Object.assign({},_this3.state.sizes,{zoom:_this3.zoomValue})});return;}if(!_this3.display)return;else if(e.type==="copy")_this3.handleCopy(e);else if(e.type==="paste")_this3.handlepaste(e);else if(e.type==="keydown")_this3.handleKeyDown(e);_this3.updateKey=true;};this.handleKeyDown=function(e){if(!e.defaultPrevented&&_this3.display.handleKeyDown&&(_this3.props.isActive===undefined||_this3.props.isActive)){_this3.display.handleKeyDown(e);}};this.handleCopy=function(e){if(!e.defaultPrevented&&_this3.display.handleCopy&&(_this3.props.isActive===undefined||_this3.props.isActive)){_this3.display.handleCopy(e);}};this.handlePaste=function(e){if(!e.defaultPrevented&&_this3.display.handlePaste&&(_this3.props.isActive===undefined||_this3.props.isActive)){_this3.display.handlePaste(e);}};this.buildObject=function(item,excludes){if(Array.isArray(item)){return item.map(function(item){return _this3.buildObject(item,excludes);});}else if((typeof item==="undefined"?"undefined":_typeof(item))==="object"){return Object.keys(item).reduce(function(acc,key){if(!__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].isNullOrUndefined(item[key])&&!excludes[key]){acc[key]=_this3.buildObject(item[key],excludes);}return acc;},{});}else{return item;}};this.applyDimensions=function(){var _props2=_this3.props,configuration=_props2.configuration,configurationFunctions=_props2.configurationFunctions;var dimensions=_this3.buildObject(_this3.tabs[1].data.filter(function(d){return!(_this3.tabs[1].updatedRows[d.index_]||{}).deleted_;}),{index_:true});var add=false;var axis={};(configuration.rows||[]).forEach(function(d){return axis[d]="rows";});(configuration.columns||[]).forEach(function(d){return axis[d]="columns";});(configuration.dimensions||[]).forEach(function(d){return axis[d]="rows";});configuration.rows=[];configuration.columns=[];// configuration.dimensions = [];
// if (
//   (configuration.rows || []).length +
//     (configuration.columns || []).length ===
//   0
// ) {
//   configuration.rows = [];
//   add = true;
// }
if(!configurationFunctions.dataset){configurationFunctions.dataset={accessors:{},sorts:{},formats:{}};}else{if(!configurationFunctions.dataset.accessors){configurationFunctions.dataset.accessors={};}if(!configurationFunctions.dataset.sorts){configurationFunctions.dataset.sorts={};}if(!configurationFunctions.dataset.formats){configurationFunctions.dataset.formats={};}}dimensions.forEach(function(dimension){configurationFunctions.dataset.accessors[dimension.keyAccessor]=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"accessor",dimension.keyAccessor,_this3.props.utils);configurationFunctions.dataset.accessors[dimension.labelAccessor]=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"accessor",dimension.labelAccessor,_this3.props.utils);configurationFunctions.dataset.accessors[dimension.sortAccessor]=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"accessor",dimension.sortAccessor,_this3.props.utils);configurationFunctions.dataset.sorts[dimension.sortFunction]=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"sort",dimension.sortFunction,_this3.props.utils);configurationFunctions.dataset.formats[dimension.format]=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"format",dimension.format,_this3.props.utils);if(axis[dimension.id]==="dimensions"){configuration.dimensions.push(dimension.id);}else if(axis[dimension.id]==="columns"){configuration.columns.push(dimension.id);}else{configuration.rows.push(dimension.id);}});configuration.dimensions=dimensions;configuration.axis={measures:configuration.axis.measures};Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["a" /* applyConfigurationToStore */])(_this3.store,configuration,_this3.functions,_this3.props.data,_this3.props.utils||__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */]);return true;};this.applyMeasures=function(){var _props3=_this3.props,configuration=_props3.configuration,configurationFunctions=_props3.configurationFunctions;var measures=_this3.buildObject(_this3.tabs[0].data.filter(function(m){return!(_this3.tabs[0].updatedRows[m.index_]||{}).deleted_;}),{index_:true});var axis={};(configuration.measures||[]).forEach(function(m){return axis[m.id]="out";});(configuration.activeMeasures||[]).forEach(function(m){return axis[m]="in";});configuration.activeMeasures=[];if(!configurationFunctions.dataset){configurationFunctions.dataset={accessors:{},aggregations:{},formats:{}};}else{if(!configurationFunctions.dataset.accessors){configurationFunctions.dataset.accessors={};}if(!configurationFunctions.dataset.aggregations){configurationFunctions.dataset.aggregations={};}if(!configurationFunctions.dataset.formats){configurationFunctions.dataset.formats={};}}measures.forEach(function(measure){var f=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"accessor",measure.valueAccessor,_this3.props.utils);configurationFunctions.dataset.accessors[measure.valueAccessor]=f;configurationFunctions.dataset.formats[measure.format]=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"format",measure.format,_this3.props.utils);if(!__WEBPACK_IMPORTED_MODULE_8__utils_aggregation__[measure.aggregation]){configurationFunctions.dataset.aggregation[measure.aggregation]=__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */].getFunction(_this3.functions,"aggregation",measure.aggregation,_this3.props.utils);}if(axis[measure.id]!=="out"){configuration.activeMeasures.push(measure.id);}});configuration.measures=measures;delete configuration.axis.measures;Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["a" /* applyConfigurationToStore */])(_this3.store,configuration,_this3.functions,_this3.props.data,_this3.props.utils||__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */]);return true;};this.applyFunctions=function(){var _props4=_this3.props,configuration=_props4.configuration,configurationFunctions=_props4.configurationFunctions;var functions=// this.buildObject(
_this3.display.state.functions.filter(function(f){return f.isLocal;}).reduce(function(acc,f){if(!acc.dataset[f.tp+"s"]){acc.dataset[f.tp+"s"]={};}acc.dataset[f.tp+"s"][f.id]=f.functionText;return acc;},{dataset:{}});configuration.functions=functions;return true;};};Object.keys(__WEBPACK_IMPORTED_MODULE_12__actions__).forEach(function(action){/* eslint-disable func-names */ZebulonGrid.prototype[action]=function(){this.store.dispatch(__WEBPACK_IMPORTED_MODULE_12__actions__[action].apply(__WEBPACK_IMPORTED_MODULE_12__actions__,arguments));};/* eslint-enable */});ZebulonGrid.prototype["setData"]=function(data){Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["h" /* setData */])(this.store,data);};ZebulonGrid.prototype["getStore"]=function(){return this.store.getState();};ZebulonGrid.prototype["setConfiguration"]=function(configuration,data){Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["a" /* applyConfigurationToStore */])(this.store,configuration,this.Functions,data,this.props.utils||__WEBPACK_IMPORTED_MODULE_6_zebulon_controls__["j" /* utils */]);};ZebulonGrid.prototype["setSizes"]=function(sizes){Object(__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["b" /* applySizesToStore */])(this.store,Object.assign({},__WEBPACK_IMPORTED_MODULE_11__utils_configuration__["d" /* defaultSizes */],sizes));};/* harmony default export */ __webpack_exports__["a"] = (ZebulonGrid);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(157);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(155);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(17)))

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(71);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(159);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(73);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(74);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(41);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(168);
var invariant = __webpack_require__(169);
var ReactPropTypesSecret = __webpack_require__(170);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(177);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(78);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(78);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(79);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(178);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(41);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(180);
var invariant = __webpack_require__(181);
var ReactPropTypesSecret = __webpack_require__(182);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropManager = __webpack_require__(184);

Object.defineProperty(exports, 'DragDropManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropManager).default;
  }
});

var _DragSource = __webpack_require__(244);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(245);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

var _createTestBackend = __webpack_require__(246);

Object.defineProperty(exports, 'createTestBackend', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createTestBackend).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createStore = __webpack_require__(185);

var _createStore2 = _interopRequireDefault(_createStore);

var _reducers = __webpack_require__(190);

var _reducers2 = _interopRequireDefault(_reducers);

var _dragDrop = __webpack_require__(27);

var dragDropActions = _interopRequireWildcard(_dragDrop);

var _DragDropMonitor = __webpack_require__(240);

var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropManager = function () {
	function DragDropManager(createBackend) {
		var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, DragDropManager);

		var store = (0, _createStore2.default)(_reducers2.default);
		this.context = context;
		this.store = store;
		this.monitor = new _DragDropMonitor2.default(store);
		this.registry = this.monitor.registry;
		this.backend = createBackend(this);

		store.subscribe(this.handleRefCountChange.bind(this));
	}

	_createClass(DragDropManager, [{
		key: 'handleRefCountChange',
		value: function handleRefCountChange() {
			var shouldSetUp = this.store.getState().refCount > 0;
			if (shouldSetUp && !this.isSetUp) {
				this.backend.setup();
				this.isSetUp = true;
			} else if (!shouldSetUp && this.isSetUp) {
				this.backend.teardown();
				this.isSetUp = false;
			}
		}
	}, {
		key: 'getContext',
		value: function getContext() {
			return this.context;
		}
	}, {
		key: 'getMonitor',
		value: function getMonitor() {
			return this.monitor;
		}
	}, {
		key: 'getBackend',
		value: function getBackend() {
			return this.backend;
		}
	}, {
		key: 'getRegistry',
		value: function getRegistry() {
			return this.registry;
		}
	}, {
		key: 'getActions',
		value: function getActions() {
			var manager = this;
			var dispatch = this.store.dispatch;


			function bindActionCreator(actionCreator) {
				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var action = actionCreator.apply(manager, args);
					if (typeof action !== 'undefined') {
						dispatch(action);
					}
				};
			}

			return Object.keys(dragDropActions).filter(function (key) {
				return typeof dragDropActions[key] === 'function';
			}).reduce(function (boundActions, key) {
				var action = dragDropActions[key];
				boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
				return boundActions;
			}, {});
		}
	}]);

	return DragDropManager;
}();

exports.default = DragDropManager;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ActionTypes = undefined;
exports['default'] = createStore;

var _isPlainObject = __webpack_require__(11);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(72);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2['default'])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2['default']] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(42);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 187 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(189);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = reduce;

var _dragOffset = __webpack_require__(83);

var _dragOffset2 = _interopRequireDefault(_dragOffset);

var _dragOperation = __webpack_require__(191);

var _dragOperation2 = _interopRequireDefault(_dragOperation);

var _refCount = __webpack_require__(227);

var _refCount2 = _interopRequireDefault(_refCount);

var _dirtyHandlerIds = __webpack_require__(93);

var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);

var _stateId = __webpack_require__(239);

var _stateId2 = _interopRequireDefault(_stateId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	return {
		dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
		dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
		refCount: (0, _refCount2.default)(state.refCount, action),
		dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
		stateId: (0, _stateId2.default)(state.stateId)
	};
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOperation;

var _without = __webpack_require__(85);

var _without2 = _interopRequireDefault(_without);

var _dragDrop = __webpack_require__(27);

var _registry = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
	itemType: null,
	item: null,
	sourceId: null,
	targetIds: [],
	dropResult: null,
	didDrop: false,
	isSourcePublic: null
};

function dragOperation() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return _extends({}, state, {
				itemType: action.itemType,
				item: action.item,
				sourceId: action.sourceId,
				isSourcePublic: action.isSourcePublic,
				dropResult: null,
				didDrop: false
			});
		case _dragDrop.PUBLISH_DRAG_SOURCE:
			return _extends({}, state, {
				isSourcePublic: true
			});
		case _dragDrop.HOVER:
			return _extends({}, state, {
				targetIds: action.targetIds
			});
		case _registry.REMOVE_TARGET:
			if (state.targetIds.indexOf(action.targetId) === -1) {
				return state;
			}
			return _extends({}, state, {
				targetIds: (0, _without2.default)(state.targetIds, action.targetId)
			});
		case _dragDrop.DROP:
			return _extends({}, state, {
				dropResult: action.dropResult,
				didDrop: true,
				targetIds: []
			});
		case _dragDrop.END_DRAG:
			return _extends({}, state, {
				itemType: null,
				item: null,
				sourceId: null,
				dropResult: null,
				didDrop: false,
				isSourcePublic: null,
				targetIds: []
			});
		default:
			return state;
	}
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(193),
    ListCache = __webpack_require__(204),
    Map = __webpack_require__(210);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(194),
    hashDelete = __webpack_require__(200),
    hashGet = __webpack_require__(201),
    hashHas = __webpack_require__(202),
    hashSet = __webpack_require__(203);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(28);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(88),
    isMasked = __webpack_require__(196),
    isObject = __webpack_require__(21),
    toSource = __webpack_require__(198);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(197);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(19);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 198 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 199 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 200 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(28);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(28);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(28);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(205),
    listCacheDelete = __webpack_require__(206),
    listCacheGet = __webpack_require__(207),
    listCacheHas = __webpack_require__(208),
    listCacheSet = __webpack_require__(209);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 205 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(30);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(30);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(30);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(30);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(29),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(32);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(32);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(32);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(32);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(219),
    baseIsNaN = __webpack_require__(220),
    strictIndexOf = __webpack_require__(221);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 221 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(90);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(224),
    shortOut = __webpack_require__(226);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(225),
    defineProperty = __webpack_require__(91),
    identity = __webpack_require__(89);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 226 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = refCount;

var _registry = __webpack_require__(34);

function refCount() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var action = arguments[1];

	switch (action.type) {
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
			return state + 1;
		case _registry.REMOVE_SOURCE:
		case _registry.REMOVE_TARGET:
			return state - 1;
		default:
			return state;
	}
}

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(229),
    baseRest = __webpack_require__(15),
    baseXor = __webpack_require__(230),
    isArrayLikeObject = __webpack_require__(33);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(86),
    baseFlatten = __webpack_require__(94),
    baseUniq = __webpack_require__(96);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(42),
    isArguments = __webpack_require__(95),
    isArray = __webpack_require__(12);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(235),
    noop = __webpack_require__(97),
    setToArray = __webpack_require__(98);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(29),
    root = __webpack_require__(19);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46),
    baseIntersection = __webpack_require__(237),
    baseRest = __webpack_require__(15),
    castArrayLikeObject = __webpack_require__(238);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(43),
    arrayIncludes = __webpack_require__(44),
    arrayIncludesWith = __webpack_require__(45),
    arrayMap = __webpack_require__(46),
    baseUnary = __webpack_require__(47),
    cacheHas = __webpack_require__(48);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(33);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stateId;
function stateId() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

	return state + 1;
}

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(12);

var _isArray2 = _interopRequireDefault(_isArray);

var _matchesType = __webpack_require__(84);

var _matchesType2 = _interopRequireDefault(_matchesType);

var _HandlerRegistry = __webpack_require__(241);

var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);

var _dragOffset = __webpack_require__(83);

var _dirtyHandlerIds = __webpack_require__(93);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropMonitor = function () {
	function DragDropMonitor(store) {
		_classCallCheck(this, DragDropMonitor);

		this.store = store;
		this.registry = new _HandlerRegistry2.default(store);
	}

	_createClass(DragDropMonitor, [{
		key: 'subscribeToStateChange',
		value: function subscribeToStateChange(listener) {
			var _this = this;

			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var handlerIds = options.handlerIds;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
			(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');

			var prevStateId = this.store.getState().stateId;
			var handleChange = function handleChange() {
				var state = _this.store.getState();
				var currentStateId = state.stateId;
				try {
					var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);

					if (!canSkipListener) {
						listener();
					}
				} finally {
					prevStateId = currentStateId;
				}
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'subscribeToOffsetChange',
		value: function subscribeToOffsetChange(listener) {
			var _this2 = this;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');

			var previousState = this.store.getState().dragOffset;
			var handleChange = function handleChange() {
				var nextState = _this2.store.getState().dragOffset;
				if (nextState === previousState) {
					return;
				}

				previousState = nextState;
				listener();
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'canDragSource',
		value: function canDragSource(sourceId) {
			var source = this.registry.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (this.isDragging()) {
				return false;
			}

			return source.canDrag(this, sourceId);
		}
	}, {
		key: 'canDropOnTarget',
		value: function canDropOnTarget(targetId) {
			var target = this.registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected to find a valid target.');

			if (!this.isDragging() || this.didDrop()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			return Boolean(this.getItemType());
		}
	}, {
		key: 'isDraggingSource',
		value: function isDraggingSource(sourceId) {
			var source = this.registry.getSource(sourceId, true);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (!this.isDragging() || !this.isSourcePublic()) {
				return false;
			}

			var sourceType = this.registry.getSourceType(sourceId);
			var draggedItemType = this.getItemType();
			if (sourceType !== draggedItemType) {
				return false;
			}

			return source.isDragging(this, sourceId);
		}
	}, {
		key: 'isOverTarget',
		value: function isOverTarget(targetId) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
			var shallow = options.shallow;

			if (!this.isDragging()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				return false;
			}

			var targetIds = this.getTargetIds();
			if (!targetIds.length) {
				return false;
			}

			var index = targetIds.indexOf(targetId);
			if (shallow) {
				return index === targetIds.length - 1;
			} else {
				return index > -1;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.store.getState().dragOperation.itemType;
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.store.getState().dragOperation.item;
		}
	}, {
		key: 'getSourceId',
		value: function getSourceId() {
			return this.store.getState().dragOperation.sourceId;
		}
	}, {
		key: 'getTargetIds',
		value: function getTargetIds() {
			return this.store.getState().dragOperation.targetIds;
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.store.getState().dragOperation.dropResult;
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.store.getState().dragOperation.didDrop;
		}
	}, {
		key: 'isSourcePublic',
		value: function isSourcePublic() {
			return this.store.getState().dragOperation.isSourcePublic;
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.store.getState().dragOffset.initialClientOffset;
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.store.getState().dragOffset.initialSourceClientOffset;
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.store.getState().dragOffset.clientOffset;
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
		}
	}]);

	return DragDropMonitor;
}();

exports.default = DragDropMonitor;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(12);

var _isArray2 = _interopRequireDefault(_isArray);

var _asap = __webpack_require__(242);

var _asap2 = _interopRequireDefault(_asap);

var _registry = __webpack_require__(34);

var _getNextUniqueId = __webpack_require__(243);

var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HandlerRoles = {
	SOURCE: 'SOURCE',
	TARGET: 'TARGET'
};

function validateSourceContract(source) {
	(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}

function validateTargetContract(target) {
	(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
	(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}

function validateType(type, allowArray) {
	if (allowArray && (0, _isArray2.default)(type)) {
		type.forEach(function (t) {
			return validateType(t, false);
		});
		return;
	}

	(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

function getNextHandlerId(role) {
	var id = (0, _getNextUniqueId2.default)().toString();
	switch (role) {
		case HandlerRoles.SOURCE:
			return 'S' + id;
		case HandlerRoles.TARGET:
			return 'T' + id;
		default:
			(0, _invariant2.default)(false, 'Unknown role: ' + role);
	}
}

function parseRoleFromHandlerId(handlerId) {
	switch (handlerId[0]) {
		case 'S':
			return HandlerRoles.SOURCE;
		case 'T':
			return HandlerRoles.TARGET;
		default:
			(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
	}
}

var HandlerRegistry = function () {
	function HandlerRegistry(store) {
		_classCallCheck(this, HandlerRegistry);

		this.store = store;

		this.types = {};
		this.handlers = {};

		this.pinnedSourceId = null;
		this.pinnedSource = null;
	}

	_createClass(HandlerRegistry, [{
		key: 'addSource',
		value: function addSource(type, source) {
			validateType(type);
			validateSourceContract(source);

			var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
			this.store.dispatch((0, _registry.addSource)(sourceId));
			return sourceId;
		}
	}, {
		key: 'addTarget',
		value: function addTarget(type, target) {
			validateType(type, true);
			validateTargetContract(target);

			var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
			this.store.dispatch((0, _registry.addTarget)(targetId));
			return targetId;
		}
	}, {
		key: 'addHandler',
		value: function addHandler(role, type, handler) {
			var id = getNextHandlerId(role);
			this.types[id] = type;
			this.handlers[id] = handler;

			return id;
		}
	}, {
		key: 'containsHandler',
		value: function containsHandler(handler) {
			var _this = this;

			return Object.keys(this.handlers).some(function (key) {
				return _this.handlers[key] === handler;
			});
		}
	}, {
		key: 'getSource',
		value: function getSource(sourceId, includePinned) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');

			var isPinned = includePinned && sourceId === this.pinnedSourceId;
			var source = isPinned ? this.pinnedSource : this.handlers[sourceId];

			return source;
		}
	}, {
		key: 'getTarget',
		value: function getTarget(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.handlers[targetId];
		}
	}, {
		key: 'getSourceType',
		value: function getSourceType(sourceId) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
			return this.types[sourceId];
		}
	}, {
		key: 'getTargetType',
		value: function getTargetType(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.types[targetId];
		}
	}, {
		key: 'isSourceId',
		value: function isSourceId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.SOURCE;
		}
	}, {
		key: 'isTargetId',
		value: function isTargetId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.TARGET;
		}
	}, {
		key: 'removeSource',
		value: function removeSource(sourceId) {
			var _this2 = this;

			(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
			this.store.dispatch((0, _registry.removeSource)(sourceId));

			(0, _asap2.default)(function () {
				delete _this2.handlers[sourceId];
				delete _this2.types[sourceId];
			});
		}
	}, {
		key: 'removeTarget',
		value: function removeTarget(targetId) {
			var _this3 = this;

			(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
			this.store.dispatch((0, _registry.removeTarget)(targetId));

			(0, _asap2.default)(function () {
				delete _this3.handlers[targetId];
				delete _this3.types[targetId];
			});
		}
	}, {
		key: 'pinSource',
		value: function pinSource(sourceId) {
			var source = this.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected an existing source.');

			this.pinnedSourceId = sourceId;
			this.pinnedSource = source;
		}
	}, {
		key: 'unpinSource',
		value: function unpinSource() {
			(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');

			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	}]);

	return HandlerRegistry;
}();

exports.default = HandlerRegistry;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(65);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getNextUniqueId;
var nextUniqueId = 0;

function getNextUniqueId() {
	return nextUniqueId++;
}

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragSource = function () {
	function DragSource() {
		_classCallCheck(this, DragSource);
	}

	_createClass(DragSource, [{
		key: "canDrag",
		value: function canDrag() {
			return true;
		}
	}, {
		key: "isDragging",
		value: function isDragging(monitor, handle) {
			return handle === monitor.getSourceId();
		}
	}, {
		key: "endDrag",
		value: function endDrag() {}
	}]);

	return DragSource;
}();

exports.default = DragSource;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropTarget = function () {
	function DropTarget() {
		_classCallCheck(this, DropTarget);
	}

	_createClass(DropTarget, [{
		key: "canDrop",
		value: function canDrop() {
			return true;
		}
	}, {
		key: "hover",
		value: function hover() {}
	}, {
		key: "drop",
		value: function drop() {}
	}]);

	return DropTarget;
}();

exports.default = DropTarget;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createBackend;

var _noop = __webpack_require__(97);

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TestBackend = function () {
	function TestBackend(manager) {
		_classCallCheck(this, TestBackend);

		this.actions = manager.getActions();
	}

	_createClass(TestBackend, [{
		key: 'setup',
		value: function setup() {
			this.didCallSetup = true;
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			this.didCallTeardown = true;
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource() {
			return _noop2.default;
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview() {
			return _noop2.default;
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget() {
			return _noop2.default;
		}
	}, {
		key: 'simulateBeginDrag',
		value: function simulateBeginDrag(sourceIds, options) {
			this.actions.beginDrag(sourceIds, options);
		}
	}, {
		key: 'simulatePublishDragSource',
		value: function simulatePublishDragSource() {
			this.actions.publishDragSource();
		}
	}, {
		key: 'simulateHover',
		value: function simulateHover(targetIds, options) {
			this.actions.hover(targetIds, options);
		}
	}, {
		key: 'simulateDrop',
		value: function simulateDrop() {
			this.actions.drop();
		}
	}, {
		key: 'simulateEndDrag',
		value: function simulateEndDrag() {
			this.actions.endDrag();
		}
	}]);

	return TestBackend;
}();

function createBackend(manager) {
	return new TestBackend(manager);
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragDropContext = __webpack_require__(81);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This class is a React-Component based version of the DragDropContext.
 * This is an alternative to decorating an application component with an ES7 decorator.
 */
var DragDropContextProvider = (_temp = _class = function (_Component) {
	_inherits(DragDropContextProvider, _Component);

	function DragDropContextProvider(props, context) {
		_classCallCheck(this, DragDropContextProvider);

		/**
   * This property determines which window global to use for creating the DragDropManager.
   * If a window has been injected explicitly via props, that is used first. If it is available
   * as a context value, then use that, otherwise use the browser global.
   */
		var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));

		var getWindow = function getWindow() {
			if (props && props.window) {
				return props.window;
			} else if (context && context.window) {
				return context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		};

		_this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
		_this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
			window: getWindow()
		});
		return _this;
	}

	_createClass(DragDropContextProvider, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
				throw new Error('DragDropContextProvider backend and window props must not change.');
			}
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			return this.childContext;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react.Children.only(this.props.children);
		}
	}]);

	return DragDropContextProvider;
}(_react.Component), _class.propTypes = {
	backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
	children: _propTypes2.default.element.isRequired,
	window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
}, _class.defaultProps = {
	window: undefined
}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
	window: _propTypes2.default.object
}, _temp);
exports.default = DragDropContextProvider;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = DragLayer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(25);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _isPlainObject = __webpack_require__(11);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _shallowEqual = __webpack_require__(50);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(99);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

var _checkDecoratorArguments = __webpack_require__(35);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DragLayer(collect) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);

	return function decorateLayer(DecoratedComponent) {
		var _class, _temp;

		var _options$arePropsEqua = options.arePropsEqual,
		    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragLayerContainer = (_temp = _class = function (_Component) {
			_inherits(DragLayerContainer, _Component);

			_createClass(DragLayerContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate(nextProps, nextState) {
					return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
				}
			}]);

			function DragLayerContainer(props, context) {
				_classCallCheck(this, DragLayerContainer);

				var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));

				_this.handleChange = _this.handleChange.bind(_this);

				_this.manager = context.dragDropManager;
				(0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

				_this.state = _this.getCurrentState();
				return _this;
			}

			_createClass(DragLayerContainer, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.isCurrentlyMounted = true;

					var monitor = this.manager.getMonitor();
					this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
					this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);

					this.handleChange();
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this.isCurrentlyMounted = false;

					this.unsubscribeFromOffsetChange();
					this.unsubscribeFromStateChange();
				}
			}, {
				key: 'handleChange',
				value: function handleChange() {
					if (!this.isCurrentlyMounted) {
						return;
					}

					var nextState = this.getCurrentState();
					if (!(0, _shallowEqual2.default)(nextState, this.state)) {
						this.setState(nextState);
					}
				}
			}, {
				key: 'getCurrentState',
				value: function getCurrentState() {
					var monitor = this.manager.getMonitor();
					return collect(monitor, this.props);
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragLayerContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
			dragDropManager: _propTypes2.default.object.isRequired
		}, _temp);


		return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
	};
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DragSource;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(11);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(35);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(100);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerSource = __webpack_require__(254);

var _registerSource2 = _interopRequireDefault(_registerSource);

var _createSourceFactory = __webpack_require__(255);

var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);

var _createSourceMonitor = __webpack_require__(256);

var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);

var _createSourceConnector = __webpack_require__(257);

var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);

var _isValidType = __webpack_require__(103);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DragSource(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
	var createSource = (0, _createSourceFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);

	return function decorateSource(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, sourceId) {
				return backend.connectDragSource(sourceId);
			},
			containerDisplayName: 'DragSource',
			createHandler: createSource,
			registerHandler: _registerSource2.default,
			createMonitor: _createSourceMonitor2.default,
			createConnector: _createSourceConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isDisposable2 = __webpack_require__(51);

var _isDisposable3 = _interopRequireDefault(_isDisposable2);

exports.isDisposable = _isDisposable3['default'];

var _Disposable2 = __webpack_require__(251);

var _Disposable3 = _interopRequireDefault(_Disposable2);

exports.Disposable = _Disposable3['default'];

var _CompositeDisposable2 = __webpack_require__(252);

var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);

exports.CompositeDisposable = _CompositeDisposable3['default'];

var _SerialDisposable2 = __webpack_require__(253);

var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);

exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};

/**
 * The basic disposable.
 */

var Disposable = (function () {
  _createClass(Disposable, null, [{
    key: "empty",
    value: { dispose: noop },
    enumerable: true
  }]);

  function Disposable(action) {
    _classCallCheck(this, Disposable);

    this.isDisposed = false;
    this.action = action || noop;
  }

  Disposable.prototype.dispose = function dispose() {
    if (!this.isDisposed) {
      this.action.call(null);
      this.isDisposed = true;
    }
  };

  return Disposable;
})();

exports["default"] = Disposable;
module.exports = exports["default"];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(51);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

/**
 * Represents a group of disposable resources that are disposed together.
 */

var CompositeDisposable = (function () {
  function CompositeDisposable() {
    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
      disposables[_key] = arguments[_key];
    }

    _classCallCheck(this, CompositeDisposable);

    if (Array.isArray(disposables[0]) && disposables.length === 1) {
      disposables = disposables[0];
    }

    for (var i = 0; i < disposables.length; i++) {
      if (!_isDisposable2['default'](disposables[i])) {
        throw new Error('Expected a disposable');
      }
    }

    this.disposables = disposables;
    this.isDisposed = false;
  }

  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Disposable} item Disposable to add.
   */

  CompositeDisposable.prototype.add = function add(item) {
    if (this.isDisposed) {
      item.dispose();
    } else {
      this.disposables.push(item);
    }
  };

  /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Disposable} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */

  CompositeDisposable.prototype.remove = function remove(item) {
    if (this.isDisposed) {
      return false;
    }

    var index = this.disposables.indexOf(item);
    if (index === -1) {
      return false;
    }

    this.disposables.splice(index, 1);
    item.dispose();
    return true;
  };

  /**
   * Disposes all disposables in the group and removes them from the group.
   */

  CompositeDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    var len = this.disposables.length;
    var currentDisposables = new Array(len);
    for (var i = 0; i < len; i++) {
      currentDisposables[i] = this.disposables[i];
    }

    this.isDisposed = true;
    this.disposables = [];
    this.length = 0;

    for (var i = 0; i < len; i++) {
      currentDisposables[i].dispose();
    }
  };

  return CompositeDisposable;
})();

exports['default'] = CompositeDisposable;
module.exports = exports['default'];

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(51);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

var SerialDisposable = (function () {
  function SerialDisposable() {
    _classCallCheck(this, SerialDisposable);

    this.isDisposed = false;
    this.current = null;
  }

  /**
   * Gets the underlying disposable.
   * @return The underlying disposable.
   */

  SerialDisposable.prototype.getDisposable = function getDisposable() {
    return this.current;
  };

  /**
   * Sets the underlying disposable.
   * @param {Disposable} value The new underlying disposable.
   */

  SerialDisposable.prototype.setDisposable = function setDisposable() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    if (value != null && !_isDisposable2['default'](value)) {
      throw new Error('Expected either an empty value or a valid disposable');
    }

    var isDisposed = this.isDisposed;
    var previous = undefined;

    if (!isDisposed) {
      previous = this.current;
      this.current = value;
    }

    if (previous) {
      previous.dispose();
    }

    if (isDisposed && value) {
      value.dispose();
    }
  };

  /**
   * Disposes the underlying disposable as well as all future replacements.
   */

  SerialDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    this.isDisposed = true;
    var previous = this.current;
    this.current = null;

    if (previous) {
      previous.dispose();
    }
  };

  return SerialDisposable;
})();

exports['default'] = SerialDisposable;
module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerSource;
function registerSource(type, source, manager) {
	var registry = manager.getRegistry();
	var sourceId = registry.addSource(type, source);

	function unregisterSource() {
		registry.removeSource(sourceId);
	}

	return {
		handlerId: sourceId,
		unregister: unregisterSource
	};
}

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceFactory;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(11);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

function createSourceFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});
	REQUIRED_SPEC_METHODS.forEach(function (key) {
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});

	var Source = function () {
		function Source(monitor) {
			_classCallCheck(this, Source);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Source, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				if (!spec.canDrag) {
					return true;
				}

				return spec.canDrag(this.props, this.monitor);
			}
		}, {
			key: 'isDragging',
			value: function isDragging(globalMonitor, sourceId) {
				if (!spec.isDragging) {
					return sourceId === globalMonitor.getSourceId();
				}

				return spec.isDragging(this.props, this.monitor);
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				var item = spec.beginDrag(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
				}
				return item;
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {
				if (!spec.endDrag) {
					return;
				}

				spec.endDrag(this.props, this.monitor, this.component);
			}
		}]);

		return Source;
	}();

	return function createSource(monitor) {
		return new Source(monitor);
	};
}

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceMonitor;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrag = false;
var isCallingIsDragging = false;

var SourceMonitor = function () {
	function SourceMonitor(manager) {
		_classCallCheck(this, SourceMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(SourceMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(sourceId) {
			this.sourceId = sourceId;
		}
	}, {
		key: 'canDrag',
		value: function canDrag() {
			(0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingCanDrag = true;
				return this.internalMonitor.canDragSource(this.sourceId);
			} finally {
				isCallingCanDrag = false;
			}
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			(0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingIsDragging = true;
				return this.internalMonitor.isDraggingSource(this.sourceId);
			} finally {
				isCallingIsDragging = false;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return SourceMonitor;
}();

function createSourceMonitor(manager) {
	return new SourceMonitor(manager);
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createSourceConnector;

var _wrapConnectorHooks = __webpack_require__(101);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(102);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createSourceConnector(backend) {
	var currentHandlerId = void 0;

	var currentDragSourceNode = void 0;
	var currentDragSourceOptions = void 0;
	var disconnectCurrentDragSource = void 0;

	var currentDragPreviewNode = void 0;
	var currentDragPreviewOptions = void 0;
	var disconnectCurrentDragPreview = void 0;

	function reconnectDragSource() {
		if (disconnectCurrentDragSource) {
			disconnectCurrentDragSource();
			disconnectCurrentDragSource = null;
		}

		if (currentHandlerId && currentDragSourceNode) {
			disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
		}
	}

	function reconnectDragPreview() {
		if (disconnectCurrentDragPreview) {
			disconnectCurrentDragPreview();
			disconnectCurrentDragPreview = null;
		}

		if (currentHandlerId && currentDragPreviewNode) {
			disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDragSource();
		reconnectDragPreview();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dragSource: function connectDragSource(node, options) {
			if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
				return;
			}

			currentDragSourceNode = node;
			currentDragSourceOptions = options;

			reconnectDragSource();
		},

		dragPreview: function connectDragPreview(node, options) {
			if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
				return;
			}

			currentDragPreviewNode = node;
			currentDragPreviewOptions = options;

			reconnectDragPreview();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = cloneWithRef;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneWithRef(element, newRef) {
	var previousRef = element.ref;
	(0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

	if (!previousRef) {
		// When there is no ref on the element, use the new ref directly
		return (0, _react.cloneElement)(element, {
			ref: newRef
		});
	}

	return (0, _react.cloneElement)(element, {
		ref: function ref(node) {
			newRef(node);

			if (previousRef) {
				previousRef(node);
			}
		}
	});
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DropTarget;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(11);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(35);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(100);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerTarget = __webpack_require__(260);

var _registerTarget2 = _interopRequireDefault(_registerTarget);

var _createTargetFactory = __webpack_require__(261);

var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);

var _createTargetMonitor = __webpack_require__(262);

var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);

var _createTargetConnector = __webpack_require__(263);

var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);

var _isValidType = __webpack_require__(103);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropTarget(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
	var createTarget = (0, _createTargetFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);

	return function decorateTarget(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, targetId) {
				return backend.connectDropTarget(targetId);
			},
			containerDisplayName: 'DropTarget',
			createHandler: createTarget,
			registerHandler: _registerTarget2.default,
			createMonitor: _createTargetMonitor2.default,
			createConnector: _createTargetConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerTarget;
function registerTarget(type, target, manager) {
	var registry = manager.getRegistry();
	var targetId = registry.addTarget(type, target);

	function unregisterTarget() {
		registry.removeTarget(targetId);
	}

	return {
		handlerId: targetId,
		unregister: unregisterTarget
	};
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetFactory;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(11);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

function createTargetFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	});

	var Target = function () {
		function Target(monitor) {
			_classCallCheck(this, Target);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Target, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveMonitor',
			value: function receiveMonitor(monitor) {
				this.monitor = monitor;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrop',
			value: function canDrop() {
				if (!spec.canDrop) {
					return true;
				}

				return spec.canDrop(this.props, this.monitor);
			}
		}, {
			key: 'hover',
			value: function hover() {
				if (!spec.hover) {
					return;
				}

				spec.hover(this.props, this.monitor, this.component);
			}
		}, {
			key: 'drop',
			value: function drop() {
				if (!spec.drop) {
					return undefined;
				}

				var dropResult = spec.drop(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
				}
				return dropResult;
			}
		}]);

		return Target;
	}();

	return function createTarget(monitor) {
		return new Target(monitor);
	};
}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetMonitor;

var _invariant = __webpack_require__(3);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrop = false;

var TargetMonitor = function () {
	function TargetMonitor(manager) {
		_classCallCheck(this, TargetMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(TargetMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(targetId) {
			this.targetId = targetId;
		}
	}, {
		key: 'canDrop',
		value: function canDrop() {
			(0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');

			try {
				isCallingCanDrop = true;
				return this.internalMonitor.canDropOnTarget(this.targetId);
			} finally {
				isCallingCanDrop = false;
			}
		}
	}, {
		key: 'isOver',
		value: function isOver(options) {
			return this.internalMonitor.isOverTarget(this.targetId, options);
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return TargetMonitor;
}();

function createTargetMonitor(manager) {
	return new TargetMonitor(manager);
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createTargetConnector;

var _wrapConnectorHooks = __webpack_require__(101);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(102);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTargetConnector(backend) {
	var currentHandlerId = void 0;

	var currentDropTargetNode = void 0;
	var currentDropTargetOptions = void 0;
	var disconnectCurrentDropTarget = void 0;

	function reconnectDropTarget() {
		if (disconnectCurrentDropTarget) {
			disconnectCurrentDropTarget();
			disconnectCurrentDropTarget = null;
		}

		if (currentHandlerId && currentDropTargetNode) {
			disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDropTarget();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dropTarget: function connectDropTarget(node, options) {
			if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
				return;
			}

			currentDropTargetNode = node;
			currentDropTargetOptions = options;

			reconnectDropTarget();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getEmptyImage = exports.NativeTypes = undefined;
exports.default = createHTML5Backend;

var _HTML5Backend = __webpack_require__(265);

var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);

var _getEmptyImage = __webpack_require__(291);

var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);

var _NativeTypes = __webpack_require__(53);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NativeTypes = NativeTypes;
exports.getEmptyImage = _getEmptyImage2.default;
function createHTML5Backend(manager) {
	return new _HTML5Backend2.default(manager);
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */


var _defaults = __webpack_require__(266);

var _defaults2 = _interopRequireDefault(_defaults);

var _shallowEqual = __webpack_require__(284);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _EnterLeaveCounter = __webpack_require__(285);

var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);

var _BrowserDetector = __webpack_require__(106);

var _OffsetUtils = __webpack_require__(288);

var _NativeDragSources = __webpack_require__(290);

var _NativeTypes = __webpack_require__(53);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTML5Backend = function () {
	function HTML5Backend(manager) {
		_classCallCheck(this, HTML5Backend);

		this.actions = manager.getActions();
		this.monitor = manager.getMonitor();
		this.registry = manager.getRegistry();
		this.context = manager.getContext();

		this.sourcePreviewNodes = {};
		this.sourcePreviewNodeOptions = {};
		this.sourceNodes = {};
		this.sourceNodeOptions = {};
		this.enterLeaveCounter = new _EnterLeaveCounter2.default();

		this.dragStartSourceIds = [];
		this.dropTargetIds = [];
		this.dragEnterTargetIds = [];
		this.currentNativeSource = null;
		this.currentNativeHandle = null;
		this.currentDragSourceNode = null;
		this.currentDragSourceNodeOffset = null;
		this.currentDragSourceNodeOffsetChanged = false;
		this.altKeyPressed = false;
		this.mouseMoveTimeoutTimer = null;

		this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
		this.handleTopDragStart = this.handleTopDragStart.bind(this);
		this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
		this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
		this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
		this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
		this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
		this.handleTopDragOver = this.handleTopDragOver.bind(this);
		this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
		this.handleTopDrop = this.handleTopDrop.bind(this);
		this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
		this.handleSelectStart = this.handleSelectStart.bind(this);
		this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
		this.endDragNativeItem = this.endDragNativeItem.bind(this);
		this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
		this.isNodeInDocument = this.isNodeInDocument.bind(this);
	}

	_createClass(HTML5Backend, [{
		key: 'setup',
		value: function setup() {
			if (this.window === undefined) {
				return;
			}

			if (this.window.__isReactDndBackendSetUp) {
				throw new Error('Cannot have two HTML5 backends at the same time.');
			}
			this.window.__isReactDndBackendSetUp = true;
			this.addEventListeners(this.window);
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			if (this.window === undefined) {
				return;
			}

			this.window.__isReactDndBackendSetUp = false;
			this.removeEventListeners(this.window);
			this.clearCurrentDragSourceNode();
			if (this.asyncEndDragFrameId) {
				this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
			}
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.addEventListener) {
				return;
			}
			target.addEventListener('dragstart', this.handleTopDragStart);
			target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.addEventListener('dragend', this.handleTopDragEndCapture, true);
			target.addEventListener('dragenter', this.handleTopDragEnter);
			target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.addEventListener('dragover', this.handleTopDragOver);
			target.addEventListener('dragover', this.handleTopDragOverCapture, true);
			target.addEventListener('drop', this.handleTopDrop);
			target.addEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'removeEventListeners',
		value: function removeEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.removeEventListener) {
				return;
			}
			target.removeEventListener('dragstart', this.handleTopDragStart);
			target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
			target.removeEventListener('dragenter', this.handleTopDragEnter);
			target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.removeEventListener('dragover', this.handleTopDragOver);
			target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
			target.removeEventListener('drop', this.handleTopDrop);
			target.removeEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview(sourceId, node, options) {
			var _this = this;

			this.sourcePreviewNodeOptions[sourceId] = options;
			this.sourcePreviewNodes[sourceId] = node;

			return function () {
				delete _this.sourcePreviewNodes[sourceId];
				delete _this.sourcePreviewNodeOptions[sourceId];
			};
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource(sourceId, node, options) {
			var _this2 = this;

			this.sourceNodes[sourceId] = node;
			this.sourceNodeOptions[sourceId] = options;

			var handleDragStart = function handleDragStart(e) {
				return _this2.handleDragStart(e, sourceId);
			};
			var handleSelectStart = function handleSelectStart(e) {
				return _this2.handleSelectStart(e, sourceId);
			};

			node.setAttribute('draggable', true);
			node.addEventListener('dragstart', handleDragStart);
			node.addEventListener('selectstart', handleSelectStart);

			return function () {
				delete _this2.sourceNodes[sourceId];
				delete _this2.sourceNodeOptions[sourceId];

				node.removeEventListener('dragstart', handleDragStart);
				node.removeEventListener('selectstart', handleSelectStart);
				node.setAttribute('draggable', false);
			};
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget(targetId, node) {
			var _this3 = this;

			var handleDragEnter = function handleDragEnter(e) {
				return _this3.handleDragEnter(e, targetId);
			};
			var handleDragOver = function handleDragOver(e) {
				return _this3.handleDragOver(e, targetId);
			};
			var handleDrop = function handleDrop(e) {
				return _this3.handleDrop(e, targetId);
			};

			node.addEventListener('dragenter', handleDragEnter);
			node.addEventListener('dragover', handleDragOver);
			node.addEventListener('drop', handleDrop);

			return function () {
				node.removeEventListener('dragenter', handleDragEnter);
				node.removeEventListener('dragover', handleDragOver);
				node.removeEventListener('drop', handleDrop);
			};
		}
	}, {
		key: 'getCurrentSourceNodeOptions',
		value: function getCurrentSourceNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourceNodeOptions = this.sourceNodeOptions[sourceId];

			return (0, _defaults2.default)(sourceNodeOptions || {}, {
				dropEffect: this.altKeyPressed ? 'copy' : 'move'
			});
		}
	}, {
		key: 'getCurrentDropEffect',
		value: function getCurrentDropEffect() {
			if (this.isDraggingNativeItem()) {
				// It makes more sense to default to 'copy' for native resources
				return 'copy';
			}

			return this.getCurrentSourceNodeOptions().dropEffect;
		}
	}, {
		key: 'getCurrentSourcePreviewNodeOptions',
		value: function getCurrentSourcePreviewNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];

			return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
				anchorX: 0.5,
				anchorY: 0.5,
				captureDraggingState: false
			});
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset(sourceId) {
			return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
		}
	}, {
		key: 'isDraggingNativeItem',
		value: function isDraggingNativeItem() {
			var itemType = this.monitor.getItemType();
			return Object.keys(NativeTypes).some(function (key) {
				return NativeTypes[key] === itemType;
			});
		}
	}, {
		key: 'beginDragNativeItem',
		value: function beginDragNativeItem(type) {
			this.clearCurrentDragSourceNode();

			var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
			this.currentNativeSource = new SourceType();
			this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
			this.actions.beginDrag([this.currentNativeHandle]);
		}
	}, {
		key: 'asyncEndDragNativeItem',
		value: function asyncEndDragNativeItem() {
			this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
		}
	}, {
		key: 'endDragNativeItem',
		value: function endDragNativeItem() {
			if (!this.isDraggingNativeItem()) {
				return;
			}

			this.actions.endDrag();
			this.registry.removeSource(this.currentNativeHandle);
			this.currentNativeHandle = null;
			this.currentNativeSource = null;
		}
	}, {
		key: 'isNodeInDocument',
		value: function isNodeInDocument(node) {
			// Check the node either in the main document or in the current context
			return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
		}
	}, {
		key: 'endDragIfSourceWasRemovedFromDOM',
		value: function endDragIfSourceWasRemovedFromDOM() {
			var node = this.currentDragSourceNode;
			if (this.isNodeInDocument(node)) {
				return;
			}

			if (this.clearCurrentDragSourceNode()) {
				this.actions.endDrag();
			}
		}
	}, {
		key: 'setCurrentDragSourceNode',
		value: function setCurrentDragSourceNode(node) {
			var _this4 = this;

			this.clearCurrentDragSourceNode();
			this.currentDragSourceNode = node;
			this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
			this.currentDragSourceNodeOffsetChanged = false;

			// A timeout of > 0 is necessary to resolve Firefox issue referenced
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			var MOUSE_MOVE_TIMEOUT = 1000;

			// Receiving a mouse event in the middle of a dragging operation
			// means it has ended and the drag source node disappeared from DOM,
			// so the browser didn't dispatch the dragend event.
			//
			// We need to wait before we start listening for mousemove events.
			// This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
			// immediately in some browsers.
			//
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			//
			this.mouseMoveTimeoutTimer = setTimeout(function () {
				_this4.mouseMoveTimeoutId = null;
				return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
			}, MOUSE_MOVE_TIMEOUT);
		}
	}, {
		key: 'clearCurrentDragSourceNode',
		value: function clearCurrentDragSourceNode() {
			if (this.currentDragSourceNode) {
				this.currentDragSourceNode = null;
				this.currentDragSourceNodeOffset = null;
				this.currentDragSourceNodeOffsetChanged = false;
				this.window.clearTimeout(this.mouseMoveTimeoutTimer);
				this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
				this.mouseMoveTimeoutTimer = null;
				return true;
			}

			return false;
		}
	}, {
		key: 'checkIfCurrentDragSourceRectChanged',
		value: function checkIfCurrentDragSourceRectChanged() {
			var node = this.currentDragSourceNode;
			if (!node) {
				return false;
			}

			if (this.currentDragSourceNodeOffsetChanged) {
				return true;
			}

			this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);

			return this.currentDragSourceNodeOffsetChanged;
		}
	}, {
		key: 'handleTopDragStartCapture',
		value: function handleTopDragStartCapture() {
			this.clearCurrentDragSourceNode();
			this.dragStartSourceIds = [];
		}
	}, {
		key: 'handleDragStart',
		value: function handleDragStart(e, sourceId) {
			this.dragStartSourceIds.unshift(sourceId);
		}
	}, {
		key: 'handleTopDragStart',
		value: function handleTopDragStart(e) {
			var _this5 = this;

			var dragStartSourceIds = this.dragStartSourceIds;

			this.dragStartSourceIds = null;

			var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);

			// Avoid crashing if we missed a drop event or our previous drag died
			if (this.monitor.isDragging()) {
				this.actions.endDrag();
			}

			// Don't publish the source just yet (see why below)
			this.actions.beginDrag(dragStartSourceIds, {
				publishSource: false,
				getSourceClientOffset: this.getSourceClientOffset,
				clientOffset: clientOffset
			});

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (this.monitor.isDragging()) {
				if (typeof dataTransfer.setDragImage === 'function') {
					// Use custom drag image if user specifies it.
					// If child drag source refuses drag but parent agrees,
					// use parent's node as drag image. Neither works in IE though.
					var sourceId = this.monitor.getSourceId();
					var sourceNode = this.sourceNodes[sourceId];
					var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;

					var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
					    anchorX = _getCurrentSourcePrev.anchorX,
					    anchorY = _getCurrentSourcePrev.anchorY,
					    offsetX = _getCurrentSourcePrev.offsetX,
					    offsetY = _getCurrentSourcePrev.offsetY;

					var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
					var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
					var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);

					dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
				}

				try {
					// Firefox won't drag without setting data
					dataTransfer.setData('application/json', {});
				} catch (err) {}
				// IE doesn't support MIME types in setData


				// Store drag source node so we can check whether
				// it is removed from DOM and trigger endDrag manually.
				this.setCurrentDragSourceNode(e.target);

				// Now we are ready to publish the drag source.. or are we not?

				var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
				    captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;

				if (!captureDraggingState) {
					// Usually we want to publish it in the next tick so that browser
					// is able to screenshot the current (not yet dragging) state.
					//
					// It also neatly avoids a situation where render() returns null
					// in the same tick for the source element, and browser freaks out.
					setTimeout(function () {
						return _this5.actions.publishDragSource();
					});
				} else {
					// In some cases the user may want to override this behavior, e.g.
					// to work around IE not supporting custom drag previews.
					//
					// When using a custom drag layer, the only way to prevent
					// the default drag preview from drawing in IE is to screenshot
					// the dragging state in which the node itself has zero opacity
					// and height. In this case, though, returning null from render()
					// will abruptly end the dragging, which is not obvious.
					//
					// This is the reason such behavior is strictly opt-in.
					this.actions.publishDragSource();
				}
			} else if (nativeType) {
				// A native item (such as URL) dragged from inside the document
				this.beginDragNativeItem(nativeType);
			} else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
				// Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
				// Just let it drag. It's a native type (URL or text) and will be picked up in
				// dragenter handler.
				return; // eslint-disable-line no-useless-return
			} else {
				// If by this time no drag source reacted, tell browser not to drag.
				e.preventDefault();
			}
		}
	}, {
		key: 'handleTopDragEndCapture',
		value: function handleTopDragEndCapture() {
			if (this.clearCurrentDragSourceNode()) {
				// Firefox can dispatch this event in an infinite loop
				// if dragend handler does something like showing an alert.
				// Only proceed if we have not handled it already.
				this.actions.endDrag();
			}
		}
	}, {
		key: 'handleTopDragEnterCapture',
		value: function handleTopDragEnterCapture(e) {
			this.dragEnterTargetIds = [];

			var isFirstEnter = this.enterLeaveCounter.enter(e.target);
			if (!isFirstEnter || this.monitor.isDragging()) {
				return;
			}

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (nativeType) {
				// A native item (such as file or URL) dragged from outside the document
				this.beginDragNativeItem(nativeType);
			}
		}
	}, {
		key: 'handleDragEnter',
		value: function handleDragEnter(e, targetId) {
			this.dragEnterTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragEnter',
		value: function handleTopDragEnter(e) {
			var _this6 = this;

			var dragEnterTargetIds = this.dragEnterTargetIds;

			this.dragEnterTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				return;
			}

			this.altKeyPressed = e.altKey;

			if (!(0, _BrowserDetector.isFirefox)()) {
				// Don't emit hover in `dragenter` on Firefox due to an edge case.
				// If the target changes position as the result of `dragenter`, Firefox
				// will still happily dispatch `dragover` despite target being no longer
				// there. The easy solution is to only fire `hover` in `dragover` on FF.
				this.actions.hover(dragEnterTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
			}

			var canDrop = dragEnterTargetIds.some(function (targetId) {
				return _this6.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// IE requires this to fire dragover events
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			}
		}
	}, {
		key: 'handleTopDragOverCapture',
		value: function handleTopDragOverCapture() {
			this.dragOverTargetIds = [];
		}
	}, {
		key: 'handleDragOver',
		value: function handleDragOver(e, targetId) {
			this.dragOverTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragOver',
		value: function handleTopDragOver(e) {
			var _this7 = this;

			var dragOverTargetIds = this.dragOverTargetIds;

			this.dragOverTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				// Prevent default "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
				return;
			}

			this.altKeyPressed = e.altKey;

			this.actions.hover(dragOverTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});

			var canDrop = dragOverTargetIds.some(function (targetId) {
				return _this7.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// Show user-specified drop effect.
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			} else if (this.isDraggingNativeItem()) {
				// Don't show a nice cursor but still prevent default
				// "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
			} else if (this.checkIfCurrentDragSourceRectChanged()) {
				// Prevent animating to incorrect position.
				// Drop effect must be other than 'none' to prevent animation.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'move';
			}
		}
	}, {
		key: 'handleTopDragLeaveCapture',
		value: function handleTopDragLeaveCapture(e) {
			if (this.isDraggingNativeItem()) {
				e.preventDefault();
			}

			var isLastLeave = this.enterLeaveCounter.leave(e.target);
			if (!isLastLeave) {
				return;
			}

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			}
		}
	}, {
		key: 'handleTopDropCapture',
		value: function handleTopDropCapture(e) {
			this.dropTargetIds = [];
			e.preventDefault();

			if (this.isDraggingNativeItem()) {
				this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
			}

			this.enterLeaveCounter.reset();
		}
	}, {
		key: 'handleDrop',
		value: function handleDrop(e, targetId) {
			this.dropTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDrop',
		value: function handleTopDrop(e) {
			var dropTargetIds = this.dropTargetIds;

			this.dropTargetIds = [];

			this.actions.hover(dropTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});
			this.actions.drop({ dropEffect: this.getCurrentDropEffect() });

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			} else {
				this.endDragIfSourceWasRemovedFromDOM();
			}
		}
	}, {
		key: 'handleSelectStart',
		value: function handleSelectStart(e) {
			var target = e.target;

			// Only IE requires us to explicitly say
			// we want drag drop operation to start

			if (typeof target.dragDrop !== 'function') {
				return;
			}

			// Inputs and textareas should be selectable
			if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
				return;
			}

			// For other targets, ask IE
			// to enable drag and drop
			e.preventDefault();
			target.dragDrop();
		}
	}, {
		key: 'window',
		get: function get() {
			if (this.context && this.context.window) {
				return this.context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		}
	}]);

	return HTML5Backend;
}();

exports.default = HTML5Backend;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(90),
    assignInWith = __webpack_require__(267),
    baseRest = __webpack_require__(15),
    customDefaultsAssignIn = __webpack_require__(283);

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(args) {
  args.push(undefined, customDefaultsAssignIn);
  return apply(assignInWith, undefined, args);
});

module.exports = defaults;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(268),
    createAssigner = __webpack_require__(270),
    keysIn = __webpack_require__(272);

/**
 * This method is like `_.assignIn` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extendWith
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignInWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keysIn(source), object, customizer);
});

module.exports = assignInWith;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(269),
    baseAssignValue = __webpack_require__(104);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(104),
    eq = __webpack_require__(31);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(15),
    isIterateeCall = __webpack_require__(271);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(31),
    isArrayLike = __webpack_require__(49),
    isIndex = __webpack_require__(105),
    isObject = __webpack_require__(21);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(273),
    baseKeysIn = __webpack_require__(280),
    isArrayLike = __webpack_require__(49);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(274),
    isArguments = __webpack_require__(95),
    isArray = __webpack_require__(12),
    isBuffer = __webpack_require__(275),
    isIndex = __webpack_require__(105),
    isTypedArray = __webpack_require__(277);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19),
    stubFalse = __webpack_require__(276);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)(module)))

/***/ }),
/* 276 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(278),
    baseUnary = __webpack_require__(47),
    nodeUtil = __webpack_require__(279);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(26),
    isLength = __webpack_require__(92),
    isObjectLike = __webpack_require__(20);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(82);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)(module)))

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21),
    isPrototype = __webpack_require__(281),
    nativeKeysIn = __webpack_require__(282);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 281 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 282 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(31);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
 * of source objects to the destination object for all destination properties
 * that resolve to `undefined`.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to assign.
 * @param {Object} object The parent object of `objValue`.
 * @returns {*} Returns the value to assign.
 */
function customDefaultsAssignIn(objValue, srcValue, key, object) {
  if (objValue === undefined ||
      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
    return srcValue;
  }
  return objValue;
}

module.exports = customDefaultsAssignIn;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _union = __webpack_require__(286);

var _union2 = _interopRequireDefault(_union);

var _without = __webpack_require__(85);

var _without2 = _interopRequireDefault(_without);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterLeaveCounter = function () {
	function EnterLeaveCounter() {
		_classCallCheck(this, EnterLeaveCounter);

		this.entered = [];
	}

	_createClass(EnterLeaveCounter, [{
		key: 'enter',
		value: function enter(enteringNode) {
			var previousLength = this.entered.length;

			var isNodeEntered = function isNodeEntered(node) {
				return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
			};

			this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);

			return previousLength === 0 && this.entered.length > 0;
		}
	}, {
		key: 'leave',
		value: function leave(leavingNode) {
			var previousLength = this.entered.length;

			this.entered = (0, _without2.default)(this.entered.filter(function (node) {
				return document.documentElement.contains(node);
			}), leavingNode);

			return previousLength > 0 && this.entered.length === 0;
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.entered = [];
		}
	}]);

	return EnterLeaveCounter;
}();

exports.default = EnterLeaveCounter;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(94),
    baseRest = __webpack_require__(15),
    baseUniq = __webpack_require__(96),
    isArrayLikeObject = __webpack_require__(33);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(87);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getNodeClientOffset = getNodeClientOffset;
exports.getEventClientOffset = getEventClientOffset;
exports.getDragPreviewOffset = getDragPreviewOffset;

var _BrowserDetector = __webpack_require__(106);

var _MonotonicInterpolant = __webpack_require__(289);

var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint
   no-mixed-operators: off
*/
var ELEMENT_NODE = 1;

function getNodeClientOffset(node) {
	var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

	if (!el) {
		return null;
	}

	var _el$getBoundingClient = el.getBoundingClientRect(),
	    top = _el$getBoundingClient.top,
	    left = _el$getBoundingClient.left;

	return { x: left, y: top };
}

function getEventClientOffset(e) {
	return {
		x: e.clientX,
		y: e.clientY
	};
}

function isImageNode(node) {
	return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
	var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;

	// Work around @2x coordinate discrepancies in browsers
	if ((0, _BrowserDetector.isSafari)() && isImage) {
		dragPreviewHeight /= window.devicePixelRatio;
		dragPreviewWidth /= window.devicePixelRatio;
	}
	return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
	// The browsers will use the image intrinsic size under different conditions.
	// Firefox only cares if it's an image, but WebKit also wants it to be detached.
	var isImage = isImageNode(dragPreview);
	var dragPreviewNode = isImage ? sourceNode : dragPreview;
	var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	var offsetFromDragPreview = {
		x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
		y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	};
	var sourceWidth = sourceNode.offsetWidth,
	    sourceHeight = sourceNode.offsetHeight;
	var anchorX = anchorPoint.anchorX,
	    anchorY = anchorPoint.anchorY;

	var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
	    dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
	    dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

	var calculateYOffset = function calculateYOffset() {
		var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the top
		offsetFromDragPreview.y,
		// Align at the center
		offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
		// Dock to the bottom
		offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
		var y = interpolantY.interpolate(anchorY);
		// Work around Safari 8 positioning bug
		if ((0, _BrowserDetector.isSafari)() && isImage) {
			// We'll have to wait for @3x to see if this is entirely correct
			y += (window.devicePixelRatio - 1) * dragPreviewHeight;
		}
		return y;
	};

	var calculateXOffset = function calculateXOffset() {
		// Interpolate coordinates depending on anchor point
		// If you know a simpler way to do this, let me know
		var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the left
		offsetFromDragPreview.x,
		// Align at the center
		offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
		// Dock to the right
		offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
		return interpolantX.interpolate(anchorX);
	};

	// Force offsets if specified in the options.
	var offsetX = offsetPoint.offsetX,
	    offsetY = offsetPoint.offsetY;

	var isManualOffsetX = offsetX === 0 || offsetX;
	var isManualOffsetY = offsetY === 0 || offsetY;
	return {
		x: isManualOffsetX ? offsetX : calculateXOffset(),
		y: isManualOffsetY ? offsetY : calculateYOffset()
	};
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint
   no-plusplus: off,
   no-mixed-operators: off
*/
var MonotonicInterpolant = function () {
	function MonotonicInterpolant(xs, ys) {
		_classCallCheck(this, MonotonicInterpolant);

		var length = xs.length;

		// Rearrange xs and ys so that xs is sorted
		var indexes = [];
		for (var i = 0; i < length; i++) {
			indexes.push(i);
		}
		indexes.sort(function (a, b) {
			return xs[a] < xs[b] ? -1 : 1;
		});

		// Get consecutive differences and slopes
		var dys = [];
		var dxs = [];
		var ms = [];
		var dx = void 0;
		var dy = void 0;
		for (var _i = 0; _i < length - 1; _i++) {
			dx = xs[_i + 1] - xs[_i];
			dy = ys[_i + 1] - ys[_i];
			dxs.push(dx);
			dys.push(dy);
			ms.push(dy / dx);
		}

		// Get degree-1 coefficients
		var c1s = [ms[0]];
		for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
			var _m = ms[_i2];
			var mNext = ms[_i2 + 1];
			if (_m * mNext <= 0) {
				c1s.push(0);
			} else {
				dx = dxs[_i2];
				var dxNext = dxs[_i2 + 1];
				var common = dx + dxNext;
				c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
			}
		}
		c1s.push(ms[ms.length - 1]);

		// Get degree-2 and degree-3 coefficients
		var c2s = [];
		var c3s = [];
		var m = void 0;
		for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
			m = ms[_i3];
			var c1 = c1s[_i3];
			var invDx = 1 / dxs[_i3];
			var _common = c1 + c1s[_i3 + 1] - m - m;
			c2s.push((m - c1 - _common) * invDx);
			c3s.push(_common * invDx * invDx);
		}

		this.xs = xs;
		this.ys = ys;
		this.c1s = c1s;
		this.c2s = c2s;
		this.c3s = c3s;
	}

	_createClass(MonotonicInterpolant, [{
		key: "interpolate",
		value: function interpolate(x) {
			var xs = this.xs,
			    ys = this.ys,
			    c1s = this.c1s,
			    c2s = this.c2s,
			    c3s = this.c3s;

			// The rightmost point in the dataset should give an exact result

			var i = xs.length - 1;
			if (x === xs[i]) {
				return ys[i];
			}

			// Search for the interval x is in, returning the corresponding y if x is one of the original xs
			var low = 0;
			var high = c3s.length - 1;
			var mid = void 0;
			while (low <= high) {
				mid = Math.floor(0.5 * (low + high));
				var xHere = xs[mid];
				if (xHere < x) {
					low = mid + 1;
				} else if (xHere > x) {
					high = mid - 1;
				} else {
					return ys[mid];
				}
			}
			i = Math.max(0, high);

			// Interpolate
			var diff = x - xs[i];
			var diffSq = diff * diff;
			return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
		}
	}]);

	return MonotonicInterpolant;
}();

exports.default = MonotonicInterpolant;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nativeTypesConfig;

exports.createNativeDragSource = createNativeDragSource;
exports.matchNativeItemType = matchNativeItemType;

var _NativeTypes = __webpack_require__(53);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
		return resultSoFar || dataTransfer.getData(typeToTry);
	}, null);

	return result != null // eslint-disable-line eqeqeq
	? result : defaultValue;
}

var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	exposeProperty: 'files',
	matchesTypes: ['Files'],
	getData: function getData(dataTransfer) {
		return Array.prototype.slice.call(dataTransfer.files);
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	exposeProperty: 'urls',
	matchesTypes: ['Url', 'text/uri-list'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	exposeProperty: 'text',
	matchesTypes: ['Text', 'text/plain'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	}
}), _nativeTypesConfig);

function createNativeDragSource(type) {
	var _nativeTypesConfig$ty = nativeTypesConfig[type],
	    exposeProperty = _nativeTypesConfig$ty.exposeProperty,
	    matchesTypes = _nativeTypesConfig$ty.matchesTypes,
	    getData = _nativeTypesConfig$ty.getData;


	return function () {
		function NativeDragSource() {
			var _item, _mutatorMap;

			_classCallCheck(this, NativeDragSource);

			this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
				// eslint-disable-next-line no-console
				console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
				return null;
			}, _defineEnumerableProperties(_item, _mutatorMap), _item);
		}

		_createClass(NativeDragSource, [{
			key: 'mutateItemByReadingDataTransfer',
			value: function mutateItemByReadingDataTransfer(dataTransfer) {
				delete this.item[exposeProperty];
				this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				return true;
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				return this.item;
			}
		}, {
			key: 'isDragging',
			value: function isDragging(monitor, handle) {
				return handle === monitor.getSourceId();
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {}
		}]);

		return NativeDragSource;
	}();
}

function matchNativeItemType(dataTransfer) {
	var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);

	return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
		var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;

		return matchesTypes.some(function (t) {
			return dataTransferTypes.indexOf(t) > -1;
		});
	})[0] || null;
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
	if (!emptyImage) {
		emptyImage = new Image();
		emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	}

	return emptyImage;
}

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextMenu_ContextMenu__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__containers_DataCells__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_DimensionHeaders__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ColumnHeaders__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_RowHeaders__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DragLayer__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_zebulon_controls__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { findDOMNode } from "react-dom";
// import { connectMenu } from "react-contextmenu";
// import ArrowKeyStepper from '../../containers/ArrowKeyStepper';
// import { utils } from "zebulon-controls";
// import { isEmpty } from "../../utils/generic";
// import {  } from "zebulon-controls";
// import * as actions from '../../actions';
// ------------------------------------------
// CONCEPTS
// ------------------------------------------
// The pivot grid is build using a dataset (as an array of data rows) and a meta description(configuration) of the data set
// most of the configuration can be determined from the dataset, nevertheless
// - MEASURE:
// measures are the descriptions for available computed (aggregated) values displayed into the grid
// measures properties are
//    - id
//    - label
//    - aggregation function
//    - data accessor
//    - format
//  measures together can be restituted in rows or columns
// - DIMENSION:
//  dimensions are the descriptions of the axes used to determine the perimeter of the calculation of the measures (group by)
// dimension properties are:
//    - id
//    - label
//    - id accessor
//    - label accessor
//    - sort accessor
//    - format
//    - parent dimension for 'attributes'
//      attributes are additional properties of a dimension with (0,1) cardinality (person -> gender, age, nationality...) ,g
//      it will be possible to expand/collapse those attributes
//  any dimension can be restituted either in row nor in column
//  filters can be defined on the dimension and will be applied to the dataset
// in a 'SQL like' expression you may represent the result of your configuration as something like:
// select
//        measure1.aggregation_function(measure1.data_accessor),
//        measure2.aggregation_function(measure2.data_accessor)
// from   dataset
// where  dimension3.filter_function()
// group by
//        dimension1.id_accessor,dimension1.label_accessor in row,
//        dimension2.id_accessor,dimension2.label_accessor in row,
//        dimension3.id_accessor,dimension3.label_accessor in column
// order by
//        dimension1.sort_accessor,dimension2.sort_accessor
// ------------------------------------------
// PIVOT GRID
// ------------------------------------------
// pivot grid is the main component is the main component
// it is decomposed in 4 different parts
// - the data cells grid where the measures aggregation calculations are displayed
// this is a virtualised grid in rows and columns with standards navigation, selection, copy... functionalities
// - the row headers grid
// this is a virtualised grid in rows, synchronized in rows with the the datacells grid that display,
// as a tree the successive dimensions values (for in row dimensions)
// this is a virtualised grid in columns, synchronized in columns with the the datacells grid that display,
// as a tree the successive dimensions values (for in column dimensions)
// - the dimension headers grid that will display the captions of dimensions in rows and columns
// most of changes of the pivot grid configuration are available there (dimension  moves, sort...)
// const Checkbox = ({ onChange, checked, key, label, index, style }) =>
//   <div style={{ ...style, textAlign: 'left' }}>
//     <label>
//       <input
//         type="checkbox"
//         value={label}
//         onChange={onChange}
//         checked={checked || false}
//       />
//       {label}
//     </label>
//   </div>;
var PivotGrid=function(_Component){_inherits(PivotGrid,_Component);function PivotGrid(props){_classCallCheck(this,PivotGrid);var _this=_possibleConstructorReturn(this,(PivotGrid.__proto__||Object.getPrototypeOf(PivotGrid)).call(this,props));_this.closeOpenedWindows=function(){_this.contextualMenu.close();if(_this.state.toolTip.comment!==undefined){_this.setState({toolTip:{toolTip:{style:{opacity:0,height:0},modal:false}}});}};_this.handleKeyDown=function(e){// a voir
var isFilter=_this.hasParent(document.activeElement,"filter");if(e.key==="Escape"){_this.closeOpenedWindows();}if(isFilter&&e.key==="Tab"){return false;}if(__WEBPACK_IMPORTED_MODULE_8_zebulon_controls__["j" /* utils */].isNavigationKey(e)){if(isFilter){_this.contextualMenu.handleKeyDown(e);}else if(!isFilter&&_this.dataCells&&_this.dataCells.handleNavigationKeys){return _this.dataCells.handleNavigationKeys(e);}}};_this.handleCopy=function(e){_this.closeOpenedWindows();_this.props.copy(_this.props.selectedRange);};_this.handlePaste=function(e){_this.closeOpenedWindows();if(_this.props.editable){var data=_this.props.paste(e.clipboardData.getData("text"),_this.props.selectedRange.end);}};_this.handleExport=function(){if(// Works only if the grid is focused
_this.modifierKeyIsPressed){_this.props.copy(_this.props.selectedRange);}};_this.onScroll=function(scrollToRow,scrollToColumn){var _this$props$headers=_this.props.headers,rows=_this$props$headers.rows,columns=_this$props$headers.columns;if(scrollToRow!==null&&(scrollToRow.index!==rows.index||scrollToRow.direction!==rows.direction)){_this.closeOpenedWindows();_this.props.scrollToRow(scrollToRow);}if(scrollToColumn!==null&&(scrollToColumn.index!==columns.index||scrollToColumn.direction!==columns.direction)){_this.closeOpenedWindows();_this.props.scrollToColumn(scrollToColumn);}};_this.state={toolTip:{style:{opacity:0,height:0,zIndex:0,padding:0},modal:false}};return _this;}_createClass(PivotGrid,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _props=this.props,height=_props.height,width=_props.width,setSizes=_props.setSizes;if(height!==prevProps.height||width!==prevProps.width){setSizes({height:height,width:width});}}},{key:"componentDidMount",value:function componentDidMount(){this.props.getRef(this);}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){this.isPushing=this.props.status!==nextProps.status&&nextProps.status.pushed;if(this.contextualMenu&&this.contextualMenu.state.menu&&this.contextualMenu.state.menu.visible){this.closeOpenedWindows();}if(nextProps.selectedCell&&nextProps.selectedCell!==this.props.selectedCell){this.onScroll({direction:1,index:nextProps.selectedCell.rows},{direction:1,index:nextProps.selectedCell.columns});this.props.selectCell(nextProps.selectedCell);}}// ------------------------------------
// Navigation
// ------------------------------------
},{key:"hasParent",value:function hasParent(element,id){if(!element.parentElement){return false;}else if(element.parentElement.id===id){return true;}else{return this.hasParent(element.parentElement,id);}}//-----------------------------
},{key:"render",value:function render(){var _this2=this;var _props2=this.props,connectDropTarget=_props2.connectDropTarget,height=_props2.height,width=_props2.width,drilldown=_props2.drilldown,zoomValue=_props2.zoomValue,headers=_props2.headers,gridId=_props2.gridId,status=_props2.status;var rows=headers.rows,columns=headers.columns;var grid=void 0;if(this.props.status.loading||this.props.status.loadingConfig){grid=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Loading data...");}else if(this.props.status.error){if(this.props.status.error.message==="No rows retrieved"){grid=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:"max-content"}},"No rows retrieved");}else{grid=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"red",width:"max-content"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.status.error.type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.props.status.error.message));}}else if(rows!==undefined&&columns!==undefined){// this.computeGrid(rows, columns);
var scrollbarsWidth={horizontal:__WEBPACK_IMPORTED_MODULE_8_zebulon_controls__["h" /* constants */].ScrollbarSize*(columns.hasScrollbar||0),vertical:__WEBPACK_IMPORTED_MODULE_8_zebulon_controls__["h" /* constants */].ScrollbarSize*(rows.hasScrollbar||0)};var dataCellsSizes={height:Math.min(height-rows.crossSize-scrollbarsWidth.horizontal,rows.size),width:Math.min(width-columns.crossSize-scrollbarsWidth.vertical,columns.size)};// const ConnectedMenu = connectMenu(`context-menu-${gridId}`)(ContextMenu);
grid=connectDropTarget(// Width has to be set in order to render correctly in a resizable box
// Position must be relative so that the absolutely positioned DragLayer behaves correctly
// position of Datacells must be absolute to avoid columns size distorsion
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:width,height:height,position:"relative"// cursor: serverloading ? "progress" : "default"
},id:gridId,onWheel:function onWheel(e){return _this2.dataCells.onWheel(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DragLayer__["a" /* default */],{gridId:gridId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"zebulon-grid-zebulon-grid",style:{fontSize:zoomValue*100+"%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers_DimensionHeaders__["a" /* default */],{gridId:gridId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_ColumnHeaders__["a" /* default */],{gridId:gridId,rows:null,columns:columns,height:rows.crossSize,width:dataCellsSizes.width})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_RowHeaders__["a" /* default */],{gridId:gridId,rows:rows,columns:null,height:dataCellsSizes.height,width:columns.crossSize}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__containers_DataCells__["a" /* default */],{drilldown:drilldown,menuFunctions:this.props.menuFunctions,rows:rows,columns:columns,gridId:gridId,height:height-rows.crossSize,width:width-columns.crossSize,scrollbarsWidth:scrollbarsWidth,onScroll:this.onScroll,isPushing:this.isPushing,setToolTip:function setToolTip(toolTip){return _this2.setState({toolTip:toolTip});},style:{// position: "absolute",
top:rows.crossSize,left:columns.crossSize},getRef:function getRef(ref){return _this2.dataCells=ref;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_zebulon_controls__["b" /* ContextualMenu */],{key:"contextual-menu",getMenu:__WEBPACK_IMPORTED_MODULE_2__ContextMenu_ContextMenu__["a" /* getMenu */],component:gridId,ref:function ref(_ref){return _this2.contextualMenu=_ref;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:"tool-tip",className:"zebulon-tool-tip",style:this.state.toolTip.style},this.state.toolTip.comment))));}else{grid=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Loading...");}return grid;}}]);return PivotGrid;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var gridSpec={drop:function drop(props,monitor,component){var handle=monitor.getItem();var initialOffset=monitor.getInitialClientOffset();var offset=monitor.getClientOffset();component.props.updateCellSize({handle:handle,offset:offset,initialOffset:initialOffset});}};var collect=function collect(connect){return{connectDropTarget:connect.dropTarget()};};PivotGrid.defaultProps={id:0};// Add grid id to the type to ensure only correct drop target is used
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["DropTarget"])(function(props){return"cell-resize-handle--"+(props.gridId||0);},gridSpec,collect)(PivotGrid));

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Filter__ = __webpack_require__(303);
var _this=this;// import classnames from "classnames";
var AxisType=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].AxisType,toAxis=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].toAxis,TOTAL_ID=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].TOTAL_ID,MEASURE_ID=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].MEASURE_ID;// const { isNullOrUndefined } = utils;
// import Dataset from "../../containers/Dataset";
// import Properties from "../../containers/Properties";
// import Dimensions from "../../containers/Dimensions";
// import Measures from "../../containers/Measures";
var menuFunctions=function menuFunctions(type,fct,data,menus){var keys=Object.keys(fct);if(keys.length){menus.push({id:menus.length,type:"sub-menu",caption:type,children:keys.map(function(f,index){return{id:100*(menus.length-1)+index,type:fct[f].type||"menu-item",children:[],caption:fct[f].caption,onClick:function onClick(){return data.onItemClick(type,fct[f].code,{rowIndex:data.rowIndex,columnIndex:data.columnIndex,value:null});}};})});}};var getGridMenu=function getGridMenu(data){var menus=[];var features=data.configuration.features;// let // fct = data.menuFunctions.dataCellFunctions || {},
//   // keys,
//   cellFunctions,
//   rangeFunctions,
//   gridFunctions;
menuFunctions("Cell",data.menuFunctions.dataCellFunctions||{},data,menus);menuFunctions("Range",data.menuFunctions.rangeFunctions||{},data,menus);menuFunctions("Grid",data.menuFunctions.gridFunctions||{},data,menus);if(features.filters==="enabled"){menus.push({id:menus.length,type:"sub-menu",separation:menus.length>0,caption:"Filters",children:data.dimensions.filter(function(dimension){return dimension.id!==MEASURE_ID;}).map(function(dimension,index){return{id:100*(menus.length-1)+index,type:"sub-menu",caption:dimension.caption,checked:data.filters[dimension.id]!==undefined,children:[{id:1000*(menus.length-1)+index,type:"jsx",navigation:true,content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_Filter__["a" /* default */],{key:dimension.id,id:"filter",style:{maxHeight:600,backgroundColor:"white",fontFamily:"inherit"},dimensionId:dimension.id,title:dimension.caption,ref:function ref(_ref){_this.filter=_ref;}})}]};})});}if(features.configuration==="enabled"){var children=[{id:100,type:"sub-menu",caption:"Default cell height",children:[{id:1000,type:"jsx",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"right",backgroundColor:"lightgrey",minWidth:50,padding:2}},data.configuration.cellHeight)}]},{id:101,type:"sub-menu",caption:"Default cell width",children:[{id:1001,type:"jsx",content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"right",backgroundColor:"lightgrey",minWidth:50,padding:2}},data.configuration.cellWidth)}]},{id:100*menus.length+2,type:"menu-item",separation:true,caption:"Totals before",checked:data.configuration.totalsFirst,onClick:function onClick(){return data.onItemClick("Totals",null,{value:!data.configuration.totalsFirst});}}];if(data.configuration.edition.editable){children.push({id:100*menus.length+children.length,type:"menu-item",separation:true,caption:"Edition mode",checked:data.configuration.edition.activated,onClick:function onClick(){return data.onItemClick("Edition",null,{value:!data.configuration.edition.activated});}});children.push({id:100*menus.length+children.length,type:"menu-item",caption:"Comments tool tips",checked:data.configuration.edition.comments,onClick:function onClick(){return data.onItemClick("Comments",null,{value:!data.configuration.edition.comments});}});}// children.push({
//   id: 100 * menus.length + children.length,
//   type: "sub-menu",
//   separation: true,
//   caption: "Dataset",
//   children: [
//     {
//       id: 10 * (100 * menus.length + children.length),
//       type: "jsx",
//       content: (
//         <div
//           key="dataset"
//           style={{
//             maxHeight: 1000,
//             backgroundColor: "white",
//             border: " solid 0.05em rgba(0, 0, 0, 0.5)"
//           }}
//         >
//           <Dataset />
//         </div>
//       )
//     }
//   ]
// });
// children.push({
//   id: 100 * menus.length + children.length,
//   type: "sub-menu",
//   caption: "Properties",
//   children: [
//     {
//       id: 10 * (100 * menus.length + children.length),
//       type: "jsx",
//       content: (
//         <div
//           key="properties"
//           style={{
//             maxHeight: 1000,
//             backgroundColor: "white",
//             border: " solid 0.05em rgba(0, 0, 0, 0.5)"
//           }}
//         >
//           <Properties />
//         </div>
//       )
//     }
//   ]
// });
// children.push({
//   id: 100 * menus.length + children.length,
//   type: "sub-menu",
//   caption: "Measures",
//   children: [
//     {
//       id: 10 * (100 * menus.length + children.length),
//       type: "jsx",
//       content: (
//         <div
//           key="measures"
//           style={{
//             maxHeight: 1000,
//             backgroundColor: "white",
//             border: " solid 0.05em rgba(0, 0, 0, 0.5)"
//           }}
//         >
//           <Measures />
//         </div>
//       )
//     }
//   ]
// });
// children.push({
//   id: 100 * menus.length + children.length,
//   type: "sub-menu",
//   caption: "Dimensions",
//   children: [
//     {
//       id: 10 * (100 * menus.length + children.length),
//       type: "jsx",
//       content: (
//         <div
//           key="dimensions"
//           style={{
//             maxHeight: 1000,
//             backgroundColor: "white",
//             border: " solid 0.05em rgba(0, 0, 0, 0.5)"
//           }}
//         >
//           <Dimensions />
//         </div>
//       )
//     }
//   ]
// });
menus.push({id:menus.length,type:"sub-menu",separation:menus.length>0,caption:"Configuration",children:children});// console.log(menus);
}if(menus.length){return{type:"menu",position:"bottom",children:menus};}else{return null;}};var getMeasureMenu=function getMeasureMenu(data){if(data.features.measures==="enabled"){return{type:"menu",position:"bottom",children:[{id:1,type:"menu-item",caption:"Measures in rows",checked:data.axis===AxisType.ROWS,onClick:function onClick(){return data.toggleMeasuresAxis(data.axis===AxisType.ROWS?"columns":"rows");}},{id:2,type:"menu-item",caption:"Remove "+data.header.caption,onClick:function onClick(){return data.toggleMeasure(data.header.id);},disable:data.measures.length===1},{id:3,type:"sub-menu",caption:"Add measure",disable:data.availableMeasures.length===0,children:data.availableMeasures.map(function(measure,index){return{id:4+index,type:"menu-item",caption:measure.caption,onClick:function onClick(){return data.toggleMeasure(measure.id);}};})}]};}else{return null;}};var getDimensionMenu=function getDimensionMenu(data){var features=data.features,isNotCollapsible=data.isNotCollapsible,dimension=data.dimension,toggleSubTotal=data.toggleSubTotal,toggleSortOrder=data.toggleSortOrder,collapseAll=data.collapseAll,moveDimension=data.moveDimension;var hasSubTotal=dimension.hasSubTotal,hasGrandTotal=dimension.hasGrandTotal;var availableDimensions=data.availableDimensions.filter(function(dimension){return dimension.id!==MEASURE_ID;});var menus=[];if(features.sorting==="enabled"){menus.push({id:menus.length,type:"menu-item",caption:"Sort  "+(dimension.sort.direction==="asc"?"descending":"ascending"),onClick:function onClick(){return toggleSortOrder(dimension.id);}});}if(!isNotCollapsible&&features.expandCollapse==="enabled"){menus.push({id:menus.length,type:"menu-item",caption:"Expand all",separation:menus.length>0,disable:isNotCollapsible,onClick:function onClick(){return collapseAll(false);}},{id:menus.length+1,type:"menu-item",caption:"Collapse all",disable:isNotCollapsible,onClick:function onClick(){return collapseAll(true);}});}if(features.totals==="enabled"){if(hasSubTotal!==null){menus.push({id:menus.length,type:"menu-item",separation:menus.length>0,caption:"Sub total",checked:hasSubTotal,onClick:function onClick(){return toggleSubTotal(dimension.id);}});}if(hasGrandTotal!==null){menus.push({id:menus.length,type:"menu-item",caption:"Grand total",checked:hasGrandTotal,onClick:function onClick(){return toggleSubTotal(""+toAxis(dimension.axis)+TOTAL_ID);}});}}/*
 content: (
            <div
              key="filters"
              id="filter"
              style={{
                maxHeight: 600,
                backgroundColor: "white",
                // border: " solid 0.05em rgba(0, 0, 0, 0.5)",
                fontFamily: "inherit"
              }}
            >
              <Filter
                dimensionId={dimension.id}
                style={{ width: "inherit" }}
                title={dimension.caption}
                ref={ref => {
                  this.filter = ref;
                  console.log("filter", this.filter);
                }}
              />
            </div>
          )
 */if(features.filters==="enabled"&&dimension.id!==TOTAL_ID){menus.push({id:menus.length,type:"sub-menu",caption:"Filter",separation:menus.length>0,checked:data.dimensionFilter!==undefined,children:[{id:100,type:"jsx",navigation:true,content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers_Filter__["a" /* default */],{key:"filters",id:"filter",style:{maxHeight:600,backgroundColor:"white",fontFamily:"inherit"},dimensionId:dimension.id,title:dimension.caption,ref:function ref(_ref2){_this.filter=_ref2;}})}]});}if(features.dimensions==="enabled"){if(dimension.id!==TOTAL_ID){menus.push({id:menus.length,type:"menu-item",separation:menus.length>0,caption:"Remove "+dimension.caption,onClick:function onClick(){return moveDimension(dimension.id,toAxis(dimension.axis),toAxis(AxisType.DIMENSION));}});menus.push({id:menus.length,type:"sub-menu",caption:"Add dimension",disable:availableDimensions.length===0,children:availableDimensions.map(function(dim,index){return{id:100*(menus.length-1)+index,type:"menu-item",caption:dim.caption,onClick:function onClick(){return moveDimension(dim.id,toAxis(AxisType.DIMENSION),toAxis(dimension.axis),dimension.id===MEASURE_ID?dimension.depth:dimension.depth+1);}};})});}}if(menus.length){return{type:"menu",position:"bottom",children:menus};}else{return null;}};var getMenu=function getMenu(id,data){if(id==="dimension-menu"){return getDimensionMenu(data);}else if(id==="measure-menu"){return getMeasureMenu(data);}else if(id==="grid-menu"){return getGridMenu(data);}};// export default ContextMenu;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(295);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(296);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 296 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rightArrow", function() { return rightArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "downArrow", function() { return downArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upArrow", function() { return upArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "filter", function() { return filter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "close", function() { return close; });
var rightArrow = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAX4QB0UU2zAMDCEIgMGTjOyAaOAAAAA6dUK1fxYl1IAAAAASUVORK5CYII=)";
var downArrow = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJ0lEQVQ4jWNgGAWDE9RBMbHiOBXWERAj2hCSNeMyhCxAkeZRQCQAAFO3CtUd1w9cAAAAAElFTkSuQmCC)";
var upArrow = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAB9CAMAAAC4XpwXAAAAXVBMVEX///9RUVFOTk6ampr09PSrq6vx8fFLS0uoqKhZWVldXV1BQUFWVlb8/Pzq6uqdnZ1GRka1tbVxcXHNzc1lZWWOjo59fX3e3t6+vr5sbGyUlJSFhYXT09N3d3fk5OQkmpkuAAACPUlEQVRoge3Y25aCIBSAYUUFD5l4yMys93/MwVqtWSWwgQG7mP1fzM0MfokFNFGEYRiGYRiGYRi2e+kytW07LfU37H6+DWVRDre5392n+UAIieNY/Ly06c54U6z0M1bmu/K0Ofzi4v6LPXmavOEPfrdnv8EFf9iLT7f4fnyaxFv8wX8PF3wcnq9nBb7yTXBcZa88Cctr8eD8zHS4iAXkTxAekj9xEI9jHog3wkPxVzM8DG+Mh3j2htMehrfCxQffK2+Je112anCR2fLethwH/MF72e+BtV3JezlupG64H14cJnSC7pUJ/o8nXeVJ5nn9sit1v/7jQZsCeLY0khOmJ15ydH7DcxodoT9x5g3wSPBFEJ7qZ/WJw3zmxBviETj5GdU60o4NMKO/1/TPW+D+eSvcN2+J++WtcZ88gBcSfOWBZdGQd8J98QB+UOArr93xjPg0c8TXlVnPT/B+vwx6XLdu0kR3BmPdGbz1XHMBEgOLNk10h18G/lfxPKpvnRBwx9Dy7HoEhusmHsZXvlKPv0BT3x/UL91or0zVPCncdZ6ZHVHVPCkhXTnzlSGu4Ul3B4ber/L3vDmu5tkMvevqVqrb4Eqe9eDI8yjh7XAFz0/QrYv6YcPb4lKeXRaTkdPn9xN7XMKzAZ53Ge+Cb3hj/IN3wz94C3zlX8+euOKCb6rXTXCzZ/7qPHLOCGPVYDXsvXoqKiauwvkJWmY+u+djNybgjgz4/Tx218zgk4ZhGIZhGIZhGIZhGIZh2H/uB6QNIEK/CbxpAAAAAElFTkSuQmCC)";
var filter = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAABfCAMAAAC5kuvHAAAAbFBMVEX///8AAAABAQGWlpbi4uK5ubnHx8fr6+uKiorExMQqKiqOjo7e3t7Ly8v29vbl5eWCgoI7Ozt8fHyxsbFoaGienp5ZWVkXFxfR0dGnp6c2NjZUVFTX19deXl4wMDBEREQQEBBMTEwfHx9ycnKLTiNGAAACQElEQVRoge2Z27qCIBCFRS21g5bZ+Vzv/46bRW0/UxDQ4Y51ifgPDYflUBB4GSiPiZX/8k+MWI+4iZ+ykFhs3uRnnE85ek5LW3z2jsg0ZxL+hHC1OOYnMv6Rjl+0+UvewJZU+PzV5gdrBFgQ4QWs+G278bYwVrxhJ4Fvo/I9AiQE+Cfwl05zwvFsn0tesNMV+0s2lQUCzMYGqIDPpI8WfF+z0zh8CfxG8fCAAM8x+DnwW+XjKQLshuMj4KOeDhMEqIbij1g5aW+XDQKUw/AbjF737hEBVkPw4re/td0idJtru3WUmaZWswYUWgJ/Nuq6wjRZntYX4NeGncUetLKbglnt/at6k0slzq6XxdFytvKb/GF99p4s/Cafdf1EK3NDE9bU8ROjQYUmg7oDf7DE8zmDoTF9UnfoZrEWasWYtZkuQAX8sE8n4Tfr/lVXAq/yE53Eprz39Vhhowz/MFtq/CbFc+ujqiFxKF5VT7cYfb+f6NRnaAI/yCoaOipNSdjVYC+tFSlGmaF9xLdALeE3ZbdEMfYTnUqgJDXW2G+xWm9pdanbeuZKJNVlSFhQoZwqk2Z1XmwoC7ZOufYpqFzyp57v+Z7v+Z7v+Z7v+Z7v+S75rRs5cv7996qDmI8C6edelpSPawAe4NW4JaHlB4eZKIrO9S0SMf9brLN6msn5QV6JJO0njvi85vr8ybpbOOLXSUpd8f+TxDLS+rGpb5LWrvifJIWk9XtLCZLkkM+TdGPu8iOEJFneONspmTjFexHpD7a5F/IsQrLEAAAAAElFTkSuQmCC)";
var close = "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHkAAAB5CAMAAAAqJH57AAAAWlBMVEX///8AAAB+fn6BgYGYmJiSkpKFhYV7e3uOjo6hoaGkpKT39/ecnJzW1taoqKi5ubkeHh7u7u4ODg7Jyclra2tMTEzf399WVlZGRkYzMzMpKSlmZmZgYGA7Oztfm/ARAAADLUlEQVRogcWb4XaCMAyFWxU2UYfbnHObe//XHMhQxLY3TdKT+5MWvpMmhZKmzg3atIvTm//+aY6ujI7Nz7d/Oy3azd3lTeWv+twV4O4+b4Bqwt59+alW6uDV3fO/rra9+5melMFPc8D7cH03v66NfgB7P1j9+9jgl4rgZeD5v33DOtCgafUi+Px11xJs0EMHhvqiQHjpomPgLsi2sSYVdBTst+4QbVNAx8H+4D7ijWJ0OLgGfSTJfiECh6bThHxONYusTgx1p7Orku0CdBrsK9emO7DRAOxbtwE9mOhUcF3UfSrrEmhksa+7Tq971Cs/wqHF+9e+G/J0/pcrOZ0uaoeOL7BjntXQYv8ydtVFZ4B10Vlg5xo1NAY39zfEP5Z5aAzezm9ZwVsoaBzVgSU1RuPJxQJr+BoP9Tp8I0anrcYWN7FbZWj4AYiDY2tvGhpbHBnqQfwwYwbXTWCJ4mNhhoOrSoO5Vost7sV5m2Hww5srJBxm9ewOHNXJ4OKj1cCUAZ+iMZg01INwhN/QGAyjeqpn+LgxwnFwPeeAKVYvieAsi3vRfK3q4xx0ETAFfSoDprxIkdjZRBzhaWVG9VTYj4XAlMkVV/Z0uhff1+KMMRetkKrmoVVy5BxfC308Kn9yiaJ6qtzJNV+zCJRntZrFvXJ8reTjUfQIVwbTrVYHU32t6uNRlAhXjOqp8ELgVAZsZrOZn81im/4qUUabvcPM3ttm3yqz77PZmsRsHWa29jRbb5v9Y8j+qwSTy+xf0uz/2SxnQMmTYHcUStAUyQ1R82HKGUDDHKBZ3tMs12uW3zbL6eOhftxCUdnHMNu74e5XifPc/D067Ouk1ZJ9SVGY4b3Y1MdegDbbf8ZDjfbcmRvBOLjwuooVZhoFDqx5bVZPoldDkxlmmnVDGF2oYMmwSCsDbVYTV6IOEKIvdYBFah/hgHdvJVjvyavtJdR72tW4gjU9v64XWF0VrGVOo8/p+m1ZSi0Zu+nKcVnhOKpZt6vTtzubYHcew+4MSmThJw2um+LnbuzOGrljuaEeFBjw/9N6ZmfKDM/RGZ4d7Nlt3Z+XPBQ8L3noz0vW1/OSfwNyKlQrPfvJAAAAAElFTkSuQmCC)";
// export const rightArrow =
// 	'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAIElEQVQ4jWNgGAX4QB0UU2zAMDCEIgMGTjOyAaOAAAAA6dUK1fxYl1IAAAAASUVORK5CYII=)';
// export const downArrow =
// 	'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJ0lEQVQ4jWNgGAWDE9RBMbHiOBXWERAj2hCSNeMyhCxAkeZRQCQAAFO3CtUd1w9cAAAAAElFTkSuQmCC)';

// export const rightChevron="";
// export const leftChevron="";
// export const downChevron="";
// export const upChevron="";
// export const rightChevron="";
// export const leftChevron="";
// export const downArrow="";
// export const upArrow="";
// export const filter="";

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accessors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generic__ = __webpack_require__(22);



// import { utils } from "zebulon-controls";
// import {
// 	buildObject,
// 	exportFunctions
// 	// aggregations
// } from "./utils/utils";
// import { getFunction } from "./utils/compute.meta";
// ({row})=>accessor('qty')({row})*3
var sum = function sum(values) {
	return values.reduce(function (sum, value) {
		return sum += value;
	}, null);
};
var accessors = {
	globals_: {
		formats: {
			decimals: function decimals(_ref) {
				var value = _ref.value,
				    _decimals = _ref.decimals,
				    column = _ref.column;
				return __WEBPACK_IMPORTED_MODULE_1__generic__["formatValue"](value, null, _decimals || (column || {}).decimals || 2);
			},
			percentage: function percentage(_ref2) {
				var value = _ref2.value,
				    decimals = _ref2.decimals,
				    column = _ref2.column;
				return __WEBPACK_IMPORTED_MODULE_1__generic__["formatValue"](value * 100, null, decimals || (column || {}).decimals || 2) + "%";
			},
			date: function date(_ref3) {
				var value = _ref3.value,
				    format = _ref3.format,
				    column = _ref3.column;
				return __WEBPACK_IMPORTED_MODULE_1__generic__["isNullOrUndefined"](value) ? "" : __WEBPACK_IMPORTED_MODULE_1__generic__["formatValue"](value, format || (column || {}).format || "dd/mm/yyyy");
			},
			"mm/yyyy": function mmYyyy(_ref4) {
				var value = _ref4.value;
				return __WEBPACK_IMPORTED_MODULE_1__generic__["isNullOrUndefined"](value) ? "" : __WEBPACK_IMPORTED_MODULE_1__generic__["formatValue"](value, "mm/yyyy");
			},
			yyyy: function yyyy(_ref5) {
				var value = _ref5.value;
				return __WEBPACK_IMPORTED_MODULE_1__generic__["isNullOrUndefined"](value) ? "" : __WEBPACK_IMPORTED_MODULE_1__generic__["formatValue"](value, "yyyy");
			},
			time: function time(_ref6) {
				var value = _ref6.value;
				return __WEBPACK_IMPORTED_MODULE_1__generic__["isNullOrUndefined"](value) ? "" : __WEBPACK_IMPORTED_MODULE_1__generic__["formatValue"](value, "hh:mi:ss");
			},
			dateTime: function dateTime(_ref7) {
				var value = _ref7.value;
				return __WEBPACK_IMPORTED_MODULE_1__generic__["isNullOrUndefined"](value) ? "" : __WEBPACK_IMPORTED_MODULE_1__generic__["formatValue"](value, "dd/mm/yyyy hh:mi:ss");
			},
			image: function image(_ref8) {
				var value = _ref8.value;

				if (!value) {
					return null;
				}
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
					height: "100%",
					width: "100%",
					padding: "unset",
					alt: "",
					src: value
				});
			}
		},
		aggregations: {
			count: function count(values) {
				return values.length;
			},
			sum: sum,
			min: function min(values) {
				return values.reduce(function (min, value) {
					return min = min === null || value < min ? value : min;
				}, null);
			},
			max: function max(values) {
				return values.reduce(function (max, value) {
					return max = max === null || value > max ? value : max;
				}, null);
			},
			avg: function avg(values) {
				return values.length === 0 ? null : sum(values) / values.length;
			},
			weighted_avg: function weighted_avg(values) {
				var wavg = values.reduce(function (wavg, value) {
					wavg.v0 += value.v0;
					wavg.v1 += value.v1;
					return wavg;
				}, { v0: null, v1: null });
				return wavg.v0 === null && wavg.v1 === null ? null : wavg.v0 / wavg.v1;
			},
			delta: function delta(values) {
				var delta = values.reduce(function (delta, value) {
					delta.v0 += value.v0;
					delta.v1 += value.v1;
					return delta;
				}, { v0: null, v1: null });
				return delta.v0 - delta.v1;
			},
			prod: function prod(values) {
				return values.reduce(function (prod, value) {
					return prod *= value;
				}, null);
			}
		}
	}
};
// function forEachIntersection(accessor, intersection, data, callback) {
//   if (intersection && intersection.length > 0) {
//     // for (let i = 0; i < intersection.length; i += 1) {
//     //   const row=data[intersection[i]];
//     //   callback(accessor(row));
//     // }
//     intersection.map(index=>{const row =data[index];
//       if(!row.isFiltered){callback(accessor(row))};
//   }
// }

// export function calcVariance(accessor, intersection, data, population) {
//   let variance = 0;
//   let avg = null;
//   const len = intersection.length;
//   if (len > 0) {
//     if (population || len > 1) {
//       forEachIntersection(accessor, intersection, data, val => {
//         avg += val;
//       });
//       avg /= len;
//       forEachIntersection(accessor, intersection, data, val => {
//         variance += (val - avg) * (val - avg);
//       });
//       variance /= population ? len : len - 1;
//     } else {
//       variance = NaN;
//     }
//   }
//   return variance;
// }



/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Filter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScrollableGrid__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(36);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FilterValues = function (_ScrollableGrid) {
  _inherits(FilterValues, _ScrollableGrid);

  function FilterValues() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FilterValues);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterValues.__proto__ || Object.getPrototypeOf(FilterValues)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (id, index) {
      _this.selectCell({ rows: index, columns: 0 });
      _this.props.onChangeCheck(id, index);
    }, _this.selectRange = function (range) {
      _this.focusedIndex = range.end.rows;
      _this.setState({ selectedRange: range });
    }, _this.getRowWidth = function () {
      _this.rowWidth = _this.props.width - __WEBPACK_IMPORTED_MODULE_2__constants__["ScrollbarSize"];
      _this.lockedWidth = 0;
    }, _this.getContent = function () {
      var items = [];
      var i = 0,
          index = _this.state.scroll.rows.startIndex;
      var _this$props = _this.props,
          filter = _this$props.filter,
          rowCount = _this$props.rowCount,
          height = _this$props.height,
          rowHeight = _this$props.rowHeight;

      var _loop = function _loop() {
        var _this$props$data$inde = _this.props.data[index],
            id = _this$props$data$inde.id,
            label = _this$props$data$inde.label;

        var style = { height: rowHeight, width: "inherit", display: "flex" };
        if (index === _this.state.selectedRange.end.rows) {
          style.backgroundColor = "aliceblue";
        }
        var ix = index;
        items.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { key: index, style: style },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            id: "checkbox " + index,
            type: "checkbox",
            checked: filter[id] !== undefined,
            onChange: function onChange() {
              return _this.onClick(id, ix);
            }
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { onClick: function onClick() {
                return _this.onClick(id, ix);
              } },
            label
          )
        ));
        index++;
        i++;
      };

      while (index < rowCount && i < height / rowHeight) {
        _loop();
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "content", style: {}, onWheel: _this.onWheel },
        items
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FilterValues, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focusedIndex !== undefined) {
        var element = document.getElementById("checkbox " + this.focusedIndex);
        if (element) {
          element.focus();
        }
        this.focusedIndex = undefined;
      }
    }
  }]);

  return FilterValues;
}(__WEBPACK_IMPORTED_MODULE_1__ScrollableGrid__["a" /* ScrollableGrid */]);

var Filter = function (_Component) {
  _inherits(Filter, _Component);

  function Filter(props) {
    _classCallCheck(this, Filter);

    var _this2 = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

    _this2.filterItems = function (value) {
      var v = value.toLowerCase();
      var items = _this2.props.items.filter(function (item) {
        return String(item.label).toLowerCase().startsWith(v);
      });
      _this2.setState({
        items: items,
        rowCount: items.length,
        changed: !_this2.state.changed
      });
    };

    _this2.onChangeCheck = function (id, index) {
      var filter = _this2.state.filter;
      var checked = filter[id] === undefined;
      if (checked) {
        filter[id] = id;
      } else {
        delete filter[id];
      }
      _this2.setState({ filter: filter, index: index, changed: !_this2.state.changed });
      //this.selectCell({ rows: index, columns: 0 });
    };

    _this2.onChangeCheckAll = function () {
      var filter = _this2.state.items.reduce(function (acc, item) {
        if (_this2.state.checkAll) {
          delete acc[item.id];
          return acc;
        } else {
          acc[item.id] = item.id;
          return acc;
        }
      }, Object.assign({}, _this2.state.filter));
      _this2.setState({
        filter: filter,
        checkAll: !_this2.state.checkAll,
        changed: !_this2.state.changed
      });
    };

    _this2.onOk = function () {
      var filterKeys = Object.values(_this2.state.filter);
      var filter = filterKeys.length === _this2.props.items.length || filterKeys.length === 0 ? null : _this2.state.filter;
      _this2.props.onOk(filter);
    };

    _this2.state = {
      items: [].concat(_toConsumableArray(props.items)),
      filter: Object.assign({}, props.filter),
      rowCount: props.items.length,
      checkAll: false,
      maxRows: props.maxRows || 10,
      rowHeight: props.rowHeight || 20
    };
    return _this2;
  }

  _createClass(Filter, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.keyEvent !== nextProps.keyEvent && this.values) {
        this.values.handleNavigationKeys(nextProps.keyEvent);
      } else if (nextProps.items !== this.props.items || nextProps.filter !== this.props.filter) {
        this.setState({
          items: [].concat(_toConsumableArray(nextProps.items)),
          filter: Object.assign({}, nextProps.filter),
          rowCount: nextProps.items.length
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.keyEvent === nextProps.keyEvent;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          maxRows = _state.maxRows,
          rowHeight = _state.rowHeight;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          id: "filter",
          style: Object.assign({}, this.props.style, {
            height: "fit-content"
          }),
          onWheel: this.onWheel
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { textAlign: "center" } },
          this.props.title || "Filter"
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            type: "text",
            style: {
              width: "94%",
              margin: "2%",
              placeholder: "toto",
              textAlign: "left"
            },
            autoFocus: true,
            value: this.value,
            onChange: function onChange(e) {
              return _this3.filterItems(e.target.value);
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
            id: "-1",
            value: "0",
            type: "checkbox",
            checked: this.state.checkAll,
            onChange: this.onChangeCheckAll
          }),
          "Select all",
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilterValues, {
            width: (this.props.style.width || 200) * 0.98,
            height: maxRows * rowHeight - 5,
            style: {
              width: (this.props.style.width || 200) * 0.98,
              justifyContent: "space-between",
              borderTop: "solid 0.02em rgba(0, 0, 0, 0.3)",
              marginTop: 5
            },
            rowCount: this.state.rowCount,
            rowHeight: rowHeight,
            data: this.state.items,
            filter: this.state.filter,
            onChangeCheck: this.onChangeCheck,
            changed: this.state.changed,
            ref: function ref(_ref2) {
              return _this3.values = _ref2;
            }
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { style: { width: "96%", margin: "2%" }, onClick: this.onOk },
          "Apply filter"
        )
      );
    }
  }]);

  return Filter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scrollbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ScrollbarInner = function (_Component) {
  _inherits(ScrollbarInner, _Component);

  function ScrollbarInner() {
    _classCallCheck(this, ScrollbarInner);

    return _possibleConstructorReturn(this, (ScrollbarInner.__proto__ || Object.getPrototypeOf(ScrollbarInner)).apply(this, arguments));
  }

  _createClass(ScrollbarInner, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "zebulon-scrollbar-thumb",
        id: "thumb-" + this.props.id,
        style: this.props.style
      });
    }
  }]);

  return ScrollbarInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var Scrollbar = function (_Component2) {
  _inherits(Scrollbar, _Component2);

  function Scrollbar(props) {
    _classCallCheck(this, Scrollbar);

    var _this2 = _possibleConstructorReturn(this, (Scrollbar.__proto__ || Object.getPrototypeOf(Scrollbar)).call(this, props));

    _initialiseProps.call(_this2);

    _this2.state = { innerStyle: _this2.computeScrollbar(props) };
    return _this2;
  }

  _createClass(Scrollbar, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var innerStyle = this.computeScrollbar(nextProps);
      // if (!this.isDragging) {
      this.setState({ innerStyle: innerStyle });
      // }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var element = document.getElementById(this.props.id);
      if (element) {
        this.scrollbarPositions = element.getBoundingClientRect();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          width = _props.width,
          id = _props.id;

      if (!width) {
        return null;
      }
      // if (this.props.direction === "horizontal") {
      //   console.log("scrollbar", this.props.positionRatio);
      // }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          className: "zebulon-scrollbar-bar",
          id: id,
          style: this.style,
          onMouseDown: this._handleMouseDown,
          onMouseUp: this._handleMouseUp,
          onMouseMove: this._handleMouseMove
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollbarInner, {
          id: "thumb-" + id,
          style: this.state.innerStyle,
          direction: this.props.direction,
          length: this.props.length,
          positionRatio: this.props.positionRatio,
          onScroll: this.props.onScroll
        })
      );
    }
  }]);

  return Scrollbar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.computeScrollbar = function (props) {
    var direction = props.direction,
        length = props.length,
        width = props.width,
        positionRatio = props.positionRatio,
        displayRatio = props.displayRatio;


    var innerStyle = void 0;
    _this3.innerSize = Math.max(30, length * displayRatio);
    _this3.position = Math.min(length - _this3.innerSize, length * positionRatio);
    _this3.positionRatio = positionRatio;
    if (direction === "horizontal") {
      _this3.style = {
        // position: "absolute",
        height: width,
        width: length
        // left,
        // top
      };
      innerStyle = {
        position: "relative",
        height: width - 1,
        width: _this3.innerSize,
        left: _this3.position
      };
    } else {
      _this3.style = {
        height: length,
        width: width
      };
      innerStyle = {
        position: "relative",
        height: _this3.innerSize,
        width: width - 1,
        top: _this3.position
      };
    }
    return innerStyle;
  };

  this._handleMouseDown = function (e) {
    var event = {
      type: "scrollbar",
      direction: _this3.props.direction,
      initiator: e.target.id.startsWith("thumb") ? "thumb" : "bar",
      position: _this3.props.direction === "horizontal" ? e.clientX : e.clientY
    };
    e.preventDefault();
    if (event.initiator === "thumb") {
      _this3.isDragging = true;
      _this3.props._handleDrag("startDrag", event);
    } else if (!_this3.isDragging) {
      var _e$target$getBounding = e.target.getBoundingClientRect(),
          left = _e$target$getBounding.left,
          top = _e$target$getBounding.top;

      event.relativePosition = event.position - (_this3.props.direction === "horizontal" ? left : top);
      // console.log("click", left, e.clientX, event);
      return _this3.props._handleDrag("click", event);
    }
  };

  this._handleMouseUp = function (e) {
    _this3.isDragging = false;
    _this3.props._handleDrag("endDrag", { direction: _this3.props.direction });
  };

  this._handleMouseMove = function (e) {
    if (_this3.isDragging && e.buttons) {
      var event = {
        type: "scrollbar",
        direction: _this3.props.direction,
        position: _this3.props.direction === "horizontal" ? e.clientX : e.clientY
      };
      e.preventDefault();
      _this3.props._handleDrag("drag", event);
    } else if (_this3.isDragging && !e.buttons) {
      _this3.isDragging = false;
      _this3.props._handleDrag("endDrag", { direction: _this3.props.direction });
    }
  };
};

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_generic__ = __webpack_require__(22);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ConfirmationModal = function (_React$Component) {
	_inherits(ConfirmationModal, _React$Component);

	function ConfirmationModal(props) {
		_classCallCheck(this, ConfirmationModal);

		var _this = _possibleConstructorReturn(this, (ConfirmationModal.__proto__ || Object.getPrototypeOf(ConfirmationModal)).call(this, props));

		_initialiseProps.call(_this);

		if (props.show) {
			_this.init(props);
		}
		_this.state = { status: {}, body: _this.body };
		return _this;
	}

	_createClass(ConfirmationModal, [{
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.keyEvent && nextProps.keyEvent !== this.props.keyEvent && !(nextProps.show && !this.props.show)) {
				var keyCode = nextProps.keyEvent.which || nextProps.keyEvent.keyCode;
				var key = __WEBPACK_IMPORTED_MODULE_1__utils_generic__["keyMap"][keyCode];
				if (key === "Escape") {
					nextProps.keyEvent.preventDefault();
					this.onConfirm(false, false, nextProps);
				} else if (key === "Enter") {
					nextProps.keyEvent.preventDefault();
					this.onConfirm(true, true, nextProps);
				}
			}
			if (nextProps.show) {
				this.init(nextProps);
				this.setState({ body: this.body });
			}
		}
	}, {
		key: "render",
		value: function render() {
			// Render nothing if the "show" prop is false
			if (!this.props.show) {
				return null;
			}
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				{
					className: "backdrop zebulon-modal-backdrop",
					style: { zIndex: 4 }
				},
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					{
						className: "modal zebulon-modal-confirmation",
						style: { display: "flex", top: 100, zIndex: 4 }
					},
					this.state.body,
					__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						"div",
						{ className: "footer", style: { display: "flex" } },
						this.buttons
					)
				)
			);
		}
	}]);

	return ConfirmationModal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var _initialiseProps = function _initialiseProps() {
	var _this2 = this;

	this.init = function (props, refresh) {
		var _props$detail = props.detail,
		    body = _props$detail.body,
		    type = _props$detail.type,
		    noRefresh = _props$detail.noRefresh;
		// do you wnat to save before

		if (type === "YesNoCancel") {
			_this2.buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, true, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Yes"
			), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, false, props);
						}
					},
					tabIndex: 1,
					key: 1
				},
				"No"
			), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, false, props);
						}
					},
					tabIndex: 2,
					key: 2
				},
				"Cancel"
			)];
			// do you want to continue
		} else if (type === "YesNo") {
			_this2.buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, undefined, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Yes"
			), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, undefined, props);
						}
					},
					tabIndex: 0,
					key: 1,
					autoFocus: true
				},
				"No"
			)];
			// foreign key selection
		} else if (type === "foreignKey" || type === "OkCancel" || type === "conflict") {
			_this2.buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(true, undefined, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Ok"
			), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, undefined, props);
						}
					},
					tabIndex: 1,
					key: 1
				},
				"Cancel"
			)];
			if (!noRefresh && type === "foreignKey") {
				_this2.buttons.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"button",
					{
						style: { minWidth: 70, margin: 5 },
						onClick: function onClick(e) {
							if (!e.defaultPrevented) {
								_this2.init(props, true);
								_this2.setState({
									status: { loading: true },
									body: _this2.body
								});
							}
						},
						tabIndex: 2,
						key: 2
					},
					"Refresh"
				));
			}
			// blocking alert
		} else if (type === "Ok") {
			_this2.buttons = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"button",
				{
					style: { minWidth: 70, margin: 5 },
					onClick: function onClick(e) {
						if (!e.defaultPrevented) {
							_this2.onConfirm(false, undefined, props);
						}
					},
					tabIndex: 0,
					key: 0,
					autoFocus: true
				},
				"Ok"
			)];
		}
		_this2.body = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			"div",
			null,
			body
		);
		if (Array.isArray(body)) {
			_this2.body = body.map(function (line, index) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					{ key: index },
					line
				);
			});
		} else if (type === "foreignKey" && props.detail.callback) {
			var foreignProps = {
				callbackForeignKey: function callbackForeignKey(ok, message) {
					_this2.row = message;
					_this2.onConfirm(ok, undefined, props);
				},
				onDoubleClick: function onDoubleClick() {
					return _this2.onConfirm(true, undefined, props);
				},
				keyEvent: props.keyEvent,
				onRowEnter: function onRowEnter(_ref) {
					var row = _ref.row;

					_this2.row = row;
					return true;
				},
				isModal: true,
				status: _this2.state.status,
				refresh: refresh,
				ref: function ref(_ref2) {
					return _this2.zebulonTable = _ref2;
				}
			};

			_this2.body = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(body, foreignProps)
			);
		} else if (type === "conflict" && props.detail.callback) {
			var conflictProps = {
				keyEvent: props.keyEvent,
				ref: function ref(_ref3) {
					return _this2.zebulonTable = _ref3;
				}
			};

			_this2.body = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(body, conflictProps)
			);
		}
	};

	this.onConfirm = function (carryOn_, ok, props) {
		if (props.show) {
			var carryOn = carryOn_;
			var message = ok;
			if (props.detail.type === "foreignKey") {
				carryOn = carryOn && _this2.row !== undefined;
				message = _this2.row;
			} else if (props.detail.type === "conflict") {
				message = Object.values(_this2.zebulonTable.state.updatedRows).filter(function (row) {
					return row.checked_ && row.index_ !== undefined;
				}).map(function (row) {
					return row.index_;
				}); // a voir
			}
			props.onConfirm();
			if (props.detail.callback) {
				props.detail.callback(carryOn, message);
			}
		}
	};
};

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Layout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContextualMenu__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input__ = __webpack_require__(107);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// import { ZebulonTable } from "../table/ZebulonTable";
// import { buildMeta } from "./meta.dataset";
// ------------------------------------
// tests data
// ------------------------------------
// class Queries extends ScrollableGrid {}
var resizeHandleSize = 5;
var titleHeight = 20;

// -----------------------------------------
// component Layout
// ---------------------------------------
var Layout = function (_Component) {
  _inherits(Layout, _Component);

  function Layout(props) {
    _classCallCheck(this, Layout);

    var _this = _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).call(this, props));

    _initialiseProps.call(_this);

    var components = props.components.reduce(function (acc, component) {
      acc[component.id] = component;
      return acc;
    }, {});
    _this.state = {
      layout: props.layout,
      components: components,
      selectedTabs: {},
      activeLayout: "0",
      resizeImage: {
        position: "fixed",
        top: 0,
        height: 0,
        with: 0,
        backgroundColor: "blue"
      },
      dragPreviewStyle: { display: "none" }
    };
    // this.state.layoutDiv = this.buildLayout(props.layout, null, 0, components);
    return _this;
  }

  _createClass(Layout, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // if (this.props.keyEvent !== nextProps.keyEvent) {
      //   if (nextProps.keyEvent.which === 27 && this.contextualMenu) {
      //     this.contextualMenu.close();
      //   }
      //   const zoom = utils.isZoom(nextProps.keyEvent);
      //   if (zoom) {
      //     const lay = this.getLayout(this.getIds(": " + this.state.activeLayout));
      //     lay.zoom = (lay.zoom || 1) * (zoom === 1 ? 1.1 : 1 / 1.1);
      //     this.setState({ layout: this.state.layout });
      //     nextProps.keyEvent.preventDefault();
      //     return;
      //   }
      //   if (
      //     utils.isNavigationKey(nextProps.keyEvent) ||
      //     nextProps.keyEvent.type === "copy" ||
      //     nextProps.keyEvent.type === "paste"
      //   ) {
      //     this.setState({ keyEvent: nextProps.keyEvent });
      //     return;
      //   }
      //   this.keyEvent = true;
      // }
      if (this.props.sizes.height !== nextProps.sizes.height || this.props.sizes.width !== this.state.layout) {
        var layout = this.state.layout;
        layout.height = nextProps.sizes.height;
        layout.width = nextProps.sizes.width;
        this.setState({ layout: layout });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      if (this.keyEvent) {
        this.keyEvent = false;
        return false;
      }
      return true;
    }
    //----------------------------------------
    //utils
    //----------------------------------------

    // --------------------------------------
    // build layout
    // --------------------------------------

    //----------------------------------------
    // contextual menu
    //----------------------------------------

    // ---------------------------------------------

    //----------------------------------------
    // drag and drop
    //----------------------------------------

    //----------------------------------------
    // render
    //----------------------------------------

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // let resizePreview;
      // if (this.state.dragId) {
      //   const y = this.rect.y - this.dragRect.y,
      //     x =
      //       this.rect.x -
      //       this.dragRect.x +
      //       this.layout.width -
      //       4 +
      //       (this.pageX2 || this.pageX) -
      //       this.pageX;
      //   console.log(
      //     "render layout",
      //     x,
      //     y,
      //     this.rect.x,
      //     this.dragRect.x,
      //     this.layout.width,
      //     this.pageX2,
      //     this.pageX
      //   );
      //   const previewStyle = {
      //     position: "absolute",
      //     height: this.rect.height,
      //     width: 4,
      //     transform: `translate(${x}px,${y}px)`,
      //     backgroundColor: "blue"
      //   };
      //   resizePreview = (
      //     <div style={previewStyle} ref={ref => (this.div = ref)} />
      //   );
      // } else {
      //   resizePreview = (
      //     <div style={{ display: "none" }} ref={ref => (this.div = ref)} />
      //   );
      // }
      if (this.props.visible === false) {
        return null;
      }
      var menu = this.state.layout.updatable ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ContextualMenu__["a" /* ContextualMenu */], {
        key: "layout-menu",
        getMenu: this.getMenu,
        component: "layout",
        ref: function ref(_ref) {
          return _this2.contextualMenu = _ref;
        }
      }) : null;
      return (
        // <div ref={ref => (this.dragLayer = ref)}>
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: { position: "relative" },
            onDragStart: this.handleDragStart,
            onDragOver: this.handleDragOver
            // onDragExit={e => console.log("exit", e)}
            // onDragLeave={e => console.log("leave", e)}
            , onDrop: this.handleDrop,
            onClick: function onClick(e) {
              if (!e.defaultPrevented && !e.target.id.startsWith("menuRename") && _this2.contextualMenu) {
                _this2.contextualMenu.close();
              }
            },
            id: "layout",
            ref: function ref(_ref2) {
              return _this2.dragLayer = _ref2;
            }
          },
          this.computeLayout(this.state.layout, this.state.activeLayout),
          menu
        )
        // (  <div
        //     id="layout-preview"
        //     style={{ display: "none" }}
        //     ref={ref => (this.preview = ref)}
        //   />
        // </div>)

      );
      // {resizePreview}
    }
  }]);

  return Layout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleKeyEvent = function (e) {
    var layout = _this3.getLayout(_this3.getIds(": " + _this3.state.activeLayout));
    if (layout && layout.handleKeyEvent) {
      return layout.handleKeyEvent(e);
    }
  };

  this.getParent = function (element, id) {
    if (element.id.startsWith(id)) {
      return element;
    } else if (element.parentElement) {
      return _this3.getParent(element.parentElement, id);
    } else {
      return null;
    }
  };

  this.getIds = function (id) {
    return id.slice(id.indexOf(":") + 2).split(" - ").map(function (id) {
      return Number(id);
    });
  };

  this.getLayout = function (ids) {
    var layout = _this3.state.layout,
        index = void 0;
    if (ids.length > 1) {
      ids.reverse();
      ids.pop(); // root
      while ((index = ids.pop()) !== undefined) {
        layout = layout.layouts[index];
      }
    }
    return layout;
  };

  this.isVisible = function (layoutId, index) {
    return (_this3.state.selectedTabs[layoutId] || 0) === index;
  };

  this.buildLayout = function (layout, parent, index, components) {
    var height = layout.height,
        width = layout.width,
        display = layout.display,
        layouts = layout.layouts,
        content = layout.content,
        visible = layout.visible;

    layout.id = parent ? parent.id + " - " + index : String(index);
    layout.parent = parent || {};
    layout.layouts = layout.layouts || [];
    layout.index = index;
    layout.calculatedZoom = (parent ? parent.calculatedZoom : 1) * (layout.zoom || 1);
    var resizeH = parent && parent.display === "block" && index < parent.layouts.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: "layout-resize-handle-H: " + layout.id,
      style: {
        width: width - resizeHandleSize,
        height: resizeHandleSize,
        cursor: "row-resize"
      },
      className: "zebulon-layout-resize-handle",
      draggable: true
    }) : null;
    var resizeV = parent && parent.display === "flex" && index < parent.layouts.length - 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: "layout-resize-handle-V: " + layout.id,
      style: {
        height: height,
        width: resizeHandleSize,
        cursor: "col-resize"
      },
      className: "zebulon-layout-resize-handle",
      draggable: true
    }) : null;
    var getChildren = function getChildren(layouts, height, width) {
      if (layouts.length) {
        var childrenSize = 0;
        layouts.forEach(function (layout, index) {
          return childrenSize += display === "flex" ? layout.width : layout.height;
        });
        var ratio = display === "flex" ? width / childrenSize : // : (height - titleHeight * layouts.length) / childrenSize;
        height / childrenSize;
        layouts.forEach(function (lay, index) {
          lay.calculatedZoom = (lay.parent ? lay.parent.calculatedZoom : 1) * (lay.zoom || 1);
          if (display === "tabs") {
            lay.height = height;
            lay.width = width;
            lay.visible = _this3.isVisible(layout.id, index);
          } else if (display === "flex") {
            lay.height = height;
            lay.width *= ratio;
          } else {
            lay.width = width;
            lay.height *= ratio;
          }
        });
        return layouts.map(function (child, index) {
          return _this3.buildLayout(child, layout, index, components);
        });
      }
    };
    if (content && typeof components[content].title === "function") {
      var title = components[content].title(height, width, layout.calculatedZoom);
      layout.title = title.title;
      layout.titleHeight = title.height;
    } else if (content) {
      layout.title = components[content].title;
    }
    var heightBody = height - (layout.titleHeight || titleHeight) - resizeHandleSize * (resizeH === null ? 0 : 1),
        widthBody = width - resizeHandleSize * (resizeV === null ? 0 : 1);
    var style = {
      display: "block",
      height: height,
      width: width
    };
    var getHeader = function getHeader(layouts, isTab, parentId) {
      return layouts.map(function (layout, index) {
        var id = isTab ? parentId + " - " + String(index) : layout.id;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2__ContextualMenu__["b" /* ContextualMenuClient */],
          {
            id: "layout-title: " + id,
            key: index,
            menu: "layout-menu",
            component: "layout",
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
              "zebulon-layout-header ": !isTab,
              "zebulon-layout-header-active ": !isTab && _this3.state.activeLayout === id,
              "zebulon-layout-tab": isTab,
              "zebulon-layout-tab-selected": isTab && layout.visible,
              "zebulon-layout-tab-selected-active": isTab && layout.visible && _this3.state.activeLayout === id
            }),
            draggable: _this3.state.layout.updatable,
            style: {
              textAlign: "center",
              width: widthBody / layouts.length,
              height: layout.titleHeight || titleHeight,
              userSelect: "none"
            },
            onClick: isTab ? function (e) {
              e.stopPropagation();
              // e.preventDefault();
              if (_this3.state.selectedTabs[layout.parent.id] !== index || _this3.state.activeLayout !== id) {
                _this3.setState({
                  selectedTabs: Object.assign({}, _this3.state.selectedTabs, _defineProperty({}, layout.parent.id, index)),
                  activeLayout: id
                });
              }
            } : function (e) {
              e.stopPropagation();
              // e.preventDefault();
              if (_this3.state.activeLayout !== id) {
                _this3.setState({
                  activeLayout: id
                });
              }
            }
          },
          layout.title
        );
      });
    };
    var header = void 0;
    if (layout.parent.display === "tabs" && !visible) {
      return null;
    } else if (layout.parent.display === "tabs") {
      header = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          id: "layout-titles: " + layout.parent.id,
          style: { display: "-webkit-box" }
        },
        getHeader(layout.parent.layouts, true, layout.parent.id)
      );
    } else {
      header = getHeader([layout], false);
    }
    var body = content && typeof components[content].component === "function" ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: "layout-component: " + layout.id,
        style: { position: "relative" }
      },
      components[content].component(heightBody, widthBody, layout.calculatedZoom, Object.assign({}, _this3.props, {
        keyEvent: _this3.state.keyEvent,
        isActive: _this3.state.activeLayout === layout.id
      }))
    ) : getChildren(layouts, heightBody, widthBody);
    if (!content && layouts.length === 0) {
      body = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ContextualMenu__["b" /* ContextualMenuClient */], {
        id: "layout-body: " + layout.id,
        key: index,
        menu: "layout-menu",
        component: "layout",
        style: { width: widthBody, height: heightBody }
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: "layout: " + layout.id,
        key: index,
        className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
          "zebulon-layout": true
          // "zebulon-layout-component": layout.id === "0"
        }),
        style: Object.assign({}, style, {
          display: "-webkit-box"
        })
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          style: {
            display: "block",
            width: widthBody,
            height: height - resizeHandleSize * (resizeH === null ? 0 : 1)
          }
        },
        header,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            id: "layout-body: " + layout.id,
            className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
              "zebulon-layout-body ": true
              // ,
              // "zebulon-layout-body-active ":
              //   this.state.activeLayout === layout.id
            }),
            style: {
              fontSize: (content ? layout.calculatedZoom : 1) * 100 + "%",
              display: display === "flex" ? "-webkit-box" : display,
              width: widthBody,
              height: heightBody
            },
            onClick: function onClick(e) {
              e.stopPropagation();
              if (_this3.state.activeLayout !== layout.id) {
                _this3.setState({ activeLayout: layout.id });
              }
            }
          },
          body
        ),
        resizeH
      ),
      resizeV
    );
  };

  this.remove = function (layout) {
    return layout.parent.layouts = layout.parent.layouts.slice(0, layout.index).concat(layout.parent.layouts.slice(layout.index + 1));
  };

  this.splitHorizontaly = function (layout) {
    layout.layouts = [{
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: [],
      parent: layout,
      content: null,
      title: "???"
    }, {
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: layout.layouts,
      parent: layout,
      content: layout.content,
      title: "???"
    }];
    layout.content = null;
    layout.layouts[1].layouts.forEach(function (lay) {
      return lay.parent = layout.layouts[1];
    });
  };

  this.splitVerticaly = function (layout) {
    layout.layouts = [{
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: [],
      parent: layout,
      content: null,
      title: "???"
    }, {
      height: 100,
      width: 100,
      display: layout.display,
      resizable: true,
      layouts: layout.layouts,
      content: layout.content,
      parent: layout,
      title: "???"
    }];
    layout.content = null;
    layout.layouts[1].layouts.forEach(function (lay) {
      return lay.parent = layout.layouts[1];
    });
  };

  this.removeSplit = function (layout) {
    if (layout.layouts.length === 1) {
      layout.layouts[0].parent = layout.parent;
      layout.title = layout.layouts[0].title;
      layout.content = layout.layouts[0].content;
      layout.layouts = layout.layouts[0].layouts;
    } else {
      layout.parent.content = layout.content;
      layout.parent.layouts = layout.layouts;
      layout.parent.display = layout.display;
    }
  };

  this.insertLayout = function (parent, layout, index) {
    _this3.remove(layout);
    layout.parent = parent;
    parent.layouts = parent.layouts.slice(0, index).concat([layout]).concat(parent.layouts.slice(index));
  };

  this.handleClickMenu = function (data, item) {
    var ids = _this3.getIds(data.id);
    // const root = ids.length === 1;
    var layout = _this3.getLayout(ids);
    if (item.id === 0) {
      _this3.remove(layout);
    } else if (item.id === 1) {
      layout.content = null;
      layout.layouts = [];
    } else if (item.id === 2) {
      _this3.removeSplit(layout);
    } else if (item.id === 3) {
      _this3.splitVerticaly(layout);
      layout.display = "flex";
    } else if (item.id === 4) {
      _this3.splitHorizontaly(layout);
      layout.display = "block";
    } else if (item.id === 5) {
      layout.display = layout.display === "flex" ? "block" : "-webkit-box";
    } else if (item.id >= 100) {
      layout.content = item.component;
    }
    _this3.setState({ layout: _this3.state.layout });
    // console.log("clickmenu", data, item, layout);
  };

  this.getMenu = function (menu, data) {
    var ids = _this3.getIds(data.id);
    // const root = ids.length === 1;
    var layout = _this3.getLayout(ids);
    var menus = [];
    var menuComponents = Object.keys(_this3.state.components).map(function (key, index) {
      return {
        id: 100 + index,
        type: "menu-item",
        separation: false,
        caption: "" + _this3.state.components[key].caption,
        component: _this3.state.components[key].id,
        onClick: _this3.handleClickMenu
      };
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      disable: layout.id === "0" || !layout.content && layout.layouts.length === 0 && !data.id.startsWith("layout-title"),
      separation: false,
      caption: "Remove",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      disable: layout.content === null && layout.layouts.length === 0,
      caption: "Remove content",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      disable: !layout.parent || layout.layouts.length > 1 && layout.parent.layouts > 1 || layout.content || !layout.content && layout.layouts.length === 0,
      caption: "Remove split",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: menus.length > 0,
      caption: "Split verticaly",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      caption: "Split horizontaly",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "menu-item",
      separation: false,
      caption: "Transpose",
      onClick: _this3.handleClickMenu
    });
    menus.push({
      id: menus.length,
      type: "sub-menu",
      separation: menus.length > 0,
      disable: !layout.content && layout.layouts.length === 0,
      caption: "Rename",
      children: [{
        id: 100,
        type: "jsx",
        navigation: false,
        // caption: "Filter",
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Input__["a" /* Input */], {
          key: 100,
          id: "menuRename",
          hasFocus: true,
          dataType: "string",
          value: layout.title,
          editable: true,
          style: { textAlign: "left" },
          onChange: function onChange(e) {
            layout.title = e;
            _this3.setState({ layout: _this3.state.layout });
          }
        })
      }]
    });
    menus.push({
      id: menus.length,
      type: "sub-menu",
      separation: menus.length > 0,
      disable: !(layout.content === null && layout.layouts.length === 0),
      caption: "Add component",
      children: menuComponents
    });
    if (menus.length) {
      return {
        type: "menu",
        position: "bottom",
        children: menus
      };
    } else {
      return null;
    }
  };

  this.handleDragStart = function (e, type) {
    if (_this3.contextualMenu) {
      _this3.contextualMenu.close();
    }
    // this.dragMessage = { type, index: e.target.id, x: e.pageX };
    _this3.pageX = e.pageX;
    _this3.pageY = e.pageY;
    // this.pageXStart = e.pageX;
    // this.pageYStart = e.pageY;
    e.dataTransfer.setData("text", e.target.id);
    _this3.dragId = e.target.id;
    if (e.target.id.startsWith("layout-resize-handle")) {
      var ids = _this3.getIds(e.target.id);
      var layout = _this3.getLayout(ids);
      _this3.layout = layout;
      var length = "layout-resize-handle".length;
      _this3.dragDirection = e.target.id.slice(length, length + 2) === "-V" ? "vertical" : "horizontal";
      // const rect = document
      //   .getElementById("layout: " + e.target.id.slice(length + 4))
      //   .getBoundingClientRect();
      // const dragRect = this.dragLayer.getBoundingClientRect();
      // const dragPreviewStyle = {
      //   position: "relative",
      //   backgroundColor: "red"
      // };
      // let x, y;
      // if (this.dragDirection === "vertical") {
      //   dragPreviewStyle.height = rect.height;
      //   dragPreviewStyle.width = 4;
      //   dragPreviewStyle.top = rect.top - dragRect.top;
      //   dragPreviewStyle.left = rect.left - dragRect.left + rect.width - 4;
      // } else {
      //   dragPreviewStyle.height = 4;
      //   dragPreviewStyle.width = rect.width;
      //   dragPreviewStyle.top = rect.top - dragRect.top + rect.height - 4;
      //   dragPreviewStyle.left = rect.left - dragRect.left;
      // }
      // this.dragPreviewStyle = dragPreviewStyle;
      // e.dataTransfer.setDragImage(this.preview, 0, 0);
      // this.setState({ dragPreviewStyle });
    }
    // e.stopPropagation();
    // console.log(
    //   "dragstart",
    //   e.pageX,
    //   e.pageY,
    //   e.dataTransfer.getData("text"),
    //   e.target,
    //   e.clientOffset
    // );
  };

  this.handleDragOver = function (e) {
    if (_this3.dragId) {
      if (_this3.dragId.startsWith("layout-resize-handle") && _this3.state.layout.resizable) {
        e.preventDefault();
        // e.stopPropagation();
        var dragPreviewStyle = Object.assign({}, _this3.dragPreviewStyle);
        if (_this3.dragDirection === "vertical") {
          dragPreviewStyle.left += e.pageX - _this3.pageX;
        } else {
          dragPreviewStyle.top += e.pageY - _this3.pageY;
        }
      } else if (_this3.dragId.startsWith("layout-title") && _this3.state.layout.updatable && (!e.target.id.startsWith("layout-title") || _this3.getLayout(_this3.getIds(e.target.id)).parent.display === "tabs")) {
        // you cant drop a header on a child
        var component = _this3.getParent(e.target, "layout-component");
        if (_this3.getParent(component || e.target, _this3.dragId.replace("-title", "")) === null) {
          e.preventDefault();
        }
      }
    }
  };

  this.handleDrop = function (e) {
    // console.log("drop", id, e.pageX, e.pageY, e.target);
    if (_this3.dragId) {
      e.preventDefault();
      var id = e.dataTransfer.getData("text");
      if (id.startsWith("layout-resize-handle")) {
        var length = "layout-resize-handle".length;
        var ids = _this3.getIds(id); //id.slice(length + 4).split(" - ");
        var root = ids.length === 1;
        var lastIndex = Number(ids.pop());
        var direction = id.slice(length, length + 2) === "-V" ? "vertical" : "horizontal";
        var delta = 0;
        var layout = _this3.getLayout(ids);
        if (root) {
          if (direction === "horizontal") {
            delta = e.pageY - _this3.pageY;
            layout.height += delta;
          } else {
            delta = e.pageX - _this3.pageX;
            layout.width += delta;
          }
        } else {
          if (direction === "horizontal") {
            delta = e.pageY - _this3.pageY;
            layout.layouts[lastIndex].height += delta;
            layout.layouts[lastIndex + 1].height -= delta;
          } else {
            delta = e.pageX - _this3.pageX;
            layout.layouts[lastIndex].width += delta;
            layout.layouts[lastIndex + 1].width -= delta;
          }
        }
        _this3.setState({ layout: _this3.state.layout });
      } else if (id.startsWith("layout-title")) {
        var body = e.target.id.startsWith("layout-title") ? e.target : _this3.getParent(e.target, "layout-body");
        if (body !== null) {
          var dropIds = _this3.getIds(body.id);
          var dropIndex = dropIds[dropIds.length - 1];
          var dragIds = _this3.getIds(id);
          var dropLayout = _this3.getLayout(dropIds);
          var dragLayout = _this3.getLayout(dragIds);
          var rect = void 0;
          if (dropLayout.content === null && dropLayout.layouts.length === 0) {
            dropLayout.title = dragLayout.title;
            dropLayout.content = dragLayout.content;
            dropLayout.layouts = dragLayout.layouts;
            _this3.remove(dragLayout);
          } else {
            // const element = document.getElementById(body);
            rect = body.getBoundingClientRect();
            var top = e.clientY - rect.top < rect.height / 2;
            var left = e.clientX - rect.left < rect.width / 2;

            if (dropLayout.content !== null || dropLayout.parent.display === "tabs") {
              if (dropLayout.parent.display === "block" || dropLayout.parent.display === "tabs") {
                _this3.insertLayout(dropLayout.parent, dragLayout, dropIndex + !top);
              } else if (dropLayout.parent.display === "flex") {
                _this3.insertLayout(dropLayout.parent, dragLayout, dropIndex + !left);
              }
            }
          }
          _this3.setState({ layout: _this3.state.layout });
          // console.log(
          //   "dropbody",
          //   body,
          //   e.pageX,
          //   e.pageY,
          //   rect,
          //   dragIds,
          //   dropIds,
          //   e.target
          // );
        }
      }
      _this3.dragId = null;
    }
  };

  this.computeLayout = function (layout, active) {
    return _this3.buildLayout(layout, null, 0, _this3.state.components);
  };
};

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_zebulon_controls__ = __webpack_require__(1);
var mapStateToProps=function mapStateToProps(){return function(state,ownProps){return Object.assign({items:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["q" /* getDimensionValuesSelector */])(state)(ownProps.dimensionId),filter:(state.filters[ownProps.dimensionId]||{}).values||{}},ownProps);};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return Object.assign({onOk:function onOk(filter){if(!filter){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["deleteFilter"])(ownProps.dimensionId));}else{dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions__["addFilter"])(ownProps.dimensionId,"in",null,false,filter));}}},ownProps);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_zebulon_controls__["d" /* Filter */]));

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRowHeadersSelector */
/* unused harmony export getColumnHeadersSelector */
/* unused harmony export pushedDataSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rowAndColumnHeadersSelector; });
/* unused harmony export getRowsCollapsedSelector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return previewSizesSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axis_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dimensions_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cellSizes_selector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sizes_selector__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_selector__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(2);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}///////////////////////////////////////////////////////////////////
//  compute the header trees (rows and columns) with positions ans sizes...
///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
// headers
//////////////////////////////////////////////////////////////////
var parentsSizes=function parentsSizes(header,main,crossPositions,collapsedSizes,affix,cellsKey,rowCells,dimensions,measuresCount,direction,isCollapsibleAttribute){if(!header||header.id===__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* ROOT_ID */]&&!header.isTotal){return null;}// et main = mainSizes;
var first=cellsKey[header.key]===undefined;if(first){var dimension=dimensions[header.depth];header.format=dimension.format;header.sizes={main:Object.assign({},main),cross:Object.assign({},crossPositions[dimension.id])};header.options={isCollapsibleAttribute:header.isAttribute&&header.depth<getLastDimension(dimensions)&&(isCollapsibleAttribute||header.orderedChildren.length>1),isNotCollapsible:(header.isAttribute||header.depth>=getLastDimension(dimensions)||header.orderedChildren.length<2)&&!isCollapsibleAttribute,isAffixManaged:false,isDropTarget:false};cellsKey[header.key]=true;}else{header.sizes.main.size+=main.size;if(direction===-1){header.sizes.main.position-=main.size;}}header.sizes.affix=header.nVisibles===1?0:affix;if(header.parent&&(header.parent.id!==__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* ROOT_ID */]||header.parent.isTotal)){parentsSizes(header.parent,main,crossPositions,collapsedSizes,affix,cellsKey,rowCells,dimensions,measuresCount,direction,header.options.isCollapsibleAttribute);}if(first){if(dimensions[header.depth].isVisible&&(!header.isParentCollapsed||header.parent.id===__WEBPACK_IMPORTED_MODULE_7__constants__["q" /* ROOT_ID */])){rowCells.push(header);}if(header.isCollapsed&&(header.type===__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* HeaderType */].GRAND_TOTAL||header.type===__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* HeaderType */].SUB_TOTAL)){header.sizes.cross.collapsed=crossPositions[__WEBPACK_IMPORTED_MODULE_7__constants__["m" /* MEASURE_ID */]].position-header.sizes.cross.size;header.sizes.cross.size=crossPositions[__WEBPACK_IMPORTED_MODULE_7__constants__["m" /* MEASURE_ID */]].position;}else if(header.isCollapsed){header.sizes.cross.collapsed=collapsedSizes[header.depth];header.sizes.cross.size+=collapsedSizes[header.depth];}if(header.isParentCollapsed){header.dataIndexes=header.parent.dataIndexes;}else{header.dataIndexes=header.filteredIndexes;}}return header.rootIndex;};var getLastDimension=function getLastDimension(dimensions){return dimensions.length-1-((dimensions[dimensions.length-1]||{}).id===__WEBPACK_IMPORTED_MODULE_7__constants__["m" /* MEASURE_ID */]);};var getCrossHeadersSize=function getCrossHeadersSize(dimensions,crossPositions){var lastDimension=getLastDimension(dimensions);if(lastDimension===-1){return 0;}var last=crossPositions[dimensions[lastDimension].id];return last.position+last.size;};var getCollapsedSizes=function getCollapsedSizes(dimensions,crossPositions){// pre compute collapses size
var collapsedSizes=[];var collapsedSize=0,isPrevAttribute=false,size=void 0;for(var index=getLastDimension(dimensions);index>=0;index--){if(isPrevAttribute){collapsedSizes.push(0);}else{collapsedSizes.push(collapsedSize);}size=crossPositions[dimensions[index].id].size;// headerSizes({ index: [index] });
collapsedSize+=size;isPrevAttribute=dimensions[index].isAttribute&&dimensions[index].isVisible;}collapsedSizes.reverse();return collapsedSizes;};var buildPositionedHeaders=function buildPositionedHeaders(headerSizes,crossPositions,containerSize,crossSize,dimensions,measures,nVisibles,leaves,scroll){// if (!leaves.length) {
//   return undefined;
// }
// const x = Date.now();
var maxSize=containerSize-crossSize;var size=0,depth=0;var measuresCount=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNull(measures)?1:Object.keys(measures).length||1;// no dimension is on the axis ==> Total header
var cellsKey={};var collapsedSizes=getCollapsedSizes(dimensions,crossPositions);var cells=[];// Loop on leaves
if(scroll.index>=leaves.length){scroll.index=leaves.length-1;scroll.direction=-1;}else if(scroll.index===-1&&leaves.length){scroll.index=0;scroll.direction=1;}var index=scroll.index;var ix=0;var lastSize=void 0;var crossHeadersSize=getCrossHeadersSize(dimensions,crossPositions);while(size<=maxSize&&index<leaves.length&&index>=0){var header=leaves[index];var dimension=dimensions[header.depth];header.format=dimension.format||function(_ref){var value=_ref.value;return value;};header.index=index;if(header.isVisible){var rowCells=[];var mainSize=headerSizes(header.key);header.sizes={main:{size:mainSize,position:scroll.direction===1?size:maxSize-size-mainSize},cross:Object.assign({},crossPositions[dimension.id])};// grand total and subtotals
if(header.isCollapsed// ||
// (header.dimensionId === MEASURE_ID &&
//   (header.parent.type === HeaderType.GRAND_TOTAL ||
//     header.parent.type === HeaderType.SUB_TOTAL))
){header.sizes.cross.collapsed=crossHeadersSize-header.sizes.cross.position-header.sizes.cross.size;header.sizes.cross.size=crossHeadersSize-header.sizes.cross.position;}else if(header.dimensionId===__WEBPACK_IMPORTED_MODULE_7__constants__["m" /* MEASURE_ID */]&&(header.parent.type===__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* HeaderType */].GRAND_TOTAL||header.parent.type===__WEBPACK_IMPORTED_MODULE_7__constants__["j" /* HeaderType */].SUB_TOTAL)){header.sizes.cross.position=crossHeadersSize;// console.log("sizes", header.sizes);
}parentsSizes(header.parent,header.sizes.main,crossPositions,collapsedSizes,scroll.direction===1?false:size+mainSize>maxSize,cellsKey,rowCells,dimensions,measuresCount,scroll.direction,false);if(header.isTotal&&header.dimensionId===__WEBPACK_IMPORTED_MODULE_7__constants__["m" /* MEASURE_ID */]){header.sizes.cross.position+=collapsedSizes[header.parent.depth];}header.options={isNotCollapsible:true,isAffixManaged:false,isDropTarget:(dimension.id===__WEBPACK_IMPORTED_MODULE_7__constants__["m" /* MEASURE_ID */]||dimension.id===__WEBPACK_IMPORTED_MODULE_7__constants__["C" /* TOTAL_ID */])&&(header.depth===0||measuresCount>1)};if(header.isParentCollapsed){header.dataIndexes=header.parent.dataIndexes;}else{header.dataIndexes=header.filteredIndexes;}lastSize=header.sizes.main.size;if(dimension.isVisible){rowCells.push(header);}if(rowCells.length){rowCells.reverse();cells.push(rowCells);size+=header.sizes.main.size;ix++;}}index+=scroll.direction;}index-=scroll.direction;// index = Math.min(Math.max(index, 0), leaves.length - 1);
// when height(or width) increase and the grid is scrolled, it may not rest enough cells to feed the grid
if(size<maxSize&&(Math.max(index,scroll.index)<leaves.length-1||Math.min(index,scroll.index)>0)){scroll.index=leaves.length-1;scroll.direction=-1;return buildPositionedHeaders(headerSizes,crossPositions,containerSize,crossSize,dimensions,measures,nVisibles,leaves,scroll);}// console.log("buildPositionedHeaders", Date.now() - x, scroll, cells);
var hasScrollbar=ix<nVisibles||size>maxSize;if(measuresCount>1){// console.log(
//   "selector",
//   scroll.direction,
//   (scroll.direction === 1 ? scroll.index : index + (size > maxSize)) /
//     leaves.length
// );
}return{size:Math.min(maxSize,size),containerSize:containerSize,crossSize:crossSize,lastSize:lastSize,affix:scroll.direction===1?0:Math.max(size-maxSize,0),depth:depth+1,cells:cells,index:scroll.index,direction:scroll.direction,startIndex:scroll.direction===1?scroll.index:index,stopIndex:scroll.direction===-1?scroll.index:index,// incompleteIndex=size===Math.min(maxSize, size)
length:leaves.length,leaves:leaves,// headers,
nVisibles:nVisibles,hasScrollbar:hasScrollbar,// displayedRatio: (ix - (size > maxSize)) / nVisibles,
displayedRatio:cells.length-(size>maxSize)===nVisibles?maxSize/Math.min(maxSize,size):(cells.length-(size>maxSize))/nVisibles,positionRatio:(scroll.direction===1?scroll.index:index+(size>maxSize))/leaves.length,scroll:scroll};};var getRowHeadersSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4__cellSizes_selector__["e" /* getCellHeightByKeySelector */],__WEBPACK_IMPORTED_MODULE_4__cellSizes_selector__["a" /* crossColumnPositionsSelector */],function(state){return state.configuration.height;},__WEBPACK_IMPORTED_MODULE_5__sizes_selector__["a" /* columnHeadersHeightSelector */],__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["i" /* rowVisibleDimensionsSelector */],Object(__WEBPACK_IMPORTED_MODULE_2__axis_selector__["d" /* getAxisActivatedMeasuresSelector */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* AxisType */].ROWS),function(state){return state.status.refreshDisplay;}],function(headerSizes,crossPositions,containerSize,crossSize,dimensions,measures,forceRefresh){return function(leaves,scroll){return buildPositionedHeaders(headerSizes,crossPositions,containerSize,crossSize,dimensions,measures,leaves.node.nVisibles,leaves.leaves,scroll);};});var getColumnHeadersSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_4__cellSizes_selector__["f" /* getCellWidthByKeySelector */],__WEBPACK_IMPORTED_MODULE_4__cellSizes_selector__["c" /* crossRowPositionsSelector */],function(state){return state.configuration.width;},__WEBPACK_IMPORTED_MODULE_5__sizes_selector__["b" /* rowHeadersWidthSelector */],__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["e" /* columnVisibleDimensionsSelector */],Object(__WEBPACK_IMPORTED_MODULE_2__axis_selector__["d" /* getAxisActivatedMeasuresSelector */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* AxisType */].COLUMNS),function(state){return state.status.refreshDisplay;}],function(headerSizes,crossPositions,containerSize,crossSize,dimensions,measures,forceRefresh){return function(leaves,scroll){return buildPositionedHeaders(headerSizes,crossPositions,containerSize,crossSize,dimensions,measures,leaves.node.nVisibles,leaves.leaves,scroll);};});var combineRowsAndColumns=function combineRowsAndColumns(rows,columns){// console.log(rows, columns);
if(rows.hasScrollbar&&!columns.hasScrollbar||!rows.hasScrollbar&&columns.hasScrollbar){if(rows.hasScrollbar&&columns.size+__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* ScrollbarSize */]>columns.containerSize-columns.crossSize){columns.hasScrollbar=true;}else if(columns.hasScrollbar&&rows.size+__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* ScrollbarSize */]>rows.containerSize-rows.crossSize){rows.hasScrollbar=true;}}columns.offset=rows.hasScrollbar?columns.scroll.direction===1?0:__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* ScrollbarSize */]:0;rows.offset=columns.hasScrollbar?rows.scroll.direction===1?0:__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* ScrollbarSize */]:0;};var pushedDataSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.data;},__WEBPACK_IMPORTED_MODULE_2__axis_selector__["f" /* getAxisTreesSelector */],__WEBPACK_IMPORTED_MODULE_2__axis_selector__["h" /* rowLeavesSelector */],__WEBPACK_IMPORTED_MODULE_2__axis_selector__["b" /* columnLeavesSelector */],function(state){return state.dimensions;},function(state){return state.axis;},Object(__WEBPACK_IMPORTED_MODULE_2__axis_selector__["d" /* getAxisActivatedMeasuresSelector */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* AxisType */].ROWS),Object(__WEBPACK_IMPORTED_MODULE_2__axis_selector__["d" /* getAxisActivatedMeasuresSelector */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* AxisType */].COLUMNS),function(state){return state.collapses;},function(state){return state.subtotals;},function(state){return state.configuration.totalsFirst;},__WEBPACK_IMPORTED_MODULE_6__data_selector__["b" /* filteredIndexesSelector */],__WEBPACK_IMPORTED_MODULE_6__data_selector__["d" /* notVisibleFiltersSelector */]],function(data,axisTrees,rowLeaves,columnLeaves,dimensions,axises,rowMeasures,columnMeasures,collapses,subtotals,totalsFirst,filteredIndexes,filters){var _data$data;if(!data.pushedData.length){return{rows:rowLeaves,columns:columnLeaves};}// build the axis trees only for new data using the previous root
// nodes of the intial root will be completed
var newAxisTrees=Object(__WEBPACK_IMPORTED_MODULE_2__axis_selector__["a" /* buildAxisTrees */])(axisTrees.rows,axisTrees.columns,data.pushedData,axisTrees.dimensions,data.data.length);// filtered indexes must be completed when filters are applied on not displayed dimensions
if(filters.length){Object(__WEBPACK_IMPORTED_MODULE_6__data_selector__["a" /* dataFilteredIndexes */])(data,filters,dimensions,filteredIndexes,data.data.length);}// when new dimension key appears, axis leaves must be rebuild
var leaves=void 0,axisDimensions=void 0;if(newAxisTrees.newRows){leaves=[];axisDimensions=axises.rows.map(function(axis){return dimensions[axis];});Object(__WEBPACK_IMPORTED_MODULE_2__axis_selector__["e" /* getAxisLeaves */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* AxisType */].ROWS,axisTrees.rows,axisDimensions,rowMeasures,rowMeasures===null?1:rowMeasures.length,collapses.rows,subtotals,totalsFirst,filteredIndexes,true,leaves);rowLeaves.leaves=leaves;}// when new dimension key appears, axis leaves must be rebuild
if(newAxisTrees.newColumns){leaves=[];axisDimensions=axises.columns.map(function(axis){return dimensions[axis];});Object(__WEBPACK_IMPORTED_MODULE_2__axis_selector__["e" /* getAxisLeaves */])(__WEBPACK_IMPORTED_MODULE_7__constants__["b" /* AxisType */].COLUMNS,axisTrees.columns,axisDimensions,columnMeasures,columnMeasures===null?1:columnMeasures.length,collapses.columns,subtotals,totalsFirst,filteredIndexes,true,leaves);columnLeaves.leaves=leaves;}(_data$data=data.data).push.apply(_data$data,_toConsumableArray(data.pushedData));data.pushedData=[];return{rows:rowLeaves,columns:columnLeaves};});var rowAndColumnHeadersSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([pushedDataSelector,getRowHeadersSelector,function(state){return state.selectedRange.scrollToRow;},getColumnHeadersSelector,function(state){return state.selectedRange.scrollToColumn;},function(state){return state.status.loadingConfig;}],function(rowAndColumnLeaves,getRowHeaders,scrollToRow,getColumnHeaders,scrollToColumn,loadingConfig){var rows=void 0,columns=void 0;console.log("rowAndColumnHeadersSelector");if(!(loadingConfig||__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(rowAndColumnLeaves.rows.node)||__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(rowAndColumnLeaves.columns.node))){rows=getRowHeaders(rowAndColumnLeaves.rows,scrollToRow);columns=getColumnHeaders(rowAndColumnLeaves.columns,scrollToColumn);if(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(rows)||__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(rows)){return{rows:rows,columns:columns};}combineRowsAndColumns(rows,columns);// corrections of display aberations
var change=false;if(columns.direction===-1&&columns.cells.length&&columns.cells[columns.cells.length-1][0].sizes.main.position-columns.offset>0){scrollToColumn.index=0;scrollToColumn.direction=1;columns=getColumnHeaders(rowAndColumnLeaves.columns,scrollToColumn);change=true;}if(rows.direction===-1&&rows.cells.length&&rows.cells[rows.cells.length-1][0].sizes.main.position-rows.offset>0){scrollToRow.index=0;scrollToRow.direction=1;rows=getRowHeaders(rowAndColumnLeaves.rows,scrollToRow);change=true;}if(change){combineRowsAndColumns(rows,columns);}}return{rows:rows,columns:columns};});var getRowsCollapsedSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_2__axis_selector__["h" /* rowLeavesSelector */],function(state){return state.collapses.columns;}],function(leaves,areCollapsed){return function(maxSize,scroll){};});var previewSizesSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.configuration.height;},function(state){return state.configuration.width;},rowAndColumnHeadersSelector],function(height,width,rowsAndColumns){var rows=rowsAndColumns.rows,columns=rowsAndColumns.columns;// console.log(
//   height,
//   width,
//   columns.crossSize,
//   columns.size,
//   rows.crossSize,
//   rows.size
// );
return{height:Math.min(height-columns.hasScrollbar*__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* ScrollbarSize */],rows.size+rows.crossSize),width:Math.min(width-rows.hasScrollbar*__WEBPACK_IMPORTED_MODULE_7__constants__["z" /* ScrollbarSize */],columns.size+columns.crossSize)};});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getRowIndexFromKey */
/* unused harmony export getColumnIndexFromKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSelectedColumnRangeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSelectedRowRangeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return selectedRangeSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getElementsSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copySelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return exportSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pasteSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__axis_selector__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cell_selector__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dimensions_selector__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_headers__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_copyService__ = __webpack_require__(57);
var getIndexfromKey=function getIndexfromKey(leaves,key){return leaves.leaves.findIndex(function(leaf){return leaf.key===key;});};var getRowIndexFromKey=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1__axis_selector__["h" /* rowLeavesSelector */]],function(leaves){return function(key){return getIndexfromKey(leaves,key);};});var getColumnIndexFromKey=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1__axis_selector__["b" /* columnLeavesSelector */]],function(leaves){return function(key){return getIndexfromKey(leaves,key);};});var getSelectedColumnRangeSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getColumnIndexFromKey,__WEBPACK_IMPORTED_MODULE_1__axis_selector__["h" /* rowLeavesSelector */]],function(getColumnIndexFromKey,rowLeaves){return function(header){var columnLeaves=Object(__WEBPACK_IMPORTED_MODULE_4__utils_headers__["a" /* getLeaves */])(header);var startIndex=getColumnIndexFromKey(columnLeaves[0].key);var stopIndex=startIndex+columnLeaves.length-1;return{start:{columns:startIndex,rows:0},end:{columns:stopIndex,rows:rowLeaves.leaves.length-1}};};});var getSelectedRowRangeSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getRowIndexFromKey,__WEBPACK_IMPORTED_MODULE_1__axis_selector__["b" /* columnLeavesSelector */]],function(getRowIndexFromKey,columnLeaves){return function(header){var rowLeaves=Object(__WEBPACK_IMPORTED_MODULE_4__utils_headers__["a" /* getLeaves */])(header);var startIndex=getRowIndexFromKey(rowLeaves[0].key);var stopIndex=startIndex+rowLeaves.length-1;return{start:{columns:0,rows:startIndex},end:{columns:columnLeaves.leaves.length-1,rows:stopIndex}};};});var selectedRangeSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function(state){return state.selectedRange;}],function(selectedRange){return selectedRange;});var getElementsSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1__axis_selector__["h" /* rowLeavesSelector */],__WEBPACK_IMPORTED_MODULE_1__axis_selector__["b" /* columnLeavesSelector */],__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["i" /* rowVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["e" /* columnVisibleDimensionsSelector */],__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["a" /* activatedMeasuresSelector */],__WEBPACK_IMPORTED_MODULE_2__cell_selector__["d" /* getCellValueSelector */],__WEBPACK_IMPORTED_MODULE_2__cell_selector__["b" /* getCellDimensionInfosSelector */],function(state){return state.configuration.measureHeadersAxis;}],function(rowLeaves,columnLeaves,rowDimensions,columnDimensions,measures,getCellValue,getCellDimensionInfos,measureHeadersAxis){return function(range){return Object(__WEBPACK_IMPORTED_MODULE_5__services_copyService__["d" /* getSelectedElements */])({range:range,columnLeaves:columnLeaves,rowLeaves:rowLeaves,rowDimensions:rowDimensions.filter(function(row){return row.isVisible;}),columnDimensions:columnDimensions.filter(function(column){return column.isVisible;}),measures:measures,getCellValue:getCellValue,getCellDimensionInfos:getCellDimensionInfos,measureHeadersAxis:measureHeadersAxis});};});var copySelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getElementsSelector],function(getElements){return function(range){return Object(__WEBPACK_IMPORTED_MODULE_5__services_copyService__["a" /* copy */])(Object(__WEBPACK_IMPORTED_MODULE_5__services_copyService__["e" /* getSelectedText */])(getElements(range)));};});var exportSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getElementsSelector],function(getElements){return function(range){return Object(__WEBPACK_IMPORTED_MODULE_5__services_copyService__["b" /* exportFile */])(Object(__WEBPACK_IMPORTED_MODULE_5__services_copyService__["e" /* getSelectedText */])(getElements(range),"csv"),"toto.csv");};});var pasteSelector=Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([__WEBPACK_IMPORTED_MODULE_1__axis_selector__["h" /* rowLeavesSelector */],__WEBPACK_IMPORTED_MODULE_1__axis_selector__["b" /* columnLeavesSelector */],__WEBPACK_IMPORTED_MODULE_3__dimensions_selector__["a" /* activatedMeasuresSelector */],__WEBPACK_IMPORTED_MODULE_2__cell_selector__["d" /* getCellValueSelector */],__WEBPACK_IMPORTED_MODULE_2__cell_selector__["a" /* buildDataSelector */]],function(rowLeaves,columnLeaves,measures,getCellValue,buidData){return function(clipboard,cell){return Object(__WEBPACK_IMPORTED_MODULE_5__services_copyService__["c" /* getElementsToPaste */])({rowLeaves:rowLeaves,columnLeaves:columnLeaves,measures:measures,getCellValue:getCellValue,buidData:buidData,clipboard:clipboard,cell:cell});};});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchFailure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyPushedData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchSuccess; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var fetchData=function fetchData(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_DATA */]};};var fetchFailure=function fetchFailure(error){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["h" /* FETCH_FAILURE */],error:error};};var validateData=function validateData(payload){// typeof null is 'object'...
var isObject=function isObject(obj){return(typeof obj==="undefined"?"undefined":_typeof(obj))==="object"&&obj!==null;};if(Array.isArray(payload)){if(Array.isArray(payload[0])||isObject(payload[0])){// Payload is an array of arrays of objects or an array of object
return payload;}}else if(isObject(payload)){return[payload];}// Invalid payload
return[];};var applyPushedData=function applyPushedData(pushedData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["p" /* PUSH_DATA */],pushedData:validateData(pushedData)};};var fetchSuccess=function fetchSuccess(data,meta){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["i" /* FETCH_SUCCESS */],data:validateData(data),meta:meta};};

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadingConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setDimensions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return setMeasures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setConfigurationProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return toggleMeasure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return moveMeasure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return moveDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return zoom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_configuration__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(2);
var loadingConfig=function loadingConfig(loading){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["l" /* LOADING_CONFIG */],loading:loading};};var setDimensions=function setDimensions(configObject,functions,utils_){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["w" /* SET_DIMENSIONS */],dimensions:configObject.dimensions.map(function(dimension){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_configuration__["e" /* dimensionFactory */])(dimension,functions,utils_);})};};var setMeasures=function setMeasures(configObject,functions,utils_){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["x" /* SET_MEASURES */],measures:configObject.measures.map(function(measure){return Object(__WEBPACK_IMPORTED_MODULE_0__utils_configuration__["f" /* measureFactory */])(measure,functions,utils_);})};};var setProperty=function setProperty(property,value){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_CONFIG_PROPERTY */],property:property,value:value};};var setConfigurationProperty=function setConfigurationProperty(configObject,property,defaultValue){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["v" /* SET_CONFIG_PROPERTY */],property:property,value:configObject[property]||defaultValue};};var toggleMeasure=function toggleMeasure(measureId){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["A" /* TOGGLE_MEASURE */],id:measureId};};var moveMeasure=function moveMeasure(measureId,position){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["o" /* MOVE_MEASURE */],id:measureId,position:position};};var moveDimension=function moveDimension(dimensionId,oldAxis,newAxis,position){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["n" /* MOVE_DIMENSION */],id:dimensionId,oldAxis:oldAxis,newAxis:newAxis,position:position};};var setAxis=function setAxis(axis){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["t" /* SET_AXIS */],axis:axis};};var zoom=function zoom(zoomValue){return{type:__WEBPACK_IMPORTED_MODULE_1__constants__["E" /* ZOOM */],zoomValue:zoomValue};};// export const zoomOut = () => ({ type: ZOOM_OUT });
// export const zoom = type => {
//   return { type };
// };

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateCellSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setSizes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_headers__ = __webpack_require__(24);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function calculateSize(size,ratio){return Math.max(size*ratio,10);}var getInitialSize=function getInitialSize(sizes,defaultSize,leaves){return leaves.reduce(function(size,leaf){return size+(sizes[leaf.key]||defaultSize);},0);};var updateCellSize=function updateCellSize(_ref){var handle=_ref.handle,offset=_ref.offset,initialOffset=_ref.initialOffset,defaultCellSizes=_ref.defaultCellSizes,sizes=_ref.sizes;var direction=void 0,ratio=void 0,initialSize=void 0,defaultSize=void 0,leaves=void 0,axisSizes=void 0;if(!__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(handle.header)){leaves=Object(__WEBPACK_IMPORTED_MODULE_2__utils_headers__["a" /* getLeaves */])(handle.header);}if(handle.position==="right"){direction="widths";axisSizes=sizes.widths;defaultSize=defaultCellSizes.width;initialSize=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(leaves)?axisSizes[handle.id]||defaultSize:getInitialSize(sizes.widths,defaultSize,leaves);ratio=(initialSize+offset.x-initialOffset.x)/initialSize;}else if(handle.position==="bottom"){direction="heights";axisSizes=sizes.heights;defaultSize=defaultCellSizes.height;initialSize=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(leaves)?axisSizes[handle.id]||defaultSize:getInitialSize(sizes.heights,defaultSize,leaves);ratio=(initialSize+offset.y-initialOffset.y)/initialSize;}var newSizes={};if(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(handle.header)){// Dimension size
newSizes=_defineProperty({},handle.id,calculateSize(initialSize,ratio));}else{// Header size
newSizes=leaves.reduce(function(acc,hdr){return Object.assign({},acc,_defineProperty({},hdr.key,calculateSize(axisSizes[hdr.key]||defaultSize,ratio)));},{});}return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["D" /* UPDATE_CELL_SIZE */],sizes:newSizes,direction:direction};};var setSizes=function setSizes(sizes){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["y" /* SET_SIZES */],sizes:sizes};};

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleSortOrder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
// import { toggleSortOrderSelector } from "../selectors";
var toggleSortOrder=function toggleSortOrder(axis,depth){// toggleSortOrderSelector(axis, depth);
return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_SORT_ORDER */],axis:Object(__WEBPACK_IMPORTED_MODULE_0__constants__["F" /* toAxis */])(axis)};};

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deleteFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
var addFilter=function addFilter(dimensionId,operator,term,exclude,values){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_FILTER */],filter:{dimensionId:dimensionId,operator:operator,term:term,exclude:exclude,values:values},dimension:dimensionId};};var deleteFilter=function deleteFilter(dimensionId){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DELETE_FILTER */],dimension:dimensionId};};

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return toggleCollapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expandCollapseAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleCollapseDimension; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCollapses; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
var toggleCollapse=function toggleCollapse(_ref){var axisType=_ref.axisType,key=_ref.key,n=_ref.n;return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPAND_COLLAPSE */],key:key,axis:Object(__WEBPACK_IMPORTED_MODULE_0__constants__["F" /* toAxis */])(axisType),n:n};};var expandCollapseAll=function expandCollapseAll(_ref2){var axisType=_ref2.axisType,keys=_ref2.keys,n=_ref2.n;return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPAND_COLLAPSE_ALL */],keys:keys,axis:Object(__WEBPACK_IMPORTED_MODULE_0__constants__["F" /* toAxis */])(axisType),n:n};};var toggleCollapseDimension=function toggleCollapseDimension(_ref3){var key=_ref3.key;return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPAND_COLLAPSE */],key:key,axis:"dimensions"};};var setCollapses=function setCollapses(collapses){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SET_COLLAPSES */],collapses:collapses};};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return selectRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return selectCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollToIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
var selectRange=function selectRange(selectedRange){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["s" /* SELECT_RANGE */],selectedRange:selectedRange};};var selectCell=function selectCell(cell){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["s" /* SELECT_RANGE */],selectedRange:{start:cell,end:cell}};};var scrollToIndex=function scrollToIndex(scrollToRow,scrollToColumn){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["r" /* SCROLL */],scrollToRow:scrollToRow,scrollToColumn:scrollToColumn};};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleSubTotal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
var toggleSubTotal=function toggleSubTotal(dimensionId){return{type:__WEBPACK_IMPORTED_MODULE_0__constants__["B" /* TOGGLE_SUBTOTAL */],dimensionId:dimensionId};};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DataCells_DataCells__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(6);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var mapStateToProps=function mapStateToProps(){return function(state,ownProps){var measures=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["a" /* activatedMeasuresSelector */])(state);var dimensions=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["j" /* dimensionsSelector */])(state);var getCellValue=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["p" /* getCellValueSelector */])(state);var selectedRange=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["C" /* selectedRangeSelector */])(state);var props=Object.assign({measures:measures,filters:state.filters,dimensions:dimensions,selectedRange:selectedRange,getCellValue:getCellValue,getCellInfos:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["o" /* getCellInfosSelector */])(state),getRangeInfos:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["u" /* getRangeInfosSelector */])(state),getGridInfos:function getGridInfos(){return Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["r" /* getElementsSelector */])(state)();},buildData:function buildData(rowLeaf,columnLeaf,oldValue,newValue,comment){return Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["d" /* buildDataSelector */])(state)(rowLeaf,columnLeaf,oldValue,newValue,comment);},// height: state.configuration.height,
// width: state.configuration.width,
configuration:state.configuration,status:state.status},ownProps);return props;};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{selectRange:function selectRange(selectedRange){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["selectRange"])(selectedRange));},selectCell:function selectCell(cell){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["selectCell"])(cell));},setConfigProperty:function setConfigProperty(prop,value){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["setConfigurationProperty"])(_defineProperty({},prop,value),prop));},editData:function editData(data){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["applyPushedData"])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_DataCells_DataCells__["a" /* DataCells */]));

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataCells; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DataCell_DataCell__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_copyService__ = __webpack_require__(57);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isInRange=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isInRange,isUndefined=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isUndefined;var AXIS_SEPARATOR=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].AXIS_SEPARATOR,HeaderType=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].HeaderType,AxisType=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].AxisType,toAxis=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].toAxis;var DataCells=function(_ScrollableGrid){_inherits(DataCells,_ScrollableGrid);// -------------------------------------
// life cycle
// -------------------------------------
function DataCells(props){_classCallCheck(this,DataCells);var _this=_possibleConstructorReturn(this,(DataCells.__proto__||Object.getPrototypeOf(DataCells)).call(this,props));_initialiseProps.call(_this);_this.cellCache={};_this.isPushing=0;_this.editable=_this.props.configuration.edition.editable&&_this.props.configuration.edition.activated;_this.commentsVisible=props.configuration.edition.comments;_this.comment=undefined;_this.state={toolTip:{style:{opacity:0,height:0,zIndex:0,padding:0},modal:false}};return _this;}_createClass(DataCells,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.isPushing&&!this.isEditing){this.isPushing=1+this.isPushing%2;}this.isEditing=false;if(nextProps.isPushing){console.log("isPushing",this.isPushing,this.cellCache,nextProps);}if(!nextProps.isPushing&&(nextProps.rows!==this.props.rows||nextProps.columns!==this.props.columns)){console.log("clearCache",nextProps);this.cellCache={};}if(this.editable&&(this.props.rows.leaves!==nextProps.rows.leaves||this.props.columns.leaves!==nextProps.columns.leaves||this.props.selectedRange.end.rows!==nextProps.selectedRange.end.rows||this.props.selectedRange.end.columns!==nextProps.selectedRange.end.columns)){if(this.oldValue!==this.newValue||this.comment){var _props$selectedRange$=this.props.selectedRange.end,rows=_props$selectedRange$.rows,columns=_props$selectedRange$.columns;this.editData(this.props.rows.leaves[rows],this.props.columns.leaves[columns]);}this.focusChanged=true;}this.focusChanged=this.focusChanged||nextProps.isPushing;this.editable=nextProps.configuration.edition.editable&&nextProps.configuration.edition.activated;this.commentsVisible=nextProps.configuration.edition.comments;}},{key:"componentDidMount",value:function componentDidMount(){this.props.getRef(this);}// -----------------------------------------------------------
// comments
// -----------------------------------------------------------
// -----------------------------------------------------------
// edition
// -----------------------------------------------------------
// ------------------------------------------------
// events
// ------------------------------------------------
// -----------------------------------------
// scrolling and selection
// -----------------------------------------
// -----------------------------------------
// rendering
// -----------------------------------------
}]);return DataCells;}(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["f" /* ScrollableGrid */]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.commentsClose=function(){_this2.comment=undefined;_this2.handleOnCommentOk();_this2.isMouseDown=false;};this.handleOnCommentOk=function(e){var toolTip={style:{opacity:0,height:0,zIndex:0,padding:0}};_this2.setState({toolTip:toolTip});_this2.props.setToolTip(toolTip);};this.handleOnCommentChange=function(e){_this2.comment=e.target.value;};this.handleComments=function(e){if(_this2.commentsVisible&&e.comments.length||e.editComment){var style=Object.assign({},e.style,{opacity:1,zIndex:3,height:"fit-content",width:"fit-content",position:"fixed",minHeight:30,top:e.y+e.style.height,left:e.x});var comment=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{style:{paddingLeft:20,maxWidth:300}},e.comments.map(function(comment,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index},comment.split("\n").map(function(comment,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index},comment);}));}));var modal=false;if(e.editComment){// style.autofocus = true;
comment=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"center",fontWeight:"bold"}},"Comments"),comment,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea",{rows:"10",cols:"50",id:"comment",tabIndex:0,autoFocus:true// value={this.comment}
,onChange:_this2.handleOnCommentChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{diplay:"flex"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{style:{marginRight:".5em"},onClick:_this2.handleOnCommentOk},"Ok"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{style:{marginRight:".5em"},onClick:_this2.commentsClose},"Cancel"));// this.isEditing = true;
modal=true;}var toolTip={comment:comment,style:style,modal:modal};_this2.setState({toolTip:toolTip});_this2.props.setToolTip(toolTip);}else if(_this2.state.toolTip.style.opacity===1&&!_this2.state.toolTip.modal){_this2.commentsClose();}};this.handleOnChange=function(value,key){_this2.newValue=value;_this2.cellCache[key].value=value;};this.editData=function(rowLeaf,columnLeaf){// const { rows, columns } = this.props;
var newValue=_this2.newValue,oldValue=_this2.oldValue,comment=_this2.comment;if(newValue!==oldValue||_this2.comment){var data=_this2.props.buildData(rowLeaf,columnLeaf,oldValue,newValue,comment);_this2.isEditing=true;_this2.props.editData([data]);if(_this2.props.configuration.callbacks.onEdit){}_this2.props.configuration.callbacks.onEdit(data);}_this2.comment=undefined;_this2.oldValue=_this2.newValue;if(_this2.state.toolTip.modal){_this2.commentsClose();}};this.handleMouseOver=function(e){if(!_this2.state.toolTip.modal){var columnIndex=e.columnIndex,rowIndex=e.rowIndex,button=e.button;if(_this2.isMouseDown&&button===0&&!e.openComment){if(!(_this2.props.selectedRange.end.columns===columnIndex&&_this2.props.selectedRange.end.rows===rowIndex)){_this2.props.selectRange({end:{columns:columnIndex,rows:rowIndex},focusedCell:{columns:columnIndex,rows:rowIndex}});}}else if(_this2.commentsVisible){_this2.handleComments(e);}else if(_this2.state.toolTip.style.opacity===1){_this2.commentsClose();}}};this.handleMouseDown=function(e){if(!e.defaultPrevented){_this2.onSelect(e);}};this.handleMouseUp=function(e){// console.log("mouse up", e.target);
_this2.isMouseDown=false;e.stopPropagation();};this.onSelect=function(e){// console.log(e);
var button=e.button,shiftKey=e.shiftKey,columnIndex=e.columnIndex,rowIndex=e.rowIndex,value=e.value;if(button===0){// check if cell value has changed
var focusedCell=_this2.props.selectedRange.end;if(_this2.editable&&(focusedCell.columns!==columnIndex||focusedCell.rows!==rowIndex)&&_this2.oldValue!==_this2.newValue){_this2.editData(_this2.props.rows.leaves[focusedCell.rows],_this2.props.columns.leaves[focusedCell.columns]);}_this2.isMouseDown=true;_this2.oldValue=value;_this2.newValue=value;if(shiftKey){_this2.props.selectRange({start:_this2.props.selectedRange.start,end:{columns:columnIndex,rows:rowIndex}});}else{// console.log("select", { columnIndex, rowIndex });
_this2.props.selectCell({columns:columnIndex,rows:rowIndex});}}};this.handleDoubleClick=function(cell){var keys=Object.keys(_this2.props.menuFunctions.dataCellFunctions);if(keys.length){var menuFunction=_this2.props.menuFunctions.dataCellFunctions[keys[0]].function;return menuFunction(_this2.props.getCellInfos(cell));}};this.collectMenu=function(props){return Object.assign({},props,{dimensions:_this2.props.dimensions,menuFunctions:_this2.props.menuFunctions,filters:_this2.props.filters,// zoom: this.props.zoom,
onItemClick:_this2.handleClickMenu,configuration:_this2.props.configuration});};this.handleClickMenu=function(type,fct,data){var menu=void 0;if(type==="Cell"){menu=_this2.props.menuFunctions.dataCellFunctions[fct].function(_this2.props.getCellInfos({columns:data.columnIndex,rows:data.rowIndex}));}else if(type==="Range"){menu=_this2.props.menuFunctions.rangeFunctions[fct].function(_this2.props.getRangeInfos(_this2.props.selectedRange));}else if(type==="Grid"){menu=_this2.props.menuFunctions.gridFunctions[fct].function({grid:_this2.props.getGridInfos(),toText:__WEBPACK_IMPORTED_MODULE_3__services_copyService__["e" /* getSelectedText */]});}else if(type==="Totals"){_this2.props.setConfigProperty("totalsFirst",data.value);}else if(type==="Edition"){_this2.props.setConfigProperty("edition",Object.assign({},_this2.props.configuration.edition,{activated:data.value}));}else if(type==="Comments"){_this2.props.setConfigProperty("edition",Object.assign({},_this2.props.configuration.edition,{comments:data.value}));}return menu;};this.selectedRange=function(){return _this2.props.selectedRange;};this.selectedCell=function(){return Object.assign({},_this2.props.selectedRange.end);};this.nextVisible=function(leaves,index,direction,offset){var ix=0,n=0;if(offset===0){ix=-direction;n=-1;}while(n<offset&&(direction===1?index+ix<leaves.length-1:index+ix>0)){ix+=direction;n+=leaves[index+ix].isVisible||0;}return index+ix;};this.lastIndex=function(axis,direction){var axisLeaves=axis===AxisType.COLUMNS?_this2.props.columns:_this2.props.rows;return _this2.nextVisible(axisLeaves.leaves,direction===1?axisLeaves.length-1:0,-direction,0);};this.nextIndex=function(axis,direction,index,offset){var axisLeaves=axis===AxisType.COLUMNS?_this2.props.columns:_this2.props.rows;return _this2.nextVisible(axisLeaves.leaves,index,direction,offset);};this.nextPageIndex=function(axis,direction,index){var axisLeaves=axis===AxisType.COLUMNS?_this2.props.columns:_this2.props.rows;return _this2.nextVisible(axisLeaves.leaves,index,direction,axisLeaves.cells.length-1);};this.scrollOnKey=function(cell,axis,direction,directionC,extension){var _props=_this2.props,rows=_props.rows,columns=_props.columns;var axisLeaves=axis===AxisType.COLUMNS?columns:rows;var scroll={rows:rows.scroll,columns:columns.scroll};if(axisLeaves.hasScrollbar&&(direction===1&&cell[toAxis(axis)]>=axisLeaves.stopIndex||direction===-1&&cell[toAxis(axis)]<=axisLeaves.startIndex)){scroll[toAxis(axis)]={index:cell[toAxis(axis)],direction:-direction};_this2.props.onScroll(scroll.rows,scroll.columns);}_this2.selectCell(cell,extension);};this.onWheel=function(e){if(!e.defaultPrevented){e.preventDefault();var _props2=_this2.props,rows=_props2.rows,columns=_props2.columns,onScroll=_props2.onScroll;var sense=e.altKey||e.deltaX!==0?"columns":"rows";var leaves=sense==="columns"?columns:rows;var direction=Math.sign(sense==="columns"?e.deltaX:e.deltaY);var prevIndex=direction===1?leaves.stopIndex:leaves.startIndex;var offset=leaves.direction===direction&&leaves.offset>2;var index=_this2.nextVisible(leaves.leaves,prevIndex-offset,direction,1);var scroll={rows:rows.scroll,columns:columns.scroll};if(sense==="columns"){scroll.columns={index:index,direction:-direction};}else{scroll.rows={index:index,direction:-direction};}onScroll(scroll.rows,scroll.columns);}};this.onScroll=function(axis,dir,dirC,cell,extension,positionRatio){var ix=cell?cell[toAxis(axis)]:null;var _props3=_this2.props,rows=_props3.rows,columns=_props3.columns,onScroll=_props3.onScroll;// if (e.type === "scrollbar") {
var scroll={rows:Object.assign({},rows.scroll),columns:Object.assign({},columns.scroll)};var direction=void 0,index=void 0;// if (e.initiator === "bar") {
if(axis===AxisType.COLUMNS){index=Math.round(columns.length*positionRatio);direction=Math.sign(_this2.props.columns.startIndex+(scroll.columns.direction===-1?1:0)-index);scroll.columns={index:direction===-1?Math.round(columns.length*(positionRatio+columns.displayedRatio)):index,direction:direction};}else{index=Math.round(rows.length*positionRatio);direction=Math.sign(_this2.props.rows.startIndex+(scroll.rows.direction===-1?1:0)-index);scroll.rows={index:direction===-1?Math.round(rows.length*(positionRatio+rows.displayedRatio)):index,direction:direction};}if(direction){onScroll(scroll.rows,scroll.columns);return true;}// }
return false;};this.cellRenderer=function(rowHeader,columnHeader,isEven,offsetRow,offsetColumn){var _props4=_this2.props,getCellValue=_props4.getCellValue,measures=_props4.measures,selectedRange=_props4.selectedRange,gridId=_props4.gridId,isPushing=_props4.isPushing;var key=""+rowHeader.key+AXIS_SEPARATOR+columnHeader.key;var style={position:"absolute",top:rowHeader.sizes.main.position-offsetRow,left:columnHeader.sizes.main.position-offsetColumn,height:rowHeader.sizes.main.size,width:columnHeader.sizes.main.size};var measure=void 0;if(rowHeader.type===HeaderType.MEASURE){measure=measures[rowHeader.id];}else{measure=measures[columnHeader.id];}// empty measure
if(isUndefined(measure)){measure={format:function format(v){return v;},valueAccessor:function valueAccessor(){return null;}};}var selected=false;if(selectedRange.start&&selectedRange.end){selected=isInRange({columns:columnHeader.index,rows:rowHeader.index},selectedRange.start,selectedRange.end);}var focused=false;if(selectedRange.end){focused=columnHeader.index===selectedRange.end.columns&&rowHeader.index===selectedRange.end.rows;}var valueHasChanged=void 0;var cell=_this2.cellCache[key]||{};if(cell.value===undefined||isPushing){var value=getCellValue(measure.valueAccessor,rowHeader.dataIndexes,columnHeader.dataIndexes,measure.aggregation,measure.id);valueHasChanged=_this2.props.isPushing*_this2.isPushing*(cell.value!==value.value);if(valueHasChanged){console.log("valueHasChanged",valueHasChanged);}cell.value=value.value;cell.edited=value.edited;cell.comments=value.comments;cell.caption=measure.format({value:cell.value});_this2.cellCache[key]=cell;}if(focused&&_this2.focusChanged){_this2.oldValue=cell.value;_this2.newValue=cell.value;_this2.focusChanged=false;}var highlighted=false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DataCell_DataCell__["a" /* default */],{headersKey:key,key:key,valueHasChanged:valueHasChanged,style:style,rowIndex:rowHeader.index,columnIndex:columnHeader.index,caption:cell.caption,value:cell.value,gridId:gridId,selected:selected,focused:focused,highlighted:highlighted,isTotal:Math.max(rowHeader.isTotal,columnHeader.isTotal||0),handleMouseDown:_this2.handleMouseDown,handleMouseOver:_this2.handleMouseOver,handleMouseUp:_this2.handleMouseUp,handleDoubleClick:_this2.handleDoubleClick,handleOnChange:_this2.handleOnChange,collectMenu:_this2.collectMenu,isEven:isEven,editable:_this2.editable,edited:cell.edited,comments:cell.comments,handleComments:_this2.handleComments});};this._getContent=function(){var _props5=_this2.props,rows=_props5.rows,columns=_props5.columns,status=_props5.status;if(rows===undefined||columns===undefined){return[];}_this2.positionRatios={vertical:rows.positionRatio,horizontal:columns.positionRatio};var cells=[];console.log("render",_this2.props.isPushing);rows.cells.forEach(function(row,rowIndex){return columns.cells.map(function(column,columnIndex){return cells.push(_this2.cellRenderer(row[0],column[0],!(rowIndex%2),rows.offset,columns.offset));});});return cells;};this.getRatios=function(props){var rows=props.rows,columns=props.columns;return{vertical:{display:rows.displayedRatio,position:rows.positionRatio,size:rows.size},horizontal:{display:columns.displayedRatio,position:columns.positionRatio,size:columns.size}};};};

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// console.log("ContextualMenuClient", ContextualMenuClient);
var DataCell=function(_PureComponent){_inherits(DataCell,_PureComponent);function DataCell(props){_classCallCheck(this,DataCell);var _this=_possibleConstructorReturn(this,(DataCell.__proto__||Object.getPrototypeOf(DataCell)).call(this,props));_this.collect=function(e){var button=e.button,shiftKey=e.shiftKey;var _this$props=_this.props,columnIndex=_this$props.columnIndex,rowIndex=_this$props.rowIndex,value=_this$props.value,edited=_this$props.edited,comments=_this$props.comments,style=_this$props.style,headersKey=_this$props.headersKey;var element=document.getElementById(rowIndex+" - "+columnIndex);var rect=element?element.getBoundingClientRect():{};// console.log(rect, rowIndex, columnIndex);
var left=rect.left,top=rect.top;return{type:"cell",button:button,shiftKey:shiftKey,columnIndex:columnIndex,rowIndex:rowIndex,headersKey:headersKey,value:value,edited:edited,comments:comments,style:style,left:left,top:top};};_this.handleComments=function(e){var event=_this.collect(e);event.editComment=true;_this.props.handleComments(event);};_this.handleMouseDown=function(e){_this.props.handleMouseDown(_this.collect(e));};_this.handleMouseOver=function(e){return _this.props.handleMouseOver(_this.collect(e));};_this.handleMouseUp=function(e){return _this.props.handleMouseUp(_this.collect(e));};_this.handleDoubleClick=function(e){var _this$props2=_this.props,columnIndex=_this$props2.columnIndex,rowIndex=_this$props2.rowIndex;_this.props.handleDoubleClick({columns:columnIndex,rows:rowIndex});};_this.handleOnChange=function(e){var newValue=e.target.value===""?null:isNaN(Number(e.target.value))?_this.state.value:Number(e.target.value);_this.setState({value:newValue});_this.props.handleOnChange(newValue,_this.props.headersKey);// console.log(
//   "changed",
//   this.props.rowIndex,
//   this.props.columnIndex,
//   e.target.value
// );
};_this.state={value:props.value};return _this;}_createClass(DataCell,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){this.setState({value:nextProps.value});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.focused&&!prevProps.focused){var element=document.getElementById("input "+this.props.rowIndex+" - "+this.props.columnIndex);if(element){element.focus();element.select();}}}},{key:"render",value:function render(){var _props=this.props,caption=_props.caption,rowIndex=_props.rowIndex,columnIndex=_props.columnIndex,selected=_props.selected,focused=_props.focused,valueHasChanged=_props.valueHasChanged,isTotal=_props.isTotal,collectMenu=_props.collectMenu,gridId=_props.gridId,isEven=_props.isEven,editable=_props.editable,edited=_props.edited,highlighted=_props.highlighted;var style={boxSizing:"border-box",overflow:"hidden"// cursor: loading ? "progress" : "default"
};var className=__WEBPACK_IMPORTED_MODULE_1_classnames___default()("zebulon-grid-cell","zebulon-grid-data-cell",{"zebulon-grid-data-cell-even":isEven,"zebulon-grid-data-cell-uneven":!isEven,"zebulon-grid-data-cell-selected":selected,"zebulon-grid-data-cell-focused":focused,"zebulon-grid-data-cell-total":isTotal===1,"zebulon-grid-data-cell-grandtotal":isTotal===2,"zebulon-grid-data-cell-changed":valueHasChanged===1,"zebulon-grid-data-cell-changed2":valueHasChanged===2,"zebulon-grid-data-cell-highlighted":highlighted,"zebulon-grid-data-cell-edited":edited});var cell=void 0;if(focused&&editable&&!isTotal){cell=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:rowIndex+" - "+columnIndex,style:Object.assign({},style,this.props.style,{display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{background:__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["i" /* icons */].rightArrow,backgroundSize:"cover",height:".8em",width:".8em",marginTop:"0.1em",marginRight:"0.1em",position:"absolute",zIndex:3},onClick:this.handleComments}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:className,style:{height:"-webkit-fill-available",width:"-webkit-fill-available",position:"absolute"},autoFocus:true,tabIndex:"0",id:"input "+rowIndex+" - "+columnIndex,value:this.state.value===null?"":this.state.value,onChange:this.handleOnChange,onMouseDown:this.handleMouseDown,onMouseUp:this.props.handleMouseUp,onDoubleClick:this.handleDoubleClick,onMouseOver:this.handleMouseOver,onDragStart:function onDragStart(e){return e.preventDefault();}}));}else{cell=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:className,id:rowIndex+" - "+columnIndex,style:Object.assign({},style,this.props.style),onMouseDown:this.handleMouseDown,onMouseUp:this.props.handleMouseUp,onDoubleClick:this.handleDoubleClick,onMouseOver:this.handleMouseOver},caption);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["c" /* ContextualMenuClient */],{menu:"grid-menu",id:"grid-menu-"+rowIndex+" - "+columnIndex// gridId={gridId}
,component:gridId,draggable:false,collect:function collect(){return collectMenu({rowIndex:rowIndex,columnIndex:columnIndex});}},cell);}}]);return DataCell;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (DataCell);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DimensionHeaders_DimensionHeaders__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_headers__ = __webpack_require__(24);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var mapStateToProps=function mapStateToProps(){return function(state,ownProps){var columnDimensions=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["f" /* columnVisibleDimensionsSelector */])(state);var rowDimensions=Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["B" /* rowVisibleDimensionsSelector */])(state);return{columnDimensions:columnDimensions,rowDimensions:rowDimensions,getExpandCollapseKeys:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["s" /* getExpandCollapseKeysSelector */])(state),filters:state.filters,availableDimensions:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["b" /* availableDimensionsSelector */])(state),crossPositions:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["h" /* crossPositionsSelector */])(state),height:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["e" /* columnHeadersHeightSelector */])(state),previewSizes:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["y" /* previewSizesSelector */])(state),width:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["A" /* rowHeadersWidthSelector */])(state),gridId:ownProps.gridId,sizes:state.sizes,features:state.configuration.features,toggleSort:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["D" /* toggleSortOrderSelector */])(state),getAxisTrees:Object(__WEBPACK_IMPORTED_MODULE_1__selectors__["n" /* getAxisTreesSelector */])(state),status:state.status};};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleCollapseDimension:function toggleCollapseDimension(key){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["toggleCollapseDimension"])({key:key}));},toggleSortOrder:function toggleSortOrder(axisType,depth){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["toggleSortOrder"])(axisType,depth));},expandCollapseAll:function expandCollapseAll(axisType,keys,n,measuresCount){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["expandCollapseAll"])({axisType:axisType,keys:keys,n:n,measuresCount:measuresCount}));},moveDimension:function moveDimension(dimensionId,oldAxis,newAxis,position){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["moveDimension"])(dimensionId,oldAxis,newAxis,position));},toggleSubTotal:function toggleSubTotal(dimensionId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["toggleSubTotal"])(dimensionId));}};};var mergeProps=function mergeProps(_ref,_ref2,ownProps){var _toggleSortOrder2=_ref2.toggleSortOrder,_moveDimension2=_ref2.moveDimension,restDispatchProps=_objectWithoutProperties(_ref2,["toggleSortOrder","moveDimension"]);var toggleSort=_ref.toggleSort,measures=_ref.measures,getAxisTrees=_ref.getAxisTrees,restStateProps=_objectWithoutProperties(_ref,["toggleSort","measures","getAxisTrees"]);return Object.assign({toggleSortOrder:function toggleSortOrder(axisType,depth){toggleSort(axisType,depth);_toggleSortOrder2(axisType,depth);},moveDimension:function moveDimension(dimensionId,oldAxis,newAxis,position){var rows=getAxisTrees.rows,columns=getAxisTrees.columns;Object(__WEBPACK_IMPORTED_MODULE_4__utils_headers__["c" /* resetLeaves */])(rows);Object(__WEBPACK_IMPORTED_MODULE_4__utils_headers__["c" /* resetLeaves */])(columns);return _moveDimension2(dimensionId,oldAxis,newAxis,position);}},restStateProps,restDispatchProps,ownProps);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_2__components_DimensionHeaders_DimensionHeaders__["a" /* default */]));

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DimensionHeader_DimensionHeader__ = __webpack_require__(319);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AxisType=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].AxisType,MEASURE_ID=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].MEASURE_ID,TOTAL_ID=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["h" /* constants */].TOTAL_ID;var isNullOrUndefined=__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined;var DimensionHeaders=function(_Component){_inherits(DimensionHeaders,_Component);function DimensionHeaders(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DimensionHeaders);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DimensionHeaders.__proto__||Object.getPrototypeOf(DimensionHeaders)).call.apply(_ref,[this].concat(args))),_this),_this.setCollapsibles=function(){var getAxisCollapsibles=function getAxisCollapsibles(dimensions){return dimensions.reduceRight(function(acc,dim,index){var res=void 0;if(dim.isAttribute||dim.id===MEASURE_ID){res=0;}else{res=Object.values(acc).some(function(el){return el>=1;})?2:1;}return Object.assign({},acc,_defineProperty({},dim.id,res));},{});};var columnCollapsibles=getAxisCollapsibles(_this.props.columnDimensions);var rowCollapsibles=getAxisCollapsibles(_this.props.rowDimensions);_this.collapsibles=Object.assign({},columnCollapsibles,rowCollapsibles);},_this.collectMenu=function(props){return Object.assign({},props,{availableDimensions:_this.props.availableDimensions,// direction: props.sortDirection === "asc" ? "descending" : "ascending",
dimensionFilter:_this.props.filters[props.dimension.id],isNotCollapsible:_this.collapsibles[props.dimension.id]<2,features:_this.props.features});},_this.headersRenderer=function(axis,dimensions,lastCrossDimensionId){var _this$props=_this.props,previewSizes=_this$props.previewSizes,gridId=_this$props.gridId,toggleCollapseDimension=_this$props.toggleCollapseDimension,moveDimension=_this$props.moveDimension,getExpandCollapseKeys=_this$props.getExpandCollapseKeys,expandCollapseAll=_this$props.expandCollapseAll,_toggleSortOrder=_this$props.toggleSortOrder,toggleSubTotal=_this$props.toggleSubTotal,crossPositions=_this$props.crossPositions,height=_this$props.height,width=_this$props.width,features=_this$props.features;var headers=[];dimensions.forEach(function(dimension,index){if(dimension.isVisible&&(dimension.id!==MEASURE_ID||lastCrossDimensionId===TOTAL_ID)){var positions=void 0;if(axis===AxisType.ROWS){positions={left:crossPositions[AxisType.ROWS][dimension.id].position,top:height-crossPositions[AxisType.COLUMNS][lastCrossDimensionId].size,width:crossPositions[AxisType.ROWS][dimension.id].size,height:crossPositions[AxisType.COLUMNS][lastCrossDimensionId].size};}else{positions={left:width-crossPositions[AxisType.ROWS][lastCrossDimensionId].size,top:crossPositions[AxisType.COLUMNS][dimension.id].position,width:crossPositions[AxisType.ROWS][lastCrossDimensionId].size,height:crossPositions[AxisType.COLUMNS][dimension.id].size};}headers.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DimensionHeader_DimensionHeader__["a" /* default */],{key:"dimension-header-"+dimension.id,positions:positions,dimension:dimension,crossDimensionId:lastCrossDimensionId,previewSizes:previewSizes,gridId:gridId,toggleCollapseDimension:toggleCollapseDimension,toggleSortOrder:function toggleSortOrder(){return _toggleSortOrder(axis,index);},moveDimension:moveDimension,toggleSubTotal:toggleSubTotal,getExpandCollapseKeys:getExpandCollapseKeys,expandCollapseAll:expandCollapseAll,collectMenu:_this.collectMenu,isFiltered:!isNullOrUndefined(_this.props.filters[dimension.id]),features:features}));}});return headers;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DimensionHeaders,[{key:"componentDidMount",value:function componentDidMount(){this.setCollapsibles();}},{key:"componentDidUpdate",value:function componentDidUpdate(){this.setCollapsibles();}// -----------------------------------------------------
// ---------------------------------------------------
},{key:"render",value:function render(){var _props=this.props,columnDimensions=_props.columnDimensions,rowDimensions=_props.rowDimensions,height=_props.height,width=_props.width;var headers=[];var lastCrossDimensionId=void 0;var crossDimensions=rowDimensions.filter(function(dimension){return dimension.isVisible;});lastCrossDimensionId=crossDimensions[crossDimensions.length-1].id;headers=this.headersRenderer(AxisType.COLUMNS,columnDimensions,lastCrossDimensionId);crossDimensions=columnDimensions.filter(function(dimension){return dimension.isVisible;});lastCrossDimensionId=crossDimensions[crossDimensions.length-1].id;headers=headers.concat(this.headersRenderer(AxisType.ROWS,rowDimensions,lastCrossDimensionId));return(// Putting position as relative here allows its children (the dimension headers)
// to be absolutely positioned relatively to their parent
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"relative",overflow:"hidden",height:height,width:width},className:"zebulon-grid-dimension-headers",onMouseDown:this.handleMouseDown},headers));}}]);return DimensionHeaders;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DimensionHeaders);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InnerHeader_InnerHeader__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ResizeHandle_ResizeHandle__ = __webpack_require__(114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MEASURE_ID=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].MEASURE_ID,ROOT_ID=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].ROOT_ID,AxisType=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].AxisType;var DimensionHeader=function(_PureComponent){_inherits(DimensionHeader,_PureComponent);function DimensionHeader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DimensionHeader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DimensionHeader.__proto__||Object.getPrototypeOf(DimensionHeader)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickCollapse=function(e){if(e.button===0&&_this.props.features.expandCollapse==="enabled"){var _this$props=_this.props,toggleCollapseDimension=_this$props.toggleCollapseDimension,dimension=_this$props.dimension;toggleCollapseDimension(dimension.id);}},_this.handleClickSort=function(e){_this.button=e.button;if(e.button===0&&_this.props.features.sorting==="enabled"){var _this$props2=_this.props,toggleSortOrder=_this$props2.toggleSortOrder,dimension=_this$props2.dimension;if(dimension.id!==MEASURE_ID&&dimension.id!==ROOT_ID){toggleSortOrder(dimension.id);}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DimensionHeader,[{key:"render",value:function render(){var _props=this.props,positions=_props.positions,dimension=_props.dimension,crossDimensionId=_props.crossDimensionId,previewSizes=_props.previewSizes,gridId=_props.gridId,moveDimension=_props.moveDimension,collectMenu=_props.collectMenu,isFiltered=_props.isFiltered,features=_props.features,toggleSortOrder=_props.toggleSortOrder,expandCollapseAll=_props.expandCollapseAll,toggleSubTotal=_props.toggleSubTotal,getExpandCollapseKeys=_props.getExpandCollapseKeys;var ids={};if(dimension.axis===AxisType.ROWS){ids.right=dimension.id;ids.bottom=crossDimensionId;}else{ids.bottom=dimension.id;ids.right=crossDimensionId;}var left=positions.left,top=positions.top,width=positions.width,height=positions.height;var className=__WEBPACK_IMPORTED_MODULE_1_classnames___default()({"zebulon-grid-cell":true,"zebulon-grid-dimension-header":true,"zebulon-grid-dimension-header-column":dimension.axis===AxisType.COLUMNS,"zebulon-grid-dimension-header-row":dimension.axis===AxisType.ROWS,"zebulon-grid-dimension-attribute-header":dimension.isAttribute,"zebulon-grid-dimension-filtered-header":isFiltered});var resizeHandle=[];if(features.resize==="enabled"){resizeHandle=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ResizeHandle_ResizeHandle__["a" /* default */],{key:"right",position:"right",size:height,id:ids.right,axis:AxisType.ROWS,gridId:gridId,previewSize:previewSizes.height}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ResizeHandle_ResizeHandle__["a" /* default */],{key:"bottom",position:"bottom",size:width,gridId:gridId,id:ids.bottom,axis:AxisType.COLUMNS,previewSize:previewSizes.width})];}// let menuTrigger = null;
// if (true) {
//   menuTrigger = `context-menu-${gridId}`;
// }
var header=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:"fixed-dim-"+dimension.id,className:className,style:{position:"absolute",left:left,top:top,width:width,height:height,boxSizing:"border-box",display:"flex"},onClick:this.handleClickSort},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__InnerHeader_InnerHeader__["a" /* default */],{axis:dimension.axis,id:dimension.id,index:dimension.depth,caption:dimension.caption,isNotCollapsible:!dimension.hasAttribute||this.props.features.expandCollapse!=="enabled",isCollapsed:dimension.isCollapsed,handleClickCollapse:this.handleClickCollapse,moveDimension:moveDimension,isDropTarget:this.props.features.dimensions==="enabled",isDragSource:this.props.features.dimensions==="enabled",gridId:gridId}),resizeHandle);// return header;
var collapseAll=function collapseAll(collapse){var keys=getExpandCollapseKeys(dimension.axis,dimension.depth,collapse);return expandCollapseAll(dimension.axis,keys.keys,keys.n);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["c" /* ContextualMenuClient */],{menu:"dimension-menu",id:"dimensions-menu-"+dimension.id,component:gridId,collect:function collect(){return collectMenu({dimension:dimension,toggleSortOrder:toggleSortOrder,moveDimension:moveDimension,collapseAll:collapseAll,toggleSubTotal:toggleSubTotal,getExpandCollapseKeys:getExpandCollapseKeys});}},header);}}]);return DimensionHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (DimensionHeader);

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Headers_Headers__ = __webpack_require__(115);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var mapStateToProps=function mapStateToProps(){return function(state,ownProps){return{axisType:__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].COLUMNS,zoom:state.configuration.zoom,gridId:ownProps.gridId,getSelectedColumnRange:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["v" /* getSelectedColumnRangeSelector */])(state),measures:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["m" /* getAxisActivatedMeasuresSelector */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].COLUMNS)(state),availableMeasures:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* availableMeasuresSelector */])(state),previewSizes:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["y" /* previewSizesSelector */])(state),features:state.configuration.features,status:state.status};};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleCollapse:function toggleCollapse(key,n){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["toggleCollapse"])({axisType:__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].COLUMNS,key:key,n:n}));},moveDimension:function moveDimension(dimensionId,oldAxis,newAxis,position){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["moveDimension"])(dimensionId,oldAxis,newAxis,position));},moveMeasure:function moveMeasure(measures){return function(measureId,measureToId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["moveMeasure"])(measureId,Object.keys(measures).indexOf(measureToId)));};},toggleMeasure:function toggleMeasure(measureId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["toggleMeasure"])(measureId));},toggleMeasuresAxis:function toggleMeasuresAxis(axis){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["setConfigurationProperty"])({measureHeadersAxis:axis},"measureHeadersAxis"));},selectAxis:function selectAxis(getSelectedColumnRange){return function(header){var selectedRange=getSelectedColumnRange(header);dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__actions__["selectRange"])(selectedRange));};}};};var mergeProps=function mergeProps(_ref,_ref2,ownProps){var selectAxis=_ref2.selectAxis,moveMeasure=_ref2.moveMeasure,restDispatchProps=_objectWithoutProperties(_ref2,["selectAxis","moveMeasure"]);var getSelectedColumnRange=_ref.getSelectedColumnRange,measures=_ref.measures,restStateProps=_objectWithoutProperties(_ref,["getSelectedColumnRange","measures"]);return Object.assign({selectAxis:selectAxis(getSelectedColumnRange),moveMeasure:moveMeasure(measures),measures:measures},restStateProps,restDispatchProps,ownProps);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_4__components_Headers_Headers__["a" /* default */]));

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ResizeHandle_ResizeHandle__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InnerHeader_InnerHeader__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AxisType=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].AxisType,MEASURE_ID=__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].MEASURE_ID;var Header=function(_Component){_inherits(Header,_Component);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickCollapse=function(){if(_this.props.features.expandCollapse==="enabled"){var _this$props=_this.props,toggleCollapse=_this$props.toggleCollapse,header=_this$props.header,measuresCount=_this$props.measuresCount;toggleCollapse(header.key,Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["k" /* expandCollapseNode */])(header,undefined,measuresCount));}},_this.handleClick=function(){_this.props.selectAxis(_this.props.header);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Header,[{key:"render",value:function render(){var _props=this.props,axis=_props.axis,dimensionId=_props.dimensionId,gridId=_props.gridId,header=_props.header,caption=_props.caption,positionStyle=_props.positionStyle,previewSizes=_props.previewSizes,isNotCollapsible=_props.isNotCollapsible,isCollapsed=_props.isCollapsed,collapseOffset=_props.collapseOffset,moveDimension=_props.moveDimension,moveMeasure=_props.moveMeasure,toggleMeasuresAxis=_props.toggleMeasuresAxis,toggleMeasure=_props.toggleMeasure,collectMenu=_props.collectMenu,isDropTarget=_props.isDropTarget,isDragSource=_props.isDragSource,features=_props.features,zoom=_props.zoom;var style=positionStyle;var rightKey=axis===AxisType.COLUMNS?header.key:dimensionId;var bottomKey=axis===AxisType.ROWS?header.key:dimensionId;var rightHeader=axis===AxisType.COLUMNS?header:null;var bottomHeader=axis===AxisType.ROWS?header:null;var className=__WEBPACK_IMPORTED_MODULE_1_classnames___default()({"zebulon-grid-cell":true,"zebulon-grid-header":!header.isTotal,"zebulon-grid-column-header":axis===AxisType.COLUMNS,"zebulon-grid-row-header":axis===AxisType.ROWS,"zebulon-grid-header-total":header.isTotal===1,"zebulon-grid-header-grandtotal":header.isTotal===2});var resizeHandle=[];if(features.resize==="enabled"){resizeHandle=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResizeHandle_ResizeHandle__["a" /* default */],{key:"right",position:"right",size:positionStyle.height,id:rightKey,axis:axis,header:rightHeader,previewSize:previewSizes.height,gridId:gridId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ResizeHandle_ResizeHandle__["a" /* default */],{key:"bottom",position:"bottom",size:positionStyle.width,id:bottomKey,gridId:gridId,axis:axis,header:bottomHeader,previewSize:previewSizes.width})];}// let menuTrigger = null;
// if (true) {
//   menuTrigger = `context-menu-${gridId}`;
// }
var head=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:className,style:Object.assign({boxSizing:"border-box",overflow:"hidden",display:"flex"},style)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__InnerHeader_InnerHeader__["a" /* default */],{axis:axis,id:dimensionId,measureId:dimensionId===MEASURE_ID?header.id:null,index:header.index,caption:caption,isNotCollapsible:isNotCollapsible||this.props.features.expandCollapse!=="enabled",isCollapsed:isCollapsed,collapseOffset:collapseOffset,handleClickCollapse:this.handleClickCollapse,handleClick:this.handleClick,handleClickMenu:this.handleClickMenu,moveDimension:moveDimension,moveMeasure:moveMeasure,toggleMeasuresAxis:toggleMeasuresAxis,isDropTarget:isDropTarget&&this.props.features.dimensions==="enabled",isDragSource:isDragSource&&this.props.features.measures==="enabled",zoom:zoom,gridId:gridId}),resizeHandle);if(dimensionId===MEASURE_ID){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["c" /* ContextualMenuClient */],{menu:"measure-menu",id:"measure-menu-"+header.id,component:gridId,collect:function collect(){return collectMenu({axis:axis,header:header,toggleMeasuresAxis:toggleMeasuresAxis,toggleMeasure:toggleMeasure});}},head);}else{return head;}}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Headers_Headers__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(6);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var mapStateToProps=function mapStateToProps(){return function(state,ownProps){return{axisType:__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].ROWS,// height: state.configuration.height,
// width: state.configuration.width,
zoom:state.configuration.zoom,previewSizes:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["y" /* previewSizesSelector */])(state),features:state.configuration.features,gridId:ownProps.gridId,getSelectedRowRange:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["w" /* getSelectedRowRangeSelector */])(state),measures:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["m" /* getAxisActivatedMeasuresSelector */])(__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].ROWS)(state),availableMeasures:Object(__WEBPACK_IMPORTED_MODULE_2__selectors__["c" /* availableMeasuresSelector */])(state),status:state.status};};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleCollapse:function toggleCollapse(key,n){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["toggleCollapse"])({axisType:__WEBPACK_IMPORTED_MODULE_1__constants__["b" /* AxisType */].ROWS,key:key,n:n}));},selectAxis:function selectAxis(getSelectedRowRange){return function(header){var selectedRange=getSelectedRowRange(header);dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["selectRange"])(selectedRange));};},moveDimension:function moveDimension(dimensionId,oldAxis,newAxis,position){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["moveDimension"])(dimensionId,oldAxis,newAxis,position));},toggleMeasuresAxis:function toggleMeasuresAxis(axis){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["setConfigurationProperty"])({measureHeadersAxis:axis},"measureHeadersAxis"));},moveMeasure:function moveMeasure(measures){return function(measureId,measureToId){dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["moveMeasure"])(measureId,Object.keys(measures).indexOf(measureToId)));};},toggleMeasure:function toggleMeasure(measureId){return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions__["toggleMeasure"])(measureId));}};};var mergeProps=function mergeProps(_ref,_ref2,ownProps){var selectAxis=_ref2.selectAxis,moveMeasure=_ref2.moveMeasure,restDispatchProps=_objectWithoutProperties(_ref2,["selectAxis","moveMeasure"]);var getSelectedRowRange=_ref.getSelectedRowRange,measures=_ref.measures,restStateProps=_objectWithoutProperties(_ref,["getSelectedRowRange","measures"]);return Object.assign({selectAxis:selectAxis(getSelectedRowRange),moveMeasure:moveMeasure(measures),measures:measures},restStateProps,restDispatchProps,ownProps);};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps,mergeProps)(__WEBPACK_IMPORTED_MODULE_3__components_Headers_Headers__["a" /* default */]));

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dnd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dnd__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var collectDragLayer=function collectDragLayer(monitor){return{item:monitor.getItem(),itemType:monitor.getItemType(),clientOffset:monitor.getClientOffset(),initialClientOffset:monitor.getInitialClientOffset(),isDragging:monitor.isDragging()};};var CustomDragLayer=function(_Component){_inherits(CustomDragLayer,_Component);function CustomDragLayer(){_classCallCheck(this,CustomDragLayer);var _this=_possibleConstructorReturn(this,(CustomDragLayer.__proto__||Object.getPrototypeOf(CustomDragLayer)).call(this));_this.state={};_this.getItemPosition=_this.getItemPosition.bind(_this);return _this;}_createClass(CustomDragLayer,[{key:"getItemPosition",value:function getItemPosition(){var _props=this.props,clientOffset=_props.clientOffset,item=_props.item;if(!clientOffset){return{display:"none"};}var x=void 0;var y=void 0;var gridRect=this.element.getBoundingClientRect();if(item.position==="right"){y=0;// Keep hint bar inside the grid
x=Math.min(Math.max(clientOffset.x-gridRect.left,0),gridRect.width);}else{x=0;// Keep hint bar inside the grid
y=Math.min(Math.max(clientOffset.y-gridRect.top,0),gridRect.height);}// Translate the hint bar in the correct position starting from the top left corner of the grid
// console.log("transform", x, y);
var transform="translate("+x+"px, "+y+"px)";return{transform:transform};}},{key:"render",value:function render(){var _this2=this;var height=void 0;var width=void 0;var resizeBar=void 0;if(!this.props.item||this.props.itemType.substring(0,18)!=="cell-resize-handle"||this.props.item.gridId!==this.props.gridId){resizeBar=null;}else{var _props$item=this.props.item,position=_props$item.position,previewSize=_props$item.previewSize;if(position==="right"){width=2;height=previewSize;}else{width=previewSize;height=2;}resizeBar=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:Object.assign({position:"absolute",height:height,width:width,backgroundColor:"grey"},this.getItemPosition())});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:function ref(element){_this2.element=element;},style:this.props.isDragging?{position:"absolute",pointerEvents:"none",zIndex:100,left:0,top:0,width:"100%",height:"100%"}:{display:"none"}},resizeBar);}}]);return CustomDragLayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_dnd__["DragLayer"])(collectDragLayer)(CustomDragLayer));

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PivotGrid_Chart__ = __webpack_require__(325);
// import {
var mapStateToProps=function mapStateToProps(state){return{status:state.status,width:state.configuration.width,height:state.configuration.height};};/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1__components_PivotGrid_Chart__["a" /* default */]));

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Chart=function(_Component){_inherits(Chart,_Component);function Chart(props){_classCallCheck(this,Chart);return _possibleConstructorReturn(this,(Chart.__proto__||Object.getPrototypeOf(Chart)).call(this,props));}_createClass(Chart,[{key:"componentDidMount",value:function componentDidMount(){this.props.getRef(this);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Chart...");}}]);return Chart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Chart);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();
// https://github.com/uxitten/polyfill/blob/master/string.polyfill.js
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
// if (!String.prototype.padStart) {
//   String.prototype.padStart = function padStart(targetLength, padString) {
//     targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
//     padString = String(typeof padString !== "undefined" ? padString : " ");
//     if (this.length > targetLength) {
//       return String(this);
//     } else {
//       targetLength = targetLength - this.length;
//       if (targetLength > padString.length) {
//         padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
//       }
//       return padString.slice(0, targetLength) + String(this);
//     }
//   };
// }
/* eslint-disable */
if (!Math.sign) {
  Math.sign = function (x) {
    // Si x vaut NaN, le résultat vaudra NaN.
    // Si x vaut -0, le résultat vaudra -0.
    // Si x vaut +0, le résultat vaudra +0.
    // Si x est négatif et différent de -0, le résultat vaudra -1.
    // Si x est positif et différent de +0, le résultat vaudra +1.
    x = +x; // on convertit la valeur en un nombre
    if (x === 0 || isNaN(x)) {
      return Number(x);
    }
    return x > 0 ? 1 : -1;
  };
}
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== "function") {
        throw new TypeError("predicate must be a function");
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, "includes", {
    value: function value(searchElement, fromIndex) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || typeof x === "number" && typeof y === "number" && isNaN(x) && isNaN(y);
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, "findIndex", {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== "function") {
        throw new TypeError("predicate must be a function");
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    }
  });
}

var values = __webpack_require__(116);
if (!Object.values) {
  values.shim();
}

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
  Object.keys = function () {
    "use strict";

    var hasOwnProperty = Object.prototype.hasOwnProperty,
        hasDontEnumBug = !{ toString: null }.propertyIsEnumerable("toString"),
        dontEnums = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"],
        dontEnumsLength = dontEnums.length;

    return function (obj) {
      if (typeof obj !== "function" && ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== "object" || obj === null)) {
        throw new TypeError("Object.keys called on non-object");
      }

      var result = [],
          prop,
          i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }();
}

// Production steps of ECMA-262, Edition 5, 15.4.4.22
// Reference: http://es5.github.io/#x15.4.4.22
if ("function" !== typeof Array.prototype.reduceRight) {
  Array.prototype.reduceRight = function (callback /*, initialValue*/) {
    "use strict";

    if (null === this || "undefined" === typeof this) {
      throw new TypeError("Array.prototype.reduce called on null or undefined");
    }
    if ("function" !== typeof callback) {
      throw new TypeError(callback + " is not a function");
    }
    var t = Object(this),
        len = t.length >>> 0,
        k = len - 1,
        value;
    if (arguments.length >= 2) {
      value = arguments[1];
    } else {
      while (k >= 0 && !(k in t)) {
        k--;
      }
      if (k < 0) {
        throw new TypeError("Reduce of empty array with no initial value");
      }
      value = t[k--];
    }
    for (; k >= 0; k--) {
      if (k in t) {
        value = callback(value, t[k], k, t);
      }
    }
    return value;
  };
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es5-shim
var has = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var slice = Array.prototype.slice;
var isArgs = __webpack_require__(328);
var isEnumerable = Object.prototype.propertyIsEnumerable;
var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
var dontEnums = [
	'toString',
	'toLocaleString',
	'valueOf',
	'hasOwnProperty',
	'isPrototypeOf',
	'propertyIsEnumerable',
	'constructor'
];
var equalsConstructorPrototype = function (o) {
	var ctor = o.constructor;
	return ctor && ctor.prototype === o;
};
var excludedKeys = {
	$console: true,
	$external: true,
	$frame: true,
	$frameElement: true,
	$frames: true,
	$innerHeight: true,
	$innerWidth: true,
	$outerHeight: true,
	$outerWidth: true,
	$pageXOffset: true,
	$pageYOffset: true,
	$parent: true,
	$scrollLeft: true,
	$scrollTop: true,
	$scrollX: true,
	$scrollY: true,
	$self: true,
	$webkitIndexedDB: true,
	$webkitStorageInfo: true,
	$window: true
};
var hasAutomationEqualityBug = (function () {
	/* global window */
	if (typeof window === 'undefined') { return false; }
	for (var k in window) {
		try {
			if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
				try {
					equalsConstructorPrototype(window[k]);
				} catch (e) {
					return true;
				}
			}
		} catch (e) {
			return true;
		}
	}
	return false;
}());
var equalsConstructorPrototypeIfNotBuggy = function (o) {
	/* global window */
	if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
		return equalsConstructorPrototype(o);
	}
	try {
		return equalsConstructorPrototype(o);
	} catch (e) {
		return false;
	}
};

var keysShim = function keys(object) {
	var isObject = object !== null && typeof object === 'object';
	var isFunction = toStr.call(object) === '[object Function]';
	var isArguments = isArgs(object);
	var isString = isObject && toStr.call(object) === '[object String]';
	var theKeys = [];

	if (!isObject && !isFunction && !isArguments) {
		throw new TypeError('Object.keys called on a non-object');
	}

	var skipProto = hasProtoEnumBug && isFunction;
	if (isString && object.length > 0 && !has.call(object, 0)) {
		for (var i = 0; i < object.length; ++i) {
			theKeys.push(String(i));
		}
	}

	if (isArguments && object.length > 0) {
		for (var j = 0; j < object.length; ++j) {
			theKeys.push(String(j));
		}
	} else {
		for (var name in object) {
			if (!(skipProto && name === 'prototype') && has.call(object, name)) {
				theKeys.push(String(name));
			}
		}
	}

	if (hasDontEnumBug) {
		var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

		for (var k = 0; k < dontEnums.length; ++k) {
			if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
				theKeys.push(dontEnums[k]);
			}
		}
	}
	return theKeys;
};

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			return (Object.keys(arguments) || '').length === 2;
		}(1, 2));
		if (!keysWorksWithArguments) {
			var originalKeys = Object.keys;
			Object.keys = function keys(object) {
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				} else {
					return originalKeys(object);
				}
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 329 */
/***/ (function(module, exports) {


var hasOwn = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

module.exports = function forEach (obj, fn, ctx) {
    if (toString.call(fn) !== '[object Function]') {
        throw new TypeError('iterator must be a function');
    }
    var l = obj.length;
    if (l === +l) {
        for (var i = 0; i < l; i++) {
            fn.call(ctx, obj[i], i, obj);
        }
    } else {
        for (var k in obj) {
            if (hasOwn.call(obj, k)) {
                fn.call(ctx, obj[k], k, obj);
            }
        }
    }
};



/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(331);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES2015 = __webpack_require__(332);
var assign = __webpack_require__(122);

var ES2016 = assign(assign({}, ES2015), {
	// https://github.com/tc39/ecma262/pull/60
	SameValueNonNumber: function SameValueNonNumber(x, y) {
		if (typeof x === 'number' || typeof x !== typeof y) {
			throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
		}
		return this.SameValue(x, y);
	}
});

module.exports = ES2016;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(37);
var toPrimitive = __webpack_require__(334);

var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var $isNaN = __webpack_require__(120);
var $isFinite = __webpack_require__(121);
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

var assign = __webpack_require__(122);
var sign = __webpack_require__(123);
var mod = __webpack_require__(124);
var isPrimitive = __webpack_require__(337);
var parseInteger = parseInt;
var bind = __webpack_require__(60);
var arraySlice = bind.call(Function.call, Array.prototype.slice);
var strSlice = bind.call(Function.call, String.prototype.slice);
var isBinary = bind.call(Function.call, RegExp.prototype.test, /^0b[01]+$/i);
var isOctal = bind.call(Function.call, RegExp.prototype.test, /^0o[0-7]+$/i);
var regexExec = bind.call(Function.call, RegExp.prototype.exec);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new RegExp('[' + nonWS + ']', 'g');
var hasNonWS = bind.call(Function.call, RegExp.prototype.test, nonWSregex);
var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
var isInvalidHexLiteral = bind.call(Function.call, RegExp.prototype.test, invalidHexLiteral);

// whitespace from: http://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var replace = bind.call(Function.call, String.prototype.replace);
var trim = function (value) {
	return replace(value, trimRegex, '');
};

var ES5 = __webpack_require__(338);

var hasRegExpMatcher = __webpack_require__(340);

// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
var ES6 = assign(assign({}, ES5), {

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
	Call: function Call(F, V) {
		var args = arguments.length > 2 ? arguments[2] : [];
		if (!this.IsCallable(F)) {
			throw new TypeError(F + ' is not a function');
		}
		return F.apply(V, args);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
	ToPrimitive: toPrimitive,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
	// ToBoolean: ES5.ToBoolean,

	// http://www.ecma-international.org/ecma-262/6.0/#sec-tonumber
	ToNumber: function ToNumber(argument) {
		var value = isPrimitive(argument) ? argument : toPrimitive(argument, Number);
		if (typeof value === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a number');
		}
		if (typeof value === 'string') {
			if (isBinary(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 2));
			} else if (isOctal(value)) {
				return this.ToNumber(parseInteger(strSlice(value, 2), 8));
			} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
				return NaN;
			} else {
				var trimmed = trim(value);
				if (trimmed !== value) {
					return this.ToNumber(trimmed);
				}
			}
		}
		return Number(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
	// ToInteger: ES5.ToNumber,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
	// ToInt32: ES5.ToInt32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
	// ToUint32: ES5.ToUint32,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
	ToInt16: function ToInt16(argument) {
		var int16bit = this.ToUint16(argument);
		return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
	// ToUint16: ES5.ToUint16,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
	ToInt8: function ToInt8(argument) {
		var int8bit = this.ToUint8(argument);
		return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
	ToUint8: function ToUint8(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x100);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
	ToUint8Clamp: function ToUint8Clamp(argument) {
		var number = this.ToNumber(argument);
		if ($isNaN(number) || number <= 0) { return 0; }
		if (number >= 0xFF) { return 0xFF; }
		var f = Math.floor(argument);
		if (f + 0.5 < number) { return f + 1; }
		if (number < f + 0.5) { return f; }
		if (f % 2 !== 0) { return f + 1; }
		return f;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
	ToString: function ToString(argument) {
		if (typeof argument === 'symbol') {
			throw new TypeError('Cannot convert a Symbol value to a string');
		}
		return String(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
	ToObject: function ToObject(value) {
		this.RequireObjectCoercible(value);
		return Object(value);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
	ToPropertyKey: function ToPropertyKey(argument) {
		var key = this.ToPrimitive(argument, String);
		return typeof key === 'symbol' ? key : this.ToString(key);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	ToLength: function ToLength(argument) {
		var len = this.ToInteger(argument);
		if (len <= 0) { return 0; } // includes converting -0 to +0
		if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
		return len;
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
	CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
		if (toStr.call(argument) !== '[object String]') {
			throw new TypeError('must be a string');
		}
		if (argument === '-0') { return -0; }
		var n = this.ToNumber(argument);
		if (this.SameValue(this.ToString(n), argument)) { return n; }
		return void 0;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
	RequireObjectCoercible: ES5.CheckObjectCoercible,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
	IsArray: Array.isArray || function IsArray(argument) {
		return toStr.call(argument) === '[object Array]';
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
	// IsCallable: ES5.IsCallable,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
	IsConstructor: function IsConstructor(argument) {
		return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
	IsExtensible: function IsExtensible(obj) {
		if (!Object.preventExtensions) { return true; }
		if (isPrimitive(obj)) {
			return false;
		}
		return Object.isExtensible(obj);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
	IsInteger: function IsInteger(argument) {
		if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
			return false;
		}
		var abs = Math.abs(argument);
		return Math.floor(abs) === abs;
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
	IsPropertyKey: function IsPropertyKey(argument) {
		return typeof argument === 'string' || typeof argument === 'symbol';
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-isregexp
	IsRegExp: function IsRegExp(argument) {
		if (!argument || typeof argument !== 'object') {
			return false;
		}
		if (hasSymbols) {
			var isRegExp = argument[Symbol.match];
			if (typeof isRegExp !== 'undefined') {
				return ES5.ToBoolean(isRegExp);
			}
		}
		return hasRegExpMatcher(argument);
	},

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
	// SameValue: ES5.SameValue,

	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
	SameValueZero: function SameValueZero(x, y) {
		return (x === y) || ($isNaN(x) && $isNaN(y));
	},

	/**
	 * 7.3.2 GetV (V, P)
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let O be ToObject(V).
	 * 3. ReturnIfAbrupt(O).
	 * 4. Return O.[[Get]](P, V).
	 */
	GetV: function GetV(V, P) {
		// 7.3.2.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.2.2-3
		var O = this.ToObject(V);

		// 7.3.2.4
		return O[P];
	},

	/**
	 * 7.3.9 - http://www.ecma-international.org/ecma-262/6.0/#sec-getmethod
	 * 1. Assert: IsPropertyKey(P) is true.
	 * 2. Let func be GetV(O, P).
	 * 3. ReturnIfAbrupt(func).
	 * 4. If func is either undefined or null, return undefined.
	 * 5. If IsCallable(func) is false, throw a TypeError exception.
	 * 6. Return func.
	 */
	GetMethod: function GetMethod(O, P) {
		// 7.3.9.1
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}

		// 7.3.9.2
		var func = this.GetV(O, P);

		// 7.3.9.4
		if (func == null) {
			return void 0;
		}

		// 7.3.9.5
		if (!this.IsCallable(func)) {
			throw new TypeError(P + 'is not a function');
		}

		// 7.3.9.6
		return func;
	},

	/**
	 * 7.3.1 Get (O, P) - http://www.ecma-international.org/ecma-262/6.0/#sec-get-o-p
	 * 1. Assert: Type(O) is Object.
	 * 2. Assert: IsPropertyKey(P) is true.
	 * 3. Return O.[[Get]](P, O).
	 */
	Get: function Get(O, P) {
		// 7.3.1.1
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		// 7.3.1.2
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		// 7.3.1.3
		return O[P];
	},

	Type: function Type(x) {
		if (typeof x === 'symbol') {
			return 'Symbol';
		}
		return ES5.Type(x);
	},

	// http://www.ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
	SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		var C = O.constructor;
		if (typeof C === 'undefined') {
			return defaultConstructor;
		}
		if (this.Type(C) !== 'Object') {
			throw new TypeError('O.constructor is not an Object');
		}
		var S = hasSymbols && Symbol.species ? C[Symbol.species] : void 0;
		if (S == null) {
			return defaultConstructor;
		}
		if (this.IsConstructor(S)) {
			return S;
		}
		throw new TypeError('no constructor found');
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
	CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
			if (!has(Desc, '[[Value]]')) {
				Desc['[[Value]]'] = void 0;
			}
			if (!has(Desc, '[[Writable]]')) {
				Desc['[[Writable]]'] = false;
			}
		} else {
			if (!has(Desc, '[[Get]]')) {
				Desc['[[Get]]'] = void 0;
			}
			if (!has(Desc, '[[Set]]')) {
				Desc['[[Set]]'] = void 0;
			}
		}
		if (!has(Desc, '[[Enumerable]]')) {
			Desc['[[Enumerable]]'] = false;
		}
		if (!has(Desc, '[[Configurable]]')) {
			Desc['[[Configurable]]'] = false;
		}
		return Desc;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
	Set: function Set(O, P, V, Throw) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		if (this.Type(Throw) !== 'Boolean') {
			throw new TypeError('Throw must be a Boolean');
		}
		if (Throw) {
			O[P] = V;
			return true;
		} else {
			try {
				O[P] = V;
			} catch (e) {
				return false;
			}
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
	HasOwnProperty: function HasOwnProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		return has(O, P);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-hasproperty
	HasProperty: function HasProperty(O, P) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('O must be an Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		return P in O;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
	IsConcatSpreadable: function IsConcatSpreadable(O) {
		if (this.Type(O) !== 'Object') {
			return false;
		}
		if (hasSymbols && typeof Symbol.isConcatSpreadable === 'symbol') {
			var spreadable = this.Get(O, Symbol.isConcatSpreadable);
			if (typeof spreadable !== 'undefined') {
				return this.ToBoolean(spreadable);
			}
		}
		return this.IsArray(O);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-invoke
	Invoke: function Invoke(O, P) {
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('P must be a Property Key');
		}
		var argumentsList = arraySlice(arguments, 2);
		var func = this.GetV(O, P);
		return this.Call(func, O, argumentsList);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
	CreateIterResultObject: function CreateIterResultObject(value, done) {
		if (this.Type(done) !== 'Boolean') {
			throw new TypeError('Assertion failed: Type(done) is not Boolean');
		}
		return {
			value: value,
			done: done
		};
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-regexpexec
	RegExpExec: function RegExpExec(R, S) {
		if (this.Type(R) !== 'Object') {
			throw new TypeError('R must be an Object');
		}
		if (this.Type(S) !== 'String') {
			throw new TypeError('S must be a String');
		}
		var exec = this.Get(R, 'exec');
		if (this.IsCallable(exec)) {
			var result = this.Call(exec, R, [S]);
			if (result === null || this.Type(result) === 'Object') {
				return result;
			}
			throw new TypeError('"exec" method must return `null` or an Object');
		}
		return regexExec(R, S);
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
	ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
		if (!this.IsInteger(length) || length < 0) {
			throw new TypeError('Assertion failed: length must be an integer >= 0');
		}
		var len = length === 0 ? 0 : length;
		var C;
		var isArray = this.IsArray(originalArray);
		if (isArray) {
			C = this.Get(originalArray, 'constructor');
			// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
			// if (this.IsConstructor(C)) {
			// 	if C is another realm's Array, C = undefined
			// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
			// }
			if (this.Type(C) === 'Object' && hasSymbols && Symbol.species) {
				C = this.Get(C, Symbol.species);
				if (C === null) {
					C = void 0;
				}
			}
		}
		if (typeof C === 'undefined') {
			return Array(len);
		}
		if (!this.IsConstructor(C)) {
			throw new TypeError('C must be a constructor');
		}
		return new C(len); // this.Construct(C, len);
	},

	CreateDataProperty: function CreateDataProperty(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var oldDesc = Object.getOwnPropertyDescriptor(O, P);
		var extensible = oldDesc || (typeof Object.isExtensible !== 'function' || Object.isExtensible(O));
		var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
		if (immutable || !extensible) {
			return false;
		}
		var newDesc = {
			configurable: true,
			enumerable: true,
			value: V,
			writable: true
		};
		Object.defineProperty(O, P, newDesc);
		return true;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
	CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
		if (this.Type(O) !== 'Object') {
			throw new TypeError('Assertion failed: Type(O) is not Object');
		}
		if (!this.IsPropertyKey(P)) {
			throw new TypeError('Assertion failed: IsPropertyKey(P) is not true');
		}
		var success = this.CreateDataProperty(O, P, V);
		if (!success) {
			throw new TypeError('unable to create data property');
		}
		return success;
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
	AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
		if (this.Type(S) !== 'String') {
			throw new TypeError('Assertion failed: Type(S) is not String');
		}
		if (!this.IsInteger(index)) {
			throw new TypeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
		}
		if (index < 0 || index > MAX_SAFE_INTEGER) {
			throw new RangeError('Assertion failed: length must be an integer >= 0 and <= (2**53 - 1)');
		}
		if (this.Type(unicode) !== 'Boolean') {
			throw new TypeError('Assertion failed: Type(unicode) is not Boolean');
		}
		if (!unicode) {
			return index + 1;
		}
		var length = S.length;
		if ((index + 1) >= length) {
			return index + 1;
		}
		var first = S.charCodeAt(index);
		if (first < 0xD800 || first > 0xDBFF) {
			return index + 1;
		}
		var second = S.charCodeAt(index + 1);
		if (second < 0xDC00 || second > 0xDFFF) {
			return index + 1;
		}
		return index + 2;
	}
});

delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible

module.exports = ES6;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(119);
var isCallable = __webpack_require__(61);
var isDate = __webpack_require__(335);
var isSymbol = __webpack_require__(336);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (PreferredType === String) {
			hint = 'string';
		} else if (PreferredType === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateObject(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) { return false; }
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = typeof Symbol === 'function' && typeof Symbol() === 'symbol';

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') { return false; }
		return symStringRegex.test(symToStr.call(value));
	};
	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') { return true; }
		if (toStr.call(value) !== '[object Symbol]') { return false; }
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {
	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false;
	};
}


/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(120);
var $isFinite = __webpack_require__(121);

var sign = __webpack_require__(123);
var mod = __webpack_require__(124);

var IsCallable = __webpack_require__(61);
var toPrimitive = __webpack_require__(339);

var has = __webpack_require__(37);

// https://es5.github.io/#x9
var ES5 = {
	ToPrimitive: toPrimitive,

	ToBoolean: function ToBoolean(value) {
		return !!value;
	},
	ToNumber: function ToNumber(value) {
		return Number(value);
	},
	ToInteger: function ToInteger(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number)) { return 0; }
		if (number === 0 || !$isFinite(number)) { return number; }
		return sign(number) * Math.floor(Math.abs(number));
	},
	ToInt32: function ToInt32(x) {
		return this.ToNumber(x) >> 0;
	},
	ToUint32: function ToUint32(x) {
		return this.ToNumber(x) >>> 0;
	},
	ToUint16: function ToUint16(value) {
		var number = this.ToNumber(value);
		if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
		var posInt = sign(number) * Math.floor(Math.abs(number));
		return mod(posInt, 0x10000);
	},
	ToString: function ToString(value) {
		return String(value);
	},
	ToObject: function ToObject(value) {
		this.CheckObjectCoercible(value);
		return Object(value);
	},
	CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
		/* jshint eqnull:true */
		if (value == null) {
			throw new TypeError(optMessage || 'Cannot call method on ' + value);
		}
		return value;
	},
	IsCallable: IsCallable,
	SameValue: function SameValue(x, y) {
		if (x === y) { // 0 === -0, but they are not identical.
			if (x === 0) { return 1 / x === 1 / y; }
			return true;
		}
		return $isNaN(x) && $isNaN(y);
	},

	// http://www.ecma-international.org/ecma-262/5.1/#sec-8
	Type: function Type(x) {
		if (x === null) {
			return 'Null';
		}
		if (typeof x === 'undefined') {
			return 'Undefined';
		}
		if (typeof x === 'function' || typeof x === 'object') {
			return 'Object';
		}
		if (typeof x === 'number') {
			return 'Number';
		}
		if (typeof x === 'boolean') {
			return 'Boolean';
		}
		if (typeof x === 'string') {
			return 'String';
		}
	},

	// http://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
		if (this.Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};
		// jscs:disable
		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}
		// jscs:enable
		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.1
	IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.2
	IsDataDescriptor: function IsDataDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
			return false;
		}

		return true;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.3
	IsGenericDescriptor: function IsGenericDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return false;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
			return true;
		}

		return false;
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.4
	FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
		if (typeof Desc === 'undefined') {
			return Desc;
		}

		if (!this.IsPropertyDescriptor(Desc)) {
			throw new TypeError('Desc must be a Property Descriptor');
		}

		if (this.IsDataDescriptor(Desc)) {
			return {
				value: Desc['[[Value]]'],
				writable: !!Desc['[[Writable]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else if (this.IsAccessorDescriptor(Desc)) {
			return {
				get: Desc['[[Get]]'],
				set: Desc['[[Set]]'],
				enumerable: !!Desc['[[Enumerable]]'],
				configurable: !!Desc['[[Configurable]]']
			};
		} else {
			throw new TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
		}
	},

	// http://ecma-international.org/ecma-262/5.1/#sec-8.10.5
	ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
		if (this.Type(Obj) !== 'Object') {
			throw new TypeError('ToPropertyDescriptor requires an object');
		}

		var desc = {};
		if (has(Obj, 'enumerable')) {
			desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
		}
		if (has(Obj, 'configurable')) {
			desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
		}
		if (has(Obj, 'value')) {
			desc['[[Value]]'] = Obj.value;
		}
		if (has(Obj, 'writable')) {
			desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
		}
		if (has(Obj, 'get')) {
			var getter = Obj.get;
			if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
				throw new TypeError('getter must be a function');
			}
			desc['[[Get]]'] = getter;
		}
		if (has(Obj, 'set')) {
			var setter = Obj.set;
			if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
				throw new TypeError('setter must be a function');
			}
			desc['[[Set]]'] = setter;
		}

		if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
			throw new TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
		}
		return desc;
	}
};

module.exports = ES5;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(119);

var isCallable = __webpack_require__(61);

// https://es5.github.io/#x8.12
var ES5internalSlots = {
	'[[DefaultValue]]': function (O, hint) {
		var actualHint = hint || (toStr.call(O) === '[object Date]' ? String : Number);

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// https://es5.github.io/#x9
module.exports = function ToPrimitive(input, PreferredType) {
	if (isPrimitive(input)) {
		return input;
	}
	return ES5internalSlots['[[DefaultValue]]'](input, PreferredType);
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(37);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0;

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex;
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(125);
var define = __webpack_require__(117);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableHeaders__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table_filters_sorts__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Rows__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Search__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_compute_data__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_compute_meta__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// import { utils } from "zebulon-controls";
var Table = function (_TableFilterSort) {
  _inherits(Table, _TableFilterSort);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _initialiseProps.call(_this);

    var filteredData = _this.filters(props.data, props.filters);
    var status = props.status;
    if (props.meta.serverPagination && status.loaded) {
      status = { loaded: false, loading: true };
      props.data({ startIndex: 0 }).then(function (filteredData) {
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_compute_data__["d" /* computeData */])(filteredData.page, props.meta, 0);
        if (props.onGetPage) {
          props.onGetPage(filteredData);
        }
        _this.setState({
          filteredData: filteredData,
          filteredDataLength: filteredData.filteredDataLength,
          status: { loaded: true, loading: false }
        });
      });
    }
    //  else if (this.props.callbackForeignKey && filteredData.length < 2) {
    //   this.props.callbackForeignKey(
    //     filteredData.length ? filteredData.length[0] : false
    //   );
    // } // a voir serverPagination
    _this.sorts(filteredData, props.meta.properties);
    var columns = props.meta && props.meta.visibleIndexes ? props.meta.visibleIndexes[0] : 0;
    _this.state = {
      data: props.data,
      filteredData: filteredData,
      params: props.params,
      meta: props.meta,
      filters: props.filters || {},
      status: status,
      updatedRows: props.updatedRows,
      scroll: {
        rows: {
          index: 0,
          direction: 1,
          startIndex: 0,
          shift: 0,
          position: 0
        },
        columns: {
          index: 0,
          direction: 1,
          startIndex: 0,
          shift: 0,
          position: 0
        }
      },
      selectedRange: {
        start: { rows: 0, columns: columns },
        end: { rows: 0, columns: columns }
      },
      detail: {},
      text: {},
      checkAll: false,
      search: false,
      dataStrings: {}
    };
    // this.state.selectedRangeAudit = this.state.selectedRange;
    // this.state.scrollAudit = this.state.scroll;
    _this.rowHeight = _this.props.rowHeight;
    _this.range = { start: {}, end: {} };
    _this.onTableEnter();
    if (status.loaded) {
      _this.bLoaded = true;
    }
    if (_this.props.contextualMenu) {
      if (typeof _this.props.contextualMenu === "function") {
        _this.customContextualMenu = _this.props.contextualMenu(_this.state, props);
      } else {
        _this.customContextualMenu = _this.props.contextualMenu;
      }
    }
    // this.filtersOut = props.filters;
    return _this;
  }
  // componentDidMount() {
  //   this.selectRange(this.state.selectedRange, undefined, undefined, "enter");
  // }


  _createClass(Table, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data || nextProps.meta !== this.props.meta || nextProps.status !== this.props.status || nextProps.updatedRows !== this.props.updatedRows) {
        // const filteredData = this.filters(nextProps.data, nextProps.filters);
        var filteredData = [];
        var status = nextProps.status;
        // if (nextProps.meta.serverPagination) {
        //   if (status.loaded && !this.props.status.loaded) {
        //     status = { loaded: false, loading: true };
        //     nextProps.data({ startIndex: 0 }).then(filteredData => {
        //       computeData(filteredData.page, nextProps.meta, 0);
        //       if (nextProps.onGetPage) {
        //         nextProps.onGetPage(filteredData);
        //       }
        //       this.setState({
        //         filteredData,
        //         filteredDataLength: filteredData.filteredDataLength,
        //         status: { loaded: true, loading: false }
        //       });
        //     });
        //   }
        // } else {
        filteredData = this.filters(nextProps.data, this.state.filters);
        this.sorts(filteredData, nextProps.meta.properties);
        // }

        this.setState({
          data: nextProps.data || [],
          filteredData: filteredData,
          filteredDataLength: filteredData.length,
          meta: nextProps.meta,
          status: status,
          updatedRows: nextProps.updatedRows,
          // selectedRange: { start: {}, end: {} },
          scroll: {
            rows: {
              index: 0,
              direction: 1,
              startIndex: 0,
              shift: 0,
              position: 0
            },
            columns: {
              index: 0,
              direction: 1,
              startIndex: 0,
              shift: 0,
              position: 0
            }
          }
        });
        if (status.loaded && this.bLoaded === undefined) {
          this.bLoaded = true;
        }
        if (status.loaded && this.props.callbackForeignKey && filteredData.length < 2) {
          this.props.callbackForeignKey(filteredData.length === 1, filteredData[0]);
          return null;
        }
      }
      this.rowHeight = nextProps.rowHeight;
      if (nextProps.visible && !this.props.visible) this.onTableEnter();
      // else if (!nextProps.visible && this.props.visible) {
      //   this.onTableQuit();
      // }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !nextProps.modal;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      return this.onTableClose();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onLoad();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onLoad();
      this.changingFilter = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          height = _props.height,
          width = _props.width,
          isModal = _props.isModal,
          visible = _props.visible,
          params = _props.params;
      var _state = this.state,
          status = _state.status,
          meta = _state.meta,
          selectedRange = _state.selectedRange,
          updatedRows = _state.updatedRows,
          data = _state.data,
          auditedRow = _state.auditedRow,
          audits = _state.audits,
          scroll = _state.scroll,
          filteredData = void 0,
          filteredDataLength = void 0;
      var selectRange = this.selectRange,
          onScroll = this.onScroll;

      var headersLength = 1 + !meta.table.noFilter * (1 + (meta.properties.findIndex(function (column) {
        return column.filterType === "between" && !column.hidden;
      }) !== -1));
      // -----------------------------
      // audit
      // -----------------------------
      // console.log("render", scroll, selectedRange);
      var auditStatus = void 0;
      if (auditedRow) {
        // selectRange = undefined;
        headersLength = 2;
        auditStatus = updatedRows[auditedRow.index_] || {};
        meta = Object.assign({}, meta, {
          table: Object.assign({}, meta.table, { editable: false }),
          properties: [{
            id: "user_",
            caption: "User",
            width: 80
          }, {
            id: "time_",
            caption: "Time",
            dataType: "date",
            format: "time",
            formatFunction: function formatFunction(_ref) {
              var value = _ref.value;
              return __WEBPACK_IMPORTED_MODULE_5_zebulon_controls__["j" /* utils */].formatValue(value, "dd/mm/yyyy hh:mi:ss");
            },
            width: 130
          }, {
            id: "status_",
            caption: "Status",
            dataType: "string",
            width: 70
          }].concat(_toConsumableArray(meta.properties))
        });
        Object(__WEBPACK_IMPORTED_MODULE_7__utils_compute_meta__["c" /* computeMetaPositions */])(meta, this.props.zoom); // A voir zoom
        meta.lockedIndex = 2;
        meta.lockedWidth = 280 * this.props.zoom;
        var row = auditStatus.row || auditStatus.rowUpdated || auditedRow;
        var rowUpdated = auditStatus.updated_ && !auditStatus.new_ ? auditStatus.rowUpdated : undefined;
        filteredData = Object(__WEBPACK_IMPORTED_MODULE_6__utils_compute_data__["c" /* computeAudit */])(rowUpdated, row, meta, audits);
        auditedRow = filteredData[0];
        filteredData.splice(0, 1);
        filteredDataLength = filteredData.length;
      } else {
        filteredData = this.state.filteredData;
        filteredDataLength = this.state.filteredData.length;
      }

      var actions = auditedRow || isModal || meta.properties.length === 0 ? [] : meta.table.actions.filter(function (action) {
        return !action.hidden;
      }) || [];
      if (!visible) {
        return null;
      } else if (status.loading || status.loadingConfig) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          "Loading data..."
        );
      } else if (status.error) {
        if (status.error.message === "No rows retrieved") {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { width: "max-content" } },
            "No rows retrieved"
          );
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { color: "red", width: "max-content" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              status.error.type
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "p",
              null,
              status.error.message
            )
          );
        }
      } else if (data.length === 0 && meta.properties.length === 0) {
        return null;
      }
      var noUpdate = !this.isInPage(scroll.rows) || this.noUpdate;
      this.noUpdate = false;
      // -----------------------------------
      // Filter check list
      // -----------------------------------
      var _state2 = this.state,
          openedFilter = _state2.openedFilter,
          filters = _state2.filters;

      this.openedFilter = null;
      if (openedFilter !== undefined) {
        var _filters$openedFilter = filters[openedFilter],
            _top = _filters$openedFilter.top,
            _left = _filters$openedFilter.left,
            items = _filters$openedFilter.items,
            _v = _filters$openedFilter.v,
            caption = _filters$openedFilter.caption,
            computedWidth = _filters$openedFilter.computedWidth;

        this.filter = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_zebulon_controls__["d" /* Filter */], {
          items: items,
          title: caption,
          filter: _v,
          style: {
            position: "absolute",
            border: "solid 0.1em rgba(0, 0, 0, 0.5)",
            backgroundColor: "white",
            fontFamily: "inherit",
            top: _top,
            left: _left,
            width: Math.max(computedWidth * 1.2, 150),
            zIndex: 3,
            opacity: 1
          },
          onOk: this.onChangeFilterValues,
          ref: function ref(_ref2) {
            return _this2.openedFilter = _ref2;
          }
        });
      } else {
        this.filter = undefined;
      }
      // ------------------------
      // text area
      // ------------------------
      var _state$text = this.state.text,
          top = _state$text.top,
          left = _state$text.left,
          v = _state$text.v,
          editable = _state$text.editable,
          label = _state$text.label;

      if (top !== undefined) {
        this.text = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            style: {
              position: "absolute",
              border: "solid 0.1em rgba(0, 0, 0, 0.5)",
              backgroundColor: "white",
              top: top + (headersLength - 2) * this.rowHeight,
              left: left,
              zIndex: 3,
              opacity: 1
            }
          },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            label,
            " "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", {
            rows: "10",
            cols: "80",
            id: "textarea",
            tabIndex: 0,
            style: { top: top, left: left, font: "inherit" },
            disabled: !editable,
            autoFocus: true,
            value: v || "",
            onChange: this.handleTextChange
            // ref={ref => (this.focused = ref)}
          })
        );
      } else {
        this.text = undefined;
      }
      // ------------------------
      // Detail
      // ------------------------
      var detail = this.state.detail.content;
      if (detail) {
        var _row = selectedRange.end.rows !== undefined ? this.getRow(selectedRange.end.rows) : {};
        var _status = updatedRows[_row.index_];
        //       top: (3 + rowIndex) * this.rowHeight + scroll.rows.shift,
        // left:
        //   column.position + this.rowHeight - scroll.columns.position
        detail = this.getDetail({
          Detail: detail,
          row: _row,
          data: data,
          meta: meta.properties,
          status: _status,
          params: params,
          top: (2 + headersLength + selectedRange.end.rows - scroll.rows.startIndex) * this.rowHeight + scroll.rows.shift,
          onChange: meta.row.onChange,
          onClose: this.closeOpenedWindows
        });
      }
      // ------------------------
      // errors
      // ------------------------
      var toolTip = this.state.toolTip || null;
      if (toolTip) {
        var content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          { style: { paddingLeft: 20, maxWidth: 300 } },
          toolTip.content.map(function (error, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "li",
              { key: index },
              error.error
            );
          })
        );
        toolTip = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: "tool-tip",
            className: "zebulon-tool-tip",
            style: { top: toolTip.top, left: toolTip.left, position: "absolute" }
          },
          content
        );
      }
      this.rowsHeight = height - (meta.table.caption ? 30 : 0) - headersLength * this.rowHeight - (actions.length ? 30 : 0);
      // ------------------------
      // search
      // ------------------------
      var search = null;

      if (this.state.search) {
        var _state3 = this.state,
            _filteredData = _state3.filteredData,
            _meta = _state3.meta,
            dataStrings = _state3.dataStrings,
            _scroll = _state3.scroll;

        var _content = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Search__["a" /* Search */], {
          filteredData: _filteredData,
          meta: _meta,
          dataStrings: dataStrings,
          scroll: _scroll,
          rowStartIndex: _scroll.rows.startIndex + _scroll.rows.shift === 0 ? 0 : 1,
          rowStopIndex: Math.min(_scroll.rows.startIndex + Math.floor(this.rowsHeight / this.rowHeight) - (_scroll.rows.shift === 0 ? 1 : 0), _filteredData.length - 1),
          onClose: function onClose() {
            return _this2.setState({ search: false });
          }
          // selectRange={this.selectRange_}
          , selectedCell: this.state.selectedRange.end,
          scrollTo: this.scrollTo
        });
        search = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: "tool-tip",
            className: "zebulon-tool-tip",
            style: { top: 0, left: 0, position: "absolute" }
          },
          _content
        );
      }

      // ----------------------------------
      // Status bar
      // ----------------------------------
      var statusBar = void 0;
      if (meta.table.noStatus) {
        statusBar = null;
      } else {
        statusBar = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableHeaders__["b" /* Status */], {
          key: "statusBar",
          data: filteredData,
          status: status,
          dataLength: filteredDataLength,
          height: this.rowsHeight,
          rowHeight: this.rowHeight,
          scroll: scroll.rows,
          updatedRows: updatedRows,
          selectRange: this.selectRange,
          selectedIndex: selectedRange.end.rows,
          meta: meta,
          handleErrors: this.handleErrors,
          noUpdate: noUpdate,
          component: this.props.id,
          checkable: meta.table.checkable,
          onDoubleClick: this.onDoubleClick,
          draggable: meta.table.statusDraggable,
          isAudit: auditedRow ? true : false
        });
      }
      // -----------------------------
      //   action buttons
      // -----------------------------
      actions = actions.map(function (action, index) {
        if (!_this2.doubleClickAction && action.doubleClick) {
          _this2.doubleClickAction = action;
        }
        var enable = action.enable || false;
        if (status.loadingPage) {
          enable = false;
        } else if (action.enableFunction) {
          var _row2 = selectedRange.end.rows !== undefined ? _this2.getRow(selectedRange.end.rows) : { index_: undefined };
          var _status2 = updatedRows[_row2.index_];
          enable = action.enableFunction({ row: _row2, status: _status2 });
        }
        action.statusEnable = action.enable && enable;
        var lastColumn = meta.properties[meta.properties.length - 1];
        var actionsWidth = Math.min(lastColumn.position + lastColumn.computedWidth + _this2.rowHeight * (statusBar !== null), width - 4 * actions.length) / actions.length || 0;
        var style = {
          width: actionsWidth,
          minWidth: 50,
          margin: 2,
          marginTop: 6
          // backgroundColor: "lightgrey"
        };
        var className = enable ? "zebulon-action-button" : "zebulon-action-button-disabled";
        if (action.jsxFunction) {
          return action.jsxFunction({
            disabled: !enable,
            className: className,
            index: index,
            style: style,
            onClick: function onClick(e) {
              return _this2.handleAction(action, e);
            }
          });
        }
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          {
            key: index,
            disabled: !enable,
            className: className,
            style: style,
            onClick: function onClick(e) {
              return _this2.handleAction(action, e);
            }
          },
          action.caption
        );
      });
      var style = {};
      var locked = !__WEBPACK_IMPORTED_MODULE_5_zebulon_controls__["j" /* utils */].isNullOrUndefined(meta.lockedIndex) && meta.lockedWidth;
      if (locked) {
        style = {
          borderLeft: "solid 0.05em rgba(0, 0, 0, .5)",
          boxSizing: "border-box"
        };
      }
      // console.log("table", this.hasFocus, this.changingFilter);
      var rows = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Rows__["a" /* Rows */], {
        key: "rows",
        meta: meta,
        data: filteredData,
        status: status,
        dataLength: filteredDataLength,
        height: this.rowsHeight,
        width: width - this.rowHeight * (statusBar !== null) - (meta.lockedWidth || 0),
        rowHeight: this.rowHeight,
        scroll: scroll,
        onScroll: onScroll,
        selectedRange: selectedRange,
        selectRange: selectRange,
        onChange: this.onChange,
        onFocus: function onFocus(e, row, column) {
          return _this2.closeOpenedWindows(true, column);
        },
        hasFocus: this.hasFocus,
        updatedRows: updatedRows,
        params: params,
        navigationKeyHandler: this.props.navigationKeyHandler,
        ref: function ref(_ref3) {
          return _this2.rows = _ref3;
        },
        noUpdate: noUpdate,
        style: style,
        onDoubleClick: this.onDoubleClick,
        component: this.props.id
      });
      var lockedColumns = null;
      if (locked) {
        lockedColumns = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Rows__["a" /* Rows */], {
          key: "lockedColumns",
          meta: meta,
          data: filteredData,
          status: status,
          dataLength: filteredDataLength,
          height: this.rowsHeight,
          width: meta.lockedWidth,
          rowHeight: this.rowHeight,
          scroll: scroll,
          onScroll: onScroll,
          selectedRange: selectedRange,
          selectRange: selectRange,
          onChange: this.onChange,
          onFocus: function onFocus(e, row, column) {
            return _this2.closeOpenedWindows(true, column);
          },
          hasFocus: this.hasFocus,
          updatedRows: updatedRows,
          params: params,
          noUpdate: noUpdate,
          noVerticalScrollbar: true,
          onDoubleClick: this.onDoubleClick,
          locked: locked,
          component: this.props.id
        });
      }

      var headers = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableHeaders__["a" /* Headers */], {
        onSort: this.onSort,
        meta: meta,
        data: data,
        height: this.rowHeight * headersLength,
        width: width - this.rowHeight * (statusBar !== null) - (meta.lockedWidth || 0),
        scroll: scroll.columns,
        headersLength: headersLength,
        onMetaChange: this.onMetaChange,
        openFilter: this.openFilter,
        onChange: this.onChangeFilter,
        style: style,
        component: this.props.id,
        auditedRow: auditedRow,
        auditStatus: auditStatus,
        isActive: this.props.isActive,
        onActivation: this.props.onActivation,
        changingFilter: this.changingFilter
      });
      var lockedHeaders = null;
      if (!__WEBPACK_IMPORTED_MODULE_5_zebulon_controls__["j" /* utils */].isNullOrUndefined(meta.lockedIndex) && meta.lockedWidth) {
        lockedHeaders = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TableHeaders__["a" /* Headers */], {
          onSort: this.onSort,
          meta: meta,
          data: auditedRow ? data : null,
          height: this.rowHeight * headersLength,
          width: meta.lockedWidth,
          scroll: scroll.columns,
          headersLength: headersLength,
          onMetaChange: this.onMetaChange,
          openFilter: this.openFilter,
          onChange: this.onChangeFilter,
          locked: true,
          component: this.props.id,
          auditedRow: auditedRow,
          auditStatus: auditStatus,
          isActive: this.props.isActive,
          onActivation: this.props.onActivation,
          changingFilter: this.changingFilter
        });
      }
      var statusBarHeader = [];
      if (statusBar !== null) {
        for (var i = 0; i < headersLength; i++) {
          var checkbox = null;
          if (i === 0 && meta.table.checkable === true) {
            checkbox = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
              type: "checkbox",
              checked: this.state.checkAll,
              onChange: this.onCheckAll
            });
          }
          statusBarHeader.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              key: "status-" + i,
              className: "zebulon-table-corner",
              style: {
                width: this.rowHeight,
                height: this.rowHeight,
                top: i * this.rowHeight
                // border: "0.02em solid rgba(0, 0, 0, 0.3)",
                // padding: 4
              }
            },
            checkbox
          ));
        }
        statusBarHeader = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_zebulon_controls__["c" /* ContextualMenuClient */],
          {
            key: "header-status",
            id: "header-status",
            menu: "top-left-corner-menu",
            component: this.props.id
          },
          statusBarHeader
        );
      } else {
        statusBarHeader = null;
      }
      // statusBar !== null ? <div style={{ display: "block" }}>{1}</div> : null;
      // {filterHeaders}
      var title = null;
      if (meta.table.caption) {
        title = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            key: "title",
            className: "zebulon-table-title",
            style: {
              fontWeight: "bold",
              textAlign: "center",
              padding: 4,
              border: "solid 0.03em rgba(0,0,0,.2)",
              height: 30,
              width: width,
              boxSizing: "border-box"
            }
          },
          meta.table.caption
        );
      }
      // const className = "zebulon-table";
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          id: this.props.id,
          style: Object.assign({
            width: "max-content",
            height: "fit-content"
          }, this.props.style)
        },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_zebulon_controls__["b" /* ContextualMenu */], {
            key: "table-menu",
            getMenu: this.getMenu,
            component: this.props.id,
            id: "table-menu",
            ref: function ref(_ref4) {
              return _this2.contextualMenu = _ref4;
            }
          }),
          detail,
          this.filter,
          this.text,
          toolTip,
          search,
          title,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            {
              style: {
                // display: "-webkit-box"
                display: "flex"
              }
            },
            statusBarHeader,
            lockedHeaders,
            headers
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { style: { display: "flex" } },
            statusBar,
            lockedColumns,
            rows
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { style: { height: actions.length ? 30 : 0, display: "flex" } },
          actions
        ),
        " "
      );
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_2__Table_filters_sorts__["a" /* TableFilterSort */]);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onLoad = function () {
    if (_this3.bLoaded && _this3.state.filteredData.length) {
      var columns = (_this3.state.meta.visibleIndexes || [0])[0];
      _this3.selectRange({
        start: { rows: 0, columns: columns },
        end: { rows: 0, columns: columns }
      }, undefined, _this3.state.filteredData[0], "enter", true);
      _this3.hasFocus = true;
      _this3.bLoaded = null;
    }
  };

  this.onCheckAll = function () {
    var checked_ = !_this3.state.checkAll;

    _this3.state.filteredData.forEach(function (row) {
      return _this3.state.updatedRows[row.index_] = { checked_: checked_, errors: {} };
    });
    _this3.setState({ checkAll: checked_, updatedRows: _this3.state.updatedRows });
  };
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Headers; });
/* unused harmony export statusCell */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Status; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_compute_meta__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_compute_data__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// import { Input } from "./Input";





var filter = function filter(column, position, height, width, filterTo, onChange, openFilter, focusedId, component) {
  var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()({
    "zebulon-table-cell": true,
    "zebulon-table-header": true,
    "zebulon-table-filter": true,
    "zebulon-table-filter-checkbox": column.dataType === "boolean",
    "zebulon-table-filter-checkbox-undefined": (column.v === undefined || column.v === null) && column.dataType === "boolean"
  });
  var textAlign = column.alignement || "left";
  if (!column.alignement) {
    if (column.dataType === "number") textAlign = "right";else if (column.dataType === "date" || column.dataType === "boolean") textAlign = "center";
  }
  var focused = (focusedId || document.activeElement || {}.id) === String(column.index_ + 1000 * filterTo);
  var id = "filter" + (filterTo ? "To" : "") + ": " + component + "--" + column.index_;
  var value = column.v,
      div = void 0;
  if (column.filterType === "values" && column.v) {
    // value = "Y";
    div = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        style: {
          height: height,
          width: width
        },
        id: id,
        key: id,
        className: className,
        onClick: function onClick(e) {
          return openFilter(e, column);
        }
      },
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        style: {
          background: __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["i" /* icons */].filter,
          backgroundSize: "cover",
          height: "1em",
          width: "1em",
          marginTop: "0.1em",
          marginRight: "0.1em"
        }
      })
    );
  } else {
    if (filterTo) {
      value = column.vTo;
    } else if (column.filterType === "values") {
      value = "";
    }
    div = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["e" /* Input */], {
      column: column,
      id: id,
      key: id,
      className: className,
      style: {
        // position: "absolute",
        height: height,
        width: width,
        textAlign: textAlign
      },
      editable: true,
      focused: focused,
      inputType: "filter",
      tabIndex: column.index_ * 2 + (filterTo || 0) + 100,
      value: value,
      filterTo: filterTo,
      onChange: onChange,
      onFocus: function onFocus(e) {
        // console.log("filter", this);
        openFilter(e, column);
      }
    });
  }

  return div;
};
var header = function header(column, position, height, width, handleClick, handleDragStart, handleDragOver, handleDrop, component
// handleDragEnd
) {
  var sort = "";
  if (column.sort === "asc") {
    sort = "↑";
  } else if (column.sort === "desc") {
    sort = "↓";
  }
  var id = "header: " + component + "--" + column.index_;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["c" /* ContextualMenuClient */],
    {
      key: id,
      id: id,
      className: "zebulon-table-cell zebulon-table-header",
      onClick: function onClick() {
        return handleClick(column, false);
      },
      onDoubleClick: function onDoubleClick() {
        return handleClick(column, true);
      },
      onDragOver: handleDragOver,
      onDrop: handleDrop,
      style: {
        height: height,
        width: width,
        justifyContent: "space-between",
        display: "flex",
        paddingRight: "unset"
      },
      column: column,
      menu: "column-header-menu",
      component: component
    },
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      {
        id: id,
        key: 0,
        style: { width: width - 15 },
        draggable: true,
        onDragStart: function onDragStart(e) {
          return handleDragStart(e, "move");
        }
      },
      column.caption || column.id
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      "div",
      { id: id, key: 1, style: { width: 8 } },
      sort
    ),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      id: id,
      key: 2,
      style: {
        width: 6,
        cursor: "col-resize",
        opacity: 0
      },
      draggable: true,
      onDragStart: function onDragStart(e) {
        return handleDragStart(e, "resize");
      }
    })
  );
};
var auditCell = function auditCell(row, column, status, data, params, style, component) {
  var _cellData = Object(__WEBPACK_IMPORTED_MODULE_3__utils_compute_data__["a" /* cellData */])(row, column, status, data, params, false),
      value = _cellData.value;

  var textAlign = column.alignement || "left";
  if (!column.alignement) {
    if (column.dataType === "number") {
      textAlign = "right";
    } else if (column.dataType === "date" || column.dataType === "boolean") {
      textAlign = "center";
    }
  }
  style.textAlign = textAlign;
  var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()({
    "zebulon-table-cell": true,
    "zebulon-table-cell-audit": true,
    "zebulon-table-cell-odd": true
    // "zebulon-table-cell-selected": selected,
    // "zebulon-table-cell-focused": focused,
    // "zebulon-table-cell-editable": editable && focused
  });
  // if (column.dataType === "boolean") value = value || false;
  var id = "audit-cell: " + component + "-" + row.index_ + "-" + column.index_;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["e" /* Input */], {
    row: row,
    column: column,
    style: style,
    className: className,
    value: value,
    key: id,
    id: id
  });
};
var filterEmpty = function filterEmpty(id, position, width, height) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    key: id + "-filter-empty",
    className: "zebulon-table-cell zebulon-table-header zebulon-table-filter-empty",
    style: {
      height: height,
      width: width
      // ,
      // border: "0.02em solid rgba(0, 0, 0, 0.2) ",
      // borderRight
    }
  });
};

// ↑↓
var Headers = function (_Component) {
  _inherits(Headers, _Component);

  function Headers() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Headers);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Headers.__proto__ || Object.getPrototypeOf(Headers)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (column, double) {
      if (!_this.props.isActive && _this.props.onActivation) {
        _this.props.onActivation();
      }
      var onSort = _this.props.onSort;

      if (!double) {
        _this.timer = setTimeout(function () {
          if (!_this.prevent) {
            onSort(column, false);
          }
          _this.prevent = false;
        }, 200);
      } else {
        clearTimeout(_this.timer);
        _this.prevent = true;
        onSort(column, true);
      }
    }, _this.getColumnIndex = function (id) {
      var ids = id.split("-");
      return ids[ids.length - 1];
    }, _this.handleDragStart = function (e, type) {
      _this.dragId = e.target.id;
      _this.dragType = type;
      _this.dragX = e.pageX;
      // console.log("handleDragStart", this.dragId, e);
      e.dataTransfer.setData("text", _this.dragId);
      e.stopPropagation();
    }, _this.handleDragOver = function (e) {
      // console.log("handleDragOver", e);
      if (_this.dragType === "move" || _this.dragType === "resize" && _this.props.meta.properties[_this.getColumnIndex(_this.dragId)].computedWidth + e.pageX - _this.dragX > 20) {
        e.preventDefault();
      }
    }, _this.handleDrop = function (e) {
      e.preventDefault();
      var meta = _this.props.meta.properties;
      if (_this.dragType) {
        if (_this.dragType === "move" && !__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(_this.dragId) && _this.dragId !== e.target.id) {
          meta[_this.getColumnIndex(_this.dragId)].index_ = meta[_this.getColumnIndex(e.target.id)].index_ + 0.1;
          meta.sort(function (a, b) {
            return a.index_ - b.index_;
          });
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_meta__["c" /* computeMetaPositions */])(_this.props.meta);
          _this.props.onMetaChange();
        } else if (_this.dragType === "resize" && !__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(_this.dragX) && !__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(e.pageX)) {
          var column = meta[_this.getColumnIndex(_this.dragId)];
          var zoom = column.computedWidth / column.width;
          column.computedWidth += e.pageX - _this.dragX;
          column.width = column.computedWidth / zoom;
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_meta__["c" /* computeMetaPositions */])(_this.props.meta);
          _this.props.onMetaChange();
        }
      }
      _this.dragId = null;
      _this.dragType = null;
      _this.dragX = null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Headers, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return !this.props.changingFilter;
    }
  }, {
    key: "render",
    value: function render() {
      var _props$scroll = this.props.scroll,
          shift = _props$scroll.shift,
          index = _props$scroll.startIndex;
      var _props = this.props,
          meta = _props.meta,
          width = _props.width,
          height = _props.height,
          onChange = _props.onChange,
          openFilter = _props.openFilter,
          focusedId = _props.focusedId,
          headersLength = _props.headersLength,
          locked = _props.locked,
          auditedRow = _props.auditedRow,
          auditStatus = _props.auditStatus,
          component = _props.component,
          data = _props.data,
          params = _props.params;

      var cells = [];
      var position = 0,
          first = true;
      if (!locked) {
        index = Math.max(index, __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(meta.lockedIndex) ? 0 : meta.lockedIndex + 1);
      } else {
        index = 0;
        shift = 0;
      }
      while (index < meta.properties.length && position < width) {
        var column = meta.properties[index];
        var columnWidth = Math.max(Math.min(first ? column.computedWidth + shift : column.computedWidth, width - position), 0);
        var div = null;
        if (!column.hidden && columnWidth) {
          first = false;
          div = header(column, position, height / headersLength, columnWidth, this.handleClick, this.handleDragStart, this.handleDragOver, this.handleDrop, component);
          if (headersLength > 1) {
            if (auditedRow) {
              div = [div];
              var _style = {
                // position: "absolute",
                // left: position,
                width: columnWidth,
                // top: height / 2,
                height: height / 2
              };
              div.push(auditCell(auditedRow, column, auditStatus, data, params, _style, component));
            } else {
              div = [div];
              if (!["object", "array", "function", "text"].includes(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].nullValue(column.dataType, "object"))) {
                div.push(filter(column, position, height / headersLength, columnWidth, false, onChange, openFilter, focusedId, component));
              } else {
                div.push(filterEmpty(column.id, position, columnWidth, height / headersLength));
              }
              if (headersLength === 3) {
                if (column.filterType === "between" && !["object", "array", "function", "text"].includes(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].nullValue(column.dataType, "object"))) {
                  div.push(filter(column, position, height / headersLength, columnWidth, column.filterType === "between", onChange, openFilter, focusedId, component));
                } else {
                  div.push(filterEmpty(column.id + "-to", position, columnWidth, height / headersLength));
                }
              }
            }
            div = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "div",
              {
                key: column.id || "undefined " + column.index_,
                style: { display: "block", width: columnWidth, height: height }
              },
              div
            );
          }
          cells.push(div);
          position += columnWidth;
        }
        index += 1;
      }
      var style = {
        width: width,
        height: height,
        // overflow: "hidden",
        display: "flex"
      };
      if (!locked) {
        style.overflow = "hidden";
      }

      if (cells.length) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          {
            id: "tutut",
            key: -2 - locked
            // id={type + filterTo ? "To" : ""}
            , style: Object.assign({}, this.props.style, style)
          },
          cells
        );
      } else {
        return null;
      }
    }
  }]);

  return Headers;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
var statusCell = function statusCell(style, className, index, row, status, _onClick, onDoubleClick, handleErrors, component, checkable, _onChange, isAudit, draggable, handleDragStart) {
  var glyph = void 0;
  if (status.deleted_) {
    glyph = "X";
  } else if (status.new_) {
    glyph = "+";
  } else if (status.updated_) {
    glyph = "√";
  } else {
    glyph = null;
  }
  var errors = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["d" /* getRowErrors */])(status, status.index_);
  if (errors.length && !status.deleted_) {
    style.color = "red";
  }
  if (checkable) {
    glyph = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
      type: "checkbox",
      checked: status.checked_ || false,
      onChange: function onChange() {
        return _onChange(row.index_);
      }
      // style={{ height: 20 }}
    });
  }
  var id = "status: " + component + "-" + (isAudit ? index : row.index_) + "-";
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["c" /* ContextualMenuClient */],
    {
      id: id,
      key: id,
      className: className,
      style: style,
      onClick: function onClick(e) {
        return _onClick(index, e.shiftKey);
      },
      onMouseOver: function onMouseOver(e) {
        return handleErrors(e, errors);
      },
      onMouseOut: function onMouseOut(e) {
        return handleErrors(e, []);
      },
      onDoubleClick: onDoubleClick ? function (e) {
        return onDoubleClick(e, row);
      } : function () {},
      draggable: draggable,
      onDragStart: handleDragStart,
      status: status,
      row: row,
      menu: "row-header-menu",
      component: component
    },
    glyph
  );
};
var Status = function (_Component2) {
  _inherits(Status, _Component2);

  function Status(props) {
    _classCallCheck(this, Status);

    var _this2 = _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).call(this, props));

    _this2.onClick = function (index, extension) {
      var _this2$props = _this2.props,
          meta = _this2$props.meta,
          scroll = _this2$props.scroll;

      var columns = (meta.visibleIndexes || [0])[0];
      var startRowIndex = extension ? _this2.props.selectedIndex : index;
      _this2.props.selectRange({
        end: { rows: index, columns: columns },
        start: { rows: startRowIndex, columns: meta.properties.length - 1 }
      }, undefined, undefined, undefined, undefined, index === scroll.startIndex || index === _this2.stopIndex);
    };

    _this2.onChange = function (index) {
      if (_this2.props.checkable) {
        var updatedRows = _this2.state.updatedRows;
        if (!updatedRows[index]) {
          updatedRows[index] = { errors: {} };
        }
        updatedRows[index].checked_ = !updatedRows[index].checked_;
        if (_this2.props.checkable === 2) {
          updatedRows[index + 1 - 2 * (index % 2)].checked_ = !updatedRows[index].checked_;
        }
        _this2.setState({ updatedRows: updatedRows });
      }
    };

    _this2.handleDragStart = function (e) {
      e.stopPropagation();
      e.dataTransfer.setData("text", "status: " + e.target.id);
    };

    _this2.state = { updatedRows: _this2.props.updatedRows };
    return _this2;
  }

  _createClass(Status, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.updatedRows !== nextProps.updatedRows) {
        this.setState({ updatedRows: nextProps.updatedRows });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.status.loadingPage && !nextProps.noUpdate;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          height = _props2.height,
          rowHeight = _props2.rowHeight,
          data = _props2.data,
          scroll = _props2.scroll,
          selectedIndex = _props2.selectedIndex,
          handleErrors = _props2.handleErrors,
          dataLength = _props2.dataLength,
          component = _props2.component,
          checkable = _props2.checkable,
          onDoubleClick = _props2.onDoubleClick,
          isAudit = _props2.isAudit,
          draggable = _props2.draggable;

      var updatedRows = this.state.updatedRows;
      var index = 0,
          indexPage = 0,
          rows = data;
      if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" && data.page) {
        rows = data.page;
        indexPage = data.pageStartIndex;
      }
      var cells = [];
      while (index < Math.min(dataLength || data.length, Math.ceil(height / rowHeight))) {
        var style = {
          // position: "relative",
          top: index === 0 ? 0 : scroll.shift + index * rowHeight,
          width: rowHeight,
          height: index === 0 ? rowHeight + scroll.shift : Math.min(rowHeight, height - (scroll.shift + index * rowHeight))
        };
        if (index + scroll.startIndex - indexPage < rows.length) {
          (function () {
            var row = rows[index + scroll.startIndex - indexPage];
            var updatedRow = updatedRows[row.index_] || { errors: {} };
            var className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()({
              "zebulon-table-status": true,
              "zebulon-table-status-selected": selectedIndex === index + scroll.startIndex
            });
            var ix = index;
            cells.push(statusCell(style, className, ix + scroll.startIndex, row, updatedRow, _this3.onClick, onDoubleClick, function (e, errors) {
              return handleErrors(e, ix, errors);
            }, component, checkable, _this3.onChange, isAudit, draggable));
          })();
        }
        index += 1;
      }
      this.stopIndex = index + scroll.startIndex - 1;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: "status: " + component,
          id: "status: " + component,
          style: {
            width: rowHeight,
            height: height,
            // overflow: "hidden",
            position: "relative",
            diplay: "flex"
          }
        },
        cells
      );
    }
  }]);

  return Status;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableFilterSort; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table_events__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_filters_sorts__ = __webpack_require__(62);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var TableFilterSort = function (_TableEvent) {
  _inherits(TableFilterSort, _TableEvent);

  function TableFilterSort() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TableFilterSort);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableFilterSort.__proto__ || Object.getPrototypeOf(TableFilterSort)).call.apply(_ref, [this].concat(args))), _this), _this.adjustScrollRows = function (filteredData) {
      if (_this.state) {
        var _this$state = _this.state,
            selectedRange = _this$state.selectedRange,
            scroll = _this$state.scroll,
            meta = _this$state.meta;
        // let { rows, columns } = scroll;

        if (!filteredData.length) {
          selectedRange.end = {};
          selectedRange.start = {};
          _this.hasFocus = false;
          _this.bLoaded = undefined;
        } else if (selectedRange.end.rows === undefined) {
          var columns = (meta.visibleIndexes || [0])[0];
          selectedRange.end = { rows: 0, columns: columns };
          selectedRange.start = { rows: 0, columns: columns };
          _this.bLoaded = true;
          _this.scrollTo(selectedRange.end.rows, 1, selectedRange.end.columns, scroll.columns.direction, false, filteredData.length);
        } else if (selectedRange.end.rows > filteredData.length - 1) {
          selectedRange.end.rows = filteredData.length - 1;
          _this.scrollTo(selectedRange.end.rows, 1, selectedRange.end.columns, scroll.columns.direction, false, filteredData.length);
        } else {
          _this.scrollTo(selectedRange.end.rows, scroll.rows.direction, selectedRange.end.columns, scroll.columns.direction, false, filteredData.length);
        }
        // if (
        //   // filteredData.length !== this.getFilteredDataLength() &&
        //   rows.startIndex !== 0 &&
        //   rows.index +
        //     (rows.direction === 1 ? this.rowsHeight / this.rowHeight : 0) >
        //     filteredData.length
        // ) {
        //   rows = {
        //     index: 0,
        //     direction: 1,
        //     startIndex: 0,
        //     shift: 0,
        //     position: 0
        //   };
        //   this.setState({ scroll: { rows, columns } });
        // }
        return filteredData[selectedRange.end.rows];
      }
    }, _this.filters = function (data, filters, noFocus, updatedRows) {
      if (!Array.isArray(data)) {
        return [];
      }
      var filter = Object(__WEBPACK_IMPORTED_MODULE_2__utils_filters_sorts__["a" /* filtersFunction */])(filters, _this.props.params, data, updatedRows, _this.props.utils);
      var filteredData = data.filter(filter);
      if (_this.props.onFilter) {
        _this.props.onFilter({
          filters: filters,
          filteredData: filteredData,
          data: data,
          params: _this.props.params,
          updatedRows: updatedRows
        });
      }
      return filteredData;
    }, _this.getFilterItems = function (filter, column) {
      var _this$state2 = _this.state,
          meta = _this$state2.meta,
          data = _this$state2.data,
          updatedRows = _this$state2.updatedRows;

      if (!meta.serverPagination) {
        if (!filter || !filter.items) {
          var items = {};
          _this.props.data.forEach(function (row) {
            var id = (column.accessorFunction || function (_ref2) {
              var row = _ref2.row;
              return row[column.id];
            })({
              row: row,
              column: column,
              status: updatedRows[row.index_],
              params: _this.props.params,
              data: data
            }); // a voir status
            var label = column.selectItems && !column.reference && !Array.isArray(column.selectItems) && _typeof(column.selectItems) === "object" ? (column.selectItems[id] || {}).caption : id;
            items[id] = {
              id: id,
              label: (column.formatFunction || function (_ref3) {
                var value = _ref3.value;
                return __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].formatValue(value, null, column.decimals);
              })({
                value: label,
                column: column,
                row: row,
                params: _this.props.params,
                status: updatedRows[row.index_],
                data: data
              }) || id
            };
          });
          column.items = Object.values(items);
          column.items.sort(function (itemA, itemB) {
            return __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullValue(itemA.label) ? -1 : (itemA.label > itemB.label) - (itemA.label < itemB.label);
          });
          filter = column;
        }
      } else {
        column.items = [];
        filter = column;
        // ????
      }
      return filter;
    }, _this.openFilter = function (e, column) {
      if (_this.isOpening) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      e.persist();
      var filter = _this.state.filters[column.id];
      filter = _this.getFilterItems(filter, column);
      filter.top = _this.rowHeight + (_this.state.meta.table.caption ? 30 : 0); // e.target.offsetParent.offsetTop; //this.nFilterRows * this.rowHeight;
      filter.left = e.target.offsetLeft;
      var ok = _this.canQuit("rowQuit", function (ok) {
        if (ok) {
          return _this.openFilter_(e, column, filter);
        }
      });
      if (ok) {
        return _this.openFilter_(e, column, filter);
      }
    }, _this.openFilter_ = function (e, column, filter) {
      if (column.filterType !== "values") {
        e.target.focus();
        _this.hasFocus = false;
        return _this.closeOpenedWindows();
      }
      // column.position + this.rowHeight - this.state.scroll.columns.position;
      // console.log("filtersort", this.hasFocus);
      _this.hasFocus = false;
      _this.setState({
        openedFilter: column.id,
        filters: Object.assign({}, _this.state.filters, _defineProperty({}, column.id, filter))
      });
    }, _this.onChangeFilter = function (e, row, column, filterTo) {
      var ok = _this.props.onTableChange("filter", function (ok) {
        if (ok) {
          _this.onChangeFilter_(e, row, column, filterTo);
        }
      });
      if (ok) {
        _this.onChangeFilter_(e, row, column, filterTo);
      }
    }, _this.onChangeFilter_ = function (e, row, column, filterTo) {
      var _this$state3 = _this.state,
          selectedRange = _this$state3.selectedRange,
          filters = _this$state3.filters,
          meta = _this$state3.meta,
          data = _this$state3.data,
          updatedRows = _this$state3.updatedRows;
      // const ok = this.selectRange(selectedRange, undefined, this.row, "quit");
      // return false;

      _this.closeOpenedWindows();
      var v = e;
      if (v === undefined) {
        return;
      }
      if (v !== column.v && !filterTo || v !== column.vTo && filterTo) {
        _this.hasFocus = false;
        if (column.filterType === "between" && filterTo) {
          column.vTo = v;
        } else {
          column.v = v;
        }
        filters[column.id] = column;
        _this.changingFilter = true;
        var filteredData = _this.filters(data, filters, true, updatedRows);
        // if (!meta.serverPagination) {
        _this.sorts(filteredData, meta.properties);
        _this.setState({ filteredData: filteredData });
        _this.selectRange(selectedRange, undefined, _this.adjustScrollRows(filteredData), "enter", true);
        // }
      }
    }, _this.onChangeFilterValues = function (filter) {
      var openedFilter = _this.state.openedFilter;
      _this.setState({ openedFilter: undefined });
      var ok = _this.props.onTableChange("filter", function (ok) {
        if (ok) {
          _this.onChangeFilterValues_(openedFilter, filter);
        }
      });
      if (ok) {
        _this.onChangeFilterValues_(openedFilter, filter);
      }
    }, _this.onChangeFilterValues_ = function (openedFilter, filter) {
      var _this$state4 = _this.state,
          filters = _this$state4.filters,
          meta = _this$state4.meta,
          data = _this$state4.data;

      var column = filters[openedFilter];
      column.v = filter;
      filters[column.id] = column;
      var filteredData = _this.filters(data, filters);
      // if (!meta.serverPagination) {
      _this.sorts(filteredData, meta.properties);
      _this.setState({ filteredData: filteredData });
      _this.selectRange(_this.range, undefined, _this.adjustScrollRows(filteredData), "enter");
      // }
    }, _this.sorts = function (data, columns) {
      var sorts = Object(__WEBPACK_IMPORTED_MODULE_2__utils_filters_sorts__["c" /* getSorts */])(columns);
      if (!Array.isArray(data)) {
        if (_this.state && _this.state.meta.serverPagination) {
          return _this.pagination({
            sorts: sorts,
            callbackAfter: function callbackAfter() {
              _this.selectRange_(_this.range, undefined, undefined, "enter");
            }
          });
        }
        return [];
      }
      if (sorts.length) {
        data.sort(Object(__WEBPACK_IMPORTED_MODULE_2__utils_filters_sorts__["d" /* sortsFunction */])(sorts));
      }
      if (_this.props.onSort) {
        _this.props.onSort({
          sorts: columns,
          filteredData: data,
          data: _this.props.data,
          params: _this.props.params
        });
      }
    }, _this.onSort = function (column, doubleClick) {
      if (!_this.state.meta.table.noOrder) {
        var ok = _this.props.onTableChange("sort", function (ok) {
          if (ok) {
            _this.onSort_(column, doubleClick);
          }
        });
        if (ok) {
          _this.onSort_(column, doubleClick);
        }
      }
    }, _this.onSort_ = function (column, doubleClick) {
      var _this$state5 = _this.state,
          filteredData = _this$state5.filteredData,
          meta = _this$state5.meta;

      _this.closeOpenedWindows();
      if (_this.selectRange(_this.range, undefined, _this.row, "quit") === false) {
        return false;
      }
      var columns = meta.properties;
      var sorts = [];
      columns.forEach(function (col) {
        if (doubleClick && col.id !== column.id) {
          col.sort = undefined;
          col.sortOrder = undefined;
        }
        if (col.id === column.id) {
          if (col.sort === undefined) {
            col.sort = "asc";
          } else if (col.sort === "asc") {
            col.sort = "desc";
          } else if (col.sort === "desc") {
            col.sort = undefined;
            col.sortOrder = undefined;
          }
        }
        if (col.sort !== undefined) {
          sorts.push({
            index: col.index_,
            sortOrder: col.sortOrder === undefined ? 1000 : col.sortOrder
          });
        }
      });
      sorts.sort(function (a, b) {
        return (a.sortOrder > b.sortOrder) - (b.sortOrder > a.sortOrder);
      });
      sorts.forEach(function (col, index) {
        return columns[col.index].sortOrder = index;
      });
      _this.sorts(filteredData, columns);
      if (!meta.serverPagination) {
        _this.selectRange(_this.range, undefined, undefined, "enter");
        _this.setState({ filteredData: filteredData });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // ----------------------------------------
  // filtering
  // ----------------------------------------

  // a voir si pagination server ???
  //

  // ----------------------------------------
  //sorting
  // ----------------------------------------


  return TableFilterSort;
}(__WEBPACK_IMPORTED_MODULE_0__Table_events__["a" /* TableEvent */]);
// const dataStrings = computeRowSearch(this.state.data, this.state.meta, {});
//    const indexes = rowSearch(dataStrings, "22/02");

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableEvent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table_menu__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_compute_data__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_utils__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_copy_paste__ = __webpack_require__(347);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var TableEvent = function (_TableMenu) {
  _inherits(TableEvent, _TableMenu);

  function TableEvent() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TableEvent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableEvent.__proto__ || Object.getPrototypeOf(TableEvent)).call.apply(_ref, [this].concat(args))), _this), _this.closeOpenedWindows = function (keepSearch, column) {
      if (_this.state.openedFilter) {
        _this.setState({ openedFilter: undefined });
      }
      if (_this.state.text.top !== undefined && !(column && column.dataType === "text")) {
        _this.setState({ text: {} });
      }
      if (_this.state.detail.content !== undefined) {
        _this.setState({ detail: {} });
      }
      if (_this.state.toolTip !== undefined) {
        _this.setState({ toolTip: undefined });
      }
      if (!keepSearch && _this.state.search !== undefined) {
        _this.setState({ search: undefined });
      }
      if (_this.contextualMenu) {
        _this.contextualMenu.close();
      }
    }, _this.fKeyMap = {
      f12: "save",
      f11: "filter",
      f10: "refresh"
    }, _this.toggleFilter = function () {
      if (_this.hasFocus) {
        var element = document.getElementById("filter: " + _this.props.id + "--" + _this.state.selectedRange.end.columns);
        if (element && element.children[0]) {
          element.children[0].focus();
          _this.hasFocus = false;
        }
      } else {
        document.activeElement.blur();
        _this.hasFocus = true;
        _this.setState({ selectedRange: _this.state.selectedRange });
      }
    }, _this.handleKeyDown = function (e) {
      // a voir
      var keyCode = e.which || e.keyCode;
      var key = __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].keyMap[keyCode];
      if (key === undefined) {
        return;
      }
      var _this$state = _this.state,
          openedFilter = _this$state.openedFilter,
          detail = _this$state.detail;

      var isFilter = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["g" /* hasParent */])(document.activeElement, "filter");
      if (key === "Escape") {
        if (openedFilter) {
          _this.hasFocus = true;
        }
        _this.closeOpenedWindows();
      }
      if (key === "Tab" && (openedFilter || detail.content || isFilter)) {
        _this.hasFocus = false;
        return false;
      }
      //function Keys
      if (keyCode > 112 && keyCode < 124) {
        var action = _this.state.meta.table.actions.find(function (action) {
          return action.key === key;
        });
        if (action) {
          e.preventDefault();
          _this.handleAction(action);
        }
        // else if (key === "f11") {
        //   e.preventDefault();
        //   this.toggleFilter();
        // }
      }
      // const fKey = this.fKeyMap[key];
      // ctrl+F
      if (70 === (e.which || e.keyCode) && e.ctrlKey) {
        _this.hasFocus = false;
        _this.handleSearch(e);
      } else if (__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].isNavigationKey(e)) {
        if (openedFilter) {
          if (key === "Enter") {
            e.preventDefault();
            _this.hasFocus = true;
            return _this.openedFilter.onOk();
          } else {
            return _this.openedFilter.values.handleNavigationKeys(e);
          }
        } else if (isFilter && ["ArrowLeft", "ArrowRight"].includes(key)) {
          return false;
        } else if (_this.rows) {
          return _this.rows.handleNavigationKeys(e);
        }
      }
    }, _this.handleCopy = function (e) {
      __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].copy(Object(__WEBPACK_IMPORTED_MODULE_5__utils_copy_paste__["b" /* getSelection */])("xls", _this.state.selectedRange, _this.state.meta.properties, _this.state.filteredData, _this.state.updatedRows, _this.state.data, _this.props.params));
    }, _this.handlePaste = function (e) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__utils_copy_paste__["a" /* buildPasteArray */])("xls", e.clipboardData.getData("text"), _this.state.meta.properties, _this.state.selectedRange.end, function (cell) {
        return _this.selectRange_({ start: cell, end: cell }, function (x) {
          return x;
        }, undefined, "enter");
      }, _this.onChange, _this.canQuit, _this.state.filteredData, _this.state.updatedRows, _this.state.data, _this.props.params);
    }, _this.handleSearch = function (e) {
      e.preventDefault();
      _this.setState({ search: true });
    }, _this.getDetail = function (_ref2) {
      var Detail = _ref2.Detail,
          row = _ref2.row,
          data = _ref2.data,
          meta = _ref2.meta,
          status = _ref2.status,
          params = _ref2.params,
          top = _ref2.top,
          onClose = _ref2.onClose,
          onChange = _ref2.onChange;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Detail, {
        row: row,
        data: data,
        meta: meta,
        params: params,
        status: status,
        onChange: onChange,
        close: onClose,
        top: top
      });
    }, _this.onDoubleClick = function (e, row, column) {
      if (_this.props.onDoubleClick) {
        _this.props.onDoubleClick(row, column);
      } else if (_this.doubleClickAction) {
        _this.handleAction(_this.doubleClickAction, e, row, column);
      }
    }, _this.handleAction = function (action, e, row, column) {
      if (action.statusEnable === false || action.enable === false) {
        return false;
      }
      _this.closeOpenedWindows();
      var rowIndex = _this.state.selectedRange.end.rows;
      // let row = {};
      if (!row && rowIndex !== undefined) {
        row = _this.getRow(rowIndex);
      }
      if (_this.state.selectedRange || !(action.type === "delete" || action.type === "select")) {
        if (action.type === "delete") {
          return _this.handleDelete(row);
        } else if (action.type === "insert") {
          return _this.handleNew(rowIndex || 0);
        } else if (action.type === "duplicate") {
          return _this.handleDuplicate(rowIndex || 0);
        } else if (action.type === "save") {
          return _this.props.onSave();
        } else if (action.type === "refresh") {
          _this.props.onTableChange("refresh");
        } else {
          if (action.type === "detail" && action.content) {
            _this.setState({ detail: action });
          } else if (action.action) {
            var _this$state2 = _this.state,
                selectedRange = _this$state2.selectedRange,
                updatedRows = _this$state2.updatedRows,
                data = _this$state2.data,
                meta = _this$state2.meta;

            var f = function f() {
              return action.actionFunction({
                row: row || _this.row,
                column: column,
                selectedRange: selectedRange,
                updatedRows: updatedRows,
                data: data,
                meta: meta,
                params: _this.props.params,
                action: action,
                ref: _this
              }, e);
            };
            // if changes save is required
            if (action.onTableChange) {
              _this.props.onTableChange(action.onTableChange, function (ok) {
                if (ok) {
                  f();
                }
              });
            } else {
              f();
            }
            _this.setState({ status: _this.state.status });
          }
        }
      }
    }, _this.handleDelete = function (row) {
      var status = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["e" /* getRowStatus */])(_this.state.updatedRows, row);
      if (status.deleted_) {
        status.deleted_ = false;
      } else {
        if (!status.new_) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["i" /* rollback */])(_this.state.updatedRows, row.index_);
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["k" /* setStatus */])(status, "deleted_");
      }
      _this.setState({ status: _this.state.status });
      if (_this.props.onRowDelete) {
        var message = {
          row: row,
          status: status,
          meta: _this.state.meta,
          data: _this.state.data,
          params: _this.props.params
        };
        _this.props.onRowDelete(message);
      }
    }, _this.newRow = function (row, index) {
      var ok = _this.canQuit("new", function (ok) {
        if (ok) {
          _this.newRow_(row, index);
        }
      });
      if (ok) {
        _this.newRow_(row, index);
      }
    }, _this.newRow_ = function (row, index) {
      var _this$state3 = _this.state,
          selectedRange = _this$state3.selectedRange,
          updatedRows = _this$state3.updatedRows,
          filteredData = _this$state3.filteredData,
          meta = _this$state3.meta,
          data = _this$state3.data,
          scroll = _this$state3.scroll;

      var status = {
        new_: true,
        errors: {},
        rowUpdated: row,
        timeStamp: new Date().getTime()
      };
      var rows = filteredData,
          ix = index;
      updatedRows[_this.getDataLength()] = status;
      if (!meta.serverPagination) {
        rows = filteredData;
        data.push(row);
      } else {
        rows = filteredData.page;
        ix = index - filteredData.pageStartIndex;
        filteredData.pageLength++;
        filteredData.filteredDataLength++;
        filteredData.dataLength++;
      }
      rows = rows.slice(0, ix).concat(row).concat(rows.slice(ix));
      if (meta.serverPagination) {
        filteredData.page = rows;
        _this.setState({ filteredData: filteredData });
      } else {
        _this.setState({ filteredData: rows });
      }
      if (_this.onRowNew(row)) {
        var columns = (meta.visibleIndexes || [0])[0];
        var range = {
          end: { rows: selectedRange.end.rows || 0, columns: columns },
          start: {
            rows: selectedRange.end.rows,
            columns: meta.properties.length - 1
          }
        };
        var rowDirection = Math.sign(range.end.rows - (scroll.rows.startIndex || 0));
        var columnDirection = Math.sign(range.end.columns - scroll.columns.startIndex);
        _this.selectRange(range, undefined, row, "enter");
        _this.rowUpdated = true;
        _this.scrollTo(range.end.rows, rowDirection, range.end.columns, columnDirection);
      }
    }, _this.handleNew = function (index) {
      var row = { index_: _this.getDataLength() };
      //  default values
      _this.state.meta.properties.filter(function (column) {
        return column.defaultFunction;
      }).forEach(function (column) {
        return row[column.id] = column.defaultFunction({
          column: column,
          row: row,
          params: _this.props.params
        });
      });
      _this.newRow(row, index);
    }, _this.handleDuplicate = function (index) {
      if (_this.row) {
        var row = Object.assign({}, _this.row, { index_: _this.getDataLength() });
        if (_this.state.meta.table.rowId) {
          row[_this.state.meta.table.rowId] = undefined;
        }
        if (_this.state.meta.table.primaryKey) {
          row[_this.state.meta.table.primaryKey] = null;
        }
        _this.newRow(row, index);
      }
    }, _this.pagination = function (_ref3) {
      var startIndex = _ref3.startIndex,
          stopIndex = _ref3.stopIndex,
          callbackBefore = _ref3.callbackBefore,
          callbackAfter = _ref3.callbackAfter,
          filters = _ref3.filters,
          sorts = _ref3.sorts;
      var _this$state4 = _this.state,
          updatedRows = _this$state4.updatedRows,
          filteredData = _this$state4.filteredData,
          meta = _this$state4.meta;

      _this.setState({
        status: { loaded: false, loading: false, loadingPage: true }
      });
      _this.state.data({
        startIndex: startIndex,
        stopIndex: stopIndex,
        filters: filters,
        sorts: sorts,
        updatedRows: updatedRows
      }).then(function (data) {
        if (callbackBefore) {
          callbackBefore(data);
        }
        filteredData.page = data.page;
        filteredData.pageLength = data.pageLength;
        filteredData.filteredDataLength = data.filteredDataLength;
        filteredData.pageStartIndex = data.pageStartIndex;
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_compute_data__["d" /* computeData */])(data.page, meta, 0);
        if (_this.props.onGetPage) {
          _this.props.onGetPage(data);
        }
        // console.log("page", startIndex, stopIndex, filteredData);
        if (callbackAfter) {
          callbackAfter(data);
        }
        _this.setState({
          filteredDataLength: filteredData.filteredDataLength,
          status: { loaded: true, loading: false, loadingPage: false }
        });
      });
    }, _this.getDataLength = function () {
      return _this.state.meta.serverPagination ? _this.state.filteredData.dataLength : _this.state.data.length;
    }, _this.getFilteredDataLength = function () {
      return _this.state.meta.serverPagination ? _this.state.filteredData.filteredDataLength : _this.state.filteredData.length;
    }, _this.getRow = function (index) {
      var rows = _this.state.filteredData;
      if (_this.state.meta.serverPagination) {
        return rows.page[index - rows.pageStartIndex] || { index_: undefined };
      } else {
        return rows[index] || { index_: undefined };
      }
    }, _this.isInPage = function (scroll) {
      return !_this.state.meta.serverPagination || scroll.startIndex >= _this.state.filteredData.pageStartIndex && scroll.startIndex + Math.ceil(_this.rowsHeight / _this.rowHeight) - 1 < _this.state.filteredData.pageStartIndex + _this.state.filteredData.pageLength;
    }, _this.paginationIsRequired = function (_ref4) {
      var startIndex = _ref4.startIndex,
          stopIndex = _ref4.stopIndex;

      return _this.state.meta.serverPagination && (startIndex < _this.state.filteredData.pageStartIndex || stopIndex >= _this.state.filteredData.pageStartIndex + _this.state.filteredData.pageLength);
    }, _this.scrollTo = function (rowIndex, rowDirection, columnIndex, columnDirection, noFocus, dataLength) {
      // console.log("scroll", rowIndex, noFocus);
      if (_this.rows && (rowDirection || columnDirection)) {
        _this.rows.scrollOnKey({ rows: rowIndex, columns: columnIndex }, null, rowDirection, columnDirection, false, dataLength);
      }
      if (noFocus) {
        _this.hasFocus = false;
      }
    }, _this.onScroll = function (scroll, cell, extention) {
      var startIndex = scroll.rows.startIndex;
      var stopIndex = startIndex + Math.ceil(_this.rowsHeight / _this.rowHeight) - 1;
      if (_this.paginationIsRequired({ startIndex: startIndex, stopIndex: stopIndex })) {
        _this.pagination({
          startIndex: startIndex,
          stopIndex: stopIndex,
          callbackAfter: function callbackAfter() {
            return _this.onScroll_(scroll, cell, extention);
          }
        });
      } else {
        _this.onScroll_(scroll, cell, extention);
      }
    }, _this.onScroll_ = function (scroll, cell, extension) {
      _this.closeOpenedWindows(true);
      var range = Object.assign({}, _this.state.selectedRange);
      if (cell) {
        range.end = cell;
        if (!extension) {
          range.start = cell;
        }
        _this.selectRange_(range, function (x) {
          return x;
        });
      }
      _this.setState({ scroll: scroll });
    }, _this.selectRange = function (range, callback, row, type, noFocus, scrollOnClick) {
      // console.log("selectRange", type, noFocus);
      if (!_this.state.status.loadingPage && !_this.state.status.loading) {
        var startIndex = range.end.rows,
            stopIndex = range.end.rows;
        if (_this.paginationIsRequired({ startIndex: startIndex, stopIndex: stopIndex })) {
          _this.pagination({
            startIndex: startIndex,
            stopIndex: stopIndex,
            callbackAfter: function callbackAfter() {
              return _this.selectRange_(range, callback || function (x) {
                return x;
              }, row, type, noFocus, scrollOnClick);
            }
          });
        } else {
          _this.closeOpenedWindows(true);
          var ok = _this.selectRange_(range, callback || function (x) {
            return x;
          }, row, type, noFocus, scrollOnClick);
          if (ok !== undefined) {
            if (callback) {
              return callback(ok);
            } else {
              return ok;
            }
          }
        }
      }
    }, _this.selectRange_ = function (range, callback, row, type, noFocus, scrollOnClick) {
      if (!_this.props.isActive && _this.props.onActivation) {
        _this.props.onActivation();
      }
      var _this$state5 = _this.state,
          selectedRange = _this$state5.selectedRange,
          scroll = _this$state5.scroll;

      var meta = _this.state.meta;
      // if (this.state.auditedRow) {
      //   selectedRange = this.state.selectedRangeAudit;
      //   scroll = this.state.scrollAudit;
      // }
      // this.hasFocus = !noFocus && !search;
      _this.hasFocus = !noFocus;
      var prevEnd = selectedRange.end;
      var prevStart = selectedRange.start;
      var endChanged = prevEnd.rows !== range.end.rows || prevEnd.columns !== range.end.columns;
      var enter = function enter(ok) {
        if (!ok) {
          callback(false);
          return false;
        }
        if (endChanged || type) {
          if (prevEnd.rows !== range.end.rows || type === "enter") {
            _this.rowUpdated = false;
            if (range.end.rows !== undefined) {
              _this.row = row || _this.getRow(range.end.rows);
              _this.previousRow = Object.assign({}, _this.row);
            } else {
              _this.row = undefined;
              _this.previousRow = undefined;
            }
          }
          _this.updated = false;
          if (range.end.rows !== undefined) {
            _this.column = meta.properties[range.end.columns];
            _this.previousValue = _this.row[_this.column.id];
            if (prevEnd.rows !== range.end.rows || type === "enter") {
              _this.onRowEnter(_this.row);
            }
            _this.onCellEnter(_this.previousValue, _this.row, _this.column);
            if (meta.properties[range.end.columns].dataType === "text") {
              _this.handleText(range.end, _this.row, _this.column);
            }
            if (scrollOnClick) {
              _this.rows.scrollOnKey({ rows: range.end.rows, columns: range.end.columns }, __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["h" /* constants */].AxisType.ROWS);
            }
          } else {
            _this.column = undefined;
            _this.previousValue = undefined;
          }
        }
        if (endChanged || prevStart.rows !== range.start.rows || prevStart.columns !== range.start.columns) {
          // if (this.state.auditedRow) {
          //   this.setState({ selectedRangeAudit: range });
          // } else {
          _this.setState({ selectedRange: range });
        }
        _this.range = range;
        // }
        callback(true);
        return true;
      };
      var quit = function quit() {
        var action = prevEnd.rows !== range.end.rows || row ? "rowQuit" : "cellQuit";
        var ok = _this.canQuit(action, enter);
        if (ok !== undefined) {
          return enter(ok);
        }
      };
      if (type === "enter") {
        return enter(true);
      }
      return quit();
    }, _this.onChange = function (value, row, column) {
      _this.updated = true;
      _this.rowUpdated = true;
      _this.tableUpdated = true;
      var _this$state6 = _this.state,
          updatedRows = _this$state6.updatedRows,
          data = _this$state6.data,
          meta = _this$state6.meta,
          dataStrings = _this$state6.dataStrings;

      delete dataStrings[row.index_];
      var status = Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["e" /* getRowStatus */])(updatedRows, row);
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["k" /* setStatus */])(status, "updated_");
      var message = {
        value: value,
        previousValue: _this.previousValue,
        row: row,
        status: status,
        column: column,
        meta: meta,
        data: data,
        params: _this.props.params
      };
      return _this.onChange_(message) && _this.props.errorHandler(message, "onChange");
    }, _this.onChange_ = function (message) {
      if (message.column.onChangeFunction && message.column.onChangeFunction(message) === false) {
        return false;
      }
      if (_this.props.onChange) {
        if (_this.props.onChange(message) === false) {
          return false;
        }
      }
      return true;
    }, _this.onCellQuit = function (message) {
      return _this.onCellQuit_(message, message.callback);
    }, _this.onCellQuit_ = function (message, callback) {
      var cellQuit = function cellQuit(ok_) {
        message.status = _this.state.updatedRows[message.row.index_];
        var onCellQuit = _this.props.onCellQuit || message.column.onQuitFunction;
        var ok = onCellQuit && ok_ ? onCellQuit(message) : ok_;
        ok = ok && _this.props.errorHandler(message, "onCellQuit");
        if (ok !== undefined && callback) {
          return callback(ok);
        }
        return ok;
      };
      var foreignObjectQuit = function foreignObjectQuit(ok_) {
        var column = message.column,
            row = message.row;

        var value = row[column.id];
        if (!(column.reference && column.foreignObjectFunction)) {
          return cellQuit(ok_);
        }
        if (__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].isNullValue(value)) {
          row[column.reference] = undefined;
          return cellQuit(ok_);
        }
        var element = document.activeElement;
        var col = column.accessor.replace("row.", "");
        col = col.replace(column.reference + ".", "");
        var filters = _defineProperty({}, col, { id: col, filterType: "starts", v: value });
        var callback = function callback(ok, data) {
          if (!ok) {
            _this.noUpdate = true;
            element = document.getElementById("cell: " + _this.props.id + "-" + row.index_ + "-" + column.index_).children[0];
          } else {
            row[column.reference] = data;
          }
          if (element) {
            _this.isOpening = true;
            element.focus();
            _this.isOpening = false;
          }
          return cellQuit(ok);
        };
        _this.props.onForeignKey(column.foreignObjectFunction, filters, callback);
        return;
      };
      if (!message.row || !message.updated) {
        return true;
      }
      return foreignObjectQuit(true);
    }, _this.onCellEnter = function (value, row, column) {
      var status = _this.state.updatedRows[row.index_];
      var message = {
        value: value,
        row: row,
        status: status,
        column: column,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.onCellEnter) _this.props.onCellEnter(message);
    }, _this.onRowQuit = function (message) {
      return _this.onRowQuit_(message, message.callback);
    }, _this.checkUnicity = function (type, key, message) {
      var keyIndex = message.meta[type][message.row[key.id]];
      var error = keyIndex !== message.row.index_ && keyIndex !== undefined;
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["h" /* manageRowError */])(message.updatedRows, message.row.index_, key, "duplicate key", error ? key.caption + ": duplicate key." : null);
      if (!error) {
        delete message.meta[type][message.previousRow[key.id]];
        message.meta[type][message.row[key.id]] = message.row.index_;
      }
    }, _this.onRowQuit_ = function (message, callback) {
      var meta = message.meta,
          updatedRows = message.updatedRows,
          row = message.row,
          rowUpdated = message.rowUpdated;

      if (rowUpdated) {
        message.status = updatedRows[row.index_];
        // mandatory data
        meta.properties.filter(function (property) {
          return property.mandatory;
        }).forEach(function (property) {
          Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["h" /* manageRowError */])(updatedRows, row.index_, property, "mandatory", __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].isNullValue(property.accessorFunction ? property.accessorFunction({ row: message.row }) : row[property.id]) && !message.status.deleted_ ? (property.caption || property.id) + ": mandatory data." : null);
        });
        // duplicate key
        var pk = meta.table.pk;
        var lk = meta.table.lk;
        if (pk && !pk.hidden) {
          _this.checkUnicity("indexPk", pk, message);
        }
        if (lk && !lk.hidden) {
          _this.checkUnicity("indexLk", lk, message);
        }
        var onRowQuit = _this.props.onRowQuit || meta.row.onQuitFunction;
        var ok = onRowQuit ? onRowQuit(message) : true;
        ok = ok && _this.props.errorHandler(message, "onRowQuit", callback);

        if (ok !== undefined && callback) {
          return callback(ok);
        }
        return ok;
      }
      return true;
    }, _this.onRowEnter = function (row) {
      var message = {
        row: row,
        status: _this.state.updatedRows[row.index_],
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.onRowEnter) {
        _this.props.onRowEnter(message);
      }
    }, _this.onRowNew = function (row) {
      var message = {
        row: row,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.onRowNew) if (_this.props.onRowNew(message) === false) return false;
      return true;
    }, _this.onTableEnter = function () {
      var message = {
        updatedRows: _this.state.updatedRows,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      _this.tableUpdated = false;
      _this.rowUpdated = false;
      _this.updated = false;
      if (_this.props.onTableEnter) {
        _this.props.onTableEnter(message);
      }
    }, _this.beforeTableClose = function () {
      var message = {
        updatedRows: _this.state.updatedRows,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (_this.props.beforeTableClose) {
        _this.props.beforeTableClose(message);
      }
    }, _this.onTableClose = function () {
      var message = {
        updatedRows: _this.state.updatedRows,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params
      };
      if (Object(__WEBPACK_IMPORTED_MODULE_4__utils_utils__["f" /* getUpdatedRows */])(_this.state.updatedRows).length) {
        _this.setState({ confirmationModal: true });
        return false;
      } else {
        if (_this.props.onTableClose) {
          _this.props.onTableClose(message);
        }
      }
    }, _this.buildMessage = function (callback) {
      var message = {
        updated: _this.updated,
        rowUpdated: _this.rowUpdated,
        tableUpdated: _this.tableUpdated,
        previousValue: _this.previousValue,
        row: _this.row,
        previousRow: _this.previousRow,
        column: _this.column,
        meta: _this.state.meta,
        data: _this.state.data,
        params: _this.props.params,
        updatedRows: _this.state.updatedRows,
        callback: callback
      };
      return message;
    }, _this.canQuit = function (action, callback) {
      var message = _this.buildMessage(callback || function () {});
      var rowQuit = function rowQuit(ok_) {
        var callback = function callback(ok) {
          if (ok) {
            _this.rowUpdated = false;
          }
          message.callback(ok);
        };
        var ok = ok_ && _this.onRowQuit_(message, callback);
        if (ok !== undefined) {
          return callback(ok);
        }
      };

      var cellQuit = function cellQuit(ok_) {
        var ok = true;
        var callback = function callback(ok) {
          if (ok) {
            _this.updated = false;
          }
          return (action === "cellQuit" ? message.callback : rowQuit)(ok);
        };
        // if (!utils.isNullValue(this.range.end.rows)) {
        ok = ok_ && _this.onCellQuit_(message, callback);
        if (ok !== undefined) {
          return callback(ok);
        }
      };
      return cellQuit(true);
    }, _this.handleErrors = function (e, rowIndex, errors) {
      if (errors.length || _this.state.toolTip) {
        var toolTip = errors.length ? {
          type: "error",
          top: e.target.offsetParent.offsetTop + rowIndex * _this.rowHeight + _this.state.scroll.rows.shift,
          left: _this.rowHeight,
          rowIndex: rowIndex,
          content: errors
        } : null;
        _this.setState({ toolTip: toolTip });
      }
    }, _this.handleText = function (cell, row, column) {
      var label = void 0;
      if (_this.state.meta.row.descriptorFunction) label = _this.state.meta.row.descriptorFunction({ row: row });
      var text = {
        top: (3 + cell.rows - _this.state.scroll.rows.startIndex) * _this.rowHeight + _this.state.scroll.rows.shift,
        left: column.position + _this.rowHeight - _this.state.scroll.columns.position,
        v: (column.accessorFunction || function (_ref5) {
          var row = _ref5.row;
          return row[column.id];
        })({ row: row }),
        label: label,
        editable: column.editable,
        row: row,
        column: column
      };
      _this.setState({ text: text });
    }, _this.handleTextChange = function (e) {
      var _this$state$text = _this.state.text,
          row = _this$state$text.row,
          column = _this$state$text.column;

      _this.setState({ text: Object.assign({}, _this.state.text, { v: e.target.value }) });
      _this.onChange(e.target.value, row, column);
    }, _this.onMetaChange = function (resetScroll) {
      var bReset = false;
      // console.log("onMetaChange", this.state.scroll.rows);
      _this.setState({
        scroll: {
          rows: _this.state.scroll.rows,
          columns: resetScroll || bReset ? {
            index: 0,
            direction: 1,
            startIndex: 0,
            shift: 0,
            position: 0
          } : _this.state.scroll.columns
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // ------------------------------------
  // Navigation
  // ------------------------------------

  //-----------------------------------------
  // buttons and actions management
  //-----------------------------------------

  // ------------------------------------------------------
  // selection and validations
  // ------------------------------------------------------

  // -------------------------------
  //  Cell events
  //  -------------------------------

  // -------------------------------
  //  row events
  //  -------------------------------

  // -------------------------------
  //  Table  events
  //  -------------------------------
  // onTableQuit_ = (message, callback) => {
  //   if (message.tableUpdated) {
  //     const onTableQuit =
  //       this.props.onTableQuit || this.state.meta.table.onQuitFunction;
  //     let ok = onRowQuit ? onRowQuit(message) : true;
  //     ok = ok && this.props.errorHandler(message, "onRowQuit", callback);

  //     if (ok !== undefined && callback) {
  //       return callback(ok);
  //     }
  //     return ok;
  //   }
  //   return true;
  // };

  // ---------------------------------------------------------
  // successive checks and validations
  // with callbacks to manage users interraction
  // and asynchronous processes
  // ---------------------------------------------------------

  //-------------------------------------------
  // end events
  // ------------------------------------------


  return TableEvent;
}(__WEBPACK_IMPORTED_MODULE_1__Table_menu__["a" /* TableMenu */]);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableMenu; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_compute_meta__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TableMenu = function (_Component) {
    _inherits(TableMenu, _Component);

    function TableMenu() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TableMenu);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableMenu.__proto__ || Object.getPrototypeOf(TableMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickMenu = function (props, item) {
            if (props.menu === "column-header-menu") {
                var column = props.column;
                var _this$state = _this.state,
                    data = _this$state.data,
                    meta = _this$state.meta,
                    params = _this$state.params,
                    scroll = _this$state.scroll;

                if (item.id <= 1) {
                    if (!__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(meta.lockedIndex)) {
                        meta.properties[meta.lockedIndex].locked = false;
                    }
                    if (item.id) {
                        meta.properties[column.index_].locked = true;
                    }
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_meta__["c" /* computeMetaPositions */])(meta);
                    _this.setState({
                        scroll: Object.assign({}, scroll, {
                            columns: {
                                direction: 1,
                                index: 0,
                                position: 0,
                                shift: 0,
                                startIndex: 0
                            }
                        })
                    });
                } else {
                    item.function({ data: data, meta: meta, params: params, column: column });
                }
            } else if (props.menu === "row-header-menu") {
                var row = props.row,
                    status = props.status;
                var _this$state2 = _this.state,
                    _data = _this$state2.data,
                    _meta = _this$state2.meta,
                    _params = _this$state2.params,
                    updatedRows = _this$state2.updatedRows;

                if (item.id === 0) {
                    Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["i" /* rollback */])(updatedRows, row.index_);
                    _this.setState({ scroll: _this.state.scroll });
                } else if (item.id === 1) {
                    var audits = _meta.row.auditFunction({ row: row });
                    var prevScroll = _this.state.scroll;
                    var prevRange = _this.state.selectedRange;
                    var columns = props.meta && props.meta.visibleIndexes ? props.meta.visibleIndexes[0] : 0;
                    var selectedRange = {
                        start: { rows: 0, columns: columns },
                        end: { rows: 0, columns: columns }
                    };

                    var _scroll = {
                        rows: {
                            index: 0,
                            direction: 1,
                            startIndex: 0,
                            shift: 0,
                            position: 0
                        },
                        columns: {
                            index: 0,
                            direction: 1,
                            startIndex: 0,
                            shift: 0,
                            position: 0
                        }
                    };
                    if (__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isPromise(audits)) {
                        audits.then(function (audits) {
                            _this.setState({
                                auditedRow: row,
                                audits: audits || [],
                                scroll: _scroll,
                                prevScroll: prevScroll,
                                selectedRange: selectedRange,
                                prevRange: prevRange
                            });
                            // }
                        });
                    } else {
                        // if (audits)
                        var _scroll2 = _this.state.prevScroll;
                        _this.setState({
                            auditedRow: row,
                            audits: audits || [],
                            scroll: _scroll2,
                            prevScroll: prevScroll,
                            selectedRange: selectedRange,
                            prevRange: prevRange
                        });
                    }
                } else {
                    item.function({ data: _data, meta: _meta, params: _params, row: row, status: status });
                }
            } else if (props.menu === "top-left-corner-menu") {
                var _this$state3 = _this.state,
                    filters = _this$state3.filters,
                    _data2 = _this$state3.data,
                    _meta2 = _this$state3.meta,
                    _params2 = _this$state3.params,
                    _updatedRows = _this$state3.updatedRows;

                var filter = filters.status_;
                if (!filter) {
                    filter = { id: "status_", v: 0 };
                }
                var v = item.id % 100;
                if (filter.v & v) {
                    filter.v -= v;
                } else {
                    filter.v += v;
                }
                if (item.id === 2) {
                    var _scroll3 = _this.state.prevScroll;
                    var _selectedRange = _this.state.prevRange;
                    Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_meta__["c" /* computeMetaPositions */])(_meta2);
                    _this.setState({
                        auditedRow: undefined,
                        audits: undefined,
                        scroll: _scroll3,
                        prevScroll: undefined,
                        selectedRange: _selectedRange,
                        prevRange: undefined
                    });
                } else if (item.id === 0 || item.id >= 100 && item.id < 104) {
                    if (item.id === 0 || filter.v === 0) {
                        delete filters.status_;
                    } else if (item.id >= 100) {
                        filters.status_ = filter;
                    }
                    _this.setState({
                        filteredData: _this.filters(_data2, filters, false, _updatedRows)
                    });
                } else {
                    item.function({ data: _data2, meta: _meta2, params: _params2 });
                }
            } else if (props.menu === "cell-menu") {
                var _row = props.row,
                    _column = props.column;
                var _this$state4 = _this.state,
                    _data3 = _this$state4.data,
                    _meta3 = _this$state4.meta,
                    _params3 = _this$state4.params;

                item.function({ data: _data3, meta: _meta3, params: _params3, row: _row, column: _column });
            }
        }, _this.getCustomMenu = function (menu, menus) {
            if (_this.customContextualMenu && _this.customContextualMenu[menu]) {
                _this.customContextualMenu[menu].forEach(function (menu, index) {
                    return menus.push({
                        id: 1000000 + menus.length,
                        separation: index === 0 && menus.length > 0,
                        type: menu.type,
                        caption: menu.caption,
                        onClick: _this.handleClickMenu,
                        function: menu.function
                    });
                });
            }
        }, _this.getMenu = function (menu, data) {
            var menus = [];
            if (menu === "row-header-menu") {
                if (_this.state.meta.table.editable) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        disable: !(data.status || {}).updated_,
                        separation: false,
                        caption: "Rollback row updates",
                        onClick: _this.handleClickMenu
                    });
                }
                if (_this.state.meta.row.audit) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        disable: _this.state.auditedRow !== undefined,
                        // separation: false,
                        caption: "Audit",
                        onClick: _this.handleClickMenu
                    });
                }
            } else if (menu === "column-header-menu") {
                menus.push({
                    id: menus.length,
                    type: "menu-item",
                    disable: __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(_this.state.meta.lockedIndex),
                    separation: false,
                    caption: "Unlock columns",
                    onClick: _this.handleClickMenu
                });
                menus.push({
                    id: menus.length,
                    type: "menu-item",
                    separation: false,
                    caption: "Lock columns until " + data.column.caption,
                    onClick: _this.handleClickMenu
                });
            } else if (menu === "top-left-corner-menu") {
                if (_this.state.meta.table.editable) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        checked: _this.state.filters.status_ === undefined,
                        caption: "No status filter",
                        onClick: _this.handleClickMenu
                    });
                    menus.push({
                        id: menus.length,
                        type: "sub-menu",
                        separation: menus.length > 0,
                        caption: "Status filters",
                        children: [{
                            id: 101,
                            type: "menu-item",
                            checked: (1 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            // disable: utils.isNullOrUndefined(this.state.meta.lockedIndex),
                            separation: false,
                            caption: "Updated rows",
                            onClick: _this.handleClickMenu
                        }, {
                            id: 102,
                            type: "menu-item",
                            checked: (2 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            separation: false,
                            caption: "New rows",
                            onClick: _this.handleClickMenu
                        }, {
                            id: 104,
                            type: "menu-item",
                            checked: (4 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            separation: false,
                            caption: "Deleted rows",
                            onClick: _this.handleClickMenu
                        }, {
                            id: 108,
                            type: "menu-item",
                            // disable: utils.isNullOrUndefined(this.state.meta.lockedIndex),
                            checked: (8 | (_this.state.filters.status_ || { v: 0 }).v) === (_this.state.filters.status_ || { v: 0 }).v,
                            separation: false,
                            caption: "Rows with errors",
                            onClick: _this.handleClickMenu
                        }]
                    });
                }
                if (_this.state.meta.row.audit) {
                    menus.push({
                        id: menus.length,
                        type: "menu-item",
                        disable: _this.state.auditedRow === undefined,
                        separation: _this.state.meta.table.editable,
                        caption: "Close audit",
                        onClick: _this.handleClickMenu
                    });
                }
            }
            _this.getCustomMenu(menu, menus);
            if (menus.length) {
                return {
                    type: "menu",
                    position: "bottom",
                    children: menus
                };
            } else {
                return null;
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return TableMenu;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildPasteArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compute_data__ = __webpack_require__(10);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var getSelection = function getSelection() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "xls";
  var selectedRange = arguments[1];
  var columns = arguments[2];
  var filteredData = arguments[3];
  var updatedRows = arguments[4];
  var data = arguments[5];
  var params = arguments[6];

  var columnSeparator = type === "csv" ? "," : "\t";
  var rowStart = Math.min(selectedRange.start.rows, selectedRange.end.rows);
  var rowEnd = Math.max(selectedRange.start.rows, selectedRange.end.rows);
  var columnStart = Math.min(selectedRange.start.columns, selectedRange.end.columns);
  var columnEnd = Math.max(selectedRange.start.columns, selectedRange.end.columns);
  var outputs = [];
  var output = "";
  for (var iColumn = columnStart; iColumn <= columnEnd; iColumn++) {
    if (!columns[iColumn].hidden) {
      output += columnSeparator + JSON.stringify(columns[iColumn].caption);
    }
  }
  outputs.push(output.slice(1));
  for (var iRow = rowStart; iRow <= rowEnd; iRow++) {
    var row = filteredData[iRow];
    output = "";
    for (var _iColumn = columnStart; _iColumn <= columnEnd; _iColumn++) {
      var column = columns[_iColumn];
      if (!column.hidden) {
        var value = Object(__WEBPACK_IMPORTED_MODULE_1__compute_data__["a" /* cellData */])(row, column, updatedRows[row.index_], data, params, true).value;
        if (__WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].isNullOrUndefined(value)) {
          value = "";
        } else if (column.dataType === "date" && value !== null) {
          value = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].dateToString(value, undefined || "dd/mm/yyyy");
        }
        output += columnSeparator + JSON.stringify(value);
      }
    }
    outputs.push(output.slice(1));
  }
  return outputs.join("\n");
};
var buildPasteArray = function buildPasteArray() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "xls";
  var clipboard = arguments[1];
  var columns = arguments[2];
  var selectedCell = arguments[3];
  var selectCell = arguments[4];
  var onChange = arguments[5];
  var canQuit = arguments[6];
  var filteredData = arguments[7];
  var updatedRows = arguments[8];
  var data = arguments[9];
  var params = arguments[10];

  var columnSeparator = type === "csv" ? "," : "\t";

  var lines = clipboard.replace(/\r/g, "").split("\n");
  lines.pop();
  var cells = lines.map(function (line) {
    return line.split(columnSeparator);
  });

  var cellsValue = [];
  cells.forEach(function (rowCells, rowIndex) {
    var row = filteredData[selectedCell.rows + rowIndex];
    var columnIndex = 0;
    rowCells.forEach(function (value) {
      var col = selectedCell.columns + columnIndex < columns.length;
      var column = columns[selectedCell.columns + columnIndex];
      while (col && column.hidden && column.index_ + 1 < columns.length) {
        columnIndex++;
        col = selectedCell.columns + columnIndex < columns.length;
        column = columns[selectedCell.columns + columnIndex];
      }
      var cell = {
        rows: selectedCell.rows + rowIndex,
        columns: column.index_
      };
      var editable = col && column.editableFunction ? column.editableFunction({
        column: column,
        row: row,
        status: updatedRows[row.index_] || {},
        data: data,
        params: params
      }) : column.editable;
      if (editable) {
        var v = value;
        var _column = column,
            dataType = _column.dataType,
            format = _column.format;

        if (dataType === "boolean") {
          v = v === "true";
        } else if (dataType === "date") {
          v = __WEBPACK_IMPORTED_MODULE_0_zebulon_controls__["j" /* utils */].stringToDate(v, format);
        } else if (dataType === "number") {
          v = v === "" ? null : Number(value);
        }
        cell.value = v;
        cell.columnId = column.id;
        cellsValue.push(cell);
      }
      columnIndex++;
    });
  });
  //  mangement of callback and users interractions
  cellsValue.reverse();
  var cellValue = function cellValue(ok_, previousRow) {
    if (!ok_ || cellsValue.length === 0) {
      return;
    }
    var ok = ok_;
    var cell = cellsValue.pop();
    var cellV = function cellV(ok_) {
      var endCell = function endCell(ok_) {
        if (ok_ && cellsValue.length) {
          cellValue(ok_, cell.rows);
        }
      };
      if (!ok_) {
        return false;
      }
      selectCell(cell);
      var row = filteredData[cell.rows];
      var column = columns[cell.columns];
      // can change value
      if (!onChange(cell.value, row, column)) {
        return false;
      }
      row[cell.columnId] = cell.value;
      // object in select input
      if (column.reference && column.selectItems) {
        var item = Object.values(column.selectItems).find(function (item) {
          return column.accessorFunction({ row: _defineProperty({}, column.reference, item) }) === cell.value;
        });
        row[column.reference] = item;
        if (column.setForeignKeyAccessorFunction) {
          column.setForeignKeyAccessorFunction({
            value: item.pk_,
            row: row
          });
          // column.setForeignKeyAccessorFunction({
          //   value: column.primaryKeyAccessorFunction({
          //     row: { [column.reference]: item }
          //   }),
          //   row
          // });
        }
      }
      // can quit cell
      var ok = canQuit("cellQuit", endCell);
      if (ok !== undefined) {
        endCell(ok);
      }
    };
    // can quit row
    if (previousRow !== undefined && previousRow !== cell.rows) {
      ok = canQuit("rowQuit", cellV);
    }
    if (ok !== undefined) {
      cellV(ok);
    }
  };
  cellValue(true, undefined);
  return cells;
};

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rows; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_compute_data__ = __webpack_require__(10);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Rows = function (_ScrollableGrid) {
  _inherits(Rows, _ScrollableGrid);

  function Rows() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Rows);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rows.__proto__ || Object.getPrototypeOf(Rows)).call.apply(_ref, [this].concat(args))), _this), _this.cell = function (tableEditable, row, column, status, data, params, style, focused, hasFocus, selected, onMouseDown, onMouseUp, onMouseOver, onChange, onFocus, rowIndex, onDoubleClick, component) {
      var _cellData = Object(__WEBPACK_IMPORTED_MODULE_3__utils_compute_data__["a" /* cellData */])(row, column, status, data, params, focused),
          editable = _cellData.editable,
          value = _cellData.value,
          select = _cellData.select;

      var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
        "zebulon-table-cell": true,
        "zebulon-table-cell-odd": rowIndex % 2 === 1,
        "zebulon-table-cell-selected": selected,
        "zebulon-table-cell-focused": focused,
        "zebulon-table-cell-editable": editable && focused
      });
      var id = "cell: " + component + "-" + row.index_ + "-" + column.index_;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["e" /* Input */], {
        row: row,
        column: column,
        style: style,
        className: className,
        value: value,
        editable: editable && tableEditable,
        focused: focused,
        hasFocus: hasFocus,
        select: select,
        id: id,
        key: id,
        onChange: onChange,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onDoubleClick: onDoubleClick ? function (e) {
          return onDoubleClick(e, row, column);
        } : function () {},
        menu: "cell-menu",
        component: component,
        ref: function ref(_ref2) {
          if (focused && hasFocus) {
            _this.focused = _ref2;
          }
        }
      });
    }, _this.rowRenderer = function (tableEditable, row, status, meta, startIndex, shift, visibleWidth, rowHeight, rowIndex, hasFocus, component) {
      var cells = [];
      var left = shift,
          index = startIndex;
      var selectedRange = _this.selectedRange();
      while (index < meta.length && left < visibleWidth) {
        var column = meta[index];
        if (!column.hidden) {
          (function () {
            var textAlign = column.alignement || "left";
            if (!column.alignement) {
              if (column.dataType === "number") {
                textAlign = "right";
              } else if (column.dataType === "date" || column.dataType === "boolean") {
                textAlign = "center";
              }
            }
            var columnIndex = index;
            var selected = __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].isInRange({ columns: index, rows: rowIndex }, selectedRange.start, selectedRange.end),
                focused = selectedRange.end.rows === rowIndex && selectedRange.end.columns === index,
                onMouseDown = function onMouseDown(e) {
              e.preventDefault();
              _this.selectCell({ rows: rowIndex, columns: columnIndex }, e.shiftKey);
            },
                onMouseOver = function onMouseOver(e) {
              if ((e.buttons & 1) === 1 && !_this.noOver) {
                e.preventDefault();
                _this.selectCell({ rows: rowIndex, columns: columnIndex }, true);
              }
            },
                onMouseUp = function onMouseUp(e) {
              e.preventDefault();
              _this.mouseDown = false;
            };
            cells.push(_this.cell(tableEditable, row, column, status, _this.props.data, _this.props.params, {
              position: "absolute",
              left: left,
              width: Math.min(false ? column.computedWidth + shift : column.computedWidth, visibleWidth - left),
              height: rowHeight,
              textAlign: textAlign
            }, focused, hasFocus && focused, selected, onMouseDown, onMouseUp, onMouseOver, _this.props.onChange, _this.props.onFocus, rowIndex, _this.props.onDoubleClick, component));
            left += column.computedWidth;
          })();
        }
        index += 1;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        {
          key: rowIndex,
          id: rowIndex,
          style: {
            display: "flex",
            height: rowHeight
          }
        },
        cells
      );
    }, _this.getContent = function () {
      _this.noOver = true;
      var items = [];
      var _this$props = _this.props,
          data = _this$props.data,
          meta = _this$props.meta,
          height = _this$props.height,
          rowHeight = _this$props.rowHeight,
          width = _this$props.width,
          updatedRows = _this$props.updatedRows,
          hasFocus = _this$props.hasFocus,
          component = _this$props.component;

      var i = 0,
          index = _this.props.scroll.rows.startIndex,
          indexPage = 0,
          rows = data,
          columnStartIndex = _this.props.scroll.columns.startIndex,
          columnShift = _this.props.scroll.columns.shift;
      if ((typeof data === "undefined" ? "undefined" : _typeof(data)) === "object" && data.page) {
        rows = data.page;
        indexPage = data.pageStartIndex;
      }
      var visibleWidth = width - _this.scrollbars.vertical.width;
      if (!_this.props.noVerticalScrollbar) {
        columnStartIndex = Math.max(columnStartIndex, __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].isNullOrUndefined(meta.lockedIndex) ? 0 : meta.lockedIndex + 1);
      } else {
        columnStartIndex = 0;
        columnShift = 0;
      }
      while (index < rows.length && i < height / rowHeight) {
        var row = rows[index - indexPage];
        var status = updatedRows[row.index_];
        if (meta.serverPagination && status && status.rowUpdated) {
          row = status.rowUpdated;
        }
        items.push(_this.rowRenderer(meta.table.editable, row, status, meta.properties, columnStartIndex, columnShift, visibleWidth, rowHeight, index, hasFocus, component));
        index++;
        i++;
      }
      var style = {
        top: _this.props.scroll.rows.shift || 0,
        width: visibleWidth,
        position: "inherit",
        height: "inherit"
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { id: "content", style: style, onWheel: _this.onWheel },
        items
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Rows, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !nextProps.status.loadingPage && !nextProps.noUpdate;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // console.log("row", this.focused, this.props.hasFocus);
      if (this.focused && this.focused.input && this.focused.input.ref) {
        // && this.focused.props.dataType === "boolean"
        this.focused.input.ref.focus();
        // this.focused = undefined;
        // console.log("row", this.focused);
      }
      //  else if (this.focused) {
      //   this.focused.focus();
      // }
      this.noOver = false;
    }
  }]);

  return Rows;
}(__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["f" /* ScrollableGrid */]);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_compute_data__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Search = function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _initialiseProps.call(_this);

    var filteredData = props.filteredData,
        meta = props.meta,
        dataStrings = props.dataStrings,
        rowStartIndex = props.rowStartIndex,
        rowStopIndex = props.rowStopIndex;

    var properties = meta.properties.filter(function (property) {
      return !property.hidden;
    });
    _this.state = {
      dataStrings: Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_data__["e" /* computeRowSearch */])(filteredData, properties, dataStrings),
      value: "",
      properties: properties,
      cell: {},
      rowStartIndex: rowStartIndex,
      rowStopIndex: rowStopIndex
    };
    return _this;
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        { style: { display: "flex" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
          style: { width: 200 },
          onChange: function onChange(e) {
            return _this2.handleChange(e);
          },
          value: this.state.value,
          autoFocus: true,
          ref: function ref(_ref) {
            return _this2.input = _ref;
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          style: {
            background: __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["i" /* icons */].downArrow,
            backgroundSize: "cover",
            height: "1em",
            width: "1em",
            marginTop: "0.1em",
            marginRight: "0.1em"
          },
          onClick: function onClick() {
            return _this2.handleClickNext(1);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          style: {
            background: __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["i" /* icons */].upArrow,
            backgroundSize: "cover",
            height: "1em",
            width: "1em",
            marginTop: "0.4em",
            marginRight: "0.1em",
            zoom: 0.7
          },
          onClick: function onClick() {
            return _this2.handleClickNext(-1);
          }
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          style: {
            background: __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["i" /* icons */].close,
            backgroundSize: "cover",
            height: "1em",
            width: "1em",
            marginTop: "0.7em",
            zoom: 0.5,
            marginRight: "0.1em",
            marginLeft: ".6em"
          },
          onClick: this.props.onClose
        })
      );
    }
  }]);

  return Search;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleClickNext = function (direction) {
    var _state = _this3.state,
        cell = _state.cell,
        value = _state.value,
        rowIndexes = _state.rowIndexes,
        indexRowIndex = _state.indexRowIndex,
        properties = _state.properties;

    var exp = Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_data__["f" /* getRegExp */])(value);
    var cell_ = Object.assign({}, cell);
    var index = indexRowIndex;
    cell_.columns = Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_data__["b" /* cellSearch */])(_this3.props.filteredData[cell_.rows], properties, exp, cell_.columns + direction, direction);
    if (cell_.columns === null && (direction === 1 && index < rowIndexes.length - 1 || direction === -1 && index !== 0)) {
      index += direction;
      cell_.rows = rowIndexes[index];
      cell_.columns = Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_data__["b" /* cellSearch */])(_this3.props.filteredData[cell_.rows], properties, exp, direction === -1 ? properties.length - 1 : 0, direction);
    }
    if (cell_.columns !== null) {
      var cellRange = Object.assign({}, cell_, { columns: properties[cell_.columns].index_ });
      _this3.props.scrollTo(cellRange.rows, Math.sign(cellRange.rows - (_this3.state.cell.rows || 0)), cellRange.columns, Math.sign(cellRange.columns - (_this3.props.selectedCell.columns || 0)));
      _this3.setState({ cell: cell_, indexRowIndex: index });
    }
  };

  this.handleChange = function (e) {
    var value = e.target.value;
    var exp = Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_data__["f" /* getRegExp */])(value);
    var cell = { rows: undefined, columns: undefined };
    var ix = -1;
    if (!__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullValue(value && value !== _this3.state.value)) {
      var _props = _this3.props,
          rowStartIndex = _props.rowStartIndex,
          rowStopIndex = _props.rowStopIndex,
          filteredData = _props.filteredData;

      var rows = _this3.state.dataStrings;
      var rowIndexes = Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_data__["g" /* rowSearch */])(rows, exp);
      _this3.setState({ value: value, rowIndexes: rowIndexes });
      if (rowIndexes.length) {
        ix = rowIndexes.findIndex(function (index) {
          return index >= rowStartIndex && index <= rowStopIndex;
        });
        if (ix === -1) {
          if (rowIndexes[rowIndexes.length - 1] > rowStopIndex) {
            ix = rowIndexes.findIndex(function (index) {
              return index > rowStopIndex;
            });
          } else {
            ix = rowIndexes.length - 1;
          }
        }
        cell.rows = rowIndexes[ix];
        var row = filteredData[cell.rows];
        cell.columns = Object(__WEBPACK_IMPORTED_MODULE_2__utils_compute_data__["b" /* cellSearch */])(row, _this3.state.properties, exp);
        var cellRange = Object.assign({}, cell, {
          columns: _this3.state.properties[cell.columns].index_
        });
        _this3.props.scrollTo(cellRange.rows, Math.sign(cellRange.rows - (_this3.props.selectedCell.rows || 0)), cellRange.columns, Math.sign(cellRange.columns - (_this3.props.selectedCell.columns || 0)), true);
      }
      _this3.setState({ value: value, rowIndexes: rowIndexes, cell: cell, indexRowIndex: ix });
    } else {
      _this3.setState({ value: value, rowIndexes: [], cell: cell, indexRowIndex: -1 });
    }
    _this3.input.focus();
  };
};

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZebulonTableAndConfiguration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ZebulonTable__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_compute_meta__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ZebulonTableAndConfiguration = function (_Component) {
	_inherits(ZebulonTableAndConfiguration, _Component);

	function ZebulonTableAndConfiguration(props) {
		_classCallCheck(this, ZebulonTableAndConfiguration);

		var _this = _possibleConstructorReturn(this, (ZebulonTableAndConfiguration.__proto__ || Object.getPrototypeOf(ZebulonTableAndConfiguration)).call(this, props));

		_initialiseProps.call(_this);

		var f = props.functions; // || functions;
		// functions
		if (!Array.isArray(f)) {
			f = __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].mergeFunctions([__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["g" /* accessors */], __WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["a" /* functions */], f || {}], props.meta.table.object || "dataset");
		}
		var meta = props.meta;
		_this.initMeta(props.meta, props.callbacks, props.data, f, props.sizes.zoom);
		Object(__WEBPACK_IMPORTED_MODULE_5__utils_compute_meta__["b" /* computeMetaFromData */])(props.data, meta, props.sizes.zoom, f, props.utils);
		var state = {
			selectedTab: props.selectedTab || 0,
			data: props.data,
			meta: meta,
			updatedRows: props.updatedRows || {},
			propertiesUpdatedRows: {},
			functionsUpdatedRows: {},
			functions: f,
			sizes: props.sizes,
			filters: props.filters,
			status: {}
		};
		_this.zoomValue = props.sizes.zoom || 1;
		f = __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].mergeFunctions([__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["g" /* accessors */], __WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["a" /* functions */]], "properties");
		state.propertiesMeta = Object(__WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["b" /* metaDescriptions */])("properties", props.callbacks, state.functions);
		Object(__WEBPACK_IMPORTED_MODULE_5__utils_compute_meta__["a" /* computeMeta */])(state.propertiesMeta, props.sizes.zoom, state.functions, props.utils);
		state.functionsProperties = f;
		f = __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].mergeFunctions([__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["g" /* accessors */], __WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["a" /* functions */]], "functions");
		state.functionsMeta = Object(__WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["b" /* metaDescriptions */])("functions", props.callbacks, state.functions);
		Object(__WEBPACK_IMPORTED_MODULE_5__utils_compute_meta__["a" /* computeMeta */])(state.functionsMeta, props.sizes.zoom, state.functions, props.utils);
		state.functionsFunctions = f;
		// if (this.props.tabs) {
		// 	this.props.tabs.forEach((tab, index) => {
		// 		f = utils.mergeFunctions([accessors, functions], tab.id);
		// 		// f = utils.functionsTable({ [tab.id]: functions[tab.id] });
		// 		state[tab.id] = tab.data;
		// 		state[`${tab.id}Meta`] =
		// 			tab.meta ||
		// 			metaDescriptions(tab.id, props.callbacks, state.functions);
		// 		computeMetaFromData(
		// 			state[tab.id],
		// 			state[`${tab.id}Meta`],
		// 			props.sizes.zoom,
		// 			state.functions,
		// 			props.utils
		// 		);
		// 		state[`${tab.id}UpdatedRows`] = tab.updatedRows;
		// 		state[`${tab.id}Functions`] = f;
		// 		if (tab.selected) {
		// 			state.selectedTab = index + 3;
		// 		}
		// 	});
		// }
		_this.initTabsState(state, props, true);
		_this.state = state;
		// this.errorHandler = this.props.errorHandler || {};
		return _this;
	}

	_createClass(ZebulonTableAndConfiguration, [{
		key: "componentWillReceiveProps",
		value: function componentWillReceiveProps(nextProps) {
			var state = {};
			if (nextProps.keyEvent !== this.props.keyEvent) {
				this.handleKeyEvent(nextProps.keyEvent);
			} else {
				if (nextProps.data !== this.props.data || nextProps.meta !== this.props.meta || nextProps.filters !== this.props.filters || nextProps.functions !== this.props.functions) {
					var f = nextProps.functions; // || functions;
					if (!Array.isArray(f)) {
						f = __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].functionsTable(f);
					}
					this.initMeta(nextProps.meta, nextProps.callbacks, nextProps.data, f, nextProps.sizes.zoom);
					state = {
						data: nextProps.data,
						meta: nextProps.meta,
						functions: f,
						filters: nextProps.filters
					};
				}
				if (nextProps.updatedRows && nextProps.updatedRows !== this.props.updatedRows) {
					state.updatedRows = nextProps.updatedRows;
				}
				if (nextProps.sizes !== this.props.sizes) {
					state.sizes = nextProps.sizes;
				}
				if (nextProps.tabs) {
					state = this.initTabsState(state, nextProps);
				}
				this.setState(state);
			}
		}
	}, {
		key: "shouldComponentUpdate",
		value: function shouldComponentUpdate(nextProps, nextState) {
			return nextProps.keyEvent === this.props.keyEvent;
		}

		// onTableEnter = ({ meta }) => {
		// 	computeMeta(meta, this.zoomValue, this.state.functions);
		// };

	}, {
		key: "render",
		value: function render() {
			var _this2 = this;

			if (this.props.status.loading || this.props.status.loadingConfig) {
				return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					null,
					"Loading data..."
				);
			} else if (this.props.status.error) {
				if (this.props.status.error.message === "No rows retrieved") {
					// return (
					// 	<div style={{ width: "max-content" }}>
					// 		No rows retrieved
					// 	</div>
					// );
				} else {
					return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
						"div",
						{ style: { color: "red", width: "max-content" } },
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							"p",
							null,
							this.props.status.error.type
						),
						__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							"p",
							null,
							this.props.status.error.message
						)
					);
				}
			}
			this.tabs = this.initTabs(this.props);
			var zoomValue = this.zoomValue;
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				"div",
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					{
						style: {
							display: "flex",
							height: 25 * zoomValue
						},
						className: "zebulon-tabs-list"
					},
					this.tabs.map(function (tab, index) {
						return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
							"div",
							{
								key: index,
								style: {
									width: (100 / _this2.tabs.length).toFixed(2) + "%"
								},
								className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()({
									"zebulon-tabs-tab": true,
									"zebulon-tabs-tab-selected": index === _this2.state.selectedTab
								}),
								onClick: function onClick() {
									return _this2.onSelectTab(index);
								}
							},
							tab.caption
						);
					})
				),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
					"div",
					{
						style: {
							height: this.props.sizes.height - 30 * zoomValue
						}
					},
					this.tabs.map(function (tab) {
						return tab.content;
					})
				)
			);
		}
	}]);

	return ZebulonTableAndConfiguration;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var _initialiseProps = function _initialiseProps() {
	var _this3 = this;

	this.initTabsState = function (state, props, constructor) {
		if (props.tabs) {
			props.tabs.forEach(function (tab, index) {
				if (tab.props === undefined) {
					tab.props = {};
				}
				if (tab.selected && state.selectedTab !== index + 3) {
					state.selectedTab = index + 3;
				}
				if (constructor || !_this3.props.tabs || !_this3.props.tabs[index] || _this3.props.tabs[index].id !== tab.id || tab.data !== _this3.props.tabs[index].data) {
					var f = tab.props.functions || __WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["j" /* utils */].mergeFunctions([__WEBPACK_IMPORTED_MODULE_2_zebulon_controls__["g" /* accessors */], __WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["a" /* functions */]], tab.id);
					// f = utils.functionsTable({ [tab.id]: functions[tab.id] });
					state[tab.id] = tab.data;

					state[tab.id + "Meta"] = tab.meta || Object(__WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["b" /* metaDescriptions */])(tab.id, props.callbacks, state.functions);
					if (state[tab.id + "Meta"]) {
						Object(__WEBPACK_IMPORTED_MODULE_5__utils_compute_meta__["b" /* computeMetaFromData */])(state[tab.id], state[tab.id + "Meta"], props.sizes.zoom, f, props.utils);
						state[tab.id + "UpdatedRows"] = tab.updatedRows;
						state[tab.id + "Functions"] = f;
					}
				}
			});
		}
		return state;
	};

	this.initMeta = function (meta_, callbacks, data, functions, zoom) {
		if (!meta_.table) {
			var meta = Object(__WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["b" /* metaDescriptions */])("dataset", callbacks, functions);
			meta_.table = meta.table;
			meta_.row = meta.row;
			meta_.properties = meta.properties;
			// meta = meta_;
		}
		if (data && Array.isArray(data) && data.length && meta_.properties) {
			if (meta_.properties.length === 0) {
				Object(__WEBPACK_IMPORTED_MODULE_5__utils_compute_meta__["b" /* computeMetaFromData */])(data, meta_, zoom, functions, _this3.props.utils);
			}
			Object(__WEBPACK_IMPORTED_MODULE_4__MetaDescriptions__["c" /* setPropertyAccessors */])(meta_.properties, data);
		}
	};

	this.handleKeyEvent = function (e) {
		// if (utils.isNavigationKey(e) || utils.isZoom(e)) {
		var tab = _this3.tabs[_this3.state.selectedTab].id;
		if (_this3[tab] && _this3[tab].handleKeyEvent) {
			return _this3[tab].handleKeyEvent(e);
		}
		// }
	};

	this.onChangeProperties = function (_ref) {
		var value = _ref.value,
		    previousValue = _ref.previousValue,
		    column = _ref.column,
		    row = _ref.row;

		if (["select", "dataType"].includes(column.id) && value !== previousValue && [value, previousValue, row.dataType].includes("joined object")) {
			_this3.changedProperties = true;
		}
	};

	this.onRowDelete = function (_ref2) {
		var row = _ref2.row,
		    status = _ref2.status;

		console.log(row, status);
		row.deleted_ = status.deleted_;
		_this3.changedProperties = true;
	};

	this.onRowNew = function (message) {
		_this3.changedProperties = true;
	};

	this.onGetData = function (_ref3) {
		var data = _ref3.data,
		    meta = _ref3.meta,
		    status = _ref3.status;

		if (data && meta.table.object === "dataset" && _this3.changedProperties) {
			var _state = _this3.state,
			    _functions = _state.functions,
			    sizes = _state.sizes;

			_this3.changedProperties = false;
			_this3.initMeta(meta, _this3.props.callbacks, data, _functions, sizes.zoom);
		}
		return true;
	};

	this.initTabs = function (props) {
		var params = props.params,
		    utils = props.utils,
		    configurationMenus = props.configurationMenus,
		    id = props.id,
		    navigationKeyHandler = props.navigationKeyHandler,
		    errorHandler = props.errorHandler;
		var _state2 = _this3.state,
		    selectedTab = _state2.selectedTab,
		    data = _state2.data,
		    meta = _state2.meta,
		    filters = _state2.filters,
		    updatedRows = _state2.updatedRows,
		    functions = _state2.functions,
		    sizes = _state2.sizes,
		    status = _state2.status,
		    functionsFunctions = _state2.functionsFunctions,
		    functionUpdatedRows = _state2.functionUpdatedRows,
		    functionsMeta = _state2.functionsMeta,
		    functionsProperties = _state2.functionsProperties,
		    propertiesMeta = _state2.propertiesMeta,
		    propertiesUpdatedRows = _state2.propertiesUpdatedRows;

		var menu = configurationMenus || {};
		var tabs = [{
			id: "dataset",
			caption: "Dataset",
			content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ZebulonTable__["a" /* ZebulonTable */], {
				key: 0,
				id: id + "-dataset",
				visible: selectedTab === 0,
				isActive: selectedTab === 0,
				data: data,
				meta: meta,
				filters: filters,
				updatedRows: updatedRows,
				sizes: sizes,
				functions: functions,
				params: params,
				keyEvent: null,
				onTableEnter: _this3.onTableEnter,
				ref: function ref(_ref4) {
					return _this3.dataset = _ref4;
				},
				errorHandler: errorHandler,
				navigationKeyHandler: navigationKeyHandler,
				onGetData: _this3.onGetData,
				utils: utils,
				contextualMenu: menu.dataset ? menu.dataset(_this3) : undefined
			})
		}, {
			id: "properties",
			caption: "Properties",
			content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ZebulonTable__["a" /* ZebulonTable */], {
				key: 1,
				id: id + "-properties",
				visible: selectedTab === 1,
				isActive: selectedTab === 1,
				data: meta.properties,
				meta: propertiesMeta,
				updatedRows: propertiesUpdatedRows,
				sizes: sizes,
				onChange: _this3.onChangeProperties,
				onRowDelete: _this3.onRowDelete,
				onRowNew: _this3.onRowNew
				// onTableEnter={this.onTableEnter}
				, functions: functionsProperties,
				status: status,
				params: params,
				keyEvent: null,
				ref: function ref(_ref5) {
					return _this3.properties = _ref5;
				},
				errorHandler: {},
				utils: utils,
				contextualMenu: menu.properties ? menu.properties(_this3) : undefined

				// navigationKeyHandler={navigationKeyHandler}
			})
		}, {
			id: "functions",
			caption: "Functions",
			content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ZebulonTable__["a" /* ZebulonTable */], {
				key: 2,
				id: id + "-functions",
				visible: selectedTab === 2,
				isActive: selectedTab === 2,
				data: functions,
				meta: functionsMeta,
				updatedRows: functionUpdatedRows,
				sizes: sizes,
				functions: functionsFunctions,
				params: params
				// onTableEnter={this.onTableEnter}
				, keyEvent: null,
				ref: function ref(_ref6) {
					return _this3.functions = _ref6;
				},
				errorHandler: {},
				utils: utils,
				contextualMenu: menu.functions ? menu.functions(_this3) : undefined
			})
		}];
		if (props.tabs) {
			props.tabs.forEach(function (tab, index) {
				var Content = tab.content ? tab.content : __WEBPACK_IMPORTED_MODULE_3__ZebulonTable__["a" /* ZebulonTable */];
				tabs.push({
					id: tab.id,
					caption: tab.caption,
					content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content, {
						key: 3 + index,
						id: id + "-" + tab.id,
						visible: selectedTab === tabs.length,
						data: _this3.state[tab.id],
						meta: _this3.state[tab.id + "Meta"],
						updatedRows: _this3.state[tab.id + "UpdatedRows"],
						sizes: sizes,
						functions: _this3.state[tab.id + "Functions"],
						params: params
						// onTableEnter={this.onTableEnter}
						, keyEvent: null,
						ref: function ref(_ref7) {
							return _this3[tab.id] = _ref7;
						},
						errorHandler: {},
						utils: utils,
						contextualMenu: menu[tab.id] ? menu[tab.id](_this3) : undefined
					}), Object.assign({}, tab.props))
				});
			});
		}

		return tabs;
	};

	this.onSelectTab = function (index) {
		var selectedTab = _this3.state.selectedTab;

		var canQuit = _this3[_this3.tabs[selectedTab].id].table ? _this3[_this3.tabs[selectedTab].id].table.canQuit : null;
		if (canQuit) {
			canQuit("quit", function (ok) {
				if (ok) {
					Object(__WEBPACK_IMPORTED_MODULE_5__utils_compute_meta__["a" /* computeMeta */])(_this3.state.meta, _this3.zoomValue, _this3.state.functions, _this3.props.utils);
					_this3.setState({ selectedTab: index });
				}
			});
		} else {
			_this3.setState({ selectedTab: index });
		}
	};
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{data:[],pushedData:[],meta:undefined};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* PUSH_DATA */]:return Object.assign({},state,{pushedData:action.pushedData});case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_DATA */]:return{data:[],pushedData:[]};case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* FETCH_SUCCESS */]:// console.log(FETCH_SUCCESS, action.data);
return{data:action.data,pushedData:[],meta:action.meta||state.meta};default:return state;}});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{loading:false,loaded:false,error:undefined,loadingConfig:false,pushed:false};var action=arguments[1];var type=action.type,error=action.error;switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_DATA */]:return Object.assign({},state,{loading:true,loaded:false,error:undefined,pushed:false});case __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* FETCH_FAILURE */]:return Object.assign({},state,{loading:false,loaded:false,error:error});case __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* FETCH_SUCCESS */]:return Object.assign({},state,{loading:false,loaded:true,error:undefined});case __WEBPACK_IMPORTED_MODULE_0__constants__["p" /* PUSH_DATA */]:return Object.assign({},state,{pushed:true});case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* LOADING_CONFIG */]:return Object.assign({},state,{loadingConfig:action.loading});// just to force the refresh
case __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* CHANGE_SORT_ORDER */]:return Object.assign({},state,{refreshDisplay:!state.refreshDisplay});default:return state;}});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// function getNextZoom(previousZoom, zoomIn) {
//   const zoomValues = [
//     0.25,
//     0.33,
//     0.5,
//     0.67,
//     0.75,
//     0.9,
//     1,
//     1.1,
//     1.25,
//     1.5,
//     1.75,
//     2,
//     2.5,
//     3,
//     4,
//     5
//   ];
//   const zoomIndex = zoomValues.indexOf(previousZoom);
//   let nextZoomIndex;
//   if (zoomIn) {
//     nextZoomIndex = Math.min(zoomIndex + 1, zoomValues.length - 1);
//   } else {
//     nextZoomIndex = Math.max(zoomIndex - 1, 0);
//   }
//   return zoomValues[nextZoomIndex];
// }
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var type=action.type,property=action.property,value=action.value,id=action.id,oldAxis=action.oldAxis,newAxis=action.newAxis,zoomValue=action.zoomValue;switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* MOVE_DIMENSION */]:if(id===__WEBPACK_IMPORTED_MODULE_0__constants__["m" /* MEASURE_ID */]&&oldAxis!==newAxis){return Object.assign({},state,{measureHeadersAxis:newAxis});}else return state;case __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* SET_CONFIG_PROPERTY */]:return Object.assign({},state,_defineProperty({},property,value));case __WEBPACK_IMPORTED_MODULE_0__constants__["E" /* ZOOM */]:return Object.assign({},state,{zoom:zoomValue});// case ZOOM_OUT:
//   return { ...state, zoom: getNextZoom(state.zoom, false) };
default:return state;}});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var type=action.type,dimensions=action.dimensions;// let sort;
switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* LOADING_CONFIG */]:if(action.loading){return{};}else{return state;}case __WEBPACK_IMPORTED_MODULE_0__constants__["w" /* SET_DIMENSIONS */]:return dimensions.reduce(function(acc,dimension){return Object.assign({},acc,_defineProperty({},dimension.id,dimension));},{});default:return state;}});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var type=action.type,measures=action.measures;switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* LOADING_CONFIG */]:if(action.loading){return{};}else{return state;}case __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* SET_MEASURES */]:return measures.reduce(function(acc,measure){return Object.assign({},acc,_defineProperty({},measure.id,measure));},{});default:return state;}});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{rows:[],columns:[],dimensions:[],measures:[]};var action=arguments[1];var type=action.type,id=action.id,position=action.position,oldAxis=action.oldAxis,newAxis=action.newAxis,axis=action.axis;var newAxisValue=void 0;var oldAxisValue=void 0;var oldPosition=void 0;var positionToRemove=void 0;var newPosition=position;switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* LOADING_CONFIG */]:if(action.loading){return{rows:[],columns:[],dimensions:[],measures:[]};}else{return state;}case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* MOVE_DIMENSION */]:if(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(newPosition)&&newAxis!==oldAxis){newPosition=state[newAxis].length;}if(oldAxis!==newAxis){var _Object$assign;oldAxisValue=state[oldAxis].filter(function(dimension){return dimension!==id;});newAxisValue=[].concat(_toConsumableArray(state[newAxis].slice(0,newPosition)),[id],_toConsumableArray(state[newAxis].slice(newPosition)));return Object.assign({},state,(_Object$assign={},_defineProperty(_Object$assign,oldAxis,oldAxisValue),_defineProperty(_Object$assign,newAxis,newAxisValue),_Object$assign));}oldPosition=state[oldAxis].indexOf(id);if(oldPosition===newPosition){return state;}newAxisValue=[].concat(_toConsumableArray(state[oldAxis].slice(0,newPosition)),[id],_toConsumableArray(state[oldAxis].slice(newPosition)));if(oldPosition>-1){// in this case, we need to remove the value at old position
if(oldPosition<newPosition){positionToRemove=oldPosition;}else{positionToRemove=oldPosition+1;}newAxisValue=[].concat(_toConsumableArray(newAxisValue.slice(0,positionToRemove)),_toConsumableArray(newAxisValue.slice(positionToRemove+1)));}return Object.assign({},state,_defineProperty({},newAxis,newAxisValue));case __WEBPACK_IMPORTED_MODULE_0__constants__["o" /* MOVE_MEASURE */]:if(__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].isNullOrUndefined(newPosition)){newPosition=state.measures.length;}oldPosition=state.measures.indexOf(id);if(oldPosition===newPosition){return state;}newAxisValue=[].concat(_toConsumableArray(state.measures.slice(0,Math.max(oldPosition,0))),_toConsumableArray(state.measures.slice(oldPosition+1)));newAxisValue=[].concat(_toConsumableArray(newAxisValue.slice(0,newPosition)),[id],_toConsumableArray(newAxisValue.slice(newPosition)));return Object.assign({},state,{measures:newAxisValue});case __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* TOGGLE_MEASURE */]:oldPosition=state.measures.indexOf(id);if(oldPosition>-1){return Object.assign({},state,{measures:[].concat(_toConsumableArray(state.measures.slice(0,oldPosition)),_toConsumableArray(state.measures.slice(oldPosition+1)))});}else{return Object.assign({},state,{measures:[].concat(_toConsumableArray(state.measures),[id])});}case __WEBPACK_IMPORTED_MODULE_0__constants__["t" /* SET_AXIS */]:return Object.assign({},state,axis);default:return state;}});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{heights:{},widths:{}};var action=arguments[1];var type=action.type,direction=action.direction,sizes=action.sizes;switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["D" /* UPDATE_CELL_SIZE */]:return Object.assign({},state,_defineProperty({},direction,Object.assign({},state[direction],sizes)));case __WEBPACK_IMPORTED_MODULE_0__constants__["y" /* SET_SIZES */]:return Object.assign({},state,sizes);default:return state;}});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];var type=action.type,dimension=action.dimension,filter=action.filter;switch(type){// Eventually users will be able to define filters in config
case __WEBPACK_IMPORTED_MODULE_0__constants__["v" /* SET_CONFIG_PROPERTY */]:return state;case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_FILTER */]:return Object.assign({},state,_defineProperty({},dimension,filter));case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DELETE_FILTER */]:{/* eslint-disable no-unused-vars */var deleted=state[dimension],newState=_objectWithoutProperties(state,[dimension]);/* eslint-enable */return newState;}default:return state;}});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*
Collapses are needed to compute number of visible rows(or columns), displays... on the whole data set.
The best moment to compute required data is during the calculation of headers trees (additional cost close to 0)
when the data set is very large, it may take significant time to recompute the axis trees...,
In consequence, for performance purpose, the collapses calculations are only when executed the axis trees have to be.
The intermediate change in the collapse description are managed by mutating the objects (headers).
to avoid that the selector refired in this case, collapses are managed at 2 levels, the config level (used by the axis tree selector) and the standard level
(used for the rest).
When the axis tree must be recalculated, the config level must be set as the standard level.
*//* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{rows:{},columns:{},dimensions:{},configurationRows:{},nVisibleRows:0,configurationColumns:{},nVisibleColumns:0};var action=arguments[1];var type=action.type,axis=action.axis,key=action.key,keys=action.keys,collapses=action.collapses,n=action.n;var newState=void 0;switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["e" /* EXPAND_COLLAPSE */]:newState=Object.assign({},state,_defineProperty({},axis,Object.assign({},state[axis],_defineProperty({},key,!state[axis][key]))));if(axis==="rows"){newState.nVisibleRows+=n;}else if(axis==="columns"){newState.nVisibleColumns+=n;}return newState;case __WEBPACK_IMPORTED_MODULE_0__constants__["f" /* EXPAND_COLLAPSE_ALL */]:newState=Object.assign({},state,_defineProperty({},axis,Object.assign({},state[axis],keys)));return newState;// apply actual collapses to confix collapses as header Trees will be recalculate
// case DELETE_FILTER:
// case ADD_FILTER:
case __WEBPACK_IMPORTED_MODULE_0__constants__["x" /* SET_MEASURES */]:case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* MOVE_DIMENSION */]:case __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* ADD_FILTER */]:case __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* DELETE_FILTER */]:case __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* TOGGLE_SUBTOTAL */]:case __WEBPACK_IMPORTED_MODULE_0__constants__["A" /* TOGGLE_MEASURE */]:var rows=Object.assign({},state.configurationRows,state.rows);var columns=Object.assign({},state.configurationColumns,state.columns);return{rows:rows,columns:columns,dimensions:state.dimensions,configurationRows:rows,nVisibleColumns:0,nVisibleRows:0,configurationColumns:columns};case __WEBPACK_IMPORTED_MODULE_0__constants__["u" /* SET_COLLAPSES */]:return Object.assign({},state,collapses);default:return state;}});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{start:{rows:null,columns:null},end:{rows:null,columns:null},scrollToRow:{index:0,direction:1},scrollToColumn:{index:0,direction:1}};var action=arguments[1];var type=action.type,selectedRange=action.selectedRange,scrollToRow=action.scrollToRow,scrollToColumn=action.scrollToColumn;switch(type){case __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* FETCH_DATA */]:case __WEBPACK_IMPORTED_MODULE_0__constants__["n" /* MOVE_DIMENSION */]:return Object.assign({},state,{start:{rows:null,columns:null},end:{rows:null,columns:null}});case __WEBPACK_IMPORTED_MODULE_0__constants__["s" /* SELECT_RANGE */]:return Object.assign({},state,selectedRange);case __WEBPACK_IMPORTED_MODULE_0__constants__["r" /* SCROLL */]:var nextState=Object.assign({},state);if(scrollToRow!==null){nextState.scrollToRow=scrollToRow;}if(scrollToColumn!==null){nextState.scrollToColumn=scrollToColumn;}return nextState;default:return state;}});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__constants__["B" /* TOGGLE_SUBTOTAL */]:return Object.assign({},state,_defineProperty({},action.dimensionId,!state[action.dimensionId]));default:return state;}});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configurationMenus; });
var newAxis=function newAxis(e,type,axis,caller){// console.log("Column menu 0", e, caller);
var table=caller[type].table;var index=table.state.selectedRange.end.rows;var row=void 0,tabIndex=void 0;if(type==="dimensions"){tabIndex=4;row={id:e[axis].id,keyAccessor:e[axis].accessor||"row."+e[axis].id,format:e[axis].format,index_:table.getDataLength(),isLocal:true};}else if(type==="measures"){tabIndex=3;row={id:e[axis].id,aggregation:"sum",valueAccessor:e[axis].accessor||"row."+e[axis].id,format:e[axis].format,index_:table.getDataLength(),isLocal:true};}caller.setState({selectedTab:tabIndex});table.newRow_(row,index);};var configurationMenus={dataset:function dataset(caller){return function(){return{"column-header-menu":[{code:"dimension",caption:"New dimension",type:"MenuItem",function:function _function(e){return newAxis(e,"dimensions","column",caller);}},{code:"measure",caption:"New measure",type:"MenuItem",function:function _function(e){return newAxis(e,"measures","column",caller);}}]};};},properties:function properties(caller){return function(state,props){return{"row-header-menu":[{code:"dimension",caption:"New dimension",type:"MenuItem",function:function _function(e){return newAxis(e,"dimensions","row",caller);}},{code:"measure",caption:"New measure",type:"MenuItem",function:function _function(e){return newAxis(e,"measures","row",caller);}}]};};}};

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* eslint-disable */// https://tc39.github.io/ecma262/#sec-array.prototype.find
if(!Array.prototype.find){Object.defineProperty(Array.prototype,'find',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return kValue.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return kValue;}// e. Increase k by 1.
k++;}// 7. Return undefined.
return undefined;}});}// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if(!Array.prototype.includes){Object.defineProperty(Array.prototype,'includes',{value:function value(searchElement,fromIndex){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If len is 0, return false.
if(len===0){return false;}// 4. Let n be ? ToInteger(fromIndex).
//    (If fromIndex is undefined, this step produces the value 0.)
var n=fromIndex|0;// 5. If n ≥ 0, then
//  a. Let k be n.
// 6. Else n < 0,
//  a. Let k be len + n.
//  b. If k < 0, let k be 0.
var k=Math.max(n>=0?n:len-Math.abs(n),0);function sameValueZero(x,y){return x===y||typeof x==='number'&&typeof y==='number'&&isNaN(x)&&isNaN(y);}// 7. Repeat, while k < len
while(k<len){// a. Let elementK be the result of ? Get(O, ! ToString(k)).
// b. If SameValueZero(searchElement, elementK) is true, return true.
// c. Increase k by 1.
if(sameValueZero(o[k],searchElement)){return true;}k++;}// 8. Return false
return false;}});}// https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
if(!Array.prototype.findIndex){Object.defineProperty(Array.prototype,'findIndex',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return k.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return k;}// e. Increase k by 1.
k++;}// 7. Return -1.
return-1;}});}var values=__webpack_require__(116);if(!Object.values){values.shim();}// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if(!Object.keys){Object.keys=function(){'use strict';var hasOwnProperty=Object.prototype.hasOwnProperty,hasDontEnumBug=!{toString:null}.propertyIsEnumerable('toString'),dontEnums=['toString','toLocaleString','valueOf','hasOwnProperty','isPrototypeOf','propertyIsEnumerable','constructor'],dontEnumsLength=dontEnums.length;return function(obj){if(typeof obj!=='function'&&((typeof obj==='undefined'?'undefined':_typeof(obj))!=='object'||obj===null)){throw new TypeError('Object.keys called on non-object');}var result=[],prop,i;for(prop in obj){if(hasOwnProperty.call(obj,prop)){result.push(prop);}}if(hasDontEnumBug){for(i=0;i<dontEnumsLength;i++){if(hasOwnProperty.call(obj,dontEnums[i])){result.push(dontEnums[i]);}}}return result;};}();}// Production steps of ECMA-262, Edition 5, 15.4.4.22
// Reference: http://es5.github.io/#x15.4.4.22
if('function'!==typeof Array.prototype.reduceRight){Array.prototype.reduceRight=function(callback/*, initialValue*/){'use strict';if(null===this||'undefined'===typeof this){throw new TypeError('Array.prototype.reduce called on null or undefined');}if('function'!==typeof callback){throw new TypeError(callback+' is not a function');}var t=Object(this),len=t.length>>>0,k=len-1,value;if(arguments.length>=2){value=arguments[1];}else{while(k>=0&&!(k in t)){k--;}if(k<0){throw new TypeError('Reduce of empty array with no initial value');}value=t[k--];}for(;k>=0;k--){if(k in t){value=callback(value,t[k],k,t);}}return value;};}

/***/ }),
/* 366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function() {
  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};

module.exports.Resizable = __webpack_require__(128).default;
module.exports.ResizableBox = __webpack_require__(371).default;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(67), __webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react-dom", "react"], factory);
	else if(typeof exports === 'object')
		exports["ReactDraggable"] = factory(require("react-dom"), require("react"));
	else
		root["ReactDraggable"] = factory(root["ReactDOM"], root["React"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_6__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 12);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findInArray = findInArray;
exports.isFunction = isFunction;
exports.isNum = isNum;
exports.int = int;
exports.dontSetMe = dontSetMe;

// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
  for (var i = 0, length = array.length; i < length; i++) {
    if (callback.apply(callback, [array[i], i, array])) return array[i];
  }
}

function isFunction(func /*: any*/) /*: boolean*/ {
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}

function isNum(num /*: any*/) /*: boolean*/ {
  return typeof num === 'number' && !isNaN(num);
}

function int(a /*: string*/) /*: number*/ {
  return parseInt(a, 10);
}

function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
  if (props[propName]) {
    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
  }
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.matchesSelector = matchesSelector;
exports.matchesSelectorAndParentsTo = matchesSelectorAndParentsTo;
exports.addEvent = addEvent;
exports.removeEvent = removeEvent;
exports.outerHeight = outerHeight;
exports.outerWidth = outerWidth;
exports.innerHeight = innerHeight;
exports.innerWidth = innerWidth;
exports.offsetXYFromParent = offsetXYFromParent;
exports.createCSSTransform = createCSSTransform;
exports.createSVGTransform = createSVGTransform;
exports.getTouch = getTouch;
exports.getTouchIdentifier = getTouchIdentifier;
exports.addUserSelectStyles = addUserSelectStyles;
exports.removeUserSelectStyles = removeUserSelectStyles;
exports.styleHacks = styleHacks;
exports.addClassName = addClassName;
exports.removeClassName = removeClassName;

var _shims = __webpack_require__(0);

var _getPrefix = __webpack_require__(19);

var _getPrefix2 = _interopRequireDefault(_getPrefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*:: import type {ControlPosition, MouseTouchEvent} from './types';*/


var matchesSelectorFunc = '';
function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
  if (!matchesSelectorFunc) {
    matchesSelectorFunc = (0, _shims.findInArray)(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
      // $FlowIgnore: Doesn't think elements are indexable
      return (0, _shims.isFunction)(el[method]);
    });
  }

  // Might not be found entirely (not an Element?) - in that case, bail
  // $FlowIgnore: Doesn't think elements are indexable
  if (!(0, _shims.isFunction)(el[matchesSelectorFunc])) return false;

  // $FlowIgnore: Doesn't think elements are indexable
  return el[matchesSelectorFunc](selector);
}

// Works up the tree to the draggable itself attempting to match selector.
function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
  var node = el;
  do {
    if (matchesSelector(node, selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);

  return false;
}

function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else if (el.addEventListener) {
    el.addEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = handler;
  }
}

function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
  if (!el) {
    return;
  }
  if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else if (el.removeEventListener) {
    el.removeEventListener(event, handler, true);
  } else {
    // $FlowIgnore: Doesn't think elements are indexable
    el['on' + event] = null;
  }
}

function outerHeight(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetTop which is including margin. See getBoundPosition
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height += (0, _shims.int)(computedStyle.borderTopWidth);
  height += (0, _shims.int)(computedStyle.borderBottomWidth);
  return height;
}

function outerWidth(node /*: HTMLElement*/) /*: number*/ {
  // This is deliberately excluding margin for our calculations, since we are using
  // offsetLeft which is including margin. See getBoundPosition
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width += (0, _shims.int)(computedStyle.borderLeftWidth);
  width += (0, _shims.int)(computedStyle.borderRightWidth);
  return width;
}
function innerHeight(node /*: HTMLElement*/) /*: number*/ {
  var height = node.clientHeight;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  height -= (0, _shims.int)(computedStyle.paddingTop);
  height -= (0, _shims.int)(computedStyle.paddingBottom);
  return height;
}

function innerWidth(node /*: HTMLElement*/) /*: number*/ {
  var width = node.clientWidth;
  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
  width -= (0, _shims.int)(computedStyle.paddingLeft);
  width -= (0, _shims.int)(computedStyle.paddingRight);
  return width;
}

// Get from offsetParent
function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
  var isBody = offsetParent === offsetParent.ownerDocument.body;
  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();

  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

  return { x: x, y: y };
}

function createCSSTransform(_ref) /*: Object*/ {
  var x = _ref.x,
      y = _ref.y;

  // Replace unitless items with px
  return _defineProperty({}, (0, _getPrefix.browserPrefixToKey)('transform', _getPrefix2.default), 'translate(' + x + 'px,' + y + 'px)');
}

function createSVGTransform(_ref3) /*: string*/ {
  var x = _ref3.x,
      y = _ref3.y;

  return 'translate(' + x + ',' + y + ')';
}

function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
  return e.targetTouches && (0, _shims.findInArray)(e.targetTouches, function (t) {
    return identifier === t.identifier;
  }) || e.changedTouches && (0, _shims.findInArray)(e.changedTouches, function (t) {
    return identifier === t.identifier;
  });
}

function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
}

// User-select Hacks:
//
// Useful for preventing blue highlights all over everything when dragging.

// Note we're passing `document` b/c we could be iframed
function addUserSelectStyles(doc /*: ?Document*/) {
  if (!doc) return;
  var styleEl = doc.getElementById('react-draggable-style-el');
  if (!styleEl) {
    styleEl = doc.createElement('style');
    styleEl.type = 'text/css';
    styleEl.id = 'react-draggable-style-el';
    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {background: transparent;}\n';
    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {background: transparent;}\n';
    doc.getElementsByTagName('head')[0].appendChild(styleEl);
  }
  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
}

function removeUserSelectStyles(doc /*: ?Document*/) {
  try {
    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
    window.getSelection().removeAllRanges(); // remove selection caused by scroll
  } catch (e) {
    // probably IE
  }
}

function styleHacks() /*: Object*/ {
  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // Workaround IE pointer events; see #51
  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
  return _extends({
    touchAction: 'none'
  }, childStyle);
}

function addClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.add(className);
  } else {
    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
      el.className += ' ' + className;
    }
  }
}

function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
  if (el.classList) {
    el.classList.remove(className);
  } else {
    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
  }
}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_6__;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(14)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(17)();
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundPosition = getBoundPosition;
exports.snapToGrid = snapToGrid;
exports.canDragX = canDragX;
exports.canDragY = canDragY;
exports.getControlPosition = getControlPosition;
exports.createCoreData = createCoreData;
exports.createDraggableData = createDraggableData;

var _shims = __webpack_require__(0);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*:: import type Draggable from '../Draggable';*/
/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
/*:: import type DraggableCore from '../DraggableCore';*/
function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
  // If no bounds, short-circuit and move on
  if (!draggable.props.bounds) return [x, y];

  // Clone new bounds
  var bounds = draggable.props.bounds;

  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
  var node = findDOMNode(draggable);

  if (typeof bounds === 'string') {
    var ownerDocument = node.ownerDocument;

    var ownerWindow = ownerDocument.defaultView;
    var boundNode = void 0;
    if (bounds === 'parent') {
      boundNode = node.parentNode;
    } else {
      boundNode = ownerDocument.querySelector(bounds);
    }
    if (!(boundNode instanceof HTMLElement)) {
      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
    }
    var nodeStyle = ownerWindow.getComputedStyle(node);
    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
    bounds = {
      left: -node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingLeft) + (0, _shims.int)(nodeStyle.marginLeft),
      top: -node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingTop) + (0, _shims.int)(nodeStyle.marginTop),
      right: (0, _domFns.innerWidth)(boundNode) - (0, _domFns.outerWidth)(node) - node.offsetLeft + (0, _shims.int)(boundNodeStyle.paddingRight) - (0, _shims.int)(nodeStyle.marginRight),
      bottom: (0, _domFns.innerHeight)(boundNode) - (0, _domFns.outerHeight)(node) - node.offsetTop + (0, _shims.int)(boundNodeStyle.paddingBottom) - (0, _shims.int)(nodeStyle.marginBottom)
    };
  }

  // Keep x and y below right and bottom limits...
  if ((0, _shims.isNum)(bounds.right)) x = Math.min(x, bounds.right);
  if ((0, _shims.isNum)(bounds.bottom)) y = Math.min(y, bounds.bottom);

  // But above left and top limits.
  if ((0, _shims.isNum)(bounds.left)) x = Math.max(x, bounds.left);
  if ((0, _shims.isNum)(bounds.top)) y = Math.max(y, bounds.top);

  return [x, y];
}

function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
  var x = Math.round(pendingX / grid[0]) * grid[0];
  var y = Math.round(pendingY / grid[1]) * grid[1];
  return [x, y];
}

function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
}

function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
}

// Get {x, y} positions from event.
function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
  var touchObj = typeof touchIdentifier === 'number' ? (0, _domFns.getTouch)(e, touchIdentifier) : null;
  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
  var node = findDOMNode(draggableCore);
  // User can provide an offsetParent if desired.
  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
  return (0, _domFns.offsetXYFromParent)(touchObj || e, offsetParent);
}

// Create an data object exposed by <DraggableCore>'s events
function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
  var state = draggable.state;
  var isStart = !(0, _shims.isNum)(state.lastX);
  var node = findDOMNode(draggable);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      node: node,
      deltaX: 0, deltaY: 0,
      lastX: x, lastY: y,
      x: x, y: y
    };
  } else {
    // Otherwise calculate proper values.
    return {
      node: node,
      deltaX: x - state.lastX, deltaY: y - state.lastY,
      lastX: state.lastX, lastY: state.lastY,
      x: x, y: y
    };
  }
}

// Create an data exposed by <Draggable>'s events
function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
  return {
    node: coreData.node,
    x: draggable.state.x + coreData.deltaX,
    y: draggable.state.y + coreData.deltaY,
    deltaX: coreData.deltaX,
    deltaY: coreData.deltaY,
    lastX: draggable.state.x,
    lastY: draggable.state.y
  };
}

// A lot faster than stringify/parse
function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
  return {
    left: bounds.left,
    top: bounds.top,
    right: bounds.right,
    bottom: bounds.bottom
  };
}

function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
  var node = _reactDom2.default.findDOMNode(draggable);
  if (!node) {
    throw new Error('<DraggableCore>: Unmounted during event!');
  }
  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
  return node;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/


// Simple abstraction for dragging events names.
/*:: import type {Element as ReactElement} from 'react';*/
var eventsFor = {
  touch: {
    start: 'touchstart',
    move: 'touchmove',
    stop: 'touchend'
  },
  mouse: {
    start: 'mousedown',
    move: 'mousemove',
    stop: 'mouseup'
  }
};

// Default to mouse events.
var dragEventFor = eventsFor.mouse;

/*:: type DraggableCoreState = {
  dragging: boolean,
  lastX: number,
  lastY: number,
  touchIdentifier: ?number
};*/
/*:: export type DraggableBounds = {
  left: number,
  right: number,
  top: number,
  bottom: number,
};*/
/*:: export type DraggableData = {
  node: HTMLElement,
  x: number, y: number,
  deltaX: number, deltaY: number,
  lastX: number, lastY: number,
};*/
/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
/*:: export type ControlPosition = {x: number, y: number};*/


//
// Define <DraggableCore>.
//
// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
// work well with libraries that require more control over the element.
//

/*:: export type DraggableCoreProps = {
  allowAnyClick: boolean,
  cancel: string,
  children: ReactElement<any>,
  disabled: boolean,
  enableUserSelectHack: boolean,
  offsetParent: HTMLElement,
  grid: [number, number],
  handle: string,
  onStart: DraggableEventHandler,
  onDrag: DraggableEventHandler,
  onStop: DraggableEventHandler,
  onMouseDown: (e: MouseEvent) => void,
};*/

var DraggableCore = function (_React$Component) {
  _inherits(DraggableCore, _React$Component);

  function DraggableCore() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DraggableCore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dragging: false,
      // Used while dragging to determine deltas.
      lastX: NaN, lastY: NaN,
      touchIdentifier: null
    }, _this.handleDragStart = function (e) {
      // Make it possible to attach event handlers on top of this one.
      _this.props.onMouseDown(e);

      // Only accept left-clicks.
      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

      // Get nodes. Be sure to grab relative document (could be iframed)
      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
        throw new Error('<DraggableCore> not mounted on DragStart!');
      }
      var ownerDocument = thisNode.ownerDocument;

      // Short circuit if handle or cancel prop was provided and selector doesn't match.

      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !(0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.handle, thisNode) || _this.props.cancel && (0, _domFns.matchesSelectorAndParentsTo)(e.target, _this.props.cancel, thisNode)) {
        return;
      }

      // Set touch identifier in component state if this is a touch event. This allows us to
      // distinguish between individual touches on multitouch screens by identifying which
      // touchpoint was set to this element.
      var touchIdentifier = (0, _domFns.getTouchIdentifier)(e);
      _this.setState({ touchIdentifier: touchIdentifier });

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, touchIdentifier, _this);
      if (position == null) return; // not possible but satisfies flow
      var x = position.x,
          y = position.y;

      // Create an event object with all the data parents need to make a decision here.

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDragStart: %j', coreEvent);

      // Call event handler. If it returns explicit false, cancel.
      (0, _log2.default)('calling', _this.props.onStart);
      var shouldUpdate = _this.props.onStart(e, coreEvent);
      if (shouldUpdate === false) return;

      // Add a style to the body to disable user-select. This prevents text from
      // being selected all over the page.
      if (_this.props.enableUserSelectHack) (0, _domFns.addUserSelectStyles)(ownerDocument);

      // Initiate dragging. Set the current x and y as offsets
      // so we know how much we've moved during the drag. This allows us
      // to drag elements around even if they have been moved, without issue.
      _this.setState({
        dragging: true,

        lastX: x,
        lastY: y
      });

      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
      // this element. We use different events depending on whether or not we have detected that this
      // is a touch-capable device.
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.move, _this.handleDrag);
      (0, _domFns.addEvent)(ownerDocument, dragEventFor.stop, _this.handleDragStop);
    }, _this.handleDrag = function (e) {

      // Prevent scrolling on mobile devices, like ipad/iphone.
      if (e.type === 'touchmove') e.preventDefault();

      // Get the current drag point from the event. This is used as the offset.
      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      // Snap to grid if prop has been provided

      if (Array.isArray(_this.props.grid)) {
        var _deltaX = x - _this.state.lastX,
            _deltaY = y - _this.state.lastY;

        var _snapToGrid = (0, _positionFns.snapToGrid)(_this.props.grid, _deltaX, _deltaY);

        var _snapToGrid2 = _slicedToArray(_snapToGrid, 2);

        _deltaX = _snapToGrid2[0];
        _deltaY = _snapToGrid2[1];

        if (!_deltaX && !_deltaY) return; // skip useless drag
        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
      }

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      (0, _log2.default)('DraggableCore: handleDrag: %j', coreEvent);

      // Call event handler. If it returns explicit false, trigger end.
      var shouldUpdate = _this.props.onDrag(e, coreEvent);
      if (shouldUpdate === false) {
        try {
          // $FlowIgnore
          _this.handleDragStop(new MouseEvent('mouseup'));
        } catch (err) {
          // Old browsers
          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
          // I see why this insanity was deprecated
          // $FlowIgnore
          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          _this.handleDragStop(event);
        }
        return;
      }

      _this.setState({
        lastX: x,
        lastY: y
      });
    }, _this.handleDragStop = function (e) {
      if (!_this.state.dragging) return;

      var position = (0, _positionFns.getControlPosition)(e, _this.state.touchIdentifier, _this);
      if (position == null) return;
      var x = position.x,
          y = position.y;

      var coreEvent = (0, _positionFns.createCoreData)(_this, x, y);

      var thisNode = _reactDom2.default.findDOMNode(_this);
      if (thisNode) {
        // Remove user-select hack
        if (_this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(thisNode.ownerDocument);
      }

      (0, _log2.default)('DraggableCore: handleDragStop: %j', coreEvent);

      // Reset the el.
      _this.setState({
        dragging: false,
        lastX: NaN,
        lastY: NaN
      });

      // Call event handler
      _this.props.onStop(e, coreEvent);

      if (thisNode) {
        // Remove event handlers
        (0, _log2.default)('DraggableCore: Removing handlers');
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
        (0, _domFns.removeEvent)(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
      }
    }, _this.onMouseDown = function (e) {
      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

      return _this.handleDragStart(e);
    }, _this.onMouseUp = function (e) {
      dragEventFor = eventsFor.mouse;

      return _this.handleDragStop(e);
    }, _this.onTouchStart = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStart(e);
    }, _this.onTouchEnd = function (e) {
      // We're on a touch device now, so change the event handlers
      dragEventFor = eventsFor.touch;

      return _this.handleDragStop(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DraggableCore, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
      var thisNode = _reactDom2.default.findDOMNode(this);
      if (thisNode) {
        var ownerDocument = thisNode.ownerDocument;

        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.move, this.handleDrag);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
        (0, _domFns.removeEvent)(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
        if (this.props.enableUserSelectHack) (0, _domFns.removeUserSelectStyles)(ownerDocument);
      }
    }

    // Same as onMouseDown (start drag), but now consider this a touch device.

  }, {
    key: 'render',
    value: function render() {
      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), {
        style: (0, _domFns.styleHacks)(this.props.children.props.style),

        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onTouchStart: this.onTouchStart,
        onMouseUp: this.onMouseUp,
        onTouchEnd: this.onTouchEnd
      });
    }
  }]);

  return DraggableCore;
}(_react2.default.Component);

DraggableCore.displayName = 'DraggableCore';
DraggableCore.propTypes = {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: _propTypes2.default.bool,

  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: _propTypes2.default.bool,

  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: _propTypes2.default.bool,

  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
    if (process.browser === true && props[propName] && props[propName].nodeType !== 1) {
      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
    }
  },

  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: _propTypes2.default.arrayOf(_propTypes2.default.number),

  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: _propTypes2.default.string,

  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: _propTypes2.default.string,

  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: _propTypes2.default.func,

  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: _propTypes2.default.func,

  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: _propTypes2.default.func,

  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: _propTypes2.default.func,

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
};
DraggableCore.defaultProps = {
  allowAnyClick: false, // by default only accept left click
  cancel: null,
  disabled: false,
  enableUserSelectHack: true,
  offsetParent: null,
  handle: null,
  grid: null,
  transform: null,
  onStart: function onStart() {},
  onDrag: function onDrag() {},
  onStop: function onStop() {},
  onMouseDown: function onMouseDown() {}
};
exports.default = DraggableCore;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = log;

/*eslint no-console:0*/
function log() {
  var _console;

  if (undefined) (_console = console).log.apply(_console, arguments);
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Draggable = __webpack_require__(13).default;

// Previous versions of this lib exported <Draggable> as the root export. As to not break
// them, or TypeScript, we export *both* as the root and as 'default'.
// See https://github.com/mzabriskie/react-draggable/pull/254
// and https://github.com/mzabriskie/react-draggable/issues/266
module.exports = Draggable;
module.exports.default = Draggable;
module.exports.DraggableCore = __webpack_require__(10).default;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(6);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(7);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(4);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(18);

var _classnames2 = _interopRequireDefault(_classnames);

var _domFns = __webpack_require__(5);

var _positionFns = __webpack_require__(9);

var _shims = __webpack_require__(0);

var _DraggableCore = __webpack_require__(10);

var _DraggableCore2 = _interopRequireDefault(_DraggableCore);

var _log = __webpack_require__(11);

var _log2 = _interopRequireDefault(_log);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*:: import type {ControlPosition, DraggableBounds, DraggableCoreProps} from './DraggableCore';*/
/*:: import type {DraggableEventHandler} from './utils/types';*/
/*:: import type {Element as ReactElement} from 'react';*/
/*:: type DraggableState = {
  dragging: boolean,
  dragged: boolean,
  x: number, y: number,
  slackX: number, slackY: number,
  isElementSVG: boolean
};*/


//
// Define <Draggable>
//

/*:: export type DraggableProps = {
  ...$Exact<DraggableCoreProps>,
  axis: 'both' | 'x' | 'y' | 'none',
  bounds: DraggableBounds | string | false,
  defaultClassName: string,
  defaultClassNameDragging: string,
  defaultClassNameDragged: string,
  defaultPosition: ControlPosition,
  position: ControlPosition,
};*/

var Draggable = function (_React$Component) {
  _inherits(Draggable, _React$Component);

  function Draggable(props /*: DraggableProps*/) {
    _classCallCheck(this, Draggable);

    var _this = _possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

    _this.onDragStart = function (e, coreData) {
      (0, _log2.default)('Draggable: onDragStart: %j', coreData);

      // Short-circuit if user's callback killed it.
      var shouldStart = _this.props.onStart(e, (0, _positionFns.createDraggableData)(_this, coreData));
      // Kills start event on core as well, so move handlers are never bound.
      if (shouldStart === false) return false;

      _this.setState({ dragging: true, dragged: true });
    };

    _this.onDrag = function (e, coreData) {
      if (!_this.state.dragging) return false;
      (0, _log2.default)('Draggable: onDrag: %j', coreData);

      var uiData = (0, _positionFns.createDraggableData)(_this, coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        x: uiData.x,
        y: uiData.y
      };

      // Keep within bounds.
      if (_this.props.bounds) {
        // Save original x and y.
        var _x = newState.x,
            _y = newState.y;

        // Add slack to the values used to calculate bound position. This will ensure that if
        // we start removing slack, the element won't react to it right away until it's been
        // completely removed.

        newState.x += _this.state.slackX;
        newState.y += _this.state.slackY;

        // Get bound position. This will ceil/floor the x and y within the boundaries.

        var _getBoundPosition = (0, _positionFns.getBoundPosition)(_this, newState.x, newState.y),
            _getBoundPosition2 = _slicedToArray(_getBoundPosition, 2),
            newStateX = _getBoundPosition2[0],
            newStateY = _getBoundPosition2[1];

        newState.x = newStateX;
        newState.y = newStateY;

        // Recalculate slack by noting how much was shaved by the boundPosition handler.
        newState.slackX = _this.state.slackX + (_x - newState.x);
        newState.slackY = _this.state.slackY + (_y - newState.y);

        // Update the event we fire to reflect what really happened after bounds took effect.
        uiData.x = newState.x;
        uiData.y = newState.y;
        uiData.deltaX = newState.x - _this.state.x;
        uiData.deltaY = newState.y - _this.state.y;
      }

      // Short-circuit if user's callback killed it.
      var shouldUpdate = _this.props.onDrag(e, uiData);
      if (shouldUpdate === false) return false;

      _this.setState(newState);
    };

    _this.onDragStop = function (e, coreData) {
      if (!_this.state.dragging) return false;

      // Short-circuit if user's callback killed it.
      var shouldStop = _this.props.onStop(e, (0, _positionFns.createDraggableData)(_this, coreData));
      if (shouldStop === false) return false;

      (0, _log2.default)('Draggable: onDragStop: %j', coreData);

      var newState /*: $Shape<DraggableState>*/ = {
        dragging: false,
        slackX: 0,
        slackY: 0
      };

      // If this is a controlled component, the result of this operation will be to
      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
      var controlled = Boolean(_this.props.position);
      if (controlled) {
        var _this$props$position = _this.props.position,
            _x2 = _this$props$position.x,
            _y2 = _this$props$position.y;

        newState.x = _x2;
        newState.y = _y2;
      }

      _this.setState(newState);
    };

    _this.state = {
      // Whether or not we are currently dragging.
      dragging: false,

      // Whether or not we have been dragged before.
      dragged: false,

      // Current transform x and y.
      x: props.position ? props.position.x : props.defaultPosition.x,
      y: props.position ? props.position.y : props.defaultPosition.y,

      // Used for compensating for out-of-bounds drags
      slackX: 0, slackY: 0,

      // Can only determine if SVG after mounting
      isElementSVG: false
    };
    return _this;
  }

  _createClass(Draggable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.position && !(this.props.onDrag || this.props.onStop)) {
        // eslint-disable-next-line
        console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Check to see if the element passed is an instanceof SVGElement
      if (typeof window.SVGElement !== 'undefined' && _reactDom2.default.findDOMNode(this) instanceof window.SVGElement) {
        this.setState({ isElementSVG: true });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps /*: Object*/) {
      // Set x/y if position has changed
      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
    }
  }, {
    key: 'render',
    value: function render() /*: ReactElement<any>*/ {
      var _classNames;

      var style = {},
          svgTransform = null;

      // If this is controlled, we don't want to move it - unless it's dragging.
      var controlled = Boolean(this.props.position);
      var draggable = !controlled || this.state.dragging;

      var position = this.props.position || this.props.defaultPosition;
      var transformOpts = {
        // Set left if horizontal drag is enabled
        x: (0, _positionFns.canDragX)(this) && draggable ? this.state.x : position.x,

        // Set top if vertical drag is enabled
        y: (0, _positionFns.canDragY)(this) && draggable ? this.state.y : position.y
      };

      // If this element was SVG, we use the `transform` attribute.
      if (this.state.isElementSVG) {
        svgTransform = (0, _domFns.createSVGTransform)(transformOpts);
      } else {
        // Add a CSS transform to move the element around. This allows us to move the element around
        // without worrying about whether or not it is relatively or absolutely positioned.
        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
        // has a clean slate.
        style = (0, _domFns.createCSSTransform)(transformOpts);
      }

      var _props = this.props,
          defaultClassName = _props.defaultClassName,
          defaultClassNameDragging = _props.defaultClassNameDragging,
          defaultClassNameDragged = _props.defaultClassNameDragged;


      var children = _react2.default.Children.only(this.props.children);

      // Mark with class while dragging
      var className = (0, _classnames2.default)(children.props.className || '', defaultClassName, (_classNames = {}, _defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), _defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));

      // Reuse the child provided
      // This makes it flexible to use whatever element is wanted (div, ul, etc)
      return _react2.default.createElement(
        _DraggableCore2.default,
        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
        _react2.default.cloneElement(children, {
          className: className,
          style: _extends({}, children.props.style, style),
          transform: svgTransform
        })
      );
    }
  }]);

  return Draggable;
}(_react2.default.Component);

Draggable.displayName = 'Draggable';
Draggable.propTypes = _extends({}, _DraggableCore2.default.propTypes, {

  /**
   * `axis` determines which axis the draggable can move.
   *
   *  Note that all callbacks will still return data as normal. This only
   *  controls flushing to the DOM.
   *
   * 'both' allows movement horizontally and vertically.
   * 'x' limits movement to horizontal axis.
   * 'y' limits movement to vertical axis.
   * 'none' limits all movement.
   *
   * Defaults to 'both'.
   */
  axis: _propTypes2.default.oneOf(['both', 'x', 'y', 'none']),

  /**
   * `bounds` determines the range of movement available to the element.
   * Available values are:
   *
   * 'parent' restricts movement within the Draggable's parent node.
   *
   * Alternatively, pass an object with the following properties, all of which are optional:
   *
   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
   *
   * All values are in px.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable bounds={{right: 300, bottom: 300}}>
   *              <div>Content</div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  bounds: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    left: _propTypes2.default.number,
    right: _propTypes2.default.number,
    top: _propTypes2.default.number,
    bottom: _propTypes2.default.number
  }), _propTypes2.default.string, _propTypes2.default.oneOf([false])]),

  defaultClassName: _propTypes2.default.string,
  defaultClassNameDragging: _propTypes2.default.string,
  defaultClassNameDragged: _propTypes2.default.string,

  /**
   * `defaultPosition` specifies the x and y that the dragged item should start at
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  defaultPosition: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * `position`, if present, defines the current position of the element.
   *
   *  This is similar to how form elements in React work - if no `position` is supplied, the component
   *  is uncontrolled.
   *
   * Example:
   *
   * ```jsx
   *      let App = React.createClass({
   *          render: function () {
   *              return (
   *                  <Draggable position={{x: 25, y: 25}}>
   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
   *                  </Draggable>
   *              );
   *          }
   *      });
   * ```
   */
  position: _propTypes2.default.shape({
    x: _propTypes2.default.number,
    y: _propTypes2.default.number
  }),

  /**
   * These properties should be defined on the child, not here.
   */
  className: _shims.dontSetMe,
  style: _shims.dontSetMe,
  transform: _shims.dontSetMe
});
Draggable.defaultProps = _extends({}, _DraggableCore2.default.defaultProps, {
  axis: 'both',
  bounds: false,
  defaultClassName: 'react-draggable',
  defaultClassNameDragging: 'react-draggable-dragging',
  defaultClassNameDragged: 'react-draggable-dragged',
  defaultPosition: { x: 0, y: 0 },
  position: null
});
exports.default = Draggable;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(8);
var assign = __webpack_require__(15);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(16);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(8);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (Object({"DRAGGABLE_DEBUG":undefined}).NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPrefix = getPrefix;
exports.browserPrefixToKey = browserPrefixToKey;
exports.browserPrefixToStyle = browserPrefixToStyle;
var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
function getPrefix() /*: string*/ {
  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

  // Checking specifically for 'window.document' is for pseudo-browser server-side
  // environments that define 'window' as the global context.
  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

  var style = window.document.documentElement.style;

  if (prop in style) return '';

  for (var i = 0; i < prefixes.length; i++) {
    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
  }

  return '';
}

function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
}

function browserPrefixToStyle(prop /*: string*/, prefix /*: string*/) /*: string*/ {
  return prefix ? '-' + prefix.toLowerCase() + '-' + prop : prop;
}

function kebabToTitleCase(str /*: string*/) /*: string*/ {
  var out = '';
  var shouldCapitalize = true;
  for (var i = 0; i < str.length; i++) {
    if (shouldCapitalize) {
      out += str[i].toUpperCase();
      shouldCapitalize = false;
    } else if (str[i] === '-') {
      shouldCapitalize = true;
    } else {
      out += str[i];
    }
  }
  return out;
}

// Default export is the prefix itself, like 'Moz', 'Webkit', etc
// Note that you may have to re-test for certain things; for instance, Chrome 50
// can handle unprefixed `transform`, but not unprefixed `user-select`
exports.default = getPrefix();

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=react-draggable.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// React.addons.cloneWithProps look-alike that merges style & className.
module.exports = function cloneElement(element, props) {
  if (props.style && element.props.style) {
    props.style = _extends({}, element.props.style, props.style);
  }
  if (props.className && element.props.className) {
    props.className = element.props.className + ' ' + props.className;
  }
  return _react2.default.cloneElement(element, props);
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(14);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Resizable = __webpack_require__(128);

var _Resizable2 = _interopRequireDefault(_Resizable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// An example use of Resizable.
var ResizableBox = function (_React$Component) {
  _inherits(ResizableBox, _React$Component);

  function ResizableBox() {
    var _temp, _this, _ret;

    _classCallCheck(this, ResizableBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      width: _this.props.width,
      height: _this.props.height
    }, _this.onResize = function (e, data) {
      var size = data.size;
      var width = size.width,
          height = size.height;


      if (_this.props.onResize) {
        e.persist && e.persist();
        _this.setState(size, function () {
          return _this.props.onResize && _this.props.onResize(e, data);
        });
      } else {
        _this.setState(size);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ResizableBox.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.width !== this.props.width || nextProps.height !== this.props.height) {
      this.setState({
        width: nextProps.width,
        height: nextProps.height
      });
    }
  };

  ResizableBox.prototype.render = function render() {
    // Basic wrapper around a Resizable instance.
    // If you use Resizable directly, you are responsible for updating the child component
    // with a new width and height.
    var _props = this.props,
        handleSize = _props.handleSize,
        onResize = _props.onResize,
        onResizeStart = _props.onResizeStart,
        onResizeStop = _props.onResizeStop,
        draggableOpts = _props.draggableOpts,
        minConstraints = _props.minConstraints,
        maxConstraints = _props.maxConstraints,
        lockAspectRatio = _props.lockAspectRatio,
        axis = _props.axis,
        width = _props.width,
        height = _props.height,
        props = _objectWithoutProperties(_props, ['handleSize', 'onResize', 'onResizeStart', 'onResizeStop', 'draggableOpts', 'minConstraints', 'maxConstraints', 'lockAspectRatio', 'axis', 'width', 'height']);

    return _react2.default.createElement(
      _Resizable2.default,
      {
        handleSize: handleSize,
        width: this.state.width,
        height: this.state.height,
        onResizeStart: onResizeStart,
        onResize: this.onResize,
        onResizeStop: onResizeStop,
        draggableOpts: draggableOpts,
        minConstraints: minConstraints,
        maxConstraints: maxConstraints,
        lockAspectRatio: lockAspectRatio,
        axis: axis
      },
      _react2.default.createElement('div', _extends({ style: { width: this.state.width + 'px', height: this.state.height + 'px' } }, props))
    );
  };

  return ResizableBox;
}(_react2.default.Component);

ResizableBox.propTypes = {
  height: _propTypes2.default.number,
  width: _propTypes2.default.number
};
ResizableBox.defaultProps = {
  handleSize: [20, 20]
};
exports.default = ResizableBox;

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getMockDatasource */
/* harmony export (immutable) */ __webpack_exports__["c"] = getRandomMockDatasource;
/* unused harmony export overwritedData */
/* unused harmony export getMockDatasource2 */
/* unused harmony export getObservableMockDatasource */
/* unused harmony export getObservableError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPromiseMockDatasource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return basicConfig; });
/* unused harmony export basicConfig2 */
/* unused harmony export getMenu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rx_lite__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rx_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rx_lite__);
/* eslint-disable import/no-extraneous-dependencies*//* eslint-enable */function getMockDatasource(){var dataRepetition=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var nToto=arguments.length>1&&arguments[1]!==undefined?arguments[1]:10;var nTiti=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;var nTutu=arguments.length>3&&arguments[3]!==undefined?arguments[3]:2;// const nTutu = 2;
var obj=[];var res=[];for(var k=0;k<dataRepetition;k+=1){for(var o=0;o<nToto;o+=1){for(var i=0;i<nTiti;i+=1){for(var u=0;u<nTutu;u+=1){obj={};obj.toto=o;obj.toto_lb="toto "+String(o);obj.toto_0="att0 "+String(o);obj.toto_1="att1 "+String(nToto-o);obj.titi=i;obj.titi_lb="titi "+String(i);obj.tutu=String(Math.round((nTutu-1)*Math.random()));obj.qty=Math.round(400*Math.random())+125;// +9999999999.1234567890123456
obj.amt=Math.round(5000*Math.random())+310;// +9999999999.1234567890123456
obj.d=new Date(2015+Math.round(4*Math.random()),Math.round(12*Math.random()),Math.round(31*Math.random()));res.push(obj);}}}}return res;}function getRandomMockDatasource(){var dataPercentage=arguments.length>0&&arguments[0]!==undefined?arguments[0]:10;var nToto=arguments.length>1&&arguments[1]!==undefined?arguments[1]:10;var nTiti=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;var nTutu=arguments.length>3&&arguments[3]!==undefined?arguments[3]:2;// return [getObj(1, 1, 0), getObj(1, 100, 1)];
var ratio=dataPercentage/100;// const nTutu = 2;
var obj=[];var res=[];for(var k=0;k<1;k+=1){for(var o=0;o<nToto*ratio;o+=1){for(var i=0;i<nTiti*ratio;i+=1){for(var u=0;u<nTutu*ratio;u+=1){var oo=Math.round(Math.random()*nToto*1.1);var ii=Math.round(Math.random()*nTiti*1);obj={};obj.toto=oo;obj.toto_lb="toto "+String(oo);obj.toto_0="att0 "+String(oo);obj.toto_1="att1 "+String(nToto-oo);obj.titi=ii;obj.titi_lb="titi "+String(ii);obj.tutu=String(Math.round((nTutu-1)*Math.random()));obj.qty=100;// Math.round(400 * Math.random()) + 125; // +9999999999.1234567890123456
obj.amt=Math.round(5000*Math.random())+310;// +9999999999.1234567890123456
res.push(obj);}}}}return res;}var overwritedData=function overwritedData(){var obj={};obj.toto=1;obj.toto_lb="toto "+String(1);obj.toto_0="att0 "+String(1);obj.toto_1="att1 "+String(199);obj.titi=1;obj.titi_lb="titi "+String(1);// obj.tutu = "2";
obj.qty=100;// Math.round(400 * Math.random()) + 125; // +9999999999.1234567890123456
// obj.amt = Math.round(5000 * Math.random()) + 310; // +9999999999.1234567890123456
return[obj];};function getMockDatasource2(){var dataRepetition=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var nToto=arguments.length>1&&arguments[1]!==undefined?arguments[1]:10;var nTiti=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;var nTutu=arguments.length>3&&arguments[3]!==undefined?arguments[3]:2;// const nTutu = 2;
var obj=[];var res=[];for(var k=0;k<dataRepetition;k+=1){for(var o=0;o<nToto;o+=1){for(var i=0;i<nTiti;i+=1){for(var u=0;u<nTutu;u+=1){obj={};obj.toto2=o;obj.toto_lb="toto2 "+String(nToto-o);obj.toto_0="att0 "+String(o);obj.toto_1="att1 "+String(nToto-o);obj.titi="titi2 "+String(i);obj.tutu=String(u);obj.qty=u+10*i+100*o+1;// +9999999999.1234567890123456
obj.amt=u+10*i+100*o+1000;// +9999999999.1234567890123456
res.push(obj);}}}}return res;}function getObservableMockDatasource(interval){var data=[getMockDatasource(),[{toto:"0",toto_lb:"toto 0",qty:100,amt:100,titi:"titi 0",tutu:"1"},{toto:"0",toto_lb:"toto 0",qty:100,amt:100,titi:"titi 0",tutu:"0"}],{toto:"0",toto_lb:"toto 0",qty:1,amt:2,titi:"titi 0",tutu:"1"}];return __WEBPACK_IMPORTED_MODULE_0_rx_lite__["Observable"].interval(interval||100).take(3).map(function(i){return data[i];});}function getObservableError(){return __WEBPACK_IMPORTED_MODULE_0_rx_lite__["Observable"].throw(new Error("titi"));}var getPromiseMockDatasource=function getPromiseMockDatasource(){var dataRepetition=arguments.length>0&&arguments[0]!==undefined?arguments[0]:1;var nToto=arguments.length>1&&arguments[1]!==undefined?arguments[1]:10;var nTiti=arguments.length>2&&arguments[2]!==undefined?arguments[2]:10;var nTutu=arguments.length>3&&arguments[3]!==undefined?arguments[3]:2;var p=new Promise(function(resolve){return setTimeout(resolve,20);}).then(function(){return getMockDatasource(dataRepetition,nToto,nTiti,nTutu);});return p;};var basicConfig=function basicConfig(callbacks){return{measureHeadersAxis:"columns",width:1099,height:601,cellHeight:30,cellWidth:100,totalsFirst:true,edition:{editable:true},dimensions:[{id:"toto",caption:"Toto",keyAccessor:"toto",labelAccessor:"toto_lb",sort:{keyAccessor:"toto"}},{id:"titi",caption:"Titi",keyAccessor:"titi",labelAccessor:"titi_lb"},{id:"tutu",caption:"Tutu",keyAccessor:"tutu"},{id:"toto att 0",caption:"toto 0",keyAccessor:"toto_0",attributeParents:["toto"]},{id:"toto att 1",caption:"toto 1",keyAccessor:"toto_1",attributeParents:["toto"],format:"id"}],measures:[{valueAccessor:"qty",id:"qty",caption:"Quantity",format:"quantity",aggregation:"sum"},{valueAccessor:"amt",id:"amt",caption:"Amount",aggregation:"sum",format:"amount"// ,
// {
//   id: "price",
//   caption: "Price",
//   aggregation: "weighted_avg",
//   valueAccessor: "price",
//   format: "price"
// }
}],columns:["titi"],rows:["toto","toto att 0","toto att 1","tutu"],activeMeasures:["qty","amt"],collapses:{rows:{99:true,98:true},columns:{}},subtotals:{toto:true,rows__total__:true},callbacks:callbacks// features: {}
};};var basicConfig2=function basicConfig2(callbacks){return{measureHeadersAxis:"columns",width:1099,height:601,cellHeight:30,cellWidth:100,dimensions:[{id:"toto2",caption:"Toto",keyAccessor:"toto2",labelAccessor:"toto_lb",sort:{keyAccessor:"toto_lb"}},{id:"titi",caption:"Titi",keyAccessor:"titi"},{id:"tutu",caption:"Tutu",keyAccessor:"tutu",format:"id"},{id:"toto att 0",caption:"toto 0",keyAccessor:"toto_0",attributeParents:["toto2"]},{id:"toto att 1",caption:"toto 1",keyAccessor:"toto_1",attributeParents:["toto2"],format:"id"}],measures:[{valueAccessor:"qty",id:"qty",caption:"Quantity",format:"quantity",aggregation:"sum"},{valueAccessor:"amt",id:"amt",caption:"Amount",aggregation:"sum",format:"amount"},{id:"price",caption:"Price",aggregation:"weighted_avg",valueAccessor:"price",format:"price"}],columns:["titi"],rows:["toto2","toto att 0","toto att 1","tutu"],activeMeasures:["qty","amt","price"],callbacks:callbacks};};var getMenu=function getMenu(id,data){return{id:1,type:"menu",caption:"Menu",position:"bottom",children:[{id:2,type:"sub-menu",caption:"SubMenu1",// accelerator: "Ctrl+A",
opened:false,selected:true,children:[{id:3,type:"menu-item",caption:"Item1",onClick:function onClick(){console.log("tutu");},// accelerator: "Ctrl+C",
checked:true},{id:4,type:"menu-item",caption:"Item2",onClick:function onClick(){console.log("tata");},disable:true},{id:6,type:"sub-menu",caption:"SubMenu6",separation:true,children:[{id:7,type:"menu-item",caption:"Item7",onClick:function onClick(){console.log("7");}},{id:8,type:"menu-item",caption:"Item8",onClick:function onClick(){console.log("8");}}]}]},{id:9,type:"sub-menu",caption:"SubMenu2",checked:true,children:[{id:10,type:"menu-item",caption:"Item10",onClick:function onClick(){console.log("10");}},{id:11,type:"menu-item",caption:"Item11",onClick:function onClick(){console.log("11");}}]},{id:12,type:"sub-menu",caption:"SubMenu3",checked:true,onClick:function onClick(){console.log("toto");},disabled:false}]};};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global, process) {var __WEBPACK_AMD_DEFINE_RESULT__;// Copyright (c) Microsoft Open Technologies, Inc. All rights reserved. See License.txt in the project root for license information.

;(function (undefined) {

  var objectTypes = {
    'function': true,
    'object': true
  };

  var
    freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports,
    freeSelf = objectTypes[typeof self] && self.Object && self,
    freeWindow = objectTypes[typeof window] && window && window.Object && window,
    freeModule = objectTypes[typeof module] && module && !module.nodeType && module,
    moduleExports = freeModule && freeModule.exports === freeExports && freeExports,
    freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  var root = root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  var Rx = {
    internals: {},
    config: {
      Promise: root.Promise
    },
    helpers: { }
  };

  // Defaults
  var noop = Rx.helpers.noop = function () { },
    identity = Rx.helpers.identity = function (x) { return x; },
    defaultNow = Rx.helpers.defaultNow = Date.now,
    defaultComparer = Rx.helpers.defaultComparer = function (x, y) { return isEqual(x, y); },
    defaultSubComparer = Rx.helpers.defaultSubComparer = function (x, y) { return x > y ? 1 : (x < y ? -1 : 0); },
    defaultKeySerializer = Rx.helpers.defaultKeySerializer = function (x) { return x.toString(); },
    defaultError = Rx.helpers.defaultError = function (err) { throw err; },
    isPromise = Rx.helpers.isPromise = function (p) { return !!p && typeof p.subscribe !== 'function' && typeof p.then === 'function'; },
    isFunction = Rx.helpers.isFunction = (function () {

      var isFn = function (value) {
        return typeof value == 'function' || false;
      }

      // fallback for older versions of Chrome and Safari
      if (isFn(/x/)) {
        isFn = function(value) {
          return typeof value == 'function' && toString.call(value) == '[object Function]';
        };
      }

      return isFn;
    }());

    function cloneArray(arr) {
      var len = arr.length, a = new Array(len);
      for(var i = 0; i < len; i++) { a[i] = arr[i]; }
      return a;
    }

  var errorObj = {e: {}};
  function tryCatcherGen(tryCatchTarget) {
    return function tryCatcher() {
      try {
        return tryCatchTarget.apply(this, arguments);
      } catch (e) {
        errorObj.e = e;
        return errorObj;
      }
    }
  }
  var tryCatch = Rx.internals.tryCatch = function tryCatch(fn) {
    if (!isFunction(fn)) { throw new TypeError('fn must be a function'); }
    return tryCatcherGen(fn);
  }
  function thrower(e) {
    throw e;
  }

  Rx.config.longStackSupport = false;
  var hasStacks = false, stacks = tryCatch(function () { throw new Error(); })();
  hasStacks = !!stacks.e && !!stacks.e.stack;

  // All code after this point will be filtered from stack traces reported by RxJS
  var rStartingLine = captureLine(), rFileName;

  var STACK_JUMP_SEPARATOR = 'From previous event:';

  function makeStackTraceLong(error, observable) {
    // If possible, transform the error stack trace by removing Node and RxJS
    // cruft, then concatenating with the stack trace of `observable`.
    if (hasStacks &&
        observable.stack &&
        typeof error === 'object' &&
        error !== null &&
        error.stack &&
        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
    ) {
      var stacks = [];
      for (var o = observable; !!o; o = o.source) {
        if (o.stack) {
          stacks.unshift(o.stack);
        }
      }
      stacks.unshift(error.stack);

      var concatedStacks = stacks.join('\n' + STACK_JUMP_SEPARATOR + '\n');
      error.stack = filterStackString(concatedStacks);
    }
  }

  function filterStackString(stackString) {
    var lines = stackString.split('\n'), desiredLines = [];
    for (var i = 0, len = lines.length; i < len; i++) {
      var line = lines[i];

      if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
        desiredLines.push(line);
      }
    }
    return desiredLines.join('\n');
  }

  function isInternalFrame(stackLine) {
    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
    if (!fileNameAndLineNumber) {
      return false;
    }
    var fileName = fileNameAndLineNumber[0], lineNumber = fileNameAndLineNumber[1];

    return fileName === rFileName &&
      lineNumber >= rStartingLine &&
      lineNumber <= rEndingLine;
  }

  function isNodeFrame(stackLine) {
    return stackLine.indexOf('(module.js:') !== -1 ||
      stackLine.indexOf('(node.js:') !== -1;
  }

  function captureLine() {
    if (!hasStacks) { return; }

    try {
      throw new Error();
    } catch (e) {
      var lines = e.stack.split('\n');
      var firstLine = lines[0].indexOf('@') > 0 ? lines[1] : lines[2];
      var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
      if (!fileNameAndLineNumber) { return; }

      rFileName = fileNameAndLineNumber[0];
      return fileNameAndLineNumber[1];
    }
  }

  function getFileNameAndLineNumber(stackLine) {
    // Named functions: 'at functionName (filename:lineNumber:columnNumber)'
    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
    if (attempt1) { return [attempt1[1], Number(attempt1[2])]; }

    // Anonymous functions: 'at filename:lineNumber:columnNumber'
    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
    if (attempt2) { return [attempt2[1], Number(attempt2[2])]; }

    // Firefox style: 'function@filename:lineNumber or @filename:lineNumber'
    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
    if (attempt3) { return [attempt3[1], Number(attempt3[2])]; }
  }

  var EmptyError = Rx.EmptyError = function() {
    this.message = 'Sequence contains no elements.';
    this.name = 'EmptyError';
    Error.call(this);
  };
  EmptyError.prototype = Object.create(Error.prototype);

  var ObjectDisposedError = Rx.ObjectDisposedError = function() {
    this.message = 'Object has been disposed';
    this.name = 'ObjectDisposedError';
    Error.call(this);
  };
  ObjectDisposedError.prototype = Object.create(Error.prototype);

  var ArgumentOutOfRangeError = Rx.ArgumentOutOfRangeError = function () {
    this.message = 'Argument out of range';
    this.name = 'ArgumentOutOfRangeError';
    Error.call(this);
  };
  ArgumentOutOfRangeError.prototype = Object.create(Error.prototype);

  var NotSupportedError = Rx.NotSupportedError = function (message) {
    this.message = message || 'This operation is not supported';
    this.name = 'NotSupportedError';
    Error.call(this);
  };
  NotSupportedError.prototype = Object.create(Error.prototype);

  var NotImplementedError = Rx.NotImplementedError = function (message) {
    this.message = message || 'This operation is not implemented';
    this.name = 'NotImplementedError';
    Error.call(this);
  };
  NotImplementedError.prototype = Object.create(Error.prototype);

  var notImplemented = Rx.helpers.notImplemented = function () {
    throw new NotImplementedError();
  };

  var notSupported = Rx.helpers.notSupported = function () {
    throw new NotSupportedError();
  };

  // Shim in iterator support
  var $iterator$ = (typeof Symbol === 'function' && Symbol.iterator) ||
    '_es6shim_iterator_';
  // Bug for mozilla version
  if (root.Set && typeof new root.Set()['@@iterator'] === 'function') {
    $iterator$ = '@@iterator';
  }

  var doneEnumerator = Rx.doneEnumerator = { done: true, value: undefined };

  var isIterable = Rx.helpers.isIterable = function (o) {
    return o[$iterator$] !== undefined;
  }

  var isArrayLike = Rx.helpers.isArrayLike = function (o) {
    return o && o.length !== undefined;
  }

  Rx.helpers.iterator = $iterator$;

  var bindCallback = Rx.internals.bindCallback = function (func, thisArg, argCount) {
    if (typeof thisArg === 'undefined') { return func; }
    switch(argCount) {
      case 0:
        return function() {
          return func.call(thisArg)
        };
      case 1:
        return function(arg) {
          return func.call(thisArg, arg);
        }
      case 2:
        return function(value, index) {
          return func.call(thisArg, value, index);
        };
      case 3:
        return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
    }

    return function() {
      return func.apply(thisArg, arguments);
    };
  };

  /** Used to determine if values are of the language type Object */
  var dontEnums = ['toString',
    'toLocaleString',
    'valueOf',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'constructor'],
  dontEnumsLength = dontEnums.length;

  /** `Object#toString` result shortcuts */
  var argsClass = '[object Arguments]',
    arrayClass = '[object Array]',
    boolClass = '[object Boolean]',
    dateClass = '[object Date]',
    errorClass = '[object Error]',
    funcClass = '[object Function]',
    numberClass = '[object Number]',
    objectClass = '[object Object]',
    regexpClass = '[object RegExp]',
    stringClass = '[object String]';

  var toString = Object.prototype.toString,
    hasOwnProperty = Object.prototype.hasOwnProperty,
    supportsArgsClass = toString.call(arguments) == argsClass, // For less <IE9 && FF<4
    supportNodeClass,
    errorProto = Error.prototype,
    objectProto = Object.prototype,
    stringProto = String.prototype,
    propertyIsEnumerable = objectProto.propertyIsEnumerable;

  try {
    supportNodeClass = !(toString.call(document) == objectClass && !({ 'toString': 0 } + ''));
  } catch (e) {
    supportNodeClass = true;
  }

  var nonEnumProps = {};
  nonEnumProps[arrayClass] = nonEnumProps[dateClass] = nonEnumProps[numberClass] = { 'constructor': true, 'toLocaleString': true, 'toString': true, 'valueOf': true };
  nonEnumProps[boolClass] = nonEnumProps[stringClass] = { 'constructor': true, 'toString': true, 'valueOf': true };
  nonEnumProps[errorClass] = nonEnumProps[funcClass] = nonEnumProps[regexpClass] = { 'constructor': true, 'toString': true };
  nonEnumProps[objectClass] = { 'constructor': true };

  var support = {};
  (function () {
    var ctor = function() { this.x = 1; },
      props = [];

    ctor.prototype = { 'valueOf': 1, 'y': 1 };
    for (var key in new ctor) { props.push(key); }
    for (key in arguments) { }

    // Detect if `name` or `message` properties of `Error.prototype` are enumerable by default.
    support.enumErrorProps = propertyIsEnumerable.call(errorProto, 'message') || propertyIsEnumerable.call(errorProto, 'name');

    // Detect if `prototype` properties are enumerable by default.
    support.enumPrototypes = propertyIsEnumerable.call(ctor, 'prototype');

    // Detect if `arguments` object indexes are non-enumerable
    support.nonEnumArgs = key != 0;

    // Detect if properties shadowing those on `Object.prototype` are non-enumerable.
    support.nonEnumShadows = !/valueOf/.test(props);
  }(1));

  var isObject = Rx.internals.isObject = function(value) {
    var type = typeof value;
    return value && (type == 'function' || type == 'object') || false;
  };

  function keysIn(object) {
    var result = [];
    if (!isObject(object)) {
      return result;
    }
    if (support.nonEnumArgs && object.length && isArguments(object)) {
      object = slice.call(object);
    }
    var skipProto = support.enumPrototypes && typeof object == 'function',
        skipErrorProps = support.enumErrorProps && (object === errorProto || object instanceof Error);

    for (var key in object) {
      if (!(skipProto && key == 'prototype') &&
          !(skipErrorProps && (key == 'message' || key == 'name'))) {
        result.push(key);
      }
    }

    if (support.nonEnumShadows && object !== objectProto) {
      var ctor = object.constructor,
          index = -1,
          length = dontEnumsLength;

      if (object === (ctor && ctor.prototype)) {
        var className = object === stringProto ? stringClass : object === errorProto ? errorClass : toString.call(object),
            nonEnum = nonEnumProps[className];
      }
      while (++index < length) {
        key = dontEnums[index];
        if (!(nonEnum && nonEnum[key]) && hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
    }
    return result;
  }

  function internalFor(object, callback, keysFunc) {
    var index = -1,
      props = keysFunc(object),
      length = props.length;

    while (++index < length) {
      var key = props[index];
      if (callback(object[key], key, object) === false) {
        break;
      }
    }
    return object;
  }

  function internalForIn(object, callback) {
    return internalFor(object, callback, keysIn);
  }

  function isNode(value) {
    // IE < 9 presents DOM nodes as `Object` objects except they have `toString`
    // methods that are `typeof` "string" and still can coerce nodes to strings
    return typeof value.toString != 'function' && typeof (value + '') == 'string';
  }

  var isArguments = function(value) {
    return (value && typeof value == 'object') ? toString.call(value) == argsClass : false;
  }

  // fallback for browsers that can't detect `arguments` objects by [[Class]]
  if (!supportsArgsClass) {
    isArguments = function(value) {
      return (value && typeof value == 'object') ? hasOwnProperty.call(value, 'callee') : false;
    };
  }

  var isEqual = Rx.internals.isEqual = function (x, y) {
    return deepEquals(x, y, [], []);
  };

  /** @private
   * Used for deep comparison
   **/
  function deepEquals(a, b, stackA, stackB) {
    // exit early for identical values
    if (a === b) {
      // treat `+0` vs. `-0` as not equal
      return a !== 0 || (1 / a == 1 / b);
    }

    var type = typeof a,
        otherType = typeof b;

    // exit early for unlike primitive values
    if (a === a && (a == null || b == null ||
        (type != 'function' && type != 'object' && otherType != 'function' && otherType != 'object'))) {
      return false;
    }

    // compare [[Class]] names
    var className = toString.call(a),
        otherClass = toString.call(b);

    if (className == argsClass) {
      className = objectClass;
    }
    if (otherClass == argsClass) {
      otherClass = objectClass;
    }
    if (className != otherClass) {
      return false;
    }
    switch (className) {
      case boolClass:
      case dateClass:
        // coerce dates and booleans to numbers, dates to milliseconds and booleans
        // to `1` or `0` treating invalid dates coerced to `NaN` as not equal
        return +a == +b;

      case numberClass:
        // treat `NaN` vs. `NaN` as equal
        return (a != +a) ?
          b != +b :
          // but treat `-0` vs. `+0` as not equal
          (a == 0 ? (1 / a == 1 / b) : a == +b);

      case regexpClass:
      case stringClass:
        // coerce regexes to strings (http://es5.github.io/#x15.10.6.4)
        // treat string primitives and their corresponding object instances as equal
        return a == String(b);
    }
    var isArr = className == arrayClass;
    if (!isArr) {

      // exit for functions and DOM nodes
      if (className != objectClass || (!support.nodeClass && (isNode(a) || isNode(b)))) {
        return false;
      }
      // in older versions of Opera, `arguments` objects have `Array` constructors
      var ctorA = !support.argsObject && isArguments(a) ? Object : a.constructor,
          ctorB = !support.argsObject && isArguments(b) ? Object : b.constructor;

      // non `Object` object instances with different constructors are not equal
      if (ctorA != ctorB &&
            !(hasOwnProperty.call(a, 'constructor') && hasOwnProperty.call(b, 'constructor')) &&
            !(isFunction(ctorA) && ctorA instanceof ctorA && isFunction(ctorB) && ctorB instanceof ctorB) &&
            ('constructor' in a && 'constructor' in b)
          ) {
        return false;
      }
    }
    // assume cyclic structures are equal
    // the algorithm for detecting cyclic structures is adapted from ES 5.1
    // section 15.12.3, abstract operation `JO` (http://es5.github.io/#x15.12.3)
    var initedStack = !stackA;
    stackA || (stackA = []);
    stackB || (stackB = []);

    var length = stackA.length;
    while (length--) {
      if (stackA[length] == a) {
        return stackB[length] == b;
      }
    }
    var size = 0;
    var result = true;

    // add `a` and `b` to the stack of traversed objects
    stackA.push(a);
    stackB.push(b);

    // recursively compare objects and arrays (susceptible to call stack limits)
    if (isArr) {
      // compare lengths to determine if a deep comparison is necessary
      length = a.length;
      size = b.length;
      result = size == length;

      if (result) {
        // deep compare the contents, ignoring non-numeric properties
        while (size--) {
          var index = length,
              value = b[size];

          if (!(result = deepEquals(a[size], value, stackA, stackB))) {
            break;
          }
        }
      }
    }
    else {
      // deep compare objects using `forIn`, instead of `forOwn`, to avoid `Object.keys`
      // which, in this case, is more costly
      internalForIn(b, function(value, key, b) {
        if (hasOwnProperty.call(b, key)) {
          // count the number of properties.
          size++;
          // deep compare each property value.
          return (result = hasOwnProperty.call(a, key) && deepEquals(a[key], value, stackA, stackB));
        }
      });

      if (result) {
        // ensure both objects have the same number of properties
        internalForIn(a, function(value, key, a) {
          if (hasOwnProperty.call(a, key)) {
            // `size` will be `-1` if `a` has more properties than `b`
            return (result = --size > -1);
          }
        });
      }
    }
    stackA.pop();
    stackB.pop();

    return result;
  }

  var hasProp = {}.hasOwnProperty,
      slice = Array.prototype.slice;

  var inherits = Rx.internals.inherits = function (child, parent) {
    function __() { this.constructor = child; }
    __.prototype = parent.prototype;
    child.prototype = new __();
  };

  var addProperties = Rx.internals.addProperties = function (obj) {
    for(var sources = [], i = 1, len = arguments.length; i < len; i++) { sources.push(arguments[i]); }
    for (var idx = 0, ln = sources.length; idx < ln; idx++) {
      var source = sources[idx];
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  };

  // Rx Utils
  var addRef = Rx.internals.addRef = function (xs, r) {
    return new AnonymousObservable(function (observer) {
      return new CompositeDisposable(r.getDisposable(), xs.subscribe(observer));
    });
  };

  function arrayInitialize(count, factory) {
    var a = new Array(count);
    for (var i = 0; i < count; i++) {
      a[i] = factory();
    }
    return a;
  }

  /**
   * Represents a group of disposable resources that are disposed together.
   * @constructor
   */
  var CompositeDisposable = Rx.CompositeDisposable = function () {
    var args = [], i, len;
    if (Array.isArray(arguments[0])) {
      args = arguments[0];
      len = args.length;
    } else {
      len = arguments.length;
      args = new Array(len);
      for(i = 0; i < len; i++) { args[i] = arguments[i]; }
    }
    for(i = 0; i < len; i++) {
      if (!isDisposable(args[i])) { throw new TypeError('Not a disposable'); }
    }
    this.disposables = args;
    this.isDisposed = false;
    this.length = args.length;
  };

  var CompositeDisposablePrototype = CompositeDisposable.prototype;

  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Mixed} item Disposable to add.
   */
  CompositeDisposablePrototype.add = function (item) {
    if (this.isDisposed) {
      item.dispose();
    } else {
      this.disposables.push(item);
      this.length++;
    }
  };

  /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Mixed} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */
  CompositeDisposablePrototype.remove = function (item) {
    var shouldDispose = false;
    if (!this.isDisposed) {
      var idx = this.disposables.indexOf(item);
      if (idx !== -1) {
        shouldDispose = true;
        this.disposables.splice(idx, 1);
        this.length--;
        item.dispose();
      }
    }
    return shouldDispose;
  };

  /**
   *  Disposes all disposables in the group and removes them from the group.
   */
  CompositeDisposablePrototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var len = this.disposables.length, currentDisposables = new Array(len);
      for(var i = 0; i < len; i++) { currentDisposables[i] = this.disposables[i]; }
      this.disposables = [];
      this.length = 0;

      for (i = 0; i < len; i++) {
        currentDisposables[i].dispose();
      }
    }
  };

  /**
   * Provides a set of static methods for creating Disposables.
   * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
   */
  var Disposable = Rx.Disposable = function (action) {
    this.isDisposed = false;
    this.action = action || noop;
  };

  /** Performs the task of cleaning up resources. */
  Disposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.action();
      this.isDisposed = true;
    }
  };

  /**
   * Creates a disposable object that invokes the specified action when disposed.
   * @param {Function} dispose Action to run during the first call to dispose. The action is guaranteed to be run at most once.
   * @return {Disposable} The disposable object that runs the given action upon disposal.
   */
  var disposableCreate = Disposable.create = function (action) { return new Disposable(action); };

  /**
   * Gets the disposable that does nothing when disposed.
   */
  var disposableEmpty = Disposable.empty = { dispose: noop };

  /**
   * Validates whether the given object is a disposable
   * @param {Object} Object to test whether it has a dispose method
   * @returns {Boolean} true if a disposable object, else false.
   */
  var isDisposable = Disposable.isDisposable = function (d) {
    return d && isFunction(d.dispose);
  };

  var checkDisposed = Disposable.checkDisposed = function (disposable) {
    if (disposable.isDisposed) { throw new ObjectDisposedError(); }
  };

  // Single assignment
  var SingleAssignmentDisposable = Rx.SingleAssignmentDisposable = function () {
    this.isDisposed = false;
    this.current = null;
  };
  SingleAssignmentDisposable.prototype.getDisposable = function () {
    return this.current;
  };
  SingleAssignmentDisposable.prototype.setDisposable = function (value) {
    if (this.current) { throw new Error('Disposable has already been assigned'); }
    var shouldDispose = this.isDisposed;
    !shouldDispose && (this.current = value);
    shouldDispose && value && value.dispose();
  };
  SingleAssignmentDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var old = this.current;
      this.current = null;
    }
    old && old.dispose();
  };

  // Multiple assignment disposable
  var SerialDisposable = Rx.SerialDisposable = function () {
    this.isDisposed = false;
    this.current = null;
  };
  SerialDisposable.prototype.getDisposable = function () {
    return this.current;
  };
  SerialDisposable.prototype.setDisposable = function (value) {
    var shouldDispose = this.isDisposed;
    if (!shouldDispose) {
      var old = this.current;
      this.current = value;
    }
    old && old.dispose();
    shouldDispose && value && value.dispose();
  };
  SerialDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this.isDisposed = true;
      var old = this.current;
      this.current = null;
    }
    old && old.dispose();
  };

  /**
   * Represents a disposable resource that only disposes its underlying disposable resource when all dependent disposable objects have been disposed.
   */
  var RefCountDisposable = Rx.RefCountDisposable = (function () {

    function InnerDisposable(disposable) {
      this.disposable = disposable;
      this.disposable.count++;
      this.isInnerDisposed = false;
    }

    InnerDisposable.prototype.dispose = function () {
      if (!this.disposable.isDisposed && !this.isInnerDisposed) {
        this.isInnerDisposed = true;
        this.disposable.count--;
        if (this.disposable.count === 0 && this.disposable.isPrimaryDisposed) {
          this.disposable.isDisposed = true;
          this.disposable.underlyingDisposable.dispose();
        }
      }
    };

    /**
     * Initializes a new instance of the RefCountDisposable with the specified disposable.
     * @constructor
     * @param {Disposable} disposable Underlying disposable.
      */
    function RefCountDisposable(disposable) {
      this.underlyingDisposable = disposable;
      this.isDisposed = false;
      this.isPrimaryDisposed = false;
      this.count = 0;
    }

    /**
     * Disposes the underlying disposable only when all dependent disposables have been disposed
     */
    RefCountDisposable.prototype.dispose = function () {
      if (!this.isDisposed && !this.isPrimaryDisposed) {
        this.isPrimaryDisposed = true;
        if (this.count === 0) {
          this.isDisposed = true;
          this.underlyingDisposable.dispose();
        }
      }
    };

    /**
     * Returns a dependent disposable that when disposed decreases the refcount on the underlying disposable.
     * @returns {Disposable} A dependent disposable contributing to the reference count that manages the underlying disposable's lifetime.
     */
    RefCountDisposable.prototype.getDisposable = function () {
      return this.isDisposed ? disposableEmpty : new InnerDisposable(this);
    };

    return RefCountDisposable;
  })();

  var ScheduledItem = Rx.internals.ScheduledItem = function (scheduler, state, action, dueTime, comparer) {
    this.scheduler = scheduler;
    this.state = state;
    this.action = action;
    this.dueTime = dueTime;
    this.comparer = comparer || defaultSubComparer;
    this.disposable = new SingleAssignmentDisposable();
  }

  ScheduledItem.prototype.invoke = function () {
    this.disposable.setDisposable(this.invokeCore());
  };

  ScheduledItem.prototype.compareTo = function (other) {
    return this.comparer(this.dueTime, other.dueTime);
  };

  ScheduledItem.prototype.isCancelled = function () {
    return this.disposable.isDisposed;
  };

  ScheduledItem.prototype.invokeCore = function () {
    return this.action(this.scheduler, this.state);
  };

  /** Provides a set of static properties to access commonly used schedulers. */
  var Scheduler = Rx.Scheduler = (function () {

    function Scheduler(now, schedule, scheduleRelative, scheduleAbsolute) {
      this.now = now;
      this._schedule = schedule;
      this._scheduleRelative = scheduleRelative;
      this._scheduleAbsolute = scheduleAbsolute;
    }

    /** Determines whether the given object is a scheduler */
    Scheduler.isScheduler = function (s) {
      return s instanceof Scheduler;
    }

    function invokeAction(scheduler, action) {
      action();
      return disposableEmpty;
    }

    var schedulerProto = Scheduler.prototype;

    /**
     * Schedules an action to be executed.
     * @param {Function} action Action to execute.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.schedule = function (action) {
      return this._schedule(action, invokeAction);
    };

    /**
     * Schedules an action to be executed.
     * @param state State passed to the action to be executed.
     * @param {Function} action Action to be executed.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleWithState = function (state, action) {
      return this._schedule(state, action);
    };

    /**
     * Schedules an action to be executed after the specified relative due time.
     * @param {Function} action Action to execute.
     * @param {Number} dueTime Relative time after which to execute the action.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleWithRelative = function (dueTime, action) {
      return this._scheduleRelative(action, dueTime, invokeAction);
    };

    /**
     * Schedules an action to be executed after dueTime.
     * @param state State passed to the action to be executed.
     * @param {Function} action Action to be executed.
     * @param {Number} dueTime Relative time after which to execute the action.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleWithRelativeAndState = function (state, dueTime, action) {
      return this._scheduleRelative(state, dueTime, action);
    };

    /**
     * Schedules an action to be executed at the specified absolute due time.
     * @param {Function} action Action to execute.
     * @param {Number} dueTime Absolute time at which to execute the action.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
      */
    schedulerProto.scheduleWithAbsolute = function (dueTime, action) {
      return this._scheduleAbsolute(action, dueTime, invokeAction);
    };

    /**
     * Schedules an action to be executed at dueTime.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to be executed.
     * @param {Number}dueTime Absolute time at which to execute the action.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleWithAbsoluteAndState = function (state, dueTime, action) {
      return this._scheduleAbsolute(state, dueTime, action);
    };

    /** Gets the current time according to the local machine's system clock. */
    Scheduler.now = defaultNow;

    /**
     * Normalizes the specified TimeSpan value to a positive value.
     * @param {Number} timeSpan The time span value to normalize.
     * @returns {Number} The specified TimeSpan value if it is zero or positive; otherwise, 0
     */
    Scheduler.normalize = function (timeSpan) {
      timeSpan < 0 && (timeSpan = 0);
      return timeSpan;
    };

    return Scheduler;
  }());

  var normalizeTime = Scheduler.normalize, isScheduler = Scheduler.isScheduler;

  (function (schedulerProto) {

    function invokeRecImmediate(scheduler, pair) {
      var state = pair[0], action = pair[1], group = new CompositeDisposable();
      action(state, innerAction);
      return group;

      function innerAction(state2) {
        var isAdded = false, isDone = false;

        var d = scheduler.scheduleWithState(state2, scheduleWork);
        if (!isDone) {
          group.add(d);
          isAdded = true;
        }

        function scheduleWork(_, state3) {
          if (isAdded) {
            group.remove(d);
          } else {
            isDone = true;
          }
          action(state3, innerAction);
          return disposableEmpty;
        }
      }
    }

    function invokeRecDate(scheduler, pair, method) {
      var state = pair[0], action = pair[1], group = new CompositeDisposable();
      action(state, innerAction);
      return group;

      function innerAction(state2, dueTime1) {
        var isAdded = false, isDone = false;

        var d = scheduler[method](state2, dueTime1, scheduleWork);
        if (!isDone) {
          group.add(d);
          isAdded = true;
        }

        function scheduleWork(_, state3) {
          if (isAdded) {
            group.remove(d);
          } else {
            isDone = true;
          }
          action(state3, innerAction);
          return disposableEmpty;
        }
      }
    }

    function invokeRecDateRelative(s, p) {
      return invokeRecDate(s, p, 'scheduleWithRelativeAndState');
    }

    function invokeRecDateAbsolute(s, p) {
      return invokeRecDate(s, p, 'scheduleWithAbsoluteAndState');
    }

    function scheduleInnerRecursive(action, self) {
      action(function(dt) { self(action, dt); });
    }

    /**
     * Schedules an action to be executed recursively.
     * @param {Function} action Action to execute recursively. The parameter passed to the action is used to trigger recursive scheduling of the action.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursive = function (action) {
      return this.scheduleRecursiveWithState(action, scheduleInnerRecursive);
    };

    /**
     * Schedules an action to be executed recursively.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in recursive invocation state.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursiveWithState = function (state, action) {
      return this.scheduleWithState([state, action], invokeRecImmediate);
    };

    /**
     * Schedules an action to be executed recursively after a specified relative due time.
     * @param {Function} action Action to execute recursively. The parameter passed to the action is used to trigger recursive scheduling of the action at the specified relative time.
     * @param {Number}dueTime Relative time after which to execute the action for the first time.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursiveWithRelative = function (dueTime, action) {
      return this.scheduleRecursiveWithRelativeAndState(action, dueTime, scheduleInnerRecursive);
    };

    /**
     * Schedules an action to be executed recursively after a specified relative due time.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in the recursive due time and invocation state.
     * @param {Number}dueTime Relative time after which to execute the action for the first time.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursiveWithRelativeAndState = function (state, dueTime, action) {
      return this._scheduleRelative([state, action], dueTime, invokeRecDateRelative);
    };

    /**
     * Schedules an action to be executed recursively at a specified absolute due time.
     * @param {Function} action Action to execute recursively. The parameter passed to the action is used to trigger recursive scheduling of the action at the specified absolute time.
     * @param {Number}dueTime Absolute time at which to execute the action for the first time.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursiveWithAbsolute = function (dueTime, action) {
      return this.scheduleRecursiveWithAbsoluteAndState(action, dueTime, scheduleInnerRecursive);
    };

    /**
     * Schedules an action to be executed recursively at a specified absolute due time.
     * @param {Mixed} state State passed to the action to be executed.
     * @param {Function} action Action to execute recursively. The last parameter passed to the action is used to trigger recursive scheduling of the action, passing in the recursive due time and invocation state.
     * @param {Number}dueTime Absolute time at which to execute the action for the first time.
     * @returns {Disposable} The disposable object used to cancel the scheduled action (best effort).
     */
    schedulerProto.scheduleRecursiveWithAbsoluteAndState = function (state, dueTime, action) {
      return this._scheduleAbsolute([state, action], dueTime, invokeRecDateAbsolute);
    };
  }(Scheduler.prototype));

  (function (schedulerProto) {

    /**
     * Schedules a periodic piece of work by dynamically discovering the scheduler's capabilities. The periodic task will be scheduled using window.setInterval for the base implementation.
     * @param {Number} period Period for running the work periodically.
     * @param {Function} action Action to be executed.
     * @returns {Disposable} The disposable object used to cancel the scheduled recurring action (best effort).
     */
    Scheduler.prototype.schedulePeriodic = function (period, action) {
      return this.schedulePeriodicWithState(null, period, action);
    };

    /**
     * Schedules a periodic piece of work by dynamically discovering the scheduler's capabilities. The periodic task will be scheduled using window.setInterval for the base implementation.
     * @param {Mixed} state Initial state passed to the action upon the first iteration.
     * @param {Number} period Period for running the work periodically.
     * @param {Function} action Action to be executed, potentially updating the state.
     * @returns {Disposable} The disposable object used to cancel the scheduled recurring action (best effort).
     */
    Scheduler.prototype.schedulePeriodicWithState = function(state, period, action) {
      if (typeof root.setInterval === 'undefined') { throw new NotSupportedError(); }
      period = normalizeTime(period);
      var s = state, id = root.setInterval(function () { s = action(s); }, period);
      return disposableCreate(function () { root.clearInterval(id); });
    };

  }(Scheduler.prototype));

  /** Gets a scheduler that schedules work immediately on the current thread. */
  var immediateScheduler = Scheduler.immediate = (function () {
    function scheduleNow(state, action) { return action(this, state); }
    return new Scheduler(defaultNow, scheduleNow, notSupported, notSupported);
  }());

  /**
   * Gets a scheduler that schedules work as soon as possible on the current thread.
   */
  var currentThreadScheduler = Scheduler.currentThread = (function () {
    var queue;

    function runTrampoline () {
      while (queue.length > 0) {
        var item = queue.shift();
        !item.isCancelled() && item.invoke();
      }
    }

    function scheduleNow(state, action) {
      var si = new ScheduledItem(this, state, action, this.now());

      if (!queue) {
        queue = [si];

        var result = tryCatch(runTrampoline)();
        queue = null;
        if (result === errorObj) { return thrower(result.e); }
      } else {
        queue.push(si);
      }
      return si.disposable;
    }

    var currentScheduler = new Scheduler(defaultNow, scheduleNow, notSupported, notSupported);
    currentScheduler.scheduleRequired = function () { return !queue; };

    return currentScheduler;
  }());

  var SchedulePeriodicRecursive = Rx.internals.SchedulePeriodicRecursive = (function () {
    function tick(command, recurse) {
      recurse(0, this._period);
      try {
        this._state = this._action(this._state);
      } catch (e) {
        this._cancel.dispose();
        throw e;
      }
    }

    function SchedulePeriodicRecursive(scheduler, state, period, action) {
      this._scheduler = scheduler;
      this._state = state;
      this._period = period;
      this._action = action;
    }

    SchedulePeriodicRecursive.prototype.start = function () {
      var d = new SingleAssignmentDisposable();
      this._cancel = d;
      d.setDisposable(this._scheduler.scheduleRecursiveWithRelativeAndState(0, this._period, tick.bind(this)));

      return d;
    };

    return SchedulePeriodicRecursive;
  }());

  var scheduleMethod, clearMethod;

  var localTimer = (function () {
    var localSetTimeout, localClearTimeout = noop;
    if (!!root.setTimeout) {
      localSetTimeout = root.setTimeout;
      localClearTimeout = root.clearTimeout;
    } else if (!!root.WScript) {
      localSetTimeout = function (fn, time) {
        root.WScript.Sleep(time);
        fn();
      };
    } else {
      throw new NotSupportedError();
    }

    return {
      setTimeout: localSetTimeout,
      clearTimeout: localClearTimeout
    };
  }());
  var localSetTimeout = localTimer.setTimeout,
    localClearTimeout = localTimer.clearTimeout;

  (function () {

    var nextHandle = 1, tasksByHandle = {}, currentlyRunning = false;

    clearMethod = function (handle) {
      delete tasksByHandle[handle];
    };

    function runTask(handle) {
      if (currentlyRunning) {
        localSetTimeout(function () { runTask(handle) }, 0);
      } else {
        var task = tasksByHandle[handle];
        if (task) {
          currentlyRunning = true;
          var result = tryCatch(task)();
          clearMethod(handle);
          currentlyRunning = false;
          if (result === errorObj) { return thrower(result.e); }
        }
      }
    }

    var reNative = RegExp('^' +
      String(toString)
        .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        .replace(/toString| for [^\]]+/g, '.*?') + '$'
    );

    var setImmediate = typeof (setImmediate = freeGlobal && moduleExports && freeGlobal.setImmediate) == 'function' &&
      !reNative.test(setImmediate) && setImmediate;

    function postMessageSupported () {
      // Ensure not in a worker
      if (!root.postMessage || root.importScripts) { return false; }
      var isAsync = false, oldHandler = root.onmessage;
      // Test for async
      root.onmessage = function () { isAsync = true; };
      root.postMessage('', '*');
      root.onmessage = oldHandler;

      return isAsync;
    }

    // Use in order, setImmediate, nextTick, postMessage, MessageChannel, script readystatechanged, setTimeout
    if (isFunction(setImmediate)) {
      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        setImmediate(function () { runTask(id); });

        return id;
      };
    } else if (typeof process !== 'undefined' && {}.toString.call(process) === '[object process]') {
      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        process.nextTick(function () { runTask(id); });

        return id;
      };
    } else if (postMessageSupported()) {
      var MSG_PREFIX = 'ms.rx.schedule' + Math.random();

      function onGlobalPostMessage(event) {
        // Only if we're a match to avoid any other global events
        if (typeof event.data === 'string' && event.data.substring(0, MSG_PREFIX.length) === MSG_PREFIX) {
          runTask(event.data.substring(MSG_PREFIX.length));
        }
      }

      if (root.addEventListener) {
        root.addEventListener('message', onGlobalPostMessage, false);
      } else if (root.attachEvent) {
        root.attachEvent('onmessage', onGlobalPostMessage);
      } else {
        root.onmessage = onGlobalPostMessage;
      }

      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        root.postMessage(MSG_PREFIX + currentId, '*');
        return id;
      };
    } else if (!!root.MessageChannel) {
      var channel = new root.MessageChannel();

      channel.port1.onmessage = function (e) { runTask(e.data); };

      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        channel.port2.postMessage(id);
        return id;
      };
    } else if ('document' in root && 'onreadystatechange' in root.document.createElement('script')) {

      scheduleMethod = function (action) {
        var scriptElement = root.document.createElement('script');
        var id = nextHandle++;
        tasksByHandle[id] = action;

        scriptElement.onreadystatechange = function () {
          runTask(id);
          scriptElement.onreadystatechange = null;
          scriptElement.parentNode.removeChild(scriptElement);
          scriptElement = null;
        };
        root.document.documentElement.appendChild(scriptElement);
        return id;
      };

    } else {
      scheduleMethod = function (action) {
        var id = nextHandle++;
        tasksByHandle[id] = action;
        localSetTimeout(function () {
          runTask(id);
        }, 0);

        return id;
      };
    }
  }());

  /**
   * Gets a scheduler that schedules work via a timed callback based upon platform.
   */
  var timeoutScheduler = Scheduler.timeout = Scheduler['default'] = (function () {

    function scheduleNow(state, action) {
      var scheduler = this, disposable = new SingleAssignmentDisposable();
      var id = scheduleMethod(function () {
        !disposable.isDisposed && disposable.setDisposable(action(scheduler, state));
      });
      return new CompositeDisposable(disposable, disposableCreate(function () {
        clearMethod(id);
      }));
    }

    function scheduleRelative(state, dueTime, action) {
      var scheduler = this, dt = Scheduler.normalize(dueTime), disposable = new SingleAssignmentDisposable();
      if (dt === 0) { return scheduler.scheduleWithState(state, action); }
      var id = localSetTimeout(function () {
        !disposable.isDisposed && disposable.setDisposable(action(scheduler, state));
      }, dt);
      return new CompositeDisposable(disposable, disposableCreate(function () {
        localClearTimeout(id);
      }));
    }

    function scheduleAbsolute(state, dueTime, action) {
      return this.scheduleWithRelativeAndState(state, dueTime - this.now(), action);
    }

    return new Scheduler(defaultNow, scheduleNow, scheduleRelative, scheduleAbsolute);
  })();

  /**
   *  Represents a notification to an observer.
   */
  var Notification = Rx.Notification = (function () {
    function Notification(kind, value, exception, accept, acceptObservable, toString) {
      this.kind = kind;
      this.value = value;
      this.exception = exception;
      this._accept = accept;
      this._acceptObservable = acceptObservable;
      this.toString = toString;
    }

    /**
     * Invokes the delegate corresponding to the notification or the observer's method corresponding to the notification and returns the produced result.
     *
     * @memberOf Notification
     * @param {Any} observerOrOnNext Delegate to invoke for an OnNext notification or Observer to invoke the notification on..
     * @param {Function} onError Delegate to invoke for an OnError notification.
     * @param {Function} onCompleted Delegate to invoke for an OnCompleted notification.
     * @returns {Any} Result produced by the observation.
     */
    Notification.prototype.accept = function (observerOrOnNext, onError, onCompleted) {
      return observerOrOnNext && typeof observerOrOnNext === 'object' ?
        this._acceptObservable(observerOrOnNext) :
        this._accept(observerOrOnNext, onError, onCompleted);
    };

    /**
     * Returns an observable sequence with a single notification.
     *
     * @memberOf Notifications
     * @param {Scheduler} [scheduler] Scheduler to send out the notification calls on.
     * @returns {Observable} The observable sequence that surfaces the behavior of the notification upon subscription.
     */
    Notification.prototype.toObservable = function (scheduler) {
      var self = this;
      isScheduler(scheduler) || (scheduler = immediateScheduler);
      return new AnonymousObservable(function (observer) {
        return scheduler.scheduleWithState(self, function (_, notification) {
          notification._acceptObservable(observer);
          notification.kind === 'N' && observer.onCompleted();
        });
      });
    };

    return Notification;
  })();

  /**
   * Creates an object that represents an OnNext notification to an observer.
   * @param {Any} value The value contained in the notification.
   * @returns {Notification} The OnNext notification containing the value.
   */
  var notificationCreateOnNext = Notification.createOnNext = (function () {
      function _accept(onNext) { return onNext(this.value); }
      function _acceptObservable(observer) { return observer.onNext(this.value); }
      function toString() { return 'OnNext(' + this.value + ')'; }

      return function (value) {
        return new Notification('N', value, null, _accept, _acceptObservable, toString);
      };
  }());

  /**
   * Creates an object that represents an OnError notification to an observer.
   * @param {Any} error The exception contained in the notification.
   * @returns {Notification} The OnError notification containing the exception.
   */
  var notificationCreateOnError = Notification.createOnError = (function () {
    function _accept (onNext, onError) { return onError(this.exception); }
    function _acceptObservable(observer) { return observer.onError(this.exception); }
    function toString () { return 'OnError(' + this.exception + ')'; }

    return function (e) {
      return new Notification('E', null, e, _accept, _acceptObservable, toString);
    };
  }());

  /**
   * Creates an object that represents an OnCompleted notification to an observer.
   * @returns {Notification} The OnCompleted notification.
   */
  var notificationCreateOnCompleted = Notification.createOnCompleted = (function () {
    function _accept (onNext, onError, onCompleted) { return onCompleted(); }
    function _acceptObservable(observer) { return observer.onCompleted(); }
    function toString () { return 'OnCompleted()'; }

    return function () {
      return new Notification('C', null, null, _accept, _acceptObservable, toString);
    };
  }());

  /**
   * Supports push-style iteration over an observable sequence.
   */
  var Observer = Rx.Observer = function () { };

  /**
   *  Creates an observer from the specified OnNext, along with optional OnError, and OnCompleted actions.
   * @param {Function} [onNext] Observer's OnNext action implementation.
   * @param {Function} [onError] Observer's OnError action implementation.
   * @param {Function} [onCompleted] Observer's OnCompleted action implementation.
   * @returns {Observer} The observer object implemented using the given actions.
   */
  var observerCreate = Observer.create = function (onNext, onError, onCompleted) {
    onNext || (onNext = noop);
    onError || (onError = defaultError);
    onCompleted || (onCompleted = noop);
    return new AnonymousObserver(onNext, onError, onCompleted);
  };

  /**
   * Abstract base class for implementations of the Observer class.
   * This base class enforces the grammar of observers where OnError and OnCompleted are terminal messages.
   */
  var AbstractObserver = Rx.internals.AbstractObserver = (function (__super__) {
    inherits(AbstractObserver, __super__);

    /**
     * Creates a new observer in a non-stopped state.
     */
    function AbstractObserver() {
      this.isStopped = false;
    }

    // Must be implemented by other observers
    AbstractObserver.prototype.next = notImplemented;
    AbstractObserver.prototype.error = notImplemented;
    AbstractObserver.prototype.completed = notImplemented;

    /**
     * Notifies the observer of a new element in the sequence.
     * @param {Any} value Next element in the sequence.
     */
    AbstractObserver.prototype.onNext = function (value) {
      !this.isStopped && this.next(value);
    };

    /**
     * Notifies the observer that an exception has occurred.
     * @param {Any} error The error that has occurred.
     */
    AbstractObserver.prototype.onError = function (error) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.error(error);
      }
    };

    /**
     * Notifies the observer of the end of the sequence.
     */
    AbstractObserver.prototype.onCompleted = function () {
      if (!this.isStopped) {
        this.isStopped = true;
        this.completed();
      }
    };

    /**
     * Disposes the observer, causing it to transition to the stopped state.
     */
    AbstractObserver.prototype.dispose = function () { this.isStopped = true; };

    AbstractObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.error(e);
        return true;
      }

      return false;
    };

    return AbstractObserver;
  }(Observer));

  /**
   * Class to create an Observer instance from delegate-based implementations of the on* methods.
   */
  var AnonymousObserver = Rx.AnonymousObserver = (function (__super__) {
    inherits(AnonymousObserver, __super__);

    /**
     * Creates an observer from the specified OnNext, OnError, and OnCompleted actions.
     * @param {Any} onNext Observer's OnNext action implementation.
     * @param {Any} onError Observer's OnError action implementation.
     * @param {Any} onCompleted Observer's OnCompleted action implementation.
     */
    function AnonymousObserver(onNext, onError, onCompleted) {
      __super__.call(this);
      this._onNext = onNext;
      this._onError = onError;
      this._onCompleted = onCompleted;
    }

    /**
     * Calls the onNext action.
     * @param {Any} value Next element in the sequence.
     */
    AnonymousObserver.prototype.next = function (value) {
      this._onNext(value);
    };

    /**
     * Calls the onError action.
     * @param {Any} error The error that has occurred.
     */
    AnonymousObserver.prototype.error = function (error) {
      this._onError(error);
    };

    /**
     *  Calls the onCompleted action.
     */
    AnonymousObserver.prototype.completed = function () {
      this._onCompleted();
    };

    return AnonymousObserver;
  }(AbstractObserver));

  var observableProto;

  /**
   * Represents a push-style collection.
   */
  var Observable = Rx.Observable = (function () {

    function makeSubscribe(self, subscribe) {
      return function (o) {
        var oldOnError = o.onError;
        o.onError = function (e) {
          makeStackTraceLong(e, self);
          oldOnError.call(o, e);
        };

        return subscribe.call(self, o);
      };
    }

    function Observable(subscribe) {
      if (Rx.config.longStackSupport && hasStacks) {
        var e = tryCatch(thrower)(new Error()).e;
        this.stack = e.stack.substring(e.stack.indexOf('\n') + 1);
        this._subscribe = makeSubscribe(this, subscribe);
      } else {
        this._subscribe = subscribe;
      }
    }

    observableProto = Observable.prototype;

    /**
    * Determines whether the given object is an Observable
    * @param {Any} An object to determine whether it is an Observable
    * @returns {Boolean} true if an Observable, else false.
    */
    Observable.isObservable = function (o) {
      return o && isFunction(o.subscribe);
    }

    /**
     *  Subscribes an o to the observable sequence.
     *  @param {Mixed} [oOrOnNext] The object that is to receive notifications or an action to invoke for each element in the observable sequence.
     *  @param {Function} [onError] Action to invoke upon exceptional termination of the observable sequence.
     *  @param {Function} [onCompleted] Action to invoke upon graceful termination of the observable sequence.
     *  @returns {Diposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribe = observableProto.forEach = function (oOrOnNext, onError, onCompleted) {
      return this._subscribe(typeof oOrOnNext === 'object' ?
        oOrOnNext :
        observerCreate(oOrOnNext, onError, onCompleted));
    };

    /**
     * Subscribes to the next value in the sequence with an optional "this" argument.
     * @param {Function} onNext The function to invoke on each element in the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribeOnNext = function (onNext, thisArg) {
      return this._subscribe(observerCreate(typeof thisArg !== 'undefined' ? function(x) { onNext.call(thisArg, x); } : onNext));
    };

    /**
     * Subscribes to an exceptional condition in the sequence with an optional "this" argument.
     * @param {Function} onError The function to invoke upon exceptional termination of the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribeOnError = function (onError, thisArg) {
      return this._subscribe(observerCreate(null, typeof thisArg !== 'undefined' ? function(e) { onError.call(thisArg, e); } : onError));
    };

    /**
     * Subscribes to the next value in the sequence with an optional "this" argument.
     * @param {Function} onCompleted The function to invoke upon graceful termination of the observable sequence.
     * @param {Any} [thisArg] Object to use as this when executing callback.
     * @returns {Disposable} A disposable handling the subscriptions and unsubscriptions.
     */
    observableProto.subscribeOnCompleted = function (onCompleted, thisArg) {
      return this._subscribe(observerCreate(null, null, typeof thisArg !== 'undefined' ? function() { onCompleted.call(thisArg); } : onCompleted));
    };

    return Observable;
  })();

  var ScheduledObserver = Rx.internals.ScheduledObserver = (function (__super__) {
    inherits(ScheduledObserver, __super__);

    function ScheduledObserver(scheduler, observer) {
      __super__.call(this);
      this.scheduler = scheduler;
      this.observer = observer;
      this.isAcquired = false;
      this.hasFaulted = false;
      this.queue = [];
      this.disposable = new SerialDisposable();
    }

    ScheduledObserver.prototype.next = function (value) {
      var self = this;
      this.queue.push(function () { self.observer.onNext(value); });
    };

    ScheduledObserver.prototype.error = function (e) {
      var self = this;
      this.queue.push(function () { self.observer.onError(e); });
    };

    ScheduledObserver.prototype.completed = function () {
      var self = this;
      this.queue.push(function () { self.observer.onCompleted(); });
    };

    ScheduledObserver.prototype.ensureActive = function () {
      var isOwner = false;
      if (!this.hasFaulted && this.queue.length > 0) {
        isOwner = !this.isAcquired;
        this.isAcquired = true;
      }
      if (isOwner) {
        this.disposable.setDisposable(this.scheduler.scheduleRecursiveWithState(this, function (parent, self) {
          var work;
          if (parent.queue.length > 0) {
            work = parent.queue.shift();
          } else {
            parent.isAcquired = false;
            return;
          }
          var res = tryCatch(work)();
          if (res === errorObj) {
            parent.queue = [];
            parent.hasFaulted = true;
            return thrower(res.e);
          }
          self(parent);
        }));
      }
    };

    ScheduledObserver.prototype.dispose = function () {
      __super__.prototype.dispose.call(this);
      this.disposable.dispose();
    };

    return ScheduledObserver;
  }(AbstractObserver));

  var ObservableBase = Rx.ObservableBase = (function (__super__) {
    inherits(ObservableBase, __super__);

    function fixSubscriber(subscriber) {
      return subscriber && isFunction(subscriber.dispose) ? subscriber :
        isFunction(subscriber) ? disposableCreate(subscriber) : disposableEmpty;
    }

    function setDisposable(s, state) {
      var ado = state[0], self = state[1];
      var sub = tryCatch(self.subscribeCore).call(self, ado);

      if (sub === errorObj) {
        if(!ado.fail(errorObj.e)) { return thrower(errorObj.e); }
      }
      ado.setDisposable(fixSubscriber(sub));
    }

    function subscribe(observer) {
      var ado = new AutoDetachObserver(observer), state = [ado, this];

      if (currentThreadScheduler.scheduleRequired()) {
        currentThreadScheduler.scheduleWithState(state, setDisposable);
      } else {
        setDisposable(null, state);
      }
      return ado;
    }

    function ObservableBase() {
      __super__.call(this, subscribe);
    }

    ObservableBase.prototype.subscribeCore = notImplemented;

    return ObservableBase;
  }(Observable));

var FlatMapObservable = (function(__super__){

    inherits(FlatMapObservable, __super__);

    function FlatMapObservable(source, selector, resultSelector, thisArg) {
        this.resultSelector = Rx.helpers.isFunction(resultSelector) ?
            resultSelector : null;

        this.selector = Rx.internals.bindCallback(Rx.helpers.isFunction(selector) ? selector : function() { return selector; }, thisArg, 3);
        this.source = source;

        __super__.call(this);

    }

    FlatMapObservable.prototype.subscribeCore = function(o) {
        return this.source.subscribe(new InnerObserver(o, this.selector, this.resultSelector, this));
    };

    function InnerObserver(observer, selector, resultSelector, source) {
        this.i = 0;
        this.selector = selector;
        this.resultSelector = resultSelector;
        this.source = source;
        this.isStopped = false;
        this.o = observer;
    }

    InnerObserver.prototype._wrapResult = function(result, x, i) {
        return this.resultSelector ?
            result.map(function(y, i2) { return this.resultSelector(x, y, i, i2); }, this) :
            result;
    };

    InnerObserver.prototype.onNext = function(x) {

        if (this.isStopped) return;

        var i = this.i++;
        var result = tryCatch(this.selector)(x, i, this.source);

        if (result === errorObj) {
            return this.o.onError(result.e);
        }

        Rx.helpers.isPromise(result) && (result = Rx.Observable.fromPromise(result));
        (Rx.helpers.isArrayLike(result) || Rx.helpers.isIterable(result)) && (result = Rx.Observable.from(result));

        this.o.onNext(this._wrapResult(result, x, i));

    };

    InnerObserver.prototype.onError = function(e) {
        if(!this.isStopped) { this.isStopped = true; this.o.onError(e); }
    };

    InnerObserver.prototype.onCompleted = function() {
        if (!this.isStopped) {this.isStopped = true; this.o.onCompleted(); }
    };

    return FlatMapObservable;

}(ObservableBase));

  var Enumerable = Rx.internals.Enumerable = function () { };

  var ConcatEnumerableObservable = (function(__super__) {
    inherits(ConcatEnumerableObservable, __super__);
    function ConcatEnumerableObservable(sources) {
      this.sources = sources;
      __super__.call(this);
    }
    
    ConcatEnumerableObservable.prototype.subscribeCore = function (o) {
      var isDisposed, subscription = new SerialDisposable();
      var cancelable = immediateScheduler.scheduleRecursiveWithState(this.sources[$iterator$](), function (e, self) {
        if (isDisposed) { return; }
        var currentItem = tryCatch(e.next).call(e);
        if (currentItem === errorObj) { return o.onError(currentItem.e); }

        if (currentItem.done) {
          return o.onCompleted();
        }

        // Check if promise
        var currentValue = currentItem.value;
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

        var d = new SingleAssignmentDisposable();
        subscription.setDisposable(d);
        d.setDisposable(currentValue.subscribe(new InnerObserver(o, self, e)));
      });

      return new CompositeDisposable(subscription, cancelable, disposableCreate(function () {
        isDisposed = true;
      }));
    };
    
    function InnerObserver(o, s, e) {
      this.o = o;
      this.s = s;
      this.e = e;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = function (x) { if(!this.isStopped) { this.o.onNext(x); } };
    InnerObserver.prototype.onError = function (err) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(err);
      }
    };
    InnerObserver.prototype.onCompleted = function () {
      if (!this.isStopped) {
        this.isStopped = true;
        this.s(this.e);
      }
    };
    InnerObserver.prototype.dispose = function () { this.isStopped = true; };
    InnerObserver.prototype.fail = function (err) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(err);
        return true;
      }
      return false;
    };
    
    return ConcatEnumerableObservable;
  }(ObservableBase));

  Enumerable.prototype.concat = function () {
    return new ConcatEnumerableObservable(this);
  };
  
  var CatchErrorObservable = (function(__super__) {
    inherits(CatchErrorObservable, __super__);
    function CatchErrorObservable(sources) {
      this.sources = sources;
      __super__.call(this);
    }
    
    CatchErrorObservable.prototype.subscribeCore = function (o) {
      var e = this.sources[$iterator$]();

      var isDisposed, subscription = new SerialDisposable();
      var cancelable = immediateScheduler.scheduleRecursiveWithState(null, function (lastException, self) {
        if (isDisposed) { return; }
        var currentItem = tryCatch(e.next).call(e);
        if (currentItem === errorObj) { return o.onError(currentItem.e); }

        if (currentItem.done) {
          return lastException !== null ? o.onError(lastException) : o.onCompleted();
        }

        // Check if promise
        var currentValue = currentItem.value;
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

        var d = new SingleAssignmentDisposable();
        subscription.setDisposable(d);
        d.setDisposable(currentValue.subscribe(
          function(x) { o.onNext(x); },
          self,
          function() { o.onCompleted(); }));
      });
      return new CompositeDisposable(subscription, cancelable, disposableCreate(function () {
        isDisposed = true;
      }));
    };
    
    return CatchErrorObservable;
  }(ObservableBase));

  Enumerable.prototype.catchError = function () {
    return new CatchErrorObservable(this);
  };

  Enumerable.prototype.catchErrorWhen = function (notificationHandler) {
    var sources = this;
    return new AnonymousObservable(function (o) {
      var exceptions = new Subject(),
        notifier = new Subject(),
        handled = notificationHandler(exceptions),
        notificationDisposable = handled.subscribe(notifier);

      var e = sources[$iterator$]();

      var isDisposed,
        lastException,
        subscription = new SerialDisposable();
      var cancelable = immediateScheduler.scheduleRecursive(function (self) {
        if (isDisposed) { return; }
        var currentItem = tryCatch(e.next).call(e);
        if (currentItem === errorObj) { return o.onError(currentItem.e); }

        if (currentItem.done) {
          if (lastException) {
            o.onError(lastException);
          } else {
            o.onCompleted();
          }
          return;
        }

        // Check if promise
        var currentValue = currentItem.value;
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

        var outer = new SingleAssignmentDisposable();
        var inner = new SingleAssignmentDisposable();
        subscription.setDisposable(new CompositeDisposable(inner, outer));
        outer.setDisposable(currentValue.subscribe(
          function(x) { o.onNext(x); },
          function (exn) {
            inner.setDisposable(notifier.subscribe(self, function(ex) {
              o.onError(ex);
            }, function() {
              o.onCompleted();
            }));

            exceptions.onNext(exn);
          },
          function() { o.onCompleted(); }));
      });

      return new CompositeDisposable(notificationDisposable, subscription, cancelable, disposableCreate(function () {
        isDisposed = true;
      }));
    });
  };
  
  var RepeatEnumerable = (function (__super__) {
    inherits(RepeatEnumerable, __super__);
    
    function RepeatEnumerable(v, c) {
      this.v = v;
      this.c = c == null ? -1 : c;
    }
    RepeatEnumerable.prototype[$iterator$] = function () {
      return new RepeatEnumerator(this); 
    };
    
    function RepeatEnumerator(p) {
      this.v = p.v;
      this.l = p.c;
    }
    RepeatEnumerator.prototype.next = function () {
      if (this.l === 0) { return doneEnumerator; }
      if (this.l > 0) { this.l--; }
      return { done: false, value: this.v }; 
    };
    
    return RepeatEnumerable;
  }(Enumerable));

  var enumerableRepeat = Enumerable.repeat = function (value, repeatCount) {
    return new RepeatEnumerable(value, repeatCount);
  };
  
  var OfEnumerable = (function(__super__) {
    inherits(OfEnumerable, __super__);
    function OfEnumerable(s, fn, thisArg) {
      this.s = s;
      this.fn = fn ? bindCallback(fn, thisArg, 3) : null;
    }
    OfEnumerable.prototype[$iterator$] = function () {
      return new OfEnumerator(this);
    };
    
    function OfEnumerator(p) {
      this.i = -1;
      this.s = p.s;
      this.l = this.s.length;
      this.fn = p.fn;
    }
    OfEnumerator.prototype.next = function () {
     return ++this.i < this.l ?
       { done: false, value: !this.fn ? this.s[this.i] : this.fn(this.s[this.i], this.i, this.s) } :
       doneEnumerator; 
    };
    
    return OfEnumerable;
  }(Enumerable));

  var enumerableOf = Enumerable.of = function (source, selector, thisArg) {
    return new OfEnumerable(source, selector, thisArg);
  };

  var ToArrayObservable = (function(__super__) {
    inherits(ToArrayObservable, __super__);
    function ToArrayObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    ToArrayObservable.prototype.subscribeCore = function(o) {
      return this.source.subscribe(new InnerObserver(o));
    };

    function InnerObserver(o) {
      this.o = o;
      this.a = [];
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = function (x) { if(!this.isStopped) { this.a.push(x); } };
    InnerObserver.prototype.onError = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
      }
    };
    InnerObserver.prototype.onCompleted = function () {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onNext(this.a);
        this.o.onCompleted();
      }
    };
    InnerObserver.prototype.dispose = function () { this.isStopped = true; }
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }
 
      return false;
    };

    return ToArrayObservable;
  }(ObservableBase));

  /**
  * Creates an array from an observable sequence.
  * @returns {Observable} An observable sequence containing a single element with a list containing all the elements of the source sequence.
  */
  observableProto.toArray = function () {
    return new ToArrayObservable(this);
  };

  /**
   *  Creates an observable sequence from a specified subscribe method implementation.
   * @example
   *  var res = Rx.Observable.create(function (observer) { return function () { } );
   *  var res = Rx.Observable.create(function (observer) { return Rx.Disposable.empty; } );
   *  var res = Rx.Observable.create(function (observer) { } );
   * @param {Function} subscribe Implementation of the resulting observable sequence's subscribe method, returning a function that will be wrapped in a Disposable.
   * @returns {Observable} The observable sequence with the specified implementation for the Subscribe method.
   */
  Observable.create = function (subscribe, parent) {
    return new AnonymousObservable(subscribe, parent);
  };

  /**
   *  Returns an observable sequence that invokes the specified factory function whenever a new observer subscribes.
   *
   * @example
   *  var res = Rx.Observable.defer(function () { return Rx.Observable.fromArray([1,2,3]); });
   * @param {Function} observableFactory Observable factory function to invoke for each observer that subscribes to the resulting sequence or Promise.
   * @returns {Observable} An observable sequence whose observers trigger an invocation of the given observable factory function.
   */
  var observableDefer = Observable.defer = function (observableFactory) {
    return new AnonymousObservable(function (observer) {
      var result;
      try {
        result = observableFactory();
      } catch (e) {
        return observableThrow(e).subscribe(observer);
      }
      isPromise(result) && (result = observableFromPromise(result));
      return result.subscribe(observer);
    });
  };

  var EmptyObservable = (function(__super__) {
    inherits(EmptyObservable, __super__);
    function EmptyObservable(scheduler) {
      this.scheduler = scheduler;
      __super__.call(this);
    }

    EmptyObservable.prototype.subscribeCore = function (observer) {
      var sink = new EmptySink(observer, this.scheduler);
      return sink.run();
    };

    function EmptySink(observer, scheduler) {
      this.observer = observer;
      this.scheduler = scheduler;
    }

    function scheduleItem(s, state) {
      state.onCompleted();
      return disposableEmpty;
    }

    EmptySink.prototype.run = function () {
      return this.scheduler.scheduleWithState(this.observer, scheduleItem);
    };

    return EmptyObservable;
  }(ObservableBase));

  var EMPTY_OBSERVABLE = new EmptyObservable(immediateScheduler);

  /**
   *  Returns an empty observable sequence, using the specified scheduler to send out the single OnCompleted message.
   *
   * @example
   *  var res = Rx.Observable.empty();
   *  var res = Rx.Observable.empty(Rx.Scheduler.timeout);
   * @param {Scheduler} [scheduler] Scheduler to send the termination call on.
   * @returns {Observable} An observable sequence with no elements.
   */
  var observableEmpty = Observable.empty = function (scheduler) {
    isScheduler(scheduler) || (scheduler = immediateScheduler);
    return scheduler === immediateScheduler ? EMPTY_OBSERVABLE : new EmptyObservable(scheduler);
  };

  var FromObservable = (function(__super__) {
    inherits(FromObservable, __super__);
    function FromObservable(iterable, mapper, scheduler) {
      this.iterable = iterable;
      this.mapper = mapper;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    FromObservable.prototype.subscribeCore = function (o) {
      var sink = new FromSink(o, this);
      return sink.run();
    };

    return FromObservable;
  }(ObservableBase));

  var FromSink = (function () {
    function FromSink(o, parent) {
      this.o = o;
      this.parent = parent;
    }

    FromSink.prototype.run = function () {
      var list = Object(this.parent.iterable),
          it = getIterable(list),
          o = this.o,
          mapper = this.parent.mapper;

      function loopRecursive(i, recurse) {
        var next = tryCatch(it.next).call(it);
        if (next === errorObj) { return o.onError(next.e); }
        if (next.done) { return o.onCompleted(); }

        var result = next.value;

        if (isFunction(mapper)) {
          result = tryCatch(mapper)(result, i);
          if (result === errorObj) { return o.onError(result.e); }
        }

        o.onNext(result);
        recurse(i + 1);
      }

      return this.parent.scheduler.scheduleRecursiveWithState(0, loopRecursive);
    };

    return FromSink;
  }());

  var maxSafeInteger = Math.pow(2, 53) - 1;

  function StringIterable(s) {
    this._s = s;
  }

  StringIterable.prototype[$iterator$] = function () {
    return new StringIterator(this._s);
  };

  function StringIterator(s) {
    this._s = s;
    this._l = s.length;
    this._i = 0;
  }

  StringIterator.prototype[$iterator$] = function () {
    return this;
  };

  StringIterator.prototype.next = function () {
    return this._i < this._l ? { done: false, value: this._s.charAt(this._i++) } : doneEnumerator;
  };

  function ArrayIterable(a) {
    this._a = a;
  }

  ArrayIterable.prototype[$iterator$] = function () {
    return new ArrayIterator(this._a);
  };

  function ArrayIterator(a) {
    this._a = a;
    this._l = toLength(a);
    this._i = 0;
  }

  ArrayIterator.prototype[$iterator$] = function () {
    return this;
  };

  ArrayIterator.prototype.next = function () {
    return this._i < this._l ? { done: false, value: this._a[this._i++] } : doneEnumerator;
  };

  function numberIsFinite(value) {
    return typeof value === 'number' && root.isFinite(value);
  }

  function isNan(n) {
    return n !== n;
  }

  function getIterable(o) {
    var i = o[$iterator$], it;
    if (!i && typeof o === 'string') {
      it = new StringIterable(o);
      return it[$iterator$]();
    }
    if (!i && o.length !== undefined) {
      it = new ArrayIterable(o);
      return it[$iterator$]();
    }
    if (!i) { throw new TypeError('Object is not iterable'); }
    return o[$iterator$]();
  }

  function sign(value) {
    var number = +value;
    if (number === 0) { return number; }
    if (isNaN(number)) { return number; }
    return number < 0 ? -1 : 1;
  }

  function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) { return 0; }
    if (len === 0 || !numberIsFinite(len)) { return len; }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) { return 0; }
    if (len > maxSafeInteger) { return maxSafeInteger; }
    return len;
  }

  /**
  * This method creates a new Observable sequence from an array-like or iterable object.
  * @param {Any} arrayLike An array-like or iterable object to convert to an Observable sequence.
  * @param {Function} [mapFn] Map function to call on every element of the array.
  * @param {Any} [thisArg] The context to use calling the mapFn if provided.
  * @param {Scheduler} [scheduler] Optional scheduler to use for scheduling.  If not provided, defaults to Scheduler.currentThread.
  */
  var observableFrom = Observable.from = function (iterable, mapFn, thisArg, scheduler) {
    if (iterable == null) {
      throw new Error('iterable cannot be null.')
    }
    if (mapFn && !isFunction(mapFn)) {
      throw new Error('mapFn when provided must be a function');
    }
    if (mapFn) {
      var mapper = bindCallback(mapFn, thisArg, 2);
    }
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new FromObservable(iterable, mapper, scheduler);
  }

  var FromArrayObservable = (function(__super__) {
    inherits(FromArrayObservable, __super__);
    function FromArrayObservable(args, scheduler) {
      this.args = args;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    FromArrayObservable.prototype.subscribeCore = function (observer) {
      var sink = new FromArraySink(observer, this);
      return sink.run();
    };

    return FromArrayObservable;
  }(ObservableBase));

  function FromArraySink(observer, parent) {
    this.observer = observer;
    this.parent = parent;
  }

  FromArraySink.prototype.run = function () {
    var observer = this.observer, args = this.parent.args, len = args.length;
    function loopRecursive(i, recurse) {
      if (i < len) {
        observer.onNext(args[i]);
        recurse(i + 1);
      } else {
        observer.onCompleted();
      }
    }

    return this.parent.scheduler.scheduleRecursiveWithState(0, loopRecursive);
  };

  /**
  *  Converts an array to an observable sequence, using an optional scheduler to enumerate the array.
  * @deprecated use Observable.from or Observable.of
  * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
  * @returns {Observable} The observable sequence whose elements are pulled from the given enumerable sequence.
  */
  var observableFromArray = Observable.fromArray = function (array, scheduler) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new FromArrayObservable(array, scheduler)
  };

  var NeverObservable = (function(__super__) {
    inherits(NeverObservable, __super__);
    function NeverObservable() {
      __super__.call(this);
    }

    NeverObservable.prototype.subscribeCore = function (observer) {
      return disposableEmpty;
    };

    return NeverObservable;
  }(ObservableBase));

  var NEVER_OBSERVABLE = new NeverObservable();

  /**
   * Returns a non-terminating observable sequence, which can be used to denote an infinite duration (e.g. when using reactive joins).
   * @returns {Observable} An observable sequence whose observers will never get called.
   */
  var observableNever = Observable.never = function () {
    return NEVER_OBSERVABLE;
  };

  function observableOf (scheduler, array) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new FromArrayObservable(array, scheduler);
  }

  /**
  *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments.
  * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
  */
  Observable.of = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return new FromArrayObservable(args, currentThreadScheduler);
  };

  /**
  *  This method creates a new Observable instance with a variable number of arguments, regardless of number or type of the arguments.
  * @param {Scheduler} scheduler A scheduler to use for scheduling the arguments.
  * @returns {Observable} The observable sequence whose elements are pulled from the given arguments.
  */
  Observable.ofWithScheduler = function (scheduler) {
    var len = arguments.length, args = new Array(len - 1);
    for(var i = 1; i < len; i++) { args[i - 1] = arguments[i]; }
    return new FromArrayObservable(args, scheduler);
  };

  var PairsObservable = (function(__super__) {
    inherits(PairsObservable, __super__);
    function PairsObservable(obj, scheduler) {
      this.obj = obj;
      this.keys = Object.keys(obj);
      this.scheduler = scheduler;
      __super__.call(this);
    }

    PairsObservable.prototype.subscribeCore = function (observer) {
      var sink = new PairsSink(observer, this);
      return sink.run();
    };

    return PairsObservable;
  }(ObservableBase));

  function PairsSink(observer, parent) {
    this.observer = observer;
    this.parent = parent;
  }

  PairsSink.prototype.run = function () {
    var observer = this.observer, obj = this.parent.obj, keys = this.parent.keys, len = keys.length;
    function loopRecursive(i, recurse) {
      if (i < len) {
        var key = keys[i];
        observer.onNext([key, obj[key]]);
        recurse(i + 1);
      } else {
        observer.onCompleted();
      }
    }

    return this.parent.scheduler.scheduleRecursiveWithState(0, loopRecursive);
  };

  /**
   * Convert an object into an observable sequence of [key, value] pairs.
   * @param {Object} obj The object to inspect.
   * @param {Scheduler} [scheduler] Scheduler to run the enumeration of the input sequence on.
   * @returns {Observable} An observable sequence of [key, value] pairs from the object.
   */
  Observable.pairs = function (obj, scheduler) {
    scheduler || (scheduler = currentThreadScheduler);
    return new PairsObservable(obj, scheduler);
  };

    var RangeObservable = (function(__super__) {
    inherits(RangeObservable, __super__);
    function RangeObservable(start, count, scheduler) {
      this.start = start;
      this.rangeCount = count;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    RangeObservable.prototype.subscribeCore = function (observer) {
      var sink = new RangeSink(observer, this);
      return sink.run();
    };

    return RangeObservable;
  }(ObservableBase));

  var RangeSink = (function () {
    function RangeSink(observer, parent) {
      this.observer = observer;
      this.parent = parent;
    }

    RangeSink.prototype.run = function () {
      var start = this.parent.start, count = this.parent.rangeCount, observer = this.observer;
      function loopRecursive(i, recurse) {
        if (i < count) {
          observer.onNext(start + i);
          recurse(i + 1);
        } else {
          observer.onCompleted();
        }
      }

      return this.parent.scheduler.scheduleRecursiveWithState(0, loopRecursive);
    };

    return RangeSink;
  }());

  /**
  *  Generates an observable sequence of integral numbers within a specified range, using the specified scheduler to send out observer messages.
  * @param {Number} start The value of the first integer in the sequence.
  * @param {Number} count The number of sequential integers to generate.
  * @param {Scheduler} [scheduler] Scheduler to run the generator loop on. If not specified, defaults to Scheduler.currentThread.
  * @returns {Observable} An observable sequence that contains a range of sequential integral numbers.
  */
  Observable.range = function (start, count, scheduler) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new RangeObservable(start, count, scheduler);
  };

  var RepeatObservable = (function(__super__) {
    inherits(RepeatObservable, __super__);
    function RepeatObservable(value, repeatCount, scheduler) {
      this.value = value;
      this.repeatCount = repeatCount == null ? -1 : repeatCount;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    RepeatObservable.prototype.subscribeCore = function (observer) {
      var sink = new RepeatSink(observer, this);
      return sink.run();
    };

    return RepeatObservable;
  }(ObservableBase));

  function RepeatSink(observer, parent) {
    this.observer = observer;
    this.parent = parent;
  }

  RepeatSink.prototype.run = function () {
    var observer = this.observer, value = this.parent.value;
    function loopRecursive(i, recurse) {
      if (i === -1 || i > 0) {
        observer.onNext(value);
        i > 0 && i--;
      }
      if (i === 0) { return observer.onCompleted(); }
      recurse(i);
    }

    return this.parent.scheduler.scheduleRecursiveWithState(this.parent.repeatCount, loopRecursive);
  };

  /**
   *  Generates an observable sequence that repeats the given element the specified number of times, using the specified scheduler to send out observer messages.
   * @param {Mixed} value Element to repeat.
   * @param {Number} repeatCount [Optiona] Number of times to repeat the element. If not specified, repeats indefinitely.
   * @param {Scheduler} scheduler Scheduler to run the producer loop on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} An observable sequence that repeats the given element the specified number of times.
   */
  Observable.repeat = function (value, repeatCount, scheduler) {
    isScheduler(scheduler) || (scheduler = currentThreadScheduler);
    return new RepeatObservable(value, repeatCount, scheduler);
  };

  var JustObservable = (function(__super__) {
    inherits(JustObservable, __super__);
    function JustObservable(value, scheduler) {
      this.value = value;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    JustObservable.prototype.subscribeCore = function (observer) {
      var sink = new JustSink(observer, this.value, this.scheduler);
      return sink.run();
    };

    function JustSink(observer, value, scheduler) {
      this.observer = observer;
      this.value = value;
      this.scheduler = scheduler;
    }

    function scheduleItem(s, state) {
      var value = state[0], observer = state[1];
      observer.onNext(value);
      observer.onCompleted();
      return disposableEmpty;
    }

    JustSink.prototype.run = function () {
      var state = [this.value, this.observer];
      return this.scheduler === immediateScheduler ?
        scheduleItem(null, state) :
        this.scheduler.scheduleWithState(state, scheduleItem);
    };

    return JustObservable;
  }(ObservableBase));

  /**
   *  Returns an observable sequence that contains a single element, using the specified scheduler to send out observer messages.
   *  There is an alias called 'just' or browsers <IE9.
   * @param {Mixed} value Single element in the resulting observable sequence.
   * @param {Scheduler} scheduler Scheduler to send the single element on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} An observable sequence containing the single specified element.
   */
  var observableReturn = Observable['return'] = Observable.just = function (value, scheduler) {
    isScheduler(scheduler) || (scheduler = immediateScheduler);
    return new JustObservable(value, scheduler);
  };

  var ThrowObservable = (function(__super__) {
    inherits(ThrowObservable, __super__);
    function ThrowObservable(error, scheduler) {
      this.error = error;
      this.scheduler = scheduler;
      __super__.call(this);
    }

    ThrowObservable.prototype.subscribeCore = function (o) {
      var sink = new ThrowSink(o, this);
      return sink.run();
    };

    function ThrowSink(o, p) {
      this.o = o;
      this.p = p;
    }

    function scheduleItem(s, state) {
      var e = state[0], o = state[1];
      o.onError(e);
    }

    ThrowSink.prototype.run = function () {
      return this.p.scheduler.scheduleWithState([this.p.error, this.o], scheduleItem);
    };

    return ThrowObservable;
  }(ObservableBase));

  /**
   *  Returns an observable sequence that terminates with an exception, using the specified scheduler to send out the single onError message.
   *  There is an alias to this method called 'throwError' for browsers <IE9.
   * @param {Mixed} error An object used for the sequence's termination.
   * @param {Scheduler} scheduler Scheduler to send the exceptional termination call on. If not specified, defaults to Scheduler.immediate.
   * @returns {Observable} The observable sequence that terminates exceptionally with the specified exception object.
   */
  var observableThrow = Observable['throw'] = function (error, scheduler) {
    isScheduler(scheduler) || (scheduler = immediateScheduler);
    return new ThrowObservable(error, scheduler);
  };

  var CatchObserver = (function(__super__) {
    inherits(CatchObserver, __super__);
    function CatchObserver(o, s, fn) {
      this._o = o;
      this._s = s;
      this._fn = fn;
      __super__.call(this);
    }

    CatchObserver.prototype.next = function (x) { this._o.onNext(x); };
    CatchObserver.prototype.completed = function () { return this._o.onCompleted(); };
    CatchObserver.prototype.error = function (e) {
      var result = tryCatch(this._fn)(e);
      if (result === errorObj) { return this._o.onError(result.e); }
      isPromise(result) && (result = observableFromPromise(result));

      var d = new SingleAssignmentDisposable();
      this._s.setDisposable(d);
      d.setDisposable(result.subscribe(this._o));
    };

    return CatchObserver;
  }(AbstractObserver));

  function observableCatchHandler(source, handler) {
    return new AnonymousObservable(function (o) {
      var d1 = new SingleAssignmentDisposable(), subscription = new SerialDisposable();
      subscription.setDisposable(d1);
      d1.setDisposable(source.subscribe(new CatchObserver(o, subscription, handler)));
      return subscription;
    }, source);
  }

  /**
   * Continues an observable sequence that is terminated by an exception with the next observable sequence.
   * @param {Mixed} handlerOrSecond Exception handler function that returns an observable sequence given the error that occurred in the first sequence, or a second observable sequence used to produce results when an error occurred in the first sequence.
   * @returns {Observable} An observable sequence containing the first sequence's elements, followed by the elements of the handler sequence in case an exception occurred.
   */
  observableProto['catch'] = function (handlerOrSecond) {
    return isFunction(handlerOrSecond) ? observableCatchHandler(this, handlerOrSecond) : observableCatch([this, handlerOrSecond]);
  };

  /**
   * Continues an observable sequence that is terminated by an exception with the next observable sequence.
   * @param {Array | Arguments} args Arguments or an array to use as the next sequence if an error occurs.
   * @returns {Observable} An observable sequence containing elements from consecutive source sequences until a source sequence terminates successfully.
   */
  var observableCatch = Observable['catch'] = function () {
    var items;
    if (Array.isArray(arguments[0])) {
      items = arguments[0];
    } else {
      var len = arguments.length;
      items = new Array(len);
      for(var i = 0; i < len; i++) { items[i] = arguments[i]; }
    }
    return enumerableOf(items).catchError();
  };

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
   * This can be in the form of an argument list of observables or an array.
   *
   * @example
   * 1 - obs = observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
   * 2 - obs = observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  observableProto.combineLatest = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    if (Array.isArray(args[0])) {
      args[0].unshift(this);
    } else {
      args.unshift(this);
    }
    return combineLatest.apply(this, args);
  };

  function falseFactory() { return false; }
  function argumentsToArray() {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return args;
  }

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever any of the observable sequences or Promises produces an element.
   *
   * @example
   * 1 - obs = Rx.Observable.combineLatest(obs1, obs2, obs3, function (o1, o2, o3) { return o1 + o2 + o3; });
   * 2 - obs = Rx.Observable.combineLatest([obs1, obs2, obs3], function (o1, o2, o3) { return o1 + o2 + o3; });
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  var combineLatest = Observable.combineLatest = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
    Array.isArray(args[0]) && (args = args[0]);

    return new AnonymousObservable(function (o) {
      var n = args.length,
        hasValue = arrayInitialize(n, falseFactory),
        hasValueAll = false,
        isDone = arrayInitialize(n, falseFactory),
        values = new Array(n);

      function next(i) {
        hasValue[i] = true;
        if (hasValueAll || (hasValueAll = hasValue.every(identity))) {
          try {
            var res = resultSelector.apply(null, values);
          } catch (e) {
            return o.onError(e);
          }
          o.onNext(res);
        } else if (isDone.filter(function (x, j) { return j !== i; }).every(identity)) {
          o.onCompleted();
        }
      }

      function done (i) {
        isDone[i] = true;
        isDone.every(identity) && o.onCompleted();
      }

      var subscriptions = new Array(n);
      for (var idx = 0; idx < n; idx++) {
        (function (i) {
          var source = args[i], sad = new SingleAssignmentDisposable();
          isPromise(source) && (source = observableFromPromise(source));
          sad.setDisposable(source.subscribe(function (x) {
              values[i] = x;
              next(i);
            },
            function(e) { o.onError(e); },
            function () { done(i); }
          ));
          subscriptions[i] = sad;
        }(idx));
      }

      return new CompositeDisposable(subscriptions);
    }, this);
  };

  /**
   * Concatenates all the observable sequences.  This takes in either an array or variable arguments to concatenate.
   * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order.
   */
  observableProto.concat = function () {
    for(var args = [], i = 0, len = arguments.length; i < len; i++) { args.push(arguments[i]); }
    args.unshift(this);
    return observableConcat.apply(null, args);
  };

  var ConcatObservable = (function(__super__) {
    inherits(ConcatObservable, __super__);
    function ConcatObservable(sources) {
      this.sources = sources;
      __super__.call(this);
    }

    ConcatObservable.prototype.subscribeCore = function(o) {
      var sink = new ConcatSink(this.sources, o);
      return sink.run();
    };

    function ConcatSink(sources, o) {
      this.sources = sources;
      this.o = o;
    }
    ConcatSink.prototype.run = function () {
      var isDisposed, subscription = new SerialDisposable(), sources = this.sources, length = sources.length, o = this.o;
      var cancelable = immediateScheduler.scheduleRecursiveWithState(0, function (i, self) {
        if (isDisposed) { return; }
        if (i === length) {
          return o.onCompleted();
        }

        // Check if promise
        var currentValue = sources[i];
        isPromise(currentValue) && (currentValue = observableFromPromise(currentValue));

        var d = new SingleAssignmentDisposable();
        subscription.setDisposable(d);
        d.setDisposable(currentValue.subscribe(
          function (x) { o.onNext(x); },
          function (e) { o.onError(e); },
          function () { self(i + 1); }
        ));
      });

      return new CompositeDisposable(subscription, cancelable, disposableCreate(function () {
        isDisposed = true;
      }));
    };


    return ConcatObservable;
  }(ObservableBase));

  /**
   * Concatenates all the observable sequences.
   * @param {Array | Arguments} args Arguments or an array to concat to the observable sequence.
   * @returns {Observable} An observable sequence that contains the elements of each given sequence, in sequential order.
   */
  var observableConcat = Observable.concat = function () {
    var args;
    if (Array.isArray(arguments[0])) {
      args = arguments[0];
    } else {
      args = new Array(arguments.length);
      for(var i = 0, len = arguments.length; i < len; i++) { args[i] = arguments[i]; }
    }
    return new ConcatObservable(args);
  };

  /**
   * Concatenates an observable sequence of observable sequences.
   * @returns {Observable} An observable sequence that contains the elements of each observed inner sequence, in sequential order.
   */
  observableProto.concatAll = function () {
    return this.merge(1);
  };

  var MergeObservable = (function (__super__) {
    inherits(MergeObservable, __super__);

    function MergeObservable(source, maxConcurrent) {
      this.source = source;
      this.maxConcurrent = maxConcurrent;
      __super__.call(this);
    }

    MergeObservable.prototype.subscribeCore = function(observer) {
      var g = new CompositeDisposable();
      g.add(this.source.subscribe(new MergeObserver(observer, this.maxConcurrent, g)));
      return g;
    };

    return MergeObservable;

  }(ObservableBase));

  var MergeObserver = (function () {
    function MergeObserver(o, max, g) {
      this.o = o;
      this.max = max;
      this.g = g;
      this.done = false;
      this.q = [];
      this.activeCount = 0;
      this.isStopped = false;
    }
    MergeObserver.prototype.handleSubscribe = function (xs) {
      var sad = new SingleAssignmentDisposable();
      this.g.add(sad);
      isPromise(xs) && (xs = observableFromPromise(xs));
      sad.setDisposable(xs.subscribe(new InnerObserver(this, sad)));
    };
    MergeObserver.prototype.onNext = function (innerSource) {
      if (this.isStopped) { return; }
        if(this.activeCount < this.max) {
          this.activeCount++;
          this.handleSubscribe(innerSource);
        } else {
          this.q.push(innerSource);
        }
      };
      MergeObserver.prototype.onError = function (e) {
        if (!this.isStopped) {
          this.isStopped = true;
          this.o.onError(e);
        }
      };
      MergeObserver.prototype.onCompleted = function () {
        if (!this.isStopped) {
          this.isStopped = true;
          this.done = true;
          this.activeCount === 0 && this.o.onCompleted();
        }
      };
      MergeObserver.prototype.dispose = function() { this.isStopped = true; };
      MergeObserver.prototype.fail = function (e) {
        if (!this.isStopped) {
          this.isStopped = true;
          this.o.onError(e);
          return true;
        }

        return false;
      };

      function InnerObserver(parent, sad) {
        this.parent = parent;
        this.sad = sad;
        this.isStopped = false;
      }
      InnerObserver.prototype.onNext = function (x) { if(!this.isStopped) { this.parent.o.onNext(x); } };
      InnerObserver.prototype.onError = function (e) {
        if (!this.isStopped) {
          this.isStopped = true;
          this.parent.o.onError(e);
        }
      };
      InnerObserver.prototype.onCompleted = function () {
        if(!this.isStopped) {
          this.isStopped = true;
          var parent = this.parent;
          parent.g.remove(this.sad);
          if (parent.q.length > 0) {
            parent.handleSubscribe(parent.q.shift());
          } else {
            parent.activeCount--;
            parent.done && parent.activeCount === 0 && parent.o.onCompleted();
          }
        }
      };
      InnerObserver.prototype.dispose = function() { this.isStopped = true; };
      InnerObserver.prototype.fail = function (e) {
        if (!this.isStopped) {
          this.isStopped = true;
          this.parent.o.onError(e);
          return true;
        }

        return false;
      };

      return MergeObserver;
  }());





  /**
  * Merges an observable sequence of observable sequences into an observable sequence, limiting the number of concurrent subscriptions to inner sequences.
  * Or merges two observable sequences into a single observable sequence.
  *
  * @example
  * 1 - merged = sources.merge(1);
  * 2 - merged = source.merge(otherSource);
  * @param {Mixed} [maxConcurrentOrOther] Maximum number of inner observable sequences being subscribed to concurrently or the second observable sequence.
  * @returns {Observable} The observable sequence that merges the elements of the inner sequences.
  */
  observableProto.merge = function (maxConcurrentOrOther) {
    return typeof maxConcurrentOrOther !== 'number' ?
      observableMerge(this, maxConcurrentOrOther) :
      new MergeObservable(this, maxConcurrentOrOther);
  };

  /**
   * Merges all the observable sequences into a single observable sequence.
   * The scheduler is optional and if not specified, the immediate scheduler is used.
   * @returns {Observable} The observable sequence that merges the elements of the observable sequences.
   */
  var observableMerge = Observable.merge = function () {
    var scheduler, sources = [], i, len = arguments.length;
    if (!arguments[0]) {
      scheduler = immediateScheduler;
      for(i = 1; i < len; i++) { sources.push(arguments[i]); }
    } else if (isScheduler(arguments[0])) {
      scheduler = arguments[0];
      for(i = 1; i < len; i++) { sources.push(arguments[i]); }
    } else {
      scheduler = immediateScheduler;
      for(i = 0; i < len; i++) { sources.push(arguments[i]); }
    }
    if (Array.isArray(sources[0])) {
      sources = sources[0];
    }
    return observableOf(scheduler, sources).mergeAll();
  };

  var CompositeError = Rx.CompositeError = function(errors) {
    this.name = "NotImplementedError";
    this.innerErrors = errors;
    this.message = 'This contains multiple errors. Check the innerErrors';
    Error.call(this);
  }
  CompositeError.prototype = Error.prototype;

  /**
  * Flattens an Observable that emits Observables into one Observable, in a way that allows an Observer to
  * receive all successfully emitted items from all of the source Observables without being interrupted by
  * an error notification from one of them.
  *
  * This behaves like Observable.prototype.mergeAll except that if any of the merged Observables notify of an
  * error via the Observer's onError, mergeDelayError will refrain from propagating that
  * error notification until all of the merged Observables have finished emitting items.
  * @param {Array | Arguments} args Arguments or an array to merge.
  * @returns {Observable} an Observable that emits all of the items emitted by the Observables emitted by the Observable
  */
  Observable.mergeDelayError = function() {
    var args;
    if (Array.isArray(arguments[0])) {
      args = arguments[0];
    } else {
      var len = arguments.length;
      args = new Array(len);
      for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    }
    var source = observableOf(null, args);

    return new AnonymousObservable(function (o) {
      var group = new CompositeDisposable(),
        m = new SingleAssignmentDisposable(),
        isStopped = false,
        errors = [];

      function setCompletion() {
        if (errors.length === 0) {
          o.onCompleted();
        } else if (errors.length === 1) {
          o.onError(errors[0]);
        } else {
          o.onError(new CompositeError(errors));
        }
      }

      group.add(m);

      m.setDisposable(source.subscribe(
        function (innerSource) {
          var innerSubscription = new SingleAssignmentDisposable();
          group.add(innerSubscription);

          // Check for promises support
          isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));

          innerSubscription.setDisposable(innerSource.subscribe(
            function (x) { o.onNext(x); },
            function (e) {
              errors.push(e);
              group.remove(innerSubscription);
              isStopped && group.length === 1 && setCompletion();
            },
            function () {
              group.remove(innerSubscription);
              isStopped && group.length === 1 && setCompletion();
          }));
        },
        function (e) {
          errors.push(e);
          isStopped = true;
          group.length === 1 && setCompletion();
        },
        function () {
          isStopped = true;
          group.length === 1 && setCompletion();
        }));
      return group;
    });
  };

  var MergeAllObservable = (function (__super__) {
    inherits(MergeAllObservable, __super__);

    function MergeAllObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    MergeAllObservable.prototype.subscribeCore = function (observer) {
      var g = new CompositeDisposable(), m = new SingleAssignmentDisposable();
      g.add(m);
      m.setDisposable(this.source.subscribe(new MergeAllObserver(observer, g)));
      return g;
    };

    function MergeAllObserver(o, g) {
      this.o = o;
      this.g = g;
      this.isStopped = false;
      this.done = false;
    }
    MergeAllObserver.prototype.onNext = function(innerSource) {
      if(this.isStopped) { return; }
      var sad = new SingleAssignmentDisposable();
      this.g.add(sad);

      isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));

      sad.setDisposable(innerSource.subscribe(new InnerObserver(this, sad)));
    };
    MergeAllObserver.prototype.onError = function (e) {
      if(!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
      }
    };
    MergeAllObserver.prototype.onCompleted = function () {
      if(!this.isStopped) {
        this.isStopped = true;
        this.done = true;
        this.g.length === 1 && this.o.onCompleted();
      }
    };
    MergeAllObserver.prototype.dispose = function() { this.isStopped = true; };
    MergeAllObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }

      return false;
    };

    function InnerObserver(parent, sad) {
      this.parent = parent;
      this.sad = sad;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = function (x) { if (!this.isStopped) { this.parent.o.onNext(x); } };
    InnerObserver.prototype.onError = function (e) {
      if(!this.isStopped) {
        this.isStopped = true;
        this.parent.o.onError(e);
      }
    };
    InnerObserver.prototype.onCompleted = function () {
      if(!this.isStopped) {
        var parent = this.parent;
        this.isStopped = true;
        parent.g.remove(this.sad);
        parent.done && parent.g.length === 1 && parent.o.onCompleted();
      }
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.parent.o.onError(e);
        return true;
      }

      return false;
    };

    return MergeAllObservable;
  }(ObservableBase));

  /**
  * Merges an observable sequence of observable sequences into an observable sequence.
  * @returns {Observable} The observable sequence that merges the elements of the inner sequences.
  */
  observableProto.mergeAll = function () {
    return new MergeAllObservable(this);
  };

  /**
   * Returns the values from the source observable sequence only after the other observable sequence produces a value.
   * @param {Observable | Promise} other The observable sequence or Promise that triggers propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence starting from the point the other sequence triggered propagation.
   */
  observableProto.skipUntil = function (other) {
    var source = this;
    return new AnonymousObservable(function (o) {
      var isOpen = false;
      var disposables = new CompositeDisposable(source.subscribe(function (left) {
        isOpen && o.onNext(left);
      }, function (e) { o.onError(e); }, function () {
        isOpen && o.onCompleted();
      }));

      isPromise(other) && (other = observableFromPromise(other));

      var rightSubscription = new SingleAssignmentDisposable();
      disposables.add(rightSubscription);
      rightSubscription.setDisposable(other.subscribe(function () {
        isOpen = true;
        rightSubscription.dispose();
      }, function (e) { o.onError(e); }, function () {
        rightSubscription.dispose();
      }));

      return disposables;
    }, source);
  };

  var SwitchObservable = (function(__super__) {
    inherits(SwitchObservable, __super__);
    function SwitchObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    SwitchObservable.prototype.subscribeCore = function (o) {
      var inner = new SerialDisposable(), s = this.source.subscribe(new SwitchObserver(o, inner));
      return new CompositeDisposable(s, inner);
    };

    function SwitchObserver(o, inner) {
      this.o = o;
      this.inner = inner;
      this.stopped = false;
      this.latest = 0;
      this.hasLatest = false;
      this.isStopped = false;
    }
    SwitchObserver.prototype.onNext = function (innerSource) {
      if (this.isStopped) { return; }
      var d = new SingleAssignmentDisposable(), id = ++this.latest;
      this.hasLatest = true;
      this.inner.setDisposable(d);
      isPromise(innerSource) && (innerSource = observableFromPromise(innerSource));
      d.setDisposable(innerSource.subscribe(new InnerObserver(this, id)));
    };
    SwitchObserver.prototype.onError = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
      }
    };
    SwitchObserver.prototype.onCompleted = function () {
      if (!this.isStopped) {
        this.isStopped = true;
        this.stopped = true;
        !this.hasLatest && this.o.onCompleted();
      }
    };
    SwitchObserver.prototype.dispose = function () { this.isStopped = true; };
    SwitchObserver.prototype.fail = function (e) {
      if(!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }
      return false;
    };

    function InnerObserver(parent, id) {
      this.parent = parent;
      this.id = id;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = function (x) {
      if (this.isStopped) { return; }
      this.parent.latest === this.id && this.parent.o.onNext(x);
    };
    InnerObserver.prototype.onError = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.parent.latest === this.id && this.parent.o.onError(e);
      }
    };
    InnerObserver.prototype.onCompleted = function () {
      if (!this.isStopped) {
        this.isStopped = true;
        if (this.parent.latest === this.id) {
          this.parent.hasLatest = false;
          this.parent.isStopped && this.parent.o.onCompleted();
        }
      }
    };
    InnerObserver.prototype.dispose = function () { this.isStopped = true; }
    InnerObserver.prototype.fail = function (e) {
      if(!this.isStopped) {
        this.isStopped = true;
        this.parent.o.onError(e);
        return true;
      }
      return false;
    };

    return SwitchObservable;
  }(ObservableBase));

  /**
  * Transforms an observable sequence of observable sequences into an observable sequence producing values only from the most recent observable sequence.
  * @returns {Observable} The observable sequence that at any point in time produces the elements of the most recent inner observable sequence that has been received.
  */
  observableProto['switch'] = observableProto.switchLatest = function () {
    return new SwitchObservable(this);
  };

  var TakeUntilObservable = (function(__super__) {
    inherits(TakeUntilObservable, __super__);

    function TakeUntilObservable(source, other) {
      this.source = source;
      this.other = isPromise(other) ? observableFromPromise(other) : other;
      __super__.call(this);
    }

    TakeUntilObservable.prototype.subscribeCore = function(o) {
      return new CompositeDisposable(
        this.source.subscribe(o),
        this.other.subscribe(new InnerObserver(o))
      );
    };

    function InnerObserver(o) {
      this.o = o;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = function (x) {
      if (this.isStopped) { return; }
      this.o.onCompleted();
    };
    InnerObserver.prototype.onError = function (err) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(err);
      }
    };
    InnerObserver.prototype.onCompleted = function () {
      !this.isStopped && (this.isStopped = true);
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }
      return false;
    };

    return TakeUntilObservable;
  }(ObservableBase));

  /**
   * Returns the values from the source observable sequence until the other observable sequence produces a value.
   * @param {Observable | Promise} other Observable sequence or Promise that terminates propagation of elements of the source sequence.
   * @returns {Observable} An observable sequence containing the elements of the source sequence up to the point the other sequence interrupted further propagation.
   */
  observableProto.takeUntil = function (other) {
    return new TakeUntilObservable(this, other);
  };

  function falseFactory() { return false; }

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function only when the (first) source observable sequence produces an element.
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  observableProto.withLatestFrom = function () {
    var len = arguments.length, args = new Array(len)
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    var resultSelector = args.pop(), source = this;
    Array.isArray(args[0]) && (args = args[0]);

    return new AnonymousObservable(function (observer) {
      var n = args.length,
        hasValue = arrayInitialize(n, falseFactory),
        hasValueAll = false,
        values = new Array(n);

      var subscriptions = new Array(n + 1);
      for (var idx = 0; idx < n; idx++) {
        (function (i) {
          var other = args[i], sad = new SingleAssignmentDisposable();
          isPromise(other) && (other = observableFromPromise(other));
          sad.setDisposable(other.subscribe(function (x) {
            values[i] = x;
            hasValue[i] = true;
            hasValueAll = hasValue.every(identity);
          }, function (e) { observer.onError(e); }, noop));
          subscriptions[i] = sad;
        }(idx));
      }

      var sad = new SingleAssignmentDisposable();
      sad.setDisposable(source.subscribe(function (x) {
        var allValues = [x].concat(values);
        if (!hasValueAll) { return; }
        var res = tryCatch(resultSelector).apply(null, allValues);
        if (res === errorObj) { return observer.onError(res.e); }
        observer.onNext(res);
      }, function (e) { observer.onError(e); }, function () {
        observer.onCompleted();
      }));
      subscriptions[n] = sad;

      return new CompositeDisposable(subscriptions);
    }, this);
  };

  function falseFactory() { return false; }
  function emptyArrayFactory() { return []; }
  function argumentsToArray() {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return args;
  }

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences or an array have produced an element at a corresponding index.
   * The last element in the arguments must be a function to invoke for each series of elements at corresponding indexes in the args.
   * @returns {Observable} An observable sequence containing the result of combining elements of the args using the specified result selector function.
   */
  observableProto.zip = function () {
    if (arguments.length === 0) { throw new Error('invalid arguments'); }

    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;
    Array.isArray(args[0]) && (args = args[0]);

    var parent = this;
    args.unshift(parent);
    return new AnonymousObservable(function (o) {
      var n = args.length,
        queues = arrayInitialize(n, emptyArrayFactory),
        isDone = arrayInitialize(n, falseFactory);

      var subscriptions = new Array(n);
      for (var idx = 0; idx < n; idx++) {
        (function (i) {
          var source = args[i], sad = new SingleAssignmentDisposable();

          isPromise(source) && (source = observableFromPromise(source));

          sad.setDisposable(source.subscribe(function (x) {
            queues[i].push(x);
            if (queues.every(function (x) { return x.length > 0; })) {
              var queuedValues = queues.map(function (x) { return x.shift(); }),
                  res = tryCatch(resultSelector).apply(parent, queuedValues);
              if (res === errorObj) { return o.onError(res.e); }
              o.onNext(res);
            } else if (isDone.filter(function (x, j) { return j !== i; }).every(identity)) {
              o.onCompleted();
            }
          }, function (e) { o.onError(e); }, function () {
            isDone[i] = true;
            isDone.every(identity) && o.onCompleted();
          }));
          subscriptions[i] = sad;
        })(idx);
      }

      return new CompositeDisposable(subscriptions);
    }, parent);
  };

  /**
   * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences have produced an element at a corresponding index.
   * @param arguments Observable sources.
   * @param {Function} resultSelector Function to invoke for each series of elements at corresponding indexes in the sources.
   * @returns {Observable} An observable sequence containing the result of combining elements of the sources using the specified result selector function.
   */
  Observable.zip = function () {
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    if (Array.isArray(args[0])) {
      args = isFunction(args[1]) ? args[0].concat(args[1]) : args[0];
    }
    var first = args.shift();
    return first.zip.apply(first, args);
  };

function falseFactory() { return false; }
function emptyArrayFactory() { return []; }
function argumentsToArray() {
  var len = arguments.length, args = new Array(len);
  for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
  return args;
}

/**
 * Merges the specified observable sequences into one observable sequence by using the selector function whenever all of the observable sequences or an array have produced an element at a corresponding index.
 * The last element in the arguments must be a function to invoke for each series of elements at corresponding indexes in the args.
 * @returns {Observable} An observable sequence containing the result of combining elements of the args using the specified result selector function.
 */
observableProto.zipIterable = function () {
  if (arguments.length === 0) { throw new Error('invalid arguments'); }

  var len = arguments.length, args = new Array(len);
  for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
  var resultSelector = isFunction(args[len - 1]) ? args.pop() : argumentsToArray;

  var parent = this;
  args.unshift(parent);
  return new AnonymousObservable(function (o) {
    var n = args.length,
      queues = arrayInitialize(n, emptyArrayFactory),
      isDone = arrayInitialize(n, falseFactory);

    var subscriptions = new Array(n);
    for (var idx = 0; idx < n; idx++) {
      (function (i) {
        var source = args[i], sad = new SingleAssignmentDisposable();

        (isArrayLike(source) || isIterable(source)) && (source = observableFrom(source));

        sad.setDisposable(source.subscribe(function (x) {
          queues[i].push(x);
          if (queues.every(function (x) { return x.length > 0; })) {
            var queuedValues = queues.map(function (x) { return x.shift(); }),
                res = tryCatch(resultSelector).apply(parent, queuedValues);
            if (res === errorObj) { return o.onError(res.e); }
            o.onNext(res);
          } else if (isDone.filter(function (x, j) { return j !== i; }).every(identity)) {
            o.onCompleted();
          }
        }, function (e) { o.onError(e); }, function () {
          isDone[i] = true;
          isDone.every(identity) && o.onCompleted();
        }));
        subscriptions[i] = sad;
      })(idx);
    }

    return new CompositeDisposable(subscriptions);
  }, parent);
};

  function asObservable(source) {
    return function subscribe(o) { return source.subscribe(o); };
  }

  /**
   *  Hides the identity of an observable sequence.
   * @returns {Observable} An observable sequence that hides the identity of the source sequence.
   */
  observableProto.asObservable = function () {
    return new AnonymousObservable(asObservable(this), this);
  };

  /**
   * Dematerializes the explicit notification values of an observable sequence as implicit notifications.
   * @returns {Observable} An observable sequence exhibiting the behavior corresponding to the source sequence's notification values.
   */
  observableProto.dematerialize = function () {
    var source = this;
    return new AnonymousObservable(function (o) {
      return source.subscribe(function (x) { return x.accept(o); }, function(e) { o.onError(e); }, function () { o.onCompleted(); });
    }, this);
  };

  var DistinctUntilChangedObservable = (function(__super__) {
    inherits(DistinctUntilChangedObservable, __super__);
    function DistinctUntilChangedObservable(source, keyFn, comparer) {
      this.source = source;
      this.keyFn = keyFn;
      this.comparer = comparer;
      __super__.call(this);
    }

    DistinctUntilChangedObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new DistinctUntilChangedObserver(o, this.keyFn, this.comparer));
    };

    return DistinctUntilChangedObservable;
  }(ObservableBase));

  var DistinctUntilChangedObserver = (function(__super__) {
    inherits(DistinctUntilChangedObserver, __super__);
    function DistinctUntilChangedObserver(o, keyFn, comparer) {
      this.o = o;
      this.keyFn = keyFn;
      this.comparer = comparer;
      this.hasCurrentKey = false;
      this.currentKey = null;
      __super__.call(this);
    }

    DistinctUntilChangedObserver.prototype.next = function (x) {
      var key = x, comparerEquals;
      if (isFunction(this.keyFn)) {
        key = tryCatch(this.keyFn)(x);
        if (key === errorObj) { return this.o.onError(key.e); }
      }
      if (this.hasCurrentKey) {
        comparerEquals = tryCatch(this.comparer)(this.currentKey, key);
        if (comparerEquals === errorObj) { return this.o.onError(comparerEquals.e); }
      }
      if (!this.hasCurrentKey || !comparerEquals) {
        this.hasCurrentKey = true;
        this.currentKey = key;
        this.o.onNext(x);
      }
    };
    DistinctUntilChangedObserver.prototype.error = function(e) {
      this.o.onError(e);
    };
    DistinctUntilChangedObserver.prototype.completed = function () {
      this.o.onCompleted();
    };

    return DistinctUntilChangedObserver;
  }(AbstractObserver));

  /**
  *  Returns an observable sequence that contains only distinct contiguous elements according to the keyFn and the comparer.
  * @param {Function} [keyFn] A function to compute the comparison key for each element. If not provided, it projects the value.
  * @param {Function} [comparer] Equality comparer for computed key values. If not provided, defaults to an equality comparer function.
  * @returns {Observable} An observable sequence only containing the distinct contiguous elements, based on a computed key value, from the source sequence.
  */
  observableProto.distinctUntilChanged = function (keyFn, comparer) {
    comparer || (comparer = defaultComparer);
    return new DistinctUntilChangedObservable(this, keyFn, comparer);
  };

  var TapObservable = (function(__super__) {
    inherits(TapObservable,__super__);
    function TapObservable(source, observerOrOnNext, onError, onCompleted) {
      this.source = source;
      this._oN = observerOrOnNext;
      this._oE = onError;
      this._oC = onCompleted;
      __super__.call(this);
    }

    TapObservable.prototype.subscribeCore = function(o) {
      return this.source.subscribe(new InnerObserver(o, this));
    };

    function InnerObserver(o, p) {
      this.o = o;
      this.t = !p._oN || isFunction(p._oN) ?
        observerCreate(p._oN || noop, p._oE || noop, p._oC || noop) :
        p._oN;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = function(x) {
      if (this.isStopped) { return; }
      var res = tryCatch(this.t.onNext).call(this.t, x);
      if (res === errorObj) { this.o.onError(res.e); }
      this.o.onNext(x);
    };
    InnerObserver.prototype.onError = function(err) {
      if (!this.isStopped) {
        this.isStopped = true;
        var res = tryCatch(this.t.onError).call(this.t, err);
        if (res === errorObj) { return this.o.onError(res.e); }
        this.o.onError(err);
      }
    };
    InnerObserver.prototype.onCompleted = function() {
      if (!this.isStopped) {
        this.isStopped = true;
        var res = tryCatch(this.t.onCompleted).call(this.t);
        if (res === errorObj) { return this.o.onError(res.e); }
        this.o.onCompleted();
      }
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }
      return false;
    };

    return TapObservable;
  }(ObservableBase));

  /**
  *  Invokes an action for each element in the observable sequence and invokes an action upon graceful or exceptional termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function | Observer} observerOrOnNext Action to invoke for each element in the observable sequence or an o.
  * @param {Function} [onError]  Action to invoke upon exceptional termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
  * @param {Function} [onCompleted]  Action to invoke upon graceful termination of the observable sequence. Used if only the observerOrOnNext parameter is also a function.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto['do'] = observableProto.tap = observableProto.doAction = function (observerOrOnNext, onError, onCompleted) {
    return new TapObservable(this, observerOrOnNext, onError, onCompleted);
  };

  /**
  *  Invokes an action for each element in the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onNext Action to invoke for each element in the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto.doOnNext = observableProto.tapOnNext = function (onNext, thisArg) {
    return this.tap(typeof thisArg !== 'undefined' ? function (x) { onNext.call(thisArg, x); } : onNext);
  };

  /**
  *  Invokes an action upon exceptional termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onError Action to invoke upon exceptional termination of the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto.doOnError = observableProto.tapOnError = function (onError, thisArg) {
    return this.tap(noop, typeof thisArg !== 'undefined' ? function (e) { onError.call(thisArg, e); } : onError);
  };

  /**
  *  Invokes an action upon graceful termination of the observable sequence.
  *  This method can be used for debugging, logging, etc. of query behavior by intercepting the message stream to run arbitrary actions for messages on the pipeline.
  * @param {Function} onCompleted Action to invoke upon graceful termination of the observable sequence.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} The source sequence with the side-effecting behavior applied.
  */
  observableProto.doOnCompleted = observableProto.tapOnCompleted = function (onCompleted, thisArg) {
    return this.tap(noop, null, typeof thisArg !== 'undefined' ? function () { onCompleted.call(thisArg); } : onCompleted);
  };

  /**
   *  Invokes a specified action after the source observable sequence terminates gracefully or exceptionally.
   * @param {Function} finallyAction Action to invoke after the source observable sequence terminates.
   * @returns {Observable} Source sequence with the action-invoking termination behavior applied.
   */
  observableProto['finally'] = function (action) {
    var source = this;
    return new AnonymousObservable(function (observer) {
      var subscription = tryCatch(source.subscribe).call(source, observer);
      if (subscription === errorObj) {
        action();
        return thrower(subscription.e);
      }
      return disposableCreate(function () {
        var r = tryCatch(subscription.dispose).call(subscription);
        action();
        r === errorObj && thrower(r.e);
      });
    }, this);
  };

  var IgnoreElementsObservable = (function(__super__) {
    inherits(IgnoreElementsObservable, __super__);

    function IgnoreElementsObservable(source) {
      this.source = source;
      __super__.call(this);
    }

    IgnoreElementsObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new InnerObserver(o));
    };

    function InnerObserver(o) {
      this.o = o;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = noop;
    InnerObserver.prototype.onError = function (err) {
      if(!this.isStopped) {
        this.isStopped = true;
        this.o.onError(err);
      }
    };
    InnerObserver.prototype.onCompleted = function () {
      if(!this.isStopped) {
        this.isStopped = true;
        this.o.onCompleted();
      }
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.observer.onError(e);
        return true;
      }

      return false;
    };

    return IgnoreElementsObservable;
  }(ObservableBase));

  /**
   *  Ignores all elements in an observable sequence leaving only the termination messages.
   * @returns {Observable} An empty observable sequence that signals termination, successful or exceptional, of the source sequence.
   */
  observableProto.ignoreElements = function () {
    return new IgnoreElementsObservable(this);
  };

  /**
   *  Materializes the implicit notifications of an observable sequence as explicit notification values.
   * @returns {Observable} An observable sequence containing the materialized notification values from the source sequence.
   */
  observableProto.materialize = function () {
    var source = this;
    return new AnonymousObservable(function (observer) {
      return source.subscribe(function (value) {
        observer.onNext(notificationCreateOnNext(value));
      }, function (e) {
        observer.onNext(notificationCreateOnError(e));
        observer.onCompleted();
      }, function () {
        observer.onNext(notificationCreateOnCompleted());
        observer.onCompleted();
      });
    }, source);
  };

  /**
   *  Repeats the observable sequence a specified number of times. If the repeat count is not specified, the sequence repeats indefinitely.
   * @param {Number} [repeatCount]  Number of times to repeat the sequence. If not provided, repeats the sequence indefinitely.
   * @returns {Observable} The observable sequence producing the elements of the given sequence repeatedly.
   */
  observableProto.repeat = function (repeatCount) {
    return enumerableRepeat(this, repeatCount).concat();
  };

  /**
   *  Repeats the source observable sequence the specified number of times or until it successfully terminates. If the retry count is not specified, it retries indefinitely.
   *  Note if you encounter an error and want it to retry once, then you must use .retry(2);
   *
   * @example
   *  var res = retried = retry.repeat();
   *  var res = retried = retry.repeat(2);
   * @param {Number} [retryCount]  Number of times to retry the sequence. If not provided, retry the sequence indefinitely.
   * @returns {Observable} An observable sequence producing the elements of the given sequence repeatedly until it terminates successfully.
   */
  observableProto.retry = function (retryCount) {
    return enumerableRepeat(this, retryCount).catchError();
  };

  /**
   *  Repeats the source observable sequence upon error each time the notifier emits or until it successfully terminates. 
   *  if the notifier completes, the observable sequence completes.
   *
   * @example
   *  var timer = Observable.timer(500);
   *  var source = observable.retryWhen(timer);
   * @param {Observable} [notifier] An observable that triggers the retries or completes the observable with onNext or onCompleted respectively.
   * @returns {Observable} An observable sequence producing the elements of the given sequence repeatedly until it terminates successfully.
   */
  observableProto.retryWhen = function (notifier) {
    return enumerableRepeat(this).catchErrorWhen(notifier);
  };
  var ScanObservable = (function(__super__) {
    inherits(ScanObservable, __super__);
    function ScanObservable(source, accumulator, hasSeed, seed) {
      this.source = source;
      this.accumulator = accumulator;
      this.hasSeed = hasSeed;
      this.seed = seed;
      __super__.call(this);
    }

    ScanObservable.prototype.subscribeCore = function(o) {
      return this.source.subscribe(new InnerObserver(o,this));
    };

    return ScanObservable;
  }(ObservableBase));

  function InnerObserver(o, parent) {
    this.o = o;
    this.accumulator = parent.accumulator;
    this.hasSeed = parent.hasSeed;
    this.seed = parent.seed;
    this.hasAccumulation = false;
    this.accumulation = null;
    this.hasValue = false;
    this.isStopped = false;
  }
  InnerObserver.prototype = {
    onNext: function (x) {
      if (this.isStopped) { return; }
      !this.hasValue && (this.hasValue = true);
      if (this.hasAccumulation) {
        this.accumulation = tryCatch(this.accumulator)(this.accumulation, x);
      } else {
        this.accumulation = this.hasSeed ? tryCatch(this.accumulator)(this.seed, x) : x;
        this.hasAccumulation = true;
      }
      if (this.accumulation === errorObj) { return this.o.onError(this.accumulation.e); }
      this.o.onNext(this.accumulation);
    },
    onError: function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
      }
    },
    onCompleted: function () {
      if (!this.isStopped) {
        this.isStopped = true;
        !this.hasValue && this.hasSeed && this.o.onNext(this.seed);
        this.o.onCompleted();
      }
    },
    dispose: function() { this.isStopped = true; },
    fail: function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }
      return false;
    }
  };

  /**
  *  Applies an accumulator function over an observable sequence and returns each intermediate result. The optional seed value is used as the initial accumulator value.
  *  For aggregation behavior with no intermediate results, see Observable.aggregate.
  * @param {Mixed} [seed] The initial accumulator value.
  * @param {Function} accumulator An accumulator function to be invoked on each element.
  * @returns {Observable} An observable sequence containing the accumulated values.
  */
  observableProto.scan = function () {
    var hasSeed = false, seed, accumulator = arguments[0];
    if (arguments.length === 2) {
      hasSeed = true;
      seed = arguments[1];
    }
    return new ScanObservable(this, accumulator, hasSeed, seed);
  };

  /**
   *  Bypasses a specified number of elements at the end of an observable sequence.
   * @description
   *  This operator accumulates a queue with a length enough to store the first `count` elements. As more elements are
   *  received, elements are taken from the front of the queue and produced on the result sequence. This causes elements to be delayed.
   * @param count Number of elements to bypass at the end of the source sequence.
   * @returns {Observable} An observable sequence containing the source sequence elements except for the bypassed ones at the end.
   */
  observableProto.skipLast = function (count) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    var source = this;
    return new AnonymousObservable(function (o) {
      var q = [];
      return source.subscribe(function (x) {
        q.push(x);
        q.length > count && o.onNext(q.shift());
      }, function (e) { o.onError(e); }, function () { o.onCompleted(); });
    }, source);
  };

  /**
   *  Prepends a sequence of values to an observable sequence with an optional scheduler and an argument list of values to prepend.
   *  @example
   *  var res = source.startWith(1, 2, 3);
   *  var res = source.startWith(Rx.Scheduler.timeout, 1, 2, 3);
   * @param {Arguments} args The specified values to prepend to the observable sequence
   * @returns {Observable} The source sequence prepended with the specified values.
   */
  observableProto.startWith = function () {
    var values, scheduler, start = 0;
    if (!!arguments.length && isScheduler(arguments[0])) {
      scheduler = arguments[0];
      start = 1;
    } else {
      scheduler = immediateScheduler;
    }
    for(var args = [], i = start, len = arguments.length; i < len; i++) { args.push(arguments[i]); }
    return enumerableOf([observableFromArray(args, scheduler), this]).concat();
  };

  /**
   *  Returns a specified number of contiguous elements from the end of an observable sequence.
   * @description
   *  This operator accumulates a buffer with a length enough to store elements count elements. Upon completion of
   *  the source sequence, this buffer is drained on the result sequence. This causes the elements to be delayed.
   * @param {Number} count Number of elements to take from the end of the source sequence.
   * @returns {Observable} An observable sequence containing the specified number of elements from the end of the source sequence.
   */
  observableProto.takeLast = function (count) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    var source = this;
    return new AnonymousObservable(function (o) {
      var q = [];
      return source.subscribe(function (x) {
        q.push(x);
        q.length > count && q.shift();
      }, function (e) { o.onError(e); }, function () {
        while (q.length > 0) { o.onNext(q.shift()); }
        o.onCompleted();
      });
    }, source);
  };

observableProto.flatMapConcat = observableProto.concatMap = function(selector, resultSelector, thisArg) {
    return new FlatMapObservable(this, selector, resultSelector, thisArg).merge(1);
};
  var MapObservable = (function (__super__) {
    inherits(MapObservable, __super__);

    function MapObservable(source, selector, thisArg) {
      this.source = source;
      this.selector = bindCallback(selector, thisArg, 3);
      __super__.call(this);
    }

    function innerMap(selector, self) {
      return function (x, i, o) { return selector.call(this, self.selector(x, i, o), i, o); }
    }

    MapObservable.prototype.internalMap = function (selector, thisArg) {
      return new MapObservable(this.source, innerMap(selector, this), thisArg);
    };

    MapObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new InnerObserver(o, this.selector, this));
    };

    function InnerObserver(o, selector, source) {
      this.o = o;
      this.selector = selector;
      this.source = source;
      this.i = 0;
      this.isStopped = false;
    }

    InnerObserver.prototype.onNext = function(x) {
      if (this.isStopped) { return; }
      var result = tryCatch(this.selector)(x, this.i++, this.source);
      if (result === errorObj) { return this.o.onError(result.e); }
      this.o.onNext(result);
    };
    InnerObserver.prototype.onError = function (e) {
      if(!this.isStopped) { this.isStopped = true; this.o.onError(e); }
    };
    InnerObserver.prototype.onCompleted = function () {
      if(!this.isStopped) { this.isStopped = true; this.o.onCompleted(); }
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }

      return false;
    };

    return MapObservable;

  }(ObservableBase));

  /**
  * Projects each element of an observable sequence into a new form by incorporating the element's index.
  * @param {Function} selector A transform function to apply to each source element; the second parameter of the function represents the index of the source element.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} An observable sequence whose elements are the result of invoking the transform function on each element of source.
  */
  observableProto.map = observableProto.select = function (selector, thisArg) {
    var selectorFn = typeof selector === 'function' ? selector : function () { return selector; };
    return this instanceof MapObservable ?
      this.internalMap(selectorFn, thisArg) :
      new MapObservable(this, selectorFn, thisArg);
  };

  function plucker(args, len) {
    return function mapper(x) {
      var currentProp = x;
      for (var i = 0; i < len; i++) {
        var p = currentProp[args[i]];
        if (typeof p !== 'undefined') {
          currentProp = p;
        } else {
          return undefined;
        }
      }
      return currentProp;
    }
  }

  /**
   * Retrieves the value of a specified nested property from all elements in
   * the Observable sequence.
   * @param {Arguments} arguments The nested properties to pluck.
   * @returns {Observable} Returns a new Observable sequence of property values.
   */
  observableProto.pluck = function () {
    var len = arguments.length, args = new Array(len);
    if (len === 0) { throw new Error('List of properties cannot be empty.'); }
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return this.map(plucker(args, len));
  };

observableProto.flatMap = observableProto.selectMany = function(selector, resultSelector, thisArg) {
    return new FlatMapObservable(this, selector, resultSelector, thisArg).mergeAll();
};


//
//Rx.Observable.prototype.flatMapWithMaxConcurrent = function(limit, selector, resultSelector, thisArg) {
//    return new FlatMapObservable(this, selector, resultSelector, thisArg).merge(limit);
//};
//

Rx.Observable.prototype.flatMapLatest = function(selector, resultSelector, thisArg) {
    return new FlatMapObservable(this, selector, resultSelector, thisArg).switchLatest();
};
  var SkipObservable = (function(__super__) {
    inherits(SkipObservable, __super__);
    function SkipObservable(source, count) {
      this.source = source;
      this.skipCount = count;
      __super__.call(this);
    }
    
    SkipObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new InnerObserver(o, this.skipCount));
    };
    
    function InnerObserver(o, c) {
      this.c = c;
      this.r = c;
      this.o = o;
      this.isStopped = false;
    }
    InnerObserver.prototype.onNext = function (x) {
      if (this.isStopped) { return; }
      if (this.r <= 0) { 
        this.o.onNext(x);
      } else {
        this.r--;
      }
    };
    InnerObserver.prototype.onError = function(e) {
      if (!this.isStopped) { this.isStopped = true; this.o.onError(e); }
    };
    InnerObserver.prototype.onCompleted = function() {
      if (!this.isStopped) { this.isStopped = true; this.o.onCompleted(); }
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function(e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }
      return false;
    };
    
    return SkipObservable;
  }(ObservableBase));  
  
  /**
   * Bypasses a specified number of elements in an observable sequence and then returns the remaining elements.
   * @param {Number} count The number of elements to skip before returning the remaining elements.
   * @returns {Observable} An observable sequence that contains the elements that occur after the specified index in the input sequence.
   */
  observableProto.skip = function (count) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    return new SkipObservable(this, count);
  };
  /**
   *  Bypasses elements in an observable sequence as long as a specified condition is true and then returns the remaining elements.
   *  The element's index is used in the logic of the predicate function.
   *
   *  var res = source.skipWhile(function (value) { return value < 10; });
   *  var res = source.skipWhile(function (value, index) { return value < 10 || index < 10; });
   * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence that contains the elements from the input sequence starting at the first element in the linear series that does not pass the test specified by predicate.
   */
  observableProto.skipWhile = function (predicate, thisArg) {
    var source = this,
        callback = bindCallback(predicate, thisArg, 3);
    return new AnonymousObservable(function (o) {
      var i = 0, running = false;
      return source.subscribe(function (x) {
        if (!running) {
          try {
            running = !callback(x, i++, source);
          } catch (e) {
            o.onError(e);
            return;
          }
        }
        running && o.onNext(x);
      }, function (e) { o.onError(e); }, function () { o.onCompleted(); });
    }, source);
  };

  /**
   *  Returns a specified number of contiguous elements from the start of an observable sequence, using the specified scheduler for the edge case of take(0).
   *
   *  var res = source.take(5);
   *  var res = source.take(0, Rx.Scheduler.timeout);
   * @param {Number} count The number of elements to return.
   * @param {Scheduler} [scheduler] Scheduler used to produce an OnCompleted message in case <paramref name="count count</paramref> is set to 0.
   * @returns {Observable} An observable sequence that contains the specified number of elements from the start of the input sequence.
   */
  observableProto.take = function (count, scheduler) {
    if (count < 0) { throw new ArgumentOutOfRangeError(); }
    if (count === 0) { return observableEmpty(scheduler); }
    var source = this;
    return new AnonymousObservable(function (o) {
      var remaining = count;
      return source.subscribe(function (x) {
        if (remaining-- > 0) {
          o.onNext(x);
          remaining <= 0 && o.onCompleted();
        }
      }, function (e) { o.onError(e); }, function () { o.onCompleted(); });
    }, source);
  };

  /**
   *  Returns elements from an observable sequence as long as a specified condition is true.
   *  The element's index is used in the logic of the predicate function.
   * @param {Function} predicate A function to test each element for a condition; the second parameter of the function represents the index of the source element.
   * @param {Any} [thisArg] Object to use as this when executing callback.
   * @returns {Observable} An observable sequence that contains the elements from the input sequence that occur before the element at which the test no longer passes.
   */
  observableProto.takeWhile = function (predicate, thisArg) {
    var source = this,
        callback = bindCallback(predicate, thisArg, 3);
    return new AnonymousObservable(function (o) {
      var i = 0, running = true;
      return source.subscribe(function (x) {
        if (running) {
          try {
            running = callback(x, i++, source);
          } catch (e) {
            o.onError(e);
            return;
          }
          if (running) {
            o.onNext(x);
          } else {
            o.onCompleted();
          }
        }
      }, function (e) { o.onError(e); }, function () { o.onCompleted(); });
    }, source);
  };

  var FilterObservable = (function (__super__) {
    inherits(FilterObservable, __super__);

    function FilterObservable(source, predicate, thisArg) {
      this.source = source;
      this.predicate = bindCallback(predicate, thisArg, 3);
      __super__.call(this);
    }

    FilterObservable.prototype.subscribeCore = function (o) {
      return this.source.subscribe(new InnerObserver(o, this.predicate, this));
    };
    
    function innerPredicate(predicate, self) {
      return function(x, i, o) { return self.predicate(x, i, o) && predicate.call(this, x, i, o); }
    }

    FilterObservable.prototype.internalFilter = function(predicate, thisArg) {
      return new FilterObservable(this.source, innerPredicate(predicate, this), thisArg);
    };
    
    function InnerObserver(o, predicate, source) {
      this.o = o;
      this.predicate = predicate;
      this.source = source;
      this.i = 0;
      this.isStopped = false;
    }
  
    InnerObserver.prototype.onNext = function(x) {
      if (this.isStopped) { return; }
      var shouldYield = tryCatch(this.predicate)(x, this.i++, this.source);
      if (shouldYield === errorObj) {
        return this.o.onError(shouldYield.e);
      }
      shouldYield && this.o.onNext(x);
    };
    InnerObserver.prototype.onError = function (e) {
      if(!this.isStopped) { this.isStopped = true; this.o.onError(e); }
    };
    InnerObserver.prototype.onCompleted = function () {
      if(!this.isStopped) { this.isStopped = true; this.o.onCompleted(); }
    };
    InnerObserver.prototype.dispose = function() { this.isStopped = true; };
    InnerObserver.prototype.fail = function (e) {
      if (!this.isStopped) {
        this.isStopped = true;
        this.o.onError(e);
        return true;
      }
      return false;
    };

    return FilterObservable;

  }(ObservableBase));

  /**
  *  Filters the elements of an observable sequence based on a predicate by incorporating the element's index.
  * @param {Function} predicate A function to test each source element for a condition; the second parameter of the function represents the index of the source element.
  * @param {Any} [thisArg] Object to use as this when executing callback.
  * @returns {Observable} An observable sequence that contains elements from the input sequence that satisfy the condition.
  */
  observableProto.filter = observableProto.where = function (predicate, thisArg) {
    return this instanceof FilterObservable ? this.internalFilter(predicate, thisArg) :
      new FilterObservable(this, predicate, thisArg);
  };

function createCbObservable(fn, ctx, selector, args) {
  var o = new AsyncSubject();

  args.push(createCbHandler(o, ctx, selector));
  fn.apply(ctx, args);

  return o.asObservable();
}

function createCbHandler(o, ctx, selector) {
  return function handler () {
    var len = arguments.length, results = new Array(len);
    for(var i = 0; i < len; i++) { results[i] = arguments[i]; }

    if (isFunction(selector)) {
      results = tryCatch(selector).apply(ctx, results);
      if (results === errorObj) { return o.onError(results.e); }
      o.onNext(results);
    } else {
      if (results.length <= 1) {
        o.onNext(results[0]);
      } else {
        o.onNext(results);
      }
    }

    o.onCompleted();
  };
}

/**
 * Converts a callback function to an observable sequence.
 *
 * @param {Function} fn Function with a callback as the last parameter to convert to an Observable sequence.
 * @param {Mixed} [ctx] The context for the func parameter to be executed.  If not specified, defaults to undefined.
 * @param {Function} [selector] A selector which takes the arguments from the callback to produce a single item to yield on next.
 * @returns {Function} A function, when executed with the required parameters minus the callback, produces an Observable sequence with a single value of the arguments to the callback as an array.
 */
Observable.fromCallback = function (fn, ctx, selector) {
  return function () {
    typeof ctx === 'undefined' && (ctx = this); 

    var len = arguments.length, args = new Array(len)
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return createCbObservable(fn, ctx, selector, args);
  };
};

function createNodeObservable(fn, ctx, selector, args) {
  var o = new AsyncSubject();

  args.push(createNodeHandler(o, ctx, selector));
  fn.apply(ctx, args);

  return o.asObservable();
}

function createNodeHandler(o, ctx, selector) {
  return function handler () {
    var err = arguments[0];
    if (err) { return o.onError(err); }

    var len = arguments.length, results = [];
    for(var i = 1; i < len; i++) { results[i - 1] = arguments[i]; }

    if (isFunction(selector)) {
      var results = tryCatch(selector).apply(ctx, results);
      if (results === errorObj) { return o.onError(results.e); }
      o.onNext(results);
    } else {
      if (results.length <= 1) {
        o.onNext(results[0]);
      } else {
        o.onNext(results);
      }
    }

    o.onCompleted();
  };
}

/**
 * Converts a Node.js callback style function to an observable sequence.  This must be in function (err, ...) format.
 * @param {Function} fn The function to call
 * @param {Mixed} [ctx] The context for the func parameter to be executed.  If not specified, defaults to undefined.
 * @param {Function} [selector] A selector which takes the arguments from the callback minus the error to produce a single item to yield on next.
 * @returns {Function} An async function which when applied, returns an observable sequence with the callback arguments as an array.
 */
Observable.fromNodeCallback = function (fn, ctx, selector) {
  return function () {
    typeof ctx === 'undefined' && (ctx = this); 
    var len = arguments.length, args = new Array(len);
    for(var i = 0; i < len; i++) { args[i] = arguments[i]; }
    return createNodeObservable(fn, ctx, selector, args);
  };
};

  function ListenDisposable(e, n, fn) {
    this._e = e;
    this._n = n;
    this._fn = fn;
    this._e.addEventListener(this._n, this._fn, false);
    this.isDisposed = false;
  }
  ListenDisposable.prototype.dispose = function () {
    if (!this.isDisposed) {
      this._e.removeEventListener(this._n, this._fn, false);
      this.isDisposed = true;
    }
  };

  function createEventListener (el, eventName, handler) {
    var disposables = new CompositeDisposable();

    // Asume NodeList or HTMLCollection
    var elemToString = Object.prototype.toString.call(el);
    if (elemToString === '[object NodeList]' || elemToString === '[object HTMLCollection]') {
      for (var i = 0, len = el.length; i < len; i++) {
        disposables.add(createEventListener(el.item(i), eventName, handler));
      }
    } else if (el) {
      disposables.add(new ListenDisposable(el, eventName, handler));
    }

    return disposables;
  }

  /**
   * Configuration option to determine whether to use native events only
   */
  Rx.config.useNativeEvents = false;

  function eventHandler(o, selector) {
    return function handler () {
      var results = arguments[0];
      if (isFunction(selector)) {
        results = tryCatch(selector).apply(null, arguments);
        if (results === errorObj) { return o.onError(results.e); }
      }
      o.onNext(results);
    };
  }

  /**
   * Creates an observable sequence by adding an event listener to the matching DOMElement or each item in the NodeList.
   * @param {Object} element The DOMElement or NodeList to attach a listener.
   * @param {String} eventName The event name to attach the observable sequence.
   * @param {Function} [selector] A selector which takes the arguments from the event handler to produce a single item to yield on next.
   * @returns {Observable} An observable sequence of events from the specified element and the specified event.
   */
  Observable.fromEvent = function (element, eventName, selector) {
    // Node.js specific
    if (element.addListener) {
      return fromEventPattern(
        function (h) { element.addListener(eventName, h); },
        function (h) { element.removeListener(eventName, h); },
        selector);
    }

    // Use only if non-native events are allowed
    if (!Rx.config.useNativeEvents) {
      // Handles jq, Angular.js, Zepto, Marionette, Ember.js
      if (typeof element.on === 'function' && typeof element.off === 'function') {
        return fromEventPattern(
          function (h) { element.on(eventName, h); },
          function (h) { element.off(eventName, h); },
          selector);
      }
    }

    return new AnonymousObservable(function (o) {
      return createEventListener(
        element,
        eventName,
        eventHandler(o, selector));
    }).publish().refCount();
  };

  /**
   * Creates an observable sequence from an event emitter via an addHandler/removeHandler pair.
   * @param {Function} addHandler The function to add a handler to the emitter.
   * @param {Function} [removeHandler] The optional function to remove a handler from an emitter.
   * @param {Function} [selector] A selector which takes the arguments from the event handler to produce a single item to yield on next.
   * @param {Scheduler} [scheduler] A scheduler used to schedule the remove handler.
   * @returns {Observable} An observable sequence which wraps an event from an event emitter
   */
  var fromEventPattern = Observable.fromEventPattern = function (addHandler, removeHandler, selector, scheduler) {
    isScheduler(scheduler) || (scheduler = immediateScheduler);
    return new AnonymousObservable(function (o) {
      function innerHandler () {
        var result = arguments[0];
        if (isFunction(selector)) {
          result = tryCatch(selector).apply(null, arguments);
          if (result === errorObj) { return o.onError(result.e); }
        }
        o.onNext(result);
      }

      var returnValue = addHandler(innerHandler);
      return disposableCreate(function () {
        isFunction(removeHandler) && removeHandler(innerHandler, returnValue);
      });
    }).publish().refCount();
  };

  var FromPromiseObservable = (function(__super__) {
    inherits(FromPromiseObservable, __super__);
    function FromPromiseObservable(p) {
      this.p = p;
      __super__.call(this);
    }

    FromPromiseObservable.prototype.subscribeCore = function(o) {
      this.p.then(function (data) {
        o.onNext(data);
        o.onCompleted();
      }, function (err) { o.onError(err); });
      return disposableEmpty;
    };

    return FromPromiseObservable;
  }(ObservableBase));

  /**
  * Converts a Promise to an Observable sequence
  * @param {Promise} An ES6 Compliant promise.
  * @returns {Observable} An Observable sequence which wraps the existing promise success and failure.
  */
  var observableFromPromise = Observable.fromPromise = function (promise) {
    return new FromPromiseObservable(promise);
  };
  /*
   * Converts an existing observable sequence to an ES6 Compatible Promise
   * @example
   * var promise = Rx.Observable.return(42).toPromise(RSVP.Promise);
   *
   * // With config
   * Rx.config.Promise = RSVP.Promise;
   * var promise = Rx.Observable.return(42).toPromise();
   * @param {Function} [promiseCtor] The constructor of the promise. If not provided, it looks for it in Rx.config.Promise.
   * @returns {Promise} An ES6 compatible promise with the last value from the observable sequence.
   */
  observableProto.toPromise = function (promiseCtor) {
    promiseCtor || (promiseCtor = Rx.config.Promise);
    if (!promiseCtor) { throw new NotSupportedError('Promise type not provided nor in Rx.config.Promise'); }
    var source = this;
    return new promiseCtor(function (resolve, reject) {
      // No cancellation can be done
      var value, hasValue = false;
      source.subscribe(function (v) {
        value = v;
        hasValue = true;
      }, reject, function () {
        hasValue && resolve(value);
      });
    });
  };

  /**
   * Invokes the asynchronous function, surfacing the result through an observable sequence.
   * @param {Function} functionAsync Asynchronous function which returns a Promise to run.
   * @returns {Observable} An observable sequence exposing the function's result value, or an exception.
   */
  Observable.startAsync = function (functionAsync) {
    var promise;
    try {
      promise = functionAsync();
    } catch (e) {
      return observableThrow(e);
    }
    return observableFromPromise(promise);
  }

  /**
   * Multicasts the source sequence notifications through an instantiated subject into all uses of the sequence within a selector function. Each
   * subscription to the resulting sequence causes a separate multicast invocation, exposing the sequence resulting from the selector function's
   * invocation. For specializations with fixed subject types, see Publish, PublishLast, and Replay.
   *
   * @example
   * 1 - res = source.multicast(observable);
   * 2 - res = source.multicast(function () { return new Subject(); }, function (x) { return x; });
   *
   * @param {Function|Subject} subjectOrSubjectSelector
   * Factory function to create an intermediate subject through which the source sequence's elements will be multicast to the selector function.
   * Or:
   * Subject to push source elements into.
   *
   * @param {Function} [selector] Optional selector function which can use the multicasted source sequence subject to the policies enforced by the created subject. Specified only if <paramref name="subjectOrSubjectSelector" is a factory function.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.multicast = function (subjectOrSubjectSelector, selector) {
    var source = this;
    return typeof subjectOrSubjectSelector === 'function' ?
      new AnonymousObservable(function (observer) {
        var connectable = source.multicast(subjectOrSubjectSelector());
        return new CompositeDisposable(selector(connectable).subscribe(observer), connectable.connect());
      }, source) :
      new ConnectableObservable(source, subjectOrSubjectSelector);
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence.
   * This operator is a specialization of Multicast using a regular Subject.
   *
   * @example
   * var resres = source.publish();
   * var res = source.publish(function (x) { return x; });
   *
   * @param {Function} [selector] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.publish = function (selector) {
    return selector && isFunction(selector) ?
      this.multicast(function () { return new Subject(); }, selector) :
      this.multicast(new Subject());
  };

  /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence.
   * This operator is a specialization of publish which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */
  observableProto.share = function () {
    return this.publish().refCount();
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence containing only the last notification.
   * This operator is a specialization of Multicast using a AsyncSubject.
   *
   * @example
   * var res = source.publishLast();
   * var res = source.publishLast(function (x) { return x; });
   *
   * @param selector [Optional] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will only receive the last notification of the source.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.publishLast = function (selector) {
    return selector && isFunction(selector) ?
      this.multicast(function () { return new AsyncSubject(); }, selector) :
      this.multicast(new AsyncSubject());
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence and starts with initialValue.
   * This operator is a specialization of Multicast using a BehaviorSubject.
   *
   * @example
   * var res = source.publishValue(42);
   * var res = source.publishValue(function (x) { return x.select(function (y) { return y * y; }) }, 42);
   *
   * @param {Function} [selector] Optional selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive immediately receive the initial value, followed by all notifications of the source from the time of the subscription on.
   * @param {Mixed} initialValue Initial value received by observers upon subscription.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.publishValue = function (initialValueOrSelector, initialValue) {
    return arguments.length === 2 ?
      this.multicast(function () {
        return new BehaviorSubject(initialValue);
      }, initialValueOrSelector) :
      this.multicast(new BehaviorSubject(initialValueOrSelector));
  };

  /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence and starts with an initialValue.
   * This operator is a specialization of publishValue which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   * @param {Mixed} initialValue Initial value received by observers upon subscription.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */
  observableProto.shareValue = function (initialValue) {
    return this.publishValue(initialValue).refCount();
  };

  /**
   * Returns an observable sequence that is the result of invoking the selector on a connectable observable sequence that shares a single subscription to the underlying sequence replaying notifications subject to a maximum time length for the replay buffer.
   * This operator is a specialization of Multicast using a ReplaySubject.
   *
   * @example
   * var res = source.replay(null, 3);
   * var res = source.replay(null, 3, 500);
   * var res = source.replay(null, 3, 500, scheduler);
   * var res = source.replay(function (x) { return x.take(6).repeat(); }, 3, 500, scheduler);
   *
   * @param selector [Optional] Selector function which can use the multicasted source sequence as many times as needed, without causing multiple subscriptions to the source sequence. Subscribers to the given source will receive all the notifications of the source subject to the specified replay buffer trimming policy.
   * @param bufferSize [Optional] Maximum element count of the replay buffer.
   * @param windowSize [Optional] Maximum time length of the replay buffer.
   * @param scheduler [Optional] Scheduler where connected observers within the selector function will be invoked on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence within a selector function.
   */
  observableProto.replay = function (selector, bufferSize, windowSize, scheduler) {
    return selector && isFunction(selector) ?
      this.multicast(function () { return new ReplaySubject(bufferSize, windowSize, scheduler); }, selector) :
      this.multicast(new ReplaySubject(bufferSize, windowSize, scheduler));
  };

  /**
   * Returns an observable sequence that shares a single subscription to the underlying sequence replaying notifications subject to a maximum time length for the replay buffer.
   * This operator is a specialization of replay which creates a subscription when the number of observers goes from zero to one, then shares that subscription with all subsequent observers until the number of observers returns to zero, at which point the subscription is disposed.
   *
   * @example
   * var res = source.shareReplay(3);
   * var res = source.shareReplay(3, 500);
   * var res = source.shareReplay(3, 500, scheduler);
   *

   * @param bufferSize [Optional] Maximum element count of the replay buffer.
   * @param window [Optional] Maximum time length of the replay buffer.
   * @param scheduler [Optional] Scheduler where connected observers within the selector function will be invoked on.
   * @returns {Observable} An observable sequence that contains the elements of a sequence produced by multicasting the source sequence.
   */
  observableProto.shareReplay = function (bufferSize, windowSize, scheduler) {
    return this.replay(null, bufferSize, windowSize, scheduler).refCount();
  };

  var ConnectableObservable = Rx.ConnectableObservable = (function (__super__) {
    inherits(ConnectableObservable, __super__);

    function ConnectableObservable(source, subject) {
      var hasSubscription = false,
        subscription,
        sourceObservable = source.asObservable();

      this.connect = function () {
        if (!hasSubscription) {
          hasSubscription = true;
          subscription = new CompositeDisposable(sourceObservable.subscribe(subject), disposableCreate(function () {
            hasSubscription = false;
          }));
        }
        return subscription;
      };

      __super__.call(this, function (o) { return subject.subscribe(o); });
    }

    ConnectableObservable.prototype.refCount = function () {
      var connectableSubscription, count = 0, source = this;
      return new AnonymousObservable(function (observer) {
          var shouldConnect = ++count === 1,
            subscription = source.subscribe(observer);
          shouldConnect && (connectableSubscription = source.connect());
          return function () {
            subscription.dispose();
            --count === 0 && connectableSubscription.dispose();
          };
      });
    };

    return ConnectableObservable;
  }(Observable));

  function observableTimerDate(dueTime, scheduler) {
    return new AnonymousObservable(function (observer) {
      return scheduler.scheduleWithAbsolute(dueTime, function () {
        observer.onNext(0);
        observer.onCompleted();
      });
    });
  }

  function observableTimerDateAndPeriod(dueTime, period, scheduler) {
    return new AnonymousObservable(function (observer) {
      var d = dueTime, p = normalizeTime(period);
      return scheduler.scheduleRecursiveWithAbsoluteAndState(0, d, function (count, self) {
        if (p > 0) {
          var now = scheduler.now();
          d = d + p;
          d <= now && (d = now + p);
        }
        observer.onNext(count);
        self(count + 1, d);
      });
    });
  }

  function observableTimerTimeSpan(dueTime, scheduler) {
    return new AnonymousObservable(function (observer) {
      return scheduler.scheduleWithRelative(normalizeTime(dueTime), function () {
        observer.onNext(0);
        observer.onCompleted();
      });
    });
  }

  function observableTimerTimeSpanAndPeriod(dueTime, period, scheduler) {
    return dueTime === period ?
      new AnonymousObservable(function (observer) {
        return scheduler.schedulePeriodicWithState(0, period, function (count) {
          observer.onNext(count);
          return count + 1;
        });
      }) :
      observableDefer(function () {
        return observableTimerDateAndPeriod(scheduler.now() + dueTime, period, scheduler);
      });
  }

  /**
   *  Returns an observable sequence that produces a value after each period.
   *
   * @example
   *  1 - res = Rx.Observable.interval(1000);
   *  2 - res = Rx.Observable.interval(1000, Rx.Scheduler.timeout);
   *
   * @param {Number} period Period for producing the values in the resulting sequence (specified as an integer denoting milliseconds).
   * @param {Scheduler} [scheduler] Scheduler to run the timer on. If not specified, Rx.Scheduler.timeout is used.
   * @returns {Observable} An observable sequence that produces a value after each period.
   */
  var observableinterval = Observable.interval = function (period, scheduler) {
    return observableTimerTimeSpanAndPeriod(period, period, isScheduler(scheduler) ? scheduler : timeoutScheduler);
  };

  /**
   *  Returns an observable sequence that produces a value after dueTime has elapsed and then after each period.
   * @param {Number} dueTime Absolute (specified as a Date object) or relative time (specified as an integer denoting milliseconds) at which to produce the first value.
   * @param {Mixed} [periodOrScheduler]  Period to produce subsequent values (specified as an integer denoting milliseconds), or the scheduler to run the timer on. If not specified, the resulting timer is not recurring.
   * @param {Scheduler} [scheduler]  Scheduler to run the timer on. If not specified, the timeout scheduler is used.
   * @returns {Observable} An observable sequence that produces a value after due time has elapsed and then each period.
   */
  var observableTimer = Observable.timer = function (dueTime, periodOrScheduler, scheduler) {
    var period;
    isScheduler(scheduler) || (scheduler = timeoutScheduler);
    if (periodOrScheduler != null && typeof periodOrScheduler === 'number') {
      period = periodOrScheduler;
    } else if (isScheduler(periodOrScheduler)) {
      scheduler = periodOrScheduler;
    }
    if (dueTime instanceof Date && period === undefined) {
      return observableTimerDate(dueTime.getTime(), scheduler);
    }
    if (dueTime instanceof Date && period !== undefined) {
      return observableTimerDateAndPeriod(dueTime.getTime(), periodOrScheduler, scheduler);
    }
    return period === undefined ?
      observableTimerTimeSpan(dueTime, scheduler) :
      observableTimerTimeSpanAndPeriod(dueTime, period, scheduler);
  };

  function observableDelayRelative(source, dueTime, scheduler) {
    return new AnonymousObservable(function (o) {
      var active = false,
        cancelable = new SerialDisposable(),
        exception = null,
        q = [],
        running = false,
        subscription;
      subscription = source.materialize().timestamp(scheduler).subscribe(function (notification) {
        var d, shouldRun;
        if (notification.value.kind === 'E') {
          q = [];
          q.push(notification);
          exception = notification.value.exception;
          shouldRun = !running;
        } else {
          q.push({ value: notification.value, timestamp: notification.timestamp + dueTime });
          shouldRun = !active;
          active = true;
        }
        if (shouldRun) {
          if (exception !== null) {
            o.onError(exception);
          } else {
            d = new SingleAssignmentDisposable();
            cancelable.setDisposable(d);
            d.setDisposable(scheduler.scheduleRecursiveWithRelative(dueTime, function (self) {
              var e, recurseDueTime, result, shouldRecurse;
              if (exception !== null) {
                return;
              }
              running = true;
              do {
                result = null;
                if (q.length > 0 && q[0].timestamp - scheduler.now() <= 0) {
                  result = q.shift().value;
                }
                if (result !== null) {
                  result.accept(o);
                }
              } while (result !== null);
              shouldRecurse = false;
              recurseDueTime = 0;
              if (q.length > 0) {
                shouldRecurse = true;
                recurseDueTime = Math.max(0, q[0].timestamp - scheduler.now());
              } else {
                active = false;
              }
              e = exception;
              running = false;
              if (e !== null) {
                o.onError(e);
              } else if (shouldRecurse) {
                self(recurseDueTime);
              }
            }));
          }
        }
      });
      return new CompositeDisposable(subscription, cancelable);
    }, source);
  }

  function observableDelayAbsolute(source, dueTime, scheduler) {
    return observableDefer(function () {
      return observableDelayRelative(source, dueTime - scheduler.now(), scheduler);
    });
  }

  function delayWithSelector(source, subscriptionDelay, delayDurationSelector) {
    var subDelay, selector;
    if (isFunction(subscriptionDelay)) {
      selector = subscriptionDelay;
    } else {
      subDelay = subscriptionDelay;
      selector = delayDurationSelector;
    }
    return new AnonymousObservable(function (o) {
      var delays = new CompositeDisposable(), atEnd = false, subscription = new SerialDisposable();

      function start() {
        subscription.setDisposable(source.subscribe(
          function (x) {
            var delay = tryCatch(selector)(x);
            if (delay === errorObj) { return o.onError(delay.e); }
            var d = new SingleAssignmentDisposable();
            delays.add(d);
            d.setDisposable(delay.subscribe(
              function () {
                o.onNext(x);
                delays.remove(d);
                done();
              },
              function (e) { o.onError(e); },
              function () {
                o.onNext(x);
                delays.remove(d);
                done();
              }
            ));
          },
          function (e) { o.onError(e); },
          function () {
            atEnd = true;
            subscription.dispose();
            done();
          }
        ));
      }

      function done () {
        atEnd && delays.length === 0 && o.onCompleted();
      }

      if (!subDelay) {
        start();
      } else {
        subscription.setDisposable(subDelay.subscribe(start, function (e) { o.onError(e); }, start));
      }

      return new CompositeDisposable(subscription, delays);
    }, this);
  }

  /**
   *  Time shifts the observable sequence by dueTime.
   *  The relative time intervals between the values are preserved.
   *
   * @param {Number} dueTime Absolute (specified as a Date object) or relative time (specified as an integer denoting milliseconds) by which to shift the observable sequence.
   * @param {Scheduler} [scheduler] Scheduler to run the delay timers on. If not specified, the timeout scheduler is used.
   * @returns {Observable} Time-shifted sequence.
   */
  observableProto.delay = function () {
    if (typeof arguments[0] === 'number' || arguments[0] instanceof Date) {
      var dueTime = arguments[0], scheduler = arguments[1];
      isScheduler(scheduler) || (scheduler = timeoutScheduler);
      return dueTime instanceof Date ?
        observableDelayAbsolute(this, dueTime, scheduler) :
        observableDelayRelative(this, dueTime, scheduler);
    } else if (isFunction(arguments[0])) {
      return delayWithSelector(this, arguments[0], arguments[1]);
    } else {
      throw new Error('Invalid arguments');
    }
  };

  function debounce(source, dueTime, scheduler) {
    isScheduler(scheduler) || (scheduler = timeoutScheduler);
    return new AnonymousObservable(function (observer) {
      var cancelable = new SerialDisposable(), hasvalue = false, value, id = 0;
      var subscription = source.subscribe(
        function (x) {
          hasvalue = true;
          value = x;
          id++;
          var currentId = id,
            d = new SingleAssignmentDisposable();
          cancelable.setDisposable(d);
          d.setDisposable(scheduler.scheduleWithRelative(dueTime, function () {
            hasvalue && id === currentId && observer.onNext(value);
            hasvalue = false;
          }));
        },
        function (e) {
          cancelable.dispose();
          observer.onError(e);
          hasvalue = false;
          id++;
        },
        function () {
          cancelable.dispose();
          hasvalue && observer.onNext(value);
          observer.onCompleted();
          hasvalue = false;
          id++;
        });
      return new CompositeDisposable(subscription, cancelable);
    }, this);
  }

  function debounceWithSelector(source, durationSelector) {
    return new AnonymousObservable(function (o) {
      var value, hasValue = false, cancelable = new SerialDisposable(), id = 0;
      var subscription = source.subscribe(
        function (x) {
          var throttle = tryCatch(durationSelector)(x);
          if (throttle === errorObj) { return o.onError(throttle.e); }

          isPromise(throttle) && (throttle = observableFromPromise(throttle));

          hasValue = true;
          value = x;
          id++;
          var currentid = id, d = new SingleAssignmentDisposable();
          cancelable.setDisposable(d);
          d.setDisposable(throttle.subscribe(
            function () {
              hasValue && id === currentid && o.onNext(value);
              hasValue = false;
              d.dispose();
            },
            function (e) { o.onError(e); },
            function () {
              hasValue && id === currentid && o.onNext(value);
              hasValue = false;
              d.dispose();
            }
          ));
        },
        function (e) {
          cancelable.dispose();
          o.onError(e);
          hasValue = false;
          id++;
        },
        function () {
          cancelable.dispose();
          hasValue && o.onNext(value);
          o.onCompleted();
          hasValue = false;
          id++;
        }
      );
      return new CompositeDisposable(subscription, cancelable);
    }, source);
  }

  observableProto.debounce = function () {
    if (isFunction (arguments[0])) {
      return debounceWithSelector(this, arguments[0]);
    } else if (typeof arguments[0] === 'number') {
      return debounce(this, arguments[0], arguments[1]);
    } else {
      throw new Error('Invalid arguments');
    }
  };

  /**
   *  Records the timestamp for each value in an observable sequence.
   *
   * @example
   *  1 - res = source.timestamp(); // produces { value: x, timestamp: ts }
   *  2 - res = source.timestamp(Rx.Scheduler.default);
   *
   * @param {Scheduler} [scheduler]  Scheduler used to compute timestamps. If not specified, the default scheduler is used.
   * @returns {Observable} An observable sequence with timestamp information on values.
   */
  observableProto.timestamp = function (scheduler) {
    isScheduler(scheduler) || (scheduler = timeoutScheduler);
    return this.map(function (x) {
      return { value: x, timestamp: scheduler.now() };
    });
  };

  function sampleObservable(source, sampler) {
    return new AnonymousObservable(function (o) {
      var atEnd = false, value, hasValue = false;

      function sampleSubscribe() {
        if (hasValue) {
          hasValue = false;
          o.onNext(value);
        }
        atEnd && o.onCompleted();
      }

      var sourceSubscription = new SingleAssignmentDisposable();
      sourceSubscription.setDisposable(source.subscribe(
        function (newValue) {
          hasValue = true;
          value = newValue;
        },
        function (e) { o.onError(e); },
        function () {
          atEnd = true;
          sourceSubscription.dispose(); 
        }
      ));

      return new CompositeDisposable(
        sourceSubscription,
        sampler.subscribe(sampleSubscribe, function (e) { o.onError(e); }, sampleSubscribe)
      );
    }, source);
  }

  /**
   *  Samples the observable sequence at each interval.
   *
   * @example
   *  1 - res = source.sample(sampleObservable); // Sampler tick sequence
   *  2 - res = source.sample(5000); // 5 seconds
   *  2 - res = source.sample(5000, Rx.Scheduler.timeout); // 5 seconds
   *
   * @param {Mixed} intervalOrSampler Interval at which to sample (specified as an integer denoting milliseconds) or Sampler Observable.
   * @param {Scheduler} [scheduler]  Scheduler to run the sampling timer on. If not specified, the timeout scheduler is used.
   * @returns {Observable} Sampled observable sequence.
   */
  observableProto.sample = observableProto.throttleLatest = function (intervalOrSampler, scheduler) {
    isScheduler(scheduler) || (scheduler = timeoutScheduler);
    return typeof intervalOrSampler === 'number' ?
      sampleObservable(this, observableinterval(intervalOrSampler, scheduler)) :
      sampleObservable(this, intervalOrSampler);
  };

  var TimeoutError = Rx.TimeoutError = function(message) {
    this.message = message || 'Timeout has occurred';
    this.name = 'TimeoutError';
    Error.call(this);
  };
  TimeoutError.prototype = Object.create(Error.prototype);

  function timeoutWithSelector(source, firstTimeout, timeoutDurationSelector, other) {
    if (isFunction(firstTimeout)) {
      other = timeoutDurationSelector;
      timeoutDurationSelector = firstTimeout;
      firstTimeout = observableNever();
    }
    other || (other = observableThrow(new TimeoutError()));
    return new AnonymousObservable(function (o) {
      var subscription = new SerialDisposable(), timer = new SerialDisposable(), original = new SingleAssignmentDisposable();

      subscription.setDisposable(original);

      var id = 0, switched = false;

      function setTimer(timeout) {
        var myId = id, d = new SingleAssignmentDisposable();
        timer.setDisposable(d);
        d.setDisposable(timeout.subscribe(function () {
          id === myId && subscription.setDisposable(other.subscribe(o));
          d.dispose();
        }, function (e) {
          id === myId && o.onError(e);
        }, function () {
          id === myId && subscription.setDisposable(other.subscribe(o));
        }));
      };

      setTimer(firstTimeout);

      function oWins() {
        var res = !switched;
        if (res) { id++; }
        return res;
      }

      original.setDisposable(source.subscribe(function (x) {
        if (oWins()) {
          o.onNext(x);
          var timeout = tryCatch(timeoutDurationSelector)(x);
          if (timeout === errorObj) { return o.onError(timeout.e); }
          setTimer(isPromise(timeout) ? observableFromPromise(timeout) : timeout);
        }
      }, function (e) {
        oWins() && o.onError(e);
      }, function () {
        oWins() && o.onCompleted();
      }));
      return new CompositeDisposable(subscription, timer);
    }, source);
  }

  function timeout(source, dueTime, other, scheduler) {
    if (other == null) { throw new Error('other or scheduler must be specified'); }
    if (isScheduler(other)) {
      scheduler = other;
      other = observableThrow(new TimeoutError());
    }
    if (other instanceof Error) { other = observableThrow(other); }
    isScheduler(scheduler) || (scheduler = timeoutScheduler);

    var schedulerMethod = dueTime instanceof Date ?
      'scheduleWithAbsolute' :
      'scheduleWithRelative';

    return new AnonymousObservable(function (o) {
      var id = 0,
        original = new SingleAssignmentDisposable(),
        subscription = new SerialDisposable(),
        switched = false,
        timer = new SerialDisposable();

      subscription.setDisposable(original);

      function createTimer() {
        var myId = id;
        timer.setDisposable(scheduler[schedulerMethod](dueTime, function () {
          if (id === myId) {
            isPromise(other) && (other = observableFromPromise(other));
            subscription.setDisposable(other.subscribe(o));
          }
        }));
      }

      createTimer();

      original.setDisposable(source.subscribe(function (x) {
        if (!switched) {
          id++;
          o.onNext(x);
          createTimer();
        }
      }, function (e) {
        if (!switched) {
          id++;
          o.onError(e);
        }
      }, function () {
        if (!switched) {
          id++;
          o.onCompleted();
        }
      }));
      return new CompositeDisposable(subscription, timer);
    }, source);
  }

  observableProto.timeout = function () {
    var firstArg = arguments[0];
    if (firstArg instanceof Date || typeof firstArg === 'number') {
      return timeout(this, firstArg, arguments[1], arguments[2]);
    } else if (Observable.isObservable(firstArg) || isFunction(firstArg)) {
      return timeoutWithSelector(this, firstArg, arguments[1], arguments[2]);
    } else {
      throw new Error('Invalid arguments');
    }
  };

  /**
   * Returns an Observable that emits only the first item emitted by the source Observable during sequential time windows of a specified duration.
   * @param {Number} windowDuration time to wait before emitting another item after emitting the last item
   * @param {Scheduler} [scheduler] the Scheduler to use internally to manage the timers that handle timeout for each item. If not provided, defaults to Scheduler.timeout.
   * @returns {Observable} An Observable that performs the throttle operation.
   */
  observableProto.throttle = function (windowDuration, scheduler) {
    isScheduler(scheduler) || (scheduler = timeoutScheduler);
    var duration = +windowDuration || 0;
    if (duration <= 0) { throw new RangeError('windowDuration cannot be less or equal zero.'); }
    var source = this;
    return new AnonymousObservable(function (o) {
      var lastOnNext = 0;
      return source.subscribe(
        function (x) {
          var now = scheduler.now();
          if (lastOnNext === 0 || now - lastOnNext >= duration) {
            lastOnNext = now;
            o.onNext(x);
          }
        },function (e) { o.onError(e); }, function () { o.onCompleted(); }
      );
    }, source);
  };

  var PausableObservable = (function (__super__) {

    inherits(PausableObservable, __super__);

    function subscribe(observer) {
      var conn = this.source.publish(),
        subscription = conn.subscribe(observer),
        connection = disposableEmpty;

      var pausable = this.pauser.distinctUntilChanged().subscribe(function (b) {
        if (b) {
          connection = conn.connect();
        } else {
          connection.dispose();
          connection = disposableEmpty;
        }
      });

      return new CompositeDisposable(subscription, connection, pausable);
    }

    function PausableObservable(source, pauser) {
      this.source = source;
      this.controller = new Subject();

      if (pauser && pauser.subscribe) {
        this.pauser = this.controller.merge(pauser);
      } else {
        this.pauser = this.controller;
      }

      __super__.call(this, subscribe, source);
    }

    PausableObservable.prototype.pause = function () {
      this.controller.onNext(false);
    };

    PausableObservable.prototype.resume = function () {
      this.controller.onNext(true);
    };

    return PausableObservable;

  }(Observable));

  /**
   * Pauses the underlying observable sequence based upon the observable sequence which yields true/false.
   * @example
   * var pauser = new Rx.Subject();
   * var source = Rx.Observable.interval(100).pausable(pauser);
   * @param {Observable} pauser The observable sequence used to pause the underlying sequence.
   * @returns {Observable} The observable sequence which is paused based upon the pauser.
   */
  observableProto.pausable = function (pauser) {
    return new PausableObservable(this, pauser);
  };

  function combineLatestSource(source, subject, resultSelector) {
    return new AnonymousObservable(function (o) {
      var hasValue = [false, false],
        hasValueAll = false,
        isDone = false,
        values = new Array(2),
        err;

      function next(x, i) {
        values[i] = x;
        hasValue[i] = true;
        if (hasValueAll || (hasValueAll = hasValue.every(identity))) {
          if (err) { return o.onError(err); }
          var res = tryCatch(resultSelector).apply(null, values);
          if (res === errorObj) { return o.onError(res.e); }
          o.onNext(res);
        }
        isDone && values[1] && o.onCompleted();
      }

      return new CompositeDisposable(
        source.subscribe(
          function (x) {
            next(x, 0);
          },
          function (e) {
            if (values[1]) {
              o.onError(e);
            } else {
              err = e;
            }
          },
          function () {
            isDone = true;
            values[1] && o.onCompleted();
          }),
        subject.subscribe(
          function (x) {
            next(x, 1);
          },
          function (e) { o.onError(e); },
          function () {
            isDone = true;
            next(true, 1);
          })
        );
    }, source);
  }

  var PausableBufferedObservable = (function (__super__) {

    inherits(PausableBufferedObservable, __super__);

    function subscribe(o) {
      var q = [], previousShouldFire;

      function drainQueue() { while (q.length > 0) { o.onNext(q.shift()); } }

      var subscription =
        combineLatestSource(
          this.source,
          this.pauser.startWith(false).distinctUntilChanged(),
          function (data, shouldFire) {
            return { data: data, shouldFire: shouldFire };
          })
          .subscribe(
            function (results) {
              if (previousShouldFire !== undefined && results.shouldFire != previousShouldFire) {
                previousShouldFire = results.shouldFire;
                // change in shouldFire
                if (results.shouldFire) { drainQueue(); }
              } else {
                previousShouldFire = results.shouldFire;
                // new data
                if (results.shouldFire) {
                  o.onNext(results.data);
                } else {
                  q.push(results.data);
                }
              }
            },
            function (err) {
              drainQueue();
              o.onError(err);
            },
            function () {
              drainQueue();
              o.onCompleted();
            }
          );
      return subscription;
    }

    function PausableBufferedObservable(source, pauser) {
      this.source = source;
      this.controller = new Subject();

      if (pauser && pauser.subscribe) {
        this.pauser = this.controller.merge(pauser);
      } else {
        this.pauser = this.controller;
      }

      __super__.call(this, subscribe, source);
    }

    PausableBufferedObservable.prototype.pause = function () {
      this.controller.onNext(false);
    };

    PausableBufferedObservable.prototype.resume = function () {
      this.controller.onNext(true);
    };

    return PausableBufferedObservable;

  }(Observable));

  /**
   * Pauses the underlying observable sequence based upon the observable sequence which yields true/false,
   * and yields the values that were buffered while paused.
   * @example
   * var pauser = new Rx.Subject();
   * var source = Rx.Observable.interval(100).pausableBuffered(pauser);
   * @param {Observable} pauser The observable sequence used to pause the underlying sequence.
   * @returns {Observable} The observable sequence which is paused based upon the pauser.
   */
  observableProto.pausableBuffered = function (subject) {
    return new PausableBufferedObservable(this, subject);
  };

var ControlledObservable = (function (__super__) {

  inherits(ControlledObservable, __super__);

  function subscribe (observer) {
    return this.source.subscribe(observer);
  }

  function ControlledObservable (source, enableQueue, scheduler) {
    __super__.call(this, subscribe, source);
    this.subject = new ControlledSubject(enableQueue, scheduler);
    this.source = source.multicast(this.subject).refCount();
  }

  ControlledObservable.prototype.request = function (numberOfItems) {
    return this.subject.request(numberOfItems == null ? -1 : numberOfItems);
  };

  return ControlledObservable;

}(Observable));

var ControlledSubject = (function (__super__) {

  function subscribe (observer) {
    return this.subject.subscribe(observer);
  }

  inherits(ControlledSubject, __super__);

  function ControlledSubject(enableQueue, scheduler) {
    enableQueue == null && (enableQueue = true);

    __super__.call(this, subscribe);
    this.subject = new Subject();
    this.enableQueue = enableQueue;
    this.queue = enableQueue ? [] : null;
    this.requestedCount = 0;
    this.requestedDisposable = null;
    this.error = null;
    this.hasFailed = false;
    this.hasCompleted = false;
    this.scheduler = scheduler || currentThreadScheduler;
  }

  addProperties(ControlledSubject.prototype, Observer, {
    onCompleted: function () {
      this.hasCompleted = true;
      if (!this.enableQueue || this.queue.length === 0) {
        this.subject.onCompleted();
        this.disposeCurrentRequest()
      } else {
        this.queue.push(Notification.createOnCompleted());
      }
    },
    onError: function (error) {
      this.hasFailed = true;
      this.error = error;
      if (!this.enableQueue || this.queue.length === 0) {
        this.subject.onError(error);
        this.disposeCurrentRequest()
      } else {
        this.queue.push(Notification.createOnError(error));
      }
    },
    onNext: function (value) {
      if (this.requestedCount <= 0) {
        this.enableQueue && this.queue.push(Notification.createOnNext(value));
      } else {
        (this.requestedCount-- === 0) && this.disposeCurrentRequest();
        this.subject.onNext(value);
      }
    },
    _processRequest: function (numberOfItems) {
      if (this.enableQueue) {
        while (this.queue.length > 0 && (numberOfItems > 0 || this.queue[0].kind !== 'N')) {
          var first = this.queue.shift();
          first.accept(this.subject);
          if (first.kind === 'N') {
            numberOfItems--;
          } else {
            this.disposeCurrentRequest();
            this.queue = [];
          }
        }
      }

      return numberOfItems;
    },
    request: function (number) {
      this.disposeCurrentRequest();
      var self = this;

      this.requestedDisposable = this.scheduler.scheduleWithState(number,
      function(s, i) {
        var remaining = self._processRequest(i);
        var stopped = self.hasCompleted || self.hasFailed
        if (!stopped && remaining > 0) {
          self.requestedCount = remaining;

          return disposableCreate(function () {
            self.requestedCount = 0;
          });
            // Scheduled item is still in progress. Return a new
            // disposable to allow the request to be interrupted
            // via dispose.
        }
      });

      return this.requestedDisposable;
    },
    disposeCurrentRequest: function () {
      if (this.requestedDisposable) {
        this.requestedDisposable.dispose();
        this.requestedDisposable = null;
      }
    }
  });

  return ControlledSubject;
}(Observable));

/**
 * Attaches a controller to the observable sequence with the ability to queue.
 * @example
 * var source = Rx.Observable.interval(100).controlled();
 * source.request(3); // Reads 3 values
 * @param {bool} enableQueue truthy value to determine if values should be queued pending the next request
 * @param {Scheduler} scheduler determines how the requests will be scheduled
 * @returns {Observable} The observable sequence which only propagates values on request.
 */
observableProto.controlled = function (enableQueue, scheduler) {

  if (enableQueue && isScheduler(enableQueue)) {
      scheduler = enableQueue;
      enableQueue = true;
  }

  if (enableQueue == null) {  enableQueue = true; }
  return new ControlledObservable(this, enableQueue, scheduler);
};

  /**
   * Pipes the existing Observable sequence into a Node.js Stream.
   * @param {Stream} dest The destination Node.js stream.
   * @returns {Stream} The destination stream.
   */
  observableProto.pipe = function (dest) {
    var source = this.pausableBuffered();

    function onDrain() {
      source.resume();
    }

    dest.addListener('drain', onDrain);

    source.subscribe(
      function (x) {
        !dest.write(String(x)) && source.pause();
      },
      function (err) {
        dest.emit('error', err);
      },
      function () {
        // Hack check because STDIO is not closable
        !dest._isStdio && dest.end();
        dest.removeListener('drain', onDrain);
      });

    source.resume();

    return dest;
  };

  /**
   * Executes a transducer to transform the observable sequence
   * @param {Transducer} transducer A transducer to execute
   * @returns {Observable} An Observable sequence containing the results from the transducer.
   */
  observableProto.transduce = function(transducer) {
    var source = this;

    function transformForObserver(o) {
      return {
        '@@transducer/init': function() {
          return o;
        },
        '@@transducer/step': function(obs, input) {
          return obs.onNext(input);
        },
        '@@transducer/result': function(obs) {
          return obs.onCompleted();
        }
      };
    }

    return new AnonymousObservable(function(o) {
      var xform = transducer(transformForObserver(o));
      return source.subscribe(
        function(v) {
          var res = tryCatch(xform['@@transducer/step']).call(xform, o, v);
          if (res === errorObj) { o.onError(res.e); }
        },
        function (e) { o.onError(e); },
        function() { xform['@@transducer/result'](o); }
      );
    }, source);
  };

  var AnonymousObservable = Rx.AnonymousObservable = (function (__super__) {
    inherits(AnonymousObservable, __super__);

    // Fix subscriber to check for undefined or function returned to decorate as Disposable
    function fixSubscriber(subscriber) {
      return subscriber && isFunction(subscriber.dispose) ? subscriber :
        isFunction(subscriber) ? disposableCreate(subscriber) : disposableEmpty;
    }

    function setDisposable(s, state) {
      var ado = state[0], self = state[1];
      var sub = tryCatch(self.__subscribe).call(self, ado);

      if (sub === errorObj) {
        if(!ado.fail(errorObj.e)) { return thrower(errorObj.e); }
      }
      ado.setDisposable(fixSubscriber(sub));
    }

    function innerSubscribe(observer) {
      var ado = new AutoDetachObserver(observer), state = [ado, this];

      if (currentThreadScheduler.scheduleRequired()) {
        currentThreadScheduler.scheduleWithState(state, setDisposable);
      } else {
        setDisposable(null, state);
      }
      return ado;
    }

    function AnonymousObservable(subscribe, parent) {
      this.source = parent;
      this.__subscribe = subscribe;
      __super__.call(this, innerSubscribe);
    }

    return AnonymousObservable;

  }(Observable));

  var AutoDetachObserver = (function (__super__) {
    inherits(AutoDetachObserver, __super__);

    function AutoDetachObserver(observer) {
      __super__.call(this);
      this.observer = observer;
      this.m = new SingleAssignmentDisposable();
    }

    var AutoDetachObserverPrototype = AutoDetachObserver.prototype;

    AutoDetachObserverPrototype.next = function (value) {
      var result = tryCatch(this.observer.onNext).call(this.observer, value);
      if (result === errorObj) {
        this.dispose();
        thrower(result.e);
      }
    };

    AutoDetachObserverPrototype.error = function (err) {
      var result = tryCatch(this.observer.onError).call(this.observer, err);
      this.dispose();
      result === errorObj && thrower(result.e);
    };

    AutoDetachObserverPrototype.completed = function () {
      var result = tryCatch(this.observer.onCompleted).call(this.observer);
      this.dispose();
      result === errorObj && thrower(result.e);
    };

    AutoDetachObserverPrototype.setDisposable = function (value) { this.m.setDisposable(value); };
    AutoDetachObserverPrototype.getDisposable = function () { return this.m.getDisposable(); };

    AutoDetachObserverPrototype.dispose = function () {
      __super__.prototype.dispose.call(this);
      this.m.dispose();
    };

    return AutoDetachObserver;
  }(AbstractObserver));

  var InnerSubscription = function (subject, observer) {
    this.subject = subject;
    this.observer = observer;
  };

  InnerSubscription.prototype.dispose = function () {
    if (!this.subject.isDisposed && this.observer !== null) {
      var idx = this.subject.observers.indexOf(this.observer);
      this.subject.observers.splice(idx, 1);
      this.observer = null;
    }
  };

  /**
   *  Represents an object that is both an observable sequence as well as an observer.
   *  Each notification is broadcasted to all subscribed observers.
   */
  var Subject = Rx.Subject = (function (__super__) {
    function subscribe(observer) {
      checkDisposed(this);
      if (!this.isStopped) {
        this.observers.push(observer);
        return new InnerSubscription(this, observer);
      }
      if (this.hasError) {
        observer.onError(this.error);
        return disposableEmpty;
      }
      observer.onCompleted();
      return disposableEmpty;
    }

    inherits(Subject, __super__);

    /**
     * Creates a subject.
     */
    function Subject() {
      __super__.call(this, subscribe);
      this.isDisposed = false,
      this.isStopped = false,
      this.observers = [];
      this.hasError = false;
    }

    addProperties(Subject.prototype, Observer.prototype, {
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () { return this.observers.length > 0; },
      /**
       * Notifies all subscribed observers about the end of the sequence.
       */
      onCompleted: function () {
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onCompleted();
          }

          this.observers.length = 0;
        }
      },
      /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          this.error = error;
          this.hasError = true;
          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onError(error);
          }

          this.observers.length = 0;
        }
      },
      /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (!this.isStopped) {
          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onNext(value);
          }
        }
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
      }
    });

    /**
     * Creates a subject from the specified observer and observable.
     * @param {Observer} observer The observer used to send messages to the subject.
     * @param {Observable} observable The observable used to subscribe to messages sent from the subject.
     * @returns {Subject} Subject implemented using the given observer and observable.
     */
    Subject.create = function (observer, observable) {
      return new AnonymousSubject(observer, observable);
    };

    return Subject;
  }(Observable));

  /**
   *  Represents the result of an asynchronous operation.
   *  The last value before the OnCompleted notification, or the error received through OnError, is sent to all subscribed observers.
   */
  var AsyncSubject = Rx.AsyncSubject = (function (__super__) {

    function subscribe(observer) {
      checkDisposed(this);

      if (!this.isStopped) {
        this.observers.push(observer);
        return new InnerSubscription(this, observer);
      }

      if (this.hasError) {
        observer.onError(this.error);
      } else if (this.hasValue) {
        observer.onNext(this.value);
        observer.onCompleted();
      } else {
        observer.onCompleted();
      }

      return disposableEmpty;
    }

    inherits(AsyncSubject, __super__);

    /**
     * Creates a subject that can only receive one value and that value is cached for all future observations.
     * @constructor
     */
    function AsyncSubject() {
      __super__.call(this, subscribe);

      this.isDisposed = false;
      this.isStopped = false;
      this.hasValue = false;
      this.observers = [];
      this.hasError = false;
    }

    addProperties(AsyncSubject.prototype, Observer, {
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () {
        checkDisposed(this);
        return this.observers.length > 0;
      },
      /**
       * Notifies all subscribed observers about the end of the sequence, also causing the last received value to be sent out (if any).
       */
      onCompleted: function () {
        var i, len;
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          var os = cloneArray(this.observers), len = os.length;

          if (this.hasValue) {
            for (i = 0; i < len; i++) {
              var o = os[i];
              o.onNext(this.value);
              o.onCompleted();
            }
          } else {
            for (i = 0; i < len; i++) {
              os[i].onCompleted();
            }
          }

          this.observers.length = 0;
        }
      },
      /**
       * Notifies all subscribed observers about the error.
       * @param {Mixed} error The Error to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (!this.isStopped) {
          this.isStopped = true;
          this.hasError = true;
          this.error = error;

          for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
            os[i].onError(error);
          }

          this.observers.length = 0;
        }
      },
      /**
       * Sends a value to the subject. The last value received before successful termination will be sent to all subscribed and future observers.
       * @param {Mixed} value The value to store in the subject.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.value = value;
        this.hasValue = true;
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
        this.exception = null;
        this.value = null;
      }
    });

    return AsyncSubject;
  }(Observable));

  var AnonymousSubject = Rx.AnonymousSubject = (function (__super__) {
    inherits(AnonymousSubject, __super__);

    function subscribe(observer) {
      return this.observable.subscribe(observer);
    }

    function AnonymousSubject(observer, observable) {
      this.observer = observer;
      this.observable = observable;
      __super__.call(this, subscribe);
    }

    addProperties(AnonymousSubject.prototype, Observer.prototype, {
      onCompleted: function () {
        this.observer.onCompleted();
      },
      onError: function (error) {
        this.observer.onError(error);
      },
      onNext: function (value) {
        this.observer.onNext(value);
      }
    });

    return AnonymousSubject;
  }(Observable));

  /**
   *  Represents a value that changes over time.
   *  Observers can subscribe to the subject to receive the last (or initial) value and all subsequent notifications.
   */
  var BehaviorSubject = Rx.BehaviorSubject = (function (__super__) {
    function subscribe(observer) {
      checkDisposed(this);
      if (!this.isStopped) {
        this.observers.push(observer);
        observer.onNext(this.value);
        return new InnerSubscription(this, observer);
      }
      if (this.hasError) {
        observer.onError(this.error);
      } else {
        observer.onCompleted();
      }
      return disposableEmpty;
    }

    inherits(BehaviorSubject, __super__);

    /**
     *  Initializes a new instance of the BehaviorSubject class which creates a subject that caches its last value and starts with the specified value.
     *  @param {Mixed} value Initial value sent to observers when no other value has been received by the subject yet.
     */
    function BehaviorSubject(value) {
      __super__.call(this, subscribe);
      this.value = value,
      this.observers = [],
      this.isDisposed = false,
      this.isStopped = false,
      this.hasError = false;
    }

    addProperties(BehaviorSubject.prototype, Observer, {
      /**
       * Gets the current value or throws an exception.
       * Value is frozen after onCompleted is called.
       * After onError is called always throws the specified exception.
       * An exception is always thrown after dispose is called.
       * @returns {Mixed} The initial value passed to the constructor until onNext is called; after which, the last value passed to onNext.
       */
      getValue: function () {
          checkDisposed(this);
          if (this.hasError) {
              throw this.error;
          }
          return this.value;
      },
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () { return this.observers.length > 0; },
      /**
       * Notifies all subscribed observers about the end of the sequence.
       */
      onCompleted: function () {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          os[i].onCompleted();
        }

        this.observers.length = 0;
      },
      /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        this.hasError = true;
        this.error = error;

        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          os[i].onError(error);
        }

        this.observers.length = 0;
      },
      /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.value = value;
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          os[i].onNext(value);
        }
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
        this.value = null;
        this.exception = null;
      }
    });

    return BehaviorSubject;
  }(Observable));

  /**
   * Represents an object that is both an observable sequence as well as an observer.
   * Each notification is broadcasted to all subscribed and future observers, subject to buffer trimming policies.
   */
  var ReplaySubject = Rx.ReplaySubject = (function (__super__) {

    var maxSafeInteger = Math.pow(2, 53) - 1;

    function createRemovableDisposable(subject, observer) {
      return disposableCreate(function () {
        observer.dispose();
        !subject.isDisposed && subject.observers.splice(subject.observers.indexOf(observer), 1);
      });
    }

    function subscribe(observer) {
      var so = new ScheduledObserver(this.scheduler, observer),
        subscription = createRemovableDisposable(this, so);
      checkDisposed(this);
      this._trim(this.scheduler.now());
      this.observers.push(so);

      for (var i = 0, len = this.q.length; i < len; i++) {
        so.onNext(this.q[i].value);
      }

      if (this.hasError) {
        so.onError(this.error);
      } else if (this.isStopped) {
        so.onCompleted();
      }

      so.ensureActive();
      return subscription;
    }

    inherits(ReplaySubject, __super__);

    /**
     *  Initializes a new instance of the ReplaySubject class with the specified buffer size, window size and scheduler.
     *  @param {Number} [bufferSize] Maximum element count of the replay buffer.
     *  @param {Number} [windowSize] Maximum time length of the replay buffer.
     *  @param {Scheduler} [scheduler] Scheduler the observers are invoked on.
     */
    function ReplaySubject(bufferSize, windowSize, scheduler) {
      this.bufferSize = bufferSize == null ? maxSafeInteger : bufferSize;
      this.windowSize = windowSize == null ? maxSafeInteger : windowSize;
      this.scheduler = scheduler || currentThreadScheduler;
      this.q = [];
      this.observers = [];
      this.isStopped = false;
      this.isDisposed = false;
      this.hasError = false;
      this.error = null;
      __super__.call(this, subscribe);
    }

    addProperties(ReplaySubject.prototype, Observer.prototype, {
      /**
       * Indicates whether the subject has observers subscribed to it.
       * @returns {Boolean} Indicates whether the subject has observers subscribed to it.
       */
      hasObservers: function () {
        return this.observers.length > 0;
      },
      _trim: function (now) {
        while (this.q.length > this.bufferSize) {
          this.q.shift();
        }
        while (this.q.length > 0 && (now - this.q[0].interval) > this.windowSize) {
          this.q.shift();
        }
      },
      /**
       * Notifies all subscribed observers about the arrival of the specified element in the sequence.
       * @param {Mixed} value The value to send to all observers.
       */
      onNext: function (value) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        var now = this.scheduler.now();
        this.q.push({ interval: now, value: value });
        this._trim(now);

        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          var observer = os[i];
          observer.onNext(value);
          observer.ensureActive();
        }
      },
      /**
       * Notifies all subscribed observers about the exception.
       * @param {Mixed} error The exception to send to all observers.
       */
      onError: function (error) {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        this.error = error;
        this.hasError = true;
        var now = this.scheduler.now();
        this._trim(now);
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          var observer = os[i];
          observer.onError(error);
          observer.ensureActive();
        }
        this.observers.length = 0;
      },
      /**
       * Notifies all subscribed observers about the end of the sequence.
       */
      onCompleted: function () {
        checkDisposed(this);
        if (this.isStopped) { return; }
        this.isStopped = true;
        var now = this.scheduler.now();
        this._trim(now);
        for (var i = 0, os = cloneArray(this.observers), len = os.length; i < len; i++) {
          var observer = os[i];
          observer.onCompleted();
          observer.ensureActive();
        }
        this.observers.length = 0;
      },
      /**
       * Unsubscribe all observers and release resources.
       */
      dispose: function () {
        this.isDisposed = true;
        this.observers = null;
      }
    });

    return ReplaySubject;
  }(Observable));

  /**
  * Used to pause and resume streams.
  */
  Rx.Pauser = (function (__super__) {
    inherits(Pauser, __super__);

    function Pauser() {
      __super__.call(this);
    }

    /**
     * Pauses the underlying sequence.
     */
    Pauser.prototype.pause = function () { this.onNext(false); };

    /**
    * Resumes the underlying sequence.
    */
    Pauser.prototype.resume = function () { this.onNext(true); };

    return Pauser;
  }(Subject));

  if (true) {
    root.Rx = Rx;

    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return Rx;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (freeExports && freeModule) {
    // in Node.js or RingoJS
    if (moduleExports) {
      (freeModule.exports = Rx).Rx = Rx;
    } else {
      freeExports.Rx = Rx;
    }
  } else {
    // in a browser or Rhino
    root.Rx = Rx;
  }

  // All code before this point will be filtered from stack traces.
  var rEndingLine = captureLine();

}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(52)(module), __webpack_require__(17), __webpack_require__(374)))

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configurationFunctions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zebulon_controls__ = __webpack_require__(1);
var configurationFunctions={dataset:{formats:{id:function id(_ref){var value=_ref.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"blue",textAlign:"right"}},value);},date:function date(_ref2){var value=_ref2.value;if(value instanceof Date){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"black",textAlign:"center"}},value.toString());}return value;},quantity:function quantity(_ref3){var value=_ref3.value;if(Number.isFinite(value)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"black",textAlign:"right"}},Number(value).toFixed(0));}return value;},amount:function amount(_ref4){var value=_ref4.value;if(Number.isFinite(value)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"black",textAlign:"right"}},Number(value).toFixed(0));}return value;},price:function price(_ref5){var value=_ref5.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"\u20AC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"right"}},__WEBPACK_IMPORTED_MODULE_1_zebulon_controls__["j" /* utils */].formatValue(value,null,2)));}},accessors:{price:function price(_ref6){var row=_ref6.row;return{v0:row.amt,v1:row.qty};}},sorts:{},aggregations:{}}};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menuFunctions; });
var menuFunctions={dataCellFunctions:{},rangeFunctions:{},gridFunctions:{}};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MEASURE_ID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customConfigurationFunctions; });
/* unused harmony export exportFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customMenuFunctions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// "zebulon-controls": "file:../controls/zebulon-controls-1.0.1.tgz",
// "zebulon-table": "file:../table/zebulon-table-1.0.0.tgz"
var MEASURE_ID="__measures__";var customConfigurationFunctions=function customConfigurationFunctions(prevConfigurationFunctions,prevConfiguration){var configurationFunctions=Object.assign({},prevConfigurationFunctions,{dataset:{formats:Object.assign({},prevConfigurationFunctions.dataset.formats,{price:function price(_ref){var value=_ref.value;if(Number.isFinite(value)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"blue",textAlign:"right"}},Number(value).toFixed(2)+" $");}return value;},titiFormat:function titiFormat(_ref2){var value=_ref2.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{color:"red",textAlign:"center"}},value);}}),accessors:Object.assign({},prevConfigurationFunctions.dataset.accessors),aggregations:Object.assign({},prevConfigurationFunctions.dataset.aggregations),sorts:Object.assign({},prevConfigurationFunctions.dataset.aggregations,{titiSort:function titiSort(a,b){var x=a%2<b%2||a%2===b%2&&a<b?-1:!(a%2===b%2&&a===b)+0;return x;}})}});var configuration=Object.assign({},prevConfiguration,{measures:[].concat(_toConsumableArray(prevConfiguration.measures),[{id:"price",caption:"Price",aggregation:"weighted_avg",valueAccessor:"price",format:"price"}]),dimensions:[prevConfiguration.dimensions[0],{id:"titi",caption:"Titi",keyAccessor:"titi",labelAccessor:"titi_lb",sort:{keyAccessor:"titi",custom:"titiSort"},format:"titiFormat"}].concat(_toConsumableArray(prevConfiguration.dimensions.slice(2,5))),activeMeasures:[].concat(_toConsumableArray(prevConfiguration.activeMeasures),["price"])});var actionContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Add a new measure (Price) with new : "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," - custom accessor function ( amounts and quantities)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"- custom agregation function ( average of amounts weighted by quantities)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," - custom format ( blue + $ symbol)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Add a (dummy) sort function for dimension Titi : ordered by even ids, then odd ids."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null," Add a custom format ( red centered) on dimension Titi."));return{configurationFunctions:configurationFunctions,configuration:configuration,actionContent:actionContent};};var cellDisplay=function cellDisplay(cell){// console.log(cell);
var rows=cell.dimensions.filter(function(dimension){return dimension.axis==="rows";}).map(function(dimension){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:dimension.dimension.id},(dimension.dimension.id===MEASURE_ID?"Measure":dimension.dimension.caption)+" : "+dimension.cell.caption);});var columns=cell.dimensions.filter(function(dimension){return dimension.axis==="columns";}).map(function(dimension){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:dimension.dimension.id},(dimension.dimension.id===MEASURE_ID?"Measure":dimension.dimension.caption)+" : "+dimension.cell.caption);});var value=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:"value"},Math.round(cell.value.value*10000)/10000);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex",height:"fitContent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:150,height:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"5px",fontWeight:"bold"}},"Rows"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{style:{paddingLeft:"20px"}}," ",rows)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:150}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"5px",fontWeight:"bold",height:"auto"}},"Columns"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{style:{paddingLeft:"20px"}}," ",columns)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:90}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"5px",fontWeight:"bold",height:"auto"}},"Value"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{style:{paddingLeft:"20px"}}," ",value)));};var rangeDisplay=function rangeDisplay(range){var cellFrom={dimensions:range.rows[0].concat(range.columns[0]),value:range.values[0][0]};var cellTo={dimensions:range.rows[range.rows.length-1].concat(range.columns[range.columns.length-1]),value:range.values[range.rows.length-1][range.columns.length-1]};var divFrom=cellDisplay(cellFrom);var divTo=cellDisplay(cellTo);var values={};if(range.measureHeadersAxis==="columns"){values=range.columns.reduce(function(values,measure,indexColumn){if(values[measure.leaf.caption]===undefined){values[measure.leaf.caption]=0;}values[measure.leaf.caption]+=range.rows.reduce(function(value,dimension,indexRow){value+=range.values[indexRow][indexColumn].value;return value;},0);return values;},{});}else{values=range.rows.reduce(function(values,measure,indexRow){if(values[measure.leaf.caption]===undefined){values[measure.leaf.caption]=0;}values[measure.leaf.caption]+=range.columns.reduce(function(value,dimension,indexColumn){value+=range.values[indexRow][indexColumn].value;return value;},0);return values;},{});}var sums=Object.keys(values).map(function(measure){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:measure},measure+" : "+Math.round(values[measure]*10000)/10000);});var divValues=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:160,borderLeft:"solid 0.02em",height:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"5px",fontWeight:"bold"}},"Sum of values"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{style:{paddingLeft:"20px"}}," ",sums));var div=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex",height:"fitContent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderLeft:"solid 0.02em",height:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"5px",fontWeight:"bold",textAlign:"left"}},"From"),divFrom),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{borderLeft:"solid 0.02em",height:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingLeft:"5px",fontWeight:"bold",textAlign:"Left"}},"To"),divTo),divValues);return div;};var exportFile=function exportFile(content,fileName,mime){if(mime==null){mime="text/csv";}var blob=new Blob([content],{type:mime});var a=document.createElement("a");a.download=fileName;a.href=window.URL.createObjectURL(blob);a.dataset.downloadurl=[mime,a.download,a.href].join(":");var e=document.createEvent("MouseEvents");e.initMouseEvent("click",true,false,window,0,0,0,0,0,false,false,false,false,0,null);return a.dispatchEvent(e);};var customMenuFunctions=function customMenuFunctions(prevMenuFunctions,callback){var menuFunctions={dataCellFunctions:Object.assign({},prevMenuFunctions.dataCellFunctions,{cell:{code:"cell",caption:"Custom cell function",type:"MenuItem",function:function _function(cell){return callback("cell",cellDisplay(cell));}}}),rangeFunctions:Object.assign({},prevMenuFunctions.rangeFunctions,{range:{code:"range",caption:"Custom range function",type:"MenuItem",function:function _function(range){return callback("range",rangeDisplay(range));}}}),gridFunctions:Object.assign({},prevMenuFunctions.gridFunctions,{grid:{code:"grid",type:"MenuItem",caption:"Custom export as csv",// function: () => <div>toto</div>
function:function _function(_ref3){var grid=_ref3.grid,toText=_ref3.toText;return exportFile(toText(grid,"csv"),"zebulon.csv");}// ,
// test: {
//   code: "test",
//   type: "SubMenu",
//   caption: "test",
//   // function: () => <div>toto</div>
//   function: () => <div>Test</div>
// }
}})};var actionContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"Add custom menu functions for cell (cells under the right ckick), selected range or grid, accesible by the contextual menu on the data cells area."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,"The first cell function is called on doubleclick too."));return{menuFunctions:menuFunctions,actionContent:actionContent};};//   return { menuFunctions, actionContent };
// };

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c28d899b.js